import { portalEventTranslations } from './utils/portalEventTranslations';
import { portalDashboardTranslations } from './utils/portalDashboardTranslations';
import { portalChartTranslations } from './utils/portalChartTranslations';
import { portalDocumentTranslations } from './utils/portalDocumentTranslations';
import { portalUsageTranslations } from './utils/portalUsageTranslations';
import { portalProfileTranslations } from './utils/portalProfileTranslations';
import { portalCompanyTranslations } from './utils/portalCompanyOverview';
import { portalExternalTranslations } from './utils/portalExternalTranslations';
import { portalTicketKindTranslations } from './utils/portalTicketKindTranslations';
import { portalTicketDetailTranslations } from './utils/portalTicketDetailTranslations';
import { portalDownloadTranslations } from './utils/portalDownloadTranslations';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  "de": {
    "translation": {
      "access_denied": "Zugriff verweigert",
      "access_denied_desc": "Sie benötigen Agent- oder Admin-Rechte.",
      "actions": "Aktionen",
      "activate_dark_mode": "Dunkles Design aktivieren",
      "activate_light_mode": "Helles Design aktivieren",
      "active": "Aktiv",
      "active_filters": "Aktive Filter",
      "active_open_assignments": "Aktive, open Zuweisungen",
      "activity_optional": "Tätigkeit (optional)",
      "admin": "Admin",
      "admin_dashboard.administrative_berechtigungen": "Administrative Berechtigungen",
      "admin_dashboard.aendern": "Ändern",
      "admin_dashboard.agent_deaktiviert": "Agent deaktiviert",
      "admin_dashboard.agent_erstellt": "Agent erstellt",
      "admin_dashboard.agent_gespeichert": "Agent gespeichert",
      "admin_dashboard.agent_ohne_zuordnung_hinweis": "Ohne Zuordnung sieht dieser Agent {{umfang}} Kunden. Sobald mindestens ein Kunde zugeordnet ist, ist der Agent auf diese Kunden beschränkt — Tickets, Berichte und Assets.",
      "admin_dashboard.agenten_in_der_kundenkonsole": "Agenten in der Kundenkonsole",
      "admin_dashboard.aktuelles_passwort": "Aktuelles Passwort",
      "admin_dashboard.alle_eingehenden_befehle_wurden_bereits_vera": "Alle eingehenden Befehle wurden bereits verarbeitet oder sind freigegeben.",
      "admin_dashboard.alle_kunden": "Alle Kunden",
      "admin_dashboard.als_hauptkategorie_erstellen": "Als Hauptkategorie erstellen",
      "admin_dashboard.api_token_hinweis": "Erstellen Sie ggf. vorab einen API-Token unter dem Reiter {{reiter}} mit dem Scope {{scope}}.",
      "admin_dashboard.aufloesungszeit": "Auflösungszeit *",
      "admin_dashboard.basic_auth_benutzername_passwort": "Basic Auth (Benutzername/Passwort)",
      "admin_dashboard.bei_prefix_u00c4nderung_werden_alle_bestehen": "Bei Prefix-Änderung werden alle bestehenden Tickets automatisch umbenannt.",
      "admin_dashboard.benoetigte_berechtigung": "Benötigte Berechtigung:",
      "admin_dashboard.bestaetigen": "Bestätigen",
      "admin_dashboard.bezeichnung_positionszeile": "Bezeichnung Positionszeile",
      "admin_dashboard.bitte_kunde_waehlen": "Bitte Kunde wählen...",
      "admin_dashboard.bitte_kunde_waehlen_2": "Bitte Kunde wählen...",
      "admin_dashboard.definieren_sie_hauptkategorien_und_bis_zu_zw": "Definieren Sie Hauptkategorien und bis zu zwei Ebenen von Unterkategorien. Diese werden bei der Ticket-Erstellung als Auswahl angeboten.",
      "admin_dashboard.definiert_die_standard_reihenfolge_der_queue": "Definiert die Standard-Reihenfolge der Queues in der Agent-Sidebar.",
      "admin_dashboard.details_anzeigen": "Details anzeigen",
      "admin_dashboard.details_anzeigen_2": "Details anzeigen",
      "admin_dashboard.die_smtp_einstellungen_fuer_den_e_mail_versa": "Die SMTP-Einstellungen für den E-Mail-Versand werden jetzt zentral unter",
      "admin_dashboard.e_mail_versand_smtp_wird_unter_e_mail_einste": "E-Mail-Versand (SMTP) wird unter E-Mail-Einstellungen konfiguriert",
      "admin_dashboard.eine_sicherheitsgruppe_legt_fest_welche_kons": "Eine Sicherheitsgruppe legt fest, welche Konsolen-Module ein Agent sieht. „Voller Zugriff\" = alle Module. Admin-Rechte sind davon unabhängig.",
      "admin_dashboard.einstellungen_speichern": "Einstellungen speichern",
      "admin_dashboard.eintraege": "Einträge",
      "admin_dashboard.endgeraet": "Endgerät",
      "admin_dashboard.endgueltig_loeschen": "Endgültig löschen",
      "admin_dashboard.entwurfsrechnung_aus_zeiteintraegen": "Entwurfsrechnung aus Zeiteinträgen",
      "admin_dashboard.erstellen_sie_ihre_erste_automatisierung": "Erstellen Sie Ihre erste Automatisierung",
      "admin_dashboard.erstellen_sie_oben_ihre_erste_hauptkategorie": "Erstellen Sie oben Ihre erste Hauptkategorie",
      "admin_dashboard.externer_mitarbeiter_dienstleister": "Externer Mitarbeiter / Dienstleister",
      "admin_dashboard.fehler_beim_deaktivieren": "Fehler beim Deaktivieren",
      "admin_dashboard.fehler_beim_deaktivieren_2": "Fehler beim Deaktivieren",
      "admin_dashboard.fehler_beim_deaktivieren_3": "Fehler beim Deaktivieren",
      "admin_dashboard.fehler_beim_loeschen": "Fehler beim Löschen",
      "admin_dashboard.firma_adresse_kontakt_steuernummern_in_der_u": "Firma, Adresse, Kontakt, Steuernummern in der Übersicht bearbeitbar. Kunden deaktivieren bleibt Administrator vorbehalten.",
      "admin_dashboard.fuer_entra_id_benoetigen_sie_eine_app_regist": "Für Entra ID benötigen Sie eine App-Registrierung im Azure Portal mit Mail.Read Berechtigung.",
      "admin_dashboard.geloescht": "Gelöscht",
      "admin_dashboard.geloescht_2": "Gelöscht",
      "admin_dashboard.installationspaket_herunterladen": "Installationspaket herunterladen",
      "admin_dashboard.kategorie_aktualisiert": "Kategorie aktualisiert",
      "admin_dashboard.kategorie_erstellt": "Kategorie erstellt",
      "admin_dashboard.kategorie_geloescht": "Kategorie gelöscht",
      "admin_dashboard.keine_abteilung": "Keine Abteilung",
      "admin_dashboard.keine_ausstehenden_befehls_freigaben_vorhand": "Keine ausstehenden Befehls-Freigaben vorhanden.",
      "admin_dashboard.keine_workflows_konfiguriert": "Keine Workflows konfiguriert",
      "admin_dashboard.keine_zuordnung_dieser_agent_sieht_alle_kund": "Keine Zuordnung — dieser Agent sieht alle Kunden.",
      "admin_dashboard.konfigurieren_sie_sprachmodelle_auto_respons": "Konfigurieren Sie Sprachmodelle, Auto-Response Prompts und System-Templates",
      "admin_dashboard.kunde_auswaehlen": "Kunde auswählen *",
      "admin_dashboard.kunde_deaktiviert": "Kunde deaktiviert",
      "admin_dashboard.kunde_erstellt": "Kunde erstellt",
      "admin_dashboard.kunde_geloescht": "Kunde „{{firma}}\" wurde endgültig gelöscht",
      "admin_dashboard.kunde_gespeichert": "Kunde gespeichert",
      "admin_dashboard.kunde_waehlen": "Kunde wählen…",
      "admin_dashboard.kundenzuordnung_verwalten": "Kundenzuordnung verwalten",
      "admin_dashboard.laden_sie_ein_fertiges_zip_archiv_fuer": "Laden Sie ein fertiges ZIP-Archiv für",
      "admin_dashboard.laedt": "Lädt…",
      "admin_dashboard.laengengrad": "Längengrad",
      "admin_dashboard.legen_sie_fest_welche_daten_der_installierte": "Legen Sie fest, welche Daten der installierte Agent sammelt und konfigurieren Sie den optionalen agentenlosen Netzwerk-Scanner (Subnetz-Ping).",
      "admin_dashboard.letzte_exporte": "Letzte Exporte",
      "admin_dashboard.lexoffice_artikel_uuid_optional_dienstleistu": "Lexoffice Artikel-UUID (optional, Dienstleistung)",
      "admin_dashboard.lexoffice_deaktiviert_hinweis": "Die LexOffice-Integration ist aktuell deaktiviert. Sie können Rechnungsentwürfe erst erstellen, wenn Sie die Integration unter {{bereich}} aktivieren und konfigurieren.",
      "admin_dashboard.lexoffice_einstellungen_konnten_nicht_gelade": "Lexoffice-Einstellungen konnten nicht geladen werden (Migration ausführen / Server neu starten).",
      "admin_dashboard.loeschen": "Löschen",
      "admin_dashboard.loeschen_2": "Löschen",
      "admin_dashboard.mailbox_empfang_imap_oauth_wird_unter_postfa": "Mailbox-Empfang (IMAP/OAuth) wird unter Postfächer konfiguriert",
      "admin_dashboard.mailbox_speichern": "Mailbox speichern",
      "admin_dashboard.microsoft_graph_api": "Microsoft Graph API",
      "admin_dashboard.mit_einem_frisch_generierten_api_schluessel": "mit einem frisch generierten API-Schlüssel und eine",
      "admin_dashboard.mitarbeiter_deaktiviert": "Mitarbeiter deaktiviert",
      "admin_dashboard.mitarbeiter_erstellt": "Mitarbeiter erstellt",
      "admin_dashboard.mitarbeiter_gespeichert": "Mitarbeiter gespeichert",
      "admin_dashboard.mloffice_gefuehrt": "Stammdaten werden von MLOffice geführt",
      "admin_dashboard.mloffice_geloest": "Mit MLOffice verknüpft — Abgleich derzeit gelöst",
      "admin_dashboard.module_assets": "Assets",
      "admin_dashboard.module_calendar": "Kalender",
      "admin_dashboard.module_customers": "Kunden",
      "admin_dashboard.module_knowledge": "Wissensbasis",
      "admin_dashboard.module_licenses": "Lizenzen",
      "admin_dashboard.module_problems": "Probleme",
      "admin_dashboard.module_reports": "Berichte",
      "admin_dashboard.module_tickets": "Tickets",
      "admin_dashboard.nach_kunde_filtern": "Nach Kunde filtern",
      "admin_dashboard.neue_mailbox_konfiguration": "Neue Mailbox Konfiguration",
      "admin_dashboard.neuer_workflow": "Neuer Workflow",
      "admin_dashboard.neues_passwort": "Neues Passwort",
      "admin_dashboard.nicht_abrechenbar": "Nicht abrechenbar",
      "admin_dashboard.noch_keine_kategorien_definiert": "Noch keine Kategorien definiert",
      "admin_dashboard.noch_keine_zeiteintraege_vorhanden": "Noch keine Zeiteinträge vorhanden",
      "admin_dashboard.nur_abrechenbare_eintraege_ohne_vorherigen_l": "Nur abrechenbare Einträge ohne vorherigen Lexoffice-Export; optional nach Vertrags-ID filtern.",
      "admin_dashboard.optionale_beschreibung_des_sla_umfangs": "Optionale Beschreibung des SLA-Umfangs",
      "admin_dashboard.passwort_aendern": "Passwort ändern",
      "admin_dashboard.primaer": "Primär",
      "admin_dashboard.prioritaet_geaendert": "• Priorität geändert",
      "admin_dashboard.pruefinterval_minuten": "Prüfinterval (Minuten)",
      "admin_dashboard.refresh_token": "Refresh Token",
      "admin_dashboard.sie_koennen_den_agenten_auch_manuell_registr": "Sie können den Agenten auch manuell registrieren. Nutzen Sie dafür folgende Syntax auf dem Client (erfordert Administratorrechte):",
      "admin_dashboard.standardmaessig_duerfen_agenten_kunden_stamm": "Standardmäßig dürfen Agenten Kunden-Stammdaten nur lesen und Kunden-Dokumente nur einsehen. Hier können Sie erweiterte Schreibrechte pro Einrichtung aktivieren.",
      "admin_dashboard.status_geaendert": "• Status geändert",
      "admin_dashboard.stundensatz_ueberschreiben_optional": "Stundensatz überschreiben (optional)",
      "admin_dashboard.tarif_erweitern": "Tarif erweitern",
      "admin_dashboard.ticket_id_format_und_admin_passwort_koennen": "Ticket-ID-Format und Admin-Passwort können hier konfiguriert werden",
      "admin_dashboard.top_kunden_nach_ticketvolumen": "Top Kunden nach Ticketvolumen",
      "admin_dashboard.uebergeordnete_kategorie": "Übergeordnete Kategorie",
      "admin_dashboard.unterkategorie_hinzufuegen": "Unterkategorie hinzufügen",
      "admin_dashboard.upload_metadaten_bearbeiten_und_loeschen_von": "Upload, Metadaten bearbeiten und Löschen von Dateien im Kunden-Tab „Dokumente“.",
      "admin_dashboard.verfuegbare_trigger": "Verfügbare Trigger",
      "admin_dashboard.verwalten_und_genehmigen_sie_ausstehende_adm": "Verwalten und genehmigen Sie ausstehende administrative Befehle von anderen Administratoren vor der Ausführung auf den Client-Endgeräten.",
      "admin_dashboard.voller_zugriff_alle_module": "Voller Zugriff (alle Module)",
      "admin_dashboard.vorkonfiguriertes_paket_zip": "Vorkonfiguriertes Paket (.zip)",
      "admin_dashboard.was_bedeuten_die_gruppen": "Was bedeuten die Gruppen?",
      "admin_dashboard.workflow_automatisierungen": "Workflow Automatisierungen",
      "admin_dashboard.z_b_hauptsitz_koeln": "z.B. Hauptsitz Köln",
      "admin_dashboard.zeit_standardmaessig_abrechenbar": "Zeit standardmäßig abrechenbar",
      "admin_dashboard.zeitbuchung_bei_ticket_schliessung_erforderl": "Zeitbuchung bei Ticket-Schließung erforderlich",
      "admin_dashboard.zeitbuchungen_erscheinen_hier_sobald_agenten": "Zeitbuchungen erscheinen hier, sobald Agenten Zeit auf Tickets erfassen.",
      "admin_dashboard.zeiteintraege": "Zeiteinträge",
      "admin_dashboard.zeiterfassung_aktivieren": "Zeiterfassung aktivieren",
      "admin_dashboard.zeiterfassung_einstellungen": "Zeiterfassung Einstellungen",
      "admin_dashboard.zugriff_verweigert": "Zugriff verweigert",
      "admin_dashboard.zugriff_verweigert_text": "Sie verfügen nicht über die notwendigen administrativen Berechtigungen, um den Bereich {{bereich}} einzusehen oder zu verwalten.",
      "admin_dashboard.zuordnung_entfernen": "Zuordnung entfernen",
      "admin_dashboard.zusaetzliche_admin_rechte": "Zusätzliche Admin-Rechte",
      "admin_default": "Admin-Standard",
      "admin_only_change": "(nur ein Administrator kann die Zuordnung ändern.)",
      "admin_overview.aktive_warnungen_risiken": "Aktive Warnungen & Risiken",
      "admin_overview.alles_in_ordnung": "Alles in Ordnung",
      "admin_overview.datenbank_engine": "Datenbank Engine",
      "admin_overview.einstellungen_filtern": "Einstellungen filtern...",
      "admin_overview.hinweis_fuer_administratoren": "Hinweis für Administratoren:",
      "admin_overview.keine_ergebnisse_gefunden": "Keine Ergebnisse gefunden",
      "admin_overview.keine_warnungen_oder_kritischen_meldungen": "Keine Warnungen oder kritischen Meldungen.",
      "admin_overview.lade_dashboard_daten": "Lade Dashboard-Daten...",
      "admin_overview.system_status": "System Status",
      "admin_overview.upgrade_erforderlich": "Upgrade erforderlich",
      "admin_overview.upgrade_erforderlich_2": "Upgrade erforderlich",
      "admin_overview.versuchen_sie_es_mit_einem_anderen_suchbegri": "Versuchen Sie es mit einem anderen Suchbegriff.",
      "admin_overview.zurueck_zum_agent_dashboard": "Zurück zum Agent Dashboard",
      "admin_view": "Admin-Ansicht",
      "administration": "Administration",
      "administrator": "Administrator",
      "agent": "Agent",
      "agent_available": "Verfügbar",
      "agent_console": "Agenten-Konsole",
      "agent_console.alle_als_gelesen": "Alle als gelesen",
      "agent_console.anhaenge": "Anhänge",
      "agent_console.anhaenge_zum_eroeffnungsbeitrag": "Anhänge zum Eröffnungsbeitrag",
      "agent_console.back_to_ticket_list": "Zurück zur Liste",
      "agent_console.beschreiben_sie_hier_details_die_dem_partner": "Beschreiben Sie hier Details, die dem Partner mitgeteilt werden sollen...",
      "agent_console.bitte_waehlen": "-- Bitte wählen --",
      "agent_console.detailansicht_schliessen": "Detailansicht schließen",
      "agent_console.erneut_oeffnen": "Erneut öffnen",
      "agent_console.hinweis_der_partner_erhaelt_eine_benachricht": "Hinweis: Der Partner erhält eine Benachrichtigungs-E-Mail mit Ihren Angaben und einem sicheren Link zur Bearbeitung des Tickets.",
      "agent_console.interner_chat": "Interner Chat",
      "agent_console.interner_chat_2": "Interner Chat",
      "agent_console.keine_benachrichtigungen": "Keine Benachrichtigungen",
      "agent_console.language_selection": "Language selection",
      "agent_console.loesen": "Lösen",
      "agent_console.mir_zuweisen": "Mir zuweisen",
      "agent_console.nachricht_notiz_fuer_den_partner_optional": "Nachricht / Notiz für den Partner (optional)",
      "agent_console.neues_ticket": "Neues Ticket",
      "agent_console.neues_ticket_2": "Neues Ticket",
      "agent_console.partner_dienstleister_waehlen": "Partner-Dienstleister wählen",
      "agent_console.schliessen": "Schließen",
      "agent_console.schliessen_2": "Schließen",
      "agent_console.schliessungsgrund": "Schließungsgrund:",
      "agent_console.schnellsuche_oeffnen": "Schnellsuche öffnen",
      "agent_console.sie_benoetigen_agent_oder_admin_rechte": "Sie benötigen Agent- oder Admin-Rechte.",
      "agent_console.tastenkuerzel": "Tastenkürzel",
      "agent_console.ticket_erstellt": "Ticket erstellt",
      "agent_console.ticket_schliessen": "Ticket schließen",
      "agent_console.zugriff_verweigert": "Zugriff verweigert",
      "agent_console.zur_antwort_composer": "Zur Antwort (Composer)",
      "agent_console.zur_antwort_scrollen": "Zur Antwort scrollen",
      "agent_console.zusammenfuehren": "Zusammenführen",
      "agent_console.zuweisung_entfernen": "Zuweisung entfernen",
      "ai": "KI",
      "ai_analysis_running": "Analyse läuft...",
      "ai_assistance": "KI-Assistenz",
      "ai_confidence_label": "{{pct}}% Konfidenz",
      "ai_context_title": "KI-Kontext & Prognosen",
      "ai_generate_summary": "Zusammenfassung generieren",
      "ai_key_points": "Kernpunkte",
      "ai_next_steps": "Nächste Schritte",
      "ai_requested_action": "Anfrage",
      "ai_risks": "Risiken",
      "ai_solution_assistant_title": "KI-Lösungsassistent",
      "ai_stale": "Veraltet",
      "ai_summary_title": "KI-Zusammenfassung",
      "all": "Alle",
      "all_active_tickets": "Alle aktiven Tickets",
      "all_categories": "Alle Kategorien",
      "all_customers": "Alle Kunden",
      "all_deadlines_ok": "Alle Fristen liegen im Zeitrahmen.",
      "all_open": "Alle offenen",
      "all_tickets": "Alle Tickets",
      "allgemein.abbrechen": "Abbrechen",
      "allgemein.schliessen": "Schließen",
      "analyze_again": "Erneut analysieren",
      "article": "Artikel",
      "article_ai_generate": "Artikel mit KI erstellen",
      "article_ai_generate_btn": "Artikel generieren",
      "article_ai_generate_desc": "Beschreiben Sie das Thema und die KI generiert einen Entwurf",
      "article_ai_improve": "Text verbessern",
      "article_ai_keywords": "Schlüsselwörter (optional)",
      "article_ai_keywords_placeholder": "z.B. Windows 11, OpenVPN, Zertifikat",
      "article_ai_language": "Sprache",
      "article_ai_len_long": "Lang / ausführlich",
      "article_ai_len_medium": "Mittel",
      "article_ai_len_short": "Kurz",
      "article_ai_length": "Länge",
      "article_ai_style": "Sprachstil",
      "article_ai_style_balanced": "Ausgewogen",
      "article_ai_style_enduser": "Endnutzer (Schritt-für-Schritt)",
      "article_ai_style_formal": "Formell",
      "article_ai_style_simple": "Einfach / leicht verständlich",
      "article_ai_style_technical": "Technisch (IT-Profis)",
      "article_ai_summarize": "Zusammenfassung generieren",
      "article_ai_topic": "Thema *",
      "article_ai_topic_placeholder": "z.B. VPN-Verbindung unter Windows einrichten",
      "article_all_customers": "Alle Kunden",
      "article_all_statuses": "Alle Status",
      "article_all_visible": "Für alle Kunden sichtbar",
      "article_archived": "Archiviert",
      "article_category": "Kategorie",
      "article_content_placeholder": "Beginnen Sie hier mit dem Schreiben Ihres Artikels...",
      "article_create_first": "Ersten Artikel erstellen",
      "article_create_first_desc": "Erstellen Sie Ihren ersten Wissensartikel, um Informationen mit Ihrem Team zu teilen.",
      "article_create_with_ai": "Mit KI erstellen",
      "article_delete_confirm": "Artikel wirklich löschen?",
      "article_draft": "Entwurf",
      "article_excerpt_placeholder": "Eine kurze Zusammenfassung des Artikels...",
      "article_manage": "Artikel verwalten",
      "article_new": "Neuer Artikel",
      "article_no_articles": "Noch keine Artikel vorhanden",
      "article_no_categories_desc": "Keine Kategorien vorhanden. Bitte im Admin-Bereich anlegen.",
      "article_no_category": "Keine Kategorie",
      "article_not_found": "Keine Artikel gefunden",
      "article_not_found_desc": "Es konnten keine Artikel für Ihre Suchanfrage gefunden werden.",
      "article_only_visible": "Nur für {{name}}",
      "article_pinned": "Angepinnt",
      "article_pinned_desc": "Wird oben in der Liste angezeigt",
      "article_plural": "Alle Artikel",
      "article_published": "Veröffentlicht",
      "article_search": "Artikel suchen...",
      "article_views": "Aufrufe",
      "article_visibility": "Kunden-Sichtbarkeit",
      "article_write_content": "Artikelinhalt",
      "article_write_excerpt": "Kurzbeschreibung",
      "article_write_title": "Artikeltitel eingeben...",
      "asset.discovery_agents": "Discovery Agents",
      "asset.event_logs": "Event-Logs",
      "asset.general": "Allgemein",
      "asset.hardware_wmi": "Hardware (WMI)",
      "asset.history_changes": "Historie & Changes",
      "asset.more": "Mehr",
      "asset.network": "Netzwerk",
      "asset.network_discovery": "Netzwerk-Entdeckung",
      "asset.printers": "Drucker",
      "asset.processes": "Prozesse",
      "asset.relationships": "Beziehungen",
      "asset.remote_control": "Remote-Steuerung",
      "asset.remote_terminal": "Remote-Terminal",
      "asset.scan_history": "Scan-Verlauf",
      "asset.security": "Sicherheit",
      "asset.services": "Dienste",
      "asset.software_catalog": "Software-Katalog (SAM)",
      "asset.software_count": "Software",
      "asset.system_assets": "System-Assets",
      "asset.updates": "Updates",
      "asset_": "asset_",
      "asset_active": "Aktiv",
      "asset_agent.offline": "Offline",
      "asset_agent.online_active": "Online (Aktiv)",
      "asset_agent.recently_active": "Kürzlich aktiv",
      "asset_inactive": "Inaktiv",
      "asset_maintenance": "Wartung",
      "asset_management": "Asset-Verwaltung",
      "asset_panel.confirm_delete_asset": "\"{{name}}\" wirklich löschen?",
      "asset_panel.confirm_delete_category": "Kategorie \"{{name}}\" löschen? Assets werden entkoppelt.",
      "asset_panel.edit_asset": "Asset bearbeiten",
      "asset_panel.edit_category": "Kategorie bearbeiten",
      "asset_panel.import_as_managed_btn": "Als managed Asset importieren",
      "asset_panel.import_device": "Gerät importieren",
      "asset_panel.new_asset": "Neues Asset",
      "asset_panel.new_category": "Neue Kategorie",
      "asset_panel.print_asset_tag": "Asset-Tag drucken",
      "asset_panel.print_now_btn": "Jetzt drucken",
      "asset_panel.toast.agent_no_response_hint": "Der Agent hat nicht rechtzeitig reagiert.",
      "asset_panel.toast.assets_imported": "{{count}} Asset(s) importiert",
      "asset_panel.toast.command_queued": "Befehl erfolgreich eingereiht",
      "asset_panel.toast.create_problem_error": "Fehler beim Erstellen des Problem-Tickets",
      "asset_panel.toast.csv_import_failed": "CSV-Import failed",
      "asset_panel.toast.device_ignored": "Gerät erfolgreich ignoriert",
      "asset_panel.toast.device_imported": "Gerät erfolgreich in verwaltete Assets importiert",
      "asset_panel.toast.ignore_device_error": "Fehler beim Ignorieren des Geräts",
      "asset_panel.toast.import_device_error": "Fehler beim Importieren des Geräts",
      "asset_panel.toast.import_with_errors": "Import mit Fehlern abgeschlossen",
      "asset_panel.toast.itil_correlation_error": "Fehler bei der ITIL Problem-Korrelation",
      "asset_panel.toast.less_than_3_tickets": "Weniger als 3 Tickets in den letzten 30 Tagen.",
      "asset_panel.toast.manual_scan_error": "Fehler beim manuellen Scan",
      "asset_panel.toast.problem_ticket_created": "Problem-Ticket erstellt und Vorfälle verknüpft!",
      "asset_panel.toast.queue_command_error": "Befehl konnte nicht eingereiht werden",
      "asset_panel.toast.request_scan_error": "Fehler beim Anfordern des Scans",
      "asset_panel.toast.scan_completed": "Scan erfolgreich abgeschlossen",
      "asset_panel.toast.scan_failed": "Scan failed",
      "asset_panel.toast.scan_requested": "{{type}} angefordert",
      "asset_panel.toast.template_downloaded": "Vorlage „asset-import-vorlage.csv“ heruntergeladen",
      "asset_panel.toast.template_load_error": "Vorlage konnte nicht geladen werden",
      "asset_remote_client_disconnected": "Verbindung vom Client getrennt",
      "asset_remote_client_disconnected_desc": "Der Benutzer auf dem Client-Gerät hat die Remote-Unterstützungssitzung beendet.",
      "asset_remote_closed_desc": "Die Remote-Unterstützungssitzung wurde erfolgreich geschlossen.",
      "asset_remote_code_placeholder": "z.B. 123 456",
      "asset_remote_conn_disconnected": "Verbindung getrennt",
      "asset_remote_conn_failed": "Verbindung zum Server fehlgeschlagen",
      "asset_remote_conn_rejected": "Verbindung abgelehnt",
      "asset_remote_consent_hint": "Auf dem Bildschirm des Kunden wird ein Zustimmungsfenster angezeigt. Bitte bitten Sie den Kunden, zuzustimmen.",
      "asset_remote_disconnect": "Trennen",
      "asset_remote_enter_code_hint": "Geben Sie den 6-stelligen Zugangscode ein, der auf dem Bildschirm des Benutzers angezeigt wird:",
      "asset_remote_invalid_code": "Falscher Zutrittscode",
      "asset_remote_live_focus": "LIVE · Fokus für Tastatureingabe",
      "asset_remote_loading_screen": "Lade Live-Bildschirm...",
      "asset_remote_preparing": "Verbindung wird vorbereitet...",
      "asset_remote_protocol2_code_label": "Zwölfstelliger Zugangscode",
      "asset_remote_protocol2_code_placeholder": "ABCD EFGH 2345",
      "asset_remote_protocol2_enter_code_hint": "Geben Sie den zwölfstelligen Zugangscode vom Bildschirm des Benutzers ein:",
      "asset_remote_protocol2_request_desc": "Sendet eine Verbindungsanfrage an den Client-Rechner. Der Benutzer muss zustimmen und den zwölfstelligen Zugangscode übermitteln.",
      "asset_remote_rejected_desc": "Die Verbindungsanfrage wurde vom Benutzer auf dem Client-Gerät abgelehnt.",
      "asset_remote_req": "Remote-Sitzung anfordern",
      "asset_remote_request_again": "Erneut anfordern",
      "asset_remote_request_desc": "Sendet eine Verbindungsanfrage an den Client-Rechner. Der Benutzer muss zustimmen und einen 6-stelligen Zugangscode übermitteln.",
      "asset_remote_request_title": "Support-Fernsteuerung anfordern",
      "asset_remote_start_error": "Fehler beim Starten der Sitzung",
      "asset_remote_start_new": "Neue Sitzung starten",
      "asset_remote_support": "Built-in Remote-Unterstützung",
      "asset_remote_support_desc": "Direkte Bildschirm-Fernsteuerung ohne externe Software (TeamViewer/RustDesk).",
      "asset_remote_user_consented": "Benutzer hat zugestimmt",
      "asset_remote_verifying_code": "Code verifizieren...",
      "asset_remote_waiting_consent": "Warte auf Benutzerzustimmung...",
      "asset_retired": "Ausgemustert",
      "assets": "Assets",
      "assign_to": "Zuweisen...",
      "assign_to_me": "Mir zuweisen",
      "assigned_agents": "Betreuende Agenten",
      "assigned_to": "Zugewiesen an",
      "at_risk_title": "Gefährdet (SLA-Warnung):",
      "attach_local_file": "Lokale Datei anhängen",
      "attachments": "Anhänge",
      "attachments_tools": "Anhänge & Tools",
      "attendees_emails": "Teilnehmer (E-Mails, kommagetrennt)",
      "automation": "Automatisierung",
      "avg_first_response": "Erst-Reaktionszeit",
      "avg_resolution": "Durchschn. Lösungszeit",
      "billable": "Abrechenbar",
      "billable_time": "Abrechenbar: {{time}}",
      "book_on_send": "Beim Senden buchen",
      "book_time_with_reply": "Zeit mit Antwort verbuchen",
      "calendar": "Kalender",
      "calendar_enter_title_warning": "Bitte Titel eingeben.",
      "calendar_event_attendees": "Teilnehmer-E-Mails (optional, kommagetrennt)",
      "calendar_event_created_error": "Termin konnte nicht erstellt werden.",
      "calendar_event_created_success": "Termin erstellt.",
      "calendar_event_description": "Beschreibung (optional)",
      "calendar_event_title": "Titel",
      "calendar_meeting_created_error": "Meeting konnte nicht erstellt werden.",
      "calendar_meeting_link_copied": "Meeting-Link in Zwischenablage kopiert.",
      "calendar_new_event": "Neuer Termin",
      "calendar_no_integration_or": "oder",
      "calendar_no_integration_prefix": "Keine Kalender- oder Meeting-Integration aktiv. Bitte konfigurieren Sie",
      "calendar_no_integration_suffix": "mit aktivierter Meeting-Planung in den Integrationen.",
      "calendar_only_event": "Nur Kalender-Event",
      "calendar_talk_meeting": "Talk-Meeting",
      "calendar_talk_room_created": "Talk-Raum erstellt.",
      "calendar_teams_meeting": "Teams-Meeting",
      "calendar_teams_meeting_created": "Teams-Meeting erstellt.",
      "cancel": "Abbrechen",
      "canned_responses": "Textbausteine einfügen",
      "canned_responses_short": "Textbaustein",
      "categories": "Kategorien",
      "category": "Kategorie",
      "change_priority": "Priorität ändern...",
      "change_status_after_send": "Nach dem Senden wechseln zu",
      "change_ticket_company": "Ticket anderer Firma zuordnen",
      "change_ticket_company_warning": "Portal-Ersteller, CC, Mitarbeiter, Bearbeiter, Kategorie, SLA, Assets und laufende Timer werden für die neue Firma zurückgesetzt.",
      "characters": "Zeichen",
      "city": "Ort",
      "clear_selection": "Auswahl aufheben",
      "click_to_logout": "Klicken zum Abmelden",
      "close": "Schließen",
      "close_detail_view": "Detailansicht schließen",
      "close_ticket": "Ticket schließen",
      "closed": "Geschlossene",
      "collapse": "Einklappen",
      "collapse_composer": "Editor einklappen",
      "collapse_sidebar": "Sidebar einklappen",
      "column_assignee_name": "Zugewiesen",
      "column_category_name": "Kategorie",
      "column_channel": "Kanal",
      "column_created_at": "Erstellt",
      "column_customer_name": "Kunde",
      "column_priority": "Priorität",
      "column_reply_count": "Antworten",
      "column_requester_name": "Ersteller",
      "column_sla": "SLA",
      "column_status": "Status",
      "column_subject": "Betreff",
      "column_tags": "Tags",
      "column_ticket_number": "Nr.",
      "column_updated_at": "Aktualisiert",
      "columns_btn": "Spalten",
      "common.abbrechen": "Abbrechen",
      "company_name": "Firmenname",
      "company_title": "Firma",
      "compliance_rate": "Einhaltungsrate",
      "composer_internal": "Intern",
      "composer_internal_placeholder": "Interne Notiz…",
      "composer_public": "Öffentlich",
      "composer_public_placeholder": "Antwort schreiben…",
      "configure_columns": "Spalten konfigurieren",
      "connect": "Verbinden",
      "contact_and_master_data": "Kontakt & Stammdaten",
      "contact_person": "Ansprechpartner",
      "contact_person_abbrev": "AP",
      "contract": "Vertrag",
      "contract.auto_renew": "Automatische Verlängerung",
      "contract.auto_renews_suffix": " (wird automatisch verlängert)",
      "contract.back_to_overview": "Zurück zur Übersicht",
      "contract.billing": "Abrechnung",
      "contract.billing_model": "Abrechnungsmodell",
      "contract.conditions": "Konditionen",
      "contract.days": "{{count}} Tage",
      "contract.end_date": "Enddatum",
      "contract.expires_in_days": "Läuft in {{count}} Tagen ab",
      "contract.first_response": "Erste Reaktion",
      "contract.hourly_rate": "Stundensatz",
      "contract.hours_quota": "Stundenkontingent",
      "contract.included_hours": "Inklusivstunden",
      "contract.no_contracts": "Keine Verträge vorhanden",
      "contract.no_contracts_desc": "Kontaktieren Sie uns für ein individuelles Angebot",
      "contract.notice_period": "Kündigungsfrist: {{count}} Tage",
      "contract.period_per": "{{count}}h / Periode",
      "contract.quota_summary": "{{remaining}} verbleibend ({{percent}}% genutzt)",
      "contract.remaining": "Verbleibend",
      "contract.resolution": "Lösung",
      "contract.runtime": "Laufzeit",
      "contract.sla_tier": "SLA",
      "contract.start_date": "Startdatum",
      "contract.status.active": "Aktiv",
      "contract.status.expired": "Abgelaufen",
      "contract.status.expiring_soon": "Läuft bald ab",
      "contract.status.future": "Zukünftig",
      "contract.subtitle": "Übersicht Ihrer aktiven Verträge und Service-Level-Agreements",
      "contract.unlimited": "Unbefristet",
      "contract.used": "Verbraucht",
      "contracts": "Verträge",
      "copied_to_clipboard": "In die Zwischenablage kopiert",
      "country": "Land",
      "create": "Erstellen",
      "create_ticket.aehnliche_tickets": "Ähnliche Tickets",
      "create_ticket.angehaengte_cloud_dateien": "Angehängte Cloud-Dateien:",
      "create_ticket.anhaenge": "Anhänge",
      "create_ticket.asset_verknuepfen_optional": "Asset verknüpfen (optional):",
      "create_ticket.assets_filtern": "Assets filtern:",
      "create_ticket.assets_werden_geladen": "Assets werden geladen...",
      "create_ticket.beschreiben_sie_das_problem_so_detailliert_w": "Beschreiben Sie das Problem so detailliert wie möglich...",
      "create_ticket.betroffene_systeme_benutzer_nennen": "Betroffene Systeme/Benutzer nennen",
      "create_ticket.bitte_betreff_und_beschreibung_ausfuellen": "Bitte Betreff und Beschreibung ausfüllen",
      "create_ticket.bitte_eine_beschreibung_angeben": "Bitte eine Beschreibung angeben.",
      "create_ticket.bitte_einen_kunden_auswaehlen": "Bitte einen Kunden auswählen.",
      "create_ticket.bitte_hauptkategorie_waehlen": "Bitte Hauptkategorie wählen...",
      "create_ticket.bitte_klassifizierung_waehlen": "Bitte Klassifizierung wählen...",
      "create_ticket.bitte_kunde_waehlen": "Bitte Kunde wählen...",
      "create_ticket.bitte_unterkategorie_waehlen": "Bitte Unterkategorie wählen...",
      "create_ticket.bitte_zuerst_einen_kunden_waehlen": "Bitte zuerst einen Kunden wählen...",
      "create_ticket.datei_hochladen": "Datei hochladen",
      "create_ticket.datei_hochladen_2": "Datei hochladen",
      "create_ticket.datei_zu_gross_max_10_mb": "Datei zu groß (max. 10 MB)",
      "create_ticket.dateityp_nicht_erlaubt": "Dateityp nicht erlaubt",
      "create_ticket.erste_antwort": "Erste Antwort",
      "create_ticket.fehlermeldungen_und_screenshots_beifuegen": "Fehlermeldungen und Screenshots beifügen",
      "create_ticket.keine_mitarbeiter_hinterlegt": "Keine Mitarbeiter hinterlegt",
      "create_ticket.letzte_kunden_tickets": "Letzte Kunden-Tickets",
      "create_ticket.loesung": "Lösung",
      "create_ticket.neues_ticket": "Neues Ticket",
      "create_ticket.nur_geschaeftszeiten": "Nur Geschäftszeiten",
      "create_ticket.praeziser_betreff_hilft_bei_der_zuordnung": "Präziser Betreff hilft bei der Zuordnung",
      "create_ticket.priority_high": "Hoch",
      "create_ticket.priority_low": "Niedrig",
      "create_ticket.priority_medium": "Mittel",
      "create_ticket.priority_urgent": "Dringend",
      "create_ticket.schritte_zur_reproduktion_angeben": "Schritte zur Reproduktion angeben",
      "create_ticket.stoerung": "Störung",
      "create_ticket.text_mit_ki_verbessern": "Text mit KI verbessern",
      "create_ticket.ticket_erstellt": "Ticket erstellt!",
      "create_ticket.uebernehmen": "Übernehmen",
      "create_ticket.ueberschrift": "Überschrift",
      "create_ticket.vielleicht_loest_ein_artikel_das_problem_ber": "Vielleicht löst ein Artikel das Problem bereits?",
      "create_ticket.vorlage_einfuegen": "Vorlage einfügen",
      "create_ticket.waehlen_sie_einen_kunden_aus_um_dessen_asset": "Wählen Sie einen Kunden aus, um dessen Assets verknüpfen zu können.",
      "create_ticket.werden_bei_erstellung_ausgeloest": "Werden bei Erstellung ausgelöst",
      "create_ticket.zurueck": "Zurück",
      "created_at": "Erstellt am",
      "critical_priority_sla": "Priorität / SLA",
      "customer": "Kunde",
      "customer_assets.no_assets": "Keine Assets für diesen Kunden erfasst. Mit Zabbix-Host-ID oder Uptime-Monitor an einem Asset erscheinen Status-Hinweise hier.",
      "customer_assets.no_assets_unconfigured": "Keine Assets erfasst. Discovery oder eine Monitoring-Integration kann die Inventarisierung automatisieren.",
      "customer_assets.no_zabbix_id": "Keine Zabbix-Host-ID am Asset",
      "customer_assets.start_rd": "RustDesk starten",
      "customer_assets.start_tv": "TeamViewer starten",
      "customer_form.adresse_eingeben_um_karte_anzuzeigen": "Adresse eingeben um Karte anzuzeigen",
      "customer_form.client_secret": "Client Secret",
      "customer_form.domain_entfernen": "Domain entfernen",
      "customer_form.domain_hinzufuegen": "+ Domain hinzufügen",
      "customer_form.domains_mit_zugeordneten_mitarbeitern_koenne": "Domains mit zugeordneten Mitarbeitern können nicht entfernt werden.",
      "customer_form.geschaeftsfuehrer": "Geschäftsführer",
      "customer_form.in_openstreetmap_oeffnen": "In OpenStreetMap öffnen ↗",
      "customer_form.interne_notizen_zu_diesem_kunden": "Interne Notizen zu diesem Kunden...",
      "customer_form.kontakt_in_lexoffice_anlegen_uuid_hier_eintr": "Kontakt in Lexoffice anlegen, UUID hier eintragen",
      "customer_form.lexoffice_kontakt_id_uuid": "Lexoffice Kontakt-ID (UUID)",
      "customer_form.logo_kann_nach_dem_erstellen_des_kunden_hoch": "Logo kann nach dem Erstellen des Kunden hochgeladen werden.",
      "customer_form.mitarbeiter_koennen_sich_per_microsoft_konto": "Mitarbeiter können sich per Microsoft-Konto anmelden",
      "customer_form.mloffice_badge": "Von MLOffice verwaltet",
      "customer_form.mloffice_banner": "Dieser Kunde wird mit MLOffice abgeglichen. Stammdaten (Name, E-Mail, Telefon, Anschrift, USt-ID) werden von MLOffice verwaltet und sind hier gesperrt.",
      "customer_form.mloffice_feld_hinweis": "Dieses Feld wird von MLOffice verwaltet — Änderungen bitte dort vornehmen; sie werden automatisch übernommen.",
      "customer_form.mloffice_geloest": "Verknüpfung gelöst — die Felder sind wieder bearbeitbar.",
      "customer_form.mloffice_loesen": "Verknüpfung lösen…",
      "customer_form.mloffice_loesen_fehler": "Verknüpfung konnte nicht gelöst werden.",
      "customer_form.mloffice_loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "customer_form.mloffice_loest": "Löse…",
      "customer_form.mloffice_verwaltung_hinweis": "Verwaltung der Verknüpfung unter Stammdaten & Organisation → MLOffice (erfordert Systemrechte).",
      "customer_form.registrieren_sie_eine_app_in_azure_portal_ap": "Registrieren Sie eine App in Azure Portal → App-Registrierungen. Redirect URI:",
      "customer_form.strasse": "Straße",
      "customer_form.tab_address": "Adresse",
      "customer_form.tab_domains": "Domains",
      "customer_form.tab_general": "Allgemein",
      "customer_form.tab_notes": "Notizen",
      "customer_form.tab_sso": "SSO",
      "customer_form.tab_tax": "Steuer & SLA",
      "customer_form.zuordnung_ticket_system_kunde_lexoffice_kont": "Zuordnung Ticket-System-Kunde → Lexoffice-Kontakt für Entwurfsrechnungen (Admin → Zeiterfassung).",
      "customer_inactive": "Kunde inaktiv",
      "customer_not_found": "Kunde nicht gefunden",
      "customer_notified_by_email": "Kunde wird per E-Mail benachrichtigt",
      "customer_number_abbrev": "Kd-Nr",
      "customer_portal.action_required": "Aktion erforderlich",
      "customer_portal.action_required_desc": "Das Support-Team wartet auf Ihre Rückmeldung zu diesem Ticket.",
      "customer_portal.action_required_title": "Ihre Antwort wird benötigt",
      "customer_portal.assignee": "Bearbeiter",
      "customer_portal.attachments_count": "Anhänge ({{count}})",
      "customer_portal.attachments_load_failed": "Weitere Anhänge konnten nicht geladen werden.",
      "customer_portal.back": "← Zurück",
      "customer_portal.back_to_my_tickets": "← Zurück zu Meine Tickets",
      "customer_portal.close": "Schließen",
      "customer_portal.close_failed": "Das Ticket konnte nicht geschlossen werden.",
      "customer_portal.collapse_replies": "Ältere schließen",
      "customer_portal.compact_replies": "Ältere Antworten sind eingeklappt. Die letzte Antwort bleibt geöffnet.",
      "customer_portal.confirm_close": "Möchten Sie dieses Ticket wirklich schließen?",
      "customer_portal.confirm_reopen": "Möchten Sie dieses Ticket wieder öffnen?",
      "customer_portal.contracts.hours_minutes": "{{hours}}h {{minutes}}min",
      "customer_portal.contracts.hours_only": "{{hours}}h",
      "customer_portal.contracts.minutes_only": "{{minutes}}min",
      "customer_portal.create_first_ticket": "Neues Ticket erstellen",
      "customer_portal.created": "Erstellt",
      "customer_portal.customer_colleague": "Kollegin/Kollege",
      "customer_portal.dashboard.active_count": "{{count}} aktiv",
      "customer_portal.dashboard.avg_resolution": "Ø Lösungszeit",
      "customer_portal.dashboard.click_to_view_waiting": "Klicken Sie hier, um die Tickets anzuzeigen",
      "customer_portal.dashboard.create_first_link": "Erstes Ticket erstellen →",
      "customer_portal.dashboard.create_new_ticket_link": "Neues Ticket erstellen",
      "customer_portal.dashboard.history_trend": "Ticket-Verlauf (letzte 12 Monate)",
      "customer_portal.dashboard.kb": "Hilfe & Wissensbasis",
      "customer_portal.dashboard.kb_desc": "Anleitungen und FAQs",
      "customer_portal.dashboard.my_tickets": "Meine Tickets",
      "customer_portal.dashboard.no_tickets": "Noch keine Tickets vorhanden",
      "customer_portal.dashboard.no_tickets_status": "Keine Tickets",
      "customer_portal.dashboard.open_active": "Offen / Aktiv",
      "customer_portal.dashboard.processing_time": "Bearbeitungszeit",
      "customer_portal.dashboard.recent_tickets": "Letzte Tickets",
      "customer_portal.dashboard.report_incident": "Störung melden",
      "customer_portal.dashboard.report_incident_desc": "Dringendes Problem oder Ausfall melden",
      "customer_portal.dashboard.reports": "Übersicht & Reports",
      "customer_portal.dashboard.reports_desc": "Alle Tickets filtern und auswerten",
      "customer_portal.dashboard.search_kb_link": "Wissensbasis durchsuchen",
      "customer_portal.dashboard.service_request": "Service-Anfrage",
      "customer_portal.dashboard.service_request_desc": "Anfragen nach konfigurierbaren Formularen",
      "customer_portal.dashboard.show_all_link": "Alle anzeigen →",
      "customer_portal.dashboard.status_overview": "Status-Übersicht",
      "customer_portal.dashboard.subtitle": "Ihre Support-Übersicht auf einen Blick",
      "customer_portal.dashboard.total_tickets": "Tickets gesamt",
      "customer_portal.dashboard.waiting_tickets_warning": "1 Ticket benötigt Ihre Antwort",
      "customer_portal.dashboard.waiting_tickets_warning_plural": "{{count}} Tickets benötigen Ihre Antwort",
      "customer_portal.dashboard.welcome": "Willkommen",
      "customer_portal.dashboard.widget_unknown": "Widget: {{type}}",
      "customer_portal.dashboard.your_reply": "Ihre Antwort",
      "customer_portal.details_title": "Details",
      "customer_portal.editor.bold": "Fett",
      "customer_portal.editor.code": "Code",
      "customer_portal.editor.italic": "Kursiv",
      "customer_portal.editor.list": "Liste",
      "customer_portal.expand_replies": "Alle öffnen",
      "customer_portal.files_draft_failed": "Anhänge konnten nicht dauerhaft im Entwurf gespeichert werden.",
      "customer_portal.files_need_reselect": "Anhänge können aus Sicherheitsgründen nicht wiederhergestellt werden. Bitte wählen Sie sie erneut aus.",
      "customer_portal.filters.active": "Aktiv",
      "customer_portal.filters.all": "Alle",
      "customer_portal.filters.closed": "Geschlossen",
      "customer_portal.filters.external": "Extern",
      "customer_portal.filters.waiting_customer": "Ihre Antwort",
      "customer_portal.history_title": "Verlauf",
      "customer_portal.impersonation_banner": "Sie betrachten dieses Portal aktuell im Impersonierungs-Modus (Vorschau für Agenten) als Kunde:",
      "customer_portal.incident_badge": "Störung",
      "customer_portal.kb.title": "Wissensbasis",
      "customer_portal.load_more_attachments": "Weitere Anhänge laden",
      "customer_portal.login.betreut_von": "BETREUT VON NALVRA",
      "customer_portal.login.claim": "Ihr direkter Draht zum Support — Anliegen melden, Status sehen, Antworten finden.",
      "customer_portal.login.copyright_text": "© {{year}} {{appName}}. Alle Rechte vorbehalten.",
      "customer_portal.login.default_subtitle": "Melden Sie sich an, um Ihre Anfragen zu verwalten.",
      "customer_portal.login.default_welcome": "Willkommen bei {{appName}}",
      "customer_portal.login.email": "E-Mail",
      "customer_portal.login.email_placeholder": "name@firma.de",
      "customer_portal.login.eyebrow": "KUNDENPORTAL · 24/7 ERREICHBAR",
      "customer_portal.login.forgot_password": "Passwort vergessen?",
      "customer_portal.login.kein_zugang": "Noch keinen Zugang? Wenden Sie sich an Ihren Ansprechpartner im Support.",
      "customer_portal.login.kundenanmeldung": "Kundenanmeldung",
      "customer_portal.login.kundenportal": "KUNDENPORTAL",
      "customer_portal.login.microsoft_signin": "Mit Microsoft anmelden",
      "customer_portal.login.mit_hinterlegter_adresse": "Mit Ihrer hinterlegten E-Mail-Adresse anmelden.",
      "customer_portal.login.or_password": "oder mit Passwort",
      "customer_portal.login.password": "Passwort",
      "customer_portal.login.password_placeholder": "Ihr Passwort",
      "customer_portal.login.reset_back": "Zurück zur Anmeldung",
      "customer_portal.login.reset_button": "Link senden",
      "customer_portal.login.reset_instruction": "Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen.",
      "customer_portal.login.reset_sent_message": "Falls ein Konto mit dieser Adresse existiert, haben wir einen Link zum Zurücksetzen gesendet.",
      "customer_portal.login.reset_sent_title": "E-Mail gesendet",
      "customer_portal.login.reset_title": "Passwort zurücksetzen",
      "customer_portal.login.sicherheitszeile": "Verschlüsselte Verbindung · Zugang nur für hinterlegte Kontakte",
      "customer_portal.login.signin_button": "Anmelden",
      "customer_portal.login.signing_in": "Anmeldung läuft …",
      "customer_portal.login.sso_available": "Single Sign-on verfügbar",
      "customer_portal.login.sso_failed": "SSO-Anmeldung fehlgeschlagen",
      "customer_portal.login.sso_logging_in": "Anmeldung läuft …",
      "customer_portal.menu.dashboard": "Dashboard",
      "customer_portal.menu.edit_profile": "Profil bearbeiten",
      "customer_portal.menu.logout": "Abmelden",
      "customer_portal.menu.profile": "Mein Profil",
      "customer_portal.message_placeholder": "Ihre Nachricht...",
      "customer_portal.nav.contracts": "Verträge",
      "customer_portal.nav.create_request": "Anfrage erstellen",
      "customer_portal.nav.dashboard": "Dashboard",
      "customer_portal.nav.documents": "Dokumente",
      "customer_portal.nav.downloads": "Downloads",
      "customer_portal.nav.help": "Hilfe & Kurztour",
      "customer_portal.nav.kb": "Wissensbasis",
      "customer_portal.nav.my_tickets": "Meine Tickets",
      "customer_portal.nav.profile": "Profil",
      "customer_portal.nav.report_incident": "Störung melden",
      "customer_portal.nav.service_request": "Service-Anfrage",
      "customer_portal.nav.support": "Support erhalten",
      "customer_portal.navigation": "Portal-Navigation",
      "customer_portal.new_ticket": "Neues Ticket",
      "customer_portal.new_ticket.add_attachment": "Hinzufügen",
      "customer_portal.new_ticket.ai_improve_btn": "Beschreibung verbessern",
      "customer_portal.new_ticket.ai_improving": "Wird verbessert...",
      "customer_portal.new_ticket.ai_preanswer_title": "KI-Vorschlag zu Ihrem Problem",
      "customer_portal.new_ticket.ai_suggestion_title": "KI-Verbesserungsvorschlag",
      "customer_portal.new_ticket.allowed_types_tip": "Nur konfigurierte Dateitypen (siehe Hinweis Ihres Administrators)",
      "customer_portal.new_ticket.apply": "Übernehmen",
      "customer_portal.new_ticket.attach_file": "Datei anhängen",
      "customer_portal.new_ticket.attachment_plural": "Anhänge",
      "customer_portal.new_ticket.attachment_singular": "Anhang",
      "customer_portal.new_ticket.back_step_1": "Zurück zu Schritt 1",
      "customer_portal.new_ticket.back_step_2": "Zurück zu Schritt 2",
      "customer_portal.new_ticket.categories_error": "Kategorien konnten nicht geladen werden.",
      "customer_portal.new_ticket.categories_loading": "Kategorien werden geladen …",
      "customer_portal.new_ticket.category_assignment": "Kategorie zuordnen",
      "customer_portal.new_ticket.category_by_support": "Zuordnung durch den Support",
      "customer_portal.new_ticket.category_hint": "Sie sind unsicher? Lassen Sie die Kategorie offen. Der Support übernimmt die Zuordnung.",
      "customer_portal.new_ticket.category_question": "Welche Kategorie passt zu Ihrem Anliegen?",
      "customer_portal.new_ticket.char_count": "{{count}} Zeichen",
      "customer_portal.new_ticket.continue_step_2": "Weiter zu Schritt 2",
      "customer_portal.new_ticket.continue_step_3": "Weiter zu Schritt 3",
      "customer_portal.new_ticket.create": "Erstellen",
      "customer_portal.new_ticket.create_anyway": "Trotzdem Ticket erstellen",
      "customer_portal.new_ticket.create_ticket": "Ticket erstellen",
      "customer_portal.new_ticket.creating": "Wird erstellt...",
      "customer_portal.new_ticket.days_count": "{{count}} Werktage",
      "customer_portal.new_ticket.description_label": "Beschreibung *",
      "customer_portal.new_ticket.description_placeholder": "Beschreiben Sie Ihr Problem im Detail...\\n\\n• Was funktioniert nicht?\\n• Seit wann tritt das Problem auf?\\n• Gibt es eine Fehlermeldung?\\n• Welches System / Gerät ist betroffen?\\n\\nTipp: Screenshots mit Strg+V einfügen",
      "customer_portal.new_ticket.description_required": "Bitte beschreiben Sie Ihr Problem.",
      "customer_portal.new_ticket.discard": "Verwerfen",
      "customer_portal.new_ticket.drag_more": "Weitere Dateien hierher ziehen · Noch {{count}} möglich",
      "customer_portal.new_ticket.drag_or_click": "Dateien hierher ziehen oder klicken",
      "customer_portal.new_ticket.drop_here": "Dateien hier ablegen...",
      "customer_portal.new_ticket.error_create_failed": "Fehler beim Erstellen des Tickets.",
      "customer_portal.new_ticket.expected_first_response": "Erste Antwort",
      "customer_portal.new_ticket.go_to_step": "Schritt {{step}}: {{label}}",
      "customer_portal.new_ticket.hide": "Ausblenden",
      "customer_portal.new_ticket.hours_count": "{{count}} Stunden",
      "customer_portal.new_ticket.insert_template": "Vorlage einfügen",
      "customer_portal.new_ticket.kb_article_error": "Dieser Artikel konnte nicht geladen werden. Sie können es erneut versuchen oder mit Ihrem Ticket fortfahren.",
      "customer_portal.new_ticket.kb_close_article": "Artikel schließen",
      "customer_portal.new_ticket.kb_did_help": "Hat dieser Artikel Ihr Problem gelöst?",
      "customer_portal.new_ticket.kb_draft_retained": "Ihr Ticketentwurf bleibt erhalten. Sie entscheiden, ob Sie ihn weiter bearbeiten.",
      "customer_portal.new_ticket.kb_feedback_error": "Ihre Rückmeldung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut. Ihr Entwurf bleibt erhalten.",
      "customer_portal.new_ticket.kb_helped": "Artikel hat mir geholfen",
      "customer_portal.new_ticket.kb_loading_article": "Artikel wird geladen",
      "customer_portal.new_ticket.kb_resolved_message": "Ihre Rückmeldung wurde gespeichert. Es wurde kein Ticket erstellt.",
      "customer_portal.new_ticket.kb_resolved_title": "Schön, dass die Anleitung geholfen hat",
      "customer_portal.new_ticket.kb_resume_draft": "Ticketentwurf weiter bearbeiten",
      "customer_portal.new_ticket.kb_retry": "Erneut laden",
      "customer_portal.new_ticket.kb_saved_draft": "Ihr Entwurf bleibt für Sie gespeichert, falls Sie später doch Unterstützung benötigen.",
      "customer_portal.new_ticket.kb_searching": "Lösungen werden gesucht",
      "customer_portal.new_ticket.kb_suggestions_hint": "Passende Anleitungen aus der Wissensbasis. Lesen Sie einen Artikel, bevor Sie Ihr Ticket erstellen.",
      "customer_portal.new_ticket.kb_suggestions_title": "Vielleicht ist die Lösung schon da",
      "customer_portal.new_ticket.kb_to_dashboard": "Zurück zum Dashboard",
      "customer_portal.new_ticket.max_files": "Max. {{count}} Dateien",
      "customer_portal.new_ticket.max_size": "Max. {{count}} MB / Datei",
      "customer_portal.new_ticket.minutes_count": "{{count}} Minuten",
      "customer_portal.new_ticket.no_category": "Bitte Kategorie wählen...",
      "customer_portal.new_ticket.optional": "Optional",
      "customer_portal.new_ticket.preanswer_might_resolve": "Hat Ihnen das geholfen? Dann brauchen Sie möglicherweise kein Ticket zu erstellen.",
      "customer_portal.new_ticket.presubmit_kb_desc": "Kein passender Artikel? Kein Problem — erstellen Sie Ihr Ticket.",
      "customer_portal.new_ticket.presubmit_kb_title": "Das könnte Ihr Problem bereits lösen",
      "customer_portal.new_ticket.prio_desc_critical": "Sofort",
      "customer_portal.new_ticket.prio_desc_high": "Dringend",
      "customer_portal.new_ticket.prio_desc_low": "Kann warten",
      "customer_portal.new_ticket.prio_desc_medium": "Normal",
      "customer_portal.new_ticket.progress": "Fortschritt der Ticketerstellung",
      "customer_portal.new_ticket.relevant_articles": "Passende Artikel:",
      "customer_portal.new_ticket.reply_by_email_tip": "Sie können auf dieses Ticket auch per E-Mail antworten",
      "customer_portal.new_ticket.resolution": "Lösung",
      "customer_portal.new_ticket.response_time_typical": "Antwort in der Regel innerhalb weniger Stunden",
      "customer_portal.new_ticket.retry_categories": "Erneut laden",
      "customer_portal.new_ticket.screenshot_tip": "Screenshots mit Strg+V einfügen",
      "customer_portal.new_ticket.similar_tickets": "Ähnliche Tickets",
      "customer_portal.new_ticket.step_attachments": "Anhänge",
      "customer_portal.new_ticket.step_attachments_detail": "Kategorie, Anhänge und Absenden",
      "customer_portal.new_ticket.step_count": "Schritt {{step}} von 3",
      "customer_portal.new_ticket.step_details": "Details",
      "customer_portal.new_ticket.step_details_detail": "Beschreibung und Priorität",
      "customer_portal.new_ticket.step_subject": "Betreff",
      "customer_portal.new_ticket.step_subject_detail": "Person, Betreff und Wissensbasis",
      "customer_portal.new_ticket.subject_desc_required": "Betreff und Beschreibung sind erforderlich.",
      "customer_portal.new_ticket.subject_label": "Betreff *",
      "customer_portal.new_ticket.subject_placeholder": "Kurze möglichst aussagekräftige Beschreibung Ihres Problems",
      "customer_portal.new_ticket.subject_required": "Bitte geben Sie einen Betreff ein.",
      "customer_portal.new_ticket.subtitle": "Technische Störung oder dringendes Problem — wird als Ticket an den Support übermittelt.",
      "customer_portal.new_ticket.subtitle_2": "Beschreiben Sie Ihr Anliegen und wir kümmern uns darum.",
      "customer_portal.new_ticket.success_desc": "Vielen Dank. Wir werden uns so schnell wie möglich bei Ihnen melden.",
      "customer_portal.new_ticket.success_title": "Ticket erstellt!",
      "customer_portal.new_ticket.template_btn": "Beispiel",
      "customer_portal.new_ticket.view_ticket": "Ticket ansehen",
      "customer_portal.no_attachments": "Keine Anhänge vorhanden.",
      "customer_portal.no_tickets_create_desc": "Erstellen Sie Ihr erstes Ticket.",
      "customer_portal.no_tickets_filter_desc": "Versuchen Sie einen anderen Filter.",
      "customer_portal.no_tickets_search_desc": "Versuchen Sie einen anderen Suchbegriff.",
      "customer_portal.no_tickets_title": "Keine Tickets gefunden",
      "customer_portal.pagination_of": "von",
      "customer_portal.password.btn": "Passwort ändern",
      "customer_portal.password.cancel": "Abbrechen",
      "customer_portal.password.changing": "Wird geändert...",
      "customer_portal.password.confirm": "Neues Passwort bestätigen",
      "customer_portal.password.current": "Aktuelles Passwort",
      "customer_portal.password.error_change": "Fehler beim Ändern.",
      "customer_portal.password.error_min_length": "Mindestens 8 Zeichen.",
      "customer_portal.password.error_mismatch": "Passwörter stimmen nicht überein.",
      "customer_portal.password.error_same": "Neues Passwort muss sich unterscheiden.",
      "customer_portal.password.logout": "Abmelden",
      "customer_portal.password.mismatch_warning": "Passwörter stimmen nicht überein",
      "customer_portal.password.must_change_desc": "Bitte ändern Sie Ihr Passwort, bevor Sie fortfahren.",
      "customer_portal.password.new": "Neues Passwort (min. 8 Zeichen)",
      "customer_portal.password.redirecting": "Sie werden weitergeleitet...",
      "customer_portal.password.success": "Passwort erfolgreich geändert!",
      "customer_portal.password.title": "Passwort ändern",
      "customer_portal.priority_help.high": "Mehrere Mitarbeitende oder eine wichtige Funktion sind stark beeinträchtigt. Es gibt keine praktikable Ausweichlösung, der übrige Betrieb läuft jedoch weiter.",
      "customer_portal.priority_help.low": "Kleine Einschränkung oder allgemeine Frage. Sie können normal weiterarbeiten, zum Beispiel bei einem Darstellungsfehler oder einem Änderungswunsch.",
      "customer_portal.priority_help.medium": "Die Arbeit ist eingeschränkt, aber eine Ausweichlösung ist möglich. Beispiel: Ein Drucker fällt aus, ein anderer kann genutzt werden.",
      "customer_portal.priority_help.urgent": "Der Betrieb oder ein geschäftskritischer Prozess steht still. Es gibt keine Ausweichlösung, zum Beispiel bei einem vollständigen Ausfall des zentralen Systems. Bitte nicht nur wegen eines persönlichen Wunschtermins wählen.",
      "customer_portal.processing_time": "Bearbeitungszeit",
      "customer_portal.profile.cancel": "Abbrechen",
      "customer_portal.profile.change_password_btn": "Passwort ändern",
      "customer_portal.profile.change_photo": "Profilbild ändern",
      "customer_portal.profile.closed": "Geschlossen",
      "customer_portal.profile.company": "Unternehmen",
      "customer_portal.profile.company_account": "Unternehmen & Account",
      "customer_portal.profile.days_count": "{{count}} Werktag(e)",
      "customer_portal.profile.department": "Abteilung",
      "customer_portal.profile.edit": "Bearbeiten",
      "customer_portal.profile.email": "E-Mail",
      "customer_portal.profile.error_save": "Fehler beim Speichern",
      "customer_portal.profile.error_upload": "Fehler beim Hochladen",
      "customer_portal.profile.first_name": "Vorname",
      "customer_portal.profile.first_response": "Erste Antwort",
      "customer_portal.profile.hours_count": "{{count}} Std.",
      "customer_portal.profile.last_name": "Nachname",
      "customer_portal.profile.loading": "Profil wird geladen...",
      "customer_portal.profile.location": "Standort",
      "customer_portal.profile.member_since": "Mitglied seit",
      "customer_portal.profile.minutes_count": "{{count}} Min.",
      "customer_portal.profile.mobile": "Mobil",
      "customer_portal.profile.mobile_placeholder": "z.B. +49 170 12345",
      "customer_portal.profile.open": "Offen",
      "customer_portal.profile.personal_data": "Persönliche Daten",
      "customer_portal.profile.phone": "Telefon",
      "customer_portal.profile.phone_placeholder": "z.B. +49 221 12345",
      "customer_portal.profile.position": "Position",
      "customer_portal.profile.resolution": "Lösung",
      "customer_portal.profile.save": "Speichern",
      "customer_portal.profile.security": "Sicherheit",
      "customer_portal.profile.security_desc": "Ändern Sie Ihr Passwort regelmäßig für mehr Sicherheit.",
      "customer_portal.profile.service_level": "Service Level",
      "customer_portal.profile.show_dashboard": "Dashboard anzeigen",
      "customer_portal.profile.sla_tier": "SLA-Stufe",
      "customer_portal.profile.sso_active": "SSO-Authentifizierung aktiv",
      "customer_portal.profile.success_photo": "Profilbild aktualisiert",
      "customer_portal.profile.success_update": "Profil erfolgreich aktualisiert",
      "customer_portal.profile.ticket_overview": "Ticket-Übersicht",
      "customer_portal.profile.total": "Gesamt",
      "customer_portal.reopen": "Wieder öffnen",
      "customer_portal.reopen_failed": "Das Ticket konnte nicht wieder geöffnet werden.",
      "customer_portal.reopen_ticket": "Ticket wieder öffnen",
      "customer_portal.replies_load_failed": "Ältere Antworten konnten nicht geladen werden.",
      "customer_portal.reply_btn": "Antworten",
      "customer_portal.reply_failed": "Ihre Antwort konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
      "customer_portal.reply_plural": "Antworten",
      "customer_portal.reply_singular": "Antwort",
      "customer_portal.request_badge": "Anfrage",
      "customer_portal.requests.attachments": "Anhänge",
      "customer_portal.requests.category": "Kategorie",
      "customer_portal.requests.description": "Beschreibung",
      "customer_portal.requests.priority": "Priorität",
      "customer_portal.search_label": "Tickets suchen",
      "customer_portal.search_placeholder": "Ticket-Nr. oder Betreff suchen...",
      "customer_portal.sending": "Wird gesendet...",
      "customer_portal.service_level": "Service Level",
      "customer_portal.show_older_replies": "{{count}} ältere Antworten anzeigen...",
      "customer_portal.sla.met": "Erfüllt",
      "customer_portal.sla.on_track": "Im Plan",
      "customer_portal.sla.overdue": "Überfällig",
      "customer_portal.sla.warning": "Bald fällig",
      "customer_portal.source": "Quelle",
      "customer_portal.source_portal": "Portal",
      "customer_portal.stop_impersonation": "Impersonierung beenden",
      "customer_portal.support_team": "Support-Team",
      "customer_portal.ticket_closed_desc": "Dieses Ticket ist geschlossen.",
      "customer_portal.ticket_load_failed": "Ticket konnte nicht geladen werden",
      "customer_portal.ticket_load_failed_desc": "Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "customer_portal.ticket_not_found": "Ticket nicht gefunden",
      "customer_portal.ticket_owner": "Ihr zuständiger Support-Agent",
      "customer_portal.ticket_plural": "Tickets",
      "customer_portal.ticket_singular": "Ticket",
      "customer_portal.tickets_load_failed": "Tickets konnten nicht geladen werden",
      "customer_portal.tickets_load_failed_desc": "Ihre Daten wurden nicht verändert.",
      "customer_portal.times_title": "Zeiten",
      "customer_portal.unassigned_owner": "Noch nicht zugewiesen",
      "customer_portal.unsaved_warning": "Ihr nicht gesendeter Entwurf geht beim Verlassen möglicherweise verloren.",
      "customer_portal.updated": "Aktualisiert",
      "customer_portal.via_email": "per E-Mail",
      "customer_portal.write_reply": "Antwort schreiben",
      "customer_portal.you": "Sie",
      "customer_tickets_summary": "{{open}} offen / {{total}} ges.",
      "customers": "Kunden",
      "customize": "Anpassen",
      "dark_mode": "Dunkles Design",
      "dashboard": "Dashboard",
      "dashboard_sub": "Hier sind Ihre operativen KPIs, SLA-Zustände und Ticketstatistiken.",
      "days_ago": "Vor {{count}} Tagen",
      "delete": "Löschen",
      "density": "Dichte:",
      "density_comfort_label": "Komfort",
      "density_comfortable": "Normal",
      "density_compact": "Kompakt",
      "density_spacious": "Weit",
      "density_standard_label": "Standard",
      "device_actions": "Geräte & Lizenzen",
      "device_actions_hint": "Fernwartung, Remote-Terminal, Behebung und Lizenzen der verknüpften Geräte",
      "document.all": "Alle",
      "document.category.certificate": "Zertifikat",
      "document.category.contract": "Vertrag",
      "document.category.correspondence": "Korrespondenz",
      "document.category.general": "Allgemein",
      "document.category.invoice": "Rechnung",
      "document.category.manual": "Anleitung",
      "document.category.report": "Bericht",
      "document.none_found": "Keine Dokumente gefunden",
      "document.none_found_desc": "Versuchen Sie einen anderen Suchbegriff",
      "document.none_shared": "Noch keine Dokumente für Sie freigegeben",
      "document.none_shared_desc": "Ihr Ansprechpartner kann Ihnen hier Dokumente bereitstellen",
      "document.plural": "Dokumente",
      "document.search_placeholder": "Dokumente durchsuchen...",
      "document.singular": "Dokument",
      "document.subtitle": "Ihre freigegebenen Dokumente, Verträge und Unterlagen",
      "document.total_suffix": "gesamt",
      "domains": "Domains",
      "draft_present": "Entwurf",
      "draft_saved": "Entwurf gespeichert",
      "drag_to_move": "{{label}} (ziehen zum Verschieben)",
      "drag_to_sort": "Ziehen zum Sortieren, klicken zum Ein-/Ausblenden",
      "duration": "Dauer (Min.)",
      "duration_minutes": "{{count}} Minuten",
      "edit": "Bearbeiten",
      "edit_customer": "Kunde bearbeiten",
      "edit_master_data_admin": "Stammdaten in der Verwaltung bearbeiten",
      "edit_widgets_title": "Widgets einblenden & sortieren",
      "email": "E-Mail",
      "email_channel": "E-Mail-Kanal",
      "employee_form.account_erstellt": "Account erstellt:",
      "employee_form.bitte_zuerst_kunde_auswaehlen": "Bitte zuerst Kunde auswählen",
      "employee_form.dieser_mitarbeiter_hat_noch_keinen_zugang_zu": "Dieser Mitarbeiter hat noch keinen Zugang zum Kundenportal. Erstellen Sie einen Account mit Passwort.",
      "employee_form.domain_waehlen": "Domain wählen",
      "employee_form.domains_werden_geladen": "Domains werden geladen...",
      "employee_form.e_mail_server_nicht_konfiguriert": "E-Mail-Server nicht konfiguriert",
      "employee_form.initialpasswort_vergeben": "Initialpasswort vergeben...",
      "employee_form.interne_notizen_zum_mitarbeiter": "Interne Notizen zum Mitarbeiter...",
      "employee_form.kein_portal_zugang_vorhanden": "Kein Portal-Zugang vorhanden",
      "employee_form.keine_domains_fuer_diesen_kunden_hinterlegt": "Keine Domains für diesen Kunden hinterlegt.",
      "employee_form.kunde_auswaehlen": "Kunde auswählen",
      "employee_form.lade_account_informationen": "Lade Account-Informationen...",
      "employee_form.leer_lassen_wenn_kein_portal_zugang_benoetig": "Leer lassen, wenn kein Portal-Zugang benötigt wird (z.B. bei SSO).",
      "employee_form.letzter_login": "Letzter Login:",
      "employee_form.neues_passwort": "Neues Passwort...",
      "employee_form.neues_passwort_min_8_zeichen": "Neues Passwort (min. 8 Zeichen)",
      "employee_form.passwort_fuer_neuen_account_min_8_zeichen": "Passwort für neuen Account (min. 8 Zeichen)",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge": "Passwortänderung beim ersten Login erzwingen",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge_2": "Passwortänderung beim ersten Login erzwingen",
      "employee_form.passwortaenderung_beim_naechsten_login_erzwi": "Passwortänderung beim nächsten Login erzwingen",
      "employee_form.profilbild_kann_nach_dem_erstellen_hochgelad": "Profilbild kann nach dem Erstellen hochgeladen werden.",
      "employee_form.pw_aenderung_ausstehend": "PW-Änderung ausstehend",
      "employee_form.reset_link_24h_gueltig": "Reset-Link (24h gültig):",
      "employee_form.tab_access": "Kundenportal",
      "employee_form.tab_it": "IT & Arbeitsplatz",
      "employee_form.tab_notes": "Notizen",
      "employee_form.tab_personal": "Persönlich",
      "employee_form.tab_work": "Arbeit & Kontakt",
      "employee_form.weitere_it_informationen_wie_betriebssystem": "Weitere IT-Informationen wie Betriebssystem, installierte Software etc. können in den Notizen hinterlegt werden.",
      "employee_form.z_b_koeln_buero_3_og": "z.B. Köln, Büro 3.OG",
      "employees": "Mitarbeiter",
      "employees_ca": "Mitarbeiter (ca.)",
      "end_edit": "Bearbeiten beenden",
      "enter_title_error": "Bitte einen Titel eingeben.",
      "escalate": "Eskalieren",
      "escalated": "Eskaliert",
      "escalated_badge": "Eskaliert",
      "expand_sidebar": "Sidebar aufklappen",
      "expired": "Abgelaufen",
      "expires_at": "Läuft bis",
      "expiring_soon": "Läuft bald ab",
      "export_csv": "CSV-Datei",
      "export_pdf": "PDF-Dokument",
      "export_png": "PNG-Diagramm",
      "export_xlsx": "Excel (XLSX)",
      "filter_active": "Filter active",
      "filter_all_az": "Alle A–Z",
      "filter_list_placeholder": "Liste filtern…",
      "filter_open_first": "Offene zuerst",
      "filter_open_only": "Nur mit Offenen",
      "filter_with_sla": "Mit SLA-Tier",
      "first_post_attachments": "Anhänge zum Eröffnungsbeitrag",
      "first_response": "Erste Antwort",
      "follow_ups": "Warte auf Kunde",
      "generating": "Generiere...",
      "greeting_day": "Guten Tag, {{name}} 👋",
      "held_review": "Prüfung erforderlich",
      "high_priority": "Hohe Priorität",
      "hours": "Stunden",
      "hours_ago": "Vor {{count}} Std.",
      "inactive": "Inaktiv",
      "included_hours": "Inkl. Stunden",
      "industry": "Branche",
      "internal": "Intern",
      "internal_chat": "Interner Chat",
      "internal_note": "Interne Notiz",
      "internal_notes": "Interne Notizen",
      "internal_notes_placeholder": "Interne Notizen zum Kunden...",
      "invalid_datetime_error": "Ungültiges Datum oder Uhrzeit.",
      "just_now": "Gerade eben",
      "kb.all_articles": "Alle Artikel",
      "kb.author": "Autor",
      "kb.back_to_overview": "Zurück zur Übersicht",
      "kb.browse_more": "← Weitere Artikel durchstöbern",
      "kb.no_articles": "Noch keine Wissensartikel verfügbar",
      "kb.no_articles_desc": "Hier werden bald hilfreiche Artikel erscheinen",
      "kb.pinned": "Angepinnt",
      "kb.read_time": "{{count}} Min. Lesezeit",
      "kb.search_placeholder": "Wonach suchen Sie? z.B. VPN, Passwort, E-Mail...",
      "kb.subtitle": "Anleitungen, Tipps und Hilfestellungen für Ihre Fragen",
      "kb.try_different_search": "Versuchen Sie einen anderen Suchbegriff",
      "kb.updated_at": "Aktualisiert am {{date}}",
      "kb.views_count": "{{count}} Aufrufe",
      "keyboard_shortcuts": "Tastenkürzel",
      "knowledge": "Wissensbasis",
      "knowledge_base": "Wissensbasis",
      "kpi_held": "Absender unklar",
      "kpi_important": "wichtig",
      "kpi_open": "offen",
      "kpi_sla_breached": "SLA-Bruch",
      "kunde_loeschen.artikel": "Wissensartikel",
      "kunde_loeschen.bestaetigung_label": "Zur Bestätigung den Firmennamen eingeben",
      "kunde_loeschen.connectoren": "Connectoren",
      "kunde_loeschen.dokumente": "Dokumente",
      "kunde_loeschen.einleitung": "Dieser Kunde hat keine Tickets und keine Rechnungen. Er kann vollständig entfernt werden — mitsamt seinem Mandantenbereich in der Datenbank. Das lässt sich nicht rückgängig machen.",
      "kunde_loeschen.endgueltig_loeschen": "Endgültig löschen",
      "kunde_loeschen.fehlgeschlagen": "Das Löschen ist fehlgeschlagen.",
      "kunde_loeschen.geraete": "Geräte im Inventar",
      "kunde_loeschen.lizenzen": "Softwarelizenzen",
      "kunde_loeschen.mitarbeiter": "Mitarbeiter",
      "kunde_loeschen.netzgeraete": "Gefundene Netzwerkgeräte",
      "kunde_loeschen.nichts_dran": "An diesem Kunden hängen keine weiteren Daten.",
      "kunde_loeschen.portalbenutzer": "Portalzugänge",
      "kunde_loeschen.pruefung_fehlgeschlagen": "Die Prüfung ist fehlgeschlagen.",
      "kunde_loeschen.titel": "Kunde endgültig löschen",
      "kunde_loeschen.tokens": "API-Token",
      "kunde_loeschen.vertraege": "Verträge",
      "kunde_loeschen.wird_geprueft": "Wird geprüft …",
      "kunde_loeschen.wird_mitgeloescht": "Wird mitgelöscht",
      "kunde_loeschen.zeiten": "Zeiteinträge",
      "language": "Sprache",
      "license.cluster_audit": "Audit",
      "license.cluster_balance": "Bilanz",
      "license.cluster_calc": "Rechner",
      "license.cluster_contracts": "Verträge & Lizenzen",
      "license.cluster_optimize": "Optimierung",
      "license.tab_ad_coupling": "CAL-AD-Kopplung",
      "license.tab_cal_calc": "CAL-Rechner",
      "license.tab_catalog": "Software-Katalog",
      "license.tab_contracts": "Verträge",
      "license.tab_dashboard": "Lizenzbilanz & Trend",
      "license.tab_licenses": "Lizenzverwaltung",
      "license.tab_more_views": "Weitere Ansichten",
      "license.tab_reclaims": "Optimierung & Reclaims",
      "license.tab_remediation": "Remediation",
      "license.tab_sealed": "Audit-Archiv",
      "license.tab_sql_calc": "SQL-Lizenzrechner",
      "license.tab_steering": "Steuerung",
      "license.tab_suite_config": "Suite-Konfigurator",
      "license_compliance.actions": "Aktionen",
      "license_compliance.assign_license_metric": "Lizenzmetrik zuordnen",
      "license_compliance.confirm_delete_assignment": "Zuordnung wirklich löschen?",
      "license_compliance.confirm_delete_contract": "Vertrag wirklich löschen? Verknüpfte Lizenzen bleiben bestehen, werden aber vom Vertrag gelöst.",
      "license_compliance.contract_expiry_alert": "Vertragsablauf",
      "license_compliance.deficit_forecast_desc": "Basierend auf Live-Scans fallen zum Jahrestag Nachzahlungsgebühren für unterlizenzierte Produkte an.",
      "license_compliance.edit_contract": "Vertrag bearbeiten",
      "license_compliance.edit_license": "Lizenz bearbeiten",
      "license_compliance.expired_contracts_title": "Abgelaufene Software-Verträge erfasst!",
      "license_compliance.expired_contracts_warning_desc": "Lizenzen, die diesen Verträgen zugeordnet sind, werden in der Compliance-Berechnung ignoriert.",
      "license_compliance.forecasted_payment": "Prognostizierte Nachzahlung",
      "license_compliance.license_deficit_alert": "Lizenzdefizit",
      "license_compliance.mark_license_required_btn": "Als lizenzpflichtig markieren",
      "license_compliance.new_contract": "Neuen Vertrag anlegen",
      "license_compliance.new_license": "Neue Lizenz anlegen",
      "license_compliance.no_deficit_desc": "Glückwunsch! Ihre Microsoft Core/CAL Zuweisungen decken alle Scanbefunde ab.",
      "license_compliance.not_catalogued": "Nicht katalogisiert",
      "license_compliance.reconciliation_desc": "Stößt eine manuelle Reconciliation-Schleife für diesen Mandanten an. Berechnet VM-Stacking, WMI-Discovery-Stände, Software-Assurance-Zeiträume und Vertragsgültigkeiten live neu.",
      "license_compliance.reconciliation_running": "Reconciliation läuft...",
      "license_compliance.run_reconciliation": "Abgleich ausführen",
      "license_compliance.sam_warnings_title": "SAM-Warnungen & Compliance",
      "license_compliance.save_contract": "Vertrag speichern",
      "license_compliance.save_license": "Lizenz speichern",
      "license_compliance.seal_audit": "Audit versiegeln",
      "license_compliance.seal_audit_btn": "Rechtssicher versiegeln",
      "license_compliance.sealing": "Versiegelt...",
      "license_compliance.toast.add_suite_component_error": "Fehler beim Zuordnen der Suite-Komponente",
      "license_compliance.toast.assignment_completed": "Lizenzzuweisung erfolgreich durchgeführt.",
      "license_compliance.toast.assignment_error": "Fehler beim Durchführen der Zuweisung",
      "license_compliance.toast.bulk_classify_error": "Fehler bei der Massen-Klassifizierung",
      "license_compliance.toast.bulk_classify_success": "{{count}} Software-Einträge erfolgreich klassifiziert.",
      "license_compliance.toast.calc_audit_error": "Fehler beim Berechnen des Lizenz-Audits",
      "license_compliance.toast.contract_created": "Vertrag erfolgreich angelegt.",
      "license_compliance.toast.contract_deleted": "Vertrag gelöscht.",
      "license_compliance.toast.contract_updated": "Vertrag erfolgreich aktualisiert.",
      "license_compliance.toast.create_purchase_req_error": "Fehler beim Erstellen der Kaufanfrage",
      "license_compliance.toast.delete_contract_error": "Fehler beim Löschen des Vertrags",
      "license_compliance.toast.delete_license_error": "Fehler beim Löschen der Lizenz",
      "license_compliance.toast.delete_suite_component_error": "Fehler beim Löschen der Zuordnung",
      "license_compliance.toast.license_created": "Lizenz erfolgreich angelegt.",
      "license_compliance.toast.license_deleted": "Lizenz gelöscht.",
      "license_compliance.toast.license_updated": "Lizenz erfolgreich aktualisiert.",
      "license_compliance.toast.load_customers_error": "Fehler beim Laden der Kundenliste",
      "license_compliance.toast.purchase_req_created": "Kaufanfrage für {{units}}x {{model}} (True-Up: {{cost}}) als Ticket {{ticket}} erstellt.",
      "license_compliance.toast.reconcile_completed": "Reconciliation erfolgreich abgeschlossen. Compliance-Kennzahlen wurden live neu berechnet.",
      "license_compliance.toast.reconcile_error": "Fehler bei der Reconciliation",
      "license_compliance.toast.sam_settings_saved": "SAM-Einstellungen erfolgreich gespeichert.",
      "license_compliance.toast.save_contract_error": "Fehler beim Speichern des Vertrags",
      "license_compliance.toast.save_license_error": "Fehler beim Speichern der Lizenz",
      "license_compliance.toast.save_sam_settings_error": "Fehler beim Speichern der SAM-Einstellungen",
      "license_compliance.toast.seal_audit_error": "Fehler beim Versiegeln des Lizenzaudits",
      "license_compliance.toast.seal_audit_success": "Lizenzaudit erfolgreich versiegelt.",
      "license_compliance.toast.suite_component_added": "Komponente erfolgreich der Suite zugeordnet.",
      "license_compliance.toast.suite_component_deleted": "Zuordnung gelöscht.",
      "license_compliance.toast.uninstall_error": "Fehler beim Anstoßen der Deinstallationen",
      "license_compliance.toast.uninstall_triggered": "Deinstallations-Befehle eingereiht.",
      "license_compliance.update_contract": "Vertrag aktualisieren",
      "license_compliance.update_license": "Lizenz aktualisieren",
      "licenses": "Lizenzen",
      "light_mode": "Helles Design",
      "link_asset_btn": "+ Asset verknüpfen",
      "live_activity": "Live-Aktivität",
      "loading": "Wird geladen…",
      "loading_ellipsis": "Lade...",
      "location_on_map": "Standort auf der Karte",
      "login.abbrechen": "Abbrechen",
      "login.administratoradresse_konnte_nicht_geaendert_werden": "Die Administratoradresse konnte nicht geändert werden.",
      "login.adresse_aendern": "Adresse ändern",
      "login.adresse_wird_geaendert": "Adresse wird geändert…",
      "login.aendern": "Ändern",
      "login.aktivierung": "Aktivierung…",
      "login.aktivierung_fehlgeschlagen_code_pruefen": "Aktivierung fehlgeschlagen. Bitte den Code überprüfen.",
      "login.alle_rechte_vorbehalten": "· Alle Rechte vorbehalten.",
      "login.anmelden": "Anmelden",
      "login.anmelden_laeuft": "Anmelden…",
      "login.anmeldung": "Anmeldung…",
      "login.bestaetigen": "Bestätigen",
      "login.bitte_geben_sie_eine_gueltige_e_mail_adresse": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      "login.bitte_geben_sie_ihr_passwort_ein": "Bitte geben Sie Ihr Passwort ein.",
      "login.bitte_geben_sie_zuerst_ihre_e_mail_adresse_e": "Bitte geben Sie zuerst Ihre E-Mail-Adresse ein.",
      "login.claim": "Service Desk, Assets und Lizenzen — eine Datenbasis, ein Prozess.",
      "login.datenschutz": "Datenschutz",
      "login.e_mail_adresse_erfolgreich_geaendert": "E-Mail-Adresse erfolgreich geändert. Melden Sie sich jetzt mit der neuen Adresse an.",
      "login.ein_fehler_ist_aufgetreten": "Ein Fehler ist aufgetreten.",
      "login.einloggen_schliessen": "Einloggen & Schließen",
      "login.erstanmeldung": "Erstanmeldung:",
      "login.falls_ein_konto_existiert_wurde_eine_e_mail": "Falls ein Konto existiert, wurde eine E-Mail zum Zurücksetzen gesendet.",
      "login.fehler_beim_laden_des_mfa_setups": "Fehler beim Laden des MFA-Setups",
      "login.fehler_beim_ueberpruefen_der_e_mail_adresse": "Fehler beim Überprüfen der E-Mail-Adresse.",
      "login.geben_sie_den_6_stelligen_code_aus_ihrer_aut": "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App oder einen Wiederherstellungscode ein.",
      "login.geschaeftliche_e_mail": "Geschäftliche E-Mail",
      "login.ihr_account_ist_deaktiviert": "Ihr Account ist deaktiviert.",
      "login.ihr_administrator_erfordert_die_einrichtung": "Ihr Administrator erfordert die Einrichtung der Zwei-Faktor-Authentisierung.",
      "login.impressum": "Impressum",
      "login.kunden_account_erkannt": "Kunden-Account erkannt",
      "login.manueller_schluessel": "Manueller Schlüssel",
      "login.melden_sie_sich_an_ihrem_service_desk_an": "Melden Sie sich an Ihrem Service Desk an.",
      "login.mfa_aktivieren_weiter": "MFA aktivieren & weiter",
      "login.mfa_einrichtung_erforderlich": "MFA-Einrichtung erforderlich",
      "login.mfa_einrichtung_fehlgeschlagen": "MFA-Einrichtung fehlgeschlagen.",
      "login.mfa_erfolgreich_aktiviert": "MFA erfolgreich aktiviert",
      "login.neue_geschaeftliche_e_mail": "Neue geschäftliche E-Mail",
      "login.oder": "ODER",
      "login.passwort": "Passwort",
      "login.qr_code_fuer_die_authenticator_app": "QR-Code für die Authenticator-App",
      "login.sechsstelliger_verifizierungscode": "6-stelliger Verifizierungscode",
      "login.sende": "Sende…",
      "login.sicherheitszeile": "AES-256 · Zwei-Faktor · Betrieb im eigenen Haus",
      "login.sicherheitszeile_kurz": "AES-256 · Zwei-Faktor",
      "login.sie_werden_automatisch_zum_kundenportal_weit": "Sie werden automatisch zum Kundenportal weitergeleitet, um sich dort anzumelden...",
      "login.single_sign_on_entra_id": "Single Sign-On (Entra ID)",
      "login.speichern_sie_diese_einmal_wiederherstellung": "Speichern Sie diese Einmal-Wiederherstellungscodes gut ab! Sie können sie verwenden, falls Sie den Zugriff auf Ihre App verlieren.",
      "login.sso_anmeldung_fehlgeschlagen": "SSO-Anmeldung fehlgeschlagen",
      "login.startkonto_bestaetigt_adresse_festlegen": "Die Zugangsdaten des Startkontos wurden bestätigt. Legen Sie jetzt die geschäftliche Adresse für den Administrator fest.",
      "login.ueberpruefe": "Überprüfe...",
      "login.ungueltiger_oder_abgelaufener_mfa_code": "Ungültiger oder abgelaufener MFA-Code.",
      "login.verifiziere": "Verifiziere…",
      "login.weiter": "Weiter",
      "login.willkommen_zurueck": "Willkommen zurück",
      "login.zurueck_zum_login": "Zurück zum Login",
      "login.zuruecksetzen": "Zurücksetzen",
      "login.zwei_faktor_code_totp": "Zwei-Faktor-Code (TOTP)",
      "logout": "Abmelden",
      "main_navigation_rail": "Hauptnavigation-Schiene",
      "managing_director": "Geschäftsführer",
      "managing_director_abbrev": "GF",
      "managing_director_prefix": "Geschäftsführung:",
      "mark_all_read": "Alle als gelesen",
      "mark_as_resolved": "Als gelöst markieren",
      "mati.connection_error": "Verbindungsfehler",
      "mati.delete": "Löschen",
      "mati.error_failed_connection": "Verbindung zum KI-Dienst fehlgeschlagen.",
      "mati.error_generation": "Fehler bei der Antwortgenerierung. Bitte noch einmal versuchen.",
      "mati.gdpr_warning": "DSGVO-Filter aktiv: Persönliche Daten werden vor der Übertragung automatisch anonymisiert.",
      "mati.greeting": "Hallo {{name}}! Ich bin {{mascot}}. Wie kann ich dich heute bei deiner Arbeit unterstützen? 🔮\\n\\nDu kannst mich fragen nach:\\n- Dem Systemstatus oder Arbeitsauslastung der Agenten\\n- Ticket-Suchen (\"Finde ungelöste Tickets mit hoher Priorität\")\\n- Ticketerstellungen (\"Erstelle Ticket: Druckerpatrone im 2. OG leer\")",
      "mati.history": "Verlauf",
      "mati.input_placeholder": "Frag mich etwas über Tickets, Arbeitsbelastung oder erstelle ein Ticket...",
      "mati.new_chat": "Neuer Chat",
      "mati.online_intelligent": "Online & Intelligent",
      "mati.rename": "Umbenennen",
      "mati.restore_bead": "Schwebenden Helfer einblenden",
      "mati.restore_bead_tooltip": "Schwebenden Helfer (Bead) wieder am Bildschirmrand anzeigen",
      "mati.send_btn": "Senden",
      "mati.suggest.create_ticket.desc": "Drucker im 1. OG defekt",
      "mati.suggest.create_ticket.prompt": "Erstelle mir ein Ticket für einen defekten Drucker im 1. OG, Priorität mittel.",
      "mati.suggest.create_ticket.title": "Ticket erstellen",
      "mati.suggest.search_tickets.desc": "Suchanfrage \"Datenbank\"",
      "mati.suggest.search_tickets.prompt": "Finde Tickets, die das Wort \"Datenbank\" enthalten.",
      "mati.suggest.search_tickets.title": "Tickets suchen",
      "mati.suggest.support_help.desc": "Hilfe bei FAQ-Entwürfen",
      "mati.suggest.support_help.prompt": "Wie formuliere ich eine freundliche Absage auf eine Rückerstattungsanfrage?",
      "mati.suggest.support_help.title": "Support-Hilfe",
      "mati.suggest.system_status.desc": "Aktuelle Auslastung zeigen",
      "mati.suggest.system_status.prompt": "Zeige mir den aktuellen Systemstatus und eine Übersicht der Agentenauslastung.",
      "mati.suggest.system_status.title": "Systemstatus",
      "mati.typing_text": "{{name}} schreibt...",
      "mati.welcome_subtitle": "Ich bin dein intelligenter KI-Copilot. Ich kann dir helfen, Tickets zu verwalten, im System zu suchen, oder Systemstatistiken einzusehen.",
      "mati.welcome_title": "Hallo! Ich bin {{name}}",
      "mati_gdpr_warning": "DSGVO-Filter aktiv: Persönliche Daten werden vor der Übertragung automatisch anonymisiert.",
      "mati_placeholder": "Frag mich etwas über Tickets, Arbeitsbelastung oder erstelle ein Ticket...",
      "mati_welcome": "Hallo! Ich bin {{name}}",
      "meeting_error_title": "Teams-Meeting konnte nicht erstellt werden.",
      "meeting_success": "Teams-Meeting erstellt.",
      "meeting_success_copy": "Teams-Meeting erstellt, Link in die Zwischenablage kopiert.",
      "megamenu.active_label": "Arbeiten",
      "megamenu.calendar_desc": "Termine und Kalenderintegration.",
      "megamenu.licenses_desc": "Lizenz-Compliance, Suites & True-up-Planung.",
      "megamenu.modules": "Module",
      "megamenu.open_calendar": "Kalender öffnen",
      "megamenu.open_licenses": "Lizenzen öffnen",
      "megamenu.open_problems": "Probleme öffnen",
      "megamenu.problems_desc": "Problem-Management & RCA (Root Cause Analysis).",
      "megamenu.quick_search_commands": "Schnellsuche & Befehle",
      "merge": "Zusammenführen",
      "merge_tickets": "Die beiden markierten Tickets zusammenführen",
      "mfa_settings": "MFA-Einstellungen",
      "minutes_ago": "Vor {{count}} Min.",
      "mloffice.abgleich_fehler": "Abgleich konnte nicht gestartet werden.",
      "mloffice.abgleich_fehlgeschlagen": "Letzter Abgleich fehlgeschlagen: {{fehler}}",
      "mloffice.abgleich_gestartet": "Voll-Abgleich gestartet.",
      "mloffice.abgleich_laeuft": "Abgleich läuft",
      "mloffice.adresse": "MLOffice-Adresse",
      "mloffice.adresse_hinweis": "Basisadresse der MLOffice-Installation — ohne /api/v1.",
      "mloffice.agenten_titel": "Agenten ↔ MLOffice-Benutzer",
      "mloffice.aktion_anlegen": "Neu anlegen",
      "mloffice.aktion_entkoppeln": "Entkoppeln",
      "mloffice.aktion_entkoppeln_hinweis": "Aus dem Abgleich nehmen — der Kunde bleibt bestehen und wird wieder editierbar.",
      "mloffice.aktion_verknuepfen": "Verknüpfen",
      "mloffice.aktiv": "Aktiv",
      "mloffice.aktivieren": "Anbindung aktiv",
      "mloffice.auswahl_fehler": "Auswahl konnte nicht gespeichert werden.",
      "mloffice.bereits_uebertragen": "{{n}} Einträge im Zeitraum sind bereits übertragen und werden übersprungen.",
      "mloffice.email_eingeben": "Der Partner hat in MLOffice keine E-Mail-Adresse. E-Mail für den neuen Kunden:",
      "mloffice.entwurf_anlegen": "Entwurf anlegen",
      "mloffice.entwurf_fehler": "Entwurf konnte nicht angelegt werden.",
      "mloffice.entwurf_hinweis": "Erzeugt aus den bereits übertragenen Zeiten des Zeitraums einen ENTWURF in MLOffice. Belegnummer, Festschreibung und Versand bleiben MLOffice vorbehalten.",
      "mloffice.entwurf_ok": "Entwurf über {{h}} h in MLOffice angelegt — Festschreiben und Versand dort.",
      "mloffice.entwurf_titel": "Rechnungsentwurf in MLOffice",
      "mloffice.ereignis_closed": "Ticket geschlossen",
      "mloffice.ereignis_created": "Ticket eröffnet",
      "mloffice.ereignis_escalated": "Ticket eskaliert",
      "mloffice.ereignisse_titel": "Ticket-Ereignisse in die MLOffice-Kontakthistorie melden (nur Referenz, nie Inhalt):",
      "mloffice.erst_aktivieren": "Bitte zuerst die Anbindung aktivieren und die Verbindung testen — dann erscheint hier der MLOffice-Kundenbestand.",
      "mloffice.erst_aktivieren_abrechnung": "Bitte zuerst die Anbindung aktivieren — dann erscheinen hier offene Posten und der Kontingent-Abgleich.",
      "mloffice.erst_aktivieren_zeiten": "Bitte zuerst die Anbindung aktivieren — dann lassen sich Zeiten per Übertragungslauf nach MLOffice geben.",
      "mloffice.fallback_hinweis": "{{n}} Einträge ohne Agenten-Zuordnung werden über den technischen Benutzer gebucht (Agentenname in der Beschreibung).",
      "mloffice.feld_bis": "Bis",
      "mloffice.feld_kunde": "Kunde",
      "mloffice.feld_projekt": "MLOffice-Projekt",
      "mloffice.feld_satz": "Stundensatz (netto)",
      "mloffice.feld_von": "Von",
      "mloffice.gespeichert": "MLOffice-Einstellungen gespeichert.",
      "mloffice.gueltig_180": "180 Tage",
      "mloffice.gueltig_365": "365 Tage",
      "mloffice.gueltig_90": "90 Tage",
      "mloffice.gueltig_unbegrenzt": "Unbegrenzt",
      "mloffice.hoheit_frage": "MLOffice übernimmt die Hoheit über: {{felder}}.\\n\\nDiese Felder sind in AISupportDesk dann gesperrt und werden fortlaufend aus MLOffice übernommen. Fortfahren?",
      "mloffice.inaktiv": "Inaktiv",
      "mloffice.keine_partner": "Noch keine MLOffice-Kunden geladen. „Liste aus MLOffice laden“ holt den Bestand.",
      "mloffice.keine_zuordnung": "— keine Zuordnung —",
      "mloffice.konflikt_fehler": "Konnte nicht übernommen werden.",
      "mloffice.konflikt_geloest": "Übernommen.",
      "mloffice.konflikt_hinweis": "Übernahme braucht eine Entscheidung — siehe Konfliktzeile.",
      "mloffice.kopieren": "Kopieren",
      "mloffice.kunde_waehlen": "— Kunde wählen —",
      "mloffice.kunden_erklaerung": "Wähle aus, welche MLOffice-Kunden hier geführt werden. Ausgewählte Kunden werden fortlaufend abgeglichen; ihre Stammdaten sind hier gesperrt. Abwählen entkoppelt nur — der Kunde bleibt bestehen.",
      "mloffice.laden_fehler": "MLOffice-Einstellungen konnten nicht geladen werden.",
      "mloffice.laeufe_titel": "Bisherige Übertragungsläufe",
      "mloffice.lauf_detail": "Lauf #{{id}} — Einzelposten",
      "mloffice.lauf_fehler": "Lauf konnte nicht gestartet werden.",
      "mloffice.lauf_fertig": "Fertig",
      "mloffice.lauf_gestartet": "Übertragungslauf gestartet.",
      "mloffice.lauf_laeuft": "Läuft",
      "mloffice.lauf_starten": "Übertragung starten",
      "mloffice.lauf_teilfehler": "Mit Fehlern",
      "mloffice.linktoken_abgelaufen": "Das Verbindungstoken ist abgelaufen — MLOffice kann sich nicht mehr ausweisen. Neues Token erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_ablauf_teil": ", gültig bis {{datum}}",
      "mloffice.linktoken_einmal": "Jetzt kopieren — dieses Token wird nur EINMAL angezeigt:",
      "mloffice.linktoken_eintragen": "In MLOffice unter Einstellungen → AISupportDesk-Anbindung eintragen.",
      "mloffice.linktoken_erklaerung": "Dieses Token wird HIER erzeugt und in MLOffice unter „AISupportDesk-Anbindung“ eingetragen. MLOffice weist sich damit aus (Verbindungsstatus, Webhooks). Wird die Anbindung hier gelöst oder das Token widerrufen, zeigt MLOffice die Verbindung als gelöst.",
      "mloffice.linktoken_erzeugen": "Token erzeugen",
      "mloffice.linktoken_fehler": "Verbindungstoken konnte nicht erzeugt werden.",
      "mloffice.linktoken_gueltigkeit": "Gültigkeit",
      "mloffice.linktoken_kopiert": "Token kopiert.",
      "mloffice.linktoken_laeuft_ab": "Das Verbindungstoken läuft in {{tage}} Tagen ab. Rechtzeitig neu erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_neu": "Neues Token erzeugen",
      "mloffice.linktoken_rotieren_frage": "Es existiert bereits ein Verbindungstoken. Ein neues macht das alte sofort ungültig — MLOffice muss dann das neue Token eintragen. Fortfahren?",
      "mloffice.linktoken_status": "Hinterlegt ({{hint}}), erzeugt {{erzeugt}}{{ablauf}}.",
      "mloffice.linktoken_titel": "Verbindungstoken für MLOffice",
      "mloffice.linktoken_unbegrenzt_teil": ", unbegrenzt gültig",
      "mloffice.linktoken_widerruf_fehler": "Widerruf fehlgeschlagen.",
      "mloffice.linktoken_widerruf_frage": "Verbindungstoken widerrufen? MLOffice zeigt die Verbindung danach als gelöst; Webhooks und Statusabfragen von MLOffice werden abgewiesen.",
      "mloffice.linktoken_widerrufen": "Verbindungstoken widerrufen.",
      "mloffice.linktoken_widerrufen_btn": "Widerrufen",
      "mloffice.liste_aktualisieren": "Liste aus MLOffice laden",
      "mloffice.loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "mloffice.nur_verknuepfte": "Nur mit MLOffice verknüpfte Kunden.",
      "mloffice.ohne_email": "ohne E-Mail",
      "mloffice.op_aktualisiert": "Offene Posten aktualisiert.",
      "mloffice.op_belege": "Belege",
      "mloffice.op_fehler": "Offene Posten konnten nicht geladen werden.",
      "mloffice.op_laden": "Offene Posten aus MLOffice laden",
      "mloffice.op_stand": "Stand: {{zeit}}",
      "mloffice.op_titel": "Offene Posten (MLOffice)",
      "mloffice.partner_laden_fehler": "MLOffice-Kundenliste konnte nicht geladen werden.",
      "mloffice.posten_ok": "übertragen",
      "mloffice.posten_retry": "Erneut",
      "mloffice.posten_skip": "Überspringen",
      "mloffice.projekt_pflicht": "Bitte oben ein MLOffice-Projekt wählen.",
      "mloffice.projekt_waehlen": "— Projekt wählen —",
      "mloffice.rechte_fehlen": "Dem Token fehlen Rechte:",
      "mloffice.recon_asd": "Support-Sicht (NALVRA SERVICE)",
      "mloffice.recon_diff": "Abweichung Support- zu Abrechnungs-Sicht: {{min}} Min.",
      "mloffice.recon_gebucht": "{{min}} Min. im Projekt „{{projekt}}“ gebucht",
      "mloffice.recon_gesperrt_bis": "Erfassung gesperrt bis: {{d}}",
      "mloffice.recon_kein_projekt": "Kein MLOffice-Projekt zugeordnet (Tab „Zuordnung“).",
      "mloffice.recon_kein_vertrag": "Kein aktiver Vertrag mit Kontingent für diesen Kunden.",
      "mloffice.recon_mlo": "Abrechnungs-Sicht (MLOffice)",
      "mloffice.recon_offen": "{{min}} Min. der laufenden Periode sind noch nicht an MLOffice übertragen — Übertragungslauf im Tab „Zeiten-Übertragung“ starten.",
      "mloffice.recon_titel": "Kontingent-Abgleich",
      "mloffice.recon_verbrauch": "{{used}} von {{incl}} Min. verbraucht — {{rest}} Min. übrig",
      "mloffice.schon_drueben": "übertragen",
      "mloffice.sp_agent": "Agent",
      "mloffice.sp_beschreibung": "Beschreibung",
      "mloffice.sp_datum": "Datum",
      "mloffice.sp_fortschritt": "Gesendet / Fehler / Gesamt",
      "mloffice.sp_kunde": "Kunde",
      "mloffice.sp_minuten": "Min.",
      "mloffice.sp_status": "Status",
      "mloffice.sp_ticket": "Ticket",
      "mloffice.sp_zeitraum": "Zeitraum",
      "mloffice.spalte_kunde": "MLOffice-Kunde",
      "mloffice.spalte_status": "Status",
      "mloffice.spalte_sync": "Sync",
      "mloffice.spalte_zuordnung": "Zuordnung in NALVRA SERVICE",
      "mloffice.speichern": "Speichern",
      "mloffice.speichern_fehler": "Speichern fehlgeschlagen.",
      "mloffice.status_archiviert": "In MLOffice archiviert",
      "mloffice.status_delta": "Letzter Kundenabgleich: {{zeit}}",
      "mloffice.status_entkoppelt": "Entkoppelt",
      "mloffice.status_failed": "{{n}} Übertragungen fehlgeschlagen",
      "mloffice.status_kein_linktoken": "Kein Verbindungstoken für MLOffice erzeugt",
      "mloffice.status_konflikt": "Entscheidung nötig",
      "mloffice.status_linktoken_abgelaufen": "Verbindungstoken abgelaufen — neu erzeugen und in MLOffice eintragen",
      "mloffice.status_neu": "Neu",
      "mloffice.status_op": "Offene Posten: {{zeit}}",
      "mloffice.status_pending": "{{n}} Übertragungen offen",
      "mloffice.status_ratelimit": "MLOffice-Ratenbegrenzung — kurze Pause",
      "mloffice.status_sync_fehler": "Letzter Abgleich mit Fehler",
      "mloffice.status_uebernommen": "Übernommen",
      "mloffice.tab_abrechnung": "Abrechnung",
      "mloffice.tab_kunden": "Kundenabgleich",
      "mloffice.tab_verbindung": "Verbindung",
      "mloffice.tab_zeiten": "Zeiten-Übertragung",
      "mloffice.tab_zuordnung": "Zuordnung",
      "mloffice.techuser_hinweis": "Wird für Zeitbuchungen ohne Agenten-Zuordnung verwendet; der Agentenname wandert dann in die Buchungsbeschreibung.",
      "mloffice.techuser_titel": "Technischer Benutzer (Fallback)",
      "mloffice.test_fehler": "Verbindungstest fehlgeschlagen.",
      "mloffice.test_nicht_verbunden": "Keine Verbindung",
      "mloffice.test_ok": "Verbindung zu MLOffice steht.",
      "mloffice.test_verbunden": "Verbunden mit Mandant „{{tenant}}“",
      "mloffice.testen": "Verbindung testen",
      "mloffice.titel": "MLOffice-Anbindung",
      "mloffice.token": "API-Token",
      "mloffice.token_gesetzt": "hinterlegt ({{hint}})",
      "mloffice.token_hinweis": "In MLOffice unter Einstellungen → API-Tokens anlegen. Benötigte Rechte prüft der Verbindungstest.",
      "mloffice.token_name": "Token: {{name}}",
      "mloffice.token_unveraendert": "Leer lassen = unverändert",
      "mloffice.untertitel": "Kundenstammdaten, Abrechnung, Zeiterfassung und CRM mit MLOffice koppeln. MLOffice ist das führende System für Stammdaten und Rechnungen.",
      "mloffice.users_dropdown": "Zeitbuchungen werden in MLOffice unter dem zugeordneten Benutzer geführt. Ohne Zuordnung greift der technische Benutzer.",
      "mloffice.users_manuell": "MLOffice stellt (noch) keine Benutzerliste bereit — MLOffice-User-UUID bitte manuell eintragen (in MLOffice unter Benutzerverwaltung kopieren).",
      "mloffice.uuid_platzhalter": "MLOffice-User-UUID",
      "mloffice.verbindung": "Verbindung",
      "mloffice.vollabgleich": "Voll-Abgleich starten",
      "mloffice.vorschau": "Vorschau",
      "mloffice.vorschau_anlegen": "Wird neu angelegt",
      "mloffice.vorschau_email_fehlt": "E-Mail fehlt — wird bei Übernahme abgefragt",
      "mloffice.vorschau_fehler": "Vorschau fehlgeschlagen.",
      "mloffice.vorschau_titel": "Vorschau: {{n}} Einträge, {{h}} h werden übertragen",
      "mloffice.vorschau_verknuepfung": "Vorschlag: mit „{{name}}“ verknüpfen ({{grund}})",
      "mloffice.zeiten_erklaerung": "Zeiten werden NICHT automatisch übertragen. Du wählst Kunde und Zeitraum, prüfst die Vorschau und bestätigst — erst dann gehen die Buchungen nach MLOffice. Übertragene Buchungen sind dort unumkehrbar und hier gesperrt.",
      "mloffice.zeitraum_bis_heute": "Bis heute",
      "mloffice.zeitraum_dieser_monat": "Dieser Monat",
      "mloffice.zeitraum_letzter_monat": "Letzter Monat",
      "mloffice.zuordnung_fehler": "Zuordnung konnte nicht gespeichert werden.",
      "mloffice.zuordnung_fehlt": "{{n}} Einträge ohne Agenten-Zuordnung — bitte unter „Zuordnung“ pflegen oder einen technischen Benutzer hinterlegen.",
      "mloffice.zuordnung_gespeichert": "Zuordnung gespeichert.",
      "mobile": "Mobil",
      "move_ticket": "Verschieben",
      "my_tickets": "Meine Tickets",
      "navbar_search_placeholder": "Tickets, Kunden oder KB durchsuchen...",
      "new": "Neu",
      "new_activity_aria": "Neue Aktivität",
      "new_activity_title": "Neue Aktivität seit letztem Aufruf",
      "new_company": "Neue Firma",
      "new_label": "Neu",
      "new_ticket": "Neues Ticket",
      "next": "Weiter",
      "no_activities_recorded": "Noch keine Aktivität erfasst.",
      "no_canned_responses": "Keine Textbausteine",
      "no_canned_responses_hint": "In der Administration verwaltbar.",
      "no_critical_tickets": "Keine kritischen Tickets",
      "no_customer_assigned": "Kein Kunde zugeordnet",
      "no_customer_data": "Keine Kundendaten geladen.",
      "no_customers_found": "Keine Kunden gefunden",
      "no_customers_matching": "Es konnten keine Kunden für Ihre Filterauswahl oder Suchanfrage gefunden werden.",
      "no_data_available": "Keine Daten verfügbar",
      "no_employees_found": "Keine Mitarbeiter hinterlegt",
      "no_notes_placeholder": "Keine Notizen vorhanden. Klicken Sie auf \"Bearbeiten\" um Notizen hinzuzufügen.",
      "no_notifications": "Keine Benachrichtigungen",
      "no_other_agents_online": "Aktuell keine anderen Teammitglieder online.",
      "no_results": "Keine Treffer",
      "no_tickets_found": "Keine Tickets gefunden",
      "no_tickets_found_desc": "In dieser Filter-Queue befinden sich momentan keine Einträge.",
      "no_tickets_risk": "Aktuell keine Tickets im kritischen SLA-Warnfenster.",
      "not_spam": "Kein Spam",
      "notification_settings": "Benachrichtigungseinstellungen",
      "notification_settings_desc": "Wählen Sie, welche Benachrichtigungen Sie erhalten möchten.",
      "notification_settings_saved": "Benachrichtigungseinstellungen gespeichert.",
      "notifications": "Benachrichtigungen",
      "notify_license_change": "Lizenzänderungen",
      "notify_new_reply": "Neue Antworten",
      "notify_new_ticket": "Neue Tickets",
      "notify_status_changed": "Statusänderungen",
      "observers_title": "Beobachter",
      "only_visible_for": "Nur {{name}}",
      "only_visible_to_agents": "Nur für Mitarbeiter sichtbar",
      "open_administration": "Administration öffnen",
      "open_btn": "Öffnen",
      "open_password_vault": "Passwort-Tresor im Browser öffnen",
      "open_quick_search": "Schnellsuche öffnen",
      "open_tickets": "Offene Tickets",
      "other_tickets_count": "Weitere Tickets ({{count}})",
      "other_tickets_requester_count": "Weitere Tickets des Anfragenden ({{count}})",
      "overdue": "Überfällig",
      "overview_option_1": "1. Standard KPI-Dashboard",
      "overview_option_10": "10. SLA-Verletzungsquote nach Prioritäten",
      "overview_option_2": "2. Erstlösungsquote (FCR) & Reaktionszeit",
      "overview_option_3": "3. Ticket-Volumenentwicklung & Peak-Hours",
      "overview_option_4": "4. Lösungsraten-Trends (Erstellt vs. Gelöst)",
      "overview_option_5": "5. CSAT vs. Lösungszeit-Matrix",
      "overview_option_6": "6. Ticket-Kanäle & Source Breakdown",
      "overview_option_7": "7. Eskalationsraten & Eskalationspfad-Analyse",
      "overview_option_8": "8. Durchschnittliche Ticket-Lebenszeit (Aging)",
      "overview_option_9": "9. Backlog-Status & Alterung",
      "performance_queues": "Performance & Queues",
      "phone": "Telefon",
      "plan_teams_meeting": "Teams-Meeting planen",
      "planning": "Planung",
      "please_enter_text": "Bitte Text eingeben",
      "policy": "Policy",
      "portal_company.load_failed": "Dokumente konnten nicht geladen werden.",
      "portal_company.primary_contact": "Hauptansprechpartner",
      "portal_session.continue": "Weiterarbeiten",
      "portal_session.login": "Erneut anmelden",
      "portal_session.warning": "Ihre Sitzung endet in {{seconds}} Sekunden. Gespeicherte Entwürfe bleiben erhalten.",
      "portal_speech.denied": "Mikrofonzugriff oder Spracherkennung wurde nicht erlaubt. Bitte die Browserberechtigung prüfen.",
      "portal_speech.failed": "Spracheingabe nicht verfügbar. Bitte Mikrofon und Verbindung prüfen oder weitertippen.",
      "portal_speech.listening": "Mikrofon aktiv – bitte sprechen …",
      "portal_speech.notice": "Diktierter Text wird unten an die Beschreibung angefügt. Der Browser kann Audio zur Erkennung an seinen Sprachdienst senden.",
      "portal_speech.silence": "Keine Sprache erkannt. Bitte erneut starten.",
      "portal_speech.start": "Diktat starten",
      "portal_speech.stop": "Stoppen",
      "portal_speech.title": "Spracheingabe",
      "portal_speech.unsupported": "Dieser Browser unterstützt hier keine Spracheingabe. Sie können die Diktierfunktion Ihrer Tastatur verwenden.",
      "preview": "Vorschau",
      "previous": "Zurück",
      "primary": "Primär",
      "priority": "Priorität",
      "priority_": "",
      "priority_critical": "Kritisch",
      "priority_high": "Hoch",
      "priority_low": "Niedrig",
      "priority_medium": "Mittel",
      "priority_urgent": "Dringend",
      "problem_cascade_close_checkbox": "Ja, alle verknüpften Vorfälle mitlöschen (empfohlen)",
      "problem_cascade_close_desc": "Es gibt verknüpfte, offene Vorfälle. Sollen diese automatisch gelöst und mit der Fehlerursache & Lösung kommentiert werden?",
      "problem_cascade_close_title": "Kaskadierendes Schließen",
      "problem_confirm_resolve": "Bestätigen & Lösen",
      "problem_create_btn": "Problem erstellen",
      "problem_create_error": "Fehler beim Erstellen des Problems",
      "problem_create_success": "Problem-Ticket erstellt.",
      "problem_create_title": "Neues Problem-Ticket anlegen",
      "problem_created_by_on": "Erstellt von {{creator}} am {{date}}",
      "problem_description_label": "Problembeschreibung",
      "problem_detail_load_error": "Fehler beim Laden des Problem-Details",
      "problem_incidents_linked": "Incidents verknüpft",
      "problem_kedb_empty": "Keine bekannten Fehler",
      "problem_kedb_empty_desc": "Als Known Error klassifizierte Probleme erscheinen hier mit Ursache und Workaround.",
      "problem_kedb_load_error": "Fehler beim Laden der bekannten Fehler",
      "problem_kedb_search_placeholder": "Bekannte Fehler durchsuchen...",
      "problem_kedb_title": "Bekannte Fehler (Known Errors)",
      "problem_known_error_badge": "Bekannter Fehler",
      "problem_known_error_checkbox": "Als Known Error (Bekannten Fehler) klassifizieren",
      "problem_known_error_only": "Nur bekannte Fehler",
      "problem_link_btn": "Verknüpfen",
      "problem_link_error": "Fehler beim Verknüpfen der Vorfälle",
      "problem_link_incident_btn": "Incident verknüpfen",
      "problem_link_incidents_title": "Vorfälle verknüpfen",
      "problem_link_success": "Vorfälle verknüpft.",
      "problem_linked_incidents": "Verknüpfte Vorfälle (Incidents)",
      "problem_load_error": "Fehler beim Laden der Probleme",
      "problem_loading": "Lade ITIL Problem Management...",
      "problem_mark_known_error": "Als Known Error markieren",
      "problem_no_incidents_found": "Keine verknüpften Vorfälle gefunden.",
      "problem_no_tickets": "Keine Problem-Tickets",
      "problem_no_tickets_desc": "Es sind derzeit keine ITIL Problem-Tickets erfasst.",
      "problem_no_unlinked_found": "Keine offenen, unverknüpften Vorfälle gefunden.",
      "problem_none": "—",
      "problem_none_selected": "Kein Problem ausgewählt",
      "problem_none_selected_desc": "Wählen Sie links ein ITIL Problem-Ticket aus oder erstellen Sie ein neues, um RCA-Daten zu verwalten.",
      "problem_open_change_confirm": "Neues Change-Ticket {{num}} jetzt öffnen?",
      "problem_raise_change_btn": "Change ableiten",
      "problem_raise_change_error": "Fehler beim Ableiten des Changes",
      "problem_raise_change_success": "Change-Ticket erstellt: {{num}}",
      "problem_raise_change_title": "Change aus diesem Problem ableiten",
      "problem_rca_title": "ITIL Problems (RCA)",
      "problem_resolution_note": "Lösungsnotiz",
      "problem_resolution_note_placeholder": "Geben Sie Details zur finalen Behebung ein...",
      "problem_resolve_btn": "Problem lösen",
      "problem_resolve_error": "Fehler beim Lösen des Problems",
      "problem_resolve_success": "Problem gelöst.",
      "problem_root_cause_label": "Vermutete Fehlerursache (Root Cause)",
      "problem_root_cause_short": "Root Cause",
      "problem_search_placeholder": "Probleme durchsuchen...",
      "problem_stage_closed": "Geschlossen",
      "problem_stage_known_error": "Bekannter Fehler",
      "problem_stage_label": "Lifecycle-Status (Problem-Stage)",
      "problem_stage_open": "Offen",
      "problem_stage_resolved": "Gelöst",
      "problem_stage_under_investigation": "In Untersuchung",
      "problem_stage_updated": "Lifecycle-Status aktualisiert.",
      "problem_stage_workaround_found": "Workaround gefunden",
      "problem_tab_kedb": "Known-Error-DB (KEDB)",
      "problem_tab_problems": "Probleme (RCA)",
      "problem_title": "ITIL Problem: Wiederkehrende Störung",
      "problem_title_label": "Problem Titel",
      "problem_unlink_btn": "Verknüpfung aufheben",
      "problem_unlink_error": "Fehler beim Aufheben der Verknüpfung",
      "problem_unlink_success": "Verknüpfung aufgehoben.",
      "problem_update_error": "Fehler beim Aktualisieren des Problems",
      "problem_update_success": "Problem erfolgreich aktualisiert.",
      "problem_workaround_label": "Bekannter Workaround",
      "problem_workaround_short": "Workaround",
      "problems": "Probleme",
      "queue.": "queue.",
      "queue_external_processing": "Externe Bearbeitung",
      "queues": "Warteschlangen",
      "quick_access_views": "Schnellzugriffe & Schnellansichten",
      "quick_search": "Schnellsuche",
      "read_ticket_also": "liest dieses Ticket ebenfalls",
      "reading_ticket": "Liest Ticket #{{id}}",
      "reassign_to": "Neu zuweisen ({{name}})...",
      "recent_activities_description": "Letzte Ticket- und Antwort-Aktivitäten für diesen Kunden.",
      "recent_tickets": "Letzte Tickets",
      "refresh": "Aktualisieren",
      "remove_assignment": "Zuweisung entfernen",
      "remove_attachment_aria": "Anhang {{filename}} entfernen",
      "remove_filter": "Filter entfernen",
      "reopen": "Erneut öffnen",
      "reply": "Antwort",
      "reply_keyboard_shortcut_hint": "Tastenkürzel: Strg oder Cmd und Enter zum Senden, wenn der Cursor im Text steht.",
      "report_active_breaches": "Aktive Breaches",
      "report_ai_analysis": "KI-Analyse",
      "report_ai_analyzing": "KI analysiert Report-Daten...",
      "report_ai_highlights": "Auffälligkeiten",
      "report_ai_recommendations": "Empfehlungen",
      "report_billable": "Abrechenbar",
      "report_compliance": "Compliance",
      "report_export": "Exportieren",
      "report_exporting": "Exportiere...",
      "report_no_data": "Keine Daten verfügbar",
      "report_no_data_desc": "Es konnten keine Berichtsdaten für diesen Zeitraum geladen werden.",
      "report_range": "Berichts-Ansicht:",
      "report_total_time": "Zeit gesamt",
      "reports": "Berichte",
      "reports_desc": "Service Management Reports & Analyse",
      "request.additional_info": "Zusätzliche Angaben",
      "request.back_to_dashboard": "Zurück zum Dashboard",
      "request.back_to_dashboard_link": "← Dashboard",
      "request.back_to_list": "Zur Übersicht",
      "request.back_to_requests": "← Alle Anfragen",
      "request.catalog_subtitle": "Wählen Sie eine Anfrageart — Sie erhalten ein passendes Formular.",
      "request.choose_files": "Dateien wählen",
      "request.description_placeholder": "Beschreiben Sie Ihr Anliegen…",
      "request.description_required": "Bitte eine Beschreibung eingeben.",
      "request.failed_load_catalog": "Katalog konnte nicht geladen werden",
      "request.file_too_large": "Datei zu groß (max. {{max}} MB): {{name}}",
      "request.file_type_not_allowed": "Dateityp nicht erlaubt: {{name}}",
      "request.no_requests": "Es sind keine Service-Anfragen im Portal freigeschaltet.",
      "request.not_available": "Diese Anfrage ist nicht verfügbar oder nicht veröffentlicht.",
      "request.optional_select": "— Optional —",
      "request.please_select": "— Bitte wählen —",
      "request.remove_file": "Entfernen",
      "request.required_field": "Pflichtfeld: {{label}}",
      "request.standard_fields_info": "Standardfelder: Priorität, Kategorie, Beschreibung und Anhänge sind bei jeder Service-Anfrage enthalten. Darunter folgen ggf. zusätzliche Felder für diese Anfrageart.",
      "request.submit_btn": "Anfrage absenden",
      "request.submit_failed": "Senden fehlgeschlagen",
      "request.submitting_btn": "Wird gesendet…",
      "request_type": "Anfragetyp",
      "requester_title": "Ersteller",
      "reset": "Zurücksetzen",
      "reset_all_filters": "Alle Filter zurücksetzen",
      "reset_filter": "Filter zurücksetzen",
      "reset_kpi_filter": "Kachel-Filter zurücksetzen",
      "reset_to_default": "Standard zurücksetzen",
      "resolution": "Lösung",
      "resolve": "Lösen",
      "resolved_label": "Gelöst",
      "retry": "Erneut versuchen",
      "risk": "Risiko",
      "risk_minutes": "{{count}} Min",
      "save": "Speichern",
      "save_changes": "Änderungen speichern",
      "save_note": "Notiz speichern",
      "saving": "Speichern...",
      "scroll_to_reply": "Zur Antwort scrollen",
      "search": "Suche...",
      "search_canned_responses": "Textbausteine durchsuchen…",
      "search_customers": "Kunden suchen...",
      "select_company": "Firma auswählen…",
      "select_customer_placeholder": "Wählen Sie einen Kunden aus der Liste",
      "self_healing": "Self-Healing",
      "send": "Senden",
      "sending_ellipsis": "Senden…",
      "settings": "Einstellungen",
      "seven_days": "7 Tage",
      "shortcut_back_close": "Zurück / Schließen",
      "shortcut_escalate": "Eskalieren",
      "shortcut_focus_mode": "Focus Mode",
      "shortcut_help": "Diese Hilfe",
      "shortcut_internal_note": "Interne Notiz",
      "shortcut_next_prev": "Nächstes / Vorheriges Ticket",
      "shortcut_quick_search": "Schnellsuche",
      "shortcut_write_reply": "Antwort schreiben",
      "show_all": "Alle anzeigen",
      "show_full_ticket_backlog": "Gesamtes Ticket-Backlog anzeigen",
      "show_older_replies": "{{count}} ältere Antworten anzeigen...",
      "sla_and_contract_title": "SLA & Vertrag",
      "sla_breached_both": "Antwort & Lösung überschritten",
      "sla_breached_exclamation": "SLA verletzt!",
      "sla_breached_resolution": "Lösung überschritten",
      "sla_breached_response": "Antwort überschritten",
      "sla_breaches": "SLA-Verletzungen:",
      "sla_compliance": "SLA-Einhaltung",
      "sla_level": "SLA-Stufe:",
      "sla_option_1": "1. SLA Compliance & Trends (Übersicht)",
      "sla_option_10": "10. SLA-Wochenend- & Feiertags-Statistik",
      "sla_option_2": "2. SLA Verletzungen & gefährdete Tickets",
      "sla_option_3": "3. SLA nach Priorität",
      "sla_option_4": "4. SLA nach Kunde / Service-Plan",
      "sla_option_5": "5. Reaktionszeit-SLA Einhaltung",
      "sla_option_6": "6. Lösungszeit-SLA Einhaltung",
      "sla_option_7": "7. SLA Verletzungen nach Agent/Gruppe",
      "sla_option_8": "8. SLA Verletzungsursachen",
      "sla_option_9": "9. Pönalen & Gutschriften-Vorschau (Finanz-Risiko)",
      "sla_performance_breaches": "SLA-Performance & Verletzungen",
      "sla_risk": "SLA-Risiko",
      "sla_status_ok": "OK",
      "sort_by_label": "Sortieren nach {{label}}",
      "spam": "Spam",
      "starred": "Favoriten",
      "start": "Start",
      "status": "Status",
      "status_closed": "Geschlossen",
      "status_in_progress": "In Bearbeitung",
      "status_new": "Neu",
      "status_on_hold": "Angehalten",
      "status_open": "Offen",
      "status_resolved": "Gelöst",
      "status_waiting": "Wartend",
      "status_waiting_customer": "Warte auf Kunde",
      "street": "Straße",
      "subtasks": "Teilaufgaben",
      "supporting_agents": "Betreuende Agenten",
      "switch_language": "Sprache wechseln",
      "system_logs": "System-Logs",
      "tab_": "",
      "tab_activity": "Aktivität",
      "tab_agents": "Agenten",
      "tab_assets": "Assets",
      "tab_contracts": "Verträge",
      "tab_csat": "CSAT",
      "tab_custom": "Eigene Berichte",
      "tab_customers": "Kunden",
      "tab_documents": "Dokumente",
      "tab_employees": "Mitarbeiter",
      "tab_incidents": "Incidents",
      "tab_licenses": "Lizenzen",
      "tab_notes": "Notizen",
      "tab_overview": "Übersicht",
      "tab_sla": "SLA",
      "tab_tickets": "Tickets",
      "tab_time": "Zeiterfassung",
      "tab_trends": "Trends",
      "tag_add_placeholder": "Tag hinzufügen...",
      "tag_label": "Tag",
      "tax_number": "Steuernummer",
      "teams_call_start": "Teams Anruf starten",
      "teams_chat_open": "Teams Chat öffnen",
      "teams_meeting_subject": "Besprechung {{number}}",
      "teams_meeting_title": "Teams-Meeting",
      "thirty_days": "30 Tage",
      "ticket_assets.action_col": "Aktion",
      "ticket_assets.agent_offline": "Agent offline",
      "ticket_assets.agent_ready": "Bereit",
      "ticket_assets.assigned_assets": "Dem Mitarbeiter zugeordnete Assets",
      "ticket_assets.bios_label": "BIOS Version:",
      "ticket_assets.calculating_compliance": "Lizenzaudit wird berechnet...",
      "ticket_assets.clean_temp": "Temp löschen",
      "ticket_assets.cmd_status_completed": "Fertig",
      "ticket_assets.cmd_status_failed": "Fehler",
      "ticket_assets.cmd_status_pending": "Wartend",
      "ticket_assets.cmd_status_running": "Läuft...",
      "ticket_assets.cmdb_alert_desc": "Dieses Asset hängt ab von/ist verbunden mit:",
      "ticket_assets.cmdb_alert_title": "CMDB-Kaskadenwarnung: Abhängigkeits-Störung!",
      "ticket_assets.command_execution_failed": "Befehlsausführung fehlgeschlagen.",
      "ticket_assets.command_placeholder": "z.B. ipconfig /all, systeminfo, dir",
      "ticket_assets.command_running": "Befehl wird aktuell auf dem Client-Gerät ausgeführt...",
      "ticket_assets.command_success_solved": "Erfolgreich ausgeführt! Das Ticket wurde automatisch gelöst.",
      "ticket_assets.command_timeout": "Zeitüberschreitung bei der Befehlsausführung.",
      "ticket_assets.compliant": "Konform",
      "ticket_assets.confirm_kill_process": "Möchten Sie den Prozess mit der PID {{pid}} wirklich beenden?",
      "ticket_assets.cpu_cores_label": "Kerne:",
      "ticket_assets.cpu_label": "Prozessor (CPU)",
      "ticket_assets.cpu_sockets_label": "Sockel:",
      "ticket_assets.cpu_util_label": "CPU Util",
      "ticket_assets.created_label": "Erstellt:",
      "ticket_assets.device_scan_label": "Geräte-Scan",
      "ticket_assets.disk_free_label": "frei",
      "ticket_assets.disk_used_label": "Belegt",
      "ticket_assets.disks_label": "Festplatten / Laufwerke",
      "ticket_assets.domain_label": "Arbeitsgruppe/Domäne:",
      "ticket_assets.edition_id_label": "Edition ID:",
      "ticket_assets.employee_assets": "Mitarbeiter-Assets",
      "ticket_assets.error_kill_process": "Fehler beim Beenden des Prozesses: {{error}}",
      "ticket_assets.error_loading_monitoring": "Fehler beim Laden des Monitorings",
      "ticket_assets.error_sending_command": "Fehler beim Senden des Befehls.",
      "ticket_assets.error_submit_command": "Befehl konnte nicht übermittelt werden: {{error}}",
      "ticket_assets.executed_label": "Ausgeführt:",
      "ticket_assets.fetch_logs_btn": "Protokolle abrufen",
      "ticket_assets.filter_processes_placeholder": "Prozesse filtern (Name, PID)...",
      "ticket_assets.fix_dns": "DNS reparieren",
      "ticket_assets.fix_spooler": "Spooler reparieren",
      "ticket_assets.hostname_label": "Netzwerkname:",
      "ticket_assets.incomplete_summary": "Compliance-Zusammenfassung unvollständig.",
      "ticket_assets.invalid_json_response": "Ungültige Antwort vom Server",
      "ticket_assets.kill_btn": "Kill",
      "ticket_assets.killing_proc": "Beendet...",
      "ticket_assets.last_scan_label": "Letzter Scan:",
      "ticket_assets.license_compliance": "Lizenz-Compliance",
      "ticket_assets.link": "Verknüpfen",
      "ticket_assets.link_asset_title": "Asset verknüpfen",
      "ticket_assets.linked": "Verknüpft",
      "ticket_assets.linked_assets": "Mit Ticket verknüpfte Assets",
      "ticket_assets.loading": "Assets werden geladen...",
      "ticket_assets.loading_command_queue": "Lade Befehls-Warteschlange...",
      "ticket_assets.loading_logs": "Ereignisprotokolle werden geladen...",
      "ticket_assets.loading_monitoring": "Lade Live-Monitoring & CMDB-Check...",
      "ticket_assets.log_name_label": "Log-Name",
      "ticket_assets.memory_col": "Arbeitsspeicher",
      "ticket_assets.model_label": "Modell:",
      "ticket_assets.monitored_ok": "Monitored (OK)",
      "ticket_assets.more_params_title": "Weitere Parameter",
      "ticket_assets.motherboard_label": "Motherboard:",
      "ticket_assets.no_active_zabbix_alerts": "Keine aktiven Zabbix-Alarme.",
      "ticket_assets.no_assets_assigned": "Diesem Mitarbeiter sind keine IT-Assets zugeordnet.",
      "ticket_assets.no_assets_linked": "Keine Assets verknüpft.",
      "ticket_assets.no_commands_executed": "Noch keine Befehle ausgeführt. Geben Sie unten einen Befehl ein.",
      "ticket_assets.no_compliance_available": "Keine Lizenzen oder Compliance-Bericht verfügbar.",
      "ticket_assets.no_employee_assigned": "Kein Mitarbeiter für das Ticket zugeordnet.",
      "ticket_assets.no_hardware_details": "Keine Hardware-Details gescannt.",
      "ticket_assets.no_matching_software": "Keine übereinstimmenden Software-Einträge gefunden.",
      "ticket_assets.no_monitoring_data": "Keine Monitoring-Daten verfügbar",
      "ticket_assets.os_arch_label": "Architektur:",
      "ticket_assets.os_label": "Betriebssystem",
      "ticket_assets.os_ver_label": "Version:",
      "ticket_assets.overlicensed": "Überlizensiert",
      "ticket_assets.pagination_text": "Seite {{page}} von {{total}} ({{count}} Einträge)",
      "ticket_assets.process_name_col": "Prozessname",
      "ticket_assets.publisher_col": "Herausgeber",
      "ticket_assets.query_realtime_btn": "Echtzeit abfragen",
      "ticket_assets.ram_label": "Arbeitsspeicher (RAM)",
      "ticket_assets.ram_util_label": "RAM Util",
      "ticket_assets.scan_details_btn": "Scan-Details",
      "ticket_assets.scan_never": "nie",
      "ticket_assets.search_logs_placeholder": "Ergebnisse durchsuchen (Quelle, ID, Message)...",
      "ticket_assets.search_placeholder": "Name, IP oder S/N suchen...",
      "ticket_assets.search_software_placeholder": "Software durchsuchen...",
      "ticket_assets.self_healing_title": "Selbstheilung & Automatisierung",
      "ticket_assets.send_btn": "Senden",
      "ticket_assets.sending_command_failed": "Senden des Befehls fehlgeschlagen.",
      "ticket_assets.serial_number_label": "Seriennummer:",
      "ticket_assets.severity_all": "Alle",
      "ticket_assets.severity_error": "Fehler (Error)",
      "ticket_assets.severity_info": "Information",
      "ticket_assets.severity_label": "Schweregrad",
      "ticket_assets.severity_warning": "Warnung (Warning)",
      "ticket_assets.sn_label": "S/N:",
      "ticket_assets.software_name_col": "Softwarename",
      "ticket_assets.sql_instance_label": "Instanz:",
      "ticket_assets.sql_instances_title": "Erkannte SQL Server-Instanzen",
      "ticket_assets.sql_patchlevel_label": "Patchlevel:",
      "ticket_assets.success_kill_process": "Prozess erfolgreich beendet.",
      "ticket_assets.surplus_label": "Überschuss:",
      "ticket_assets.timeout_kill_process": "Zeitüberschreitung beim Beenden des Prozesses.",
      "ticket_assets.total_ram_desc": "Gesamt physischer Speicher",
      "ticket_assets.underlicensed": "Unterlizensiert",
      "ticket_assets.unlink_asset_title": "Verknüpfung aufheben",
      "ticket_assets.unreachable": "Nicht erreichbar",
      "ticket_assets.version_col": "Version",
      "ticket_assets.virtualization_label": "Virtualisierung:",
      "ticket_assets.waiting_agent_response": "Warte auf Antwort vom Agenten...",
      "ticket_assets.waiting_agent_timeout": "Zeitüberschreitung: Der Agent hat nicht rechtzeitig geantwortet.",
      "ticket_assets.zabbix_live_status": "Zabbix Live-Status",
      "ticket_created": "Ticket erstellt",
      "ticket_detail.achtung_ueberschneidungskollisionen_ci_abhae": "Achtung: Überschneidungskollisionen (CI-Abhängigkeiten) erkannt!",
      "ticket_detail.aktivitaeten": "Aktivitäten",
      "ticket_detail.aktivitaets_verlauf": "Aktivitäts-Verlauf",
      "ticket_detail.als_diesen_kunden_im_portal_anmelden": "Als diesen Kunden im Portal anmelden",
      "ticket_detail.anhaenge": "Anhänge",
      "ticket_detail.begruendung_kommentare": "Begründung / Kommentare",
      "ticket_detail.bekannter_fehler_workaround_verfuegbar": "Bekannter Fehler — Workaround verfügbar",
      "ticket_detail.cab_hat_die_aenderung_abgelehnt": "CAB hat die Änderung abgelehnt",
      "ticket_detail.change_advisory_board_cab_stimmen": "Change Advisory Board (CAB) Stimmen",
      "ticket_detail.das_ticket_existiert_nicht_oder_wurde_geloes": "Das Ticket existiert nicht oder wurde gelöscht.",
      "ticket_detail.der_status_kann_erst_auf_in_bearbeitung_oder": "Der Status kann erst auf „In Bearbeitung\" oder „Gelöst\" gesetzt werden, sobald die CAB-Mehrheit zugestimmt hat.",
      "ticket_detail.detaillierte_schritte_zur_durchfuehrung": "Detaillierte Schritte zur Durchführung...",
      "ticket_detail.es_wurde_noch_kein_change_plan_fuer_dieses_t": "Es wurde noch kein Change-Plan für dieses Ticket angelegt.",
      "ticket_detail.es_wurden_andere_aktive_tickets_auf_denselbe": "Es wurden andere aktive Tickets auf denselben oder abhängigen CMDB-Assets im gleichen Zeitraum geplant:",
      "ticket_detail.extrahierte_daten": "Extrahierte Daten",
      "ticket_detail.geplanter_start_wartungsfenster": "Geplanter Start (Wartungsfenster)",
      "ticket_detail.geplantes_ende": "Geplantes Ende",
      "ticket_detail.geplantes_wartungsfenster": "Geplantes Wartungsfenster:",
      "ticket_detail.hinzufuegen": "Hinzufügen",
      "ticket_detail.keine_aktivitaeten_vorhanden": "Keine Aktivitäten vorhanden",
      "ticket_detail.keine_anhaenge_vorhanden": "Keine Anhänge vorhanden",
      "ticket_detail.keine_kategorie": "Keine Kategorie",
      "ticket_detail.kommentar_zur_entscheidung_optional": "Kommentar zur Entscheidung (optional)...",
      "ticket_detail.loeschen": "Löschen",
      "ticket_detail.niemand_zugewiesen": "Niemand zugewiesen",
      "ticket_detail.noch_keine_stimmen_abgegeben": "Noch keine Stimmen abgegeben.",
      "ticket_detail.noch_keine_zeit_erfasst": "Noch keine Zeit erfasst",
      "ticket_detail.nur_fuer_mitarbeiter_sichtbar": "Nur für Mitarbeiter sichtbar",
      "ticket_detail.prioritaet": "Priorität",
      "ticket_detail.sprachnotizen_in_administration_ki_einstellu": "Sprachnotizen in Administration → KI-Einstellungen aktivieren.",
      "ticket_detail.sprachnotizen_nicht_aktiv": "Sprachnotizen nicht aktiv",
      "ticket_detail.stimme_uebermitteln": "Stimme übermitteln",
      "ticket_detail.tag_entfernen": "Tag entfernen",
      "ticket_detail.tag_hinzufuegen": "Tag hinzufügen…",
      "ticket_detail.tag_hinzufuegen_2": "Tag hinzufügen",
      "ticket_detail.ticket_nicht_gefunden": "Ticket nicht gefunden",
      "ticket_detail.ticket_wird_geladen": "Ticket wird geladen...",
      "ticket_detail.timer_laeuft_fuer_anderes_ticket": "Timer läuft für anderes Ticket",
      "ticket_detail.timer_starten": "Timer starten",
      "ticket_detail.timer_stoppen": "Timer stoppen",
      "ticket_detail.uebersicht": "Übersicht",
      "ticket_detail.veroeffentlicht": "Veröffentlicht",
      "ticket_detail.was_wurde_erledigt": "Was wurde erledigt?",
      "ticket_detail.welches_risiko_besteht_fuer_den_betrieb": "Welches Risiko besteht für den Betrieb?",
      "ticket_detail.wie_machen_wir_aenderungen_rueckgaengig": "Wie machen wir Änderungen rückgängig?",
      "ticket_detail.wie_wird_die_funktion_verifiziert": "Wie wird die Funktion verifiziert?",
      "ticket_detail.zeiteintraege": "Zeiteinträge",
      "ticket_detail.zugewiesen_an": "Zugewiesen an",
      "ticket_detail.zugewiesen_an_2": "Zugewiesen an",
      "ticket_detail.zurueck_zur_uebersicht": "Zurück zur Übersicht",
      "ticket_detail.zustimmung_des_change_advisory_boards_cab_zw": "Zustimmung des Change Advisory Boards (CAB) zwingend erforderlich",
      "ticket_filter_active_label": "Filter aktiv",
      "ticket_inventory_kpis": "Kennzahlen & Arbeitslast",
      "ticket_properties_title": "Ticket",
      "ticket_relations": "Verknüpfte Tickets",
      "ticket_view_search_label": "Diese Ticketansicht durchsuchen",
      "tickets": "Tickets",
      "tickets_exist_hint": "Insgesamt sind {{count}} Tickets vorhanden.",
      "tickets_near_sla_breach": "Tickets kurz vor SLA-Verletzung",
      "tickets_plural": "{{count}} Tickets",
      "tickets_ratio_label": "{{count}} von {{total}} Tickets",
      "tickets_selected": "{{count}} Tickets ausgewählt",
      "tickets_without_assignee": "Tickets ohne Bearbeiter",
      "time_logged": "Zeit geloggt: {{time}}",
      "time_minutes": "Zeit in Minuten",
      "title": "Titel",
      "to_reply_composer": "Zur Antwort (Composer)",
      "today_due": "Heute fällig",
      "toggle_design_mode": "Design-Modus umschalten",
      "toggle_favorite": "Favorit umschalten",
      "tracked_hours": "{{hours}} Std.",
      "tracked_hours_min": "{{hours}} Std. {{minutes}} Min.",
      "tracked_min": "{{minutes}} Min.",
      "tracked_time": "Erfasste Zeit",
      "unassigned": "Nicht zugewiesen",
      "unlink_asset": "Verknüpfung aufheben",
      "unread": "Ungelesen",
      "update": "Aktualisieren",
      "updated_at": "Aktualisiert",
      "urgent": "Dringend",
      "user_profile_logout": "Benutzer-Profil & Abmelden",
      "vat_id": "USt-IdNr.",
      "views": "Ansichten",
      "voice_notes_admin_hint": "Sprachnotizen: In Administration → KI-Einstellungen „Sprachnotizen“ aktivieren.",
      "voice_notes_enable_info": "Sprachnotizen unter Administration → KI-Einstellungen aktivieren (Toggle „Sprachnotizen“).",
      "voice_notes_not_active": "Sprachnotizen nicht aktiv",
      "website": "Website",
      "widget_critical_tickets": "Kritische Tickets (Feuerwehr)",
      "widget_group_analytics_team": "Analysen & Team",
      "widget_group_overview_performance": "Übersicht & Leistung",
      "widget_group_volume_trends": "Volumen & Trends",
      "widget_my_open_tickets": "Meine offenen Tickets",
      "widget_performance_times": "Leistungszeiten & Aufwand",
      "widget_priority_chart": "Prioritäten-Verteilung",
      "widget_sla_compliance": "SLA-Compliance & Risiko",
      "widget_status_chart": "Ticket-Status Verteilung",
      "widget_team_presence": "Team-Präsenz & Aktivität",
      "widget_ticket_trends": "Ticket-Trends & Volumen",
      "widget_top_customers": "Top-Kunden nach Tickets",
      "zip_code": "PLZ"
    }
  },
  "en": {
    "translation": {
      "access_denied": "Access Denied",
      "access_denied_desc": "You need Agent or Admin privileges.",
      "actions": "Actions",
      "activate_dark_mode": "Activate dark mode",
      "activate_light_mode": "Activate light mode",
      "active": "Active",
      "active_filters": "Aktive Filter",
      "active_open_assignments": "Active, open assignments",
      "activity_optional": "Activity (optional)",
      "admin": "Admin",
      "admin_dashboard.administrative_berechtigungen": "Administrative permissions",
      "admin_dashboard.aendern": "Change",
      "admin_dashboard.agent_deaktiviert": "Agent deactivated",
      "admin_dashboard.agent_erstellt": "Agent created",
      "admin_dashboard.agent_gespeichert": "Agent saved",
      "admin_dashboard.agent_ohne_zuordnung_hinweis": "Without an assignment this agent sees {{umfang}} customers. As soon as at least one customer is assigned, the agent is limited to those customers — tickets, reports and assets.",
      "admin_dashboard.agenten_in_der_kundenkonsole": "Agents in the customer console",
      "admin_dashboard.aktuelles_passwort": "Current password",
      "admin_dashboard.alle_eingehenden_befehle_wurden_bereits_vera": "All incoming commands have already been processed or approved.",
      "admin_dashboard.alle_kunden": "All customers",
      "admin_dashboard.als_hauptkategorie_erstellen": "Create as main category",
      "admin_dashboard.api_token_hinweis": "If needed, create an API token beforehand under the {{reiter}} tab with the {{scope}} scope.",
      "admin_dashboard.aufloesungszeit": "Resolution time *",
      "admin_dashboard.basic_auth_benutzername_passwort": "Basic auth (username/password)",
      "admin_dashboard.bei_prefix_u00c4nderung_werden_alle_bestehen": "Changing the prefix automatically renames all existing tickets.",
      "admin_dashboard.benoetigte_berechtigung": "Required permission:",
      "admin_dashboard.bestaetigen": "Confirm",
      "admin_dashboard.bezeichnung_positionszeile": "Line item description",
      "admin_dashboard.bitte_kunde_waehlen": "Select customer...",
      "admin_dashboard.bitte_kunde_waehlen_2": "Select customer...",
      "admin_dashboard.definieren_sie_hauptkategorien_und_bis_zu_zw": "Define main categories and up to two levels of subcategories. They are offered as options when a ticket is created.",
      "admin_dashboard.definiert_die_standard_reihenfolge_der_queue": "Defines the default order of the queues in the agent sidebar.",
      "admin_dashboard.details_anzeigen": "Show details",
      "admin_dashboard.details_anzeigen_2": "Show details",
      "admin_dashboard.die_smtp_einstellungen_fuer_den_e_mail_versa": "The SMTP settings for outgoing email are now configured centrally under",
      "admin_dashboard.e_mail_versand_smtp_wird_unter_e_mail_einste": "Outgoing email (SMTP) is configured under Email settings",
      "admin_dashboard.eine_sicherheitsgruppe_legt_fest_welche_kons": "A security group defines which console modules an agent sees. \"Full access\" = all modules. Admin rights are independent of this.",
      "admin_dashboard.einstellungen_speichern": "Save settings",
      "admin_dashboard.eintraege": "Entries",
      "admin_dashboard.endgeraet": "Device",
      "admin_dashboard.endgueltig_loeschen": "Endgültig löschen",
      "admin_dashboard.entwurfsrechnung_aus_zeiteintraegen": "Draft invoice from time entries",
      "admin_dashboard.erstellen_sie_ihre_erste_automatisierung": "Create your first automation",
      "admin_dashboard.erstellen_sie_oben_ihre_erste_hauptkategorie": "Create your first main category above",
      "admin_dashboard.externer_mitarbeiter_dienstleister": "External employee / service provider",
      "admin_dashboard.fehler_beim_deaktivieren": "Deactivation failed",
      "admin_dashboard.fehler_beim_deaktivieren_2": "Deactivation failed",
      "admin_dashboard.fehler_beim_deaktivieren_3": "Deactivation failed",
      "admin_dashboard.fehler_beim_loeschen": "Deletion failed",
      "admin_dashboard.firma_adresse_kontakt_steuernummern_in_der_u": "Company, address, contact and tax numbers can be edited in the overview. Deactivating customers remains reserved for administrators.",
      "admin_dashboard.fuer_entra_id_benoetigen_sie_eine_app_regist": "Entra ID requires an app registration in the Azure portal with the Mail.Read permission.",
      "admin_dashboard.geloescht": "Deleted",
      "admin_dashboard.geloescht_2": "Deleted",
      "admin_dashboard.installationspaket_herunterladen": "Download installation package",
      "admin_dashboard.kategorie_aktualisiert": "Category updated",
      "admin_dashboard.kategorie_erstellt": "Category created",
      "admin_dashboard.kategorie_geloescht": "Category deleted",
      "admin_dashboard.keine_abteilung": "No department",
      "admin_dashboard.keine_ausstehenden_befehls_freigaben_vorhand": "No pending command approvals.",
      "admin_dashboard.keine_workflows_konfiguriert": "No workflows configured",
      "admin_dashboard.keine_zuordnung_dieser_agent_sieht_alle_kund": "No assignment — this agent sees all customers.",
      "admin_dashboard.konfigurieren_sie_sprachmodelle_auto_respons": "Configure language models, auto-response prompts and system templates",
      "admin_dashboard.kunde_auswaehlen": "Select customer *",
      "admin_dashboard.kunde_deaktiviert": "Customer deactivated",
      "admin_dashboard.kunde_erstellt": "Customer created",
      "admin_dashboard.kunde_geloescht": "Kunde „{{firma}}\" wurde endgültig gelöscht",
      "admin_dashboard.kunde_gespeichert": "Customer saved",
      "admin_dashboard.kunde_waehlen": "Select customer…",
      "admin_dashboard.kundenzuordnung_verwalten": "Manage customer assignment",
      "admin_dashboard.laden_sie_ein_fertiges_zip_archiv_fuer": "Download a ready-made ZIP archive for",
      "admin_dashboard.laedt": "Loading…",
      "admin_dashboard.laengengrad": "Longitude",
      "admin_dashboard.legen_sie_fest_welche_daten_der_installierte": "Define which data the installed agent collects and configure the optional agentless network scanner (subnet ping).",
      "admin_dashboard.letzte_exporte": "Recent exports",
      "admin_dashboard.lexoffice_artikel_uuid_optional_dienstleistu": "Lexoffice article UUID (optional, service)",
      "admin_dashboard.lexoffice_deaktiviert_hinweis": "The LexOffice integration is currently disabled. You can only create invoice drafts once you enable and configure the integration under {{bereich}}.",
      "admin_dashboard.lexoffice_einstellungen_konnten_nicht_gelade": "Lexoffice settings could not be loaded (run the migration / restart the server).",
      "admin_dashboard.loeschen": "Delete",
      "admin_dashboard.loeschen_2": "Delete",
      "admin_dashboard.mailbox_empfang_imap_oauth_wird_unter_postfa": "Mailbox retrieval (IMAP/OAuth) is configured under Mailboxes",
      "admin_dashboard.mailbox_speichern": "Save mailbox",
      "admin_dashboard.microsoft_graph_api": "Microsoft Graph API",
      "admin_dashboard.mit_einem_frisch_generierten_api_schluessel": "with a freshly generated API key and a",
      "admin_dashboard.mitarbeiter_deaktiviert": "Employee deactivated",
      "admin_dashboard.mitarbeiter_erstellt": "Employee created",
      "admin_dashboard.mitarbeiter_gespeichert": "Employee saved",
      "admin_dashboard.mloffice_gefuehrt": "Stammdaten werden von MLOffice geführt",
      "admin_dashboard.mloffice_geloest": "Mit MLOffice verknüpft — Abgleich derzeit gelöst",
      "admin_dashboard.module_assets": "Assets",
      "admin_dashboard.module_calendar": "Calendar",
      "admin_dashboard.module_customers": "Customers",
      "admin_dashboard.module_knowledge": "Knowledge base",
      "admin_dashboard.module_licenses": "Licenses",
      "admin_dashboard.module_problems": "Problems",
      "admin_dashboard.module_reports": "Reports",
      "admin_dashboard.module_tickets": "Tickets",
      "admin_dashboard.nach_kunde_filtern": "Filter by customer",
      "admin_dashboard.neue_mailbox_konfiguration": "New mailbox configuration",
      "admin_dashboard.neuer_workflow": "New workflow",
      "admin_dashboard.neues_passwort": "New password",
      "admin_dashboard.nicht_abrechenbar": "Not billable",
      "admin_dashboard.noch_keine_kategorien_definiert": "No categories defined yet",
      "admin_dashboard.noch_keine_zeiteintraege_vorhanden": "No time entries yet",
      "admin_dashboard.nur_abrechenbare_eintraege_ohne_vorherigen_l": "Only billable entries without a previous Lexoffice export; optionally filter by contract ID.",
      "admin_dashboard.optionale_beschreibung_des_sla_umfangs": "Optional description of the SLA scope",
      "admin_dashboard.passwort_aendern": "Change password",
      "admin_dashboard.primaer": "Primary",
      "admin_dashboard.prioritaet_geaendert": "• Priority changed",
      "admin_dashboard.pruefinterval_minuten": "Check interval (minutes)",
      "admin_dashboard.refresh_token": "Refresh Token",
      "admin_dashboard.sie_koennen_den_agenten_auch_manuell_registr": "You can also register the agent manually. Use the following syntax on the client (requires administrator rights):",
      "admin_dashboard.standardmaessig_duerfen_agenten_kunden_stamm": "By default, agents may only read customer master data and only view customer documents. Here you can enable extended write permissions for each area.",
      "admin_dashboard.status_geaendert": "• Status changed",
      "admin_dashboard.stundensatz_ueberschreiben_optional": "Override hourly rate (optional)",
      "admin_dashboard.tarif_erweitern": "Upgrade plan",
      "admin_dashboard.ticket_id_format_und_admin_passwort_koennen": "Ticket ID format and admin password can be configured here",
      "admin_dashboard.top_kunden_nach_ticketvolumen": "Top customers by ticket volume",
      "admin_dashboard.uebergeordnete_kategorie": "Parent category",
      "admin_dashboard.unterkategorie_hinzufuegen": "Add subcategory",
      "admin_dashboard.upload_metadaten_bearbeiten_und_loeschen_von": "Upload files, edit metadata and delete files in the customer \"Documents\" tab.",
      "admin_dashboard.verfuegbare_trigger": "Available triggers",
      "admin_dashboard.verwalten_und_genehmigen_sie_ausstehende_adm": "Manage and approve pending administrative commands from other administrators before they run on client devices.",
      "admin_dashboard.voller_zugriff_alle_module": "Full access (all modules)",
      "admin_dashboard.vorkonfiguriertes_paket_zip": "Preconfigured package (.zip)",
      "admin_dashboard.was_bedeuten_die_gruppen": "What do the groups mean?",
      "admin_dashboard.workflow_automatisierungen": "Workflow automations",
      "admin_dashboard.z_b_hauptsitz_koeln": "e.g. Cologne headquarters",
      "admin_dashboard.zeit_standardmaessig_abrechenbar": "Time billable by default",
      "admin_dashboard.zeitbuchung_bei_ticket_schliessung_erforderl": "Time entry required when closing a ticket",
      "admin_dashboard.zeitbuchungen_erscheinen_hier_sobald_agenten": "Time entries appear here as soon as agents log time on tickets.",
      "admin_dashboard.zeiteintraege": "Time entries",
      "admin_dashboard.zeiterfassung_aktivieren": "Enable time tracking",
      "admin_dashboard.zeiterfassung_einstellungen": "Time tracking settings",
      "admin_dashboard.zugriff_verweigert": "Access denied",
      "admin_dashboard.zugriff_verweigert_text": "You do not have the administrative permissions required to view or manage the {{bereich}} area.",
      "admin_dashboard.zuordnung_entfernen": "Remove assignment",
      "admin_dashboard.zusaetzliche_admin_rechte": "Additional admin rights",
      "admin_default": "Admin Default",
      "admin_only_change": "(only an administrator can change the assignment.)",
      "admin_overview.aktive_warnungen_risiken": "Active warnings & risks",
      "admin_overview.alles_in_ordnung": "All clear",
      "admin_overview.datenbank_engine": "Database engine",
      "admin_overview.einstellungen_filtern": "Filter settings...",
      "admin_overview.hinweis_fuer_administratoren": "Note for administrators:",
      "admin_overview.keine_ergebnisse_gefunden": "No results found",
      "admin_overview.keine_warnungen_oder_kritischen_meldungen": "No warnings or critical messages.",
      "admin_overview.lade_dashboard_daten": "Loading dashboard data...",
      "admin_overview.system_status": "System Status",
      "admin_overview.upgrade_erforderlich": "Upgrade required",
      "admin_overview.upgrade_erforderlich_2": "Upgrade required",
      "admin_overview.versuchen_sie_es_mit_einem_anderen_suchbegri": "Try a different search term.",
      "admin_overview.zurueck_zum_agent_dashboard": "Back to agent dashboard",
      "admin_view": "Admin View",
      "administration": "Administration",
      "administrator": "Administrator",
      "agent": "Agent",
      "agent_available": "Available",
      "agent_console": "Agent Console",
      "agent_console.alle_als_gelesen": "Mark all as read",
      "agent_console.anhaenge": "Attachments",
      "agent_console.anhaenge_zum_eroeffnungsbeitrag": "Attachments to the opening message",
      "agent_console.back_to_ticket_list": "Zurück zur Liste",
      "agent_console.beschreiben_sie_hier_details_die_dem_partner": "Describe any details that should be shared with the partner...",
      "agent_console.bitte_waehlen": "-- Please select --",
      "agent_console.detailansicht_schliessen": "Close detail view",
      "agent_console.erneut_oeffnen": "Reopen",
      "agent_console.hinweis_der_partner_erhaelt_eine_benachricht": "Note: The partner receives a notification email with your details and a secure link to work on the ticket.",
      "agent_console.interner_chat": "Internal chat",
      "agent_console.interner_chat_2": "Internal chat",
      "agent_console.keine_benachrichtigungen": "No notifications",
      "agent_console.language_selection": "Language selection",
      "agent_console.loesen": "Resolve",
      "agent_console.mir_zuweisen": "Assign to me",
      "agent_console.nachricht_notiz_fuer_den_partner_optional": "Message / note for the partner (optional)",
      "agent_console.neues_ticket": "New ticket",
      "agent_console.neues_ticket_2": "New ticket",
      "agent_console.partner_dienstleister_waehlen": "Select partner service provider",
      "agent_console.schliessen": "Close",
      "agent_console.schliessen_2": "Close",
      "agent_console.schliessungsgrund": "Closing reason:",
      "agent_console.schnellsuche_oeffnen": "Open quick search",
      "agent_console.sie_benoetigen_agent_oder_admin_rechte": "You need agent or admin rights.",
      "agent_console.tastenkuerzel": "Keyboard shortcuts",
      "agent_console.ticket_erstellt": "Ticket created",
      "agent_console.ticket_schliessen": "Close ticket",
      "agent_console.zugriff_verweigert": "Access denied",
      "agent_console.zur_antwort_composer": "Go to reply (composer)",
      "agent_console.zur_antwort_scrollen": "Scroll to reply",
      "agent_console.zusammenfuehren": "Zusammenführen",
      "agent_console.zuweisung_entfernen": "Remove assignment",
      "ai": "AI",
      "ai_analysis_running": "Analysis running...",
      "ai_assistance": "AI Assistance",
      "ai_confidence_label": "{{pct}}% confidence",
      "ai_context_title": "KI-Kontext & Prognosen",
      "ai_generate_summary": "Generate Summary",
      "ai_key_points": "Key Points",
      "ai_next_steps": "Next Steps",
      "ai_requested_action": "Requested Action",
      "ai_risks": "Risks",
      "ai_solution_assistant_title": "AI Solution Assistant",
      "ai_stale": "Stale",
      "ai_summary_title": "AI Summary",
      "all": "All",
      "all_active_tickets": "All Active Tickets",
      "all_categories": "All Categories",
      "all_customers": "All Customers",
      "all_deadlines_ok": "All deadlines are within the timeframe.",
      "all_open": "All Open",
      "all_tickets": "All Tickets",
      "allgemein.abbrechen": "Abbrechen",
      "allgemein.schliessen": "Schließen",
      "analyze_again": "Analyze again",
      "article": "Article",
      "article_ai_generate": "Create Article with AI",
      "article_ai_generate_btn": "Generate Article",
      "article_ai_generate_desc": "Describe the topic and the AI will generate a draft",
      "article_ai_improve": "Improve text",
      "article_ai_keywords": "Keywords (optional)",
      "article_ai_keywords_placeholder": "e.g., Windows 11, OpenVPN, certificate",
      "article_ai_language": "Language",
      "article_ai_len_long": "Long / detailed",
      "article_ai_len_medium": "Medium",
      "article_ai_len_short": "Short",
      "article_ai_length": "Length",
      "article_ai_style": "Tone of voice",
      "article_ai_style_balanced": "Balanced",
      "article_ai_style_enduser": "End user (step by step)",
      "article_ai_style_formal": "Formal",
      "article_ai_style_simple": "Simple / easy to understand",
      "article_ai_style_technical": "Technical (IT professionals)",
      "article_ai_summarize": "Generate summary",
      "article_ai_topic": "Topic *",
      "article_ai_topic_placeholder": "e.g., Set up VPN connection on Windows",
      "article_all_customers": "All customers",
      "article_all_statuses": "All statuses",
      "article_all_visible": "Visible to all customers",
      "article_archived": "Archived",
      "article_category": "Category",
      "article_content_placeholder": "Start writing your article here...",
      "article_create_first": "Create First Article",
      "article_create_first_desc": "Create your first knowledge article to share information with your team.",
      "article_create_with_ai": "Create with AI",
      "article_delete_confirm": "Do you really want to delete this article?",
      "article_draft": "Draft",
      "article_excerpt_placeholder": "A brief summary of the article...",
      "article_manage": "Manage articles",
      "article_new": "New Article",
      "article_no_articles": "No articles available yet",
      "article_no_categories_desc": "No categories available. Please create them in the admin area.",
      "article_no_category": "No Category",
      "article_not_found": "No articles found",
      "article_not_found_desc": "No articles could be found for your search query.",
      "article_only_visible": "Only visible to {{name}}",
      "article_pinned": "Pinned",
      "article_pinned_desc": "Will be shown at the top of the list",
      "article_plural": "All articles",
      "article_published": "Published",
      "article_search": "Search articles...",
      "article_views": "views",
      "article_visibility": "Customer Visibility",
      "article_write_content": "Article Content",
      "article_write_excerpt": "Excerpt",
      "article_write_title": "Enter article title...",
      "asset.discovery_agents": "Discovery Agents",
      "asset.event_logs": "Event Logs",
      "asset.general": "General",
      "asset.hardware_wmi": "Hardware (WMI)",
      "asset.history_changes": "History & Changes",
      "asset.more": "More",
      "asset.network": "Network",
      "asset.network_discovery": "Network Discovery",
      "asset.printers": "Printers",
      "asset.processes": "Processes",
      "asset.relationships": "Relationships",
      "asset.remote_control": "Remote Control",
      "asset.remote_terminal": "Remote Terminal",
      "asset.scan_history": "Scan history",
      "asset.security": "Security",
      "asset.services": "Services",
      "asset.software_catalog": "Software Catalog (SAM)",
      "asset.software_count": "Software",
      "asset.system_assets": "System Assets",
      "asset.updates": "Updates",
      "asset_": "asset_",
      "asset_active": "Active",
      "asset_agent.offline": "Offline",
      "asset_agent.online_active": "Online (active)",
      "asset_agent.recently_active": "Recently active",
      "asset_inactive": "Inactive",
      "asset_maintenance": "Maintenance",
      "asset_management": "Asset Management",
      "asset_panel.confirm_delete_asset": "Really delete \"{{name}}\"?",
      "asset_panel.confirm_delete_category": "Delete category \"{{name}}\"? Assets will be unlinked.",
      "asset_panel.edit_asset": "Edit asset",
      "asset_panel.edit_category": "Edit category",
      "asset_panel.import_as_managed_btn": "Import as managed asset",
      "asset_panel.import_device": "Import device",
      "asset_panel.new_asset": "New asset",
      "asset_panel.new_category": "New category",
      "asset_panel.print_asset_tag": "Print asset tag",
      "asset_panel.print_now_btn": "Print now",
      "asset_panel.toast.agent_no_response_hint": "The agent did not respond in time.",
      "asset_panel.toast.assets_imported": "{{count}} asset(s) imported",
      "asset_panel.toast.command_queued": "Command queued successfully",
      "asset_panel.toast.create_problem_error": "Error creating the problem ticket",
      "asset_panel.toast.csv_import_failed": "CSV import failed",
      "asset_panel.toast.device_ignored": "Device ignored successfully",
      "asset_panel.toast.device_imported": "Device imported into managed assets successfully",
      "asset_panel.toast.ignore_device_error": "Error ignoring the device",
      "asset_panel.toast.import_device_error": "Error importing the device",
      "asset_panel.toast.import_with_errors": "Import completed with errors",
      "asset_panel.toast.itil_correlation_error": "Error during ITIL problem correlation",
      "asset_panel.toast.less_than_3_tickets": "Fewer than 3 tickets in the last 30 days.",
      "asset_panel.toast.manual_scan_error": "Error during manual scan",
      "asset_panel.toast.problem_ticket_created": "Problem ticket created and incidents linked!",
      "asset_panel.toast.queue_command_error": "Command could not be queued",
      "asset_panel.toast.request_scan_error": "Error requesting the scan",
      "asset_panel.toast.scan_completed": "Scan completed successfully",
      "asset_panel.toast.scan_failed": "Scan failed",
      "asset_panel.toast.scan_requested": "{{type}} requested",
      "asset_panel.toast.template_downloaded": "Template “asset-import-vorlage.csv” downloaded",
      "asset_panel.toast.template_load_error": "Template could not be loaded",
      "asset_remote_client_disconnected": "Client disconnected",
      "asset_remote_client_disconnected_desc": "The user on the client device has terminated the remote support session.",
      "asset_remote_closed_desc": "The remote support session was successfully closed.",
      "asset_remote_code_placeholder": "e.g., 123 456",
      "asset_remote_conn_disconnected": "Disconnected",
      "asset_remote_conn_failed": "Connection to the remote server failed",
      "asset_remote_conn_rejected": "Connection rejected",
      "asset_remote_consent_hint": "A consent dialog is displayed on the client screen. Please ask the client to accept.",
      "asset_remote_disconnect": "Disconnect",
      "asset_remote_enter_code_hint": "Enter the 6-digit access code displayed on the user's screen:",
      "asset_remote_invalid_code": "Incorrect entry code",
      "asset_remote_live_focus": "LIVE · Focus for keyboard input",
      "asset_remote_loading_screen": "Loading live screen...",
      "asset_remote_preparing": "Preparing connection...",
      "asset_remote_protocol2_code_label": "Zwölfstelliger Zugangscode",
      "asset_remote_protocol2_code_placeholder": "ABCD EFGH 2345",
      "asset_remote_protocol2_enter_code_hint": "Geben Sie den zwölfstelligen Zugangscode vom Bildschirm des Benutzers ein:",
      "asset_remote_protocol2_request_desc": "Sendet eine Verbindungsanfrage an den Client-Rechner. Der Benutzer muss zustimmen und den zwölfstelligen Zugangscode übermitteln.",
      "asset_remote_rejected_desc": "The connection request was rejected by the user on the client device.",
      "asset_remote_req": "Request Remote Session",
      "asset_remote_request_again": "Request again",
      "asset_remote_request_desc": "Sends a connection request to the client machine. The user must consent and share a 6-digit access code.",
      "asset_remote_request_title": "Request Remote Support",
      "asset_remote_start_error": "Could not start remote support session",
      "asset_remote_start_new": "Start new session",
      "asset_remote_support": "Built-in Remote Support",
      "asset_remote_support_desc": "Direct screen remote control without external software (TeamViewer/RustDesk).",
      "asset_remote_user_consented": "User has consented",
      "asset_remote_verifying_code": "Verifying code...",
      "asset_remote_waiting_consent": "Waiting for user consent...",
      "asset_retired": "Retired",
      "assets": "Assets",
      "assign_to": "Assign...",
      "assign_to_me": "Assign to me",
      "assigned_agents": "Assigned Agents",
      "assigned_to": "Assigned to",
      "at_risk_title": "At Risk (SLA Warning):",
      "attach_local_file": "Attach local file",
      "attachments": "Attachments",
      "attachments_tools": "Attachments & Tools",
      "attendees_emails": "Attendees (Emails, comma separated)",
      "automation": "Automation",
      "avg_first_response": "First Response Time",
      "avg_resolution": "Avg. Resolution Time",
      "billable": "Billable",
      "billable_time": "Billable: {{time}}",
      "book_on_send": "Book on send",
      "book_time_with_reply": "Log time with reply",
      "calendar": "Calendar",
      "calendar_enter_title_warning": "Please enter a title.",
      "calendar_event_attendees": "Attendee Emails (optional, comma separated)",
      "calendar_event_created_error": "Could not create event.",
      "calendar_event_created_success": "Event created.",
      "calendar_event_description": "Description (optional)",
      "calendar_event_title": "Title",
      "calendar_meeting_created_error": "Could not create meeting.",
      "calendar_meeting_link_copied": "Meeting link copied to clipboard.",
      "calendar_new_event": "New Event",
      "calendar_no_integration_or": "or",
      "calendar_no_integration_prefix": "No calendar or meeting integration active. Please configure",
      "calendar_no_integration_suffix": "with active meeting planning in the integrations.",
      "calendar_only_event": "Calendar Event Only",
      "calendar_talk_meeting": "Talk Meeting",
      "calendar_talk_room_created": "Talk room created.",
      "calendar_teams_meeting": "Teams Meeting",
      "calendar_teams_meeting_created": "Teams meeting created.",
      "cancel": "Cancel",
      "canned_responses": "Insert canned response",
      "canned_responses_short": "Canned response",
      "categories": "Categories",
      "category": "Category",
      "change_priority": "Change priority...",
      "change_status_after_send": "After sending, change to",
      "change_ticket_company": "Ticket anderer Firma zuordnen",
      "change_ticket_company_warning": "Portal-Ersteller, CC, Mitarbeiter, Bearbeiter, Kategorie, SLA, Assets und laufende Timer werden für die neue Firma zurückgesetzt.",
      "characters": "characters",
      "city": "City",
      "clear_selection": "Clear selection",
      "click_to_logout": "Click to logout",
      "close": "Close",
      "close_detail_view": "Close detail view",
      "close_ticket": "Close ticket",
      "closed": "Closed",
      "collapse": "Collapse",
      "collapse_composer": "Collapse editor",
      "collapse_sidebar": "Collapse sidebar",
      "column_assignee_name": "Assignee",
      "column_category_name": "Category",
      "column_channel": "Channel",
      "column_created_at": "Created",
      "column_customer_name": "Customer",
      "column_priority": "Priority",
      "column_reply_count": "Replies",
      "column_requester_name": "Requester",
      "column_sla": "SLA",
      "column_status": "Status",
      "column_subject": "Subject",
      "column_tags": "Tags",
      "column_ticket_number": "No.",
      "column_updated_at": "Updated",
      "columns_btn": "Columns",
      "common.abbrechen": "Abbrechen",
      "company_name": "Company Name",
      "company_title": "Company",
      "compliance_rate": "Compliance Rate",
      "composer_internal": "Internal",
      "composer_internal_placeholder": "Internal note...",
      "composer_public": "Public",
      "composer_public_placeholder": "Write reply...",
      "configure_columns": "Configure Columns",
      "connect": "Connect",
      "contact_and_master_data": "Contact & Master Data",
      "contact_person": "Contact Person",
      "contact_person_abbrev": "CP",
      "contract": "Contract",
      "contract.auto_renew": "Automatic renewal",
      "contract.auto_renews_suffix": " (renews automatically)",
      "contract.back_to_overview": "Back to overview",
      "contract.billing": "Billing",
      "contract.billing_model": "Billing model",
      "contract.conditions": "Terms",
      "contract.days": "{{count}} days",
      "contract.end_date": "End date",
      "contract.expires_in_days": "Expires in {{count}} days",
      "contract.first_response": "First response",
      "contract.hourly_rate": "Hourly rate",
      "contract.hours_quota": "Hours quota",
      "contract.included_hours": "Included hours",
      "contract.no_contracts": "No contracts available",
      "contract.no_contracts_desc": "Contact us for an individual quote",
      "contract.notice_period": "Notice period: {{count}} days",
      "contract.period_per": "{{count}}h / period",
      "contract.quota_summary": "{{remaining}} remaining ({{percent}}% used)",
      "contract.remaining": "Remaining",
      "contract.resolution": "Resolution",
      "contract.runtime": "Term",
      "contract.sla_tier": "SLA",
      "contract.start_date": "Start date",
      "contract.status.active": "Active",
      "contract.status.expired": "Expired",
      "contract.status.expiring_soon": "Expiring soon",
      "contract.status.future": "Future",
      "contract.subtitle": "Overview of your active contracts and service level agreements",
      "contract.unlimited": "Open-ended",
      "contract.used": "Used",
      "contracts": "Contracts",
      "copied_to_clipboard": "Copied to clipboard",
      "country": "Country",
      "create": "Create",
      "create_ticket.aehnliche_tickets": "Similar tickets",
      "create_ticket.angehaengte_cloud_dateien": "Attached cloud files:",
      "create_ticket.anhaenge": "Attachments",
      "create_ticket.asset_verknuepfen_optional": "Link asset (optional):",
      "create_ticket.assets_filtern": "Filter assets:",
      "create_ticket.assets_werden_geladen": "Loading assets...",
      "create_ticket.beschreiben_sie_das_problem_so_detailliert_w": "Describe the problem in as much detail as possible...",
      "create_ticket.betroffene_systeme_benutzer_nennen": "Name the affected systems/users",
      "create_ticket.bitte_betreff_und_beschreibung_ausfuellen": "Please fill in subject and description",
      "create_ticket.bitte_eine_beschreibung_angeben": "Please enter a description.",
      "create_ticket.bitte_einen_kunden_auswaehlen": "Please select a customer.",
      "create_ticket.bitte_hauptkategorie_waehlen": "Select main category...",
      "create_ticket.bitte_klassifizierung_waehlen": "Select classification...",
      "create_ticket.bitte_kunde_waehlen": "Select customer...",
      "create_ticket.bitte_unterkategorie_waehlen": "Select subcategory...",
      "create_ticket.bitte_zuerst_einen_kunden_waehlen": "Select a customer first...",
      "create_ticket.datei_hochladen": "Upload file",
      "create_ticket.datei_hochladen_2": "Upload file",
      "create_ticket.datei_zu_gross_max_10_mb": "File too large (max. 10 MB)",
      "create_ticket.dateityp_nicht_erlaubt": "File type not allowed",
      "create_ticket.erste_antwort": "First response",
      "create_ticket.fehlermeldungen_und_screenshots_beifuegen": "Attach error messages and screenshots",
      "create_ticket.keine_mitarbeiter_hinterlegt": "No employees on record",
      "create_ticket.letzte_kunden_tickets": "Recent customer tickets",
      "create_ticket.loesung": "Resolution",
      "create_ticket.neues_ticket": "New ticket",
      "create_ticket.nur_geschaeftszeiten": "Business hours only",
      "create_ticket.praeziser_betreff_hilft_bei_der_zuordnung": "A precise subject helps with assignment",
      "create_ticket.priority_high": "High",
      "create_ticket.priority_low": "Low",
      "create_ticket.priority_medium": "Medium",
      "create_ticket.priority_urgent": "Urgent",
      "create_ticket.schritte_zur_reproduktion_angeben": "Provide steps to reproduce",
      "create_ticket.stoerung": "Incident",
      "create_ticket.text_mit_ki_verbessern": "Improve text with AI",
      "create_ticket.ticket_erstellt": "Ticket created!",
      "create_ticket.uebernehmen": "Apply",
      "create_ticket.ueberschrift": "Title",
      "create_ticket.vielleicht_loest_ein_artikel_das_problem_ber": "Maybe an article already solves the problem?",
      "create_ticket.vorlage_einfuegen": "Insert template",
      "create_ticket.waehlen_sie_einen_kunden_aus_um_dessen_asset": "Select a customer to link their assets.",
      "create_ticket.werden_bei_erstellung_ausgeloest": "Triggered on creation",
      "create_ticket.zurueck": "Back",
      "created_at": "Created at",
      "critical_priority_sla": "Priority / SLA",
      "customer": "Customer",
      "customer_assets.no_assets": "No assets recorded for this customer. Status information appears here once an asset has a Zabbix host ID or an uptime monitor.",
      "customer_assets.no_assets_unconfigured": "No assets recorded. Discovery or a monitoring integration can automate inventory.",
      "customer_assets.no_zabbix_id": "No Zabbix host ID on the asset",
      "customer_assets.start_rd": "Start RustDesk",
      "customer_assets.start_tv": "Start TeamViewer",
      "customer_form.adresse_eingeben_um_karte_anzuzeigen": "Enter an address to show the map",
      "customer_form.client_secret": "Client Secret",
      "customer_form.domain_entfernen": "Remove domain",
      "customer_form.domain_hinzufuegen": "+ Add domain",
      "customer_form.domains_mit_zugeordneten_mitarbeitern_koenne": "Domains with assigned employees cannot be removed.",
      "customer_form.geschaeftsfuehrer": "Managing director",
      "customer_form.in_openstreetmap_oeffnen": "Open in OpenStreetMap ↗",
      "customer_form.interne_notizen_zu_diesem_kunden": "Internal notes on this customer...",
      "customer_form.kontakt_in_lexoffice_anlegen_uuid_hier_eintr": "Create the contact in Lexoffice, then enter the UUID here",
      "customer_form.lexoffice_kontakt_id_uuid": "Lexoffice contact ID (UUID)",
      "customer_form.logo_kann_nach_dem_erstellen_des_kunden_hoch": "The logo can be uploaded once the customer has been created.",
      "customer_form.mitarbeiter_koennen_sich_per_microsoft_konto": "Employees can sign in with their Microsoft account",
      "customer_form.mloffice_badge": "Von MLOffice verwaltet",
      "customer_form.mloffice_banner": "Dieser Kunde wird mit MLOffice abgeglichen. Stammdaten (Name, E-Mail, Telefon, Anschrift, USt-ID) werden von MLOffice verwaltet und sind hier gesperrt.",
      "customer_form.mloffice_feld_hinweis": "Dieses Feld wird von MLOffice verwaltet — Änderungen bitte dort vornehmen; sie werden automatisch übernommen.",
      "customer_form.mloffice_geloest": "Verknüpfung gelöst — die Felder sind wieder bearbeitbar.",
      "customer_form.mloffice_loesen": "Verknüpfung lösen…",
      "customer_form.mloffice_loesen_fehler": "Verknüpfung konnte nicht gelöst werden.",
      "customer_form.mloffice_loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "customer_form.mloffice_loest": "Löse…",
      "customer_form.mloffice_verwaltung_hinweis": "Verwaltung der Verknüpfung unter Stammdaten & Organisation → MLOffice (erfordert Systemrechte).",
      "customer_form.registrieren_sie_eine_app_in_azure_portal_ap": "Register an app in Azure Portal → App registrations. Redirect URI:",
      "customer_form.strasse": "Street",
      "customer_form.tab_address": "Address",
      "customer_form.tab_domains": "Domains",
      "customer_form.tab_general": "General",
      "customer_form.tab_notes": "Notes",
      "customer_form.tab_sso": "SSO",
      "customer_form.tab_tax": "Tax & SLA",
      "customer_form.zuordnung_ticket_system_kunde_lexoffice_kont": "Maps the ticket system customer → Lexoffice contact for draft invoices (Admin → Time tracking).",
      "customer_inactive": "Customer inactive",
      "customer_not_found": "Customer not found",
      "customer_notified_by_email": "Customer will be notified by email",
      "customer_number_abbrev": "Cust No",
      "customer_portal.action_required": "Action required",
      "customer_portal.action_required_desc": "The support team is waiting for your feedback on this ticket.",
      "customer_portal.action_required_title": "Your reply is needed",
      "customer_portal.assignee": "Assignee",
      "customer_portal.attachments_count": "Attachments ({{count}})",
      "customer_portal.attachments_load_failed": "Weitere Anhänge konnten nicht geladen werden.",
      "customer_portal.back": "← Back",
      "customer_portal.back_to_my_tickets": "← Back to My Tickets",
      "customer_portal.close": "Close",
      "customer_portal.close_failed": "The ticket could not be closed.",
      "customer_portal.collapse_replies": "Ältere schließen",
      "customer_portal.compact_replies": "Ältere Antworten sind eingeklappt. Die letzte Antwort bleibt geöffnet.",
      "customer_portal.confirm_close": "Do you really want to close this ticket?",
      "customer_portal.confirm_reopen": "Do you really want to reopen this ticket?",
      "customer_portal.contracts.hours_minutes": "{{hours}}h {{minutes}}min",
      "customer_portal.contracts.hours_only": "{{hours}}h",
      "customer_portal.contracts.minutes_only": "{{minutes}}min",
      "customer_portal.create_first_ticket": "Create new ticket",
      "customer_portal.created": "Created",
      "customer_portal.customer_colleague": "Kollegin/Kollege",
      "customer_portal.dashboard.active_count": "{{count}} active",
      "customer_portal.dashboard.avg_resolution": "Avg. resolution time",
      "customer_portal.dashboard.click_to_view_waiting": "Click here to view the tickets",
      "customer_portal.dashboard.create_first_link": "Create your first ticket →",
      "customer_portal.dashboard.create_new_ticket_link": "Create new ticket",
      "customer_portal.dashboard.history_trend": "Ticket history (last 12 months)",
      "customer_portal.dashboard.kb": "Help & Knowledge Base",
      "customer_portal.dashboard.kb_desc": "Guides and FAQs",
      "customer_portal.dashboard.my_tickets": "My tickets",
      "customer_portal.dashboard.no_tickets": "No tickets yet",
      "customer_portal.dashboard.no_tickets_status": "No tickets",
      "customer_portal.dashboard.open_active": "Open / active",
      "customer_portal.dashboard.processing_time": "Handling time",
      "customer_portal.dashboard.recent_tickets": "Recent tickets",
      "customer_portal.dashboard.report_incident": "Report an incident",
      "customer_portal.dashboard.report_incident_desc": "Report an urgent problem or outage",
      "customer_portal.dashboard.reports": "Overview & reports",
      "customer_portal.dashboard.reports_desc": "Filter and analyse all tickets",
      "customer_portal.dashboard.search_kb_link": "Search the knowledge base",
      "customer_portal.dashboard.service_request": "Service request",
      "customer_portal.dashboard.service_request_desc": "Requests based on configurable forms",
      "customer_portal.dashboard.show_all_link": "Show all →",
      "customer_portal.dashboard.status_overview": "Status overview",
      "customer_portal.dashboard.subtitle": "Your support overview at a glance",
      "customer_portal.dashboard.total_tickets": "Total tickets",
      "customer_portal.dashboard.waiting_tickets_warning": "1 ticket needs your reply",
      "customer_portal.dashboard.waiting_tickets_warning_plural": "{{count}} tickets need your reply",
      "customer_portal.dashboard.welcome": "Welcome",
      "customer_portal.dashboard.widget_unknown": "Widget: {{type}}",
      "customer_portal.dashboard.your_reply": "Your reply",
      "customer_portal.details_title": "Details",
      "customer_portal.editor.bold": "Bold",
      "customer_portal.editor.code": "Code",
      "customer_portal.editor.italic": "Italic",
      "customer_portal.editor.list": "List",
      "customer_portal.expand_replies": "Alle öffnen",
      "customer_portal.files_draft_failed": "Anhänge konnten nicht dauerhaft im Entwurf gespeichert werden.",
      "customer_portal.files_need_reselect": "Anhänge können aus Sicherheitsgründen nicht wiederhergestellt werden. Bitte wählen Sie sie erneut aus.",
      "customer_portal.filters.active": "Active",
      "customer_portal.filters.all": "All",
      "customer_portal.filters.closed": "Closed",
      "customer_portal.filters.external": "Extern",
      "customer_portal.filters.waiting_customer": "Your reply",
      "customer_portal.history_title": "History",
      "customer_portal.impersonation_banner": "You are currently viewing this portal in impersonation mode (agent preview) as customer:",
      "customer_portal.incident_badge": "Incident",
      "customer_portal.kb.title": "Knowledge Base",
      "customer_portal.load_more_attachments": "Weitere Anhänge laden",
      "customer_portal.login.betreut_von": "SUPPORTED BY NALVRA",
      "customer_portal.login.claim": "Your direct line to support — report issues, track status, find answers.",
      "customer_portal.login.copyright_text": "© {{year}} {{appName}}. All rights reserved.",
      "customer_portal.login.default_subtitle": "Sign in to manage your requests.",
      "customer_portal.login.default_welcome": "Welcome to {{appName}}",
      "customer_portal.login.email": "Email",
      "customer_portal.login.email_placeholder": "name@company.com",
      "customer_portal.login.eyebrow": "CUSTOMER PORTAL · AVAILABLE 24/7",
      "customer_portal.login.forgot_password": "Forgot your password?",
      "customer_portal.login.kein_zugang": "No access yet? Please contact your support representative.",
      "customer_portal.login.kundenanmeldung": "Customer sign-in",
      "customer_portal.login.kundenportal": "CUSTOMER PORTAL",
      "customer_portal.login.microsoft_signin": "Sign in with Microsoft",
      "customer_portal.login.mit_hinterlegter_adresse": "Sign in with the email address on file.",
      "customer_portal.login.or_password": "or use a password",
      "customer_portal.login.password": "Password",
      "customer_portal.login.password_placeholder": "Your password",
      "customer_portal.login.reset_back": "Back to sign in",
      "customer_portal.login.reset_button": "Send link",
      "customer_portal.login.reset_instruction": "Enter your email address. We will send you a reset link.",
      "customer_portal.login.reset_sent_message": "If an account exists for this address, we have sent a reset link.",
      "customer_portal.login.reset_sent_title": "Email sent",
      "customer_portal.login.reset_title": "Reset password",
      "customer_portal.login.sicherheitszeile": "Encrypted connection · Access only for registered contacts",
      "customer_portal.login.signin_button": "Sign in",
      "customer_portal.login.signing_in": "Signing in …",
      "customer_portal.login.sso_available": "Single sign-on available",
      "customer_portal.login.sso_failed": "SSO sign-in failed",
      "customer_portal.login.sso_logging_in": "Signing in …",
      "customer_portal.menu.dashboard": "Dashboard",
      "customer_portal.menu.edit_profile": "Edit profile",
      "customer_portal.menu.logout": "Sign out",
      "customer_portal.menu.profile": "Mein Profil",
      "customer_portal.message_placeholder": "Your message...",
      "customer_portal.nav.contracts": "Contracts",
      "customer_portal.nav.create_request": "Anfrage erstellen",
      "customer_portal.nav.dashboard": "Dashboard",
      "customer_portal.nav.documents": "Documents",
      "customer_portal.nav.downloads": "Downloads",
      "customer_portal.nav.help": "Hilfe & Kurztour",
      "customer_portal.nav.kb": "Knowledge Base",
      "customer_portal.nav.my_tickets": "My tickets",
      "customer_portal.nav.profile": "Profile",
      "customer_portal.nav.report_incident": "Report an incident",
      "customer_portal.nav.service_request": "Service request",
      "customer_portal.nav.support": "Support erhalten",
      "customer_portal.navigation": "Portal-Navigation",
      "customer_portal.new_ticket": "New ticket",
      "customer_portal.new_ticket.add_attachment": "Add",
      "customer_portal.new_ticket.ai_improve_btn": "Improve description",
      "customer_portal.new_ticket.ai_improving": "Improving...",
      "customer_portal.new_ticket.ai_preanswer_title": "AI suggestion for your problem",
      "customer_portal.new_ticket.ai_suggestion_title": "AI improvement suggestion",
      "customer_portal.new_ticket.allowed_types_tip": "Only configured file types (see the note from your administrator)",
      "customer_portal.new_ticket.apply": "Apply",
      "customer_portal.new_ticket.attach_file": "Attach file",
      "customer_portal.new_ticket.attachment_plural": "Attachments",
      "customer_portal.new_ticket.attachment_singular": "Attachment",
      "customer_portal.new_ticket.back_step_1": "Zurück zu Schritt 1",
      "customer_portal.new_ticket.back_step_2": "Zurück zu Schritt 2",
      "customer_portal.new_ticket.categories_error": "Kategorien konnten nicht geladen werden.",
      "customer_portal.new_ticket.categories_loading": "Kategorien werden geladen …",
      "customer_portal.new_ticket.category_assignment": "Kategorie zuordnen",
      "customer_portal.new_ticket.category_by_support": "Zuordnung durch den Support",
      "customer_portal.new_ticket.category_hint": "Sie sind unsicher? Lassen Sie die Kategorie offen. Der Support übernimmt die Zuordnung.",
      "customer_portal.new_ticket.category_question": "Welche Kategorie passt zu Ihrem Anliegen?",
      "customer_portal.new_ticket.char_count": "{{count}} characters",
      "customer_portal.new_ticket.continue_step_2": "Weiter zu Schritt 2",
      "customer_portal.new_ticket.continue_step_3": "Weiter zu Schritt 3",
      "customer_portal.new_ticket.create": "Create",
      "customer_portal.new_ticket.create_anyway": "Create ticket anyway",
      "customer_portal.new_ticket.create_ticket": "Create ticket",
      "customer_portal.new_ticket.creating": "Creating...",
      "customer_portal.new_ticket.days_count": "{{count}} business days",
      "customer_portal.new_ticket.description_label": "Description *",
      "customer_portal.new_ticket.description_placeholder": "Describe your problem in detail...\\n\\n• What is not working?\\n• When did the problem start?\\n• Is there an error message?\\n• Which system / device is affected?\\n\\nTip: paste screenshots with Ctrl+V",
      "customer_portal.new_ticket.description_required": "Bitte beschreiben Sie Ihr Problem.",
      "customer_portal.new_ticket.discard": "Discard",
      "customer_portal.new_ticket.drag_more": "Drag more files here · {{count}} more possible",
      "customer_portal.new_ticket.drag_or_click": "Drag files here or click",
      "customer_portal.new_ticket.drop_here": "Drop files here...",
      "customer_portal.new_ticket.error_create_failed": "Error creating the ticket.",
      "customer_portal.new_ticket.expected_first_response": "First response",
      "customer_portal.new_ticket.go_to_step": "Schritt {{step}}: {{label}}",
      "customer_portal.new_ticket.hide": "Hide",
      "customer_portal.new_ticket.hours_count": "{{count}} hours",
      "customer_portal.new_ticket.insert_template": "Insert template",
      "customer_portal.new_ticket.kb_article_error": "Dieser Artikel konnte nicht geladen werden. Sie können es erneut versuchen oder mit Ihrem Ticket fortfahren.",
      "customer_portal.new_ticket.kb_close_article": "Artikel schließen",
      "customer_portal.new_ticket.kb_did_help": "Hat dieser Artikel Ihr Problem gelöst?",
      "customer_portal.new_ticket.kb_draft_retained": "Ihr Ticketentwurf bleibt erhalten. Sie entscheiden, ob Sie ihn weiter bearbeiten.",
      "customer_portal.new_ticket.kb_feedback_error": "Ihre Rückmeldung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut. Ihr Entwurf bleibt erhalten.",
      "customer_portal.new_ticket.kb_helped": "Artikel hat mir geholfen",
      "customer_portal.new_ticket.kb_loading_article": "Artikel wird geladen",
      "customer_portal.new_ticket.kb_resolved_message": "Ihre Rückmeldung wurde gespeichert. Es wurde kein Ticket erstellt.",
      "customer_portal.new_ticket.kb_resolved_title": "Schön, dass die Anleitung geholfen hat",
      "customer_portal.new_ticket.kb_resume_draft": "Ticketentwurf weiter bearbeiten",
      "customer_portal.new_ticket.kb_retry": "Erneut laden",
      "customer_portal.new_ticket.kb_saved_draft": "Ihr Entwurf bleibt für Sie gespeichert, falls Sie später doch Unterstützung benötigen.",
      "customer_portal.new_ticket.kb_searching": "Lösungen werden gesucht",
      "customer_portal.new_ticket.kb_suggestions_hint": "Passende Anleitungen aus der Wissensbasis. Lesen Sie einen Artikel, bevor Sie Ihr Ticket erstellen.",
      "customer_portal.new_ticket.kb_suggestions_title": "Vielleicht ist die Lösung schon da",
      "customer_portal.new_ticket.kb_to_dashboard": "Zurück zum Dashboard",
      "customer_portal.new_ticket.max_files": "Max. {{count}} files",
      "customer_portal.new_ticket.max_size": "Max. {{count}} MB / file",
      "customer_portal.new_ticket.minutes_count": "{{count}} minutes",
      "customer_portal.new_ticket.no_category": "Please select a category...",
      "customer_portal.new_ticket.optional": "Optional",
      "customer_portal.new_ticket.preanswer_might_resolve": "Did that help? Then you may not need to create a ticket.",
      "customer_portal.new_ticket.presubmit_kb_desc": "No suitable article? No problem — go ahead and create your ticket.",
      "customer_portal.new_ticket.presubmit_kb_title": "This might already solve your problem",
      "customer_portal.new_ticket.prio_desc_critical": "Immediately",
      "customer_portal.new_ticket.prio_desc_high": "Urgent",
      "customer_portal.new_ticket.prio_desc_low": "Can wait",
      "customer_portal.new_ticket.prio_desc_medium": "Normal",
      "customer_portal.new_ticket.progress": "Fortschritt der Ticketerstellung",
      "customer_portal.new_ticket.relevant_articles": "Matching articles:",
      "customer_portal.new_ticket.reply_by_email_tip": "You can also reply to this ticket by email",
      "customer_portal.new_ticket.resolution": "Resolution",
      "customer_portal.new_ticket.response_time_typical": "Reply usually within a few hours",
      "customer_portal.new_ticket.retry_categories": "Erneut laden",
      "customer_portal.new_ticket.screenshot_tip": "Paste screenshots with Ctrl+V",
      "customer_portal.new_ticket.similar_tickets": "Similar tickets",
      "customer_portal.new_ticket.step_attachments": "Anhänge",
      "customer_portal.new_ticket.step_attachments_detail": "Kategorie, Anhänge und Absenden",
      "customer_portal.new_ticket.step_count": "Schritt {{step}} von 3",
      "customer_portal.new_ticket.step_details": "Details",
      "customer_portal.new_ticket.step_details_detail": "Beschreibung und Priorität",
      "customer_portal.new_ticket.step_subject": "Betreff",
      "customer_portal.new_ticket.step_subject_detail": "Person, Betreff und Wissensbasis",
      "customer_portal.new_ticket.subject_desc_required": "Subject and description are required.",
      "customer_portal.new_ticket.subject_label": "Subject *",
      "customer_portal.new_ticket.subject_placeholder": "Short description of the problem or your request",
      "customer_portal.new_ticket.subject_required": "Bitte geben Sie einen Betreff ein.",
      "customer_portal.new_ticket.subtitle": "Technical fault or urgent problem — submitted to support as a ticket.",
      "customer_portal.new_ticket.subtitle_2": "Describe your request and we will take care of it.",
      "customer_portal.new_ticket.success_desc": "Thank you. We will get back to you as soon as possible.",
      "customer_portal.new_ticket.success_title": "Ticket created!",
      "customer_portal.new_ticket.template_btn": "Example",
      "customer_portal.new_ticket.view_ticket": "View ticket",
      "customer_portal.no_attachments": "Keine Anhänge vorhanden.",
      "customer_portal.no_tickets_create_desc": "Create your first ticket.",
      "customer_portal.no_tickets_filter_desc": "Try a different filter.",
      "customer_portal.no_tickets_search_desc": "Try a different search term.",
      "customer_portal.no_tickets_title": "No tickets found",
      "customer_portal.pagination_of": "von",
      "customer_portal.password.btn": "Change password",
      "customer_portal.password.cancel": "Cancel",
      "customer_portal.password.changing": "Changing...",
      "customer_portal.password.confirm": "Confirm new password",
      "customer_portal.password.current": "Current password",
      "customer_portal.password.error_change": "Error while changing the password.",
      "customer_portal.password.error_min_length": "At least 8 characters.",
      "customer_portal.password.error_mismatch": "Passwords do not match.",
      "customer_portal.password.error_same": "The new password must be different.",
      "customer_portal.password.logout": "Sign out",
      "customer_portal.password.mismatch_warning": "Passwords do not match",
      "customer_portal.password.must_change_desc": "Please change your password before you continue.",
      "customer_portal.password.new": "New password (min. 8 characters)",
      "customer_portal.password.redirecting": "You are being redirected...",
      "customer_portal.password.success": "Password changed successfully!",
      "customer_portal.password.title": "Change password",
      "customer_portal.priority_help.high": "Mehrere Mitarbeitende oder eine wichtige Funktion sind stark beeinträchtigt. Es gibt keine praktikable Ausweichlösung, der übrige Betrieb läuft jedoch weiter.",
      "customer_portal.priority_help.low": "Kleine Einschränkung oder allgemeine Frage. Sie können normal weiterarbeiten, zum Beispiel bei einem Darstellungsfehler oder einem Änderungswunsch.",
      "customer_portal.priority_help.medium": "Die Arbeit ist eingeschränkt, aber eine Ausweichlösung ist möglich. Beispiel: Ein Drucker fällt aus, ein anderer kann genutzt werden.",
      "customer_portal.priority_help.urgent": "Der Betrieb oder ein geschäftskritischer Prozess steht still. Es gibt keine Ausweichlösung, zum Beispiel bei einem vollständigen Ausfall des zentralen Systems. Bitte nicht nur wegen eines persönlichen Wunschtermins wählen.",
      "customer_portal.processing_time": "Handling time",
      "customer_portal.profile.cancel": "Cancel",
      "customer_portal.profile.change_password_btn": "Change password",
      "customer_portal.profile.change_photo": "Profilbild ändern",
      "customer_portal.profile.closed": "Closed",
      "customer_portal.profile.company": "Company",
      "customer_portal.profile.company_account": "Company & account",
      "customer_portal.profile.days_count": "{{count}} business day(s)",
      "customer_portal.profile.department": "Department",
      "customer_portal.profile.edit": "Edit",
      "customer_portal.profile.email": "Email",
      "customer_portal.profile.error_save": "Error while saving",
      "customer_portal.profile.error_upload": "Error while uploading",
      "customer_portal.profile.first_name": "First name",
      "customer_portal.profile.first_response": "First response",
      "customer_portal.profile.hours_count": "{{count}} hrs",
      "customer_portal.profile.last_name": "Last name",
      "customer_portal.profile.loading": "Loading profile...",
      "customer_portal.profile.location": "Location",
      "customer_portal.profile.member_since": "Member since",
      "customer_portal.profile.minutes_count": "{{count}} min",
      "customer_portal.profile.mobile": "Mobile",
      "customer_portal.profile.mobile_placeholder": "e.g. +49 170 12345",
      "customer_portal.profile.open": "Open",
      "customer_portal.profile.personal_data": "Personal details",
      "customer_portal.profile.phone": "Phone",
      "customer_portal.profile.phone_placeholder": "e.g. +49 221 12345",
      "customer_portal.profile.position": "Job title",
      "customer_portal.profile.resolution": "Resolution",
      "customer_portal.profile.save": "Save",
      "customer_portal.profile.security": "Security",
      "customer_portal.profile.security_desc": "Change your password regularly for better security.",
      "customer_portal.profile.service_level": "Service level",
      "customer_portal.profile.show_dashboard": "Show dashboard",
      "customer_portal.profile.sla_tier": "SLA tier",
      "customer_portal.profile.sso_active": "SSO authentication active",
      "customer_portal.profile.success_photo": "Profile picture updated",
      "customer_portal.profile.success_update": "Profile updated successfully",
      "customer_portal.profile.ticket_overview": "Ticket overview",
      "customer_portal.profile.total": "Total",
      "customer_portal.reopen": "Reopen",
      "customer_portal.reopen_failed": "The ticket could not be reopened.",
      "customer_portal.reopen_ticket": "Reopen ticket",
      "customer_portal.replies_load_failed": "Ältere Antworten konnten nicht geladen werden.",
      "customer_portal.reply_btn": "Reply",
      "customer_portal.reply_failed": "Your reply could not be sent. Please try again.",
      "customer_portal.reply_plural": "Replies",
      "customer_portal.reply_singular": "Reply",
      "customer_portal.request_badge": "Request",
      "customer_portal.requests.attachments": "Attachments",
      "customer_portal.requests.category": "Category",
      "customer_portal.requests.description": "Description",
      "customer_portal.requests.priority": "Priority",
      "customer_portal.search_label": "Tickets suchen",
      "customer_portal.search_placeholder": "Search ticket no. or subject...",
      "customer_portal.sending": "Sending...",
      "customer_portal.service_level": "Service level",
      "customer_portal.show_older_replies": "Show {{count}} older replies...",
      "customer_portal.sla.met": "Met",
      "customer_portal.sla.on_track": "On track",
      "customer_portal.sla.overdue": "Overdue",
      "customer_portal.sla.warning": "Due soon",
      "customer_portal.source": "Source",
      "customer_portal.source_portal": "Portal",
      "customer_portal.stop_impersonation": "End impersonation",
      "customer_portal.support_team": "Support team",
      "customer_portal.ticket_closed_desc": "This ticket is closed.",
      "customer_portal.ticket_load_failed": "Ticket konnte nicht geladen werden",
      "customer_portal.ticket_load_failed_desc": "Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "customer_portal.ticket_not_found": "Ticket not found",
      "customer_portal.ticket_owner": "Ihr zuständiger Support-Agent",
      "customer_portal.ticket_plural": "Tickets",
      "customer_portal.ticket_singular": "Ticket",
      "customer_portal.tickets_load_failed": "Tickets konnten nicht geladen werden",
      "customer_portal.tickets_load_failed_desc": "Ihre Daten wurden nicht verändert.",
      "customer_portal.times_title": "Times",
      "customer_portal.unassigned_owner": "Noch nicht zugewiesen",
      "customer_portal.unsaved_warning": "Ihr nicht gesendeter Entwurf geht beim Verlassen möglicherweise verloren.",
      "customer_portal.updated": "Updated",
      "customer_portal.via_email": "by email",
      "customer_portal.write_reply": "Write a reply",
      "customer_portal.you": "You",
      "customer_tickets_summary": "{{open}} open / {{total}} total",
      "customers": "Customers",
      "customize": "Customize",
      "dark_mode": "Dark Mode",
      "dashboard": "Dashboard",
      "dashboard_sub": "Here are your operational KPIs, SLA states, and ticket statistics.",
      "days_ago": "{{count}}d ago",
      "delete": "Delete",
      "density": "Density:",
      "density_comfort_label": "Komfort",
      "density_comfortable": "Comfortable",
      "density_compact": "Compact",
      "density_spacious": "Spacious",
      "density_standard_label": "Standard",
      "device_actions": "Geräte & Lizenzen",
      "device_actions_hint": "Fernwartung, Remote-Terminal, Behebung und Lizenzen der verknüpften Geräte",
      "document.all": "All",
      "document.category.certificate": "Certificate",
      "document.category.contract": "Contract",
      "document.category.correspondence": "Correspondence",
      "document.category.general": "General",
      "document.category.invoice": "Invoice",
      "document.category.manual": "Guide",
      "document.category.report": "Report",
      "document.none_found": "No documents found",
      "document.none_found_desc": "Try a different search term",
      "document.none_shared": "No documents shared with you yet",
      "document.none_shared_desc": "Your contact person can provide documents for you here",
      "document.plural": "Documents",
      "document.search_placeholder": "Search documents...",
      "document.singular": "Document",
      "document.subtitle": "Your shared documents, contracts and records",
      "document.total_suffix": "in total",
      "domains": "Domains",
      "draft_present": "Draft",
      "draft_saved": "Draft saved",
      "drag_to_move": "{{label}} (drag to move)",
      "drag_to_sort": "Drag to reorder, click to toggle visibility",
      "duration": "Duration (min.)",
      "duration_minutes": "{{count}} Minutes",
      "edit": "Edit",
      "edit_customer": "Edit Customer",
      "edit_master_data_admin": "Edit master data in administration",
      "edit_widgets_title": "Show & Order Widgets",
      "email": "Email",
      "email_channel": "Email Channel",
      "employee_form.account_erstellt": "Account created:",
      "employee_form.bitte_zuerst_kunde_auswaehlen": "Select a customer first",
      "employee_form.dieser_mitarbeiter_hat_noch_keinen_zugang_zu": "This employee does not have access to the customer portal yet. Create an account with a password.",
      "employee_form.domain_waehlen": "Select domain",
      "employee_form.domains_werden_geladen": "Loading domains...",
      "employee_form.e_mail_server_nicht_konfiguriert": "Email server not configured",
      "employee_form.initialpasswort_vergeben": "Set an initial password...",
      "employee_form.interne_notizen_zum_mitarbeiter": "Internal notes on the employee...",
      "employee_form.kein_portal_zugang_vorhanden": "No portal access",
      "employee_form.keine_domains_fuer_diesen_kunden_hinterlegt": "No domains on record for this customer.",
      "employee_form.kunde_auswaehlen": "Select customer",
      "employee_form.lade_account_informationen": "Loading account information...",
      "employee_form.leer_lassen_wenn_kein_portal_zugang_benoetig": "Leave empty if no portal access is required (e.g. with SSO).",
      "employee_form.letzter_login": "Last login:",
      "employee_form.neues_passwort": "New password...",
      "employee_form.neues_passwort_min_8_zeichen": "New password (min. 8 characters)",
      "employee_form.passwort_fuer_neuen_account_min_8_zeichen": "Password for the new account (min. 8 characters)",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge": "Force password change at first login",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge_2": "Force password change at first login",
      "employee_form.passwortaenderung_beim_naechsten_login_erzwi": "Force password change at next login",
      "employee_form.profilbild_kann_nach_dem_erstellen_hochgelad": "The profile picture can be uploaded after creation.",
      "employee_form.pw_aenderung_ausstehend": "Password change pending",
      "employee_form.reset_link_24h_gueltig": "Reset link (valid for 24h):",
      "employee_form.tab_access": "Customer portal",
      "employee_form.tab_it": "IT & workplace",
      "employee_form.tab_notes": "Notes",
      "employee_form.tab_personal": "Personal",
      "employee_form.tab_work": "Work & contact",
      "employee_form.weitere_it_informationen_wie_betriebssystem": "Further IT information such as operating system, installed software, etc. can be stored in the notes.",
      "employee_form.z_b_koeln_buero_3_og": "e.g. Cologne, office 3rd floor",
      "employees": "Employees",
      "employees_ca": "Employees (approx.)",
      "end_edit": "Finish Editing",
      "enter_title_error": "Please enter a title.",
      "escalate": "Escalate",
      "escalated": "Escalated",
      "escalated_badge": "Escalated",
      "expand_sidebar": "Expand sidebar",
      "expired": "Expired",
      "expires_at": "Expires at",
      "expiring_soon": "Expiring soon",
      "export_csv": "CSV File",
      "export_pdf": "PDF Document",
      "export_png": "PNG Chart",
      "export_xlsx": "Excel (XLSX)",
      "filter_active": "Filter active",
      "filter_all_az": "All A–Z",
      "filter_list_placeholder": "Filter list...",
      "filter_open_first": "Open first",
      "filter_open_only": "Only with open",
      "filter_with_sla": "With SLA tier",
      "first_post_attachments": "Attachments to the first post",
      "first_response": "First Response",
      "follow_ups": "Awaiting Customer",
      "generating": "Generating...",
      "greeting_day": "Good day, {{name}} 👋",
      "held_review": "Review required",
      "high_priority": "High Priority",
      "hours": "Hours",
      "hours_ago": "{{count}}h ago",
      "inactive": "Inactive",
      "included_hours": "Incl. Hours",
      "industry": "Industry",
      "internal": "Internal",
      "internal_chat": "Internal Chat",
      "internal_note": "Internal note",
      "internal_notes": "Internal Notes",
      "internal_notes_placeholder": "Internal notes about the customer...",
      "invalid_datetime_error": "Invalid date or time.",
      "just_now": "Just now",
      "kb.all_articles": "All articles",
      "kb.author": "Author",
      "kb.back_to_overview": "Back to overview",
      "kb.browse_more": "← Browse more articles",
      "kb.no_articles": "No knowledge base articles available yet",
      "kb.no_articles_desc": "Helpful articles will appear here soon",
      "kb.pinned": "Pinned",
      "kb.read_time": "{{count}} min read",
      "kb.search_placeholder": "What are you looking for? e.g. VPN, password, email...",
      "kb.subtitle": "Guides, tips and help for your questions",
      "kb.try_different_search": "Try a different search term",
      "kb.updated_at": "Updated on {{date}}",
      "kb.views_count": "{{count}} views",
      "keyboard_shortcuts": "Keyboard Shortcuts",
      "knowledge": "Knowledge Base",
      "knowledge_base": "Knowledge Base",
      "kpi_held": "Sender unclear",
      "kpi_important": "important",
      "kpi_open": "open",
      "kpi_sla_breached": "SLA Breach",
      "kunde_loeschen.artikel": "Wissensartikel",
      "kunde_loeschen.bestaetigung_label": "Zur Bestätigung den Firmennamen eingeben",
      "kunde_loeschen.connectoren": "Connectoren",
      "kunde_loeschen.dokumente": "Dokumente",
      "kunde_loeschen.einleitung": "Dieser Kunde hat keine Tickets und keine Rechnungen. Er kann vollständig entfernt werden — mitsamt seinem Mandantenbereich in der Datenbank. Das lässt sich nicht rückgängig machen.",
      "kunde_loeschen.endgueltig_loeschen": "Endgültig löschen",
      "kunde_loeschen.fehlgeschlagen": "Das Löschen ist fehlgeschlagen.",
      "kunde_loeschen.geraete": "Geräte im Inventar",
      "kunde_loeschen.lizenzen": "Softwarelizenzen",
      "kunde_loeschen.mitarbeiter": "Mitarbeiter",
      "kunde_loeschen.netzgeraete": "Gefundene Netzwerkgeräte",
      "kunde_loeschen.nichts_dran": "An diesem Kunden hängen keine weiteren Daten.",
      "kunde_loeschen.portalbenutzer": "Portalzugänge",
      "kunde_loeschen.pruefung_fehlgeschlagen": "Die Prüfung ist fehlgeschlagen.",
      "kunde_loeschen.titel": "Kunde endgültig löschen",
      "kunde_loeschen.tokens": "API-Token",
      "kunde_loeschen.vertraege": "Verträge",
      "kunde_loeschen.wird_geprueft": "Wird geprüft …",
      "kunde_loeschen.wird_mitgeloescht": "Wird mitgelöscht",
      "kunde_loeschen.zeiten": "Zeiteinträge",
      "language": "Language",
      "license.cluster_audit": "Audit",
      "license.cluster_balance": "Balance",
      "license.cluster_calc": "Calculators",
      "license.cluster_contracts": "Contracts & Licenses",
      "license.cluster_optimize": "Optimization",
      "license.tab_ad_coupling": "CAL-AD Coupling",
      "license.tab_cal_calc": "CAL calculator",
      "license.tab_catalog": "Software Catalog",
      "license.tab_contracts": "Contracts",
      "license.tab_dashboard": "License Balance & Trend",
      "license.tab_licenses": "License Management",
      "license.tab_more_views": "More Views",
      "license.tab_reclaims": "Optimization & Reclaims",
      "license.tab_remediation": "Remediation",
      "license.tab_sealed": "Audit Archive",
      "license.tab_sql_calc": "SQL license calculator",
      "license.tab_steering": "Control",
      "license.tab_suite_config": "Suite Configurator",
      "license_compliance.actions": "Actions",
      "license_compliance.assign_license_metric": "Assign license metric",
      "license_compliance.confirm_delete_assignment": "Really delete this assignment?",
      "license_compliance.confirm_delete_contract": "Really delete this contract? Linked licenses are kept but detached from the contract.",
      "license_compliance.contract_expiry_alert": "Contract expiry",
      "license_compliance.deficit_forecast_desc": "Based on live scans, back payment fees will be due on the anniversary date for under-licensed products.",
      "license_compliance.edit_contract": "Edit contract",
      "license_compliance.edit_license": "Edit license",
      "license_compliance.expired_contracts_title": "Expired software contracts detected!",
      "license_compliance.expired_contracts_warning_desc": "Licenses assigned to these contracts are ignored in the compliance calculation.",
      "license_compliance.forecasted_payment": "Forecast back payment",
      "license_compliance.license_deficit_alert": "License deficit",
      "license_compliance.mark_license_required_btn": "Mark as license-required",
      "license_compliance.new_contract": "Create new contract",
      "license_compliance.new_license": "Create new license",
      "license_compliance.no_deficit_desc": "Congratulations! Your Microsoft Core/CAL assignments cover all scan findings.",
      "license_compliance.not_catalogued": "Not catalogued",
      "license_compliance.reconciliation_desc": "Triggers a manual reconciliation run for this tenant. Recalculates VM stacking, WMI discovery states, Software Assurance periods and contract validity live.",
      "license_compliance.reconciliation_running": "Reconciliation running...",
      "license_compliance.run_reconciliation": "Run reconciliation",
      "license_compliance.sam_warnings_title": "SAM warnings & compliance",
      "license_compliance.save_contract": "Save contract",
      "license_compliance.save_license": "Save license",
      "license_compliance.seal_audit": "Seal audit",
      "license_compliance.seal_audit_btn": "Seal legally binding",
      "license_compliance.sealing": "Sealing...",
      "license_compliance.toast.add_suite_component_error": "Error assigning the suite component",
      "license_compliance.toast.assignment_completed": "License assignment completed successfully.",
      "license_compliance.toast.assignment_error": "Error performing the assignment",
      "license_compliance.toast.bulk_classify_error": "Error during bulk classification",
      "license_compliance.toast.bulk_classify_success": "{{count}} software entries classified successfully.",
      "license_compliance.toast.calc_audit_error": "Error calculating the license audit",
      "license_compliance.toast.contract_created": "Contract created successfully.",
      "license_compliance.toast.contract_deleted": "Contract deleted.",
      "license_compliance.toast.contract_updated": "Contract updated successfully.",
      "license_compliance.toast.create_purchase_req_error": "Error creating the purchase request",
      "license_compliance.toast.delete_contract_error": "Error deleting the contract",
      "license_compliance.toast.delete_license_error": "Error deleting the license",
      "license_compliance.toast.delete_suite_component_error": "Error deleting the assignment",
      "license_compliance.toast.license_created": "License created successfully.",
      "license_compliance.toast.license_deleted": "License deleted.",
      "license_compliance.toast.license_updated": "License updated successfully.",
      "license_compliance.toast.load_customers_error": "Error loading the customer list",
      "license_compliance.toast.purchase_req_created": "Purchase request for {{units}}x {{model}} (true-up: {{cost}}) created as ticket {{ticket}}.",
      "license_compliance.toast.reconcile_completed": "Reconciliation completed successfully. Compliance metrics were recalculated live.",
      "license_compliance.toast.reconcile_error": "Error during reconciliation",
      "license_compliance.toast.sam_settings_saved": "SAM settings saved successfully.",
      "license_compliance.toast.save_contract_error": "Error saving the contract",
      "license_compliance.toast.save_license_error": "Error saving the license",
      "license_compliance.toast.save_sam_settings_error": "Error saving the SAM settings",
      "license_compliance.toast.seal_audit_error": "Error sealing the license audit",
      "license_compliance.toast.seal_audit_success": "License audit sealed successfully.",
      "license_compliance.toast.suite_component_added": "Component assigned to the suite successfully.",
      "license_compliance.toast.suite_component_deleted": "Assignment deleted.",
      "license_compliance.toast.uninstall_error": "Error triggering the uninstalls",
      "license_compliance.toast.uninstall_triggered": "Uninstall commands queued.",
      "license_compliance.update_contract": "Update contract",
      "license_compliance.update_license": "Update license",
      "licenses": "Licenses",
      "light_mode": "Light Mode",
      "link_asset_btn": "+ Link Asset",
      "live_activity": "Live Activity",
      "loading": "Wird geladen…",
      "loading_ellipsis": "Loading...",
      "location_on_map": "Location on Map",
      "login.abbrechen": "Cancel",
      "login.administratoradresse_konnte_nicht_geaendert_werden": "Die Administratoradresse konnte nicht geändert werden.",
      "login.adresse_aendern": "Adresse ändern",
      "login.adresse_wird_geaendert": "Adresse wird geändert…",
      "login.aendern": "Change",
      "login.aktivierung": "Activating…",
      "login.aktivierung_fehlgeschlagen_code_pruefen": "Activation failed. Please check the code.",
      "login.alle_rechte_vorbehalten": "· All rights reserved.",
      "login.anmelden": "Sign in",
      "login.anmelden_laeuft": "Signing in…",
      "login.anmeldung": "Signing in…",
      "login.bestaetigen": "Confirm",
      "login.bitte_geben_sie_eine_gueltige_e_mail_adresse": "Please enter a valid email address.",
      "login.bitte_geben_sie_ihr_passwort_ein": "Please enter your password.",
      "login.bitte_geben_sie_zuerst_ihre_e_mail_adresse_e": "Please enter your email address first.",
      "login.claim": "Service desk, assets and licences — one data source, one process.",
      "login.datenschutz": "Privacy",
      "login.e_mail_adresse_erfolgreich_geaendert": "E-Mail-Adresse erfolgreich geändert. Melden Sie sich jetzt mit der neuen Adresse an.",
      "login.ein_fehler_ist_aufgetreten": "An error occurred.",
      "login.einloggen_schliessen": "Log in & close",
      "login.erstanmeldung": "First sign-in:",
      "login.falls_ein_konto_existiert_wurde_eine_e_mail": "If an account exists, a reset email has been sent.",
      "login.fehler_beim_laden_des_mfa_setups": "Could not load the MFA setup",
      "login.fehler_beim_ueberpruefen_der_e_mail_adresse": "Could not check the email address.",
      "login.geben_sie_den_6_stelligen_code_aus_ihrer_aut": "Enter the 6-digit code from your authenticator app or a recovery code.",
      "login.geschaeftliche_e_mail": "Work email",
      "login.ihr_account_ist_deaktiviert": "Your account is deactivated.",
      "login.ihr_administrator_erfordert_die_einrichtung": "Your administrator requires two-factor authentication to be set up.",
      "login.impressum": "Legal notice",
      "login.kunden_account_erkannt": "Customer account detected",
      "login.manueller_schluessel": "Manual key",
      "login.melden_sie_sich_an_ihrem_service_desk_an": "Sign in to your service desk.",
      "login.mfa_aktivieren_weiter": "Enable MFA & continue",
      "login.mfa_einrichtung_erforderlich": "MFA setup required",
      "login.mfa_einrichtung_fehlgeschlagen": "MFA setup failed.",
      "login.mfa_erfolgreich_aktiviert": "MFA enabled successfully",
      "login.neue_geschaeftliche_e_mail": "Neue geschäftliche E-Mail",
      "login.oder": "OR",
      "login.passwort": "Password",
      "login.qr_code_fuer_die_authenticator_app": "QR code for the authenticator app",
      "login.sechsstelliger_verifizierungscode": "6-digit verification code",
      "login.sende": "Sending…",
      "login.sicherheitszeile": "AES-256 · Two-factor · Self-hosted",
      "login.sicherheitszeile_kurz": "AES-256 · Zwei-Faktor",
      "login.sie_werden_automatisch_zum_kundenportal_weit": "You are being redirected to the customer portal to sign in there...",
      "login.single_sign_on_entra_id": "Single Sign-On (Entra ID)",
      "login.speichern_sie_diese_einmal_wiederherstellung": "Store these one-time recovery codes safely. You can use them if you lose access to your app.",
      "login.sso_anmeldung_fehlgeschlagen": "SSO sign-in failed",
      "login.startkonto_bestaetigt_adresse_festlegen": "Die Zugangsdaten des Startkontos wurden bestätigt. Legen Sie jetzt die geschäftliche Adresse für den Administrator fest.",
      "login.ueberpruefe": "Verifying...",
      "login.ungueltiger_oder_abgelaufener_mfa_code": "Invalid or expired MFA code.",
      "login.verifiziere": "Verifying…",
      "login.weiter": "Continue",
      "login.willkommen_zurueck": "Welcome back",
      "login.zurueck_zum_login": "Back to login",
      "login.zuruecksetzen": "Reset",
      "login.zwei_faktor_code_totp": "Two-factor code (TOTP)",
      "logout": "Logout",
      "main_navigation_rail": "Main navigation rail",
      "managing_director": "Managing Director",
      "managing_director_abbrev": "MD",
      "managing_director_prefix": "Managing Director:",
      "mark_all_read": "Mark all as read",
      "mark_as_resolved": "Mark as resolved",
      "mati.connection_error": "Connection error",
      "mati.delete": "Delete",
      "mati.error_failed_connection": "Connection to the AI service failed.",
      "mati.error_generation": "Error generating the response. Please try again.",
      "mati.gdpr_warning": "GDPR filter active: personal data is anonymised automatically before transmission.",
      "mati.greeting": "Hi {{name}}! I'm {{mascot}}. How can I support you with your work today? 🔮\\n\\nYou can ask me about:\\n- System status or agent workload\\n- Ticket searches (\"Find unresolved tickets with high priority\")\\n- Creating tickets (\"Create ticket: printer cartridge empty on the 2nd floor\")",
      "mati.history": "History",
      "mati.input_placeholder": "Ask me about tickets, workload, or create a ticket...",
      "mati.new_chat": "New chat",
      "mati.online_intelligent": "Online & intelligent",
      "mati.rename": "Rename",
      "mati.restore_bead": "Show floating helper",
      "mati.restore_bead_tooltip": "Show the floating helper (bead) at the edge of the screen again",
      "mati.send_btn": "Send",
      "mati.suggest.create_ticket.desc": "Printer on the 1st floor broken",
      "mati.suggest.create_ticket.prompt": "Create a ticket for a broken printer on the 1st floor, priority medium.",
      "mati.suggest.create_ticket.title": "Create ticket",
      "mati.suggest.search_tickets.desc": "Search query \"database\"",
      "mati.suggest.search_tickets.prompt": "Find tickets that contain the word \"database\".",
      "mati.suggest.search_tickets.title": "Search tickets",
      "mati.suggest.support_help.desc": "Help with FAQ drafts",
      "mati.suggest.support_help.prompt": "How do I write a friendly rejection of a refund request?",
      "mati.suggest.support_help.title": "Support help",
      "mati.suggest.system_status.desc": "Show current workload",
      "mati.suggest.system_status.prompt": "Show me the current system status and an overview of agent workload.",
      "mati.suggest.system_status.title": "System status",
      "mati.typing_text": "{{name}} is typing...",
      "mati.welcome_subtitle": "I'm your intelligent AI copilot. I can help you manage tickets, search the system, or review system statistics.",
      "mati.welcome_title": "Hi! I'm {{name}}",
      "mati_gdpr_warning": "GDPR filter active: Personal data is automatically anonymized before transmission.",
      "mati_placeholder": "Ask me anything about tickets, workload, or create a ticket...",
      "mati_welcome": "Hello! I am {{name}}",
      "meeting_error_title": "Could not create Teams meeting.",
      "meeting_success": "Teams meeting created.",
      "meeting_success_copy": "Teams meeting created, link copied to clipboard.",
      "megamenu.active_label": "Workbench",
      "megamenu.calendar_desc": "Appointments and calendar integration.",
      "megamenu.licenses_desc": "License compliance, suites & true-up planning.",
      "megamenu.modules": "Modules",
      "megamenu.open_calendar": "Open calendar",
      "megamenu.open_licenses": "Open licenses",
      "megamenu.open_problems": "Open problems",
      "megamenu.problems_desc": "Problem management & RCA (root cause analysis).",
      "megamenu.quick_search_commands": "Quick search & commands",
      "merge": "Zusammenführen",
      "merge_tickets": "Die beiden markierten Tickets zusammenführen",
      "mfa_settings": "MFA Settings",
      "minutes_ago": "{{count}}m ago",
      "mloffice.abgleich_fehler": "Abgleich konnte nicht gestartet werden.",
      "mloffice.abgleich_fehlgeschlagen": "Letzter Abgleich fehlgeschlagen: {{fehler}}",
      "mloffice.abgleich_gestartet": "Voll-Abgleich gestartet.",
      "mloffice.abgleich_laeuft": "Abgleich läuft",
      "mloffice.adresse": "MLOffice-Adresse",
      "mloffice.adresse_hinweis": "Basisadresse der MLOffice-Installation — ohne /api/v1.",
      "mloffice.agenten_titel": "Agenten ↔ MLOffice-Benutzer",
      "mloffice.aktion_anlegen": "Neu anlegen",
      "mloffice.aktion_entkoppeln": "Entkoppeln",
      "mloffice.aktion_entkoppeln_hinweis": "Aus dem Abgleich nehmen — der Kunde bleibt bestehen und wird wieder editierbar.",
      "mloffice.aktion_verknuepfen": "Verknüpfen",
      "mloffice.aktiv": "Aktiv",
      "mloffice.aktivieren": "Anbindung aktiv",
      "mloffice.auswahl_fehler": "Auswahl konnte nicht gespeichert werden.",
      "mloffice.bereits_uebertragen": "{{n}} Einträge im Zeitraum sind bereits übertragen und werden übersprungen.",
      "mloffice.email_eingeben": "Der Partner hat in MLOffice keine E-Mail-Adresse. E-Mail für den neuen Kunden:",
      "mloffice.entwurf_anlegen": "Entwurf anlegen",
      "mloffice.entwurf_fehler": "Entwurf konnte nicht angelegt werden.",
      "mloffice.entwurf_hinweis": "Erzeugt aus den bereits übertragenen Zeiten des Zeitraums einen ENTWURF in MLOffice. Belegnummer, Festschreibung und Versand bleiben MLOffice vorbehalten.",
      "mloffice.entwurf_ok": "Entwurf über {{h}} h in MLOffice angelegt — Festschreiben und Versand dort.",
      "mloffice.entwurf_titel": "Rechnungsentwurf in MLOffice",
      "mloffice.ereignis_closed": "Ticket geschlossen",
      "mloffice.ereignis_created": "Ticket eröffnet",
      "mloffice.ereignis_escalated": "Ticket eskaliert",
      "mloffice.ereignisse_titel": "Ticket-Ereignisse in die MLOffice-Kontakthistorie melden (nur Referenz, nie Inhalt):",
      "mloffice.erst_aktivieren": "Bitte zuerst die Anbindung aktivieren und die Verbindung testen — dann erscheint hier der MLOffice-Kundenbestand.",
      "mloffice.erst_aktivieren_abrechnung": "Bitte zuerst die Anbindung aktivieren — dann erscheinen hier offene Posten und der Kontingent-Abgleich.",
      "mloffice.erst_aktivieren_zeiten": "Bitte zuerst die Anbindung aktivieren — dann lassen sich Zeiten per Übertragungslauf nach MLOffice geben.",
      "mloffice.fallback_hinweis": "{{n}} Einträge ohne Agenten-Zuordnung werden über den technischen Benutzer gebucht (Agentenname in der Beschreibung).",
      "mloffice.feld_bis": "Bis",
      "mloffice.feld_kunde": "Kunde",
      "mloffice.feld_projekt": "MLOffice-Projekt",
      "mloffice.feld_satz": "Stundensatz (netto)",
      "mloffice.feld_von": "Von",
      "mloffice.gespeichert": "MLOffice-Einstellungen gespeichert.",
      "mloffice.gueltig_180": "180 Tage",
      "mloffice.gueltig_365": "365 Tage",
      "mloffice.gueltig_90": "90 Tage",
      "mloffice.gueltig_unbegrenzt": "Unbegrenzt",
      "mloffice.hoheit_frage": "MLOffice übernimmt die Hoheit über: {{felder}}.\\n\\nDiese Felder sind in AISupportDesk dann gesperrt und werden fortlaufend aus MLOffice übernommen. Fortfahren?",
      "mloffice.inaktiv": "Inaktiv",
      "mloffice.keine_partner": "Noch keine MLOffice-Kunden geladen. „Liste aus MLOffice laden“ holt den Bestand.",
      "mloffice.keine_zuordnung": "— keine Zuordnung —",
      "mloffice.konflikt_fehler": "Konnte nicht übernommen werden.",
      "mloffice.konflikt_geloest": "Übernommen.",
      "mloffice.konflikt_hinweis": "Übernahme braucht eine Entscheidung — siehe Konfliktzeile.",
      "mloffice.kopieren": "Kopieren",
      "mloffice.kunde_waehlen": "— Kunde wählen —",
      "mloffice.kunden_erklaerung": "Wähle aus, welche MLOffice-Kunden hier geführt werden. Ausgewählte Kunden werden fortlaufend abgeglichen; ihre Stammdaten sind hier gesperrt. Abwählen entkoppelt nur — der Kunde bleibt bestehen.",
      "mloffice.laden_fehler": "MLOffice-Einstellungen konnten nicht geladen werden.",
      "mloffice.laeufe_titel": "Bisherige Übertragungsläufe",
      "mloffice.lauf_detail": "Lauf #{{id}} — Einzelposten",
      "mloffice.lauf_fehler": "Lauf konnte nicht gestartet werden.",
      "mloffice.lauf_fertig": "Fertig",
      "mloffice.lauf_gestartet": "Übertragungslauf gestartet.",
      "mloffice.lauf_laeuft": "Läuft",
      "mloffice.lauf_starten": "Übertragung starten",
      "mloffice.lauf_teilfehler": "Mit Fehlern",
      "mloffice.linktoken_abgelaufen": "Das Verbindungstoken ist abgelaufen — MLOffice kann sich nicht mehr ausweisen. Neues Token erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_ablauf_teil": ", gültig bis {{datum}}",
      "mloffice.linktoken_einmal": "Jetzt kopieren — dieses Token wird nur EINMAL angezeigt:",
      "mloffice.linktoken_eintragen": "In MLOffice unter Einstellungen → AISupportDesk-Anbindung eintragen.",
      "mloffice.linktoken_erklaerung": "Dieses Token wird HIER erzeugt und in MLOffice unter „AISupportDesk-Anbindung“ eingetragen. MLOffice weist sich damit aus (Verbindungsstatus, Webhooks). Wird die Anbindung hier gelöst oder das Token widerrufen, zeigt MLOffice die Verbindung als gelöst.",
      "mloffice.linktoken_erzeugen": "Token erzeugen",
      "mloffice.linktoken_fehler": "Verbindungstoken konnte nicht erzeugt werden.",
      "mloffice.linktoken_gueltigkeit": "Gültigkeit",
      "mloffice.linktoken_kopiert": "Token kopiert.",
      "mloffice.linktoken_laeuft_ab": "Das Verbindungstoken läuft in {{tage}} Tagen ab. Rechtzeitig neu erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_neu": "Neues Token erzeugen",
      "mloffice.linktoken_rotieren_frage": "Es existiert bereits ein Verbindungstoken. Ein neues macht das alte sofort ungültig — MLOffice muss dann das neue Token eintragen. Fortfahren?",
      "mloffice.linktoken_status": "Hinterlegt ({{hint}}), erzeugt {{erzeugt}}{{ablauf}}.",
      "mloffice.linktoken_titel": "Verbindungstoken für MLOffice",
      "mloffice.linktoken_unbegrenzt_teil": ", unbegrenzt gültig",
      "mloffice.linktoken_widerruf_fehler": "Widerruf fehlgeschlagen.",
      "mloffice.linktoken_widerruf_frage": "Verbindungstoken widerrufen? MLOffice zeigt die Verbindung danach als gelöst; Webhooks und Statusabfragen von MLOffice werden abgewiesen.",
      "mloffice.linktoken_widerrufen": "Verbindungstoken widerrufen.",
      "mloffice.linktoken_widerrufen_btn": "Widerrufen",
      "mloffice.liste_aktualisieren": "Liste aus MLOffice laden",
      "mloffice.loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "mloffice.nur_verknuepfte": "Nur mit MLOffice verknüpfte Kunden.",
      "mloffice.ohne_email": "ohne E-Mail",
      "mloffice.op_aktualisiert": "Offene Posten aktualisiert.",
      "mloffice.op_belege": "Belege",
      "mloffice.op_fehler": "Offene Posten konnten nicht geladen werden.",
      "mloffice.op_laden": "Offene Posten aus MLOffice laden",
      "mloffice.op_stand": "Stand: {{zeit}}",
      "mloffice.op_titel": "Offene Posten (MLOffice)",
      "mloffice.partner_laden_fehler": "MLOffice-Kundenliste konnte nicht geladen werden.",
      "mloffice.posten_ok": "übertragen",
      "mloffice.posten_retry": "Erneut",
      "mloffice.posten_skip": "Überspringen",
      "mloffice.projekt_pflicht": "Bitte oben ein MLOffice-Projekt wählen.",
      "mloffice.projekt_waehlen": "— Projekt wählen —",
      "mloffice.rechte_fehlen": "Dem Token fehlen Rechte:",
      "mloffice.recon_asd": "Support-Sicht (NALVRA SERVICE)",
      "mloffice.recon_diff": "Abweichung Support- zu Abrechnungs-Sicht: {{min}} Min.",
      "mloffice.recon_gebucht": "{{min}} Min. im Projekt „{{projekt}}“ gebucht",
      "mloffice.recon_gesperrt_bis": "Erfassung gesperrt bis: {{d}}",
      "mloffice.recon_kein_projekt": "Kein MLOffice-Projekt zugeordnet (Tab „Zuordnung“).",
      "mloffice.recon_kein_vertrag": "Kein aktiver Vertrag mit Kontingent für diesen Kunden.",
      "mloffice.recon_mlo": "Abrechnungs-Sicht (MLOffice)",
      "mloffice.recon_offen": "{{min}} Min. der laufenden Periode sind noch nicht an MLOffice übertragen — Übertragungslauf im Tab „Zeiten-Übertragung“ starten.",
      "mloffice.recon_titel": "Kontingent-Abgleich",
      "mloffice.recon_verbrauch": "{{used}} von {{incl}} Min. verbraucht — {{rest}} Min. übrig",
      "mloffice.schon_drueben": "übertragen",
      "mloffice.sp_agent": "Agent",
      "mloffice.sp_beschreibung": "Beschreibung",
      "mloffice.sp_datum": "Datum",
      "mloffice.sp_fortschritt": "Gesendet / Fehler / Gesamt",
      "mloffice.sp_kunde": "Kunde",
      "mloffice.sp_minuten": "Min.",
      "mloffice.sp_status": "Status",
      "mloffice.sp_ticket": "Ticket",
      "mloffice.sp_zeitraum": "Zeitraum",
      "mloffice.spalte_kunde": "MLOffice-Kunde",
      "mloffice.spalte_status": "Status",
      "mloffice.spalte_sync": "Sync",
      "mloffice.spalte_zuordnung": "Zuordnung in NALVRA SERVICE",
      "mloffice.speichern": "Speichern",
      "mloffice.speichern_fehler": "Speichern fehlgeschlagen.",
      "mloffice.status_archiviert": "In MLOffice archiviert",
      "mloffice.status_delta": "Letzter Kundenabgleich: {{zeit}}",
      "mloffice.status_entkoppelt": "Entkoppelt",
      "mloffice.status_failed": "{{n}} Übertragungen fehlgeschlagen",
      "mloffice.status_kein_linktoken": "Kein Verbindungstoken für MLOffice erzeugt",
      "mloffice.status_konflikt": "Entscheidung nötig",
      "mloffice.status_linktoken_abgelaufen": "Verbindungstoken abgelaufen — neu erzeugen und in MLOffice eintragen",
      "mloffice.status_neu": "Neu",
      "mloffice.status_op": "Offene Posten: {{zeit}}",
      "mloffice.status_pending": "{{n}} Übertragungen offen",
      "mloffice.status_ratelimit": "MLOffice-Ratenbegrenzung — kurze Pause",
      "mloffice.status_sync_fehler": "Letzter Abgleich mit Fehler",
      "mloffice.status_uebernommen": "Übernommen",
      "mloffice.tab_abrechnung": "Abrechnung",
      "mloffice.tab_kunden": "Kundenabgleich",
      "mloffice.tab_verbindung": "Verbindung",
      "mloffice.tab_zeiten": "Zeiten-Übertragung",
      "mloffice.tab_zuordnung": "Zuordnung",
      "mloffice.techuser_hinweis": "Wird für Zeitbuchungen ohne Agenten-Zuordnung verwendet; der Agentenname wandert dann in die Buchungsbeschreibung.",
      "mloffice.techuser_titel": "Technischer Benutzer (Fallback)",
      "mloffice.test_fehler": "Verbindungstest fehlgeschlagen.",
      "mloffice.test_nicht_verbunden": "Keine Verbindung",
      "mloffice.test_ok": "Verbindung zu MLOffice steht.",
      "mloffice.test_verbunden": "Verbunden mit Mandant „{{tenant}}“",
      "mloffice.testen": "Verbindung testen",
      "mloffice.titel": "MLOffice-Anbindung",
      "mloffice.token": "API-Token",
      "mloffice.token_gesetzt": "hinterlegt ({{hint}})",
      "mloffice.token_hinweis": "In MLOffice unter Einstellungen → API-Tokens anlegen. Benötigte Rechte prüft der Verbindungstest.",
      "mloffice.token_name": "Token: {{name}}",
      "mloffice.token_unveraendert": "Leer lassen = unverändert",
      "mloffice.untertitel": "Kundenstammdaten, Abrechnung, Zeiterfassung und CRM mit MLOffice koppeln. MLOffice ist das führende System für Stammdaten und Rechnungen.",
      "mloffice.users_dropdown": "Zeitbuchungen werden in MLOffice unter dem zugeordneten Benutzer geführt. Ohne Zuordnung greift der technische Benutzer.",
      "mloffice.users_manuell": "MLOffice stellt (noch) keine Benutzerliste bereit — MLOffice-User-UUID bitte manuell eintragen (in MLOffice unter Benutzerverwaltung kopieren).",
      "mloffice.uuid_platzhalter": "MLOffice-User-UUID",
      "mloffice.verbindung": "Verbindung",
      "mloffice.vollabgleich": "Voll-Abgleich starten",
      "mloffice.vorschau": "Vorschau",
      "mloffice.vorschau_anlegen": "Wird neu angelegt",
      "mloffice.vorschau_email_fehlt": "E-Mail fehlt — wird bei Übernahme abgefragt",
      "mloffice.vorschau_fehler": "Vorschau fehlgeschlagen.",
      "mloffice.vorschau_titel": "Vorschau: {{n}} Einträge, {{h}} h werden übertragen",
      "mloffice.vorschau_verknuepfung": "Vorschlag: mit „{{name}}“ verknüpfen ({{grund}})",
      "mloffice.zeiten_erklaerung": "Zeiten werden NICHT automatisch übertragen. Du wählst Kunde und Zeitraum, prüfst die Vorschau und bestätigst — erst dann gehen die Buchungen nach MLOffice. Übertragene Buchungen sind dort unumkehrbar und hier gesperrt.",
      "mloffice.zeitraum_bis_heute": "Bis heute",
      "mloffice.zeitraum_dieser_monat": "Dieser Monat",
      "mloffice.zeitraum_letzter_monat": "Letzter Monat",
      "mloffice.zuordnung_fehler": "Zuordnung konnte nicht gespeichert werden.",
      "mloffice.zuordnung_fehlt": "{{n}} Einträge ohne Agenten-Zuordnung — bitte unter „Zuordnung“ pflegen oder einen technischen Benutzer hinterlegen.",
      "mloffice.zuordnung_gespeichert": "Zuordnung gespeichert.",
      "mobile": "Mobile",
      "move_ticket": "Verschieben",
      "my_tickets": "My Tickets",
      "navbar_search_placeholder": "Search tickets, customers or KB...",
      "new": "New",
      "new_activity_aria": "New Activity",
      "new_activity_title": "New activity since last view",
      "new_company": "Neue Firma",
      "new_label": "New",
      "new_ticket": "New Ticket",
      "next": "Weiter",
      "no_activities_recorded": "No activity recorded yet.",
      "no_canned_responses": "No canned responses",
      "no_canned_responses_hint": "Can be managed in the administration area.",
      "no_critical_tickets": "No critical tickets",
      "no_customer_assigned": "No customer assigned",
      "no_customer_data": "No customer data loaded.",
      "no_customers_found": "No customers found",
      "no_customers_matching": "No customers could be found for your filter selection or search query.",
      "no_data_available": "No data available",
      "no_employees_found": "No employees registered",
      "no_notes_placeholder": "No notes available. Click \"Edit\" to add notes.",
      "no_notifications": "No notifications",
      "no_other_agents_online": "Currently no other team members online.",
      "no_results": "No results",
      "no_tickets_found": "No tickets found",
      "no_tickets_found_desc": "There are currently no items in this filter queue.",
      "no_tickets_risk": "Currently no tickets in the critical SLA warning window.",
      "not_spam": "Not Spam",
      "notification_settings": "Notification Settings",
      "notification_settings_desc": "Choose which notifications you want to receive.",
      "notification_settings_saved": "Notification settings saved.",
      "notifications": "Notifications",
      "notify_license_change": "License changes",
      "notify_new_reply": "New replies",
      "notify_new_ticket": "New tickets",
      "notify_status_changed": "Status changes",
      "observers_title": "Observers",
      "only_visible_for": "Only {{name}}",
      "only_visible_to_agents": "Only visible to agents",
      "open_administration": "Open Administration",
      "open_btn": "Open",
      "open_password_vault": "Open password vault in browser",
      "open_quick_search": "Open quick search",
      "open_tickets": "Open Tickets",
      "other_tickets_count": "Other Tickets ({{count}})",
      "other_tickets_requester_count": "Other tickets of the requester ({{count}})",
      "overdue": "Overdue",
      "overview_option_1": "1. Standard KPI Dashboard",
      "overview_option_10": "10. SLA Breach Rate by Priorities",
      "overview_option_2": "2. First Contact Resolution (FCR) & Response Time",
      "overview_option_3": "3. Ticket Volume Development & Peak Hours",
      "overview_option_4": "4. Resolution Rate Trends (Created vs. Resolved)",
      "overview_option_5": "5. CSAT vs. Resolution Time Matrix",
      "overview_option_6": "6. Ticket Channels & Source Breakdown",
      "overview_option_7": "7. Escalation Rates & Escalation Path Analysis",
      "overview_option_8": "8. Average Ticket Lifetime (Aging)",
      "overview_option_9": "9. Backlog Status & Aging",
      "performance_queues": "Performance & Queues",
      "phone": "Phone",
      "plan_teams_meeting": "Plan Teams meeting",
      "planning": "Planning",
      "please_enter_text": "Please enter text",
      "policy": "Policy",
      "portal_company.load_failed": "Dokumente konnten nicht geladen werden.",
      "portal_company.primary_contact": "Hauptansprechpartner",
      "portal_session.continue": "Weiterarbeiten",
      "portal_session.login": "Erneut anmelden",
      "portal_session.warning": "Ihre Sitzung endet in {{seconds}} Sekunden. Gespeicherte Entwürfe bleiben erhalten.",
      "portal_speech.denied": "Mikrofonzugriff oder Spracherkennung wurde nicht erlaubt. Bitte die Browserberechtigung prüfen.",
      "portal_speech.failed": "Spracheingabe nicht verfügbar. Bitte Mikrofon und Verbindung prüfen oder weitertippen.",
      "portal_speech.listening": "Mikrofon aktiv – bitte sprechen …",
      "portal_speech.notice": "Diktierter Text wird unten an die Beschreibung angefügt. Der Browser kann Audio zur Erkennung an seinen Sprachdienst senden.",
      "portal_speech.silence": "Keine Sprache erkannt. Bitte erneut starten.",
      "portal_speech.start": "Diktat starten",
      "portal_speech.stop": "Stoppen",
      "portal_speech.title": "Spracheingabe",
      "portal_speech.unsupported": "Dieser Browser unterstützt hier keine Spracheingabe. Sie können die Diktierfunktion Ihrer Tastatur verwenden.",
      "preview": "Preview",
      "previous": "Zurück",
      "primary": "Primary",
      "priority": "Priority",
      "priority_": "",
      "priority_critical": "Critical",
      "priority_high": "High",
      "priority_low": "Low",
      "priority_medium": "Medium",
      "priority_urgent": "Urgent",
      "problem_cascade_close_checkbox": "Yes, close all linked incidents (recommended)",
      "problem_cascade_close_desc": "There are linked open incidents. Do you want to automatically resolve them and comment with root cause & resolution?",
      "problem_cascade_close_title": "Cascade Close",
      "problem_confirm_resolve": "Confirm & Resolve",
      "problem_create_btn": "Create Problem",
      "problem_create_error": "Error creating problem",
      "problem_create_success": "Problem ticket created.",
      "problem_create_title": "Create New Problem Ticket",
      "problem_created_by_on": "Created by {{creator}} on {{date}}",
      "problem_description_label": "Problem Description",
      "problem_detail_load_error": "Error loading problem details",
      "problem_incidents_linked": "Incidents linked",
      "problem_kedb_empty": "No known errors",
      "problem_kedb_empty_desc": "Problems classified as known errors appear here with root cause and workaround.",
      "problem_kedb_load_error": "Error loading the known errors",
      "problem_kedb_search_placeholder": "Search known errors...",
      "problem_kedb_title": "Known Errors",
      "problem_known_error_badge": "Known error",
      "problem_known_error_checkbox": "Classify as Known Error",
      "problem_known_error_only": "Known errors only",
      "problem_link_btn": "Link",
      "problem_link_error": "Error linking incidents",
      "problem_link_incident_btn": "Link Incident",
      "problem_link_incidents_title": "Link Incidents",
      "problem_link_success": "Incidents linked.",
      "problem_linked_incidents": "Linked Incidents",
      "problem_load_error": "Error loading problems",
      "problem_loading": "Loading ITIL Problem Management...",
      "problem_mark_known_error": "Mark as Known Error",
      "problem_no_incidents_found": "No linked incidents found.",
      "problem_no_tickets": "No Problem Tickets",
      "problem_no_tickets_desc": "There are currently no ITIL problem tickets recorded.",
      "problem_no_unlinked_found": "No open, unlinked incidents found.",
      "problem_none": "—",
      "problem_none_selected": "No problem selected",
      "problem_none_selected_desc": "Select an ITIL problem ticket on the left or create a new one to manage RCA data.",
      "problem_open_change_confirm": "Open new change ticket {{num}} now?",
      "problem_raise_change_btn": "Raise change",
      "problem_raise_change_error": "Error raising the change",
      "problem_raise_change_success": "Change ticket created: {{num}}",
      "problem_raise_change_title": "Raise a change from this problem",
      "problem_rca_title": "ITIL Problems (RCA)",
      "problem_resolution_note": "Resolution Note",
      "problem_resolution_note_placeholder": "Enter details about the final fix...",
      "problem_resolve_btn": "Resolve Problem",
      "problem_resolve_error": "Error resolving problem",
      "problem_resolve_success": "Problem resolved.",
      "problem_root_cause_label": "Suspected Root Cause",
      "problem_root_cause_short": "Root cause",
      "problem_search_placeholder": "Search problems...",
      "problem_stage_closed": "Closed",
      "problem_stage_known_error": "Known error",
      "problem_stage_label": "Lifecycle status (problem stage)",
      "problem_stage_open": "Open",
      "problem_stage_resolved": "Resolved",
      "problem_stage_under_investigation": "Under investigation",
      "problem_stage_updated": "Lifecycle status updated.",
      "problem_stage_workaround_found": "Workaround found",
      "problem_tab_kedb": "Known Error DB (KEDB)",
      "problem_tab_problems": "Problems (RCA)",
      "problem_title": "ITIL Problem: Recurring Incident",
      "problem_title_label": "Problem Title",
      "problem_unlink_btn": "Unlink",
      "problem_unlink_error": "Error removing the link",
      "problem_unlink_success": "Link removed.",
      "problem_update_error": "Error updating problem",
      "problem_update_success": "Problem updated successfully.",
      "problem_workaround_label": "Known Workaround",
      "problem_workaround_short": "Workaround",
      "problems": "Problems",
      "queue.": "queue.",
      "queue_external_processing": "Externe Bearbeitung",
      "queues": "Queues",
      "quick_access_views": "Quick Access & Views",
      "quick_search": "Quick Search",
      "read_ticket_also": "is also reading this ticket",
      "reading_ticket": "Reading ticket #{{id}}",
      "reassign_to": "Reassign ({{name}})...",
      "recent_activities_description": "Recent ticket and reply activities for this customer.",
      "recent_tickets": "Recent Tickets",
      "refresh": "Refresh",
      "remove_assignment": "Remove assignment",
      "remove_attachment_aria": "Remove attachment {{filename}}",
      "remove_filter": "Filter entfernen",
      "reopen": "Reopen",
      "reply": "Reply",
      "reply_keyboard_shortcut_hint": "Keyboard shortcut: Ctrl or Cmd + Enter to send when cursor is in the text editor.",
      "report_active_breaches": "Active Breaches",
      "report_ai_analysis": "AI Analysis",
      "report_ai_analyzing": "AI is analyzing report data...",
      "report_ai_highlights": "Highlights",
      "report_ai_recommendations": "Recommendations",
      "report_billable": "Billable",
      "report_compliance": "Compliance",
      "report_export": "Export",
      "report_exporting": "Exporting...",
      "report_no_data": "No data available",
      "report_no_data_desc": "No report data could be loaded for this period.",
      "report_range": "Report View:",
      "report_total_time": "Total Time",
      "reports": "Reports",
      "reports_desc": "Service Management Reports & Analytics",
      "request.additional_info": "Additional details",
      "request.back_to_dashboard": "Back to dashboard",
      "request.back_to_dashboard_link": "← Dashboard",
      "request.back_to_list": "Back to overview",
      "request.back_to_requests": "← All requests",
      "request.catalog_subtitle": "Choose a request type — you will get a matching form.",
      "request.choose_files": "Choose files",
      "request.description_placeholder": "Describe your request…",
      "request.description_required": "Please enter a description.",
      "request.failed_load_catalog": "Catalog could not be loaded",
      "request.file_too_large": "File too large (max. {{max}} MB): {{name}}",
      "request.file_type_not_allowed": "Dateityp nicht erlaubt: {{name}}",
      "request.no_requests": "No service requests are enabled in the portal.",
      "request.not_available": "This request is not available or not published.",
      "request.optional_select": "— Optional —",
      "request.please_select": "— Please select —",
      "request.remove_file": "Remove",
      "request.required_field": "Required field: {{label}}",
      "request.standard_fields_info": "Standard fields: priority, category, description and attachments are included with every service request. Any additional fields for this request type follow below.",
      "request.submit_btn": "Submit request",
      "request.submit_failed": "Sending failed",
      "request.submitting_btn": "Sending…",
      "request_type": "Request Type",
      "requester_title": "Requester",
      "reset": "Reset",
      "reset_all_filters": "Alle Filter zurücksetzen",
      "reset_filter": "Reset filter",
      "reset_kpi_filter": "Kachel-Filter zurücksetzen",
      "reset_to_default": "Reset to Default",
      "resolution": "Resolution",
      "resolve": "Resolve",
      "resolved_label": "Resolved",
      "retry": "Erneut versuchen",
      "risk": "Risk",
      "risk_minutes": "{{count}} min",
      "save": "Save",
      "save_changes": "Save Changes",
      "save_note": "Save note",
      "saving": "Saving...",
      "scroll_to_reply": "Scroll to reply",
      "search": "Search...",
      "search_canned_responses": "Search canned responses…",
      "search_customers": "Search customers...",
      "select_company": "Firma auswählen…",
      "select_customer_placeholder": "Select a customer from the list",
      "self_healing": "Self-Healing",
      "send": "Send",
      "sending_ellipsis": "Sending...",
      "settings": "Settings",
      "seven_days": "7 Days",
      "shortcut_back_close": "Back / Close",
      "shortcut_escalate": "Escalate",
      "shortcut_focus_mode": "Focus Mode",
      "shortcut_help": "This help",
      "shortcut_internal_note": "Internal Note",
      "shortcut_next_prev": "Next / Previous Ticket",
      "shortcut_quick_search": "Quick Search",
      "shortcut_write_reply": "Write reply",
      "show_all": "Show All",
      "show_full_ticket_backlog": "View full ticket backlog",
      "show_older_replies": "Show {{count}} older replies...",
      "sla_and_contract_title": "SLA & Contract",
      "sla_breached_both": "Response & resolution breached",
      "sla_breached_exclamation": "SLA breached!",
      "sla_breached_resolution": "Resolution breached",
      "sla_breached_response": "Response breached",
      "sla_breaches": "SLA Breaches:",
      "sla_compliance": "SLA Compliance",
      "sla_level": "SLA Level:",
      "sla_option_1": "1. SLA Compliance & Trends (Overview)",
      "sla_option_10": "10. SLA Weekend & Holiday Statistics",
      "sla_option_2": "2. SLA Breaches & Tickets at Risk",
      "sla_option_3": "3. SLA by Priority",
      "sla_option_4": "4. SLA by Customer / Service Plan",
      "sla_option_5": "5. Response Time SLA Compliance",
      "sla_option_6": "6. Resolution Time SLA Compliance",
      "sla_option_7": "7. SLA Breaches by Agent/Group",
      "sla_option_8": "8. SLA Breach Causes",
      "sla_option_9": "9. Penalties & Credits Preview (Financial Risk)",
      "sla_performance_breaches": "SLA Performance & Breaches",
      "sla_risk": "SLA Risk",
      "sla_status_ok": "OK",
      "sort_by_label": "Sort by {{label}}",
      "spam": "Spam",
      "starred": "Starred",
      "start": "Start",
      "status": "Status",
      "status_closed": "Closed",
      "status_in_progress": "In Progress",
      "status_new": "New",
      "status_on_hold": "On hold",
      "status_open": "Open",
      "status_resolved": "Resolved",
      "status_waiting": "Waiting",
      "status_waiting_customer": "Awaiting Customer",
      "street": "Street",
      "subtasks": "Teilaufgaben",
      "supporting_agents": "Supporting Agents",
      "switch_language": "Switch Language",
      "system_logs": "System Logs",
      "tab_": "",
      "tab_activity": "Activity",
      "tab_agents": "Agents",
      "tab_assets": "Assets",
      "tab_contracts": "Contracts",
      "tab_csat": "CSAT",
      "tab_custom": "Custom Reports",
      "tab_customers": "Customers",
      "tab_documents": "Documents",
      "tab_employees": "Employees",
      "tab_incidents": "Incidents",
      "tab_licenses": "Licenses",
      "tab_notes": "Notes",
      "tab_overview": "Overview",
      "tab_sla": "SLA",
      "tab_tickets": "Tickets",
      "tab_time": "Time Tracking",
      "tab_trends": "Trends",
      "tag_add_placeholder": "Add tag...",
      "tag_label": "Tag",
      "tax_number": "Tax Number",
      "teams_call_start": "Start Teams Call",
      "teams_chat_open": "Open Teams Chat",
      "teams_meeting_subject": "Meeting {{number}}",
      "teams_meeting_title": "Teams Meeting",
      "thirty_days": "30 Days",
      "ticket_assets.action_col": "Action",
      "ticket_assets.agent_offline": "Agent offline",
      "ticket_assets.agent_ready": "Ready",
      "ticket_assets.assigned_assets": "Assets assigned to the employee",
      "ticket_assets.bios_label": "BIOS version:",
      "ticket_assets.calculating_compliance": "Calculating license audit...",
      "ticket_assets.clean_temp": "Clear temp",
      "ticket_assets.cmd_status_completed": "Done",
      "ticket_assets.cmd_status_failed": "Failed",
      "ticket_assets.cmd_status_pending": "Waiting",
      "ticket_assets.cmd_status_running": "Running...",
      "ticket_assets.cmdb_alert_desc": "This asset depends on / is connected to:",
      "ticket_assets.cmdb_alert_title": "CMDB cascade warning: dependency failure!",
      "ticket_assets.command_execution_failed": "Command execution failed.",
      "ticket_assets.command_placeholder": "e.g. ipconfig /all, systeminfo, dir",
      "ticket_assets.command_running": "The command is currently running on the client device...",
      "ticket_assets.command_success_solved": "Executed successfully! The ticket was resolved automatically.",
      "ticket_assets.command_timeout": "Timeout during command execution.",
      "ticket_assets.compliant": "Compliant",
      "ticket_assets.confirm_kill_process": "Do you really want to end the process with PID {{pid}}?",
      "ticket_assets.cpu_cores_label": "Cores:",
      "ticket_assets.cpu_label": "Processor (CPU)",
      "ticket_assets.cpu_sockets_label": "Sockets:",
      "ticket_assets.cpu_util_label": "CPU util",
      "ticket_assets.created_label": "Created:",
      "ticket_assets.device_scan_label": "Device scan",
      "ticket_assets.disk_free_label": "free",
      "ticket_assets.disk_used_label": "Used",
      "ticket_assets.disks_label": "Disks / drives",
      "ticket_assets.domain_label": "Workgroup/domain:",
      "ticket_assets.edition_id_label": "Edition ID:",
      "ticket_assets.employee_assets": "Employee assets",
      "ticket_assets.error_kill_process": "Error ending the process: {{error}}",
      "ticket_assets.error_loading_monitoring": "Error loading the monitoring data",
      "ticket_assets.error_sending_command": "Error sending the command.",
      "ticket_assets.error_submit_command": "Command could not be submitted: {{error}}",
      "ticket_assets.executed_label": "Executed:",
      "ticket_assets.fetch_logs_btn": "Fetch logs",
      "ticket_assets.filter_processes_placeholder": "Filter processes (name, PID)...",
      "ticket_assets.fix_dns": "Repair DNS",
      "ticket_assets.fix_spooler": "Repair spooler",
      "ticket_assets.hostname_label": "Hostname:",
      "ticket_assets.incomplete_summary": "Compliance summary incomplete.",
      "ticket_assets.invalid_json_response": "Invalid response from the server",
      "ticket_assets.kill_btn": "Kill",
      "ticket_assets.killing_proc": "Ending...",
      "ticket_assets.last_scan_label": "Last scan:",
      "ticket_assets.license_compliance": "License compliance",
      "ticket_assets.link": "Link",
      "ticket_assets.link_asset_title": "Link asset",
      "ticket_assets.linked": "Linked",
      "ticket_assets.linked_assets": "Assets linked to the ticket",
      "ticket_assets.loading": "Loading assets...",
      "ticket_assets.loading_command_queue": "Loading command queue...",
      "ticket_assets.loading_logs": "Loading event logs...",
      "ticket_assets.loading_monitoring": "Loading live monitoring & CMDB check...",
      "ticket_assets.log_name_label": "Log name",
      "ticket_assets.memory_col": "Memory",
      "ticket_assets.model_label": "Model:",
      "ticket_assets.monitored_ok": "Monitored (OK)",
      "ticket_assets.more_params_title": "More parameters",
      "ticket_assets.motherboard_label": "Motherboard:",
      "ticket_assets.no_active_zabbix_alerts": "No active Zabbix alerts.",
      "ticket_assets.no_assets_assigned": "No IT assets are assigned to this employee.",
      "ticket_assets.no_assets_linked": "No assets linked.",
      "ticket_assets.no_commands_executed": "No commands executed yet. Enter a command below.",
      "ticket_assets.no_compliance_available": "No licenses or compliance report available.",
      "ticket_assets.no_employee_assigned": "No employee assigned to the ticket.",
      "ticket_assets.no_hardware_details": "No hardware details scanned.",
      "ticket_assets.no_matching_software": "No matching software entries found.",
      "ticket_assets.no_monitoring_data": "No monitoring data available",
      "ticket_assets.os_arch_label": "Architecture:",
      "ticket_assets.os_label": "Operating system",
      "ticket_assets.os_ver_label": "Version:",
      "ticket_assets.overlicensed": "Over-licensed",
      "ticket_assets.pagination_text": "Page {{page}} of {{total}} ({{count}} entries)",
      "ticket_assets.process_name_col": "Process name",
      "ticket_assets.publisher_col": "Publisher",
      "ticket_assets.query_realtime_btn": "Query in real time",
      "ticket_assets.ram_label": "Memory (RAM)",
      "ticket_assets.ram_util_label": "RAM util",
      "ticket_assets.scan_details_btn": "Scan details",
      "ticket_assets.scan_never": "never",
      "ticket_assets.search_logs_placeholder": "Search results (source, ID, message)...",
      "ticket_assets.search_placeholder": "Search name, IP or S/N...",
      "ticket_assets.search_software_placeholder": "Search software...",
      "ticket_assets.self_healing_title": "Self-healing & automation",
      "ticket_assets.send_btn": "Send",
      "ticket_assets.sending_command_failed": "Sending the command failed.",
      "ticket_assets.serial_number_label": "Serial number:",
      "ticket_assets.severity_all": "All",
      "ticket_assets.severity_error": "Error",
      "ticket_assets.severity_info": "Information",
      "ticket_assets.severity_label": "Severity",
      "ticket_assets.severity_warning": "Warning",
      "ticket_assets.sn_label": "S/N:",
      "ticket_assets.software_name_col": "Software name",
      "ticket_assets.sql_instance_label": "Instance:",
      "ticket_assets.sql_instances_title": "Detected SQL Server instances",
      "ticket_assets.sql_patchlevel_label": "Patch level:",
      "ticket_assets.success_kill_process": "Process ended successfully.",
      "ticket_assets.surplus_label": "Surplus:",
      "ticket_assets.timeout_kill_process": "Timeout while ending the process.",
      "ticket_assets.total_ram_desc": "Total physical memory",
      "ticket_assets.underlicensed": "Under-licensed",
      "ticket_assets.unlink_asset_title": "Remove link",
      "ticket_assets.unreachable": "Unreachable",
      "ticket_assets.version_col": "Version",
      "ticket_assets.virtualization_label": "Virtualisation:",
      "ticket_assets.waiting_agent_response": "Waiting for the agent's response...",
      "ticket_assets.waiting_agent_timeout": "Timeout: the agent did not respond in time.",
      "ticket_assets.zabbix_live_status": "Zabbix live status",
      "ticket_created": "Ticket created",
      "ticket_detail.achtung_ueberschneidungskollisionen_ci_abhae": "Warning: scheduling conflicts (CI dependencies) detected!",
      "ticket_detail.aktivitaeten": "Activities",
      "ticket_detail.aktivitaets_verlauf": "Activity history",
      "ticket_detail.als_diesen_kunden_im_portal_anmelden": "Sign in to the portal as this customer",
      "ticket_detail.anhaenge": "Attachments",
      "ticket_detail.begruendung_kommentare": "Rationale / comments",
      "ticket_detail.bekannter_fehler_workaround_verfuegbar": "Known error — workaround available",
      "ticket_detail.cab_hat_die_aenderung_abgelehnt": "The CAB rejected the change",
      "ticket_detail.change_advisory_board_cab_stimmen": "Change Advisory Board (CAB) votes",
      "ticket_detail.das_ticket_existiert_nicht_oder_wurde_geloes": "The ticket does not exist or has been deleted.",
      "ticket_detail.der_status_kann_erst_auf_in_bearbeitung_oder": "The status can only be set to \"In progress\" or \"Resolved\" once the CAB majority has approved.",
      "ticket_detail.detaillierte_schritte_zur_durchfuehrung": "Detailed steps for implementation...",
      "ticket_detail.es_wurde_noch_kein_change_plan_fuer_dieses_t": "No change plan has been created for this ticket yet.",
      "ticket_detail.es_wurden_andere_aktive_tickets_auf_denselbe": "Other active tickets are scheduled on the same or dependent CMDB assets in the same period:",
      "ticket_detail.extrahierte_daten": "Extracted data",
      "ticket_detail.geplanter_start_wartungsfenster": "Planned start (maintenance window)",
      "ticket_detail.geplantes_ende": "Planned end",
      "ticket_detail.geplantes_wartungsfenster": "Planned maintenance window:",
      "ticket_detail.hinzufuegen": "Add",
      "ticket_detail.keine_aktivitaeten_vorhanden": "No activities",
      "ticket_detail.keine_anhaenge_vorhanden": "No attachments",
      "ticket_detail.keine_kategorie": "No category",
      "ticket_detail.kommentar_zur_entscheidung_optional": "Comment on the decision (optional)...",
      "ticket_detail.loeschen": "Delete",
      "ticket_detail.niemand_zugewiesen": "No assignee",
      "ticket_detail.noch_keine_stimmen_abgegeben": "No votes cast yet.",
      "ticket_detail.noch_keine_zeit_erfasst": "No time logged yet",
      "ticket_detail.nur_fuer_mitarbeiter_sichtbar": "Visible to staff only",
      "ticket_detail.prioritaet": "Priority",
      "ticket_detail.sprachnotizen_in_administration_ki_einstellu": "Enable voice notes under Administration → AI settings.",
      "ticket_detail.sprachnotizen_nicht_aktiv": "Voice notes not enabled",
      "ticket_detail.stimme_uebermitteln": "Submit vote",
      "ticket_detail.tag_entfernen": "Remove tag",
      "ticket_detail.tag_hinzufuegen": "Add tag…",
      "ticket_detail.tag_hinzufuegen_2": "Add tag",
      "ticket_detail.ticket_nicht_gefunden": "Ticket not found",
      "ticket_detail.ticket_wird_geladen": "Loading ticket...",
      "ticket_detail.timer_laeuft_fuer_anderes_ticket": "Timer running for another ticket",
      "ticket_detail.timer_starten": "Start timer",
      "ticket_detail.timer_stoppen": "Stop timer",
      "ticket_detail.uebersicht": "Overview",
      "ticket_detail.veroeffentlicht": "Published",
      "ticket_detail.was_wurde_erledigt": "What was done?",
      "ticket_detail.welches_risiko_besteht_fuer_den_betrieb": "What is the risk to operations?",
      "ticket_detail.wie_machen_wir_aenderungen_rueckgaengig": "How do we roll back changes?",
      "ticket_detail.wie_wird_die_funktion_verifiziert": "How is functionality verified?",
      "ticket_detail.zeiteintraege": "Time entries",
      "ticket_detail.zugewiesen_an": "Assigned to",
      "ticket_detail.zugewiesen_an_2": "Assigned to",
      "ticket_detail.zurueck_zur_uebersicht": "Back to overview",
      "ticket_detail.zustimmung_des_change_advisory_boards_cab_zw": "Change Advisory Board (CAB) approval is mandatory",
      "ticket_filter_active_label": "Filter aktiv",
      "ticket_inventory_kpis": "Kennzahlen & Arbeitslast",
      "ticket_properties_title": "Ticket",
      "ticket_relations": "Verknüpfte Tickets",
      "ticket_view_search_label": "Diese Ticketansicht durchsuchen",
      "tickets": "Tickets",
      "tickets_exist_hint": "Insgesamt sind {{count}} Tickets vorhanden.",
      "tickets_near_sla_breach": "Tickets close to SLA breach",
      "tickets_plural": "{{count}} tickets",
      "tickets_ratio_label": "{{count}} of {{total}} tickets",
      "tickets_selected": "{{count}} tickets selected",
      "tickets_without_assignee": "Tickets without assignee",
      "time_logged": "Time logged: {{time}}",
      "time_minutes": "Zeit in Minuten",
      "title": "Title",
      "to_reply_composer": "To reply (Composer)",
      "today_due": "Due Today",
      "toggle_design_mode": "Toggle design mode",
      "toggle_favorite": "Toggle favorite",
      "tracked_hours": "{{hours}} h",
      "tracked_hours_min": "{{hours}} h {{minutes}} m",
      "tracked_min": "{{minutes}} min.",
      "tracked_time": "Tracked Time",
      "unassigned": "Unassigned",
      "unlink_asset": "Unlink",
      "unread": "Unread",
      "update": "Update",
      "updated_at": "Updated",
      "urgent": "Urgent",
      "user_profile_logout": "User Profile & Logout",
      "vat_id": "VAT ID",
      "views": "Views",
      "voice_notes_admin_hint": "Voice notes: Enable 'Voice Notes' in Administration → AI Settings.",
      "voice_notes_enable_info": "Enable voice notes in Administration → AI Settings (toggle 'Voice Notes').",
      "voice_notes_not_active": "Voice notes not active",
      "website": "Website",
      "widget_critical_tickets": "Critical Tickets (Firefighting)",
      "widget_group_analytics_team": "Analytics & Team",
      "widget_group_overview_performance": "Overview & Performance",
      "widget_group_volume_trends": "Volume & Trends",
      "widget_my_open_tickets": "My Open Tickets",
      "widget_performance_times": "Performance & Logging",
      "widget_priority_chart": "Priority Distribution",
      "widget_sla_compliance": "SLA Compliance & Risk",
      "widget_status_chart": "Ticket Status Distribution",
      "widget_team_presence": "Team Presence & Activity",
      "widget_ticket_trends": "Ticket Trends & Volume",
      "widget_top_customers": "Top Customers by Tickets",
      "zip_code": "ZIP Code"
    }
  },
  "fr": {
    "translation": {
      "access_denied": "Accès refusé",
      "access_denied_desc": "Vous devez disposer des droits d'agent ou d'administrateur.",
      "actions": "Actions",
      "activate_dark_mode": "Activer le mode sombre",
      "activate_light_mode": "Activer le mode clair",
      "active": "Actif",
      "active_filters": "Aktive Filter",
      "active_open_assignments": "Assignations actives et ouvertes",
      "activity_optional": "Activité (optionnelle)",
      "admin": "Admin",
      "admin_dashboard.administrative_berechtigungen": "Autorisations administratives",
      "admin_dashboard.aendern": "Modifier",
      "admin_dashboard.agent_deaktiviert": "Agent désactivé",
      "admin_dashboard.agent_erstellt": "Agent créé",
      "admin_dashboard.agent_gespeichert": "Agent enregistré",
      "admin_dashboard.agent_ohne_zuordnung_hinweis": "Sans affectation, cet agent voit {{umfang}} les clients. Dès qu’au moins un client lui est affecté, l’agent est limité à ces clients — tickets, rapports et actifs.",
      "admin_dashboard.agenten_in_der_kundenkonsole": "Agents dans la console client",
      "admin_dashboard.aktuelles_passwort": "Mot de passe actuel",
      "admin_dashboard.alle_eingehenden_befehle_wurden_bereits_vera": "Toutes les commandes entrantes ont déjà été traitées ou approuvées.",
      "admin_dashboard.alle_kunden": "Tous les clients",
      "admin_dashboard.als_hauptkategorie_erstellen": "Créer comme catégorie principale",
      "admin_dashboard.api_token_hinweis": "Créez au besoin un jeton d’API au préalable sous l’onglet {{reiter}} avec la portée {{scope}}.",
      "admin_dashboard.aufloesungszeit": "Temps de résolution *",
      "admin_dashboard.basic_auth_benutzername_passwort": "Basic Auth (nom d'utilisateur/mot de passe)",
      "admin_dashboard.bei_prefix_u00c4nderung_werden_alle_bestehen": "Lors d'une modification du préfixe, tous les tickets existants sont automatiquement renommés.",
      "admin_dashboard.benoetigte_berechtigung": "Autorisation requise :",
      "admin_dashboard.bestaetigen": "Confirmer",
      "admin_dashboard.bezeichnung_positionszeile": "Libellé de la ligne d'article",
      "admin_dashboard.bitte_kunde_waehlen": "Veuillez sélectionner un client...",
      "admin_dashboard.bitte_kunde_waehlen_2": "Veuillez sélectionner un client...",
      "admin_dashboard.definieren_sie_hauptkategorien_und_bis_zu_zw": "Définissez des catégories principales et jusqu'à deux niveaux de sous-catégories. Elles sont proposées lors de la création d'un ticket.",
      "admin_dashboard.definiert_die_standard_reihenfolge_der_queue": "Définit l'ordre par défaut des files d'attente dans la barre latérale de l'agent.",
      "admin_dashboard.details_anzeigen": "Afficher les détails",
      "admin_dashboard.details_anzeigen_2": "Afficher les détails",
      "admin_dashboard.die_smtp_einstellungen_fuer_den_e_mail_versa": "Les paramètres SMTP pour l'envoi des e-mails sont désormais gérés de manière centralisée sous",
      "admin_dashboard.e_mail_versand_smtp_wird_unter_e_mail_einste": "L'envoi d'e-mails (SMTP) se configure dans les paramètres e-mail",
      "admin_dashboard.eine_sicherheitsgruppe_legt_fest_welche_kons": "Un groupe de sécurité détermine les modules de la console visibles par un agent. « Accès complet » = tous les modules. Les droits d'administration en sont indépendants.",
      "admin_dashboard.einstellungen_speichern": "Enregistrer les paramètres",
      "admin_dashboard.eintraege": "Entrées",
      "admin_dashboard.endgeraet": "Terminal",
      "admin_dashboard.endgueltig_loeschen": "Endgültig löschen",
      "admin_dashboard.entwurfsrechnung_aus_zeiteintraegen": "Projet de facture à partir des saisies de temps",
      "admin_dashboard.erstellen_sie_ihre_erste_automatisierung": "Créez votre première automatisation",
      "admin_dashboard.erstellen_sie_oben_ihre_erste_hauptkategorie": "Créez ci-dessus votre première catégorie principale",
      "admin_dashboard.externer_mitarbeiter_dienstleister": "Collaborateur externe / prestataire",
      "admin_dashboard.fehler_beim_deaktivieren": "Erreur lors de la désactivation",
      "admin_dashboard.fehler_beim_deaktivieren_2": "Erreur lors de la désactivation",
      "admin_dashboard.fehler_beim_deaktivieren_3": "Erreur lors de la désactivation",
      "admin_dashboard.fehler_beim_loeschen": "Erreur lors de la suppression",
      "admin_dashboard.firma_adresse_kontakt_steuernummern_in_der_u": "Société, adresse, contact et numéros fiscaux modifiables dans la vue d'ensemble. La désactivation des clients reste réservée à l'administrateur.",
      "admin_dashboard.fuer_entra_id_benoetigen_sie_eine_app_regist": "Pour Entra ID, vous avez besoin d'une inscription d'application dans le portail Azure avec l'autorisation Mail.Read.",
      "admin_dashboard.geloescht": "Supprimé",
      "admin_dashboard.geloescht_2": "Supprimé",
      "admin_dashboard.installationspaket_herunterladen": "Télécharger le paquet d'installation",
      "admin_dashboard.kategorie_aktualisiert": "Catégorie mise à jour",
      "admin_dashboard.kategorie_erstellt": "Catégorie créée",
      "admin_dashboard.kategorie_geloescht": "Catégorie supprimée",
      "admin_dashboard.keine_abteilung": "Aucun service",
      "admin_dashboard.keine_ausstehenden_befehls_freigaben_vorhand": "Aucune approbation de commande en attente.",
      "admin_dashboard.keine_workflows_konfiguriert": "Aucun workflow configuré",
      "admin_dashboard.keine_zuordnung_dieser_agent_sieht_alle_kund": "Aucune affectation — cet agent voit tous les clients.",
      "admin_dashboard.konfigurieren_sie_sprachmodelle_auto_respons": "Configurez les modèles de langage, les prompts de réponse automatique et les modèles système",
      "admin_dashboard.kunde_auswaehlen": "Sélectionner un client *",
      "admin_dashboard.kunde_deaktiviert": "Client désactivé",
      "admin_dashboard.kunde_erstellt": "Client créé",
      "admin_dashboard.kunde_geloescht": "Kunde „{{firma}}\" wurde endgültig gelöscht",
      "admin_dashboard.kunde_gespeichert": "Client enregistré",
      "admin_dashboard.kunde_waehlen": "Sélectionner un client…",
      "admin_dashboard.kundenzuordnung_verwalten": "Gérer l'affectation des clients",
      "admin_dashboard.laden_sie_ein_fertiges_zip_archiv_fuer": "Téléchargez une archive ZIP prête à l'emploi pour",
      "admin_dashboard.laedt": "Chargement…",
      "admin_dashboard.laengengrad": "Longitude",
      "admin_dashboard.legen_sie_fest_welche_daten_der_installierte": "Définissez les données collectées par l'agent installé et configurez le scanner réseau sans agent optionnel (ping de sous-réseau).",
      "admin_dashboard.letzte_exporte": "Derniers exports",
      "admin_dashboard.lexoffice_artikel_uuid_optional_dienstleistu": "UUID d'article Lexoffice (facultatif, prestation)",
      "admin_dashboard.lexoffice_deaktiviert_hinweis": "L’intégration LexOffice est actuellement désactivée. Vous ne pourrez créer des brouillons de factures qu’après avoir activé et configuré l’intégration sous {{bereich}}.",
      "admin_dashboard.lexoffice_einstellungen_konnten_nicht_gelade": "Impossible de charger les paramètres Lexoffice (exécutez la migration / redémarrez le serveur).",
      "admin_dashboard.loeschen": "Supprimer",
      "admin_dashboard.loeschen_2": "Supprimer",
      "admin_dashboard.mailbox_empfang_imap_oauth_wird_unter_postfa": "La réception des e-mails (IMAP/OAuth) se configure dans les boîtes aux lettres",
      "admin_dashboard.mailbox_speichern": "Enregistrer la boîte aux lettres",
      "admin_dashboard.microsoft_graph_api": "Microsoft Graph API",
      "admin_dashboard.mit_einem_frisch_generierten_api_schluessel": "avec une clé API nouvellement générée et une",
      "admin_dashboard.mitarbeiter_deaktiviert": "Collaborateur désactivé",
      "admin_dashboard.mitarbeiter_erstellt": "Collaborateur créé",
      "admin_dashboard.mitarbeiter_gespeichert": "Collaborateur enregistré",
      "admin_dashboard.mloffice_gefuehrt": "Stammdaten werden von MLOffice geführt",
      "admin_dashboard.mloffice_geloest": "Mit MLOffice verknüpft — Abgleich derzeit gelöst",
      "admin_dashboard.module_assets": "Actifs",
      "admin_dashboard.module_calendar": "Calendrier",
      "admin_dashboard.module_customers": "Clients",
      "admin_dashboard.module_knowledge": "Base de connaissances",
      "admin_dashboard.module_licenses": "Licences",
      "admin_dashboard.module_problems": "Problèmes",
      "admin_dashboard.module_reports": "Rapports",
      "admin_dashboard.module_tickets": "Tickets",
      "admin_dashboard.nach_kunde_filtern": "Filtrer par client",
      "admin_dashboard.neue_mailbox_konfiguration": "Nouvelle configuration de boîte aux lettres",
      "admin_dashboard.neuer_workflow": "Nouveau workflow",
      "admin_dashboard.neues_passwort": "Nouveau mot de passe",
      "admin_dashboard.nicht_abrechenbar": "Non facturable",
      "admin_dashboard.noch_keine_kategorien_definiert": "Aucune catégorie définie pour le moment",
      "admin_dashboard.noch_keine_zeiteintraege_vorhanden": "Aucune saisie de temps pour le moment",
      "admin_dashboard.nur_abrechenbare_eintraege_ohne_vorherigen_l": "Uniquement les saisies facturables sans export Lexoffice antérieur ; filtrage facultatif par ID de contrat.",
      "admin_dashboard.optionale_beschreibung_des_sla_umfangs": "Description facultative de la portée du SLA",
      "admin_dashboard.passwort_aendern": "Modifier le mot de passe",
      "admin_dashboard.primaer": "Principal",
      "admin_dashboard.prioritaet_geaendert": "• Priorité modifiée",
      "admin_dashboard.pruefinterval_minuten": "Intervalle de vérification (minutes)",
      "admin_dashboard.refresh_token": "Refresh Token",
      "admin_dashboard.sie_koennen_den_agenten_auch_manuell_registr": "Vous pouvez également enregistrer l'agent manuellement. Utilisez pour cela la syntaxe suivante sur le client (nécessite des droits d'administrateur) :",
      "admin_dashboard.standardmaessig_duerfen_agenten_kunden_stamm": "Par défaut, les agents peuvent uniquement lire les données de base des clients et consulter les documents clients. Vous pouvez activer ici des droits d'écriture étendus par établissement.",
      "admin_dashboard.status_geaendert": "• Statut modifié",
      "admin_dashboard.stundensatz_ueberschreiben_optional": "Remplacer le taux horaire (facultatif)",
      "admin_dashboard.tarif_erweitern": "Étendre le forfait",
      "admin_dashboard.ticket_id_format_und_admin_passwort_koennen": "Le format des ID de ticket et le mot de passe administrateur se configurent ici",
      "admin_dashboard.top_kunden_nach_ticketvolumen": "Principaux clients par volume de tickets",
      "admin_dashboard.uebergeordnete_kategorie": "Catégorie parente",
      "admin_dashboard.unterkategorie_hinzufuegen": "Ajouter une sous-catégorie",
      "admin_dashboard.upload_metadaten_bearbeiten_und_loeschen_von": "Téléversement, modification des métadonnées et suppression de fichiers dans l'onglet client « Documents ».",
      "admin_dashboard.verfuegbare_trigger": "Déclencheurs disponibles",
      "admin_dashboard.verwalten_und_genehmigen_sie_ausstehende_adm": "Gérez et approuvez les commandes administratives en attente émises par d'autres administrateurs avant leur exécution sur les terminaux clients.",
      "admin_dashboard.voller_zugriff_alle_module": "Accès complet (tous les modules)",
      "admin_dashboard.vorkonfiguriertes_paket_zip": "Paquet préconfiguré (.zip)",
      "admin_dashboard.was_bedeuten_die_gruppen": "Que signifient les groupes ?",
      "admin_dashboard.workflow_automatisierungen": "Automatisations de workflow",
      "admin_dashboard.z_b_hauptsitz_koeln": "p. ex. siège social Cologne",
      "admin_dashboard.zeit_standardmaessig_abrechenbar": "Temps facturable par défaut",
      "admin_dashboard.zeitbuchung_bei_ticket_schliessung_erforderl": "Saisie de temps obligatoire à la clôture d'un ticket",
      "admin_dashboard.zeitbuchungen_erscheinen_hier_sobald_agenten": "Les saisies de temps apparaissent ici dès que les agents enregistrent du temps sur des tickets.",
      "admin_dashboard.zeiteintraege": "Saisies de temps",
      "admin_dashboard.zeiterfassung_aktivieren": "Activer la saisie des temps",
      "admin_dashboard.zeiterfassung_einstellungen": "Paramètres de saisie des temps",
      "admin_dashboard.zugriff_verweigert": "Accès refusé",
      "admin_dashboard.zugriff_verweigert_text": "Vous ne disposez pas des autorisations administratives nécessaires pour consulter ou gérer la section {{bereich}}.",
      "admin_dashboard.zuordnung_entfernen": "Supprimer l'affectation",
      "admin_dashboard.zusaetzliche_admin_rechte": "Droits d'administration supplémentaires",
      "admin_default": "Défaut administrateur",
      "admin_only_change": "(seul un administrateur peut modifier l'assignation.)",
      "admin_overview.aktive_warnungen_risiken": "Alertes et risques actifs",
      "admin_overview.alles_in_ordnung": "Tout est en ordre",
      "admin_overview.datenbank_engine": "Moteur de base de données",
      "admin_overview.einstellungen_filtern": "Filtrer les paramètres...",
      "admin_overview.hinweis_fuer_administratoren": "Remarque pour les administrateurs :",
      "admin_overview.keine_ergebnisse_gefunden": "Aucun résultat trouvé",
      "admin_overview.keine_warnungen_oder_kritischen_meldungen": "Aucune alerte ni message critique.",
      "admin_overview.lade_dashboard_daten": "Chargement des données du tableau de bord...",
      "admin_overview.system_status": "État du système",
      "admin_overview.upgrade_erforderlich": "Mise à niveau requise",
      "admin_overview.upgrade_erforderlich_2": "Mise à niveau requise",
      "admin_overview.versuchen_sie_es_mit_einem_anderen_suchbegri": "Essayez avec un autre terme de recherche.",
      "admin_overview.zurueck_zum_agent_dashboard": "Retour au tableau de bord agent",
      "admin_view": "Vue Administrateur",
      "administration": "Administration",
      "administrator": "Administrateur",
      "agent": "Agent",
      "agent_available": "Disponible",
      "agent_console": "Console Agent",
      "agent_console.alle_als_gelesen": "Tout marquer comme lu",
      "agent_console.anhaenge": "Pièces jointes",
      "agent_console.anhaenge_zum_eroeffnungsbeitrag": "Pièces jointes du message initial",
      "agent_console.back_to_ticket_list": "Zurück zur Liste",
      "agent_console.beschreiben_sie_hier_details_die_dem_partner": "Décrivez ici les détails à communiquer au partenaire...",
      "agent_console.bitte_waehlen": "-- Veuillez sélectionner --",
      "agent_console.detailansicht_schliessen": "Fermer la vue détaillée",
      "agent_console.erneut_oeffnen": "Rouvrir",
      "agent_console.hinweis_der_partner_erhaelt_eine_benachricht": "Remarque : le partenaire reçoit un e-mail de notification contenant vos indications et un lien sécurisé pour traiter le ticket.",
      "agent_console.interner_chat": "Chat interne",
      "agent_console.interner_chat_2": "Chat interne",
      "agent_console.keine_benachrichtigungen": "Aucune notification",
      "agent_console.language_selection": "Sélection de la langue",
      "agent_console.loesen": "Résoudre",
      "agent_console.mir_zuweisen": "M'affecter le ticket",
      "agent_console.nachricht_notiz_fuer_den_partner_optional": "Message / note pour le partenaire (facultatif)",
      "agent_console.neues_ticket": "Nouveau ticket",
      "agent_console.neues_ticket_2": "Nouveau ticket",
      "agent_console.partner_dienstleister_waehlen": "Sélectionner un prestataire partenaire",
      "agent_console.schliessen": "Fermer",
      "agent_console.schliessen_2": "Fermer",
      "agent_console.schliessungsgrund": "Motif de clôture :",
      "agent_console.schnellsuche_oeffnen": "Ouvrir la recherche rapide",
      "agent_console.sie_benoetigen_agent_oder_admin_rechte": "Vous devez disposer de droits d'agent ou d'administrateur.",
      "agent_console.tastenkuerzel": "Raccourcis clavier",
      "agent_console.ticket_erstellt": "Ticket créé",
      "agent_console.ticket_schliessen": "Clôturer le ticket",
      "agent_console.zugriff_verweigert": "Accès refusé",
      "agent_console.zur_antwort_composer": "Aller à la réponse (éditeur)",
      "agent_console.zur_antwort_scrollen": "Faire défiler jusqu'à la réponse",
      "agent_console.zusammenfuehren": "Zusammenführen",
      "agent_console.zuweisung_entfernen": "Retirer l'affectation",
      "ai": "IA",
      "ai_analysis_running": "Analyse en cours...",
      "ai_assistance": "Assistance IA",
      "ai_confidence_label": "{{pct}}% de confiance",
      "ai_context_title": "KI-Kontext & Prognosen",
      "ai_generate_summary": "Générer le résumé",
      "ai_key_points": "Points clés",
      "ai_next_steps": "Prochaines étapes",
      "ai_requested_action": "Action requise",
      "ai_risks": "Risques",
      "ai_solution_assistant_title": "Assistant de solution IA",
      "ai_stale": "Obsolète",
      "ai_summary_title": "Résumé IA",
      "all": "Tous",
      "all_active_tickets": "Tous les tickets actifs",
      "all_categories": "Toutes les catégories",
      "all_customers": "Tous les clients",
      "all_deadlines_ok": "Tous les délais sont respectés.",
      "all_open": "Tous ouverts",
      "all_tickets": "Tous les tickets",
      "allgemein.abbrechen": "Abbrechen",
      "allgemein.schliessen": "Schließen",
      "analyze_again": "Analyser à nouveau",
      "article": "Article",
      "article_ai_generate": "Créer un article avec l'IA",
      "article_ai_generate_btn": "Générer l'article",
      "article_ai_generate_desc": "Décrivez le sujet et l'IA générera un brouillon",
      "article_ai_improve": "Améliorer le texte",
      "article_ai_keywords": "Mots clés (facultatif)",
      "article_ai_keywords_placeholder": "ex. Windows 11, OpenVPN, certificat",
      "article_ai_language": "Langue",
      "article_ai_len_long": "Long / détaillé",
      "article_ai_len_medium": "Moyen",
      "article_ai_len_short": "Court",
      "article_ai_length": "Longueur",
      "article_ai_style": "Style de langage",
      "article_ai_style_balanced": "Équilibré",
      "article_ai_style_enduser": "Utilisateur final (étape par étape)",
      "article_ai_style_formal": "Formel",
      "article_ai_style_simple": "Simple / facile à comprendre",
      "article_ai_style_technical": "Technique (professionnels IT)",
      "article_ai_summarize": "Générer un résumé",
      "article_ai_topic": "Sujet *",
      "article_ai_topic_placeholder": "ex. Configurer une connexion VPN sur Windows",
      "article_all_customers": "Tous les clients",
      "article_all_statuses": "Tous les statuts",
      "article_all_visible": "Visible par tous les clients",
      "article_archived": "Archivé",
      "article_category": "Catégorie",
      "article_content_placeholder": "Commencez à écrire votre article ici...",
      "article_create_first": "Créer le premier article",
      "article_create_first_desc": "Créez votre premier article de connaissances pour partager des informations avec votre équipe.",
      "article_create_with_ai": "Créer avec l'IA",
      "article_delete_confirm": "Voulez-vous vraiment supprimer cet article ?",
      "article_draft": "Brouillon",
      "article_excerpt_placeholder": "Un bref résumé de l'article...",
      "article_manage": "Gérer les articles",
      "article_new": "Nouvel article",
      "article_no_articles": "Aucun article disponible pour le moment",
      "article_no_categories_desc": "Aucune catégorie disponible. Veuillez les créer dans la zone d'administration.",
      "article_no_category": "Aucune catégorie",
      "article_not_found": "Aucun article trouvé",
      "article_not_found_desc": "Aucun article n'a pu être trouvé pour votre recherche.",
      "article_only_visible": "Visible uniquement par {{name}}",
      "article_pinned": "Épinglé",
      "article_pinned_desc": "Sera affiché en haut de la liste",
      "article_plural": "Tous les articles",
      "article_published": "Publié",
      "article_search": "Rechercher des articles...",
      "article_views": "vues",
      "article_visibility": "Visibilité client",
      "article_write_content": "Contenu de l'article",
      "article_write_excerpt": "Extrait",
      "article_write_title": "Entrez le titre de l'article...",
      "asset.discovery_agents": "Agents de découverte",
      "asset.event_logs": "Journaux d'événements",
      "asset.general": "Général",
      "asset.hardware_wmi": "Matériel (WMI)",
      "asset.history_changes": "Historique & Modifications",
      "asset.more": "Plus",
      "asset.network": "Réseau",
      "asset.network_discovery": "Découverte de réseau",
      "asset.printers": "Imprimantes",
      "asset.processes": "Processus",
      "asset.relationships": "Relations",
      "asset.remote_control": "Contrôle à distance",
      "asset.remote_terminal": "Terminal à distance",
      "asset.scan_history": "Historique des analyses",
      "asset.security": "Sécurité",
      "asset.services": "Services",
      "asset.software_catalog": "Catalogue de logiciels (SAM)",
      "asset.software_count": "Logiciels",
      "asset.system_assets": "Actifs du système",
      "asset.updates": "Mises à jour",
      "asset_": "asset_",
      "asset_active": "Actif",
      "asset_agent.offline": "Hors ligne",
      "asset_agent.online_active": "En ligne (actif)",
      "asset_agent.recently_active": "Actif récemment",
      "asset_inactive": "Inactif",
      "asset_maintenance": "Maintenance",
      "asset_management": "Gestion des actifs",
      "asset_panel.confirm_delete_asset": "Voulez-vous vraiment supprimer \"{{name}}\" ?",
      "asset_panel.confirm_delete_category": "Supprimer la catégorie \"{{name}}\" ? Les actifs seront dissociés.",
      "asset_panel.edit_asset": "Modifier l'actif",
      "asset_panel.edit_category": "Modifier la catégorie",
      "asset_panel.import_as_managed_btn": "Importer comme actif géré",
      "asset_panel.import_device": "Importer l'appareil",
      "asset_panel.new_asset": "Nouvel actif",
      "asset_panel.new_category": "Nouvelle catégorie",
      "asset_panel.print_asset_tag": "Imprimer l'étiquette d'actif",
      "asset_panel.print_now_btn": "Imprimer maintenant",
      "asset_panel.toast.agent_no_response_hint": "L'agent n'a pas répondu à temps.",
      "asset_panel.toast.assets_imported": "{{count}} actif(s) importé(s)",
      "asset_panel.toast.command_queued": "Commande mise en file d'attente avec succès",
      "asset_panel.toast.create_problem_error": "Erreur lors de la création du ticket de problème",
      "asset_panel.toast.csv_import_failed": "Échec de l'import CSV",
      "asset_panel.toast.device_ignored": "Appareil ignoré avec succès",
      "asset_panel.toast.device_imported": "Appareil importé avec succès dans les actifs gérés",
      "asset_panel.toast.ignore_device_error": "Erreur lors de l'exclusion de l'appareil",
      "asset_panel.toast.import_device_error": "Erreur lors de l'import de l'appareil",
      "asset_panel.toast.import_with_errors": "Import terminé avec des erreurs",
      "asset_panel.toast.itil_correlation_error": "Erreur lors de la corrélation des problèmes ITIL",
      "asset_panel.toast.less_than_3_tickets": "Moins de 3 tickets au cours des 30 derniers jours.",
      "asset_panel.toast.manual_scan_error": "Erreur lors de l'analyse manuelle",
      "asset_panel.toast.problem_ticket_created": "Ticket de problème créé et incidents associés !",
      "asset_panel.toast.queue_command_error": "Impossible de mettre la commande en file d'attente",
      "asset_panel.toast.request_scan_error": "Erreur lors de la demande d'analyse",
      "asset_panel.toast.scan_completed": "Analyse terminée avec succès",
      "asset_panel.toast.scan_failed": "Échec de l'analyse",
      "asset_panel.toast.scan_requested": "{{type}} demandé",
      "asset_panel.toast.template_downloaded": "Modèle « asset-import-vorlage.csv » téléchargé",
      "asset_panel.toast.template_load_error": "Impossible de charger le modèle",
      "asset_remote_client_disconnected": "Client déconnecté",
      "asset_remote_client_disconnected_desc": "L'utilisateur de l'appareil client a mis fin à la session d'assistance à distance.",
      "asset_remote_closed_desc": "La session d'assistance à distance a été fermée avec succès.",
      "asset_remote_code_placeholder": "ex. 123 456",
      "asset_remote_conn_disconnected": "Déconnecté",
      "asset_remote_conn_failed": "Connexion au serveur distant échouée",
      "asset_remote_conn_rejected": "Connexion refusée",
      "asset_remote_consent_hint": "Une invite de consentement s'affiche sur l'écran du client. Veuillez lui demander de l'accepter.",
      "asset_remote_disconnect": "Déconnecter",
      "asset_remote_enter_code_hint": "Saisissez le code d'accès à 6 chiffres affiché sur l'écran de l'utilisateur :",
      "asset_remote_invalid_code": "Code d'accès incorrect",
      "asset_remote_live_focus": "DIRECT · Focus pour saisie clavier",
      "asset_remote_loading_screen": "Chargement de l'écran en direct...",
      "asset_remote_preparing": "Préparation de la connexion...",
      "asset_remote_protocol2_code_label": "Zwölfstelliger Zugangscode",
      "asset_remote_protocol2_code_placeholder": "ABCD EFGH 2345",
      "asset_remote_protocol2_enter_code_hint": "Geben Sie den zwölfstelligen Zugangscode vom Bildschirm des Benutzers ein:",
      "asset_remote_protocol2_request_desc": "Sendet eine Verbindungsanfrage an den Client-Rechner. Der Benutzer muss zustimmen und den zwölfstelligen Zugangscode übermitteln.",
      "asset_remote_rejected_desc": "La demande de connexion a été refusée par l'utilisateur sur l'appareil client.",
      "asset_remote_req": "Demander une session à distance",
      "asset_remote_request_again": "Demander à nouveau",
      "asset_remote_request_desc": "Envoie une demande de connexion à la machine cliente. L'utilisateur doit accepter et fournir un code d'accès à 6 chiffres.",
      "asset_remote_request_title": "Demander une assistance à distance",
      "asset_remote_start_error": "Impossible de lancer la session d'assistance à distance",
      "asset_remote_start_new": "Démarrer une nouvelle session",
      "asset_remote_support": "Assistance à distance intégrée",
      "asset_remote_support_desc": "Contrôle à distance direct de l'écran sans logiciel externe (TeamViewer/RustDesk).",
      "asset_remote_user_consented": "L'utilisateur a consenti",
      "asset_remote_verifying_code": "Vérification du code...",
      "asset_remote_waiting_consent": "En attente du consentement de l'utilisateur...",
      "asset_retired": "Retiré",
      "assets": "Actifs",
      "assign_to": "Assigner...",
      "assign_to_me": "M'assigner",
      "assigned_agents": "Agents assignés",
      "assigned_to": "Assigné à",
      "at_risk_title": "À risque (Alerte SLA) :",
      "attach_local_file": "Joindre un fichier local",
      "attachments": "Pièces jointes",
      "attachments_tools": "Pièces jointes & Outils",
      "attendees_emails": "Participants (e-mails, séparés par des virgules)",
      "automation": "Automatisation",
      "avg_first_response": "Temps de première réponse",
      "avg_resolution": "Temps moyen de résolution",
      "billable": "Facturable",
      "billable_time": "Facturable : {{time}}",
      "book_on_send": "Enregistrer lors de l'envoi",
      "book_time_with_reply": "Enregistrer du temps avec la réponse",
      "calendar": "Calendrier",
      "calendar_enter_title_warning": "Veuillez saisir un titre.",
      "calendar_event_attendees": "E-mails des participants (facultatif, séparés par des virgules)",
      "calendar_event_created_error": "Impossible de créer l'événement.",
      "calendar_event_created_success": "Événement créé.",
      "calendar_event_description": "Description (facultatif)",
      "calendar_event_title": "Titre",
      "calendar_meeting_created_error": "Impossible de créer la réunion.",
      "calendar_meeting_link_copied": "Lien de la réunion copié dans le presse-papiers.",
      "calendar_new_event": "Nouvel événement",
      "calendar_no_integration_or": "ou",
      "calendar_no_integration_prefix": "Aucune intégration de calendrier ou de réunion active. Veuillez configurer",
      "calendar_no_integration_suffix": "avec planification de réunion active dans les intégrations.",
      "calendar_only_event": "Événement de calendrier uniquement",
      "calendar_talk_meeting": "Réunion Talk",
      "calendar_talk_room_created": "Salle Talk créée.",
      "calendar_teams_meeting": "Réunion Teams",
      "calendar_teams_meeting_created": "Réunion Teams créée.",
      "cancel": "Annuler",
      "canned_responses": "Insérer une réponse type",
      "canned_responses_short": "Réponse type",
      "categories": "Catégories",
      "category": "Catégorie",
      "change_priority": "Modifier la priorité...",
      "change_status_after_send": "Après l'envoi, changer pour",
      "change_ticket_company": "Ticket anderer Firma zuordnen",
      "change_ticket_company_warning": "Portal-Ersteller, CC, Mitarbeiter, Bearbeiter, Kategorie, SLA, Assets und laufende Timer werden für die neue Firma zurückgesetzt.",
      "characters": "caractères",
      "city": "Ville",
      "clear_selection": "Effacer la sélection",
      "click_to_logout": "Cliquer pour vous déconnecter",
      "close": "Fermer",
      "close_detail_view": "Fermer la vue détaillée",
      "close_ticket": "Fermer le ticket",
      "closed": "Fermés",
      "collapse": "Réduire",
      "collapse_composer": "Réduire l'éditeur",
      "collapse_sidebar": "Réduire la barre latérale",
      "column_assignee_name": "Assigné",
      "column_category_name": "Catégorie",
      "column_channel": "Canal",
      "column_created_at": "Créé",
      "column_customer_name": "Client",
      "column_priority": "Priorité",
      "column_reply_count": "Réponses",
      "column_requester_name": "Demandeur",
      "column_sla": "SLA",
      "column_status": "Statut",
      "column_subject": "Objet",
      "column_tags": "Étiquettes",
      "column_ticket_number": "N°",
      "column_updated_at": "Mis à jour",
      "columns_btn": "Colonnes",
      "common.abbrechen": "Abbrechen",
      "company_name": "Nom de l'entreprise",
      "company_title": "Entreprise",
      "compliance_rate": "Taux de conformité",
      "composer_internal": "Interne",
      "composer_internal_placeholder": "Note interne...",
      "composer_public": "Public",
      "composer_public_placeholder": "Écrire une réponse...",
      "configure_columns": "Configurer les colonnes",
      "connect": "Se connecter",
      "contact_and_master_data": "Contact & Données de base",
      "contact_person": "Interlocuteur",
      "contact_person_abbrev": "Contact",
      "contract": "Contrat",
      "contract.auto_renew": "Renouvellement automatique",
      "contract.auto_renews_suffix": " (renouvellement automatique)",
      "contract.back_to_overview": "Retour à l'aperçu",
      "contract.billing": "Facturation",
      "contract.billing_model": "Modèle de facturation",
      "contract.conditions": "Conditions",
      "contract.days": "{{count}} jours",
      "contract.end_date": "Date de fin",
      "contract.expires_in_days": "Expire dans {{count}} jours",
      "contract.first_response": "Première réponse",
      "contract.hourly_rate": "Taux horaire",
      "contract.hours_quota": "Quota d'heures",
      "contract.included_hours": "Heures incluses",
      "contract.no_contracts": "Aucun contrat disponible",
      "contract.no_contracts_desc": "Contactez-nous pour une offre personnalisée",
      "contract.notice_period": "Préavis de résiliation : {{count}} jours",
      "contract.period_per": "{{count}} h / période",
      "contract.quota_summary": "{{remaining}} restant ({{percent}} % utilisé)",
      "contract.remaining": "Restant",
      "contract.resolution": "Résolution",
      "contract.runtime": "Durée",
      "contract.sla_tier": "SLA",
      "contract.start_date": "Date de début",
      "contract.status.active": "Actif",
      "contract.status.expired": "Expiré",
      "contract.status.expiring_soon": "Expire bientôt",
      "contract.status.future": "À venir",
      "contract.subtitle": "Aperçu de vos contrats actifs et de vos accords de niveau de service",
      "contract.unlimited": "Durée indéterminée",
      "contract.used": "Consommé",
      "contracts": "Contrats",
      "copied_to_clipboard": "Copié dans le presse-papiers",
      "country": "Pays",
      "create": "Créer",
      "create_ticket.aehnliche_tickets": "Tickets similaires",
      "create_ticket.angehaengte_cloud_dateien": "Fichiers cloud joints :",
      "create_ticket.anhaenge": "Pièces jointes",
      "create_ticket.asset_verknuepfen_optional": "Associer un actif (facultatif) :",
      "create_ticket.assets_filtern": "Filtrer les actifs :",
      "create_ticket.assets_werden_geladen": "Chargement des actifs...",
      "create_ticket.beschreiben_sie_das_problem_so_detailliert_w": "Décrivez le problème de la manière la plus détaillée possible...",
      "create_ticket.betroffene_systeme_benutzer_nennen": "Indiquer les systèmes/utilisateurs concernés",
      "create_ticket.bitte_betreff_und_beschreibung_ausfuellen": "Veuillez renseigner l'objet et la description",
      "create_ticket.bitte_eine_beschreibung_angeben": "Veuillez indiquer une description.",
      "create_ticket.bitte_einen_kunden_auswaehlen": "Veuillez sélectionner un client.",
      "create_ticket.bitte_hauptkategorie_waehlen": "Veuillez sélectionner une catégorie principale...",
      "create_ticket.bitte_klassifizierung_waehlen": "Veuillez sélectionner une classification...",
      "create_ticket.bitte_kunde_waehlen": "Veuillez sélectionner un client...",
      "create_ticket.bitte_unterkategorie_waehlen": "Veuillez sélectionner une sous-catégorie...",
      "create_ticket.bitte_zuerst_einen_kunden_waehlen": "Veuillez d'abord sélectionner un client...",
      "create_ticket.datei_hochladen": "Téléverser un fichier",
      "create_ticket.datei_hochladen_2": "Téléverser un fichier",
      "create_ticket.datei_zu_gross_max_10_mb": "Fichier trop volumineux (max. 10 Mo)",
      "create_ticket.dateityp_nicht_erlaubt": "Type de fichier non autorisé",
      "create_ticket.erste_antwort": "Première réponse",
      "create_ticket.fehlermeldungen_und_screenshots_beifuegen": "Joindre les messages d'erreur et les captures d'écran",
      "create_ticket.keine_mitarbeiter_hinterlegt": "Aucun collaborateur enregistré",
      "create_ticket.letzte_kunden_tickets": "Derniers tickets du client",
      "create_ticket.loesung": "Résolution",
      "create_ticket.neues_ticket": "Nouveau ticket",
      "create_ticket.nur_geschaeftszeiten": "Heures ouvrées uniquement",
      "create_ticket.praeziser_betreff_hilft_bei_der_zuordnung": "Un objet précis facilite l'affectation",
      "create_ticket.priority_high": "Élevée",
      "create_ticket.priority_low": "Faible",
      "create_ticket.priority_medium": "Moyenne",
      "create_ticket.priority_urgent": "Urgente",
      "create_ticket.schritte_zur_reproduktion_angeben": "Indiquer les étapes de reproduction",
      "create_ticket.stoerung": "Incident",
      "create_ticket.text_mit_ki_verbessern": "Améliorer le texte avec l'IA",
      "create_ticket.ticket_erstellt": "Ticket créé !",
      "create_ticket.uebernehmen": "Appliquer",
      "create_ticket.ueberschrift": "Titre",
      "create_ticket.vielleicht_loest_ein_artikel_das_problem_ber": "Un article résout peut-être déjà le problème ?",
      "create_ticket.vorlage_einfuegen": "Insérer un modèle",
      "create_ticket.waehlen_sie_einen_kunden_aus_um_dessen_asset": "Sélectionnez un client pour pouvoir associer ses actifs.",
      "create_ticket.werden_bei_erstellung_ausgeloest": "Déclenchés lors de la création",
      "create_ticket.zurueck": "Retour",
      "created_at": "Créé le",
      "critical_priority_sla": "Priorité / SLA",
      "customer": "Client",
      "customer_assets.no_assets": "Aucun actif enregistré pour ce client. Les indications d'état apparaîtront ici dès qu'un actif dispose d'un ID d'hôte Zabbix ou d'un moniteur de disponibilité.",
      "customer_assets.no_assets_unconfigured": "Aucun actif enregistré. Discovery ou une intégration de supervision peut automatiser l’inventaire.",
      "customer_assets.no_zabbix_id": "Aucun ID d'hôte Zabbix sur l'actif",
      "customer_assets.start_rd": "Démarrer RustDesk",
      "customer_assets.start_tv": "Démarrer TeamViewer",
      "customer_form.adresse_eingeben_um_karte_anzuzeigen": "Saisissez une adresse pour afficher la carte",
      "customer_form.client_secret": "Client Secret",
      "customer_form.domain_entfernen": "Supprimer le domaine",
      "customer_form.domain_hinzufuegen": "+ Ajouter un domaine",
      "customer_form.domains_mit_zugeordneten_mitarbeitern_koenne": "Les domaines auxquels des collaborateurs sont affectés ne peuvent pas être supprimés.",
      "customer_form.geschaeftsfuehrer": "Directeur général",
      "customer_form.in_openstreetmap_oeffnen": "Ouvrir dans OpenStreetMap ↗",
      "customer_form.interne_notizen_zu_diesem_kunden": "Notes internes sur ce client...",
      "customer_form.kontakt_in_lexoffice_anlegen_uuid_hier_eintr": "Créer le contact dans Lexoffice, puis saisir l'UUID ici",
      "customer_form.lexoffice_kontakt_id_uuid": "ID de contact Lexoffice (UUID)",
      "customer_form.logo_kann_nach_dem_erstellen_des_kunden_hoch": "Le logo peut être téléversé après la création du client.",
      "customer_form.mitarbeiter_koennen_sich_per_microsoft_konto": "Les collaborateurs peuvent se connecter avec un compte Microsoft",
      "customer_form.mloffice_badge": "Von MLOffice verwaltet",
      "customer_form.mloffice_banner": "Dieser Kunde wird mit MLOffice abgeglichen. Stammdaten (Name, E-Mail, Telefon, Anschrift, USt-ID) werden von MLOffice verwaltet und sind hier gesperrt.",
      "customer_form.mloffice_feld_hinweis": "Dieses Feld wird von MLOffice verwaltet — Änderungen bitte dort vornehmen; sie werden automatisch übernommen.",
      "customer_form.mloffice_geloest": "Verknüpfung gelöst — die Felder sind wieder bearbeitbar.",
      "customer_form.mloffice_loesen": "Verknüpfung lösen…",
      "customer_form.mloffice_loesen_fehler": "Verknüpfung konnte nicht gelöst werden.",
      "customer_form.mloffice_loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "customer_form.mloffice_loest": "Löse…",
      "customer_form.mloffice_verwaltung_hinweis": "Verwaltung der Verknüpfung unter Stammdaten & Organisation → MLOffice (erfordert Systemrechte).",
      "customer_form.registrieren_sie_eine_app_in_azure_portal_ap": "Enregistrez une application dans le portail Azure → Inscriptions d'applications. URI de redirection :",
      "customer_form.strasse": "Rue",
      "customer_form.tab_address": "Adresse",
      "customer_form.tab_domains": "Domaines",
      "customer_form.tab_general": "Général",
      "customer_form.tab_notes": "Notes",
      "customer_form.tab_sso": "SSO",
      "customer_form.tab_tax": "Fiscalité et SLA",
      "customer_form.zuordnung_ticket_system_kunde_lexoffice_kont": "Affectation client du système de tickets → contact Lexoffice pour les projets de facture (Admin → Saisie des temps).",
      "customer_inactive": "Client inactif",
      "customer_not_found": "Client non trouvé",
      "customer_notified_by_email": "Le client sera notifié par e-mail",
      "customer_number_abbrev": "N° Client",
      "customer_portal.action_required": "Action requise",
      "customer_portal.action_required_desc": "L'équipe de support attend votre retour sur ce ticket.",
      "customer_portal.action_required_title": "Votre réponse est requise",
      "customer_portal.assignee": "Responsable",
      "customer_portal.attachments_count": "Pièces jointes ({{count}})",
      "customer_portal.attachments_load_failed": "Weitere Anhänge konnten nicht geladen werden.",
      "customer_portal.back": "← Retour",
      "customer_portal.back_to_my_tickets": "← Retour à Mes tickets",
      "customer_portal.close": "Fermer",
      "customer_portal.close_failed": "Impossible de fermer le ticket.",
      "customer_portal.collapse_replies": "Ältere schließen",
      "customer_portal.compact_replies": "Ältere Antworten sind eingeklappt. Die letzte Antwort bleibt geöffnet.",
      "customer_portal.confirm_close": "Voulez-vous vraiment fermer ce ticket ?",
      "customer_portal.confirm_reopen": "Voulez-vous rouvrir ce ticket ?",
      "customer_portal.contracts.hours_minutes": "{{hours}} h {{minutes}} min",
      "customer_portal.contracts.hours_only": "{{hours}} h",
      "customer_portal.contracts.minutes_only": "{{minutes}} min",
      "customer_portal.create_first_ticket": "Créer un nouveau ticket",
      "customer_portal.created": "Créé",
      "customer_portal.customer_colleague": "Kollegin/Kollege",
      "customer_portal.dashboard.active_count": "{{count}} actif(s)",
      "customer_portal.dashboard.avg_resolution": "Ø Temps de résolution",
      "customer_portal.dashboard.click_to_view_waiting": "Cliquez ici pour afficher les tickets",
      "customer_portal.dashboard.create_first_link": "Créer un premier ticket →",
      "customer_portal.dashboard.create_new_ticket_link": "Créer un nouveau ticket",
      "customer_portal.dashboard.history_trend": "Historique des tickets (12 derniers mois)",
      "customer_portal.dashboard.kb": "Aide et base de connaissances",
      "customer_portal.dashboard.kb_desc": "Guides et FAQ",
      "customer_portal.dashboard.my_tickets": "Mes tickets",
      "customer_portal.dashboard.no_tickets": "Aucun ticket pour le moment",
      "customer_portal.dashboard.no_tickets_status": "Aucun ticket",
      "customer_portal.dashboard.open_active": "Ouverts / actifs",
      "customer_portal.dashboard.processing_time": "Temps de traitement",
      "customer_portal.dashboard.recent_tickets": "Derniers tickets",
      "customer_portal.dashboard.report_incident": "Signaler un incident",
      "customer_portal.dashboard.report_incident_desc": "Signaler un problème urgent ou une panne",
      "customer_portal.dashboard.reports": "Aperçu et rapports",
      "customer_portal.dashboard.reports_desc": "Filtrer et analyser tous les tickets",
      "customer_portal.dashboard.search_kb_link": "Rechercher dans la base de connaissances",
      "customer_portal.dashboard.service_request": "Demande de service",
      "customer_portal.dashboard.service_request_desc": "Demandes via des formulaires configurables",
      "customer_portal.dashboard.show_all_link": "Tout afficher →",
      "customer_portal.dashboard.status_overview": "Aperçu des statuts",
      "customer_portal.dashboard.subtitle": "Votre aperçu du support en un coup d'œil",
      "customer_portal.dashboard.total_tickets": "Total des tickets",
      "customer_portal.dashboard.waiting_tickets_warning": "1 ticket nécessite votre réponse",
      "customer_portal.dashboard.waiting_tickets_warning_plural": "{{count}} tickets nécessitent votre réponse",
      "customer_portal.dashboard.welcome": "Bienvenue",
      "customer_portal.dashboard.widget_unknown": "Widget : {{type}}",
      "customer_portal.dashboard.your_reply": "Votre réponse",
      "customer_portal.details_title": "Détails",
      "customer_portal.editor.bold": "Gras",
      "customer_portal.editor.code": "Code",
      "customer_portal.editor.italic": "Italique",
      "customer_portal.editor.list": "Liste",
      "customer_portal.expand_replies": "Alle öffnen",
      "customer_portal.files_draft_failed": "Anhänge konnten nicht dauerhaft im Entwurf gespeichert werden.",
      "customer_portal.files_need_reselect": "Anhänge können aus Sicherheitsgründen nicht wiederhergestellt werden. Bitte wählen Sie sie erneut aus.",
      "customer_portal.filters.active": "Actifs",
      "customer_portal.filters.all": "Tous",
      "customer_portal.filters.closed": "Fermés",
      "customer_portal.filters.external": "Extern",
      "customer_portal.filters.waiting_customer": "Votre réponse",
      "customer_portal.history_title": "Historique",
      "customer_portal.impersonation_banner": "Vous consultez actuellement ce portail en mode emprunt d'identité (aperçu pour les agents) en tant que client :",
      "customer_portal.incident_badge": "Incident",
      "customer_portal.kb.title": "Base de connaissances",
      "customer_portal.load_more_attachments": "Weitere Anhänge laden",
      "customer_portal.login.betreut_von": "ASSURÉ PAR NALVRA",
      "customer_portal.login.claim": "Votre ligne directe avec le support — signaler, suivre, trouver des réponses.",
      "customer_portal.login.copyright_text": "© {{year}} {{appName}}. Tous droits réservés.",
      "customer_portal.login.default_subtitle": "Connectez-vous pour gérer vos demandes.",
      "customer_portal.login.default_welcome": "Bienvenue sur {{appName}}",
      "customer_portal.login.email": "E-mail",
      "customer_portal.login.email_placeholder": "nom@entreprise.fr",
      "customer_portal.login.eyebrow": "PORTAIL CLIENT · ACCESSIBLE 24/7",
      "customer_portal.login.forgot_password": "Mot de passe oublié ?",
      "customer_portal.login.kein_zugang": "Pas encore d'accès ? Contactez votre interlocuteur au support.",
      "customer_portal.login.kundenanmeldung": "Connexion client",
      "customer_portal.login.kundenportal": "PORTAIL CLIENT",
      "customer_portal.login.microsoft_signin": "Se connecter avec Microsoft",
      "customer_portal.login.mit_hinterlegter_adresse": "Connectez-vous avec l'adresse e-mail enregistrée.",
      "customer_portal.login.or_password": "ou avec un mot de passe",
      "customer_portal.login.password": "Mot de passe",
      "customer_portal.login.password_placeholder": "Votre mot de passe",
      "customer_portal.login.reset_back": "Retour à la connexion",
      "customer_portal.login.reset_button": "Envoyer le lien",
      "customer_portal.login.reset_instruction": "Saisissez votre adresse e-mail. Nous vous enverrons un lien de réinitialisation.",
      "customer_portal.login.reset_sent_message": "Si un compte existe pour cette adresse, nous avons envoyé un lien de réinitialisation.",
      "customer_portal.login.reset_sent_title": "E-mail envoyé",
      "customer_portal.login.reset_title": "Réinitialiser le mot de passe",
      "customer_portal.login.sicherheitszeile": "Connexion chiffrée · Accès réservé aux contacts enregistrés",
      "customer_portal.login.signin_button": "Se connecter",
      "customer_portal.login.signing_in": "Connexion en cours …",
      "customer_portal.login.sso_available": "Authentification unique disponible",
      "customer_portal.login.sso_failed": "Échec de la connexion SSO",
      "customer_portal.login.sso_logging_in": "Connexion en cours …",
      "customer_portal.menu.dashboard": "Tableau de bord",
      "customer_portal.menu.edit_profile": "Modifier le profil",
      "customer_portal.menu.logout": "Se déconnecter",
      "customer_portal.menu.profile": "Mein Profil",
      "customer_portal.message_placeholder": "Votre message...",
      "customer_portal.nav.contracts": "Contrats",
      "customer_portal.nav.create_request": "Anfrage erstellen",
      "customer_portal.nav.dashboard": "Tableau de bord",
      "customer_portal.nav.documents": "Documents",
      "customer_portal.nav.downloads": "Downloads",
      "customer_portal.nav.help": "Hilfe & Kurztour",
      "customer_portal.nav.kb": "Base de connaissances",
      "customer_portal.nav.my_tickets": "Mes tickets",
      "customer_portal.nav.profile": "Profil",
      "customer_portal.nav.report_incident": "Signaler un incident",
      "customer_portal.nav.service_request": "Demande de service",
      "customer_portal.nav.support": "Support erhalten",
      "customer_portal.navigation": "Portal-Navigation",
      "customer_portal.new_ticket": "Nouveau ticket",
      "customer_portal.new_ticket.add_attachment": "Ajouter",
      "customer_portal.new_ticket.ai_improve_btn": "Améliorer la description",
      "customer_portal.new_ticket.ai_improving": "Amélioration en cours...",
      "customer_portal.new_ticket.ai_preanswer_title": "Suggestion de l'IA concernant votre problème",
      "customer_portal.new_ticket.ai_suggestion_title": "Suggestion d'amélioration par l'IA",
      "customer_portal.new_ticket.allowed_types_tip": "Uniquement les types de fichiers configurés (voir les indications de votre administrateur)",
      "customer_portal.new_ticket.apply": "Appliquer",
      "customer_portal.new_ticket.attach_file": "Joindre un fichier",
      "customer_portal.new_ticket.attachment_plural": "Pièces jointes",
      "customer_portal.new_ticket.attachment_singular": "Pièce jointe",
      "customer_portal.new_ticket.back_step_1": "Zurück zu Schritt 1",
      "customer_portal.new_ticket.back_step_2": "Zurück zu Schritt 2",
      "customer_portal.new_ticket.categories_error": "Kategorien konnten nicht geladen werden.",
      "customer_portal.new_ticket.categories_loading": "Kategorien werden geladen …",
      "customer_portal.new_ticket.category_assignment": "Kategorie zuordnen",
      "customer_portal.new_ticket.category_by_support": "Zuordnung durch den Support",
      "customer_portal.new_ticket.category_hint": "Sie sind unsicher? Lassen Sie die Kategorie offen. Der Support übernimmt die Zuordnung.",
      "customer_portal.new_ticket.category_question": "Welche Kategorie passt zu Ihrem Anliegen?",
      "customer_portal.new_ticket.char_count": "{{count}} caractères",
      "customer_portal.new_ticket.continue_step_2": "Weiter zu Schritt 2",
      "customer_portal.new_ticket.continue_step_3": "Weiter zu Schritt 3",
      "customer_portal.new_ticket.create": "Créer",
      "customer_portal.new_ticket.create_anyway": "Créer le ticket malgré tout",
      "customer_portal.new_ticket.create_ticket": "Créer un ticket",
      "customer_portal.new_ticket.creating": "Création en cours...",
      "customer_portal.new_ticket.days_count": "{{count}} jours ouvrés",
      "customer_portal.new_ticket.description_label": "Description *",
      "customer_portal.new_ticket.description_placeholder": "Décrivez votre problème en détail...\\n\\n• Qu'est-ce qui ne fonctionne pas ?\\n• Depuis quand le problème se produit-il ?\\n• Y a-t-il un message d'erreur ?\\n• Quel système / appareil est concerné ?\\n\\nAstuce : insérez des captures d'écran avec Ctrl+V",
      "customer_portal.new_ticket.description_required": "Bitte beschreiben Sie Ihr Problem.",
      "customer_portal.new_ticket.discard": "Abandonner",
      "customer_portal.new_ticket.drag_more": "Glissez d'autres fichiers ici · encore {{count}} possible(s)",
      "customer_portal.new_ticket.drag_or_click": "Glissez des fichiers ici ou cliquez",
      "customer_portal.new_ticket.drop_here": "Déposez les fichiers ici...",
      "customer_portal.new_ticket.error_create_failed": "Erreur lors de la création du ticket.",
      "customer_portal.new_ticket.expected_first_response": "Première réponse",
      "customer_portal.new_ticket.go_to_step": "Schritt {{step}}: {{label}}",
      "customer_portal.new_ticket.hide": "Masquer",
      "customer_portal.new_ticket.hours_count": "{{count}} heures",
      "customer_portal.new_ticket.insert_template": "Insérer un modèle",
      "customer_portal.new_ticket.kb_article_error": "Dieser Artikel konnte nicht geladen werden. Sie können es erneut versuchen oder mit Ihrem Ticket fortfahren.",
      "customer_portal.new_ticket.kb_close_article": "Artikel schließen",
      "customer_portal.new_ticket.kb_did_help": "Hat dieser Artikel Ihr Problem gelöst?",
      "customer_portal.new_ticket.kb_draft_retained": "Ihr Ticketentwurf bleibt erhalten. Sie entscheiden, ob Sie ihn weiter bearbeiten.",
      "customer_portal.new_ticket.kb_feedback_error": "Ihre Rückmeldung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut. Ihr Entwurf bleibt erhalten.",
      "customer_portal.new_ticket.kb_helped": "Artikel hat mir geholfen",
      "customer_portal.new_ticket.kb_loading_article": "Artikel wird geladen",
      "customer_portal.new_ticket.kb_resolved_message": "Ihre Rückmeldung wurde gespeichert. Es wurde kein Ticket erstellt.",
      "customer_portal.new_ticket.kb_resolved_title": "Schön, dass die Anleitung geholfen hat",
      "customer_portal.new_ticket.kb_resume_draft": "Ticketentwurf weiter bearbeiten",
      "customer_portal.new_ticket.kb_retry": "Erneut laden",
      "customer_portal.new_ticket.kb_saved_draft": "Ihr Entwurf bleibt für Sie gespeichert, falls Sie später doch Unterstützung benötigen.",
      "customer_portal.new_ticket.kb_searching": "Lösungen werden gesucht",
      "customer_portal.new_ticket.kb_suggestions_hint": "Passende Anleitungen aus der Wissensbasis. Lesen Sie einen Artikel, bevor Sie Ihr Ticket erstellen.",
      "customer_portal.new_ticket.kb_suggestions_title": "Vielleicht ist die Lösung schon da",
      "customer_portal.new_ticket.kb_to_dashboard": "Zurück zum Dashboard",
      "customer_portal.new_ticket.max_files": "Max. {{count}} fichiers",
      "customer_portal.new_ticket.max_size": "Max. {{count}} Mo / fichier",
      "customer_portal.new_ticket.minutes_count": "{{count}} minutes",
      "customer_portal.new_ticket.no_category": "Veuillez choisir une catégorie...",
      "customer_portal.new_ticket.optional": "Optional",
      "customer_portal.new_ticket.preanswer_might_resolve": "Cela vous a-t-il aidé ? Dans ce cas, il n'est peut-être pas nécessaire de créer un ticket.",
      "customer_portal.new_ticket.presubmit_kb_desc": "Aucun article correspondant ? Pas de problème — créez votre ticket.",
      "customer_portal.new_ticket.presubmit_kb_title": "Ceci pourrait déjà résoudre votre problème",
      "customer_portal.new_ticket.prio_desc_critical": "Immédiat",
      "customer_portal.new_ticket.prio_desc_high": "Urgent",
      "customer_portal.new_ticket.prio_desc_low": "Peut attendre",
      "customer_portal.new_ticket.prio_desc_medium": "Normal",
      "customer_portal.new_ticket.progress": "Fortschritt der Ticketerstellung",
      "customer_portal.new_ticket.relevant_articles": "Articles correspondants :",
      "customer_portal.new_ticket.reply_by_email_tip": "Vous pouvez également répondre à ce ticket par e-mail",
      "customer_portal.new_ticket.resolution": "Résolution",
      "customer_portal.new_ticket.response_time_typical": "Réponse généralement sous quelques heures",
      "customer_portal.new_ticket.retry_categories": "Erneut laden",
      "customer_portal.new_ticket.screenshot_tip": "Insérez des captures d'écran avec Ctrl+V",
      "customer_portal.new_ticket.similar_tickets": "Tickets similaires",
      "customer_portal.new_ticket.step_attachments": "Anhänge",
      "customer_portal.new_ticket.step_attachments_detail": "Kategorie, Anhänge und Absenden",
      "customer_portal.new_ticket.step_count": "Schritt {{step}} von 3",
      "customer_portal.new_ticket.step_details": "Details",
      "customer_portal.new_ticket.step_details_detail": "Beschreibung und Priorität",
      "customer_portal.new_ticket.step_subject": "Betreff",
      "customer_portal.new_ticket.step_subject_detail": "Person, Betreff und Wissensbasis",
      "customer_portal.new_ticket.subject_desc_required": "L'objet et la description sont obligatoires.",
      "customer_portal.new_ticket.subject_label": "Objet *",
      "customer_portal.new_ticket.subject_placeholder": "Brève description du problème ou de votre demande",
      "customer_portal.new_ticket.subject_required": "Bitte geben Sie einen Betreff ein.",
      "customer_portal.new_ticket.subtitle": "Incident technique ou problème urgent — transmis au support sous forme de ticket.",
      "customer_portal.new_ticket.subtitle_2": "Décrivez votre demande et nous nous en occupons.",
      "customer_portal.new_ticket.success_desc": "Merci beaucoup. Nous vous recontacterons dans les meilleurs délais.",
      "customer_portal.new_ticket.success_title": "Ticket créé !",
      "customer_portal.new_ticket.template_btn": "Exemple",
      "customer_portal.new_ticket.view_ticket": "Afficher le ticket",
      "customer_portal.no_attachments": "Keine Anhänge vorhanden.",
      "customer_portal.no_tickets_create_desc": "Créez votre premier ticket.",
      "customer_portal.no_tickets_filter_desc": "Essayez un autre filtre.",
      "customer_portal.no_tickets_search_desc": "Essayez un autre terme de recherche.",
      "customer_portal.no_tickets_title": "Aucun ticket trouvé",
      "customer_portal.pagination_of": "von",
      "customer_portal.password.btn": "Modifier le mot de passe",
      "customer_portal.password.cancel": "Annuler",
      "customer_portal.password.changing": "Modification en cours...",
      "customer_portal.password.confirm": "Confirmer le nouveau mot de passe",
      "customer_portal.password.current": "Mot de passe actuel",
      "customer_portal.password.error_change": "Erreur lors de la modification.",
      "customer_portal.password.error_min_length": "8 caractères minimum.",
      "customer_portal.password.error_mismatch": "Les mots de passe ne correspondent pas.",
      "customer_portal.password.error_same": "Le nouveau mot de passe doit être différent.",
      "customer_portal.password.logout": "Se déconnecter",
      "customer_portal.password.mismatch_warning": "Les mots de passe ne correspondent pas",
      "customer_portal.password.must_change_desc": "Veuillez modifier votre mot de passe avant de continuer.",
      "customer_portal.password.new": "Nouveau mot de passe (min. 8 caractères)",
      "customer_portal.password.redirecting": "Vous allez être redirigé...",
      "customer_portal.password.success": "Mot de passe modifié avec succès !",
      "customer_portal.password.title": "Modifier le mot de passe",
      "customer_portal.priority_help.high": "Mehrere Mitarbeitende oder eine wichtige Funktion sind stark beeinträchtigt. Es gibt keine praktikable Ausweichlösung, der übrige Betrieb läuft jedoch weiter.",
      "customer_portal.priority_help.low": "Kleine Einschränkung oder allgemeine Frage. Sie können normal weiterarbeiten, zum Beispiel bei einem Darstellungsfehler oder einem Änderungswunsch.",
      "customer_portal.priority_help.medium": "Die Arbeit ist eingeschränkt, aber eine Ausweichlösung ist möglich. Beispiel: Ein Drucker fällt aus, ein anderer kann genutzt werden.",
      "customer_portal.priority_help.urgent": "Der Betrieb oder ein geschäftskritischer Prozess steht still. Es gibt keine Ausweichlösung, zum Beispiel bei einem vollständigen Ausfall des zentralen Systems. Bitte nicht nur wegen eines persönlichen Wunschtermins wählen.",
      "customer_portal.processing_time": "Temps de traitement",
      "customer_portal.profile.cancel": "Annuler",
      "customer_portal.profile.change_password_btn": "Modifier le mot de passe",
      "customer_portal.profile.change_photo": "Profilbild ändern",
      "customer_portal.profile.closed": "Fermés",
      "customer_portal.profile.company": "Entreprise",
      "customer_portal.profile.company_account": "Entreprise et compte",
      "customer_portal.profile.days_count": "{{count}} jour(s) ouvré(s)",
      "customer_portal.profile.department": "Département",
      "customer_portal.profile.edit": "Modifier",
      "customer_portal.profile.email": "E-mail",
      "customer_portal.profile.error_save": "Erreur lors de l'enregistrement",
      "customer_portal.profile.error_upload": "Erreur lors du téléversement",
      "customer_portal.profile.first_name": "Prénom",
      "customer_portal.profile.first_response": "Première réponse",
      "customer_portal.profile.hours_count": "{{count}} h",
      "customer_portal.profile.last_name": "Nom",
      "customer_portal.profile.loading": "Chargement du profil...",
      "customer_portal.profile.location": "Site",
      "customer_portal.profile.member_since": "Membre depuis",
      "customer_portal.profile.minutes_count": "{{count}} min",
      "customer_portal.profile.mobile": "Mobile",
      "customer_portal.profile.mobile_placeholder": "ex. +49 170 12345",
      "customer_portal.profile.open": "Ouverts",
      "customer_portal.profile.personal_data": "Données personnelles",
      "customer_portal.profile.phone": "Téléphone",
      "customer_portal.profile.phone_placeholder": "ex. +49 221 12345",
      "customer_portal.profile.position": "Fonction",
      "customer_portal.profile.resolution": "Résolution",
      "customer_portal.profile.save": "Enregistrer",
      "customer_portal.profile.security": "Sécurité",
      "customer_portal.profile.security_desc": "Modifiez régulièrement votre mot de passe pour plus de sécurité.",
      "customer_portal.profile.service_level": "Niveau de service",
      "customer_portal.profile.show_dashboard": "Afficher le tableau de bord",
      "customer_portal.profile.sla_tier": "Niveau de SLA",
      "customer_portal.profile.sso_active": "Authentification SSO active",
      "customer_portal.profile.success_photo": "Photo de profil mise à jour",
      "customer_portal.profile.success_update": "Profil mis à jour avec succès",
      "customer_portal.profile.ticket_overview": "Aperçu des tickets",
      "customer_portal.profile.total": "Total",
      "customer_portal.reopen": "Rouvrir",
      "customer_portal.reopen_failed": "Impossible de rouvrir le ticket.",
      "customer_portal.reopen_ticket": "Rouvrir le ticket",
      "customer_portal.replies_load_failed": "Ältere Antworten konnten nicht geladen werden.",
      "customer_portal.reply_btn": "Répondre",
      "customer_portal.reply_failed": "Votre réponse n'a pas pu être envoyée. Veuillez réessayer.",
      "customer_portal.reply_plural": "Réponses",
      "customer_portal.reply_singular": "Réponse",
      "customer_portal.request_badge": "Demande",
      "customer_portal.requests.attachments": "Pièces jointes",
      "customer_portal.requests.category": "Catégorie",
      "customer_portal.requests.description": "Description",
      "customer_portal.requests.priority": "Priorité",
      "customer_portal.search_label": "Tickets suchen",
      "customer_portal.search_placeholder": "Rechercher un n° de ticket ou un objet...",
      "customer_portal.sending": "Envoi en cours...",
      "customer_portal.service_level": "Niveau de service",
      "customer_portal.show_older_replies": "Afficher {{count}} réponses plus anciennes...",
      "customer_portal.sla.met": "Respecté",
      "customer_portal.sla.on_track": "Dans les temps",
      "customer_portal.sla.overdue": "En retard",
      "customer_portal.sla.warning": "Échéance proche",
      "customer_portal.source": "Source",
      "customer_portal.source_portal": "Portail",
      "customer_portal.stop_impersonation": "Quitter l'emprunt d'identité",
      "customer_portal.support_team": "Équipe de support",
      "customer_portal.ticket_closed_desc": "Ce ticket est fermé.",
      "customer_portal.ticket_load_failed": "Ticket konnte nicht geladen werden",
      "customer_portal.ticket_load_failed_desc": "Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "customer_portal.ticket_not_found": "Ticket introuvable",
      "customer_portal.ticket_owner": "Ihr zuständiger Support-Agent",
      "customer_portal.ticket_plural": "Tickets",
      "customer_portal.ticket_singular": "Ticket",
      "customer_portal.tickets_load_failed": "Tickets konnten nicht geladen werden",
      "customer_portal.tickets_load_failed_desc": "Ihre Daten wurden nicht verändert.",
      "customer_portal.times_title": "Délais",
      "customer_portal.unassigned_owner": "Noch nicht zugewiesen",
      "customer_portal.unsaved_warning": "Ihr nicht gesendeter Entwurf geht beim Verlassen möglicherweise verloren.",
      "customer_portal.updated": "Mis à jour",
      "customer_portal.via_email": "par e-mail",
      "customer_portal.write_reply": "Rédiger une réponse",
      "customer_portal.you": "Vous",
      "customer_tickets_summary": "{{open}} ouverts / {{total}} au total",
      "customers": "Clients",
      "customize": "Personnaliser",
      "dark_mode": "Mode sombre",
      "dashboard": "Tableau de bord",
      "dashboard_sub": "Voici vos KPI opérationnels, états SLA et statistiques de tickets.",
      "days_ago": "Il y a {{count}} j",
      "delete": "Supprimer",
      "density": "Densité :",
      "density_comfort_label": "Komfort",
      "density_comfortable": "Normal",
      "density_compact": "Compact",
      "density_spacious": "Spacieux",
      "density_standard_label": "Standard",
      "device_actions": "Geräte & Lizenzen",
      "device_actions_hint": "Fernwartung, Remote-Terminal, Behebung und Lizenzen der verknüpften Geräte",
      "document.all": "Tous",
      "document.category.certificate": "Certificat",
      "document.category.contract": "Contrat",
      "document.category.correspondence": "Correspondance",
      "document.category.general": "Général",
      "document.category.invoice": "Facture",
      "document.category.manual": "Guide",
      "document.category.report": "Rapport",
      "document.none_found": "Aucun document trouvé",
      "document.none_found_desc": "Essayez un autre terme de recherche",
      "document.none_shared": "Aucun document ne vous a encore été partagé",
      "document.none_shared_desc": "Votre interlocuteur peut mettre des documents à votre disposition ici",
      "document.plural": "Documents",
      "document.search_placeholder": "Rechercher dans les documents...",
      "document.singular": "Document",
      "document.subtitle": "Vos documents, contrats et pièces partagés",
      "document.total_suffix": "au total",
      "domains": "Domaines",
      "draft_present": "Brouillon",
      "draft_saved": "Brouillon enregistré",
      "drag_to_move": "{{label}} (glisser pour déplacer)",
      "drag_to_sort": "Glisser pour trier, cliquer pour afficher/masquer",
      "duration": "Durée (min.)",
      "duration_minutes": "{{count}} minutes",
      "edit": "Modifier",
      "edit_customer": "Modifier le client",
      "edit_master_data_admin": "Modifier les données de base dans l'administration",
      "edit_widgets_title": "Afficher & Trier les widgets",
      "email": "E-mail",
      "email_channel": "Canal e-mail",
      "employee_form.account_erstellt": "Compte créé :",
      "employee_form.bitte_zuerst_kunde_auswaehlen": "Veuillez d'abord sélectionner un client",
      "employee_form.dieser_mitarbeiter_hat_noch_keinen_zugang_zu": "Ce collaborateur n'a pas encore accès au portail client. Créez un compte avec un mot de passe.",
      "employee_form.domain_waehlen": "Sélectionner un domaine",
      "employee_form.domains_werden_geladen": "Chargement des domaines...",
      "employee_form.e_mail_server_nicht_konfiguriert": "Serveur e-mail non configuré",
      "employee_form.initialpasswort_vergeben": "Définir un mot de passe initial...",
      "employee_form.interne_notizen_zum_mitarbeiter": "Notes internes sur le collaborateur...",
      "employee_form.kein_portal_zugang_vorhanden": "Aucun accès au portail",
      "employee_form.keine_domains_fuer_diesen_kunden_hinterlegt": "Aucun domaine enregistré pour ce client.",
      "employee_form.kunde_auswaehlen": "Sélectionner un client",
      "employee_form.lade_account_informationen": "Chargement des informations du compte...",
      "employee_form.leer_lassen_wenn_kein_portal_zugang_benoetig": "Laissez vide si aucun accès au portail n'est nécessaire (p. ex. avec le SSO).",
      "employee_form.letzter_login": "Dernière connexion :",
      "employee_form.neues_passwort": "Nouveau mot de passe...",
      "employee_form.neues_passwort_min_8_zeichen": "Nouveau mot de passe (8 caractères min.)",
      "employee_form.passwort_fuer_neuen_account_min_8_zeichen": "Mot de passe du nouveau compte (8 caractères min.)",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge": "Exiger le changement de mot de passe à la première connexion",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge_2": "Exiger le changement de mot de passe à la première connexion",
      "employee_form.passwortaenderung_beim_naechsten_login_erzwi": "Exiger le changement de mot de passe à la prochaine connexion",
      "employee_form.profilbild_kann_nach_dem_erstellen_hochgelad": "La photo de profil peut être téléversée après la création.",
      "employee_form.pw_aenderung_ausstehend": "Changement de MDP en attente",
      "employee_form.reset_link_24h_gueltig": "Lien de réinitialisation (valable 24 h) :",
      "employee_form.tab_access": "Portail client",
      "employee_form.tab_it": "IT et poste de travail",
      "employee_form.tab_notes": "Notes",
      "employee_form.tab_personal": "Personnel",
      "employee_form.tab_work": "Travail et contact",
      "employee_form.weitere_it_informationen_wie_betriebssystem": "D'autres informations IT telles que le système d'exploitation ou les logiciels installés peuvent être consignées dans les notes.",
      "employee_form.z_b_koeln_buero_3_og": "p. ex. Cologne, bureau 3e étage",
      "employees": "Employés",
      "employees_ca": "Employés (env.)",
      "end_edit": "Terminer l'édition",
      "enter_title_error": "Veuillez entrer un titre.",
      "escalate": "Escalader",
      "escalated": "Escaladés",
      "escalated_badge": "Escaladé",
      "expand_sidebar": "Développer la barre latérale",
      "expired": "Expiré",
      "expires_at": "Expire le",
      "expiring_soon": "Expire bientôt",
      "export_csv": "Fichier CSV",
      "export_pdf": "Document PDF",
      "export_png": "Graphique PNG",
      "export_xlsx": "Excel (XLSX)",
      "filter_active": "Filtre actif",
      "filter_all_az": "Tous A–Z",
      "filter_list_placeholder": "Filtrer la liste...",
      "filter_open_first": "Ouverts en premier",
      "filter_open_only": "Uniquement avec des ouverts",
      "filter_with_sla": "Avec niveau SLA",
      "first_post_attachments": "Pièces jointes au premier message",
      "first_response": "Première réponse",
      "follow_ups": "En attente du client",
      "generating": "Génération...",
      "greeting_day": "Bonjour, {{name}} 👋",
      "held_review": "Vérification requise",
      "high_priority": "Haute priorité",
      "hours": "Heures",
      "hours_ago": "Il y a {{count}} h",
      "inactive": "Inactif",
      "included_hours": "Heures incl.",
      "industry": "Secteur",
      "internal": "Interne",
      "internal_chat": "Chat interne",
      "internal_note": "Note interne",
      "internal_notes": "Notes internes",
      "internal_notes_placeholder": "Notes internes sur le client...",
      "invalid_datetime_error": "Date ou heure invalide.",
      "just_now": "À l'instant",
      "kb.all_articles": "Tous les articles",
      "kb.author": "Auteur",
      "kb.back_to_overview": "Retour à l'aperçu",
      "kb.browse_more": "← Parcourir d'autres articles",
      "kb.no_articles": "Aucun article de connaissance disponible pour le moment",
      "kb.no_articles_desc": "Des articles utiles apparaîtront bientôt ici",
      "kb.pinned": "Épinglé",
      "kb.read_time": "{{count}} min de lecture",
      "kb.search_placeholder": "Que recherchez-vous ? ex. VPN, mot de passe, e-mail...",
      "kb.subtitle": "Guides, conseils et aide pour vos questions",
      "kb.try_different_search": "Essayez un autre terme de recherche",
      "kb.updated_at": "Mis à jour le {{date}}",
      "kb.views_count": "{{count}} consultations",
      "keyboard_shortcuts": "Raccourcis clavier",
      "knowledge": "Base de connaissances",
      "knowledge_base": "Base de connaissances",
      "kpi_held": "Expéditeur indéterminé",
      "kpi_important": "important",
      "kpi_open": "ouvert",
      "kpi_sla_breached": "SLA dépassé",
      "kunde_loeschen.artikel": "Wissensartikel",
      "kunde_loeschen.bestaetigung_label": "Zur Bestätigung den Firmennamen eingeben",
      "kunde_loeschen.connectoren": "Connectoren",
      "kunde_loeschen.dokumente": "Dokumente",
      "kunde_loeschen.einleitung": "Dieser Kunde hat keine Tickets und keine Rechnungen. Er kann vollständig entfernt werden — mitsamt seinem Mandantenbereich in der Datenbank. Das lässt sich nicht rückgängig machen.",
      "kunde_loeschen.endgueltig_loeschen": "Endgültig löschen",
      "kunde_loeschen.fehlgeschlagen": "Das Löschen ist fehlgeschlagen.",
      "kunde_loeschen.geraete": "Geräte im Inventar",
      "kunde_loeschen.lizenzen": "Softwarelizenzen",
      "kunde_loeschen.mitarbeiter": "Mitarbeiter",
      "kunde_loeschen.netzgeraete": "Gefundene Netzwerkgeräte",
      "kunde_loeschen.nichts_dran": "An diesem Kunden hängen keine weiteren Daten.",
      "kunde_loeschen.portalbenutzer": "Portalzugänge",
      "kunde_loeschen.pruefung_fehlgeschlagen": "Die Prüfung ist fehlgeschlagen.",
      "kunde_loeschen.titel": "Kunde endgültig löschen",
      "kunde_loeschen.tokens": "API-Token",
      "kunde_loeschen.vertraege": "Verträge",
      "kunde_loeschen.wird_geprueft": "Wird geprüft …",
      "kunde_loeschen.wird_mitgeloescht": "Wird mitgelöscht",
      "kunde_loeschen.zeiten": "Zeiteinträge",
      "language": "Langue",
      "license.cluster_audit": "Audit",
      "license.cluster_balance": "Bilan",
      "license.cluster_calc": "Calculateur",
      "license.cluster_contracts": "Contrats et licences",
      "license.cluster_optimize": "Optimisation",
      "license.tab_ad_coupling": "Couplage CAL-AD",
      "license.tab_cal_calc": "Calculateur CAL",
      "license.tab_catalog": "Catalogue de logiciels",
      "license.tab_contracts": "Contrats",
      "license.tab_dashboard": "Bilan des licences & Tendances",
      "license.tab_licenses": "Gestion des licences",
      "license.tab_more_views": "Autres vues",
      "license.tab_reclaims": "Optimisation & Récupérations",
      "license.tab_remediation": "Remédiation",
      "license.tab_sealed": "Archive d'audit",
      "license.tab_sql_calc": "Calculateur de licences SQL",
      "license.tab_steering": "Contrôle",
      "license.tab_suite_config": "Configurateur de suite",
      "license_compliance.actions": "Actions",
      "license_compliance.assign_license_metric": "Affecter une métrique de licence",
      "license_compliance.confirm_delete_assignment": "Voulez-vous vraiment supprimer cette affectation ?",
      "license_compliance.confirm_delete_contract": "Voulez-vous vraiment supprimer ce contrat ? Les licences associées seront conservées, mais dissociées du contrat.",
      "license_compliance.contract_expiry_alert": "Expiration de contrat",
      "license_compliance.deficit_forecast_desc": "D'après les analyses en direct, des frais de régularisation seront dus à la date anniversaire pour les produits sous-licenciés.",
      "license_compliance.edit_contract": "Modifier le contrat",
      "license_compliance.edit_license": "Modifier la licence",
      "license_compliance.expired_contracts_title": "Contrats logiciels expirés détectés !",
      "license_compliance.expired_contracts_warning_desc": "Les licences affectées à ces contrats sont ignorées dans le calcul de conformité.",
      "license_compliance.forecasted_payment": "Régularisation prévisionnelle",
      "license_compliance.license_deficit_alert": "Déficit de licences",
      "license_compliance.mark_license_required_btn": "Marquer comme soumis à licence",
      "license_compliance.new_contract": "Créer un nouveau contrat",
      "license_compliance.new_license": "Créer une nouvelle licence",
      "license_compliance.no_deficit_desc": "Félicitations ! Vos affectations Microsoft Core/CAL couvrent tous les résultats d'analyse.",
      "license_compliance.not_catalogued": "Non catalogué",
      "license_compliance.reconciliation_desc": "Déclenche un cycle de rapprochement manuel pour ce locataire. Recalcule en direct le VM stacking, l'état de la découverte WMI, les périodes de Software Assurance et la validité des contrats.",
      "license_compliance.reconciliation_running": "Rapprochement en cours...",
      "license_compliance.run_reconciliation": "Lancer le rapprochement",
      "license_compliance.sam_warnings_title": "Avertissements SAM et conformité",
      "license_compliance.save_contract": "Enregistrer le contrat",
      "license_compliance.save_license": "Enregistrer la licence",
      "license_compliance.seal_audit": "Sceller l'audit",
      "license_compliance.seal_audit_btn": "Sceller avec valeur probante",
      "license_compliance.sealing": "Scellement en cours...",
      "license_compliance.toast.add_suite_component_error": "Erreur lors de l'affectation du composant de la suite",
      "license_compliance.toast.assignment_completed": "Affectation de licence effectuée avec succès.",
      "license_compliance.toast.assignment_error": "Erreur lors de l'exécution de l'affectation",
      "license_compliance.toast.bulk_classify_error": "Erreur lors de la classification en masse",
      "license_compliance.toast.bulk_classify_success": "{{count}} entrées logicielles classées avec succès.",
      "license_compliance.toast.calc_audit_error": "Erreur lors du calcul de l'audit de licences",
      "license_compliance.toast.contract_created": "Contrat créé avec succès.",
      "license_compliance.toast.contract_deleted": "Contrat supprimé.",
      "license_compliance.toast.contract_updated": "Contrat mis à jour avec succès.",
      "license_compliance.toast.create_purchase_req_error": "Erreur lors de la création de la demande d'achat",
      "license_compliance.toast.delete_contract_error": "Erreur lors de la suppression du contrat",
      "license_compliance.toast.delete_license_error": "Erreur lors de la suppression de la licence",
      "license_compliance.toast.delete_suite_component_error": "Erreur lors de la suppression de l'affectation",
      "license_compliance.toast.license_created": "Licence créée avec succès.",
      "license_compliance.toast.license_deleted": "Licence supprimée.",
      "license_compliance.toast.license_updated": "Licence mise à jour avec succès.",
      "license_compliance.toast.load_customers_error": "Erreur lors du chargement de la liste des clients",
      "license_compliance.toast.purchase_req_created": "Demande d'achat pour {{units}}x {{model}} (True-Up : {{cost}}) créée sous forme de ticket {{ticket}}.",
      "license_compliance.toast.reconcile_completed": "Rapprochement terminé avec succès. Les indicateurs de conformité ont été recalculés en direct.",
      "license_compliance.toast.reconcile_error": "Erreur lors du rapprochement",
      "license_compliance.toast.sam_settings_saved": "Paramètres SAM enregistrés avec succès.",
      "license_compliance.toast.save_contract_error": "Erreur lors de l'enregistrement du contrat",
      "license_compliance.toast.save_license_error": "Erreur lors de l'enregistrement de la licence",
      "license_compliance.toast.save_sam_settings_error": "Erreur lors de l'enregistrement des paramètres SAM",
      "license_compliance.toast.seal_audit_error": "Erreur lors du scellement de l'audit de licences",
      "license_compliance.toast.seal_audit_success": "Audit de licences scellé avec succès.",
      "license_compliance.toast.suite_component_added": "Composant affecté à la suite avec succès.",
      "license_compliance.toast.suite_component_deleted": "Affectation supprimée.",
      "license_compliance.toast.uninstall_error": "Erreur lors du déclenchement des désinstallations",
      "license_compliance.toast.uninstall_triggered": "Commandes de désinstallation mises en file d'attente.",
      "license_compliance.update_contract": "Mettre à jour le contrat",
      "license_compliance.update_license": "Mettre à jour la licence",
      "licenses": "Licences",
      "light_mode": "Mode clair",
      "link_asset_btn": "+ Lier un actif",
      "live_activity": "Activité en direct",
      "loading": "Wird geladen…",
      "loading_ellipsis": "Chargement...",
      "location_on_map": "Emplacement sur la carte",
      "login.abbrechen": "Annuler",
      "login.administratoradresse_konnte_nicht_geaendert_werden": "Die Administratoradresse konnte nicht geändert werden.",
      "login.adresse_aendern": "Adresse ändern",
      "login.adresse_wird_geaendert": "Adresse wird geändert…",
      "login.aendern": "Modifier",
      "login.aktivierung": "Activation…",
      "login.aktivierung_fehlgeschlagen_code_pruefen": "Échec de l'activation. Veuillez vérifier le code.",
      "login.alle_rechte_vorbehalten": "· Tous droits réservés.",
      "login.anmelden": "Se connecter",
      "login.anmelden_laeuft": "Connexion…",
      "login.anmeldung": "Connexion…",
      "login.bestaetigen": "Confirmer",
      "login.bitte_geben_sie_eine_gueltige_e_mail_adresse": "Veuillez saisir une adresse e-mail valide.",
      "login.bitte_geben_sie_ihr_passwort_ein": "Veuillez saisir votre mot de passe.",
      "login.bitte_geben_sie_zuerst_ihre_e_mail_adresse_e": "Veuillez d'abord saisir votre adresse e-mail.",
      "login.claim": "Service desk, actifs et licences — une base de données, un processus.",
      "login.datenschutz": "Confidentialité",
      "login.e_mail_adresse_erfolgreich_geaendert": "E-Mail-Adresse erfolgreich geändert. Melden Sie sich jetzt mit der neuen Adresse an.",
      "login.ein_fehler_ist_aufgetreten": "Une erreur s'est produite.",
      "login.einloggen_schliessen": "Se connecter et fermer",
      "login.erstanmeldung": "Première connexion :",
      "login.falls_ein_konto_existiert_wurde_eine_e_mail": "Si un compte existe, un e-mail de réinitialisation a été envoyé.",
      "login.fehler_beim_laden_des_mfa_setups": "Impossible de charger la configuration MFA",
      "login.fehler_beim_ueberpruefen_der_e_mail_adresse": "Impossible de vérifier l'adresse e-mail.",
      "login.geben_sie_den_6_stelligen_code_aus_ihrer_aut": "Saisissez le code à 6 chiffres de votre application d'authentification ou un code de récupération.",
      "login.geschaeftliche_e_mail": "E-mail professionnel",
      "login.ihr_account_ist_deaktiviert": "Votre compte est désactivé.",
      "login.ihr_administrator_erfordert_die_einrichtung": "Votre administrateur exige la mise en place de l'authentification à deux facteurs.",
      "login.impressum": "Mentions légales",
      "login.kunden_account_erkannt": "Compte client détecté",
      "login.manueller_schluessel": "Clé manuelle",
      "login.melden_sie_sich_an_ihrem_service_desk_an": "Connectez-vous à votre service desk.",
      "login.mfa_aktivieren_weiter": "Activer le MFA et continuer",
      "login.mfa_einrichtung_erforderlich": "Configuration MFA requise",
      "login.mfa_einrichtung_fehlgeschlagen": "Échec de la configuration MFA.",
      "login.mfa_erfolgreich_aktiviert": "MFA activé avec succès",
      "login.neue_geschaeftliche_e_mail": "Neue geschäftliche E-Mail",
      "login.oder": "OU",
      "login.passwort": "Mot de passe",
      "login.qr_code_fuer_die_authenticator_app": "QR code pour l'application d'authentification",
      "login.sechsstelliger_verifizierungscode": "Code de vérification à 6 chiffres",
      "login.sende": "Envoi…",
      "login.sicherheitszeile": "AES-256 · Double authentification · Hébergement interne",
      "login.sicherheitszeile_kurz": "AES-256 · Zwei-Faktor",
      "login.sie_werden_automatisch_zum_kundenportal_weit": "Vous allez être redirigé automatiquement vers le portail client afin de vous y connecter...",
      "login.single_sign_on_entra_id": "Single Sign-On (Entra ID)",
      "login.speichern_sie_diese_einmal_wiederherstellung": "Conservez soigneusement ces codes de récupération à usage unique ! Vous pouvez les utiliser si vous perdez l'accès à votre application.",
      "login.sso_anmeldung_fehlgeschlagen": "Échec de la connexion SSO",
      "login.startkonto_bestaetigt_adresse_festlegen": "Die Zugangsdaten des Startkontos wurden bestätigt. Legen Sie jetzt die geschäftliche Adresse für den Administrator fest.",
      "login.ueberpruefe": "Vérification...",
      "login.ungueltiger_oder_abgelaufener_mfa_code": "Code MFA invalide ou expiré.",
      "login.verifiziere": "Vérification…",
      "login.weiter": "Continuer",
      "login.willkommen_zurueck": "Bon retour",
      "login.zurueck_zum_login": "Retour à la connexion",
      "login.zuruecksetzen": "Réinitialiser",
      "login.zwei_faktor_code_totp": "Code à deux facteurs (TOTP)",
      "logout": "Se déconnecter",
      "main_navigation_rail": "Barre de navigation principale",
      "managing_director": "Directeur général",
      "managing_director_abbrev": "DG",
      "managing_director_prefix": "Direction générale :",
      "mark_all_read": "Tout marquer comme lu",
      "mark_as_resolved": "Marquer comme résolu",
      "mati.connection_error": "Erreur de connexion",
      "mati.delete": "Supprimer",
      "mati.error_failed_connection": "Échec de la connexion au service d'IA.",
      "mati.error_generation": "Erreur lors de la génération de la réponse. Veuillez réessayer.",
      "mati.gdpr_warning": "Filtre RGPD actif : les données personnelles sont automatiquement anonymisées avant la transmission.",
      "mati.greeting": "Bonjour {{name}} ! Je suis {{mascot}}. Comment puis-je t’aider dans ton travail aujourd’hui ? 🔮\\n\\nTu peux m’interroger sur :\\n- L’état du système ou la charge de travail des agents\\n- La recherche de tickets (\"Trouve les tickets non résolus à priorité élevée\")\\n- La création de tickets (\"Crée un ticket : cartouche d’imprimante vide au 2e étage\")",
      "mati.history": "Historique",
      "mati.input_placeholder": "Posez-moi une question sur les tickets ou la charge de travail, ou créez un ticket...",
      "mati.new_chat": "Nouvelle conversation",
      "mati.online_intelligent": "En ligne et intelligent",
      "mati.rename": "Renommer",
      "mati.restore_bead": "Afficher l'assistant flottant",
      "mati.restore_bead_tooltip": "Réafficher l'assistant flottant (Bead) sur le bord de l'écran",
      "mati.send_btn": "Envoyer",
      "mati.suggest.create_ticket.desc": "Imprimante en panne au 1er étage",
      "mati.suggest.create_ticket.prompt": "Crée-moi un ticket pour une imprimante en panne au 1er étage, priorité moyenne.",
      "mati.suggest.create_ticket.title": "Créer un ticket",
      "mati.suggest.search_tickets.desc": "Recherche \"base de données\"",
      "mati.suggest.search_tickets.prompt": "Trouve les tickets qui contiennent le mot \"base de données\".",
      "mati.suggest.search_tickets.title": "Rechercher des tickets",
      "mati.suggest.support_help.desc": "Aide à la rédaction de FAQ",
      "mati.suggest.support_help.prompt": "Comment formuler un refus courtois à une demande de remboursement ?",
      "mati.suggest.support_help.title": "Aide au support",
      "mati.suggest.system_status.desc": "Afficher la charge actuelle",
      "mati.suggest.system_status.prompt": "Montre-moi l'état actuel du système et un aperçu de la charge des agents.",
      "mati.suggest.system_status.title": "État du système",
      "mati.typing_text": "{{name}} écrit...",
      "mati.welcome_subtitle": "Je suis ton copilote IA intelligent. Je peux t’aider à gérer les tickets, à effectuer des recherches dans le système ou à consulter les statistiques du système.",
      "mati.welcome_title": "Bonjour ! Je suis {{name}}",
      "mati_gdpr_warning": "Filtre RGPD actif : Les données personnelles sont automatiquement anonymisées avant transmission.",
      "mati_placeholder": "Posez-moi des questions sur les tickets, la charge de travail, ou créez un ticket...",
      "mati_welcome": "Bonjour ! Je suis {{name}}",
      "meeting_error_title": "Impossible de créer la réunion Teams.",
      "meeting_success": "Réunion Teams créée.",
      "meeting_success_copy": "Réunion Teams créée, lien copié dans le presse-papiers.",
      "megamenu.active_label": "Travail",
      "megamenu.calendar_desc": "Rendez-vous et intégration du calendrier.",
      "megamenu.licenses_desc": "Conformité des licences, suites et planification du true-up.",
      "megamenu.modules": "Modules",
      "megamenu.open_calendar": "Ouvrir le calendrier",
      "megamenu.open_licenses": "Ouvrir les licences",
      "megamenu.open_problems": "Ouvrir les problèmes",
      "megamenu.problems_desc": "Gestion des problèmes et RCA (analyse des causes racines).",
      "megamenu.quick_search_commands": "Recherche rapide et commandes",
      "merge": "Zusammenführen",
      "merge_tickets": "Die beiden markierten Tickets zusammenführen",
      "mfa_settings": "Paramètres MFA",
      "minutes_ago": "Il y a {{count}} min",
      "mloffice.abgleich_fehler": "Abgleich konnte nicht gestartet werden.",
      "mloffice.abgleich_fehlgeschlagen": "Letzter Abgleich fehlgeschlagen: {{fehler}}",
      "mloffice.abgleich_gestartet": "Voll-Abgleich gestartet.",
      "mloffice.abgleich_laeuft": "Abgleich läuft",
      "mloffice.adresse": "MLOffice-Adresse",
      "mloffice.adresse_hinweis": "Basisadresse der MLOffice-Installation — ohne /api/v1.",
      "mloffice.agenten_titel": "Agenten ↔ MLOffice-Benutzer",
      "mloffice.aktion_anlegen": "Neu anlegen",
      "mloffice.aktion_entkoppeln": "Entkoppeln",
      "mloffice.aktion_entkoppeln_hinweis": "Aus dem Abgleich nehmen — der Kunde bleibt bestehen und wird wieder editierbar.",
      "mloffice.aktion_verknuepfen": "Verknüpfen",
      "mloffice.aktiv": "Aktiv",
      "mloffice.aktivieren": "Anbindung aktiv",
      "mloffice.auswahl_fehler": "Auswahl konnte nicht gespeichert werden.",
      "mloffice.bereits_uebertragen": "{{n}} Einträge im Zeitraum sind bereits übertragen und werden übersprungen.",
      "mloffice.email_eingeben": "Der Partner hat in MLOffice keine E-Mail-Adresse. E-Mail für den neuen Kunden:",
      "mloffice.entwurf_anlegen": "Entwurf anlegen",
      "mloffice.entwurf_fehler": "Entwurf konnte nicht angelegt werden.",
      "mloffice.entwurf_hinweis": "Erzeugt aus den bereits übertragenen Zeiten des Zeitraums einen ENTWURF in MLOffice. Belegnummer, Festschreibung und Versand bleiben MLOffice vorbehalten.",
      "mloffice.entwurf_ok": "Entwurf über {{h}} h in MLOffice angelegt — Festschreiben und Versand dort.",
      "mloffice.entwurf_titel": "Rechnungsentwurf in MLOffice",
      "mloffice.ereignis_closed": "Ticket geschlossen",
      "mloffice.ereignis_created": "Ticket eröffnet",
      "mloffice.ereignis_escalated": "Ticket eskaliert",
      "mloffice.ereignisse_titel": "Ticket-Ereignisse in die MLOffice-Kontakthistorie melden (nur Referenz, nie Inhalt):",
      "mloffice.erst_aktivieren": "Bitte zuerst die Anbindung aktivieren und die Verbindung testen — dann erscheint hier der MLOffice-Kundenbestand.",
      "mloffice.erst_aktivieren_abrechnung": "Bitte zuerst die Anbindung aktivieren — dann erscheinen hier offene Posten und der Kontingent-Abgleich.",
      "mloffice.erst_aktivieren_zeiten": "Bitte zuerst die Anbindung aktivieren — dann lassen sich Zeiten per Übertragungslauf nach MLOffice geben.",
      "mloffice.fallback_hinweis": "{{n}} Einträge ohne Agenten-Zuordnung werden über den technischen Benutzer gebucht (Agentenname in der Beschreibung).",
      "mloffice.feld_bis": "Bis",
      "mloffice.feld_kunde": "Kunde",
      "mloffice.feld_projekt": "MLOffice-Projekt",
      "mloffice.feld_satz": "Stundensatz (netto)",
      "mloffice.feld_von": "Von",
      "mloffice.gespeichert": "MLOffice-Einstellungen gespeichert.",
      "mloffice.gueltig_180": "180 Tage",
      "mloffice.gueltig_365": "365 Tage",
      "mloffice.gueltig_90": "90 Tage",
      "mloffice.gueltig_unbegrenzt": "Unbegrenzt",
      "mloffice.hoheit_frage": "MLOffice übernimmt die Hoheit über: {{felder}}.\\n\\nDiese Felder sind in AISupportDesk dann gesperrt und werden fortlaufend aus MLOffice übernommen. Fortfahren?",
      "mloffice.inaktiv": "Inaktiv",
      "mloffice.keine_partner": "Noch keine MLOffice-Kunden geladen. „Liste aus MLOffice laden“ holt den Bestand.",
      "mloffice.keine_zuordnung": "— keine Zuordnung —",
      "mloffice.konflikt_fehler": "Konnte nicht übernommen werden.",
      "mloffice.konflikt_geloest": "Übernommen.",
      "mloffice.konflikt_hinweis": "Übernahme braucht eine Entscheidung — siehe Konfliktzeile.",
      "mloffice.kopieren": "Kopieren",
      "mloffice.kunde_waehlen": "— Kunde wählen —",
      "mloffice.kunden_erklaerung": "Wähle aus, welche MLOffice-Kunden hier geführt werden. Ausgewählte Kunden werden fortlaufend abgeglichen; ihre Stammdaten sind hier gesperrt. Abwählen entkoppelt nur — der Kunde bleibt bestehen.",
      "mloffice.laden_fehler": "MLOffice-Einstellungen konnten nicht geladen werden.",
      "mloffice.laeufe_titel": "Bisherige Übertragungsläufe",
      "mloffice.lauf_detail": "Lauf #{{id}} — Einzelposten",
      "mloffice.lauf_fehler": "Lauf konnte nicht gestartet werden.",
      "mloffice.lauf_fertig": "Fertig",
      "mloffice.lauf_gestartet": "Übertragungslauf gestartet.",
      "mloffice.lauf_laeuft": "Läuft",
      "mloffice.lauf_starten": "Übertragung starten",
      "mloffice.lauf_teilfehler": "Mit Fehlern",
      "mloffice.linktoken_abgelaufen": "Das Verbindungstoken ist abgelaufen — MLOffice kann sich nicht mehr ausweisen. Neues Token erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_ablauf_teil": ", gültig bis {{datum}}",
      "mloffice.linktoken_einmal": "Jetzt kopieren — dieses Token wird nur EINMAL angezeigt:",
      "mloffice.linktoken_eintragen": "In MLOffice unter Einstellungen → AISupportDesk-Anbindung eintragen.",
      "mloffice.linktoken_erklaerung": "Dieses Token wird HIER erzeugt und in MLOffice unter „AISupportDesk-Anbindung“ eingetragen. MLOffice weist sich damit aus (Verbindungsstatus, Webhooks). Wird die Anbindung hier gelöst oder das Token widerrufen, zeigt MLOffice die Verbindung als gelöst.",
      "mloffice.linktoken_erzeugen": "Token erzeugen",
      "mloffice.linktoken_fehler": "Verbindungstoken konnte nicht erzeugt werden.",
      "mloffice.linktoken_gueltigkeit": "Gültigkeit",
      "mloffice.linktoken_kopiert": "Token kopiert.",
      "mloffice.linktoken_laeuft_ab": "Das Verbindungstoken läuft in {{tage}} Tagen ab. Rechtzeitig neu erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_neu": "Neues Token erzeugen",
      "mloffice.linktoken_rotieren_frage": "Es existiert bereits ein Verbindungstoken. Ein neues macht das alte sofort ungültig — MLOffice muss dann das neue Token eintragen. Fortfahren?",
      "mloffice.linktoken_status": "Hinterlegt ({{hint}}), erzeugt {{erzeugt}}{{ablauf}}.",
      "mloffice.linktoken_titel": "Verbindungstoken für MLOffice",
      "mloffice.linktoken_unbegrenzt_teil": ", unbegrenzt gültig",
      "mloffice.linktoken_widerruf_fehler": "Widerruf fehlgeschlagen.",
      "mloffice.linktoken_widerruf_frage": "Verbindungstoken widerrufen? MLOffice zeigt die Verbindung danach als gelöst; Webhooks und Statusabfragen von MLOffice werden abgewiesen.",
      "mloffice.linktoken_widerrufen": "Verbindungstoken widerrufen.",
      "mloffice.linktoken_widerrufen_btn": "Widerrufen",
      "mloffice.liste_aktualisieren": "Liste aus MLOffice laden",
      "mloffice.loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "mloffice.nur_verknuepfte": "Nur mit MLOffice verknüpfte Kunden.",
      "mloffice.ohne_email": "ohne E-Mail",
      "mloffice.op_aktualisiert": "Offene Posten aktualisiert.",
      "mloffice.op_belege": "Belege",
      "mloffice.op_fehler": "Offene Posten konnten nicht geladen werden.",
      "mloffice.op_laden": "Offene Posten aus MLOffice laden",
      "mloffice.op_stand": "Stand: {{zeit}}",
      "mloffice.op_titel": "Offene Posten (MLOffice)",
      "mloffice.partner_laden_fehler": "MLOffice-Kundenliste konnte nicht geladen werden.",
      "mloffice.posten_ok": "übertragen",
      "mloffice.posten_retry": "Erneut",
      "mloffice.posten_skip": "Überspringen",
      "mloffice.projekt_pflicht": "Bitte oben ein MLOffice-Projekt wählen.",
      "mloffice.projekt_waehlen": "— Projekt wählen —",
      "mloffice.rechte_fehlen": "Dem Token fehlen Rechte:",
      "mloffice.recon_asd": "Support-Sicht (NALVRA SERVICE)",
      "mloffice.recon_diff": "Abweichung Support- zu Abrechnungs-Sicht: {{min}} Min.",
      "mloffice.recon_gebucht": "{{min}} Min. im Projekt „{{projekt}}“ gebucht",
      "mloffice.recon_gesperrt_bis": "Erfassung gesperrt bis: {{d}}",
      "mloffice.recon_kein_projekt": "Kein MLOffice-Projekt zugeordnet (Tab „Zuordnung“).",
      "mloffice.recon_kein_vertrag": "Kein aktiver Vertrag mit Kontingent für diesen Kunden.",
      "mloffice.recon_mlo": "Abrechnungs-Sicht (MLOffice)",
      "mloffice.recon_offen": "{{min}} Min. der laufenden Periode sind noch nicht an MLOffice übertragen — Übertragungslauf im Tab „Zeiten-Übertragung“ starten.",
      "mloffice.recon_titel": "Kontingent-Abgleich",
      "mloffice.recon_verbrauch": "{{used}} von {{incl}} Min. verbraucht — {{rest}} Min. übrig",
      "mloffice.schon_drueben": "übertragen",
      "mloffice.sp_agent": "Agent",
      "mloffice.sp_beschreibung": "Beschreibung",
      "mloffice.sp_datum": "Datum",
      "mloffice.sp_fortschritt": "Gesendet / Fehler / Gesamt",
      "mloffice.sp_kunde": "Kunde",
      "mloffice.sp_minuten": "Min.",
      "mloffice.sp_status": "Status",
      "mloffice.sp_ticket": "Ticket",
      "mloffice.sp_zeitraum": "Zeitraum",
      "mloffice.spalte_kunde": "MLOffice-Kunde",
      "mloffice.spalte_status": "Status",
      "mloffice.spalte_sync": "Sync",
      "mloffice.spalte_zuordnung": "Zuordnung in NALVRA SERVICE",
      "mloffice.speichern": "Speichern",
      "mloffice.speichern_fehler": "Speichern fehlgeschlagen.",
      "mloffice.status_archiviert": "In MLOffice archiviert",
      "mloffice.status_delta": "Letzter Kundenabgleich: {{zeit}}",
      "mloffice.status_entkoppelt": "Entkoppelt",
      "mloffice.status_failed": "{{n}} Übertragungen fehlgeschlagen",
      "mloffice.status_kein_linktoken": "Kein Verbindungstoken für MLOffice erzeugt",
      "mloffice.status_konflikt": "Entscheidung nötig",
      "mloffice.status_linktoken_abgelaufen": "Verbindungstoken abgelaufen — neu erzeugen und in MLOffice eintragen",
      "mloffice.status_neu": "Neu",
      "mloffice.status_op": "Offene Posten: {{zeit}}",
      "mloffice.status_pending": "{{n}} Übertragungen offen",
      "mloffice.status_ratelimit": "MLOffice-Ratenbegrenzung — kurze Pause",
      "mloffice.status_sync_fehler": "Letzter Abgleich mit Fehler",
      "mloffice.status_uebernommen": "Übernommen",
      "mloffice.tab_abrechnung": "Abrechnung",
      "mloffice.tab_kunden": "Kundenabgleich",
      "mloffice.tab_verbindung": "Verbindung",
      "mloffice.tab_zeiten": "Zeiten-Übertragung",
      "mloffice.tab_zuordnung": "Zuordnung",
      "mloffice.techuser_hinweis": "Wird für Zeitbuchungen ohne Agenten-Zuordnung verwendet; der Agentenname wandert dann in die Buchungsbeschreibung.",
      "mloffice.techuser_titel": "Technischer Benutzer (Fallback)",
      "mloffice.test_fehler": "Verbindungstest fehlgeschlagen.",
      "mloffice.test_nicht_verbunden": "Keine Verbindung",
      "mloffice.test_ok": "Verbindung zu MLOffice steht.",
      "mloffice.test_verbunden": "Verbunden mit Mandant „{{tenant}}“",
      "mloffice.testen": "Verbindung testen",
      "mloffice.titel": "MLOffice-Anbindung",
      "mloffice.token": "API-Token",
      "mloffice.token_gesetzt": "hinterlegt ({{hint}})",
      "mloffice.token_hinweis": "In MLOffice unter Einstellungen → API-Tokens anlegen. Benötigte Rechte prüft der Verbindungstest.",
      "mloffice.token_name": "Token: {{name}}",
      "mloffice.token_unveraendert": "Leer lassen = unverändert",
      "mloffice.untertitel": "Kundenstammdaten, Abrechnung, Zeiterfassung und CRM mit MLOffice koppeln. MLOffice ist das führende System für Stammdaten und Rechnungen.",
      "mloffice.users_dropdown": "Zeitbuchungen werden in MLOffice unter dem zugeordneten Benutzer geführt. Ohne Zuordnung greift der technische Benutzer.",
      "mloffice.users_manuell": "MLOffice stellt (noch) keine Benutzerliste bereit — MLOffice-User-UUID bitte manuell eintragen (in MLOffice unter Benutzerverwaltung kopieren).",
      "mloffice.uuid_platzhalter": "MLOffice-User-UUID",
      "mloffice.verbindung": "Verbindung",
      "mloffice.vollabgleich": "Voll-Abgleich starten",
      "mloffice.vorschau": "Vorschau",
      "mloffice.vorschau_anlegen": "Wird neu angelegt",
      "mloffice.vorschau_email_fehlt": "E-Mail fehlt — wird bei Übernahme abgefragt",
      "mloffice.vorschau_fehler": "Vorschau fehlgeschlagen.",
      "mloffice.vorschau_titel": "Vorschau: {{n}} Einträge, {{h}} h werden übertragen",
      "mloffice.vorschau_verknuepfung": "Vorschlag: mit „{{name}}“ verknüpfen ({{grund}})",
      "mloffice.zeiten_erklaerung": "Zeiten werden NICHT automatisch übertragen. Du wählst Kunde und Zeitraum, prüfst die Vorschau und bestätigst — erst dann gehen die Buchungen nach MLOffice. Übertragene Buchungen sind dort unumkehrbar und hier gesperrt.",
      "mloffice.zeitraum_bis_heute": "Bis heute",
      "mloffice.zeitraum_dieser_monat": "Dieser Monat",
      "mloffice.zeitraum_letzter_monat": "Letzter Monat",
      "mloffice.zuordnung_fehler": "Zuordnung konnte nicht gespeichert werden.",
      "mloffice.zuordnung_fehlt": "{{n}} Einträge ohne Agenten-Zuordnung — bitte unter „Zuordnung“ pflegen oder einen technischen Benutzer hinterlegen.",
      "mloffice.zuordnung_gespeichert": "Zuordnung gespeichert.",
      "mobile": "Mobile",
      "move_ticket": "Verschieben",
      "my_tickets": "Mes tickets",
      "navbar_search_placeholder": "Rechercher des tickets, clients ou base de connaissances...",
      "new": "Nouveau",
      "new_activity_aria": "Nouvelle activité",
      "new_activity_title": "Nouvelle activité depuis la dernière consultation",
      "new_company": "Neue Firma",
      "new_label": "Nouveau",
      "new_ticket": "Nouveau ticket",
      "next": "Weiter",
      "no_activities_recorded": "Aucune activité enregistrée pour le moment.",
      "no_canned_responses": "Aucune réponse type",
      "no_canned_responses_hint": "Gérables dans l'administration.",
      "no_critical_tickets": "Aucun ticket critique",
      "no_customer_assigned": "Aucun client assigné",
      "no_customer_data": "Aucune donnée client chargée.",
      "no_customers_found": "Aucun client trouvé",
      "no_customers_matching": "Aucun client n'a pu être trouvé pour votre sélection de filtres ou votre requête de recherche.",
      "no_data_available": "Aucune donnée disponible",
      "no_employees_found": "Aucun employé enregistré",
      "no_notes_placeholder": "Aucune note disponible. Cliquez sur \"Modifier\" pour ajouter des notes.",
      "no_notifications": "Pas de notifications",
      "no_other_agents_online": "Actuellement aucun autre membre de l'équipe en ligne.",
      "no_results": "Aucun résultat",
      "no_tickets_found": "Aucun ticket trouvé",
      "no_tickets_found_desc": "Il n'y a actuellement aucun élément dans cette file de filtrage.",
      "no_tickets_risk": "Actuellement aucun ticket dans la fenêtre d'alerte SLA critique.",
      "not_spam": "Pas du spam",
      "notification_settings": "Paramètres de notification",
      "notification_settings_desc": "Choisissez les notifications que vous souhaitez recevoir.",
      "notification_settings_saved": "Paramètres de notification enregistrés.",
      "notifications": "Notifications",
      "notify_license_change": "Modifications de licence",
      "notify_new_reply": "Nouvelles réponses",
      "notify_new_ticket": "Nouveaux tickets",
      "notify_status_changed": "Changements de statut",
      "observers_title": "Observateurs",
      "only_visible_for": "Uniquement {{name}}",
      "only_visible_to_agents": "Visible uniquement pour les agents",
      "open_administration": "Ouvrir l'administration",
      "open_btn": "Ouvrir",
      "open_password_vault": "Ouvrir le coffre-fort de mots de passe",
      "open_quick_search": "Ouvrir la recherche rapide",
      "open_tickets": "Tickets ouverts",
      "other_tickets_count": "Autres tickets ({{count}})",
      "other_tickets_requester_count": "Autres tickets du demandeur ({{count}})",
      "overdue": "En retard",
      "overview_option_1": "1. Tableau de bord KPI standard",
      "overview_option_10": "10. Taux de violation des SLA par priorités",
      "overview_option_2": "2. Taux de résolution au premier contact (FCR) & temps de réponse",
      "overview_option_3": "3. Évolution du volume de tickets & heures de pointe",
      "overview_option_4": "4. Tendances du taux de résolution (Créés vs Résolus)",
      "overview_option_5": "5. Matrice CSAT vs temps de résolution",
      "overview_option_6": "6. Canaux de tickets & répartition des sources",
      "overview_option_7": "7. Taux d'escalade & analyse du chemin d'escalade",
      "overview_option_8": "8. Durée de vie moyenne des tickets (Vieillissement)",
      "overview_option_9": "9. Statut du backlog & vieillissement",
      "performance_queues": "Performance & Files",
      "phone": "Téléphone",
      "plan_teams_meeting": "Planifier une réunion Teams",
      "planning": "Planification",
      "please_enter_text": "Veuillez entrer du texte",
      "policy": "Politique",
      "portal_company.load_failed": "Dokumente konnten nicht geladen werden.",
      "portal_company.primary_contact": "Hauptansprechpartner",
      "portal_session.continue": "Weiterarbeiten",
      "portal_session.login": "Erneut anmelden",
      "portal_session.warning": "Ihre Sitzung endet in {{seconds}} Sekunden. Gespeicherte Entwürfe bleiben erhalten.",
      "portal_speech.denied": "Mikrofonzugriff oder Spracherkennung wurde nicht erlaubt. Bitte die Browserberechtigung prüfen.",
      "portal_speech.failed": "Spracheingabe nicht verfügbar. Bitte Mikrofon und Verbindung prüfen oder weitertippen.",
      "portal_speech.listening": "Mikrofon aktiv – bitte sprechen …",
      "portal_speech.notice": "Diktierter Text wird unten an die Beschreibung angefügt. Der Browser kann Audio zur Erkennung an seinen Sprachdienst senden.",
      "portal_speech.silence": "Keine Sprache erkannt. Bitte erneut starten.",
      "portal_speech.start": "Diktat starten",
      "portal_speech.stop": "Stoppen",
      "portal_speech.title": "Spracheingabe",
      "portal_speech.unsupported": "Dieser Browser unterstützt hier keine Spracheingabe. Sie können die Diktierfunktion Ihrer Tastatur verwenden.",
      "preview": "Aperçu",
      "previous": "Zurück",
      "primary": "Primaire",
      "priority": "Priorité",
      "priority_": "",
      "priority_critical": "Critique",
      "priority_high": "Haute",
      "priority_low": "Faible",
      "priority_medium": "Moyenne",
      "priority_urgent": "Urgent",
      "problem_cascade_close_checkbox": "Oui, fermer tous les incidents liés (recommandé)",
      "problem_cascade_close_desc": "Il y a des incidents ouverts liés. Voulez-vous les résoudre automatiquement et ajouter un commentaire avec la cause racine & la résolution ?",
      "problem_cascade_close_title": "Fermeture en cascade",
      "problem_confirm_resolve": "Confirmer & Résoudre",
      "problem_create_btn": "Créer le problème",
      "problem_create_error": "Erreur lors de la création du problème",
      "problem_create_success": "Ticket de problème créé.",
      "problem_create_title": "Créer un nouveau ticket de problème",
      "problem_created_by_on": "Créé par {{creator}} le {{date}}",
      "problem_description_label": "Description du problème",
      "problem_detail_load_error": "Erreur lors du chargement des détails du problème",
      "problem_incidents_linked": "Incidents liés",
      "problem_kedb_empty": "Aucune erreur connue",
      "problem_kedb_empty_desc": "Les problèmes classés comme erreurs connues apparaissent ici avec leur cause et leur solution de contournement.",
      "problem_kedb_load_error": "Erreur lors du chargement des erreurs connues",
      "problem_kedb_search_placeholder": "Rechercher dans les erreurs connues...",
      "problem_kedb_title": "Erreurs connues (Known Errors)",
      "problem_known_error_badge": "Erreur connue",
      "problem_known_error_checkbox": "Classer comme Known Error (erreur connue)",
      "problem_known_error_only": "Erreurs connues uniquement",
      "problem_link_btn": "Lier",
      "problem_link_error": "Erreur lors de la liaison des incidents",
      "problem_link_incident_btn": "Lier l'incident",
      "problem_link_incidents_title": "Lier des incidents",
      "problem_link_success": "Incidents associés.",
      "problem_linked_incidents": "Incidents liés",
      "problem_load_error": "Erreur lors du chargement des problèmes",
      "problem_loading": "Chargement de la gestion des problèmes ITIL...",
      "problem_mark_known_error": "Marquer comme Known Error",
      "problem_no_incidents_found": "Aucun incident lié trouvé.",
      "problem_no_tickets": "Aucun ticket de problème",
      "problem_no_tickets_desc": "Aucun ticket de problème ITIL n'est actuellement enregistré.",
      "problem_no_unlinked_found": "Aucun incident ouvert et non lié trouvé.",
      "problem_none": "—",
      "problem_none_selected": "Aucun problème sélectionné",
      "problem_none_selected_desc": "Sélectionnez un ticket de problème ITIL à gauche ou créez-en un nouveau pour gérer les données RCA.",
      "problem_open_change_confirm": "Ouvrir maintenant le nouveau ticket de changement {{num}} ?",
      "problem_raise_change_btn": "Générer un changement",
      "problem_raise_change_error": "Erreur lors de la génération du changement",
      "problem_raise_change_success": "Ticket de changement créé : {{num}}",
      "problem_raise_change_title": "Générer un changement à partir de ce problème",
      "problem_rca_title": "Problèmes ITIL (RCA)",
      "problem_resolution_note": "Note de résolution",
      "problem_resolution_note_placeholder": "Saisissez les détails de la correction finale...",
      "problem_resolve_btn": "Résoudre le problème",
      "problem_resolve_error": "Erreur lors de la résolution du problème",
      "problem_resolve_success": "Problème résolu.",
      "problem_root_cause_label": "Cause racine suspectée",
      "problem_root_cause_short": "Cause racine",
      "problem_search_placeholder": "Rechercher dans les problèmes...",
      "problem_stage_closed": "Fermé",
      "problem_stage_known_error": "Erreur connue",
      "problem_stage_label": "Statut du cycle de vie (étape du problème)",
      "problem_stage_open": "Ouvert",
      "problem_stage_resolved": "Résolu",
      "problem_stage_under_investigation": "En cours d'analyse",
      "problem_stage_updated": "Statut du cycle de vie mis à jour.",
      "problem_stage_workaround_found": "Solution de contournement trouvée",
      "problem_tab_kedb": "Base d'erreurs connues (KEDB)",
      "problem_tab_problems": "Problèmes (RCA)",
      "problem_title": "Problème ITIL : Incident récurrent",
      "problem_title_label": "Titre du problème",
      "problem_unlink_btn": "Dissocier",
      "problem_unlink_error": "Erreur lors de la dissociation",
      "problem_unlink_success": "Association supprimée.",
      "problem_update_error": "Erreur lors de la mise à jour du problème",
      "problem_update_success": "Problème mis à jour avec succès.",
      "problem_workaround_label": "Solution de contournement connue",
      "problem_workaround_short": "Contournement",
      "problems": "Problèmes",
      "queue.": "queue.",
      "queue_external_processing": "Externe Bearbeitung",
      "queues": "Files d'attente",
      "quick_access_views": "Accès rapides & vues",
      "quick_search": "Recherche rapide",
      "read_ticket_also": "lit également ce ticket",
      "reading_ticket": "Lit le ticket #{{id}}",
      "reassign_to": "Réassigner ({{name}})...",
      "recent_activities_description": "Activités récentes sur les tickets et réponses pour ce client.",
      "recent_tickets": "Tickets récents",
      "refresh": "Actualiser",
      "remove_assignment": "Supprimer l'assignation",
      "remove_attachment_aria": "Supprimer la pièce jointe {{filename}}",
      "remove_filter": "Filter entfernen",
      "reopen": "Rouvrir",
      "reply": "Répondre",
      "reply_keyboard_shortcut_hint": "Raccourci clavier : Ctrl ou Cmd + Entrée pour envoyer lorsque le curseur est dans le texte.",
      "report_active_breaches": "Violations actives",
      "report_ai_analysis": "Analyse IA",
      "report_ai_analyzing": "L'IA analyse les données du rapport...",
      "report_ai_highlights": "Faits marquants",
      "report_ai_recommendations": "Recommandations",
      "report_billable": "Facturable",
      "report_compliance": "Conformité",
      "report_export": "Exporter",
      "report_exporting": "Exportation...",
      "report_no_data": "Aucune donnée disponible",
      "report_no_data_desc": "Aucune donnée de rapport n'a pu être chargée pour cette période.",
      "report_range": "Affichage du rapport :",
      "report_total_time": "Temps total",
      "reports": "Rapports",
      "reports_desc": "Rapports & analyses de gestion des services",
      "request.additional_info": "Informations complémentaires",
      "request.back_to_dashboard": "Retour au tableau de bord",
      "request.back_to_dashboard_link": "← Tableau de bord",
      "request.back_to_list": "Retour à la liste",
      "request.back_to_requests": "← Toutes les demandes",
      "request.catalog_subtitle": "Choisissez un type de demande — un formulaire adapté vous sera proposé.",
      "request.choose_files": "Choisir des fichiers",
      "request.description_placeholder": "Décrivez votre demande…",
      "request.description_required": "Veuillez saisir une description.",
      "request.failed_load_catalog": "Impossible de charger le catalogue",
      "request.file_too_large": "Fichier trop volumineux (max. {{max}} Mo) : {{name}}",
      "request.file_type_not_allowed": "Dateityp nicht erlaubt: {{name}}",
      "request.no_requests": "Aucune demande de service n'est activée dans le portail.",
      "request.not_available": "Cette demande n'est pas disponible ou n'est pas publiée.",
      "request.optional_select": "— Facultatif —",
      "request.please_select": "— Veuillez choisir —",
      "request.remove_file": "Supprimer",
      "request.required_field": "Champ obligatoire : {{label}}",
      "request.standard_fields_info": "Champs standard : la priorité, la catégorie, la description et les pièces jointes sont inclus dans chaque demande de service. Des champs supplémentaires propres à ce type de demande peuvent suivre ci-dessous.",
      "request.submit_btn": "Envoyer la demande",
      "request.submit_failed": "Échec de l'envoi",
      "request.submitting_btn": "Envoi en cours…",
      "request_type": "Type de demande",
      "requester_title": "Demandeur",
      "reset": "Réinitialiser",
      "reset_all_filters": "Alle Filter zurücksetzen",
      "reset_filter": "Réinitialiser le filtre",
      "reset_kpi_filter": "Kachel-Filter zurücksetzen",
      "reset_to_default": "Réinitialiser par défaut",
      "resolution": "Résolution",
      "resolve": "Résoudre",
      "resolved_label": "Résolu",
      "retry": "Erneut versuchen",
      "risk": "Risque",
      "risk_minutes": "{{count}} min",
      "save": "Enregistrer",
      "save_changes": "Enregistrer les modifications",
      "save_note": "Enregistrer la note",
      "saving": "Enregistrement...",
      "scroll_to_reply": "Faire défiler vers la réponse",
      "search": "Rechercher...",
      "search_canned_responses": "Rechercher une réponse type…",
      "search_customers": "Rechercher des clients...",
      "select_company": "Firma auswählen…",
      "select_customer_placeholder": "Sélectionnez un client dans la liste",
      "self_healing": "Auto-guérison",
      "send": "Envoyer",
      "sending_ellipsis": "Envoi...",
      "settings": "Paramètres",
      "seven_days": "7 jours",
      "shortcut_back_close": "Retour / Fermer",
      "shortcut_escalate": "Escalader",
      "shortcut_focus_mode": "Mode focus",
      "shortcut_help": "Cette aide",
      "shortcut_internal_note": "Note interne",
      "shortcut_next_prev": "Ticket suivant / précédent",
      "shortcut_quick_search": "Recherche rapide",
      "shortcut_write_reply": "Écrire une réponse",
      "show_all": "Afficher tout",
      "show_full_ticket_backlog": "Afficher tout le backlog de tickets",
      "show_older_replies": "Afficher {{count}} réponses plus anciennes...",
      "sla_and_contract_title": "SLA & Contrat",
      "sla_breached_both": "Réponse et résolution dépassées",
      "sla_breached_exclamation": "SLA dépassé !",
      "sla_breached_resolution": "Résolution dépassée",
      "sla_breached_response": "Réponse dépassée",
      "sla_breaches": "Violations SLA :",
      "sla_compliance": "Conformité SLA",
      "sla_level": "Niveau SLA :",
      "sla_option_1": "1. Conformité SLA & tendances (Aperçu)",
      "sla_option_10": "10. Statistiques SLA week-ends & jours fériés",
      "sla_option_2": "2. Violations de SLA & tickets à risque",
      "sla_option_3": "3. SLA par priorité",
      "sla_option_4": "4. SLA par client / plan de service",
      "sla_option_5": "5. Conformité SLA du temps de réponse",
      "sla_option_6": "6. Conformité SLA du temps de résolution",
      "sla_option_7": "7. Violations de SLA par agent/groupe",
      "sla_option_8": "8. Causes des violations de SLA",
      "sla_option_9": "9. Aperçu des pénalités & crédits (Risque financier)",
      "sla_performance_breaches": "Performance SLA & Dépasser",
      "sla_risk": "Risque SLA",
      "sla_status_ok": "OK",
      "sort_by_label": "Trier par {{label}}",
      "spam": "Spam",
      "starred": "Favoris",
      "start": "Début",
      "status": "Statut",
      "status_closed": "Fermé",
      "status_in_progress": "En cours",
      "status_new": "Nouveau",
      "status_on_hold": "En pause",
      "status_open": "Ouvert",
      "status_resolved": "Résolu",
      "status_waiting": "En attente",
      "status_waiting_customer": "En attente du client",
      "street": "Rue",
      "subtasks": "Teilaufgaben",
      "supporting_agents": "Agents de support",
      "switch_language": "Changer de langue",
      "system_logs": "Journaux système",
      "tab_": "",
      "tab_activity": "Activité",
      "tab_agents": "Agents",
      "tab_assets": "Actifs",
      "tab_contracts": "Contrats",
      "tab_csat": "CSAT",
      "tab_custom": "Rapports personnalisés",
      "tab_customers": "Clients",
      "tab_documents": "Documents",
      "tab_employees": "Employés",
      "tab_incidents": "Incidents",
      "tab_licenses": "Licences",
      "tab_notes": "Notes",
      "tab_overview": "Aperçu",
      "tab_sla": "SLA",
      "tab_tickets": "Tickets",
      "tab_time": "Saisie des temps",
      "tab_trends": "Tendances",
      "tag_add_placeholder": "Ajouter un tag...",
      "tag_label": "Étiquette",
      "tax_number": "Numéro fiscal",
      "teams_call_start": "Démarrer l'appel Teams",
      "teams_chat_open": "Ouvrir le chat Teams",
      "teams_meeting_subject": "Réunion {{number}}",
      "teams_meeting_title": "Réunion Teams",
      "thirty_days": "30 jours",
      "ticket_assets.action_col": "Action",
      "ticket_assets.agent_offline": "Agent hors ligne",
      "ticket_assets.agent_ready": "Prêt",
      "ticket_assets.assigned_assets": "Actifs affectés au collaborateur",
      "ticket_assets.bios_label": "Version du BIOS :",
      "ticket_assets.calculating_compliance": "Calcul de l'audit de licences en cours...",
      "ticket_assets.clean_temp": "Vider le dossier Temp",
      "ticket_assets.cmd_status_completed": "Terminé",
      "ticket_assets.cmd_status_failed": "Échec",
      "ticket_assets.cmd_status_pending": "En attente",
      "ticket_assets.cmd_status_running": "En cours...",
      "ticket_assets.cmdb_alert_desc": "Cet actif dépend de / est connecté à :",
      "ticket_assets.cmdb_alert_title": "Alerte de cascade CMDB : incident sur une dépendance !",
      "ticket_assets.command_execution_failed": "Échec de l'exécution de la commande.",
      "ticket_assets.command_placeholder": "ex. ipconfig /all, systeminfo, dir",
      "ticket_assets.command_running": "La commande est en cours d'exécution sur l'appareil client...",
      "ticket_assets.command_success_solved": "Exécution réussie ! Le ticket a été résolu automatiquement.",
      "ticket_assets.command_timeout": "Délai dépassé lors de l'exécution de la commande.",
      "ticket_assets.compliant": "Conforme",
      "ticket_assets.confirm_kill_process": "Voulez-vous vraiment arrêter le processus dont le PID est {{pid}} ?",
      "ticket_assets.cpu_cores_label": "Cœurs :",
      "ticket_assets.cpu_label": "Processeur (CPU)",
      "ticket_assets.cpu_sockets_label": "Sockets :",
      "ticket_assets.cpu_util_label": "Utilisation CPU",
      "ticket_assets.created_label": "Créé :",
      "ticket_assets.device_scan_label": "Analyse de l'appareil",
      "ticket_assets.disk_free_label": "libre",
      "ticket_assets.disk_used_label": "Utilisé",
      "ticket_assets.disks_label": "Disques durs / lecteurs",
      "ticket_assets.domain_label": "Groupe de travail/domaine :",
      "ticket_assets.edition_id_label": "ID d'édition :",
      "ticket_assets.employee_assets": "Actifs du collaborateur",
      "ticket_assets.error_kill_process": "Erreur lors de l'arrêt du processus : {{error}}",
      "ticket_assets.error_loading_monitoring": "Erreur lors du chargement de la supervision",
      "ticket_assets.error_sending_command": "Erreur lors de l'envoi de la commande.",
      "ticket_assets.error_submit_command": "Impossible de transmettre la commande : {{error}}",
      "ticket_assets.executed_label": "Exécuté :",
      "ticket_assets.fetch_logs_btn": "Récupérer les journaux",
      "ticket_assets.filter_processes_placeholder": "Filtrer les processus (nom, PID)...",
      "ticket_assets.fix_dns": "Réparer le DNS",
      "ticket_assets.fix_spooler": "Réparer le spouleur",
      "ticket_assets.hostname_label": "Nom réseau :",
      "ticket_assets.incomplete_summary": "Résumé de conformité incomplet.",
      "ticket_assets.invalid_json_response": "Réponse non valide du serveur",
      "ticket_assets.kill_btn": "Arrêter",
      "ticket_assets.killing_proc": "Arrêt en cours...",
      "ticket_assets.last_scan_label": "Dernière analyse :",
      "ticket_assets.license_compliance": "Conformité des licences",
      "ticket_assets.link": "Associer",
      "ticket_assets.link_asset_title": "Associer un actif",
      "ticket_assets.linked": "Associé",
      "ticket_assets.linked_assets": "Actifs associés au ticket",
      "ticket_assets.loading": "Chargement des actifs...",
      "ticket_assets.loading_command_queue": "Chargement de la file d'attente des commandes...",
      "ticket_assets.loading_logs": "Chargement des journaux d'événements...",
      "ticket_assets.loading_monitoring": "Chargement de la supervision en direct et de la vérification CMDB...",
      "ticket_assets.log_name_label": "Nom du journal",
      "ticket_assets.memory_col": "Mémoire vive",
      "ticket_assets.model_label": "Modèle :",
      "ticket_assets.monitored_ok": "Supervisé (OK)",
      "ticket_assets.more_params_title": "Autres paramètres",
      "ticket_assets.motherboard_label": "Carte mère :",
      "ticket_assets.no_active_zabbix_alerts": "Aucune alerte Zabbix active.",
      "ticket_assets.no_assets_assigned": "Aucun actif informatique n'est affecté à ce collaborateur.",
      "ticket_assets.no_assets_linked": "Aucun actif associé.",
      "ticket_assets.no_commands_executed": "Aucune commande exécutée pour le moment. Saisissez une commande ci-dessous.",
      "ticket_assets.no_compliance_available": "Aucune licence ni rapport de conformité disponible.",
      "ticket_assets.no_employee_assigned": "Aucun collaborateur n'est affecté à ce ticket.",
      "ticket_assets.no_hardware_details": "Aucun détail matériel analysé.",
      "ticket_assets.no_matching_software": "Aucune entrée logicielle correspondante trouvée.",
      "ticket_assets.no_monitoring_data": "Aucune donnée de supervision disponible",
      "ticket_assets.os_arch_label": "Architecture :",
      "ticket_assets.os_label": "Système d'exploitation",
      "ticket_assets.os_ver_label": "Version :",
      "ticket_assets.overlicensed": "Sur-licencié",
      "ticket_assets.pagination_text": "Page {{page}} sur {{total}} ({{count}} entrées)",
      "ticket_assets.process_name_col": "Nom du processus",
      "ticket_assets.publisher_col": "Éditeur",
      "ticket_assets.query_realtime_btn": "Interroger en temps réel",
      "ticket_assets.ram_label": "Mémoire vive (RAM)",
      "ticket_assets.ram_util_label": "Utilisation RAM",
      "ticket_assets.scan_details_btn": "Détails de l'analyse",
      "ticket_assets.scan_never": "jamais",
      "ticket_assets.search_logs_placeholder": "Rechercher dans les résultats (source, ID, message)...",
      "ticket_assets.search_placeholder": "Rechercher un nom, une IP ou un n° de série...",
      "ticket_assets.search_software_placeholder": "Rechercher un logiciel...",
      "ticket_assets.self_healing_title": "Auto-réparation et automatisation",
      "ticket_assets.send_btn": "Envoyer",
      "ticket_assets.sending_command_failed": "Échec de l'envoi de la commande.",
      "ticket_assets.serial_number_label": "Numéro de série :",
      "ticket_assets.severity_all": "Toutes",
      "ticket_assets.severity_error": "Erreur (Error)",
      "ticket_assets.severity_info": "Information",
      "ticket_assets.severity_label": "Gravité",
      "ticket_assets.severity_warning": "Avertissement (Warning)",
      "ticket_assets.sn_label": "N° de série :",
      "ticket_assets.software_name_col": "Nom du logiciel",
      "ticket_assets.sql_instance_label": "Instance :",
      "ticket_assets.sql_instances_title": "Instances SQL Server détectées",
      "ticket_assets.sql_patchlevel_label": "Niveau de correctif :",
      "ticket_assets.success_kill_process": "Processus arrêté avec succès.",
      "ticket_assets.surplus_label": "Excédent :",
      "ticket_assets.timeout_kill_process": "Délai dépassé lors de l'arrêt du processus.",
      "ticket_assets.total_ram_desc": "Mémoire physique totale",
      "ticket_assets.underlicensed": "Sous-licencié",
      "ticket_assets.unlink_asset_title": "Dissocier",
      "ticket_assets.unreachable": "Injoignable",
      "ticket_assets.version_col": "Version",
      "ticket_assets.virtualization_label": "Virtualisation :",
      "ticket_assets.waiting_agent_response": "En attente de la réponse de l'agent...",
      "ticket_assets.waiting_agent_timeout": "Délai dépassé : l'agent n'a pas répondu à temps.",
      "ticket_assets.zabbix_live_status": "État Zabbix en direct",
      "ticket_created": "Ticket créé",
      "ticket_detail.achtung_ueberschneidungskollisionen_ci_abhae": "Attention : des conflits de chevauchement (dépendances de CI) ont été détectés !",
      "ticket_detail.aktivitaeten": "Activités",
      "ticket_detail.aktivitaets_verlauf": "Historique des activités",
      "ticket_detail.als_diesen_kunden_im_portal_anmelden": "Se connecter au portail en tant que ce client",
      "ticket_detail.anhaenge": "Pièces jointes",
      "ticket_detail.begruendung_kommentare": "Justification / commentaires",
      "ticket_detail.bekannter_fehler_workaround_verfuegbar": "Erreur connue — solution de contournement disponible",
      "ticket_detail.cab_hat_die_aenderung_abgelehnt": "Le CAB a rejeté le changement",
      "ticket_detail.change_advisory_board_cab_stimmen": "Votes du Change Advisory Board (CAB)",
      "ticket_detail.das_ticket_existiert_nicht_oder_wurde_geloes": "Le ticket n'existe pas ou a été supprimé.",
      "ticket_detail.der_status_kann_erst_auf_in_bearbeitung_oder": "Le statut ne peut passer à « En cours » ou « Résolu » qu'une fois la majorité du CAB obtenue.",
      "ticket_detail.detaillierte_schritte_zur_durchfuehrung": "Étapes détaillées de mise en œuvre...",
      "ticket_detail.es_wurde_noch_kein_change_plan_fuer_dieses_t": "Aucun plan de changement n'a encore été créé pour ce ticket.",
      "ticket_detail.es_wurden_andere_aktive_tickets_auf_denselbe": "D'autres tickets actifs ont été planifiés sur les mêmes actifs CMDB ou sur des actifs dépendants pendant la même période :",
      "ticket_detail.extrahierte_daten": "Données extraites",
      "ticket_detail.geplanter_start_wartungsfenster": "Début planifié (fenêtre de maintenance)",
      "ticket_detail.geplantes_ende": "Fin planifiée",
      "ticket_detail.geplantes_wartungsfenster": "Fenêtre de maintenance planifiée :",
      "ticket_detail.hinzufuegen": "Ajouter",
      "ticket_detail.keine_aktivitaeten_vorhanden": "Aucune activité",
      "ticket_detail.keine_anhaenge_vorhanden": "Aucune pièce jointe",
      "ticket_detail.keine_kategorie": "Aucune catégorie",
      "ticket_detail.kommentar_zur_entscheidung_optional": "Commentaire sur la décision (facultatif)...",
      "ticket_detail.loeschen": "Supprimer",
      "ticket_detail.niemand_zugewiesen": "Aucune affectation",
      "ticket_detail.noch_keine_stimmen_abgegeben": "Aucun vote exprimé pour le moment.",
      "ticket_detail.noch_keine_zeit_erfasst": "Aucun temps saisi pour le moment",
      "ticket_detail.nur_fuer_mitarbeiter_sichtbar": "Visible uniquement par les collaborateurs",
      "ticket_detail.prioritaet": "Priorité",
      "ticket_detail.sprachnotizen_in_administration_ki_einstellu": "Activez les notes vocales dans Administration → Paramètres IA.",
      "ticket_detail.sprachnotizen_nicht_aktiv": "Notes vocales non activées",
      "ticket_detail.stimme_uebermitteln": "Soumettre le vote",
      "ticket_detail.tag_entfernen": "Supprimer le tag",
      "ticket_detail.tag_hinzufuegen": "Ajouter un tag…",
      "ticket_detail.tag_hinzufuegen_2": "Ajouter un tag",
      "ticket_detail.ticket_nicht_gefunden": "Ticket introuvable",
      "ticket_detail.ticket_wird_geladen": "Chargement du ticket...",
      "ticket_detail.timer_laeuft_fuer_anderes_ticket": "Le chronomètre est actif sur un autre ticket",
      "ticket_detail.timer_starten": "Démarrer le chronomètre",
      "ticket_detail.timer_stoppen": "Arrêter le chronomètre",
      "ticket_detail.uebersicht": "Vue d'ensemble",
      "ticket_detail.veroeffentlicht": "Publié",
      "ticket_detail.was_wurde_erledigt": "Qu'est-ce qui a été fait ?",
      "ticket_detail.welches_risiko_besteht_fuer_den_betrieb": "Quel risque cela présente-t-il pour l'exploitation ?",
      "ticket_detail.wie_machen_wir_aenderungen_rueckgaengig": "Comment annuler les modifications ?",
      "ticket_detail.wie_wird_die_funktion_verifiziert": "Comment la fonctionnalité est-elle vérifiée ?",
      "ticket_detail.zeiteintraege": "Saisies de temps",
      "ticket_detail.zugewiesen_an": "Affecté à",
      "ticket_detail.zugewiesen_an_2": "Affecté à",
      "ticket_detail.zurueck_zur_uebersicht": "Retour à la vue d'ensemble",
      "ticket_detail.zustimmung_des_change_advisory_boards_cab_zw": "L'approbation du Change Advisory Board (CAB) est obligatoire",
      "ticket_filter_active_label": "Filter aktiv",
      "ticket_inventory_kpis": "Kennzahlen & Arbeitslast",
      "ticket_properties_title": "Ticket",
      "ticket_relations": "Verknüpfte Tickets",
      "ticket_view_search_label": "Diese Ticketansicht durchsuchen",
      "tickets": "Tickets",
      "tickets_exist_hint": "Insgesamt sind {{count}} Tickets vorhanden.",
      "tickets_near_sla_breach": "Tickets proches d'un dépassement de SLA",
      "tickets_plural": "{{count}} tickets",
      "tickets_ratio_label": "{{count}} sur {{total}} tickets",
      "tickets_selected": "{{count}} tickets sélectionnés",
      "tickets_without_assignee": "Tickets sans agent assigné",
      "time_logged": "Temps enregistré : {{time}}",
      "time_minutes": "Zeit in Minuten",
      "title": "Titre",
      "to_reply_composer": "Vers la réponse (Composer)",
      "today_due": "Échéance aujourd'hui",
      "toggle_design_mode": "Basculer le mode sombre",
      "toggle_favorite": "Basculer le favori",
      "tracked_hours": "{{hours}} h",
      "tracked_hours_min": "{{hours}} h {{minutes}} m",
      "tracked_min": "{{minutes}} min.",
      "tracked_time": "Temps enregistré",
      "unassigned": "Non assignés",
      "unlink_asset": "Dissocier",
      "unread": "Non lu",
      "update": "Actualiser",
      "updated_at": "Mis à jour",
      "urgent": "Urgent",
      "user_profile_logout": "Profil utilisateur et déconnexion",
      "vat_id": "TVA intracommunautaire",
      "views": "Vues",
      "voice_notes_admin_hint": "Notes vocales : Activez les 'Notes vocales' dans Administration → Paramètres IA.",
      "voice_notes_enable_info": "Activez les notes vocales dans Administration → Paramètres IA (basculez 'Notes vocales').",
      "voice_notes_not_active": "Notes vocales non actives",
      "website": "Site web",
      "widget_critical_tickets": "Tickets critiques (Urgence)",
      "widget_group_analytics_team": "Analyses & Équipe",
      "widget_group_overview_performance": "Aperçu & Performance",
      "widget_group_volume_trends": "Volume & Tendances",
      "widget_my_open_tickets": "Mes tickets ouverts",
      "widget_performance_times": "Temps de performance & effort",
      "widget_priority_chart": "Distribution des priorités",
      "widget_sla_compliance": "Conformité SLA & risque",
      "widget_status_chart": "Distribution des statuts de tickets",
      "widget_team_presence": "Présence de l'équipe & activité",
      "widget_ticket_trends": "Tendances des tickets & volume",
      "widget_top_customers": "Principaux clients par tickets",
      "zip_code": "Code postal"
    }
  },
  "es": {
    "translation": {
      "access_denied": "Acceso denegado",
      "access_denied_desc": "Necesita permisos de agente o administrador.",
      "actions": "Acciones",
      "activate_dark_mode": "Activar modo oscuro",
      "activate_light_mode": "Activar modo claro",
      "active": "Activo",
      "active_filters": "Aktive Filter",
      "active_open_assignments": "Asignaciones activas y abiertas",
      "activity_optional": "Actividad (opcional)",
      "admin": "Admin",
      "admin_dashboard.administrative_berechtigungen": "Permisos administrativos",
      "admin_dashboard.aendern": "Cambiar",
      "admin_dashboard.agent_deaktiviert": "Agente desactivado",
      "admin_dashboard.agent_erstellt": "Agente creado",
      "admin_dashboard.agent_gespeichert": "Agente guardado",
      "admin_dashboard.agent_ohne_zuordnung_hinweis": "Sin asignación, este agente ve {{umfang}} los clientes. En cuanto se le asigne al menos un cliente, el agente queda limitado a esos clientes: tickets, informes y activos.",
      "admin_dashboard.agenten_in_der_kundenkonsole": "Agentes en la consola de clientes",
      "admin_dashboard.aktuelles_passwort": "Contraseña actual",
      "admin_dashboard.alle_eingehenden_befehle_wurden_bereits_vera": "Todos los comandos entrantes ya se han procesado o están aprobados.",
      "admin_dashboard.alle_kunden": "Todos los clientes",
      "admin_dashboard.als_hauptkategorie_erstellen": "Crear como categoría principal",
      "admin_dashboard.api_token_hinweis": "Si es necesario, cree previamente un token de API en la pestaña {{reiter}} con el ámbito {{scope}}.",
      "admin_dashboard.aufloesungszeit": "Tiempo de resolución *",
      "admin_dashboard.basic_auth_benutzername_passwort": "Basic Auth (usuario/contraseña)",
      "admin_dashboard.bei_prefix_u00c4nderung_werden_alle_bestehen": "Al cambiar el prefijo, todos los tickets existentes se renombran automáticamente.",
      "admin_dashboard.benoetigte_berechtigung": "Permiso necesario:",
      "admin_dashboard.bestaetigen": "Confirmar",
      "admin_dashboard.bezeichnung_positionszeile": "Descripción de la línea de factura",
      "admin_dashboard.bitte_kunde_waehlen": "Seleccione un cliente...",
      "admin_dashboard.bitte_kunde_waehlen_2": "Seleccione un cliente...",
      "admin_dashboard.definieren_sie_hauptkategorien_und_bis_zu_zw": "Defina categorías principales y hasta dos niveles de subcategorías. Se ofrecerán como opciones al crear un ticket.",
      "admin_dashboard.definiert_die_standard_reihenfolge_der_queue": "Define el orden predeterminado de las colas en la barra lateral del agente.",
      "admin_dashboard.details_anzeigen": "Ver detalles",
      "admin_dashboard.details_anzeigen_2": "Ver detalles",
      "admin_dashboard.die_smtp_einstellungen_fuer_den_e_mail_versa": "Los ajustes SMTP para el envío de correo electrónico se configuran ahora de forma centralizada en",
      "admin_dashboard.e_mail_versand_smtp_wird_unter_e_mail_einste": "El envío de correo electrónico (SMTP) se configura en Ajustes de correo electrónico",
      "admin_dashboard.eine_sicherheitsgruppe_legt_fest_welche_kons": "Un grupo de seguridad define qué módulos de la consola ve un agente. «Acceso completo» = todos los módulos. Los permisos de Admin son independientes de ello.",
      "admin_dashboard.einstellungen_speichern": "Guardar ajustes",
      "admin_dashboard.eintraege": "Entradas",
      "admin_dashboard.endgeraet": "Dispositivo",
      "admin_dashboard.endgueltig_loeschen": "Endgültig löschen",
      "admin_dashboard.entwurfsrechnung_aus_zeiteintraegen": "Borrador de factura a partir de las entradas de tiempo",
      "admin_dashboard.erstellen_sie_ihre_erste_automatisierung": "Cree su primera automatización",
      "admin_dashboard.erstellen_sie_oben_ihre_erste_hauptkategorie": "Cree arriba su primera categoría principal",
      "admin_dashboard.externer_mitarbeiter_dienstleister": "Empleado externo / proveedor de servicios",
      "admin_dashboard.fehler_beim_deaktivieren": "Error al desactivar",
      "admin_dashboard.fehler_beim_deaktivieren_2": "Error al desactivar",
      "admin_dashboard.fehler_beim_deaktivieren_3": "Error al desactivar",
      "admin_dashboard.fehler_beim_loeschen": "Error al eliminar",
      "admin_dashboard.firma_adresse_kontakt_steuernummern_in_der_u": "Empresa, dirección, contacto y números fiscales editables en la vista general. La desactivación de clientes queda reservada al administrador.",
      "admin_dashboard.fuer_entra_id_benoetigen_sie_eine_app_regist": "Para Entra ID necesita un registro de aplicación en Azure Portal con el permiso Mail.Read.",
      "admin_dashboard.geloescht": "Eliminado",
      "admin_dashboard.geloescht_2": "Eliminado",
      "admin_dashboard.installationspaket_herunterladen": "Descargar el paquete de instalación",
      "admin_dashboard.kategorie_aktualisiert": "Categoría actualizada",
      "admin_dashboard.kategorie_erstellt": "Categoría creada",
      "admin_dashboard.kategorie_geloescht": "Categoría eliminada",
      "admin_dashboard.keine_abteilung": "Sin departamento",
      "admin_dashboard.keine_ausstehenden_befehls_freigaben_vorhand": "No hay aprobaciones de comandos pendientes.",
      "admin_dashboard.keine_workflows_konfiguriert": "No hay flujos de trabajo configurados",
      "admin_dashboard.keine_zuordnung_dieser_agent_sieht_alle_kund": "Sin asignación: este agente ve todos los clientes.",
      "admin_dashboard.konfigurieren_sie_sprachmodelle_auto_respons": "Configure modelos de lenguaje, prompts de respuesta automática y plantillas del sistema",
      "admin_dashboard.kunde_auswaehlen": "Seleccionar cliente *",
      "admin_dashboard.kunde_deaktiviert": "Cliente desactivado",
      "admin_dashboard.kunde_erstellt": "Cliente creado",
      "admin_dashboard.kunde_geloescht": "Kunde „{{firma}}\" wurde endgültig gelöscht",
      "admin_dashboard.kunde_gespeichert": "Cliente guardado",
      "admin_dashboard.kunde_waehlen": "Seleccionar cliente…",
      "admin_dashboard.kundenzuordnung_verwalten": "Gestionar la asignación de clientes",
      "admin_dashboard.laden_sie_ein_fertiges_zip_archiv_fuer": "Descargue un archivo ZIP listo para usar para",
      "admin_dashboard.laedt": "Cargando…",
      "admin_dashboard.laengengrad": "Longitud",
      "admin_dashboard.legen_sie_fest_welche_daten_der_installierte": "Defina qué datos recopila el agente instalado y configure el escáner de red sin agente opcional (ping de subred).",
      "admin_dashboard.letzte_exporte": "Últimas exportaciones",
      "admin_dashboard.lexoffice_artikel_uuid_optional_dienstleistu": "UUID de artículo de Lexoffice (opcional, servicio)",
      "admin_dashboard.lexoffice_deaktiviert_hinweis": "La integración de LexOffice está desactivada actualmente. Solo podrá crear borradores de factura cuando active y configure la integración en {{bereich}}.",
      "admin_dashboard.lexoffice_einstellungen_konnten_nicht_gelade": "No se han podido cargar los ajustes de Lexoffice (ejecute la migración o reinicie el servidor).",
      "admin_dashboard.loeschen": "Eliminar",
      "admin_dashboard.loeschen_2": "Eliminar",
      "admin_dashboard.mailbox_empfang_imap_oauth_wird_unter_postfa": "La recepción de correo (IMAP/OAuth) se configura en Buzones",
      "admin_dashboard.mailbox_speichern": "Guardar buzón",
      "admin_dashboard.microsoft_graph_api": "Microsoft Graph API",
      "admin_dashboard.mit_einem_frisch_generierten_api_schluessel": "con una clave de API recién generada y una",
      "admin_dashboard.mitarbeiter_deaktiviert": "Empleado desactivado",
      "admin_dashboard.mitarbeiter_erstellt": "Empleado creado",
      "admin_dashboard.mitarbeiter_gespeichert": "Empleado guardado",
      "admin_dashboard.mloffice_gefuehrt": "Stammdaten werden von MLOffice geführt",
      "admin_dashboard.mloffice_geloest": "Mit MLOffice verknüpft — Abgleich derzeit gelöst",
      "admin_dashboard.module_assets": "Activos",
      "admin_dashboard.module_calendar": "Calendario",
      "admin_dashboard.module_customers": "Clientes",
      "admin_dashboard.module_knowledge": "Base de conocimiento",
      "admin_dashboard.module_licenses": "Licencias",
      "admin_dashboard.module_problems": "Problemas",
      "admin_dashboard.module_reports": "Informes",
      "admin_dashboard.module_tickets": "Tickets",
      "admin_dashboard.nach_kunde_filtern": "Filtrar por cliente",
      "admin_dashboard.neue_mailbox_konfiguration": "Nueva configuración de buzón",
      "admin_dashboard.neuer_workflow": "Nuevo flujo de trabajo",
      "admin_dashboard.neues_passwort": "Nueva contraseña",
      "admin_dashboard.nicht_abrechenbar": "No facturable",
      "admin_dashboard.noch_keine_kategorien_definiert": "Aún no hay categorías definidas",
      "admin_dashboard.noch_keine_zeiteintraege_vorhanden": "Aún no hay entradas de tiempo",
      "admin_dashboard.nur_abrechenbare_eintraege_ohne_vorherigen_l": "Solo entradas facturables sin exportación previa a Lexoffice; de forma opcional, filtre por ID de contrato.",
      "admin_dashboard.optionale_beschreibung_des_sla_umfangs": "Descripción opcional del alcance del SLA",
      "admin_dashboard.passwort_aendern": "Cambiar contraseña",
      "admin_dashboard.primaer": "Principal",
      "admin_dashboard.prioritaet_geaendert": "• Prioridad modificada",
      "admin_dashboard.pruefinterval_minuten": "Intervalo de comprobación (minutos)",
      "admin_dashboard.refresh_token": "Refresh Token",
      "admin_dashboard.sie_koennen_den_agenten_auch_manuell_registr": "También puede registrar el agente manualmente. Utilice para ello la siguiente sintaxis en el cliente (requiere permisos de administrador):",
      "admin_dashboard.standardmaessig_duerfen_agenten_kunden_stamm": "De forma predeterminada, los agentes solo pueden leer los datos maestros de los clientes y consultar sus documentos. Aquí puede activar permisos de escritura ampliados para cada ajuste.",
      "admin_dashboard.status_geaendert": "• Estado modificado",
      "admin_dashboard.stundensatz_ueberschreiben_optional": "Sobrescribir la tarifa por hora (opcional)",
      "admin_dashboard.tarif_erweitern": "Ampliar la tarifa",
      "admin_dashboard.ticket_id_format_und_admin_passwort_koennen": "Aquí puede configurar el formato del ID de ticket y la contraseña de Admin",
      "admin_dashboard.top_kunden_nach_ticketvolumen": "Principales clientes por volumen de tickets",
      "admin_dashboard.uebergeordnete_kategorie": "Categoría superior",
      "admin_dashboard.unterkategorie_hinzufuegen": "Añadir subcategoría",
      "admin_dashboard.upload_metadaten_bearbeiten_und_loeschen_von": "Subir archivos, editar metadatos y eliminarlos en la pestaña «Documentos» del cliente.",
      "admin_dashboard.verfuegbare_trigger": "Disparadores disponibles",
      "admin_dashboard.verwalten_und_genehmigen_sie_ausstehende_adm": "Gestione y apruebe los comandos administrativos pendientes de otros administradores antes de su ejecución en los dispositivos cliente.",
      "admin_dashboard.voller_zugriff_alle_module": "Acceso completo (todos los módulos)",
      "admin_dashboard.vorkonfiguriertes_paket_zip": "Paquete preconfigurado (.zip)",
      "admin_dashboard.was_bedeuten_die_gruppen": "¿Qué significan los grupos?",
      "admin_dashboard.workflow_automatisierungen": "Automatizaciones de flujos de trabajo",
      "admin_dashboard.z_b_hauptsitz_koeln": "p. ej., sede central de Colonia",
      "admin_dashboard.zeit_standardmaessig_abrechenbar": "Tiempo facturable de forma predeterminada",
      "admin_dashboard.zeitbuchung_bei_ticket_schliessung_erforderl": "Registro de tiempo obligatorio al cerrar el ticket",
      "admin_dashboard.zeitbuchungen_erscheinen_hier_sobald_agenten": "Los registros de tiempo aparecerán aquí en cuanto los agentes imputen tiempo a los tickets.",
      "admin_dashboard.zeiteintraege": "Entradas de tiempo",
      "admin_dashboard.zeiterfassung_aktivieren": "Activar el registro de tiempos",
      "admin_dashboard.zeiterfassung_einstellungen": "Ajustes del registro de tiempos",
      "admin_dashboard.zugriff_verweigert": "Acceso denegado",
      "admin_dashboard.zugriff_verweigert_text": "No dispone de los permisos administrativos necesarios para consultar o gestionar el área {{bereich}}.",
      "admin_dashboard.zuordnung_entfernen": "Eliminar asignación",
      "admin_dashboard.zusaetzliche_admin_rechte": "Permisos de Admin adicionales",
      "admin_default": "Predeterminado de administración",
      "admin_only_change": "(solo un administrador puede cambiar la asignación.)",
      "admin_overview.aktive_warnungen_risiken": "Avisos y riesgos activos",
      "admin_overview.alles_in_ordnung": "Todo en orden",
      "admin_overview.datenbank_engine": "Motor de base de datos",
      "admin_overview.einstellungen_filtern": "Filtrar ajustes...",
      "admin_overview.hinweis_fuer_administratoren": "Nota para administradores:",
      "admin_overview.keine_ergebnisse_gefunden": "No se han encontrado resultados",
      "admin_overview.keine_warnungen_oder_kritischen_meldungen": "No hay avisos ni mensajes críticos.",
      "admin_overview.lade_dashboard_daten": "Cargando los datos del panel...",
      "admin_overview.system_status": "Estado del sistema",
      "admin_overview.upgrade_erforderlich": "Actualización necesaria",
      "admin_overview.upgrade_erforderlich_2": "Actualización necesaria",
      "admin_overview.versuchen_sie_es_mit_einem_anderen_suchbegri": "Pruebe con otro término de búsqueda.",
      "admin_overview.zurueck_zum_agent_dashboard": "Volver al panel del agente",
      "admin_view": "Vista de Administrador",
      "administration": "Administración",
      "administrator": "Administrador",
      "agent": "Agente",
      "agent_available": "Disponible",
      "agent_console": "Consola de agente",
      "agent_console.alle_als_gelesen": "Marcar todo como leído",
      "agent_console.anhaenge": "Archivos adjuntos",
      "agent_console.anhaenge_zum_eroeffnungsbeitrag": "Archivos adjuntos del mensaje inicial",
      "agent_console.back_to_ticket_list": "Zurück zur Liste",
      "agent_console.beschreiben_sie_hier_details_die_dem_partner": "Describa aquí los detalles que se deben comunicar al socio...",
      "agent_console.bitte_waehlen": "-- Seleccione --",
      "agent_console.detailansicht_schliessen": "Cerrar la vista de detalle",
      "agent_console.erneut_oeffnen": "Reabrir",
      "agent_console.hinweis_der_partner_erhaelt_eine_benachricht": "Nota: el socio recibirá un correo de notificación con sus datos y un enlace seguro para tramitar el ticket.",
      "agent_console.interner_chat": "Chat interno",
      "agent_console.interner_chat_2": "Chat interno",
      "agent_console.keine_benachrichtigungen": "Sin notificaciones",
      "agent_console.language_selection": "Selección de idioma",
      "agent_console.loesen": "Resolver",
      "agent_console.mir_zuweisen": "Asignármelo",
      "agent_console.nachricht_notiz_fuer_den_partner_optional": "Mensaje / nota para el socio (opcional)",
      "agent_console.neues_ticket": "Nuevo ticket",
      "agent_console.neues_ticket_2": "Nuevo ticket",
      "agent_console.partner_dienstleister_waehlen": "Seleccionar socio proveedor de servicios",
      "agent_console.schliessen": "Cerrar",
      "agent_console.schliessen_2": "Cerrar",
      "agent_console.schliessungsgrund": "Motivo de cierre:",
      "agent_console.schnellsuche_oeffnen": "Abrir la búsqueda rápida",
      "agent_console.sie_benoetigen_agent_oder_admin_rechte": "Necesita permisos de agente o de Admin.",
      "agent_console.tastenkuerzel": "Atajos de teclado",
      "agent_console.ticket_erstellt": "Ticket creado",
      "agent_console.ticket_schliessen": "Cerrar el ticket",
      "agent_console.zugriff_verweigert": "Acceso denegado",
      "agent_console.zur_antwort_composer": "Ir a la respuesta (editor)",
      "agent_console.zur_antwort_scrollen": "Desplazarse hasta la respuesta",
      "agent_console.zusammenfuehren": "Zusammenführen",
      "agent_console.zuweisung_entfernen": "Quitar la asignación",
      "ai": "IA",
      "ai_analysis_running": "Análisis en ejecución...",
      "ai_assistance": "Asistencia de IA",
      "ai_confidence_label": "{{pct}}% de confianza",
      "ai_context_title": "KI-Kontext & Prognosen",
      "ai_generate_summary": "Generar resumen",
      "ai_key_points": "Puntos clave",
      "ai_next_steps": "Próximos pasos",
      "ai_requested_action": "Acción requerida",
      "ai_risks": "Riesgos",
      "ai_solution_assistant_title": "Asistente de soluciones de IA",
      "ai_stale": "Obsoleto",
      "ai_summary_title": "Resumen de IA",
      "all": "Todos",
      "all_active_tickets": "Todos los tickets activos",
      "all_categories": "Todas las categorías",
      "all_customers": "Todos los clientes",
      "all_deadlines_ok": "Todos los plazos están dentro del plazo.",
      "all_open": "Todos abiertos",
      "all_tickets": "Todos los tickets",
      "allgemein.abbrechen": "Abbrechen",
      "allgemein.schliessen": "Schließen",
      "analyze_again": "Analizar de nuevo",
      "article": "Artículo",
      "article_ai_generate": "Crear artículo con IA",
      "article_ai_generate_btn": "Generar artículo",
      "article_ai_generate_desc": "Describa el tema y la IA generará un borrador",
      "article_ai_improve": "Mejorar texto",
      "article_ai_keywords": "Palabras clave (opcional)",
      "article_ai_keywords_placeholder": "ej., Windows 11, OpenVPN, certificado",
      "article_ai_language": "Idioma",
      "article_ai_len_long": "Largo / detallado",
      "article_ai_len_medium": "Medio",
      "article_ai_len_short": "Corto",
      "article_ai_length": "Longitud",
      "article_ai_style": "Estilo de lenguaje",
      "article_ai_style_balanced": "Equilibrado",
      "article_ai_style_enduser": "Usuario final (paso a paso)",
      "article_ai_style_formal": "Formal",
      "article_ai_style_simple": "Sencillo / fácil de entender",
      "article_ai_style_technical": "Técnico (profesionales de TI)",
      "article_ai_summarize": "Generar resumen",
      "article_ai_topic": "Tema *",
      "article_ai_topic_placeholder": "ej., Configurar conexión VPN en Windows",
      "article_all_customers": "Todos los clientes",
      "article_all_statuses": "Todos los estados",
      "article_all_visible": "Visible para todos los clientes",
      "article_archived": "Archivado",
      "article_category": "Categoría",
      "article_content_placeholder": "Comience a escribir su artículo aquí...",
      "article_create_first": "Crear primer artículo",
      "article_create_first_desc": "Cree su primer artículo de conocimiento para compartir información con su equipo.",
      "article_create_with_ai": "Crear con IA",
      "article_delete_confirm": "¿Realmente desea eliminar este artículo?",
      "article_draft": "Borrador",
      "article_excerpt_placeholder": "Un breve resumen del artículo...",
      "article_manage": "Gestionar artículos",
      "article_new": "Nuevo artículo",
      "article_no_articles": "Aún no hay artículos disponibles",
      "article_no_categories_desc": "No hay categorías disponibles. Créelas en el área de administración.",
      "article_no_category": "Sin categoría",
      "article_not_found": "No se encontraron artículos",
      "article_not_found_desc": "No se encontraron artículos para su búsqueda.",
      "article_only_visible": "Solo visible para {{name}}",
      "article_pinned": "Fijado",
      "article_pinned_desc": "Se mostrará en la parte superior de la lista",
      "article_plural": "Todos los artículos",
      "article_published": "Publicado",
      "article_search": "Buscar artículos...",
      "article_views": "vistas",
      "article_visibility": "Visibilidad para clientes",
      "article_write_content": "Contenido del artículo",
      "article_write_excerpt": "Extracto",
      "article_write_title": "Ingrese el título del artículo...",
      "asset.discovery_agents": "Agentes de descubrimiento",
      "asset.event_logs": "Registros de eventos",
      "asset.general": "General",
      "asset.hardware_wmi": "Hardware (WMI)",
      "asset.history_changes": "Historial y Cambios",
      "asset.more": "Más",
      "asset.network": "Red",
      "asset.network_discovery": "Descubrimiento de red",
      "asset.printers": "Impresoras",
      "asset.processes": "Procesos",
      "asset.relationships": "Relaciones",
      "asset.remote_control": "Control remoto",
      "asset.remote_terminal": "Terminal remoto",
      "asset.scan_history": "Historial de escaneos",
      "asset.security": "Seguridad",
      "asset.services": "Servicios",
      "asset.software_catalog": "Catálogo de software (SAM)",
      "asset.software_count": "Software",
      "asset.system_assets": "Activos del sistema",
      "asset.updates": "Actualizaciones",
      "asset_": "asset_",
      "asset_active": "Activo",
      "asset_agent.offline": "Sin conexión",
      "asset_agent.online_active": "En línea (activo)",
      "asset_agent.recently_active": "Activo recientemente",
      "asset_inactive": "Inactivo",
      "asset_maintenance": "Mantenimiento",
      "asset_management": "Gestión de activos",
      "asset_panel.confirm_delete_asset": "¿Seguro que desea eliminar \"{{name}}\"?",
      "asset_panel.confirm_delete_category": "¿Eliminar la categoría \"{{name}}\"? Los activos se desvincularán.",
      "asset_panel.edit_asset": "Editar activo",
      "asset_panel.edit_category": "Editar categoría",
      "asset_panel.import_as_managed_btn": "Importar como activo gestionado",
      "asset_panel.import_device": "Importar dispositivo",
      "asset_panel.new_asset": "Nuevo activo",
      "asset_panel.new_category": "Nueva categoría",
      "asset_panel.print_asset_tag": "Imprimir etiqueta de activo",
      "asset_panel.print_now_btn": "Imprimir ahora",
      "asset_panel.toast.agent_no_response_hint": "El agente no ha respondido a tiempo.",
      "asset_panel.toast.assets_imported": "{{count}} activo(s) importado(s)",
      "asset_panel.toast.command_queued": "Comando puesto en cola correctamente",
      "asset_panel.toast.create_problem_error": "Error al crear el ticket de problema",
      "asset_panel.toast.csv_import_failed": "Error en la importación CSV",
      "asset_panel.toast.device_ignored": "Dispositivo ignorado correctamente",
      "asset_panel.toast.device_imported": "Dispositivo importado correctamente a los activos gestionados",
      "asset_panel.toast.ignore_device_error": "Error al ignorar el dispositivo",
      "asset_panel.toast.import_device_error": "Error al importar el dispositivo",
      "asset_panel.toast.import_with_errors": "Importación finalizada con errores",
      "asset_panel.toast.itil_correlation_error": "Error en la correlación de problemas ITIL",
      "asset_panel.toast.less_than_3_tickets": "Menos de 3 tickets en los últimos 30 días.",
      "asset_panel.toast.manual_scan_error": "Error en el escaneo manual",
      "asset_panel.toast.problem_ticket_created": "¡Ticket de problema creado e incidencias vinculadas!",
      "asset_panel.toast.queue_command_error": "No se ha podido poner el comando en cola",
      "asset_panel.toast.request_scan_error": "Error al solicitar el escaneo",
      "asset_panel.toast.scan_completed": "Escaneo finalizado correctamente",
      "asset_panel.toast.scan_failed": "Error en el escaneo",
      "asset_panel.toast.scan_requested": "{{type}} solicitado",
      "asset_panel.toast.template_downloaded": "Plantilla «asset-import-vorlage.csv» descargada",
      "asset_panel.toast.template_load_error": "No se ha podido cargar la plantilla",
      "asset_remote_client_disconnected": "Cliente desconectado",
      "asset_remote_client_disconnected_desc": "El usuario del dispositivo cliente ha finalizado la sesión de asistencia remota.",
      "asset_remote_closed_desc": "La sesión de asistencia remota se cerró con éxito.",
      "asset_remote_code_placeholder": "ej. 123 456",
      "asset_remote_conn_disconnected": "Desconectado",
      "asset_remote_conn_failed": "Error de conexión con el servidor remoto",
      "asset_remote_conn_rejected": "Conexión rechazada",
      "asset_remote_consent_hint": "Se muestra un diálogo de consentimiento en la pantalla del cliente. Pídale al cliente que acepte.",
      "asset_remote_disconnect": "Desconectar",
      "asset_remote_enter_code_hint": "Introduzca el código de acceso de 6 dígitos que aparece en la pantalla del usuario:",
      "asset_remote_invalid_code": "Código de entrada incorrecto",
      "asset_remote_live_focus": "EN VIVO · Enfoque para entrada de teclado",
      "asset_remote_loading_screen": "Cargando pantalla en vivo...",
      "asset_remote_preparing": "Preparando conexión...",
      "asset_remote_protocol2_code_label": "Zwölfstelliger Zugangscode",
      "asset_remote_protocol2_code_placeholder": "ABCD EFGH 2345",
      "asset_remote_protocol2_enter_code_hint": "Geben Sie den zwölfstelligen Zugangscode vom Bildschirm des Benutzers ein:",
      "asset_remote_protocol2_request_desc": "Sendet eine Verbindungsanfrage an den Client-Rechner. Der Benutzer muss zustimmen und den zwölfstelligen Zugangscode übermitteln.",
      "asset_remote_rejected_desc": "La solicitud de conexión fue rechazada por el usuario en el dispositivo del cliente.",
      "asset_remote_req": "Solicitar sesión remota",
      "asset_remote_request_again": "Solicitar de nuevo",
      "asset_remote_request_desc": "Envía una solicitud de conexión a la máquina cliente. El usuario debe dar su consentimiento y compartir un código de acceso de 6 dígitos.",
      "asset_remote_request_title": "Solicitar Soporte Remoto",
      "asset_remote_start_error": "No se pudo iniciar la sesión de asistencia remota",
      "asset_remote_start_new": "Iniciar nueva sesión",
      "asset_remote_support": "Soporte remoto integrado",
      "asset_remote_support_desc": "Control remoto directo de pantalla sin software externo (TeamViewer/RustDesk).",
      "asset_remote_user_consented": "El usuario ha dado su consentimiento",
      "asset_remote_verifying_code": "Verificando código...",
      "asset_remote_waiting_consent": "Esperando el consentimiento del usuario...",
      "asset_retired": "Retirado",
      "assets": "Activos",
      "assign_to": "Asignar...",
      "assign_to_me": "Asignarme a mí",
      "assigned_agents": "Agentes asignados",
      "assigned_to": "Asignado a",
      "at_risk_title": "En riesgo (Advertencia de SLA):",
      "attach_local_file": "Adjuntar archivo local",
      "attachments": "Archivos adjuntos",
      "attachments_tools": "Archivos adjuntos y Herramientas",
      "attendees_emails": "Asistentes (correos electrónicos, separados por comas)",
      "automation": "Automatización",
      "avg_first_response": "Tiempo de primera respuesta",
      "avg_resolution": "Tiempo medio de resolución",
      "billable": "Facturable",
      "billable_time": "Facturable: {{time}}",
      "book_on_send": "Registrar al enviar",
      "book_time_with_reply": "Registrar tempo con respuesta",
      "calendar": "Calendario",
      "calendar_enter_title_warning": "Por favor, ingrese un título.",
      "calendar_event_attendees": "Correos electrónicos de asistentes (opcional, separados por comas)",
      "calendar_event_created_error": "No se pudo crear el evento.",
      "calendar_event_created_success": "Evento creado.",
      "calendar_event_description": "Descripción (opcional)",
      "calendar_event_title": "Título",
      "calendar_meeting_created_error": "No se pudo crear la reunión.",
      "calendar_meeting_link_copied": "Enlace de la reunión copiado al portapapeles.",
      "calendar_new_event": "Nuevo evento",
      "calendar_no_integration_or": "o",
      "calendar_no_integration_prefix": "Ninguna integración de calendario o reunión activa. Por favor, configure",
      "calendar_no_integration_suffix": "con planificación de reuniones activa en las integraciones.",
      "calendar_only_event": "Solo evento de calendario",
      "calendar_talk_meeting": "Reunión Talk",
      "calendar_talk_room_created": "Sala Talk creada.",
      "calendar_teams_meeting": "Reunión de Teams",
      "calendar_teams_meeting_created": "Reunión de Teams creada.",
      "cancel": "Cancelar",
      "canned_responses": "Insertar respuestas predefinidas",
      "canned_responses_short": "Respuesta predefinida",
      "categories": "Categorías",
      "category": "Categoría",
      "change_priority": "Cambiar prioridad...",
      "change_status_after_send": "Después de enviar, cambiar a",
      "change_ticket_company": "Ticket anderer Firma zuordnen",
      "change_ticket_company_warning": "Portal-Ersteller, CC, Mitarbeiter, Bearbeiter, Kategorie, SLA, Assets und laufende Timer werden für die neue Firma zurückgesetzt.",
      "characters": "caracteres",
      "city": "Ciudad",
      "clear_selection": "Limpiar selección",
      "click_to_logout": "Haga clic para cerrar sesión",
      "close": "Cerrar",
      "close_detail_view": "Cerrar vista detallada",
      "close_ticket": "Cerrar ticket",
      "closed": "Cerrados",
      "collapse": "Contraer",
      "collapse_composer": "Contraer el editor",
      "collapse_sidebar": "Contraer barra lateral",
      "column_assignee_name": "Asignado",
      "column_category_name": "Categoría",
      "column_channel": "Canal",
      "column_created_at": "Creado",
      "column_customer_name": "Cliente",
      "column_priority": "Prioridad",
      "column_reply_count": "Respuestas",
      "column_requester_name": "Solicitante",
      "column_sla": "SLA",
      "column_status": "Estado",
      "column_subject": "Asunto",
      "column_tags": "Etiquetas",
      "column_ticket_number": "Nº",
      "column_updated_at": "Actualizado",
      "columns_btn": "Columnas",
      "common.abbrechen": "Abbrechen",
      "company_name": "Nombre de la empresa",
      "company_title": "Empresa",
      "compliance_rate": "Tasa de cumplimiento",
      "composer_internal": "Interno",
      "composer_internal_placeholder": "Nota interna...",
      "composer_public": "Público",
      "composer_public_placeholder": "Escribir respuesta...",
      "configure_columns": "Configurar columnas",
      "connect": "Conectar",
      "contact_and_master_data": "Contacto y Datos maestros",
      "contact_person": "Persona de contacto",
      "contact_person_abbrev": "PC",
      "contract": "Contrato",
      "contract.auto_renew": "Renovación automática",
      "contract.auto_renews_suffix": " (se renueva automáticamente)",
      "contract.back_to_overview": "Volver al resumen",
      "contract.billing": "Facturación",
      "contract.billing_model": "Modelo de facturación",
      "contract.conditions": "Condiciones",
      "contract.days": "{{count}} días",
      "contract.end_date": "Fecha de fin",
      "contract.expires_in_days": "Vence en {{count}} días",
      "contract.first_response": "Primera respuesta",
      "contract.hourly_rate": "Tarifa por hora",
      "contract.hours_quota": "Bolsa de horas",
      "contract.included_hours": "Horas incluidas",
      "contract.no_contracts": "No hay contratos",
      "contract.no_contracts_desc": "Póngase en contacto con nosotros para recibir una oferta personalizada",
      "contract.notice_period": "Plazo de preaviso: {{count}} días",
      "contract.period_per": "{{count}} h / periodo",
      "contract.quota_summary": "{{remaining}} restante(s) ({{percent}}% utilizado)",
      "contract.remaining": "Restante",
      "contract.resolution": "Resolución",
      "contract.runtime": "Duración",
      "contract.sla_tier": "SLA",
      "contract.start_date": "Fecha de inicio",
      "contract.status.active": "Activo",
      "contract.status.expired": "Caducado",
      "contract.status.expiring_soon": "Caduca pronto",
      "contract.status.future": "Futuro",
      "contract.subtitle": "Resumen de sus contratos activos y acuerdos de nivel de servicio",
      "contract.unlimited": "Indefinido",
      "contract.used": "Consumido",
      "contracts": "Contratos",
      "copied_to_clipboard": "Copiado al portapapeles",
      "country": "País",
      "create": "Crear",
      "create_ticket.aehnliche_tickets": "Tickets similares",
      "create_ticket.angehaengte_cloud_dateien": "Archivos en la nube adjuntos:",
      "create_ticket.anhaenge": "Archivos adjuntos",
      "create_ticket.asset_verknuepfen_optional": "Vincular activo (opcional):",
      "create_ticket.assets_filtern": "Filtrar activos:",
      "create_ticket.assets_werden_geladen": "Cargando activos...",
      "create_ticket.beschreiben_sie_das_problem_so_detailliert_w": "Describa el problema con el mayor detalle posible...",
      "create_ticket.betroffene_systeme_benutzer_nennen": "Indique los sistemas y usuarios afectados",
      "create_ticket.bitte_betreff_und_beschreibung_ausfuellen": "Rellene el asunto y la descripción",
      "create_ticket.bitte_eine_beschreibung_angeben": "Indique una descripción.",
      "create_ticket.bitte_einen_kunden_auswaehlen": "Seleccione un cliente.",
      "create_ticket.bitte_hauptkategorie_waehlen": "Seleccione una categoría principal...",
      "create_ticket.bitte_klassifizierung_waehlen": "Seleccione una clasificación...",
      "create_ticket.bitte_kunde_waehlen": "Seleccione un cliente...",
      "create_ticket.bitte_unterkategorie_waehlen": "Seleccione una subcategoría...",
      "create_ticket.bitte_zuerst_einen_kunden_waehlen": "Seleccione primero un cliente...",
      "create_ticket.datei_hochladen": "Subir archivo",
      "create_ticket.datei_hochladen_2": "Subir archivo",
      "create_ticket.datei_zu_gross_max_10_mb": "Archivo demasiado grande (máx. 10 MB)",
      "create_ticket.dateityp_nicht_erlaubt": "Tipo de archivo no permitido",
      "create_ticket.erste_antwort": "Primera respuesta",
      "create_ticket.fehlermeldungen_und_screenshots_beifuegen": "Adjunte los mensajes de error y las capturas de pantalla",
      "create_ticket.keine_mitarbeiter_hinterlegt": "No hay empleados registrados",
      "create_ticket.letzte_kunden_tickets": "Últimos tickets del cliente",
      "create_ticket.loesung": "Solución",
      "create_ticket.neues_ticket": "Nuevo ticket",
      "create_ticket.nur_geschaeftszeiten": "Solo en horario laboral",
      "create_ticket.praeziser_betreff_hilft_bei_der_zuordnung": "Un asunto preciso facilita la asignación",
      "create_ticket.priority_high": "Alta",
      "create_ticket.priority_low": "Baja",
      "create_ticket.priority_medium": "Media",
      "create_ticket.priority_urgent": "Urgente",
      "create_ticket.schritte_zur_reproduktion_angeben": "Indique los pasos para reproducirlo",
      "create_ticket.stoerung": "Incidencia",
      "create_ticket.text_mit_ki_verbessern": "Mejorar el texto con IA",
      "create_ticket.ticket_erstellt": "¡Ticket creado!",
      "create_ticket.uebernehmen": "Aplicar",
      "create_ticket.ueberschrift": "Título",
      "create_ticket.vielleicht_loest_ein_artikel_das_problem_ber": "¿Quizá un artículo ya resuelva el problema?",
      "create_ticket.vorlage_einfuegen": "Insertar plantilla",
      "create_ticket.waehlen_sie_einen_kunden_aus_um_dessen_asset": "Seleccione un cliente para poder vincular sus activos.",
      "create_ticket.werden_bei_erstellung_ausgeloest": "Se activan al crear el ticket",
      "create_ticket.zurueck": "Atrás",
      "created_at": "Creado el",
      "critical_priority_sla": "Prioridad / SLA",
      "customer": "Cliente",
      "customer_assets.no_assets": "No hay activos registrados para este cliente. Si un activo tiene un ID de host de Zabbix o un monitor de disponibilidad, aquí aparecerán los avisos de estado.",
      "customer_assets.no_assets_unconfigured": "No hay activos registrados. Discovery o una integración de monitorización pueden automatizar el inventario.",
      "customer_assets.no_zabbix_id": "El activo no tiene ID de host de Zabbix",
      "customer_assets.start_rd": "Iniciar RustDesk",
      "customer_assets.start_tv": "Iniciar TeamViewer",
      "customer_form.adresse_eingeben_um_karte_anzuzeigen": "Introduzca una dirección para mostrar el mapa",
      "customer_form.client_secret": "Client Secret",
      "customer_form.domain_entfernen": "Eliminar dominio",
      "customer_form.domain_hinzufuegen": "+ Añadir dominio",
      "customer_form.domains_mit_zugeordneten_mitarbeitern_koenne": "No se pueden eliminar los dominios que tienen empleados asignados.",
      "customer_form.geschaeftsfuehrer": "Director general",
      "customer_form.in_openstreetmap_oeffnen": "Abrir en OpenStreetMap ↗",
      "customer_form.interne_notizen_zu_diesem_kunden": "Notas internas sobre este cliente...",
      "customer_form.kontakt_in_lexoffice_anlegen_uuid_hier_eintr": "Cree el contacto en Lexoffice e introduzca aquí el UUID",
      "customer_form.lexoffice_kontakt_id_uuid": "ID de contacto de Lexoffice (UUID)",
      "customer_form.logo_kann_nach_dem_erstellen_des_kunden_hoch": "El logotipo se puede subir después de crear el cliente.",
      "customer_form.mitarbeiter_koennen_sich_per_microsoft_konto": "Los empleados pueden iniciar sesión con su cuenta de Microsoft",
      "customer_form.mloffice_badge": "Von MLOffice verwaltet",
      "customer_form.mloffice_banner": "Dieser Kunde wird mit MLOffice abgeglichen. Stammdaten (Name, E-Mail, Telefon, Anschrift, USt-ID) werden von MLOffice verwaltet und sind hier gesperrt.",
      "customer_form.mloffice_feld_hinweis": "Dieses Feld wird von MLOffice verwaltet — Änderungen bitte dort vornehmen; sie werden automatisch übernommen.",
      "customer_form.mloffice_geloest": "Verknüpfung gelöst — die Felder sind wieder bearbeitbar.",
      "customer_form.mloffice_loesen": "Verknüpfung lösen…",
      "customer_form.mloffice_loesen_fehler": "Verknüpfung konnte nicht gelöst werden.",
      "customer_form.mloffice_loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "customer_form.mloffice_loest": "Löse…",
      "customer_form.mloffice_verwaltung_hinweis": "Verwaltung der Verknüpfung unter Stammdaten & Organisation → MLOffice (erfordert Systemrechte).",
      "customer_form.registrieren_sie_eine_app_in_azure_portal_ap": "Registre una aplicación en Azure Portal → Registros de aplicaciones. URI de redirección:",
      "customer_form.strasse": "Calle",
      "customer_form.tab_address": "Dirección",
      "customer_form.tab_domains": "Dominios",
      "customer_form.tab_general": "General",
      "customer_form.tab_notes": "Notas",
      "customer_form.tab_sso": "SSO",
      "customer_form.tab_tax": "Impuestos y SLA",
      "customer_form.zuordnung_ticket_system_kunde_lexoffice_kont": "Asignación entre el cliente del sistema de tickets y el contacto de Lexoffice para los borradores de factura (Admin → Registro de tiempos).",
      "customer_inactive": "Cliente inactivo",
      "customer_not_found": "Cliente no encontrado",
      "customer_notified_by_email": "El cliente será notificado por correo electrónico",
      "customer_number_abbrev": "Nº Cliente",
      "customer_portal.action_required": "Acción requerida",
      "customer_portal.action_required_desc": "El equipo de soporte espera su respuesta sobre este ticket.",
      "customer_portal.action_required_title": "Se necesita su respuesta",
      "customer_portal.assignee": "Responsable",
      "customer_portal.attachments_count": "Archivos adjuntos ({{count}})",
      "customer_portal.attachments_load_failed": "Weitere Anhänge konnten nicht geladen werden.",
      "customer_portal.back": "← Volver",
      "customer_portal.back_to_my_tickets": "← Volver a Mis tickets",
      "customer_portal.close": "Cerrar",
      "customer_portal.close_failed": "No se ha podido cerrar el ticket.",
      "customer_portal.collapse_replies": "Ältere schließen",
      "customer_portal.compact_replies": "Ältere Antworten sind eingeklappt. Die letzte Antwort bleibt geöffnet.",
      "customer_portal.confirm_close": "¿Seguro que desea cerrar este ticket?",
      "customer_portal.confirm_reopen": "¿Desea volver a abrir este ticket?",
      "customer_portal.contracts.hours_minutes": "{{hours}} h {{minutes}} min",
      "customer_portal.contracts.hours_only": "{{hours}} h",
      "customer_portal.contracts.minutes_only": "{{minutes}} min",
      "customer_portal.create_first_ticket": "Crear un ticket nuevo",
      "customer_portal.created": "Creado",
      "customer_portal.customer_colleague": "Kollegin/Kollege",
      "customer_portal.dashboard.active_count": "{{count}} activos",
      "customer_portal.dashboard.avg_resolution": "Ø Tiempo de resolución",
      "customer_portal.dashboard.click_to_view_waiting": "Haga clic aquí para ver los tickets",
      "customer_portal.dashboard.create_first_link": "Crear el primer ticket →",
      "customer_portal.dashboard.create_new_ticket_link": "Crear un ticket nuevo",
      "customer_portal.dashboard.history_trend": "Histórico de tickets (últimos 12 meses)",
      "customer_portal.dashboard.kb": "Ayuda y base de conocimiento",
      "customer_portal.dashboard.kb_desc": "Guías y preguntas frecuentes",
      "customer_portal.dashboard.my_tickets": "Mis tickets",
      "customer_portal.dashboard.no_tickets": "Todavía no hay tickets",
      "customer_portal.dashboard.no_tickets_status": "Sin tickets",
      "customer_portal.dashboard.open_active": "Abiertos / activos",
      "customer_portal.dashboard.processing_time": "Tiempo de gestión",
      "customer_portal.dashboard.recent_tickets": "Últimos tickets",
      "customer_portal.dashboard.report_incident": "Notificar una incidencia",
      "customer_portal.dashboard.report_incident_desc": "Notifique un problema urgente o una interrupción",
      "customer_portal.dashboard.reports": "Resumen e informes",
      "customer_portal.dashboard.reports_desc": "Filtrar y analizar todos los tickets",
      "customer_portal.dashboard.search_kb_link": "Buscar en la base de conocimiento",
      "customer_portal.dashboard.service_request": "Solicitud de servicio",
      "customer_portal.dashboard.service_request_desc": "Solicitudes mediante formularios configurables",
      "customer_portal.dashboard.show_all_link": "Ver todos →",
      "customer_portal.dashboard.status_overview": "Resumen de estados",
      "customer_portal.dashboard.subtitle": "Su resumen de soporte de un vistazo",
      "customer_portal.dashboard.total_tickets": "Total de tickets",
      "customer_portal.dashboard.waiting_tickets_warning": "1 ticket requiere su respuesta",
      "customer_portal.dashboard.waiting_tickets_warning_plural": "{{count}} tickets requieren su respuesta",
      "customer_portal.dashboard.welcome": "Bienvenido",
      "customer_portal.dashboard.widget_unknown": "Widget: {{type}}",
      "customer_portal.dashboard.your_reply": "Su respuesta",
      "customer_portal.details_title": "Detalles",
      "customer_portal.editor.bold": "Negrita",
      "customer_portal.editor.code": "Código",
      "customer_portal.editor.italic": "Cursiva",
      "customer_portal.editor.list": "Lista",
      "customer_portal.expand_replies": "Alle öffnen",
      "customer_portal.files_draft_failed": "Anhänge konnten nicht dauerhaft im Entwurf gespeichert werden.",
      "customer_portal.files_need_reselect": "Anhänge können aus Sicherheitsgründen nicht wiederhergestellt werden. Bitte wählen Sie sie erneut aus.",
      "customer_portal.filters.active": "Activos",
      "customer_portal.filters.all": "Todos",
      "customer_portal.filters.closed": "Cerrados",
      "customer_portal.filters.external": "Extern",
      "customer_portal.filters.waiting_customer": "Su respuesta",
      "customer_portal.history_title": "Historial",
      "customer_portal.impersonation_banner": "Está viendo este portal en modo de suplantación (vista previa para agentes) como cliente:",
      "customer_portal.incident_badge": "Incidencia",
      "customer_portal.kb.title": "Base de conocimiento",
      "customer_portal.load_more_attachments": "Weitere Anhänge laden",
      "customer_portal.login.betreut_von": "ATENDIDO POR NALVRA",
      "customer_portal.login.claim": "Su línea directa con el soporte: comunicar, seguir el estado, encontrar respuestas.",
      "customer_portal.login.copyright_text": "© {{year}} {{appName}}. Todos los derechos reservados.",
      "customer_portal.login.default_subtitle": "Inicie sesión para gestionar sus solicitudes.",
      "customer_portal.login.default_welcome": "Bienvenido a {{appName}}",
      "customer_portal.login.email": "Correo electrónico",
      "customer_portal.login.email_placeholder": "nombre@empresa.es",
      "customer_portal.login.eyebrow": "PORTAL DE CLIENTES · DISPONIBLE 24/7",
      "customer_portal.login.forgot_password": "¿Ha olvidado su contraseña?",
      "customer_portal.login.kein_zugang": "¿Aún no tiene acceso? Póngase en contacto con su persona de contacto en soporte.",
      "customer_portal.login.kundenanmeldung": "Acceso de clientes",
      "customer_portal.login.kundenportal": "PORTAL DE CLIENTES",
      "customer_portal.login.microsoft_signin": "Iniciar sesión con Microsoft",
      "customer_portal.login.mit_hinterlegter_adresse": "Inicie sesión con la dirección de correo registrada.",
      "customer_portal.login.or_password": "o con contraseña",
      "customer_portal.login.password": "Contraseña",
      "customer_portal.login.password_placeholder": "Su contraseña",
      "customer_portal.login.reset_back": "Volver al inicio de sesión",
      "customer_portal.login.reset_button": "Enviar enlace",
      "customer_portal.login.reset_instruction": "Introduzca su correo electrónico. Le enviaremos un enlace para restablecerla.",
      "customer_portal.login.reset_sent_message": "Si existe una cuenta con esta dirección, hemos enviado un enlace para restablecer la contraseña.",
      "customer_portal.login.reset_sent_title": "Correo enviado",
      "customer_portal.login.reset_title": "Restablecer contraseña",
      "customer_portal.login.sicherheitszeile": "Conexión cifrada · Acceso solo para contactos registrados",
      "customer_portal.login.signin_button": "Iniciar sesión",
      "customer_portal.login.signing_in": "Iniciando sesión …",
      "customer_portal.login.sso_available": "Inicio de sesión único disponible",
      "customer_portal.login.sso_failed": "Error al iniciar sesión con SSO",
      "customer_portal.login.sso_logging_in": "Iniciando sesión …",
      "customer_portal.menu.dashboard": "Panel de control",
      "customer_portal.menu.edit_profile": "Editar perfil",
      "customer_portal.menu.logout": "Cerrar sesión",
      "customer_portal.menu.profile": "Mein Profil",
      "customer_portal.message_placeholder": "Su mensaje...",
      "customer_portal.nav.contracts": "Contratos",
      "customer_portal.nav.create_request": "Anfrage erstellen",
      "customer_portal.nav.dashboard": "Panel de control",
      "customer_portal.nav.documents": "Documentos",
      "customer_portal.nav.downloads": "Downloads",
      "customer_portal.nav.help": "Hilfe & Kurztour",
      "customer_portal.nav.kb": "Base de conocimiento",
      "customer_portal.nav.my_tickets": "Mis tickets",
      "customer_portal.nav.profile": "Perfil",
      "customer_portal.nav.report_incident": "Notificar una incidencia",
      "customer_portal.nav.service_request": "Solicitud de servicio",
      "customer_portal.nav.support": "Support erhalten",
      "customer_portal.navigation": "Portal-Navigation",
      "customer_portal.new_ticket": "Nuevo ticket",
      "customer_portal.new_ticket.add_attachment": "Añadir",
      "customer_portal.new_ticket.ai_improve_btn": "Mejorar la descripción",
      "customer_portal.new_ticket.ai_improving": "Mejorando...",
      "customer_portal.new_ticket.ai_preanswer_title": "Sugerencia de la IA para su problema",
      "customer_portal.new_ticket.ai_suggestion_title": "Propuesta de mejora de la IA",
      "customer_portal.new_ticket.allowed_types_tip": "Solo los tipos de archivo configurados (consulte la indicación de su administrador)",
      "customer_portal.new_ticket.apply": "Aplicar",
      "customer_portal.new_ticket.attach_file": "Adjuntar archivo",
      "customer_portal.new_ticket.attachment_plural": "Archivos adjuntos",
      "customer_portal.new_ticket.attachment_singular": "Archivo adjunto",
      "customer_portal.new_ticket.back_step_1": "Zurück zu Schritt 1",
      "customer_portal.new_ticket.back_step_2": "Zurück zu Schritt 2",
      "customer_portal.new_ticket.categories_error": "Kategorien konnten nicht geladen werden.",
      "customer_portal.new_ticket.categories_loading": "Kategorien werden geladen …",
      "customer_portal.new_ticket.category_assignment": "Kategorie zuordnen",
      "customer_portal.new_ticket.category_by_support": "Zuordnung durch den Support",
      "customer_portal.new_ticket.category_hint": "Sie sind unsicher? Lassen Sie die Kategorie offen. Der Support übernimmt die Zuordnung.",
      "customer_portal.new_ticket.category_question": "Welche Kategorie passt zu Ihrem Anliegen?",
      "customer_portal.new_ticket.char_count": "{{count}} caracteres",
      "customer_portal.new_ticket.continue_step_2": "Weiter zu Schritt 2",
      "customer_portal.new_ticket.continue_step_3": "Weiter zu Schritt 3",
      "customer_portal.new_ticket.create": "Crear",
      "customer_portal.new_ticket.create_anyway": "Crear el ticket de todos modos",
      "customer_portal.new_ticket.create_ticket": "Crear ticket",
      "customer_portal.new_ticket.creating": "Creando...",
      "customer_portal.new_ticket.days_count": "{{count}} días laborables",
      "customer_portal.new_ticket.description_label": "Descripción *",
      "customer_portal.new_ticket.description_placeholder": "Describa su problema en detalle...\\n\\n• ¿Qué no funciona?\\n• ¿Desde cuándo se produce el problema?\\n• ¿Aparece algún mensaje de error?\\n• ¿Qué sistema o dispositivo está afectado?\\n\\nConsejo: pegue capturas de pantalla con Ctrl+V",
      "customer_portal.new_ticket.description_required": "Bitte beschreiben Sie Ihr Problem.",
      "customer_portal.new_ticket.discard": "Descartar",
      "customer_portal.new_ticket.drag_more": "Arrastre más archivos hasta aquí · Aún puede añadir {{count}}",
      "customer_portal.new_ticket.drag_or_click": "Arrastre archivos hasta aquí o haga clic",
      "customer_portal.new_ticket.drop_here": "Suelte los archivos aquí...",
      "customer_portal.new_ticket.error_create_failed": "Error al crear el ticket.",
      "customer_portal.new_ticket.expected_first_response": "Primera respuesta",
      "customer_portal.new_ticket.go_to_step": "Schritt {{step}}: {{label}}",
      "customer_portal.new_ticket.hide": "Ocultar",
      "customer_portal.new_ticket.hours_count": "{{count}} horas",
      "customer_portal.new_ticket.insert_template": "Insertar plantilla",
      "customer_portal.new_ticket.kb_article_error": "Dieser Artikel konnte nicht geladen werden. Sie können es erneut versuchen oder mit Ihrem Ticket fortfahren.",
      "customer_portal.new_ticket.kb_close_article": "Artikel schließen",
      "customer_portal.new_ticket.kb_did_help": "Hat dieser Artikel Ihr Problem gelöst?",
      "customer_portal.new_ticket.kb_draft_retained": "Ihr Ticketentwurf bleibt erhalten. Sie entscheiden, ob Sie ihn weiter bearbeiten.",
      "customer_portal.new_ticket.kb_feedback_error": "Ihre Rückmeldung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut. Ihr Entwurf bleibt erhalten.",
      "customer_portal.new_ticket.kb_helped": "Artikel hat mir geholfen",
      "customer_portal.new_ticket.kb_loading_article": "Artikel wird geladen",
      "customer_portal.new_ticket.kb_resolved_message": "Ihre Rückmeldung wurde gespeichert. Es wurde kein Ticket erstellt.",
      "customer_portal.new_ticket.kb_resolved_title": "Schön, dass die Anleitung geholfen hat",
      "customer_portal.new_ticket.kb_resume_draft": "Ticketentwurf weiter bearbeiten",
      "customer_portal.new_ticket.kb_retry": "Erneut laden",
      "customer_portal.new_ticket.kb_saved_draft": "Ihr Entwurf bleibt für Sie gespeichert, falls Sie später doch Unterstützung benötigen.",
      "customer_portal.new_ticket.kb_searching": "Lösungen werden gesucht",
      "customer_portal.new_ticket.kb_suggestions_hint": "Passende Anleitungen aus der Wissensbasis. Lesen Sie einen Artikel, bevor Sie Ihr Ticket erstellen.",
      "customer_portal.new_ticket.kb_suggestions_title": "Vielleicht ist die Lösung schon da",
      "customer_portal.new_ticket.kb_to_dashboard": "Zurück zum Dashboard",
      "customer_portal.new_ticket.max_files": "Máx. {{count}} archivos",
      "customer_portal.new_ticket.max_size": "Máx. {{count}} MB por archivo",
      "customer_portal.new_ticket.minutes_count": "{{count}} minutos",
      "customer_portal.new_ticket.no_category": "Seleccione una categoría...",
      "customer_portal.new_ticket.optional": "Optional",
      "customer_portal.new_ticket.preanswer_might_resolve": "¿Le ha servido de ayuda? En ese caso, quizá no necesite crear un ticket.",
      "customer_portal.new_ticket.presubmit_kb_desc": "¿No encuentra un artículo adecuado? No hay problema: cree su ticket.",
      "customer_portal.new_ticket.presubmit_kb_title": "Esto podría resolver ya su problema",
      "customer_portal.new_ticket.prio_desc_critical": "Inmediato",
      "customer_portal.new_ticket.prio_desc_high": "Urgente",
      "customer_portal.new_ticket.prio_desc_low": "Puede esperar",
      "customer_portal.new_ticket.prio_desc_medium": "Normal",
      "customer_portal.new_ticket.progress": "Fortschritt der Ticketerstellung",
      "customer_portal.new_ticket.relevant_articles": "Artículos relacionados:",
      "customer_portal.new_ticket.reply_by_email_tip": "También puede responder a este ticket por correo electrónico",
      "customer_portal.new_ticket.resolution": "Resolución",
      "customer_portal.new_ticket.response_time_typical": "Por lo general respondemos en pocas horas",
      "customer_portal.new_ticket.retry_categories": "Erneut laden",
      "customer_portal.new_ticket.screenshot_tip": "Pegue capturas de pantalla con Ctrl+V",
      "customer_portal.new_ticket.similar_tickets": "Tickets similares",
      "customer_portal.new_ticket.step_attachments": "Anhänge",
      "customer_portal.new_ticket.step_attachments_detail": "Kategorie, Anhänge und Absenden",
      "customer_portal.new_ticket.step_count": "Schritt {{step}} von 3",
      "customer_portal.new_ticket.step_details": "Details",
      "customer_portal.new_ticket.step_details_detail": "Beschreibung und Priorität",
      "customer_portal.new_ticket.step_subject": "Betreff",
      "customer_portal.new_ticket.step_subject_detail": "Person, Betreff und Wissensbasis",
      "customer_portal.new_ticket.subject_desc_required": "El asunto y la descripción son obligatorios.",
      "customer_portal.new_ticket.subject_label": "Asunto *",
      "customer_portal.new_ticket.subject_placeholder": "Breve descripción del problema o de su solicitud",
      "customer_portal.new_ticket.subject_required": "Bitte geben Sie einen Betreff ein.",
      "customer_portal.new_ticket.subtitle": "Incidencia técnica o problema urgente: se envía al soporte como ticket.",
      "customer_portal.new_ticket.subtitle_2": "Describa su solicitud y nos encargaremos de ella.",
      "customer_portal.new_ticket.success_desc": "Muchas gracias. Nos pondremos en contacto con usted lo antes posible.",
      "customer_portal.new_ticket.success_title": "¡Ticket creado!",
      "customer_portal.new_ticket.template_btn": "Ejemplo",
      "customer_portal.new_ticket.view_ticket": "Ver el ticket",
      "customer_portal.no_attachments": "Keine Anhänge vorhanden.",
      "customer_portal.no_tickets_create_desc": "Cree su primer ticket.",
      "customer_portal.no_tickets_filter_desc": "Pruebe con otro filtro.",
      "customer_portal.no_tickets_search_desc": "Pruebe con otro término de búsqueda.",
      "customer_portal.no_tickets_title": "No se han encontrado tickets",
      "customer_portal.pagination_of": "von",
      "customer_portal.password.btn": "Cambiar contraseña",
      "customer_portal.password.cancel": "Cancelar",
      "customer_portal.password.changing": "Cambiando...",
      "customer_portal.password.confirm": "Confirmar la nueva contraseña",
      "customer_portal.password.current": "Contraseña actual",
      "customer_portal.password.error_change": "Error al cambiar la contraseña.",
      "customer_portal.password.error_min_length": "Mínimo 8 caracteres.",
      "customer_portal.password.error_mismatch": "Las contraseñas no coinciden.",
      "customer_portal.password.error_same": "La nueva contraseña debe ser distinta de la actual.",
      "customer_portal.password.logout": "Cerrar sesión",
      "customer_portal.password.mismatch_warning": "Las contraseñas no coinciden",
      "customer_portal.password.must_change_desc": "Cambie su contraseña antes de continuar.",
      "customer_portal.password.new": "Nueva contraseña (mín. 8 caracteres)",
      "customer_portal.password.redirecting": "Se le está redirigiendo...",
      "customer_portal.password.success": "¡Contraseña cambiada correctamente!",
      "customer_portal.password.title": "Cambiar contraseña",
      "customer_portal.priority_help.high": "Mehrere Mitarbeitende oder eine wichtige Funktion sind stark beeinträchtigt. Es gibt keine praktikable Ausweichlösung, der übrige Betrieb läuft jedoch weiter.",
      "customer_portal.priority_help.low": "Kleine Einschränkung oder allgemeine Frage. Sie können normal weiterarbeiten, zum Beispiel bei einem Darstellungsfehler oder einem Änderungswunsch.",
      "customer_portal.priority_help.medium": "Die Arbeit ist eingeschränkt, aber eine Ausweichlösung ist möglich. Beispiel: Ein Drucker fällt aus, ein anderer kann genutzt werden.",
      "customer_portal.priority_help.urgent": "Der Betrieb oder ein geschäftskritischer Prozess steht still. Es gibt keine Ausweichlösung, zum Beispiel bei einem vollständigen Ausfall des zentralen Systems. Bitte nicht nur wegen eines persönlichen Wunschtermins wählen.",
      "customer_portal.processing_time": "Tiempo de gestión",
      "customer_portal.profile.cancel": "Cancelar",
      "customer_portal.profile.change_password_btn": "Cambiar contraseña",
      "customer_portal.profile.change_photo": "Profilbild ändern",
      "customer_portal.profile.closed": "Cerrados",
      "customer_portal.profile.company": "Empresa",
      "customer_portal.profile.company_account": "Empresa y cuenta",
      "customer_portal.profile.days_count": "{{count}} día(s) laborable(s)",
      "customer_portal.profile.department": "Departamento",
      "customer_portal.profile.edit": "Editar",
      "customer_portal.profile.email": "Correo electrónico",
      "customer_portal.profile.error_save": "Error al guardar",
      "customer_portal.profile.error_upload": "Error al subir el archivo",
      "customer_portal.profile.first_name": "Nombre",
      "customer_portal.profile.first_response": "Primera respuesta",
      "customer_portal.profile.hours_count": "{{count}} h",
      "customer_portal.profile.last_name": "Apellidos",
      "customer_portal.profile.loading": "Cargando el perfil...",
      "customer_portal.profile.location": "Ubicación",
      "customer_portal.profile.member_since": "Miembro desde",
      "customer_portal.profile.minutes_count": "{{count}} min",
      "customer_portal.profile.mobile": "Móvil",
      "customer_portal.profile.mobile_placeholder": "p. ej. +34 600 123 456",
      "customer_portal.profile.open": "Abiertos",
      "customer_portal.profile.personal_data": "Datos personales",
      "customer_portal.profile.phone": "Teléfono",
      "customer_portal.profile.phone_placeholder": "p. ej. +34 91 123 45 67",
      "customer_portal.profile.position": "Cargo",
      "customer_portal.profile.resolution": "Resolución",
      "customer_portal.profile.save": "Guardar",
      "customer_portal.profile.security": "Seguridad",
      "customer_portal.profile.security_desc": "Cambie su contraseña con regularidad para mayor seguridad.",
      "customer_portal.profile.service_level": "Nivel de servicio",
      "customer_portal.profile.show_dashboard": "Mostrar el panel de control",
      "customer_portal.profile.sla_tier": "Nivel de SLA",
      "customer_portal.profile.sso_active": "Autenticación SSO activa",
      "customer_portal.profile.success_photo": "Foto de perfil actualizada",
      "customer_portal.profile.success_update": "Perfil actualizado correctamente",
      "customer_portal.profile.ticket_overview": "Resumen de tickets",
      "customer_portal.profile.total": "Total",
      "customer_portal.reopen": "Reabrir",
      "customer_portal.reopen_failed": "No se ha podido reabrir el ticket.",
      "customer_portal.reopen_ticket": "Reabrir el ticket",
      "customer_portal.replies_load_failed": "Ältere Antworten konnten nicht geladen werden.",
      "customer_portal.reply_btn": "Responder",
      "customer_portal.reply_failed": "No se ha podido enviar su respuesta. Inténtelo de nuevo.",
      "customer_portal.reply_plural": "Respuestas",
      "customer_portal.reply_singular": "Respuesta",
      "customer_portal.request_badge": "Solicitud",
      "customer_portal.requests.attachments": "Archivos adjuntos",
      "customer_portal.requests.category": "Categoría",
      "customer_portal.requests.description": "Descripción",
      "customer_portal.requests.priority": "Prioridad",
      "customer_portal.search_label": "Tickets suchen",
      "customer_portal.search_placeholder": "Buscar por n.º de ticket o asunto...",
      "customer_portal.sending": "Enviando...",
      "customer_portal.service_level": "Nivel de servicio",
      "customer_portal.show_older_replies": "Mostrar {{count}} respuestas anteriores...",
      "customer_portal.sla.met": "Cumplido",
      "customer_portal.sla.on_track": "En plazo",
      "customer_portal.sla.overdue": "Vencido",
      "customer_portal.sla.warning": "Vence pronto",
      "customer_portal.source": "Origen",
      "customer_portal.source_portal": "Portal",
      "customer_portal.stop_impersonation": "Finalizar la suplantación",
      "customer_portal.support_team": "Equipo de soporte",
      "customer_portal.ticket_closed_desc": "Este ticket está cerrado.",
      "customer_portal.ticket_load_failed": "Ticket konnte nicht geladen werden",
      "customer_portal.ticket_load_failed_desc": "Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "customer_portal.ticket_not_found": "Ticket no encontrado",
      "customer_portal.ticket_owner": "Ihr zuständiger Support-Agent",
      "customer_portal.ticket_plural": "Tickets",
      "customer_portal.ticket_singular": "Ticket",
      "customer_portal.tickets_load_failed": "Tickets konnten nicht geladen werden",
      "customer_portal.tickets_load_failed_desc": "Ihre Daten wurden nicht verändert.",
      "customer_portal.times_title": "Tiempos",
      "customer_portal.unassigned_owner": "Noch nicht zugewiesen",
      "customer_portal.unsaved_warning": "Ihr nicht gesendeter Entwurf geht beim Verlassen möglicherweise verloren.",
      "customer_portal.updated": "Actualizado",
      "customer_portal.via_email": "por correo electrónico",
      "customer_portal.write_reply": "Escribir una respuesta",
      "customer_portal.you": "Usted",
      "customer_tickets_summary": "{{open}} abiertos / {{total}} en total",
      "customers": "Clientes",
      "customize": "Personalizar",
      "dark_mode": "Modo oscuro",
      "dashboard": "Tablero",
      "dashboard_sub": "Aquí están sus KPIs operativos, estados de SLA y estadísticas de tickets.",
      "days_ago": "Hace {{count}} d",
      "delete": "Eliminar",
      "density": "Densidad:",
      "density_comfort_label": "Komfort",
      "density_comfortable": "Normal",
      "density_compact": "Compacto",
      "density_spacious": "Espacioso",
      "density_standard_label": "Standard",
      "device_actions": "Geräte & Lizenzen",
      "device_actions_hint": "Fernwartung, Remote-Terminal, Behebung und Lizenzen der verknüpften Geräte",
      "document.all": "Todos",
      "document.category.certificate": "Certificado",
      "document.category.contract": "Contrato",
      "document.category.correspondence": "Correspondencia",
      "document.category.general": "General",
      "document.category.invoice": "Factura",
      "document.category.manual": "Manual",
      "document.category.report": "Informe",
      "document.none_found": "No se han encontrado documentos",
      "document.none_found_desc": "Pruebe con otro término de búsqueda",
      "document.none_shared": "Todavía no se ha compartido ningún documento con usted",
      "document.none_shared_desc": "Su persona de contacto puede poner documentos a su disposición aquí",
      "document.plural": "Documentos",
      "document.search_placeholder": "Buscar documentos...",
      "document.singular": "Documento",
      "document.subtitle": "Sus documentos, contratos y archivos compartidos",
      "document.total_suffix": "en total",
      "domains": "Dominios",
      "draft_present": "Borrador",
      "draft_saved": "Borrador guardado",
      "drag_to_move": "{{label}} (arrastrar para mover)",
      "drag_to_sort": "Arrastrar para ordenar, hacer clic para mostrar/ocultar",
      "duration": "Duración (min.)",
      "duration_minutes": "{{count}} minutos",
      "edit": "Editar",
      "edit_customer": "Editar cliente",
      "edit_master_data_admin": "Editar datos maestros en administración",
      "edit_widgets_title": "Mostrar y ordenar widgets",
      "email": "Correo electrónico",
      "email_channel": "Canal de correo",
      "employee_form.account_erstellt": "Cuenta creada:",
      "employee_form.bitte_zuerst_kunde_auswaehlen": "Seleccione primero un cliente",
      "employee_form.dieser_mitarbeiter_hat_noch_keinen_zugang_zu": "Este empleado aún no tiene acceso al portal del cliente. Cree una cuenta con contraseña.",
      "employee_form.domain_waehlen": "Seleccionar dominio",
      "employee_form.domains_werden_geladen": "Cargando dominios...",
      "employee_form.e_mail_server_nicht_konfiguriert": "Servidor de correo electrónico no configurado",
      "employee_form.initialpasswort_vergeben": "Asignar una contraseña inicial...",
      "employee_form.interne_notizen_zum_mitarbeiter": "Notas internas sobre el empleado...",
      "employee_form.kein_portal_zugang_vorhanden": "Sin acceso al portal",
      "employee_form.keine_domains_fuer_diesen_kunden_hinterlegt": "No hay dominios registrados para este cliente.",
      "employee_form.kunde_auswaehlen": "Seleccionar cliente",
      "employee_form.lade_account_informationen": "Cargando la información de la cuenta...",
      "employee_form.leer_lassen_wenn_kein_portal_zugang_benoetig": "Deje el campo vacío si no se necesita acceso al portal (p. ej., con SSO).",
      "employee_form.letzter_login": "Último inicio de sesión:",
      "employee_form.neues_passwort": "Nueva contraseña...",
      "employee_form.neues_passwort_min_8_zeichen": "Nueva contraseña (mín. 8 caracteres)",
      "employee_form.passwort_fuer_neuen_account_min_8_zeichen": "Contraseña para la nueva cuenta (mín. 8 caracteres)",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge": "Forzar el cambio de contraseña en el primer inicio de sesión",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge_2": "Forzar el cambio de contraseña en el primer inicio de sesión",
      "employee_form.passwortaenderung_beim_naechsten_login_erzwi": "Forzar el cambio de contraseña en el próximo inicio de sesión",
      "employee_form.profilbild_kann_nach_dem_erstellen_hochgelad": "La foto de perfil se puede subir después de la creación.",
      "employee_form.pw_aenderung_ausstehend": "Cambio de contraseña pendiente",
      "employee_form.reset_link_24h_gueltig": "Enlace de restablecimiento (válido 24 h):",
      "employee_form.tab_access": "Portal del cliente",
      "employee_form.tab_it": "TI y puesto de trabajo",
      "employee_form.tab_notes": "Notas",
      "employee_form.tab_personal": "Personal",
      "employee_form.tab_work": "Trabajo y contacto",
      "employee_form.weitere_it_informationen_wie_betriebssystem": "Puede registrar en las notas más información de TI, como el sistema operativo o el software instalado.",
      "employee_form.z_b_koeln_buero_3_og": "p. ej., Colonia, oficina 3.ª planta",
      "employees": "Empleados",
      "employees_ca": "Empleados (aprox.)",
      "end_edit": "Finalizar edición",
      "enter_title_error": "Por favor, introduzca un título.",
      "escalate": "Escalar",
      "escalated": "Escalados",
      "escalated_badge": "Escalado",
      "expand_sidebar": "Expandir barra lateral",
      "expired": "Expirado",
      "expires_at": "Vence el",
      "expiring_soon": "Vence pronto",
      "export_csv": "Archivo CSV",
      "export_pdf": "Documento PDF",
      "export_png": "Gráfico PNG",
      "export_xlsx": "Excel (XLSX)",
      "filter_active": "Filtro activo",
      "filter_all_az": "Todos A–Z",
      "filter_list_placeholder": "Filtrar lista...",
      "filter_open_first": "Abiertos primero",
      "filter_open_only": "Solo con abiertos",
      "filter_with_sla": "Con nivel SLA",
      "first_post_attachments": "Archivos adjuntos al primer mensaje",
      "first_response": "Primera respuesta",
      "follow_ups": "Esperando cliente",
      "generating": "Generando...",
      "greeting_day": "Buen día, {{name}} 👋",
      "held_review": "Requiere revisión",
      "high_priority": "Alta prioridad",
      "hours": "Horas",
      "hours_ago": "Hace {{count}} h",
      "inactive": "Inactivo",
      "included_hours": "Horas incl.",
      "industry": "Sector",
      "internal": "Interno",
      "internal_chat": "Chat interno",
      "internal_note": "Nota interna",
      "internal_notes": "Notas internas",
      "internal_notes_placeholder": "Notas internas sobre el cliente...",
      "invalid_datetime_error": "Fecha u hora inválida.",
      "just_now": "Ahora mismo",
      "kb.all_articles": "Todos los artículos",
      "kb.author": "Autor",
      "kb.back_to_overview": "Volver al resumen",
      "kb.browse_more": "← Explorar más artículos",
      "kb.no_articles": "Todavía no hay artículos disponibles",
      "kb.no_articles_desc": "Pronto aparecerán aquí artículos útiles",
      "kb.pinned": "Fijado",
      "kb.read_time": "{{count}} min de lectura",
      "kb.search_placeholder": "¿Qué está buscando? P. ej. VPN, contraseña, correo electrónico...",
      "kb.subtitle": "Guías, consejos y ayuda para sus preguntas",
      "kb.try_different_search": "Pruebe con otro término de búsqueda",
      "kb.updated_at": "Actualizado el {{date}}",
      "kb.views_count": "{{count}} visualizaciones",
      "keyboard_shortcuts": "Atajos de teclado",
      "knowledge": "Base de conocimientos",
      "knowledge_base": "Base de conocimientos",
      "kpi_held": "Remitente no identificado",
      "kpi_important": "importante",
      "kpi_open": "abierto",
      "kpi_sla_breached": "Brecha de SLA",
      "kunde_loeschen.artikel": "Wissensartikel",
      "kunde_loeschen.bestaetigung_label": "Zur Bestätigung den Firmennamen eingeben",
      "kunde_loeschen.connectoren": "Connectoren",
      "kunde_loeschen.dokumente": "Dokumente",
      "kunde_loeschen.einleitung": "Dieser Kunde hat keine Tickets und keine Rechnungen. Er kann vollständig entfernt werden — mitsamt seinem Mandantenbereich in der Datenbank. Das lässt sich nicht rückgängig machen.",
      "kunde_loeschen.endgueltig_loeschen": "Endgültig löschen",
      "kunde_loeschen.fehlgeschlagen": "Das Löschen ist fehlgeschlagen.",
      "kunde_loeschen.geraete": "Geräte im Inventar",
      "kunde_loeschen.lizenzen": "Softwarelizenzen",
      "kunde_loeschen.mitarbeiter": "Mitarbeiter",
      "kunde_loeschen.netzgeraete": "Gefundene Netzwerkgeräte",
      "kunde_loeschen.nichts_dran": "An diesem Kunden hängen keine weiteren Daten.",
      "kunde_loeschen.portalbenutzer": "Portalzugänge",
      "kunde_loeschen.pruefung_fehlgeschlagen": "Die Prüfung ist fehlgeschlagen.",
      "kunde_loeschen.titel": "Kunde endgültig löschen",
      "kunde_loeschen.tokens": "API-Token",
      "kunde_loeschen.vertraege": "Verträge",
      "kunde_loeschen.wird_geprueft": "Wird geprüft …",
      "kunde_loeschen.wird_mitgeloescht": "Wird mitgelöscht",
      "kunde_loeschen.zeiten": "Zeiteinträge",
      "language": "Idioma",
      "license.cluster_audit": "Auditoría",
      "license.cluster_balance": "Balance",
      "license.cluster_calc": "Calculadora",
      "license.cluster_contracts": "Contratos y licencias",
      "license.cluster_optimize": "Optimización",
      "license.tab_ad_coupling": "Acoplamiento CAL-AD",
      "license.tab_cal_calc": "Calculadora de CAL",
      "license.tab_catalog": "Catálogo de software",
      "license.tab_contracts": "Contratos",
      "license.tab_dashboard": "Balance de licencias y Tendencias",
      "license.tab_licenses": "Gestión de licencias",
      "license.tab_more_views": "Más vistas",
      "license.tab_reclaims": "Optimización y Recuperaciones",
      "license.tab_remediation": "Remediación",
      "license.tab_sealed": "Archivo de auditoría",
      "license.tab_sql_calc": "Calculadora de licencias SQL",
      "license.tab_steering": "Control",
      "license.tab_suite_config": "Configurador de suite",
      "license_compliance.actions": "Acciones",
      "license_compliance.assign_license_metric": "Asignar métrica de licencia",
      "license_compliance.confirm_delete_assignment": "¿Seguro que desea eliminar la asignación?",
      "license_compliance.confirm_delete_contract": "¿Seguro que desea eliminar el contrato? Las licencias vinculadas se mantendrán, pero se desvincularán del contrato.",
      "license_compliance.contract_expiry_alert": "Vencimiento de contrato",
      "license_compliance.deficit_forecast_desc": "Según los escaneos en vivo, en la fecha de aniversario se generarán cargos adicionales por los productos con licencias insuficientes.",
      "license_compliance.edit_contract": "Editar contrato",
      "license_compliance.edit_license": "Editar licencia",
      "license_compliance.expired_contracts_title": "¡Se han detectado contratos de software caducados!",
      "license_compliance.expired_contracts_warning_desc": "Las licencias asignadas a estos contratos se ignoran en el cálculo de conformidad.",
      "license_compliance.forecasted_payment": "Pago adicional previsto",
      "license_compliance.license_deficit_alert": "Déficit de licencias",
      "license_compliance.mark_license_required_btn": "Marcar como sujeto a licencia",
      "license_compliance.new_contract": "Crear un contrato nuevo",
      "license_compliance.new_license": "Crear una licencia nueva",
      "license_compliance.no_deficit_desc": "¡Enhorabuena! Sus asignaciones de Microsoft Core/CAL cubren todos los resultados del escaneo.",
      "license_compliance.not_catalogued": "No catalogado",
      "license_compliance.reconciliation_desc": "Inicia un ciclo de conciliación manual para este inquilino. Vuelve a calcular en vivo el apilamiento de VM, el estado del descubrimiento WMI, los periodos de Software Assurance y la vigencia de los contratos.",
      "license_compliance.reconciliation_running": "Conciliación en curso...",
      "license_compliance.run_reconciliation": "Ejecutar la conciliación",
      "license_compliance.sam_warnings_title": "Avisos de SAM y conformidad",
      "license_compliance.save_contract": "Guardar contrato",
      "license_compliance.save_license": "Guardar licencia",
      "license_compliance.seal_audit": "Sellar la auditoría",
      "license_compliance.seal_audit_btn": "Sellar con validez legal",
      "license_compliance.sealing": "Sellando...",
      "license_compliance.toast.add_suite_component_error": "Error al asignar el componente de la suite",
      "license_compliance.toast.assignment_completed": "Asignación de licencia realizada correctamente.",
      "license_compliance.toast.assignment_error": "Error al realizar la asignación",
      "license_compliance.toast.bulk_classify_error": "Error en la clasificación masiva",
      "license_compliance.toast.bulk_classify_success": "{{count}} entradas de software clasificadas correctamente.",
      "license_compliance.toast.calc_audit_error": "Error al calcular la auditoría de licencias",
      "license_compliance.toast.contract_created": "Contrato creado correctamente.",
      "license_compliance.toast.contract_deleted": "Contrato eliminado.",
      "license_compliance.toast.contract_updated": "Contrato actualizado correctamente.",
      "license_compliance.toast.create_purchase_req_error": "Error al crear la solicitud de compra",
      "license_compliance.toast.delete_contract_error": "Error al eliminar el contrato",
      "license_compliance.toast.delete_license_error": "Error al eliminar la licencia",
      "license_compliance.toast.delete_suite_component_error": "Error al eliminar la asignación",
      "license_compliance.toast.license_created": "Licencia creada correctamente.",
      "license_compliance.toast.license_deleted": "Licencia eliminada.",
      "license_compliance.toast.license_updated": "Licencia actualizada correctamente.",
      "license_compliance.toast.load_customers_error": "Error al cargar la lista de clientes",
      "license_compliance.toast.purchase_req_created": "Solicitud de compra de {{units}}x {{model}} (True-Up: {{cost}}) creada como ticket {{ticket}}.",
      "license_compliance.toast.reconcile_completed": "Conciliación finalizada correctamente. Los indicadores de conformidad se han recalculado en vivo.",
      "license_compliance.toast.reconcile_error": "Error en la conciliación",
      "license_compliance.toast.sam_settings_saved": "Configuración de SAM guardada correctamente.",
      "license_compliance.toast.save_contract_error": "Error al guardar el contrato",
      "license_compliance.toast.save_license_error": "Error al guardar la licencia",
      "license_compliance.toast.save_sam_settings_error": "Error al guardar la configuración de SAM",
      "license_compliance.toast.seal_audit_error": "Error al sellar la auditoría de licencias",
      "license_compliance.toast.seal_audit_success": "Auditoría de licencias sellada correctamente.",
      "license_compliance.toast.suite_component_added": "Componente asignado correctamente a la suite.",
      "license_compliance.toast.suite_component_deleted": "Asignación eliminada.",
      "license_compliance.toast.uninstall_error": "Error al iniciar las desinstalaciones",
      "license_compliance.toast.uninstall_triggered": "Comandos de desinstalación puestos en cola.",
      "license_compliance.update_contract": "Actualizar contrato",
      "license_compliance.update_license": "Actualizar licencia",
      "licenses": "Licencias",
      "light_mode": "Modo claro",
      "link_asset_btn": "+ Vincular activo",
      "live_activity": "Actividad en vivo",
      "loading": "Wird geladen…",
      "loading_ellipsis": "Cargando...",
      "location_on_map": "Ubicación en el mapa",
      "login.abbrechen": "Cancelar",
      "login.administratoradresse_konnte_nicht_geaendert_werden": "Die Administratoradresse konnte nicht geändert werden.",
      "login.adresse_aendern": "Adresse ändern",
      "login.adresse_wird_geaendert": "Adresse wird geändert…",
      "login.aendern": "Cambiar",
      "login.aktivierung": "Activando…",
      "login.aktivierung_fehlgeschlagen_code_pruefen": "Error al activar. Compruebe el código.",
      "login.alle_rechte_vorbehalten": "· Todos los derechos reservados.",
      "login.anmelden": "Iniciar sesión",
      "login.anmelden_laeuft": "Iniciando sesión…",
      "login.anmeldung": "Iniciando sesión…",
      "login.bestaetigen": "Confirmar",
      "login.bitte_geben_sie_eine_gueltige_e_mail_adresse": "Introduzca una dirección de correo electrónico válida.",
      "login.bitte_geben_sie_ihr_passwort_ein": "Introduzca su contraseña.",
      "login.bitte_geben_sie_zuerst_ihre_e_mail_adresse_e": "Introduzca primero su dirección de correo electrónico.",
      "login.claim": "Service desk, activos y licencias: una base de datos, un proceso.",
      "login.datenschutz": "Privacidad",
      "login.e_mail_adresse_erfolgreich_geaendert": "E-Mail-Adresse erfolgreich geändert. Melden Sie sich jetzt mit der neuen Adresse an.",
      "login.ein_fehler_ist_aufgetreten": "Se ha producido un error.",
      "login.einloggen_schliessen": "Iniciar sesión y cerrar",
      "login.erstanmeldung": "Primer inicio de sesión:",
      "login.falls_ein_konto_existiert_wurde_eine_e_mail": "Si existe una cuenta, se ha enviado un correo electrónico para restablecer la contraseña.",
      "login.fehler_beim_laden_des_mfa_setups": "No se pudo cargar la configuración de MFA",
      "login.fehler_beim_ueberpruefen_der_e_mail_adresse": "No se pudo comprobar la dirección de correo.",
      "login.geben_sie_den_6_stelligen_code_aus_ihrer_aut": "Introduzca el código de 6 dígitos de su aplicación de autenticación o un código de recuperación.",
      "login.geschaeftliche_e_mail": "Correo corporativo",
      "login.ihr_account_ist_deaktiviert": "Su cuenta está desactivada.",
      "login.ihr_administrator_erfordert_die_einrichtung": "Su administrador exige configurar la autenticación de dos factores.",
      "login.impressum": "Aviso legal",
      "login.kunden_account_erkannt": "Cuenta de cliente detectada",
      "login.manueller_schluessel": "Clave manual",
      "login.melden_sie_sich_an_ihrem_service_desk_an": "Inicie sesión en su service desk.",
      "login.mfa_aktivieren_weiter": "Activar MFA y continuar",
      "login.mfa_einrichtung_erforderlich": "Se requiere configurar MFA",
      "login.mfa_einrichtung_fehlgeschlagen": "Error al configurar MFA.",
      "login.mfa_erfolgreich_aktiviert": "MFA activado correctamente",
      "login.neue_geschaeftliche_e_mail": "Neue geschäftliche E-Mail",
      "login.oder": "O",
      "login.passwort": "Contraseña",
      "login.qr_code_fuer_die_authenticator_app": "Código QR para la app de autenticación",
      "login.sechsstelliger_verifizierungscode": "Código de verificación de 6 dígitos",
      "login.sende": "Enviando…",
      "login.sicherheitszeile": "AES-256 · Doble factor · Alojamiento propio",
      "login.sicherheitszeile_kurz": "AES-256 · Zwei-Faktor",
      "login.sie_werden_automatisch_zum_kundenportal_weit": "Se le redirigirá automáticamente al portal del cliente para iniciar sesión allí...",
      "login.single_sign_on_entra_id": "Single Sign-On (Entra ID)",
      "login.speichern_sie_diese_einmal_wiederherstellung": "¡Guarde bien estos códigos de recuperación de un solo uso! Puede utilizarlos si pierde el acceso a su aplicación.",
      "login.sso_anmeldung_fehlgeschlagen": "Error al iniciar sesión con SSO",
      "login.startkonto_bestaetigt_adresse_festlegen": "Die Zugangsdaten des Startkontos wurden bestätigt. Legen Sie jetzt die geschäftliche Adresse für den Administrator fest.",
      "login.ueberpruefe": "Comprobando...",
      "login.ungueltiger_oder_abgelaufener_mfa_code": "Código MFA no válido o caducado.",
      "login.verifiziere": "Verificando…",
      "login.weiter": "Continuar",
      "login.willkommen_zurueck": "Bienvenido de nuevo",
      "login.zurueck_zum_login": "Volver al inicio de sesión",
      "login.zuruecksetzen": "Restablecer",
      "login.zwei_faktor_code_totp": "Código de doble factor (TOTP)",
      "logout": "Cerrar sesión",
      "main_navigation_rail": "Barra de navegación principal",
      "managing_director": "Director general",
      "managing_director_abbrev": "DG",
      "managing_director_prefix": "Dirección ejecutiva:",
      "mark_all_read": "Marcar todo como leído",
      "mark_as_resolved": "Marcar como resuelto",
      "mati.connection_error": "Error de conexión",
      "mati.delete": "Eliminar",
      "mati.error_failed_connection": "No se ha podido conectar con el servicio de IA.",
      "mati.error_generation": "Error al generar la respuesta. Inténtelo de nuevo.",
      "mati.gdpr_warning": "Filtro RGPD activo: los datos personales se anonimizan automáticamente antes de su transmisión.",
      "mati.greeting": "¡Hola, {{name}}! Soy {{mascot}}. ¿En qué puedo ayudarte hoy con tu trabajo? 🔮\\n\\nPuedes preguntarme por:\\n- El estado del sistema o la carga de trabajo de los agentes\\n- Búsquedas de tickets (\"Busca tickets sin resolver con prioridad alta\")\\n- Creación de tickets (\"Crea un ticket: cartucho de impresora vacío en la 2.ª planta\")",
      "mati.history": "Historial",
      "mati.input_placeholder": "Pregúnteme sobre tickets o carga de trabajo, o cree un ticket...",
      "mati.new_chat": "Nuevo chat",
      "mati.online_intelligent": "En línea e inteligente",
      "mati.rename": "Cambiar el nombre",
      "mati.restore_bead": "Mostrar el asistente flotante",
      "mati.restore_bead_tooltip": "Volver a mostrar el asistente flotante (Bead) en el borde de la pantalla",
      "mati.send_btn": "Enviar",
      "mati.suggest.create_ticket.desc": "Impresora averiada en la 1.ª planta",
      "mati.suggest.create_ticket.prompt": "Cree un ticket para una impresora averiada en la 1.ª planta, con prioridad media.",
      "mati.suggest.create_ticket.title": "Crear un ticket",
      "mati.suggest.search_tickets.desc": "Búsqueda \"base de datos\"",
      "mati.suggest.search_tickets.prompt": "Busque tickets que contengan la palabra \"base de datos\".",
      "mati.suggest.search_tickets.title": "Buscar tickets",
      "mati.suggest.support_help.desc": "Ayuda para redactar preguntas frecuentes",
      "mati.suggest.support_help.prompt": "¿Cómo redacto una negativa amable a una solicitud de reembolso?",
      "mati.suggest.support_help.title": "Ayuda de soporte",
      "mati.suggest.system_status.desc": "Mostrar la carga de trabajo actual",
      "mati.suggest.system_status.prompt": "Muéstreme el estado actual del sistema y un resumen de la carga de trabajo de los agentes.",
      "mati.suggest.system_status.title": "Estado del sistema",
      "mati.typing_text": "{{name}} está escribiendo...",
      "mati.welcome_subtitle": "Soy tu copiloto de IA inteligente. Puedo ayudarte a gestionar tickets, buscar en el sistema o consultar las estadísticas del sistema.",
      "mati.welcome_title": "¡Hola! Soy {{name}}",
      "mati_gdpr_warning": "Filtro RGPD activo: Los datos personales se anonimizan automáticamente antes de la transmisión.",
      "mati_placeholder": "Pregúntame algo sobre tickets, carga de trabajo, o crea un ticket...",
      "mati_welcome": "¡Hola! Soy {{name}}",
      "meeting_error_title": "No se pudo crear la reunión de Teams.",
      "meeting_success": "Reunión de Teams creada.",
      "meeting_success_copy": "Reunión de Teams creada, enlace copiado al portapapeles.",
      "megamenu.active_label": "Trabajo",
      "megamenu.calendar_desc": "Citas e integración con el calendario.",
      "megamenu.licenses_desc": "Conformidad de licencias, suites y planificación de True-up.",
      "megamenu.modules": "Módulos",
      "megamenu.open_calendar": "Abrir el calendario",
      "megamenu.open_licenses": "Abrir las licencias",
      "megamenu.open_problems": "Abrir los problemas",
      "megamenu.problems_desc": "Gestión de problemas y RCA (análisis de causa raíz).",
      "megamenu.quick_search_commands": "Búsqueda rápida y comandos",
      "merge": "Zusammenführen",
      "merge_tickets": "Die beiden markierten Tickets zusammenführen",
      "mfa_settings": "Configuración MFA",
      "minutes_ago": "Hace {{count}} min",
      "mloffice.abgleich_fehler": "Abgleich konnte nicht gestartet werden.",
      "mloffice.abgleich_fehlgeschlagen": "Letzter Abgleich fehlgeschlagen: {{fehler}}",
      "mloffice.abgleich_gestartet": "Voll-Abgleich gestartet.",
      "mloffice.abgleich_laeuft": "Abgleich läuft",
      "mloffice.adresse": "MLOffice-Adresse",
      "mloffice.adresse_hinweis": "Basisadresse der MLOffice-Installation — ohne /api/v1.",
      "mloffice.agenten_titel": "Agenten ↔ MLOffice-Benutzer",
      "mloffice.aktion_anlegen": "Neu anlegen",
      "mloffice.aktion_entkoppeln": "Entkoppeln",
      "mloffice.aktion_entkoppeln_hinweis": "Aus dem Abgleich nehmen — der Kunde bleibt bestehen und wird wieder editierbar.",
      "mloffice.aktion_verknuepfen": "Verknüpfen",
      "mloffice.aktiv": "Aktiv",
      "mloffice.aktivieren": "Anbindung aktiv",
      "mloffice.auswahl_fehler": "Auswahl konnte nicht gespeichert werden.",
      "mloffice.bereits_uebertragen": "{{n}} Einträge im Zeitraum sind bereits übertragen und werden übersprungen.",
      "mloffice.email_eingeben": "Der Partner hat in MLOffice keine E-Mail-Adresse. E-Mail für den neuen Kunden:",
      "mloffice.entwurf_anlegen": "Entwurf anlegen",
      "mloffice.entwurf_fehler": "Entwurf konnte nicht angelegt werden.",
      "mloffice.entwurf_hinweis": "Erzeugt aus den bereits übertragenen Zeiten des Zeitraums einen ENTWURF in MLOffice. Belegnummer, Festschreibung und Versand bleiben MLOffice vorbehalten.",
      "mloffice.entwurf_ok": "Entwurf über {{h}} h in MLOffice angelegt — Festschreiben und Versand dort.",
      "mloffice.entwurf_titel": "Rechnungsentwurf in MLOffice",
      "mloffice.ereignis_closed": "Ticket geschlossen",
      "mloffice.ereignis_created": "Ticket eröffnet",
      "mloffice.ereignis_escalated": "Ticket eskaliert",
      "mloffice.ereignisse_titel": "Ticket-Ereignisse in die MLOffice-Kontakthistorie melden (nur Referenz, nie Inhalt):",
      "mloffice.erst_aktivieren": "Bitte zuerst die Anbindung aktivieren und die Verbindung testen — dann erscheint hier der MLOffice-Kundenbestand.",
      "mloffice.erst_aktivieren_abrechnung": "Bitte zuerst die Anbindung aktivieren — dann erscheinen hier offene Posten und der Kontingent-Abgleich.",
      "mloffice.erst_aktivieren_zeiten": "Bitte zuerst die Anbindung aktivieren — dann lassen sich Zeiten per Übertragungslauf nach MLOffice geben.",
      "mloffice.fallback_hinweis": "{{n}} Einträge ohne Agenten-Zuordnung werden über den technischen Benutzer gebucht (Agentenname in der Beschreibung).",
      "mloffice.feld_bis": "Bis",
      "mloffice.feld_kunde": "Kunde",
      "mloffice.feld_projekt": "MLOffice-Projekt",
      "mloffice.feld_satz": "Stundensatz (netto)",
      "mloffice.feld_von": "Von",
      "mloffice.gespeichert": "MLOffice-Einstellungen gespeichert.",
      "mloffice.gueltig_180": "180 Tage",
      "mloffice.gueltig_365": "365 Tage",
      "mloffice.gueltig_90": "90 Tage",
      "mloffice.gueltig_unbegrenzt": "Unbegrenzt",
      "mloffice.hoheit_frage": "MLOffice übernimmt die Hoheit über: {{felder}}.\\n\\nDiese Felder sind in AISupportDesk dann gesperrt und werden fortlaufend aus MLOffice übernommen. Fortfahren?",
      "mloffice.inaktiv": "Inaktiv",
      "mloffice.keine_partner": "Noch keine MLOffice-Kunden geladen. „Liste aus MLOffice laden“ holt den Bestand.",
      "mloffice.keine_zuordnung": "— keine Zuordnung —",
      "mloffice.konflikt_fehler": "Konnte nicht übernommen werden.",
      "mloffice.konflikt_geloest": "Übernommen.",
      "mloffice.konflikt_hinweis": "Übernahme braucht eine Entscheidung — siehe Konfliktzeile.",
      "mloffice.kopieren": "Kopieren",
      "mloffice.kunde_waehlen": "— Kunde wählen —",
      "mloffice.kunden_erklaerung": "Wähle aus, welche MLOffice-Kunden hier geführt werden. Ausgewählte Kunden werden fortlaufend abgeglichen; ihre Stammdaten sind hier gesperrt. Abwählen entkoppelt nur — der Kunde bleibt bestehen.",
      "mloffice.laden_fehler": "MLOffice-Einstellungen konnten nicht geladen werden.",
      "mloffice.laeufe_titel": "Bisherige Übertragungsläufe",
      "mloffice.lauf_detail": "Lauf #{{id}} — Einzelposten",
      "mloffice.lauf_fehler": "Lauf konnte nicht gestartet werden.",
      "mloffice.lauf_fertig": "Fertig",
      "mloffice.lauf_gestartet": "Übertragungslauf gestartet.",
      "mloffice.lauf_laeuft": "Läuft",
      "mloffice.lauf_starten": "Übertragung starten",
      "mloffice.lauf_teilfehler": "Mit Fehlern",
      "mloffice.linktoken_abgelaufen": "Das Verbindungstoken ist abgelaufen — MLOffice kann sich nicht mehr ausweisen. Neues Token erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_ablauf_teil": ", gültig bis {{datum}}",
      "mloffice.linktoken_einmal": "Jetzt kopieren — dieses Token wird nur EINMAL angezeigt:",
      "mloffice.linktoken_eintragen": "In MLOffice unter Einstellungen → AISupportDesk-Anbindung eintragen.",
      "mloffice.linktoken_erklaerung": "Dieses Token wird HIER erzeugt und in MLOffice unter „AISupportDesk-Anbindung“ eingetragen. MLOffice weist sich damit aus (Verbindungsstatus, Webhooks). Wird die Anbindung hier gelöst oder das Token widerrufen, zeigt MLOffice die Verbindung als gelöst.",
      "mloffice.linktoken_erzeugen": "Token erzeugen",
      "mloffice.linktoken_fehler": "Verbindungstoken konnte nicht erzeugt werden.",
      "mloffice.linktoken_gueltigkeit": "Gültigkeit",
      "mloffice.linktoken_kopiert": "Token kopiert.",
      "mloffice.linktoken_laeuft_ab": "Das Verbindungstoken läuft in {{tage}} Tagen ab. Rechtzeitig neu erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_neu": "Neues Token erzeugen",
      "mloffice.linktoken_rotieren_frage": "Es existiert bereits ein Verbindungstoken. Ein neues macht das alte sofort ungültig — MLOffice muss dann das neue Token eintragen. Fortfahren?",
      "mloffice.linktoken_status": "Hinterlegt ({{hint}}), erzeugt {{erzeugt}}{{ablauf}}.",
      "mloffice.linktoken_titel": "Verbindungstoken für MLOffice",
      "mloffice.linktoken_unbegrenzt_teil": ", unbegrenzt gültig",
      "mloffice.linktoken_widerruf_fehler": "Widerruf fehlgeschlagen.",
      "mloffice.linktoken_widerruf_frage": "Verbindungstoken widerrufen? MLOffice zeigt die Verbindung danach als gelöst; Webhooks und Statusabfragen von MLOffice werden abgewiesen.",
      "mloffice.linktoken_widerrufen": "Verbindungstoken widerrufen.",
      "mloffice.linktoken_widerrufen_btn": "Widerrufen",
      "mloffice.liste_aktualisieren": "Liste aus MLOffice laden",
      "mloffice.loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "mloffice.nur_verknuepfte": "Nur mit MLOffice verknüpfte Kunden.",
      "mloffice.ohne_email": "ohne E-Mail",
      "mloffice.op_aktualisiert": "Offene Posten aktualisiert.",
      "mloffice.op_belege": "Belege",
      "mloffice.op_fehler": "Offene Posten konnten nicht geladen werden.",
      "mloffice.op_laden": "Offene Posten aus MLOffice laden",
      "mloffice.op_stand": "Stand: {{zeit}}",
      "mloffice.op_titel": "Offene Posten (MLOffice)",
      "mloffice.partner_laden_fehler": "MLOffice-Kundenliste konnte nicht geladen werden.",
      "mloffice.posten_ok": "übertragen",
      "mloffice.posten_retry": "Erneut",
      "mloffice.posten_skip": "Überspringen",
      "mloffice.projekt_pflicht": "Bitte oben ein MLOffice-Projekt wählen.",
      "mloffice.projekt_waehlen": "— Projekt wählen —",
      "mloffice.rechte_fehlen": "Dem Token fehlen Rechte:",
      "mloffice.recon_asd": "Support-Sicht (NALVRA SERVICE)",
      "mloffice.recon_diff": "Abweichung Support- zu Abrechnungs-Sicht: {{min}} Min.",
      "mloffice.recon_gebucht": "{{min}} Min. im Projekt „{{projekt}}“ gebucht",
      "mloffice.recon_gesperrt_bis": "Erfassung gesperrt bis: {{d}}",
      "mloffice.recon_kein_projekt": "Kein MLOffice-Projekt zugeordnet (Tab „Zuordnung“).",
      "mloffice.recon_kein_vertrag": "Kein aktiver Vertrag mit Kontingent für diesen Kunden.",
      "mloffice.recon_mlo": "Abrechnungs-Sicht (MLOffice)",
      "mloffice.recon_offen": "{{min}} Min. der laufenden Periode sind noch nicht an MLOffice übertragen — Übertragungslauf im Tab „Zeiten-Übertragung“ starten.",
      "mloffice.recon_titel": "Kontingent-Abgleich",
      "mloffice.recon_verbrauch": "{{used}} von {{incl}} Min. verbraucht — {{rest}} Min. übrig",
      "mloffice.schon_drueben": "übertragen",
      "mloffice.sp_agent": "Agent",
      "mloffice.sp_beschreibung": "Beschreibung",
      "mloffice.sp_datum": "Datum",
      "mloffice.sp_fortschritt": "Gesendet / Fehler / Gesamt",
      "mloffice.sp_kunde": "Kunde",
      "mloffice.sp_minuten": "Min.",
      "mloffice.sp_status": "Status",
      "mloffice.sp_ticket": "Ticket",
      "mloffice.sp_zeitraum": "Zeitraum",
      "mloffice.spalte_kunde": "MLOffice-Kunde",
      "mloffice.spalte_status": "Status",
      "mloffice.spalte_sync": "Sync",
      "mloffice.spalte_zuordnung": "Zuordnung in NALVRA SERVICE",
      "mloffice.speichern": "Speichern",
      "mloffice.speichern_fehler": "Speichern fehlgeschlagen.",
      "mloffice.status_archiviert": "In MLOffice archiviert",
      "mloffice.status_delta": "Letzter Kundenabgleich: {{zeit}}",
      "mloffice.status_entkoppelt": "Entkoppelt",
      "mloffice.status_failed": "{{n}} Übertragungen fehlgeschlagen",
      "mloffice.status_kein_linktoken": "Kein Verbindungstoken für MLOffice erzeugt",
      "mloffice.status_konflikt": "Entscheidung nötig",
      "mloffice.status_linktoken_abgelaufen": "Verbindungstoken abgelaufen — neu erzeugen und in MLOffice eintragen",
      "mloffice.status_neu": "Neu",
      "mloffice.status_op": "Offene Posten: {{zeit}}",
      "mloffice.status_pending": "{{n}} Übertragungen offen",
      "mloffice.status_ratelimit": "MLOffice-Ratenbegrenzung — kurze Pause",
      "mloffice.status_sync_fehler": "Letzter Abgleich mit Fehler",
      "mloffice.status_uebernommen": "Übernommen",
      "mloffice.tab_abrechnung": "Abrechnung",
      "mloffice.tab_kunden": "Kundenabgleich",
      "mloffice.tab_verbindung": "Verbindung",
      "mloffice.tab_zeiten": "Zeiten-Übertragung",
      "mloffice.tab_zuordnung": "Zuordnung",
      "mloffice.techuser_hinweis": "Wird für Zeitbuchungen ohne Agenten-Zuordnung verwendet; der Agentenname wandert dann in die Buchungsbeschreibung.",
      "mloffice.techuser_titel": "Technischer Benutzer (Fallback)",
      "mloffice.test_fehler": "Verbindungstest fehlgeschlagen.",
      "mloffice.test_nicht_verbunden": "Keine Verbindung",
      "mloffice.test_ok": "Verbindung zu MLOffice steht.",
      "mloffice.test_verbunden": "Verbunden mit Mandant „{{tenant}}“",
      "mloffice.testen": "Verbindung testen",
      "mloffice.titel": "MLOffice-Anbindung",
      "mloffice.token": "API-Token",
      "mloffice.token_gesetzt": "hinterlegt ({{hint}})",
      "mloffice.token_hinweis": "In MLOffice unter Einstellungen → API-Tokens anlegen. Benötigte Rechte prüft der Verbindungstest.",
      "mloffice.token_name": "Token: {{name}}",
      "mloffice.token_unveraendert": "Leer lassen = unverändert",
      "mloffice.untertitel": "Kundenstammdaten, Abrechnung, Zeiterfassung und CRM mit MLOffice koppeln. MLOffice ist das führende System für Stammdaten und Rechnungen.",
      "mloffice.users_dropdown": "Zeitbuchungen werden in MLOffice unter dem zugeordneten Benutzer geführt. Ohne Zuordnung greift der technische Benutzer.",
      "mloffice.users_manuell": "MLOffice stellt (noch) keine Benutzerliste bereit — MLOffice-User-UUID bitte manuell eintragen (in MLOffice unter Benutzerverwaltung kopieren).",
      "mloffice.uuid_platzhalter": "MLOffice-User-UUID",
      "mloffice.verbindung": "Verbindung",
      "mloffice.vollabgleich": "Voll-Abgleich starten",
      "mloffice.vorschau": "Vorschau",
      "mloffice.vorschau_anlegen": "Wird neu angelegt",
      "mloffice.vorschau_email_fehlt": "E-Mail fehlt — wird bei Übernahme abgefragt",
      "mloffice.vorschau_fehler": "Vorschau fehlgeschlagen.",
      "mloffice.vorschau_titel": "Vorschau: {{n}} Einträge, {{h}} h werden übertragen",
      "mloffice.vorschau_verknuepfung": "Vorschlag: mit „{{name}}“ verknüpfen ({{grund}})",
      "mloffice.zeiten_erklaerung": "Zeiten werden NICHT automatisch übertragen. Du wählst Kunde und Zeitraum, prüfst die Vorschau und bestätigst — erst dann gehen die Buchungen nach MLOffice. Übertragene Buchungen sind dort unumkehrbar und hier gesperrt.",
      "mloffice.zeitraum_bis_heute": "Bis heute",
      "mloffice.zeitraum_dieser_monat": "Dieser Monat",
      "mloffice.zeitraum_letzter_monat": "Letzter Monat",
      "mloffice.zuordnung_fehler": "Zuordnung konnte nicht gespeichert werden.",
      "mloffice.zuordnung_fehlt": "{{n}} Einträge ohne Agenten-Zuordnung — bitte unter „Zuordnung“ pflegen oder einen technischen Benutzer hinterlegen.",
      "mloffice.zuordnung_gespeichert": "Zuordnung gespeichert.",
      "mobile": "Móvil",
      "move_ticket": "Verschieben",
      "my_tickets": "Mis tickets",
      "navbar_search_placeholder": "Buscar tickets, clientes o KB...",
      "new": "Nuevo",
      "new_activity_aria": "Nueva actividad",
      "new_activity_title": "Nueva actividad desde la última visita",
      "new_company": "Neue Firma",
      "new_label": "Nuevo",
      "new_ticket": "Nuevo ticket",
      "next": "Weiter",
      "no_activities_recorded": "No se ha registrado ninguna actividad todavía.",
      "no_canned_responses": "No hay respuestas predefinidas",
      "no_canned_responses_hint": "Se gestionan en la administración.",
      "no_critical_tickets": "No hay tickets críticos",
      "no_customer_assigned": "Ningún cliente asignado",
      "no_customer_data": "No se cargaron datos del cliente.",
      "no_customers_found": "No se encontraron clientes",
      "no_customers_matching": "No se pudieron encontrar clientes para su selección de filtro o consulta de búsqueda.",
      "no_data_available": "No hay datos disponibles",
      "no_employees_found": "No hay empleados registrados",
      "no_notes_placeholder": "No hay notas disponibles. Haga clic en \"Editar\" para agregar notas.",
      "no_notifications": "Sin notificaciones",
      "no_other_agents_online": "Actualmente no hay otros miembros del equipo en línea.",
      "no_results": "Sin resultados",
      "no_tickets_found": "No se encontraron tickets",
      "no_tickets_found_desc": "Actualmente no hay elementos en esta cola de filtrado.",
      "no_tickets_risk": "Actualmente no hay tickets en la ventana crítica de advertencia de SLA.",
      "not_spam": "No es spam",
      "notification_settings": "Configuración de notificaciones",
      "notification_settings_desc": "Elija qué notificaciones desea recibir.",
      "notification_settings_saved": "Configuración de notificaciones guardada.",
      "notifications": "Notificaciones",
      "notify_license_change": "Cambios de licencia",
      "notify_new_reply": "Nuevas respuestas",
      "notify_new_ticket": "Nuevos tickets",
      "notify_status_changed": "Cambios de estado",
      "observers_title": "Observadores",
      "only_visible_for": "Solo {{name}}",
      "only_visible_to_agents": "Solo visible para agentes",
      "open_administration": "Abrir administración",
      "open_btn": "Abrir",
      "open_password_vault": "Abrir caja fuerte de contraseñas",
      "open_quick_search": "Abrir búsqueda rápida",
      "open_tickets": "Tickets abiertos",
      "other_tickets_count": "Otros tickets ({{count}})",
      "other_tickets_requester_count": "Otros tickets del solicitante ({{count}})",
      "overdue": "Atrasados",
      "overview_option_1": "1. Panel de KPI estándar",
      "overview_option_10": "10. Tasa de infracción de SLA por prioridades",
      "overview_option_2": "2. Tasa de resolución al primer contacto (FCR) y tiempo de respuesta",
      "overview_option_3": "3. Evolución del volumen de tickets y horas pico",
      "overview_option_4": "4. Tendencias de tasa de resolución (Creados vs. Resueltos)",
      "overview_option_5": "5. Matriz de CSAT vs. tiempo de resolución",
      "overview_option_6": "6. Canales de tickets y desglose de fuentes",
      "overview_option_7": "7. Tasas de escalada y análisis de ruta de escalada",
      "overview_option_8": "8. Tiempo de vida promedio de tickets (Envejecimiento)",
      "overview_option_9": "9. Estado del backlog y envejecimiento",
      "performance_queues": "Rendimiento y Colas",
      "phone": "Teléfono",
      "plan_teams_meeting": "Planificar reunión de Teams",
      "planning": "Planificación",
      "please_enter_text": "Por favor, introduzca texto",
      "policy": "Política",
      "portal_company.load_failed": "Dokumente konnten nicht geladen werden.",
      "portal_company.primary_contact": "Hauptansprechpartner",
      "portal_session.continue": "Weiterarbeiten",
      "portal_session.login": "Erneut anmelden",
      "portal_session.warning": "Ihre Sitzung endet in {{seconds}} Sekunden. Gespeicherte Entwürfe bleiben erhalten.",
      "portal_speech.denied": "Mikrofonzugriff oder Spracherkennung wurde nicht erlaubt. Bitte die Browserberechtigung prüfen.",
      "portal_speech.failed": "Spracheingabe nicht verfügbar. Bitte Mikrofon und Verbindung prüfen oder weitertippen.",
      "portal_speech.listening": "Mikrofon aktiv – bitte sprechen …",
      "portal_speech.notice": "Diktierter Text wird unten an die Beschreibung angefügt. Der Browser kann Audio zur Erkennung an seinen Sprachdienst senden.",
      "portal_speech.silence": "Keine Sprache erkannt. Bitte erneut starten.",
      "portal_speech.start": "Diktat starten",
      "portal_speech.stop": "Stoppen",
      "portal_speech.title": "Spracheingabe",
      "portal_speech.unsupported": "Dieser Browser unterstützt hier keine Spracheingabe. Sie können die Diktierfunktion Ihrer Tastatur verwenden.",
      "preview": "Vista previa",
      "previous": "Zurück",
      "primary": "Primario",
      "priority": "Prioridad",
      "priority_": "",
      "priority_critical": "Crítico",
      "priority_high": "Alta",
      "priority_low": "Baja",
      "priority_medium": "Media",
      "priority_urgent": "Urgente",
      "problem_cascade_close_checkbox": "Sí, cerrar todos los incidentes vinculados (recomendado)",
      "problem_cascade_close_desc": "Hay incidentes abiertos vinculados. ¿Desea resolverlos automáticamente y añadir un comentario con la causa raíz y la resolución?",
      "problem_cascade_close_title": "Cierre en cascada",
      "problem_confirm_resolve": "Confirmar y resolver",
      "problem_create_btn": "Crear problema",
      "problem_create_error": "Error al crear el problema",
      "problem_create_success": "Ticket de problema creado.",
      "problem_create_title": "Crear nuevo ticket de problema",
      "problem_created_by_on": "Creado por {{creator}} el {{date}}",
      "problem_description_label": "Descripción del problema",
      "problem_detail_load_error": "Error al cargar los detalles del problema",
      "problem_incidents_linked": "Incidents vinculados",
      "problem_kedb_empty": "No hay errores conocidos",
      "problem_kedb_empty_desc": "Los problemas clasificados como error conocido aparecerán aquí con su causa y su solución alternativa.",
      "problem_kedb_load_error": "Error al cargar los errores conocidos",
      "problem_kedb_search_placeholder": "Buscar en los errores conocidos...",
      "problem_kedb_title": "Errores conocidos (Known Errors)",
      "problem_known_error_badge": "Error conocido",
      "problem_known_error_checkbox": "Clasificar como Known Error (Error conocido)",
      "problem_known_error_only": "Solo errores conocidos",
      "problem_link_btn": "Vincular",
      "problem_link_error": "Error al vincular los incidentes",
      "problem_link_incident_btn": "Vincular incidente",
      "problem_link_incidents_title": "Vincular incidentes",
      "problem_link_success": "Incidencias vinculadas.",
      "problem_linked_incidents": "Incidentes vinculados",
      "problem_load_error": "Error al cargar los problemas",
      "problem_loading": "Cargando ITIL Problem Management...",
      "problem_mark_known_error": "Marcar como Known Error",
      "problem_no_incidents_found": "No se encontraron incidentes vinculados.",
      "problem_no_tickets": "No hay tickets de problema",
      "problem_no_tickets_desc": "Actualmente no hay registrados tickets de problema ITIL.",
      "problem_no_unlinked_found": "No se encontraron incidentes abiertos y no vinculados.",
      "problem_none": "—",
      "problem_none_selected": "Ningún problema seleccionado",
      "problem_none_selected_desc": "Seleccione un ticket de problema ITIL a la izquierda o cree uno nuevo para gestionar los datos RCA.",
      "problem_open_change_confirm": "¿Desea abrir ahora el nuevo ticket de cambio {{num}}?",
      "problem_raise_change_btn": "Derivar un cambio",
      "problem_raise_change_error": "Error al derivar el cambio",
      "problem_raise_change_success": "Ticket de cambio creado: {{num}}",
      "problem_raise_change_title": "Derivar un cambio a partir de este problema",
      "problem_rca_title": "Problemas ITIL (RCA)",
      "problem_resolution_note": "Nota de resolución",
      "problem_resolution_note_placeholder": "Introduzca detalles sobre la solución final...",
      "problem_resolve_btn": "Resolver problema",
      "problem_resolve_error": "Error al resolver el problema",
      "problem_resolve_success": "Problema resuelto.",
      "problem_root_cause_label": "Causa raíz sospechada",
      "problem_root_cause_short": "Causa raíz",
      "problem_search_placeholder": "Buscar problemas...",
      "problem_stage_closed": "Cerrado",
      "problem_stage_known_error": "Error conocido",
      "problem_stage_label": "Estado del ciclo de vida (fase del problema)",
      "problem_stage_open": "Abierto",
      "problem_stage_resolved": "Resuelto",
      "problem_stage_under_investigation": "En investigación",
      "problem_stage_updated": "Estado del ciclo de vida actualizado.",
      "problem_stage_workaround_found": "Solución alternativa encontrada",
      "problem_tab_kedb": "Base de errores conocidos (KEDB)",
      "problem_tab_problems": "Problemas (RCA)",
      "problem_title": "Problema ITIL: Incidente recurrente",
      "problem_title_label": "Título del problema",
      "problem_unlink_btn": "Desvincular",
      "problem_unlink_error": "Error al deshacer la vinculación",
      "problem_unlink_success": "Vinculación deshecha.",
      "problem_update_error": "Error al actualizar el problema",
      "problem_update_success": "Problema actualizado correctamente.",
      "problem_workaround_label": "Solución alternativa conocida",
      "problem_workaround_short": "Solución alternativa",
      "problems": "Problemas",
      "queue.": "queue.",
      "queue_external_processing": "Externe Bearbeitung",
      "queues": "Colas",
      "quick_access_views": "Accesos rápidos y vistas",
      "quick_search": "Búsqueda rápida",
      "read_ticket_also": "también está leyendo este ticket",
      "reading_ticket": "Leyendo ticket #{{id}}",
      "reassign_to": "Reasignar ({{name}})...",
      "recent_activities_description": "Actividades recientes sobre tickets y respuestas para este cliente.",
      "recent_tickets": "Tickets recientes",
      "refresh": "Actualizar",
      "remove_assignment": "Eliminar asignación",
      "remove_attachment_aria": "Eliminar archivo adjunto {{filename}}",
      "remove_filter": "Filter entfernen",
      "reopen": "Reabrir",
      "reply": "Responder",
      "reply_keyboard_shortcut_hint": "Atajo de teclado: Ctrl o Cmd + Enter para enviar cuando el cursor esté en el texto.",
      "report_active_breaches": "Infracciones activas",
      "report_ai_analysis": "Análisis de IA",
      "report_ai_analyzing": "La IA está analizando los datos del informe...",
      "report_ai_highlights": "Aspectos destacados",
      "report_ai_recommendations": "Recomendaciones",
      "report_billable": "Facturable",
      "report_compliance": "Cumplimiento",
      "report_export": "Exportar",
      "report_exporting": "Exportando...",
      "report_no_data": "No hay datos disponibles",
      "report_no_data_desc": "No se pudieron cargar datos del informe para este período.",
      "report_range": "Vista del informe:",
      "report_total_time": "Tiempo total",
      "reports": "Informes",
      "reports_desc": "Informes y análisis de gestión de servicios",
      "request.additional_info": "Datos adicionales",
      "request.back_to_dashboard": "Volver al panel de control",
      "request.back_to_dashboard_link": "← Panel de control",
      "request.back_to_list": "Ir al resumen",
      "request.back_to_requests": "← Todas las solicitudes",
      "request.catalog_subtitle": "Elija un tipo de solicitud: recibirá el formulario correspondiente.",
      "request.choose_files": "Seleccionar archivos",
      "request.description_placeholder": "Describa su solicitud…",
      "request.description_required": "Introduzca una descripción.",
      "request.failed_load_catalog": "No se ha podido cargar el catálogo",
      "request.file_too_large": "Archivo demasiado grande (máx. {{max}} MB): {{name}}",
      "request.file_type_not_allowed": "Dateityp nicht erlaubt: {{name}}",
      "request.no_requests": "No hay ninguna solicitud de servicio habilitada en el portal.",
      "request.not_available": "Esta solicitud no está disponible o no está publicada.",
      "request.optional_select": "— Opcional —",
      "request.please_select": "— Seleccione —",
      "request.remove_file": "Quitar",
      "request.required_field": "Campo obligatorio: {{label}}",
      "request.standard_fields_info": "Campos estándar: la prioridad, la categoría, la descripción y los archivos adjuntos se incluyen en todas las solicitudes de servicio. A continuación pueden aparecer campos adicionales propios de este tipo de solicitud.",
      "request.submit_btn": "Enviar la solicitud",
      "request.submit_failed": "Error al enviar",
      "request.submitting_btn": "Enviando…",
      "request_type": "Tipo de solicitud",
      "requester_title": "Solicitante",
      "reset": "Restablecer",
      "reset_all_filters": "Alle Filter zurücksetzen",
      "reset_filter": "Restablecer filtro",
      "reset_kpi_filter": "Kachel-Filter zurücksetzen",
      "reset_to_default": "Restablecer valores predeterminados",
      "resolution": "Resolución",
      "resolve": "Resolver",
      "resolved_label": "Resuelto",
      "retry": "Erneut versuchen",
      "risk": "Riesgo",
      "risk_minutes": "{{count}} min",
      "save": "Guardar",
      "save_changes": "Guardar cambios",
      "save_note": "Guardar nota",
      "saving": "Guardando...",
      "scroll_to_reply": "Desplazarse a la respuesta",
      "search": "Buscar...",
      "search_canned_responses": "Buscar respuestas predefinidas…",
      "search_customers": "Buscar clientes...",
      "select_company": "Firma auswählen…",
      "select_customer_placeholder": "Seleccione un cliente de la lista",
      "self_healing": "Autocuración",
      "send": "Enviar",
      "sending_ellipsis": "Enviando...",
      "settings": "Configuración",
      "seven_days": "7 días",
      "shortcut_back_close": "Volver / Cerrar",
      "shortcut_escalate": "Escalar",
      "shortcut_focus_mode": "Modo de enfoque",
      "shortcut_help": "Esta ayuda",
      "shortcut_internal_note": "Nota interna",
      "shortcut_next_prev": "Siguiente / Anterior ticket",
      "shortcut_quick_search": "Búsqueda rápida",
      "shortcut_write_reply": "Escribir respuesta",
      "show_all": "Mostrar todo",
      "show_full_ticket_backlog": "Ver todo el backlog de tickets",
      "show_older_replies": "Mostrar {{count}} respuestas anteriores...",
      "sla_and_contract_title": "SLA y Contrato",
      "sla_breached_both": "Respuesta y resolución superadas",
      "sla_breached_exclamation": "¡SLA superado!",
      "sla_breached_resolution": "Resolución superada",
      "sla_breached_response": "Respuesta superada",
      "sla_breaches": "Brechas de SLA:",
      "sla_compliance": "Cumplimiento de SLA",
      "sla_level": "Nivel SLA:",
      "sla_option_1": "1. Cumplimiento de SLA y tendencias (Resumen)",
      "sla_option_10": "10. Estadísticas de SLA para fines de semana y feriados",
      "sla_option_2": "2. Infracciones de SLA y tickets en riesgo",
      "sla_option_3": "3. SLA por prioridad",
      "sla_option_4": "4. SLA por cliente / plan de servicio",
      "sla_option_5": "5. Cumplimiento de SLA de tiempo de respuesta",
      "sla_option_6": "6. Cumplimiento de SLA de tiempo de resolución",
      "sla_option_7": "7. Infracciones de SLA por agente/grupo",
      "sla_option_8": "8. Causas de infracciones de SLA",
      "sla_option_9": "9. Vista previa de multas y créditos (Riesgo financiero)",
      "sla_performance_breaches": "Rendimiento y Brechas de SLA",
      "sla_risk": "Riesgo SLA",
      "sla_status_ok": "OK",
      "sort_by_label": "Ordenar por {{label}}",
      "spam": "Spam",
      "starred": "Favoritos",
      "start": "Inicio",
      "status": "Estado",
      "status_closed": "Cerrado",
      "status_in_progress": "En progreso",
      "status_new": "Nuevo",
      "status_on_hold": "En pausa",
      "status_open": "Abierto",
      "status_resolved": "Resuelto",
      "status_waiting": "En espera",
      "status_waiting_customer": "Esperando cliente",
      "street": "Calle",
      "subtasks": "Teilaufgaben",
      "supporting_agents": "Agentes de soporte",
      "switch_language": "Cambiar de idioma",
      "system_logs": "Registros del sistema",
      "tab_": "",
      "tab_activity": "Actividad",
      "tab_agents": "Agentes",
      "tab_assets": "Activos",
      "tab_contracts": "Contratos",
      "tab_csat": "CSAT",
      "tab_custom": "Informes personalizados",
      "tab_customers": "Clientes",
      "tab_documents": "Documentos",
      "tab_employees": "Empleados",
      "tab_incidents": "Incidentes",
      "tab_licenses": "Licencias",
      "tab_notes": "Notas",
      "tab_overview": "Resumen",
      "tab_sla": "SLA",
      "tab_tickets": "Tickets",
      "tab_time": "Registro de tiempo",
      "tab_trends": "Tendencias",
      "tag_add_placeholder": "Añadir etiqueta...",
      "tag_label": "Etiqueta",
      "tax_number": "Número fiscal",
      "teams_call_start": "Iniciar llamada de Teams",
      "teams_chat_open": "Abrir chat de Teams",
      "teams_meeting_subject": "Reunión {{number}}",
      "teams_meeting_title": "Reunión de Teams",
      "thirty_days": "30 días",
      "ticket_assets.action_col": "Acción",
      "ticket_assets.agent_offline": "Agente sin conexión",
      "ticket_assets.agent_ready": "Listo",
      "ticket_assets.assigned_assets": "Activos asignados al empleado",
      "ticket_assets.bios_label": "Versión de BIOS:",
      "ticket_assets.calculating_compliance": "Calculando la auditoría de licencias...",
      "ticket_assets.clean_temp": "Borrar archivos temporales",
      "ticket_assets.cmd_status_completed": "Finalizado",
      "ticket_assets.cmd_status_failed": "Error",
      "ticket_assets.cmd_status_pending": "En espera",
      "ticket_assets.cmd_status_running": "En ejecución...",
      "ticket_assets.cmdb_alert_desc": "Este activo depende de/está conectado con:",
      "ticket_assets.cmdb_alert_title": "Aviso de cascada de la CMDB: ¡incidencia en una dependencia!",
      "ticket_assets.command_execution_failed": "Error al ejecutar el comando.",
      "ticket_assets.command_placeholder": "p. ej. ipconfig /all, systeminfo, dir",
      "ticket_assets.command_running": "El comando se está ejecutando en el dispositivo cliente...",
      "ticket_assets.command_success_solved": "¡Ejecutado correctamente! El ticket se ha resuelto automáticamente.",
      "ticket_assets.command_timeout": "Se ha agotado el tiempo de espera al ejecutar el comando.",
      "ticket_assets.compliant": "Conforme",
      "ticket_assets.confirm_kill_process": "¿Seguro que desea finalizar el proceso con el PID {{pid}}?",
      "ticket_assets.cpu_cores_label": "Núcleos:",
      "ticket_assets.cpu_label": "Procesador (CPU)",
      "ticket_assets.cpu_sockets_label": "Zócalos:",
      "ticket_assets.cpu_util_label": "Uso de CPU",
      "ticket_assets.created_label": "Creado:",
      "ticket_assets.device_scan_label": "Escaneo del dispositivo",
      "ticket_assets.disk_free_label": "libre",
      "ticket_assets.disk_used_label": "Ocupado",
      "ticket_assets.disks_label": "Discos duros / unidades",
      "ticket_assets.domain_label": "Grupo de trabajo/dominio:",
      "ticket_assets.edition_id_label": "ID de edición:",
      "ticket_assets.employee_assets": "Activos del empleado",
      "ticket_assets.error_kill_process": "Error al finalizar el proceso: {{error}}",
      "ticket_assets.error_loading_monitoring": "Error al cargar la monitorización",
      "ticket_assets.error_sending_command": "Error al enviar el comando.",
      "ticket_assets.error_submit_command": "No se ha podido transmitir el comando: {{error}}",
      "ticket_assets.executed_label": "Ejecutado:",
      "ticket_assets.fetch_logs_btn": "Obtener los registros",
      "ticket_assets.filter_processes_placeholder": "Filtrar procesos (nombre, PID)...",
      "ticket_assets.fix_dns": "Reparar el DNS",
      "ticket_assets.fix_spooler": "Reparar la cola de impresión",
      "ticket_assets.hostname_label": "Nombre de red:",
      "ticket_assets.incomplete_summary": "Resumen de conformidad incompleto.",
      "ticket_assets.invalid_json_response": "Respuesta no válida del servidor",
      "ticket_assets.kill_btn": "Finalizar",
      "ticket_assets.killing_proc": "Finalizando...",
      "ticket_assets.last_scan_label": "Último escaneo:",
      "ticket_assets.license_compliance": "Conformidad de licencias",
      "ticket_assets.link": "Vincular",
      "ticket_assets.link_asset_title": "Vincular un activo",
      "ticket_assets.linked": "Vinculado",
      "ticket_assets.linked_assets": "Activos vinculados al ticket",
      "ticket_assets.loading": "Cargando los activos...",
      "ticket_assets.loading_command_queue": "Cargando la cola de comandos...",
      "ticket_assets.loading_logs": "Cargando los registros de eventos...",
      "ticket_assets.loading_monitoring": "Cargando la monitorización en vivo y la comprobación de la CMDB...",
      "ticket_assets.log_name_label": "Nombre del registro",
      "ticket_assets.memory_col": "Memoria",
      "ticket_assets.model_label": "Modelo:",
      "ticket_assets.monitored_ok": "Monitorizado (OK)",
      "ticket_assets.more_params_title": "Más parámetros",
      "ticket_assets.motherboard_label": "Placa base:",
      "ticket_assets.no_active_zabbix_alerts": "No hay alarmas activas de Zabbix.",
      "ticket_assets.no_assets_assigned": "Este empleado no tiene activos de TI asignados.",
      "ticket_assets.no_assets_linked": "No hay activos vinculados.",
      "ticket_assets.no_commands_executed": "Todavía no se ha ejecutado ningún comando. Introduzca un comando abajo.",
      "ticket_assets.no_compliance_available": "No hay licencias ni informe de conformidad disponibles.",
      "ticket_assets.no_employee_assigned": "No hay ningún empleado asignado al ticket.",
      "ticket_assets.no_hardware_details": "No se han escaneado detalles de hardware.",
      "ticket_assets.no_matching_software": "No se han encontrado entradas de software coincidentes.",
      "ticket_assets.no_monitoring_data": "No hay datos de monitorización disponibles",
      "ticket_assets.os_arch_label": "Arquitectura:",
      "ticket_assets.os_label": "Sistema operativo",
      "ticket_assets.os_ver_label": "Versión:",
      "ticket_assets.overlicensed": "Con exceso de licencias",
      "ticket_assets.pagination_text": "Página {{page}} de {{total}} ({{count}} entradas)",
      "ticket_assets.process_name_col": "Nombre del proceso",
      "ticket_assets.publisher_col": "Fabricante",
      "ticket_assets.query_realtime_btn": "Consultar en tiempo real",
      "ticket_assets.ram_label": "Memoria (RAM)",
      "ticket_assets.ram_util_label": "Uso de RAM",
      "ticket_assets.scan_details_btn": "Detalles del escaneo",
      "ticket_assets.scan_never": "nunca",
      "ticket_assets.search_logs_placeholder": "Buscar en los resultados (origen, ID, mensaje)...",
      "ticket_assets.search_placeholder": "Buscar por nombre, IP o n.º de serie...",
      "ticket_assets.search_software_placeholder": "Buscar software...",
      "ticket_assets.self_healing_title": "Autorreparación y automatización",
      "ticket_assets.send_btn": "Enviar",
      "ticket_assets.sending_command_failed": "No se ha podido enviar el comando.",
      "ticket_assets.serial_number_label": "Número de serie:",
      "ticket_assets.severity_all": "Todos",
      "ticket_assets.severity_error": "Error",
      "ticket_assets.severity_info": "Información",
      "ticket_assets.severity_label": "Gravedad",
      "ticket_assets.severity_warning": "Advertencia (Warning)",
      "ticket_assets.sn_label": "N/S:",
      "ticket_assets.software_name_col": "Nombre del software",
      "ticket_assets.sql_instance_label": "Instancia:",
      "ticket_assets.sql_instances_title": "Instancias de SQL Server detectadas",
      "ticket_assets.sql_patchlevel_label": "Nivel de parches:",
      "ticket_assets.success_kill_process": "Proceso finalizado correctamente.",
      "ticket_assets.surplus_label": "Excedente:",
      "ticket_assets.timeout_kill_process": "Se ha agotado el tiempo de espera al finalizar el proceso.",
      "ticket_assets.total_ram_desc": "Memoria física total",
      "ticket_assets.underlicensed": "Con licencias insuficientes",
      "ticket_assets.unlink_asset_title": "Deshacer la vinculación",
      "ticket_assets.unreachable": "No accesible",
      "ticket_assets.version_col": "Versión",
      "ticket_assets.virtualization_label": "Virtualización:",
      "ticket_assets.waiting_agent_response": "Esperando la respuesta del agente...",
      "ticket_assets.waiting_agent_timeout": "Tiempo de espera agotado: el agente no ha respondido a tiempo.",
      "ticket_assets.zabbix_live_status": "Estado en vivo de Zabbix",
      "ticket_created": "Ticket creado",
      "ticket_detail.achtung_ueberschneidungskollisionen_ci_abhae": "¡Atención: se han detectado solapamientos (dependencias de CI)!",
      "ticket_detail.aktivitaeten": "Actividades",
      "ticket_detail.aktivitaets_verlauf": "Historial de actividades",
      "ticket_detail.als_diesen_kunden_im_portal_anmelden": "Iniciar sesión en el portal como este cliente",
      "ticket_detail.anhaenge": "Archivos adjuntos",
      "ticket_detail.begruendung_kommentare": "Justificación / comentarios",
      "ticket_detail.bekannter_fehler_workaround_verfuegbar": "Error conocido: solución alternativa disponible",
      "ticket_detail.cab_hat_die_aenderung_abgelehnt": "El CAB ha rechazado el cambio",
      "ticket_detail.change_advisory_board_cab_stimmen": "Votos del Change Advisory Board (CAB)",
      "ticket_detail.das_ticket_existiert_nicht_oder_wurde_geloes": "El ticket no existe o se ha eliminado.",
      "ticket_detail.der_status_kann_erst_auf_in_bearbeitung_oder": "El estado solo se puede cambiar a «En curso» o «Resuelto» cuando la mayoría del CAB haya dado su aprobación.",
      "ticket_detail.detaillierte_schritte_zur_durchfuehrung": "Pasos detallados para la ejecución...",
      "ticket_detail.es_wurde_noch_kein_change_plan_fuer_dieses_t": "Aún no se ha creado ningún plan de cambio para este ticket.",
      "ticket_detail.es_wurden_andere_aktive_tickets_auf_denselbe": "Se han planificado otros tickets activos sobre los mismos activos de la CMDB, o sobre activos dependientes, en el mismo periodo:",
      "ticket_detail.extrahierte_daten": "Datos extraídos",
      "ticket_detail.geplanter_start_wartungsfenster": "Inicio previsto (ventana de mantenimiento)",
      "ticket_detail.geplantes_ende": "Fin previsto",
      "ticket_detail.geplantes_wartungsfenster": "Ventana de mantenimiento prevista:",
      "ticket_detail.hinzufuegen": "Añadir",
      "ticket_detail.keine_aktivitaeten_vorhanden": "No hay actividades",
      "ticket_detail.keine_anhaenge_vorhanden": "No hay archivos adjuntos",
      "ticket_detail.keine_kategorie": "Sin categoría",
      "ticket_detail.kommentar_zur_entscheidung_optional": "Comentario sobre la decisión (opcional)...",
      "ticket_detail.loeschen": "Eliminar",
      "ticket_detail.niemand_zugewiesen": "Sin responsable asignado",
      "ticket_detail.noch_keine_stimmen_abgegeben": "Aún no se ha emitido ningún voto.",
      "ticket_detail.noch_keine_zeit_erfasst": "Aún no se ha registrado tiempo",
      "ticket_detail.nur_fuer_mitarbeiter_sichtbar": "Visible solo para los empleados",
      "ticket_detail.prioritaet": "Prioridad",
      "ticket_detail.sprachnotizen_in_administration_ki_einstellu": "Active las notas de voz en Administración → Ajustes de IA.",
      "ticket_detail.sprachnotizen_nicht_aktiv": "Notas de voz no activas",
      "ticket_detail.stimme_uebermitteln": "Emitir voto",
      "ticket_detail.tag_entfernen": "Eliminar etiqueta",
      "ticket_detail.tag_hinzufuegen": "Añadir etiqueta…",
      "ticket_detail.tag_hinzufuegen_2": "Añadir etiqueta",
      "ticket_detail.ticket_nicht_gefunden": "Ticket no encontrado",
      "ticket_detail.ticket_wird_geladen": "Cargando el ticket...",
      "ticket_detail.timer_laeuft_fuer_anderes_ticket": "El temporizador está en marcha en otro ticket",
      "ticket_detail.timer_starten": "Iniciar el temporizador",
      "ticket_detail.timer_stoppen": "Detener el temporizador",
      "ticket_detail.uebersicht": "Vista general",
      "ticket_detail.veroeffentlicht": "Publicado",
      "ticket_detail.was_wurde_erledigt": "¿Qué se ha realizado?",
      "ticket_detail.welches_risiko_besteht_fuer_den_betrieb": "¿Qué riesgo supone para el funcionamiento?",
      "ticket_detail.wie_machen_wir_aenderungen_rueckgaengig": "¿Cómo se revierten los cambios?",
      "ticket_detail.wie_wird_die_funktion_verifiziert": "¿Cómo se verifica el funcionamiento?",
      "ticket_detail.zeiteintraege": "Entradas de tiempo",
      "ticket_detail.zugewiesen_an": "Asignado a",
      "ticket_detail.zugewiesen_an_2": "Asignado a",
      "ticket_detail.zurueck_zur_uebersicht": "Volver a la vista general",
      "ticket_detail.zustimmung_des_change_advisory_boards_cab_zw": "Se requiere obligatoriamente la aprobación del Change Advisory Board (CAB)",
      "ticket_filter_active_label": "Filter aktiv",
      "ticket_inventory_kpis": "Kennzahlen & Arbeitslast",
      "ticket_properties_title": "Ticket",
      "ticket_relations": "Verknüpfte Tickets",
      "ticket_view_search_label": "Diese Ticketansicht durchsuchen",
      "tickets": "Tickets",
      "tickets_exist_hint": "Insgesamt sind {{count}} Tickets vorhanden.",
      "tickets_near_sla_breach": "Tickets cerca del incumplimiento de SLA",
      "tickets_plural": "{{count}} tickets",
      "tickets_ratio_label": "{{count}} de {{total}} tickets",
      "tickets_selected": "{{count}} tickets seleccionados",
      "tickets_without_assignee": "Tickets sin agente asignado",
      "time_logged": "Tiempo registrado: {{time}}",
      "time_minutes": "Zeit in Minuten",
      "title": "Título",
      "to_reply_composer": "Ir a la respuesta (Composer)",
      "today_due": "Vencen hoy",
      "toggle_design_mode": "Cambiar modo de diseño",
      "toggle_favorite": "Alternar favorito",
      "tracked_hours": "{{hours}} h",
      "tracked_hours_min": "{{hours}} h {{minutes}} m",
      "tracked_min": "{{minutes}} min.",
      "tracked_time": "Tiempo registrado",
      "unassigned": "Sin asignar",
      "unlink_asset": "Desvincular",
      "unread": "No leído",
      "update": "Actualizar",
      "updated_at": "Actualizado",
      "urgent": "Urgente",
      "user_profile_logout": "Perfil de usuario y cierre de sesión",
      "vat_id": "NIF/IVA intracomunitario",
      "views": "Vistas",
      "voice_notes_admin_hint": "Notas de voz: Active 'Notas de voz' en Administración → Configuración de IA.",
      "voice_notes_enable_info": "Active las notas de voz en Administración → Configuración de IA (active 'Notas de voz').",
      "voice_notes_not_active": "Notas de voz no activas",
      "website": "Sitio web",
      "widget_critical_tickets": "Tickets críticos (Urgencias)",
      "widget_group_analytics_team": "Análisis y Equipo",
      "widget_group_overview_performance": "Resumen y Rendimiento",
      "widget_group_volume_trends": "Volumen y Tendencias",
      "widget_my_open_tickets": "Mis tickets abiertos",
      "widget_performance_times": "Tiempos de rendimiento y esfuerzo",
      "widget_priority_chart": "Distribución de prioridades",
      "widget_sla_compliance": "Cumplimiento de SLA y riesgo",
      "widget_status_chart": "Distribución de estados de tickets",
      "widget_team_presence": "Presencia y actividad del equipo",
      "widget_ticket_trends": "Tendencias de tickets y volumen",
      "widget_top_customers": "Top clientes por tickets",
      "zip_code": "Código postal"
    }
  },
  "ru": {
    "translation": {
      "access_denied": "Доступ запрещен",
      "access_denied_desc": "Требуются права агента или администратора.",
      "actions": "Действия",
      "activate_dark_mode": "Активировать темную тему",
      "activate_light_mode": "Активировать светлую тему",
      "active": "Активен",
      "active_filters": "Aktive Filter",
      "active_open_assignments": "Активные, открытые назначения",
      "activity_optional": "Действие (опционально)",
      "admin": "Админ",
      "admin_dashboard.administrative_berechtigungen": "Административные права",
      "admin_dashboard.aendern": "Изменить",
      "admin_dashboard.agent_deaktiviert": "Агент деактивирован",
      "admin_dashboard.agent_erstellt": "Агент создан",
      "admin_dashboard.agent_gespeichert": "Агент сохранён",
      "admin_dashboard.agent_ohne_zuordnung_hinweis": "Без назначения этот агент видит {{umfang}} клиентов. Как только назначен хотя бы один клиент, агент ограничен этими клиентами — заявки, отчёты и активы.",
      "admin_dashboard.agenten_in_der_kundenkonsole": "Агенты в клиентской консоли",
      "admin_dashboard.aktuelles_passwort": "Текущий пароль",
      "admin_dashboard.alle_eingehenden_befehle_wurden_bereits_vera": "Все входящие команды уже обработаны или согласованы.",
      "admin_dashboard.alle_kunden": "Все клиенты",
      "admin_dashboard.als_hauptkategorie_erstellen": "Создать как основную категорию",
      "admin_dashboard.api_token_hinweis": "При необходимости заранее создайте токен API на вкладке {{reiter}} с областью доступа {{scope}}.",
      "admin_dashboard.aufloesungszeit": "Время решения *",
      "admin_dashboard.basic_auth_benutzername_passwort": "Basic Auth (имя пользователя/пароль)",
      "admin_dashboard.bei_prefix_u00c4nderung_werden_alle_bestehen": "При изменении префикса все существующие заявки будут автоматически переименованы.",
      "admin_dashboard.benoetigte_berechtigung": "Требуемое право доступа:",
      "admin_dashboard.bestaetigen": "Подтвердить",
      "admin_dashboard.bezeichnung_positionszeile": "Наименование позиции",
      "admin_dashboard.bitte_kunde_waehlen": "Выберите клиента...",
      "admin_dashboard.bitte_kunde_waehlen_2": "Выберите клиента...",
      "admin_dashboard.definieren_sie_hauptkategorien_und_bis_zu_zw": "Задайте основные категории и до двух уровней подкатегорий. Они предлагаются для выбора при создании заявки.",
      "admin_dashboard.definiert_die_standard_reihenfolge_der_queue": "Определяет порядок очередей по умолчанию на боковой панели агента.",
      "admin_dashboard.details_anzeigen": "Показать подробности",
      "admin_dashboard.details_anzeigen_2": "Показать подробности",
      "admin_dashboard.die_smtp_einstellungen_fuer_den_e_mail_versa": "Настройки SMTP для отправки писем теперь задаются централизованно в разделе",
      "admin_dashboard.e_mail_versand_smtp_wird_unter_e_mail_einste": "Отправка почты (SMTP) настраивается в разделе «Настройки эл. почты»",
      "admin_dashboard.eine_sicherheitsgruppe_legt_fest_welche_kons": "Группа безопасности определяет, какие модули консоли видит агент. «Полный доступ» = все модули. Права администратора от этого не зависят.",
      "admin_dashboard.einstellungen_speichern": "Сохранить настройки",
      "admin_dashboard.eintraege": "Записи",
      "admin_dashboard.endgeraet": "Устройство",
      "admin_dashboard.endgueltig_loeschen": "Endgültig löschen",
      "admin_dashboard.entwurfsrechnung_aus_zeiteintraegen": "Черновик счёта из записей времени",
      "admin_dashboard.erstellen_sie_ihre_erste_automatisierung": "Создайте свою первую автоматизацию",
      "admin_dashboard.erstellen_sie_oben_ihre_erste_hauptkategorie": "Создайте выше свою первую основную категорию",
      "admin_dashboard.externer_mitarbeiter_dienstleister": "Внешний сотрудник / подрядчик",
      "admin_dashboard.fehler_beim_deaktivieren": "Ошибка при деактивации",
      "admin_dashboard.fehler_beim_deaktivieren_2": "Ошибка при деактивации",
      "admin_dashboard.fehler_beim_deaktivieren_3": "Ошибка при деактивации",
      "admin_dashboard.fehler_beim_loeschen": "Ошибка при удалении",
      "admin_dashboard.firma_adresse_kontakt_steuernummern_in_der_u": "Компанию, адрес, контакт и налоговые номера можно редактировать в обзоре. Деактивация клиентов остаётся правом администратора.",
      "admin_dashboard.fuer_entra_id_benoetigen_sie_eine_app_regist": "Для Entra ID требуется регистрация приложения в Azure Portal с разрешением Mail.Read.",
      "admin_dashboard.geloescht": "Удалено",
      "admin_dashboard.geloescht_2": "Удалено",
      "admin_dashboard.installationspaket_herunterladen": "Скачать установочный пакет",
      "admin_dashboard.kategorie_aktualisiert": "Категория обновлена",
      "admin_dashboard.kategorie_erstellt": "Категория создана",
      "admin_dashboard.kategorie_geloescht": "Категория удалена",
      "admin_dashboard.keine_abteilung": "Без отдела",
      "admin_dashboard.keine_ausstehenden_befehls_freigaben_vorhand": "Нет команд, ожидающих согласования.",
      "admin_dashboard.keine_workflows_konfiguriert": "Рабочие процессы не настроены",
      "admin_dashboard.keine_zuordnung_dieser_agent_sieht_alle_kund": "Назначение отсутствует — этот агент видит всех клиентов.",
      "admin_dashboard.konfigurieren_sie_sprachmodelle_auto_respons": "Настройте языковые модели, промпты автоответов и системные шаблоны",
      "admin_dashboard.kunde_auswaehlen": "Выберите клиента *",
      "admin_dashboard.kunde_deaktiviert": "Клиент деактивирован",
      "admin_dashboard.kunde_erstellt": "Клиент создан",
      "admin_dashboard.kunde_geloescht": "Kunde „{{firma}}\" wurde endgültig gelöscht",
      "admin_dashboard.kunde_gespeichert": "Клиент сохранён",
      "admin_dashboard.kunde_waehlen": "Выберите клиента…",
      "admin_dashboard.kundenzuordnung_verwalten": "Управление назначением клиентов",
      "admin_dashboard.laden_sie_ein_fertiges_zip_archiv_fuer": "Скачайте готовый ZIP-архив для",
      "admin_dashboard.laedt": "Загрузка…",
      "admin_dashboard.laengengrad": "Долгота",
      "admin_dashboard.legen_sie_fest_welche_daten_der_installierte": "Определите, какие данные собирает установленный агент, и настройте дополнительный безагентный сетевой сканер (пинг подсети).",
      "admin_dashboard.letzte_exporte": "Последние экспорты",
      "admin_dashboard.lexoffice_artikel_uuid_optional_dienstleistu": "UUID артикула Lexoffice (необязательно, услуга)",
      "admin_dashboard.lexoffice_deaktiviert_hinweis": "Интеграция с LexOffice сейчас отключена. Создавать черновики счетов можно будет только после того, как Вы включите и настроите интеграцию в разделе {{bereich}}.",
      "admin_dashboard.lexoffice_einstellungen_konnten_nicht_gelade": "Не удалось загрузить настройки Lexoffice (выполните миграцию / перезапустите сервер).",
      "admin_dashboard.loeschen": "Удалить",
      "admin_dashboard.loeschen_2": "Удалить",
      "admin_dashboard.mailbox_empfang_imap_oauth_wird_unter_postfa": "Приём почты (IMAP/OAuth) настраивается в разделе «Почтовые ящики»",
      "admin_dashboard.mailbox_speichern": "Сохранить почтовый ящик",
      "admin_dashboard.microsoft_graph_api": "Microsoft Graph API",
      "admin_dashboard.mit_einem_frisch_generierten_api_schluessel": "со свежесгенерированным ключом API и",
      "admin_dashboard.mitarbeiter_deaktiviert": "Сотрудник деактивирован",
      "admin_dashboard.mitarbeiter_erstellt": "Сотрудник создан",
      "admin_dashboard.mitarbeiter_gespeichert": "Сотрудник сохранён",
      "admin_dashboard.mloffice_gefuehrt": "Stammdaten werden von MLOffice geführt",
      "admin_dashboard.mloffice_geloest": "Mit MLOffice verknüpft — Abgleich derzeit gelöst",
      "admin_dashboard.module_assets": "Активы",
      "admin_dashboard.module_calendar": "Календарь",
      "admin_dashboard.module_customers": "Клиенты",
      "admin_dashboard.module_knowledge": "База знаний",
      "admin_dashboard.module_licenses": "Лицензии",
      "admin_dashboard.module_problems": "Проблемы",
      "admin_dashboard.module_reports": "Отчёты",
      "admin_dashboard.module_tickets": "Заявки",
      "admin_dashboard.nach_kunde_filtern": "Фильтровать по клиенту",
      "admin_dashboard.neue_mailbox_konfiguration": "Новая конфигурация почтового ящика",
      "admin_dashboard.neuer_workflow": "Новый рабочий процесс",
      "admin_dashboard.neues_passwort": "Новый пароль",
      "admin_dashboard.nicht_abrechenbar": "Неоплачиваемое",
      "admin_dashboard.noch_keine_kategorien_definiert": "Категории ещё не заданы",
      "admin_dashboard.noch_keine_zeiteintraege_vorhanden": "Записей времени пока нет",
      "admin_dashboard.nur_abrechenbare_eintraege_ohne_vorherigen_l": "Только оплачиваемые записи без предыдущего экспорта в Lexoffice; при необходимости отфильтруйте по ID договора.",
      "admin_dashboard.optionale_beschreibung_des_sla_umfangs": "Необязательное описание объёма SLA",
      "admin_dashboard.passwort_aendern": "Изменить пароль",
      "admin_dashboard.primaer": "Основной",
      "admin_dashboard.prioritaet_geaendert": "• Приоритет изменён",
      "admin_dashboard.pruefinterval_minuten": "Интервал проверки (минуты)",
      "admin_dashboard.refresh_token": "Refresh Token",
      "admin_dashboard.sie_koennen_den_agenten_auch_manuell_registr": "Агента можно зарегистрировать и вручную. Используйте для этого следующий синтаксис на клиенте (требуются права администратора):",
      "admin_dashboard.standardmaessig_duerfen_agenten_kunden_stamm": "По умолчанию агенты могут только читать основные данные клиентов и просматривать их документы. Здесь Вы можете включить расширенные права на запись для каждой функции.",
      "admin_dashboard.status_geaendert": "• Статус изменён",
      "admin_dashboard.stundensatz_ueberschreiben_optional": "Переопределить почасовую ставку (необязательно)",
      "admin_dashboard.tarif_erweitern": "Расширить тариф",
      "admin_dashboard.ticket_id_format_und_admin_passwort_koennen": "Здесь можно настроить формат ID заявки и пароль администратора",
      "admin_dashboard.top_kunden_nach_ticketvolumen": "Топ клиентов по объёму заявок",
      "admin_dashboard.uebergeordnete_kategorie": "Родительская категория",
      "admin_dashboard.unterkategorie_hinzufuegen": "Добавить подкатегорию",
      "admin_dashboard.upload_metadaten_bearbeiten_und_loeschen_von": "Загрузка, редактирование метаданных и удаление файлов на вкладке клиента «Документы».",
      "admin_dashboard.verfuegbare_trigger": "Доступные триггеры",
      "admin_dashboard.verwalten_und_genehmigen_sie_ausstehende_adm": "Управляйте административными командами других администраторов и согласовывайте их до выполнения на клиентских устройствах.",
      "admin_dashboard.voller_zugriff_alle_module": "Полный доступ (все модули)",
      "admin_dashboard.vorkonfiguriertes_paket_zip": "Преднастроенный пакет (.zip)",
      "admin_dashboard.was_bedeuten_die_gruppen": "Что означают группы?",
      "admin_dashboard.workflow_automatisierungen": "Автоматизация рабочих процессов",
      "admin_dashboard.z_b_hauptsitz_koeln": "например, головной офис в Кёльне",
      "admin_dashboard.zeit_standardmaessig_abrechenbar": "Время по умолчанию оплачиваемое",
      "admin_dashboard.zeitbuchung_bei_ticket_schliessung_erforderl": "При закрытии заявки требуется учёт времени",
      "admin_dashboard.zeitbuchungen_erscheinen_hier_sobald_agenten": "Записи времени появятся здесь, как только агенты начнут учитывать время по заявкам.",
      "admin_dashboard.zeiteintraege": "Записи времени",
      "admin_dashboard.zeiterfassung_aktivieren": "Включить учёт времени",
      "admin_dashboard.zeiterfassung_einstellungen": "Настройки учёта времени",
      "admin_dashboard.zugriff_verweigert": "Доступ запрещён",
      "admin_dashboard.zugriff_verweigert_text": "У Вас нет административных прав, необходимых для просмотра или управления разделом {{bereich}}.",
      "admin_dashboard.zuordnung_entfernen": "Удалить назначение",
      "admin_dashboard.zusaetzliche_admin_rechte": "Дополнительные права администратора",
      "admin_default": "Стандарт админа",
      "admin_only_change": "(только администратор может изменить назначение.)",
      "admin_overview.aktive_warnungen_risiken": "Активные предупреждения и риски",
      "admin_overview.alles_in_ordnung": "Всё в порядке",
      "admin_overview.datenbank_engine": "Движок базы данных",
      "admin_overview.einstellungen_filtern": "Фильтр настроек...",
      "admin_overview.hinweis_fuer_administratoren": "Примечание для администраторов:",
      "admin_overview.keine_ergebnisse_gefunden": "Результаты не найдены",
      "admin_overview.keine_warnungen_oder_kritischen_meldungen": "Нет предупреждений и критических сообщений.",
      "admin_overview.lade_dashboard_daten": "Загрузка данных панели...",
      "admin_overview.system_status": "Состояние системы",
      "admin_overview.upgrade_erforderlich": "Требуется расширение тарифа",
      "admin_overview.upgrade_erforderlich_2": "Требуется расширение тарифа",
      "admin_overview.versuchen_sie_es_mit_einem_anderen_suchbegri": "Попробуйте другой поисковый запрос.",
      "admin_overview.zurueck_zum_agent_dashboard": "Назад к панели агента",
      "admin_view": "Панель администратора",
      "administration": "Администрирование",
      "administrator": "Администратор",
      "agent": "Агент",
      "agent_available": "Доступен",
      "agent_console": "Консоль агента",
      "agent_console.alle_als_gelesen": "Все как прочитанные",
      "agent_console.anhaenge": "Вложения",
      "agent_console.anhaenge_zum_eroeffnungsbeitrag": "Вложения к первому сообщению",
      "agent_console.back_to_ticket_list": "Zurück zur Liste",
      "agent_console.beschreiben_sie_hier_details_die_dem_partner": "Опишите здесь детали, которые следует передать партнёру...",
      "agent_console.bitte_waehlen": "-- Выберите --",
      "agent_console.detailansicht_schliessen": "Закрыть подробный просмотр",
      "agent_console.erneut_oeffnen": "Открыть заново",
      "agent_console.hinweis_der_partner_erhaelt_eine_benachricht": "Примечание: партнёр получит уведомление по эл. почте с Вашими данными и защищённой ссылкой для обработки заявки.",
      "agent_console.interner_chat": "Внутренний чат",
      "agent_console.interner_chat_2": "Внутренний чат",
      "agent_console.keine_benachrichtigungen": "Нет уведомлений",
      "agent_console.language_selection": "Выбор языка",
      "agent_console.loesen": "Решить",
      "agent_console.mir_zuweisen": "Назначить мне",
      "agent_console.nachricht_notiz_fuer_den_partner_optional": "Сообщение / заметка для партнёра (необязательно)",
      "agent_console.neues_ticket": "Новая заявка",
      "agent_console.neues_ticket_2": "Новая заявка",
      "agent_console.partner_dienstleister_waehlen": "Выберите партнёра-подрядчика",
      "agent_console.schliessen": "Закрыть",
      "agent_console.schliessen_2": "Закрыть",
      "agent_console.schliessungsgrund": "Причина закрытия:",
      "agent_console.schnellsuche_oeffnen": "Открыть быстрый поиск",
      "agent_console.sie_benoetigen_agent_oder_admin_rechte": "Требуются права агента или администратора.",
      "agent_console.tastenkuerzel": "Горячие клавиши",
      "agent_console.ticket_erstellt": "Заявка создана",
      "agent_console.ticket_schliessen": "Закрыть заявку",
      "agent_console.zugriff_verweigert": "Доступ запрещён",
      "agent_console.zur_antwort_composer": "К полю ответа (редактор)",
      "agent_console.zur_antwort_scrollen": "Прокрутить к ответу",
      "agent_console.zusammenfuehren": "Zusammenführen",
      "agent_console.zuweisung_entfernen": "Снять назначение",
      "ai": "ИИ",
      "ai_analysis_running": "Выполняется анализ...",
      "ai_assistance": "ИИ-ассистент",
      "ai_confidence_label": "Уверенность {{pct}}%",
      "ai_context_title": "KI-Kontext & Prognosen",
      "ai_generate_summary": "Создать сводку",
      "ai_key_points": "Ключевые моменты",
      "ai_next_steps": "Следующие шаги",
      "ai_requested_action": "Запрашиваемое действие",
      "ai_risks": "Риски",
      "ai_solution_assistant_title": "Ассистент решения ИИ",
      "ai_stale": "Устарело",
      "ai_summary_title": "Сводка ИИ",
      "all": "Все",
      "all_active_tickets": "Все активные тикеты",
      "all_categories": "Все категории",
      "all_customers": "Все клиенты",
      "all_deadlines_ok": "Все сроки соблюдены.",
      "all_open": "Все открытые",
      "all_tickets": "Все тикеты",
      "allgemein.abbrechen": "Abbrechen",
      "allgemein.schliessen": "Schließen",
      "analyze_again": "Анализировать снова",
      "article": "Статья",
      "article_ai_generate": "Создать статью с помощью ИИ",
      "article_ai_generate_btn": "Сгенерировать статью",
      "article_ai_generate_desc": "Опишите тему, и ИИ сгенерирует черновик",
      "article_ai_improve": "Улучшить текст",
      "article_ai_keywords": "Ключевые слова (опционально)",
      "article_ai_keywords_placeholder": "например, Windows 11, OpenVPN, сертификат",
      "article_ai_language": "Язык",
      "article_ai_len_long": "Длинный / подробный",
      "article_ai_len_medium": "Средний",
      "article_ai_len_short": "Краткий",
      "article_ai_length": "Длина",
      "article_ai_style": "Стиль изложения",
      "article_ai_style_balanced": "Сбалансированный",
      "article_ai_style_enduser": "Конечный пользователь (пошагово)",
      "article_ai_style_formal": "Официальный",
      "article_ai_style_simple": "Простой / понятный",
      "article_ai_style_technical": "Технический (для ИТ-специалистов)",
      "article_ai_summarize": "Создать резюме",
      "article_ai_topic": "Тема *",
      "article_ai_topic_placeholder": "например, Настройка VPN-подключения в Windows",
      "article_all_customers": "Все клиенты",
      "article_all_statuses": "Все статусы",
      "article_all_visible": "Видимо для всех клиентов",
      "article_archived": "Архивировано",
      "article_category": "Категория",
      "article_content_placeholder": "Начните писать статью здесь...",
      "article_create_first": "Создать первую статью",
      "article_create_first_desc": "Создайте свою первую статью базы знаний, чтобы поделиться информацией с командой.",
      "article_create_with_ai": "Создать с помощью ИИ",
      "article_delete_confirm": "Вы действительно хотите удалить эту статью?",
      "article_draft": "Черновик",
      "article_excerpt_placeholder": "Краткое содержание статьи...",
      "article_manage": "Управление статьями",
      "article_new": "Новая статья",
      "article_no_articles": "Статьи пока отсутствуют",
      "article_no_categories_desc": "Категории отсутствуют. Пожалуйста, создайте их в панели администратора.",
      "article_no_category": "Без категории",
      "article_not_found": "Статьи не найдены",
      "article_not_found_desc": "Не удалось найти статьи по вашему запросу.",
      "article_only_visible": "Видимо только для {{name}}",
      "article_pinned": "Закреплено",
      "article_pinned_desc": "Будет отображаться вверху списка",
      "article_plural": "Все статьи",
      "article_published": "Опубликовано",
      "article_search": "Искать статьи...",
      "article_views": "просмотров",
      "article_visibility": "Видимость для клиентов",
      "article_write_content": "Содержимое статьи",
      "article_write_excerpt": "Краткое описание",
      "article_write_title": "Введите название статьи...",
      "asset.discovery_agents": "Агенты обнаружения",
      "asset.event_logs": "Журналы событий",
      "asset.general": "Общие",
      "asset.hardware_wmi": "Оборудование (WMI)",
      "asset.history_changes": "История и Изменения",
      "asset.more": "Еще",
      "asset.network": "Сеть",
      "asset.network_discovery": "Обнаружение сети",
      "asset.printers": "Принтеры",
      "asset.processes": "Процессы",
      "asset.relationships": "Связи",
      "asset.remote_control": "Удаленное управление",
      "asset.remote_terminal": "Удаленный терминал",
      "asset.scan_history": "История сканирований",
      "asset.security": "Безопасность",
      "asset.services": "Службы",
      "asset.software_catalog": "Каталог ПО (SAM)",
      "asset.software_count": "Программное обеспечение",
      "asset.system_assets": "Системные активы",
      "asset.updates": "Обновления",
      "asset_": "asset_",
      "asset_active": "Активен",
      "asset_agent.offline": "Не в сети",
      "asset_agent.online_active": "В сети (активен)",
      "asset_agent.recently_active": "Недавно активен",
      "asset_inactive": "Неактивен",
      "asset_maintenance": "Обслуживание",
      "asset_management": "Управление активами",
      "asset_panel.confirm_delete_asset": "Действительно удалить «{{name}}»?",
      "asset_panel.confirm_delete_category": "Удалить категорию «{{name}}»? Активы будут отвязаны.",
      "asset_panel.edit_asset": "Изменить актив",
      "asset_panel.edit_category": "Изменить категорию",
      "asset_panel.import_as_managed_btn": "Импортировать как управляемый актив",
      "asset_panel.import_device": "Импортировать устройство",
      "asset_panel.new_asset": "Новый актив",
      "asset_panel.new_category": "Новая категория",
      "asset_panel.print_asset_tag": "Печать этикетки актива",
      "asset_panel.print_now_btn": "Печатать сейчас",
      "asset_panel.toast.agent_no_response_hint": "Агент не ответил вовремя.",
      "asset_panel.toast.assets_imported": "Импортировано активов: {{count}}",
      "asset_panel.toast.command_queued": "Команда успешно поставлена в очередь",
      "asset_panel.toast.create_problem_error": "Ошибка при создании заявки на проблему",
      "asset_panel.toast.csv_import_failed": "Не удалось выполнить импорт CSV",
      "asset_panel.toast.device_ignored": "Устройство успешно проигнорировано",
      "asset_panel.toast.device_imported": "Устройство успешно импортировано в управляемые активы",
      "asset_panel.toast.ignore_device_error": "Ошибка при игнорировании устройства",
      "asset_panel.toast.import_device_error": "Ошибка при импорте устройства",
      "asset_panel.toast.import_with_errors": "Импорт завершён с ошибками",
      "asset_panel.toast.itil_correlation_error": "Ошибка при корреляции проблем ITIL",
      "asset_panel.toast.less_than_3_tickets": "Менее 3 заявок за последние 30 дней.",
      "asset_panel.toast.manual_scan_error": "Ошибка при ручном сканировании",
      "asset_panel.toast.problem_ticket_created": "Заявка на проблему создана, инциденты связаны!",
      "asset_panel.toast.queue_command_error": "Не удалось поставить команду в очередь",
      "asset_panel.toast.request_scan_error": "Ошибка при запросе сканирования",
      "asset_panel.toast.scan_completed": "Сканирование успешно завершено",
      "asset_panel.toast.scan_failed": "Сканирование не удалось",
      "asset_panel.toast.scan_requested": "{{type}} запрошено",
      "asset_panel.toast.template_downloaded": "Шаблон «asset-import-vorlage.csv» загружен",
      "asset_panel.toast.template_load_error": "Не удалось загрузить шаблон",
      "asset_remote_client_disconnected": "Клиент отключился",
      "asset_remote_client_disconnected_desc": "Пользователь на клиентском устройстве завершил сеанс удаленного доступа.",
      "asset_remote_closed_desc": "Сеанс удаленного доступа успешно завершен.",
      "asset_remote_code_placeholder": "например, 123 456",
      "asset_remote_conn_disconnected": "Соединение разорвано",
      "asset_remote_conn_failed": "Не удалось подключиться к удаленному серверу",
      "asset_remote_conn_rejected": "Подключение отклонено",
      "asset_remote_consent_hint": "На экране клиента появится окно согласия. Попросите клиента подтвердить подключение.",
      "asset_remote_disconnect": "Отключить",
      "asset_remote_enter_code_hint": "Введите 6-значный код доступа, отображаемый на экране пользователя:",
      "asset_remote_invalid_code": "Неверный код доступа",
      "asset_remote_live_focus": "ТРАНСЛЯЦИЯ · Фокус ввода клавиатуры",
      "asset_remote_loading_screen": "Загрузка трансляции экрана...",
      "asset_remote_preparing": "Подготовка к подключению...",
      "asset_remote_protocol2_code_label": "Zwölfstelliger Zugangscode",
      "asset_remote_protocol2_code_placeholder": "ABCD EFGH 2345",
      "asset_remote_protocol2_enter_code_hint": "Geben Sie den zwölfstelligen Zugangscode vom Bildschirm des Benutzers ein:",
      "asset_remote_protocol2_request_desc": "Sendet eine Verbindungsanfrage an den Client-Rechner. Der Benutzer muss zustimmen und den zwölfstelligen Zugangscode übermitteln.",
      "asset_remote_rejected_desc": "Запрос на подключение был отклонен пользователем на клиентском устройстве.",
      "asset_remote_req": "Запросить удаленный доступ",
      "asset_remote_request_again": "Запросить снова",
      "asset_remote_request_desc": "Отправляет запрос на подключение к клиентскому компьютеру. Пользователь должен дать согласие и передать 6-значный код доступа.",
      "asset_remote_request_title": "Запросить удаленный доступ",
      "asset_remote_start_error": "Не удалось запустить сеанс удаленного доступа",
      "asset_remote_start_new": "Начать новый сеанс",
      "asset_remote_support": "Встроенная удаленная поддержка",
      "asset_remote_support_desc": "Прямое удаленное управление экраном без стороннего ПО (TeamViewer/RustDesk).",
      "asset_remote_user_consented": "Пользователь дал согласие",
      "asset_remote_verifying_code": "Проверка кода...",
      "asset_remote_waiting_consent": "Ожидание согласия пользователя...",
      "asset_retired": "Списан",
      "assets": "Активы",
      "assign_to": "Назначить...",
      "assign_to_me": "Назначить мне",
      "assigned_agents": "Закрепленные агенты",
      "assigned_to": "Назначено",
      "at_risk_title": "Под угрозой (Предупреждение SLA):",
      "attach_local_file": "Прикрепить локальный файл",
      "attachments": "Вложения",
      "attachments_tools": "Вложения и Инструменты",
      "attendees_emails": "Участники (email, через запятую)",
      "automation": "Автоматизация",
      "avg_first_response": "Время первого ответа",
      "avg_resolution": "Среднее время решения",
      "billable": "Оплачиваемый",
      "billable_time": "Оплачено: {{time}}",
      "book_on_send": "Записать при отправке",
      "book_time_with_reply": "Записать время с ответом",
      "calendar": "Календарь",
      "calendar_enter_title_warning": "Пожалуйста, введите название.",
      "calendar_event_attendees": "Email участников (опционально, через запятую)",
      "calendar_event_created_error": "Не удалось создать событие.",
      "calendar_event_created_success": "Событие создано.",
      "calendar_event_description": "Описание (опционально)",
      "calendar_event_title": "Название",
      "calendar_meeting_created_error": "Не удалось создать встречу.",
      "calendar_meeting_link_copied": "Ссылка на встречу скопирована в буфер обмена.",
      "calendar_new_event": "Новое событие",
      "calendar_no_integration_or": "или",
      "calendar_no_integration_prefix": "Нет активных интеграций календаря или встреч. Пожалуйста, настройте",
      "calendar_no_integration_suffix": "с активным планированием встреч в интеграциях.",
      "calendar_only_event": "Только событие календаря",
      "calendar_talk_meeting": "Встреча Talk",
      "calendar_talk_room_created": "Комната Talk создана.",
      "calendar_teams_meeting": "Встреча Teams",
      "calendar_teams_meeting_created": "Встреча Teams создана.",
      "cancel": "Отмена",
      "canned_responses": "Вставить шаблон ответа",
      "canned_responses_short": "Шаблон ответа",
      "categories": "Категории",
      "category": "Категория",
      "change_priority": "Изменить приоритет...",
      "change_status_after_send": "После отправки изменить на",
      "change_ticket_company": "Ticket anderer Firma zuordnen",
      "change_ticket_company_warning": "Portal-Ersteller, CC, Mitarbeiter, Bearbeiter, Kategorie, SLA, Assets und laufende Timer werden für die neue Firma zurückgesetzt.",
      "characters": "символов",
      "city": "Город",
      "clear_selection": "Сбросить выбор",
      "click_to_logout": "Нажмите, чтобы выйти",
      "close": "Закрыть",
      "close_detail_view": "Закрыть детальный вид",
      "close_ticket": "Закрыть тикет",
      "closed": "Закрытые",
      "collapse": "Свернуть",
      "collapse_composer": "Свернуть редактор",
      "collapse_sidebar": "Свернуть боковую панель",
      "column_assignee_name": "Назначен",
      "column_category_name": "Категория",
      "column_channel": "Канал",
      "column_created_at": "Создано",
      "column_customer_name": "Клиент",
      "column_priority": "Приоритет",
      "column_reply_count": "Ответы",
      "column_requester_name": "Создатель",
      "column_sla": "SLA",
      "column_status": "Статус",
      "column_subject": "Тема",
      "column_tags": "Теги",
      "column_ticket_number": "№",
      "column_updated_at": "Обновлено",
      "columns_btn": "Колонки",
      "common.abbrechen": "Abbrechen",
      "company_name": "Название компании",
      "company_title": "Компания",
      "compliance_rate": "Уровень соответствия",
      "composer_internal": "Внутренний",
      "composer_internal_placeholder": "Внутренняя заметка...",
      "composer_public": "Публичный",
      "composer_public_placeholder": "Написать ответ...",
      "configure_columns": "Настройка колонок",
      "connect": "Подключить",
      "contact_and_master_data": "Контакты и реквизиты",
      "contact_person": "Контактное лицо",
      "contact_person_abbrev": "КЛ",
      "contract": "Договор",
      "contract.auto_renew": "Автоматическое продление",
      "contract.auto_renews_suffix": " (продлевается автоматически)",
      "contract.back_to_overview": "Назад к обзору",
      "contract.billing": "Расчёты",
      "contract.billing_model": "Модель расчётов",
      "contract.conditions": "Условия",
      "contract.days": "{{count}} дн.",
      "contract.end_date": "Дата окончания",
      "contract.expires_in_days": "Истекает через {{count}} дн.",
      "contract.first_response": "Первая реакция",
      "contract.hourly_rate": "Почасовая ставка",
      "contract.hours_quota": "Квота часов",
      "contract.included_hours": "Включённые часы",
      "contract.no_contracts": "Договоры отсутствуют",
      "contract.no_contracts_desc": "Свяжитесь с нами для получения индивидуального предложения",
      "contract.notice_period": "Срок уведомления о расторжении: {{count}} дн.",
      "contract.period_per": "{{count}} ч / период",
      "contract.quota_summary": "Осталось {{remaining}} (использовано {{percent}}%)",
      "contract.remaining": "Осталось",
      "contract.resolution": "Решение",
      "contract.runtime": "Срок действия",
      "contract.sla_tier": "SLA",
      "contract.start_date": "Дата начала",
      "contract.status.active": "Активен",
      "contract.status.expired": "Истёк",
      "contract.status.expiring_soon": "Скоро истекает",
      "contract.status.future": "Будущий",
      "contract.subtitle": "Обзор Ваших действующих договоров и соглашений об уровне обслуживания",
      "contract.unlimited": "Бессрочный",
      "contract.used": "Использовано",
      "contracts": "Договоры",
      "copied_to_clipboard": "Скопировано в буфер обмена",
      "country": "Страна",
      "create": "Создать",
      "create_ticket.aehnliche_tickets": "Похожие заявки",
      "create_ticket.angehaengte_cloud_dateien": "Прикреплённые облачные файлы:",
      "create_ticket.anhaenge": "Вложения",
      "create_ticket.asset_verknuepfen_optional": "Связать актив (необязательно):",
      "create_ticket.assets_filtern": "Фильтр активов:",
      "create_ticket.assets_werden_geladen": "Загрузка активов...",
      "create_ticket.beschreiben_sie_das_problem_so_detailliert_w": "Опишите проблему как можно подробнее...",
      "create_ticket.betroffene_systeme_benutzer_nennen": "Укажите затронутые системы и пользователей",
      "create_ticket.bitte_betreff_und_beschreibung_ausfuellen": "Заполните тему и описание",
      "create_ticket.bitte_eine_beschreibung_angeben": "Укажите описание.",
      "create_ticket.bitte_einen_kunden_auswaehlen": "Выберите клиента.",
      "create_ticket.bitte_hauptkategorie_waehlen": "Выберите основную категорию...",
      "create_ticket.bitte_klassifizierung_waehlen": "Выберите классификацию...",
      "create_ticket.bitte_kunde_waehlen": "Выберите клиента...",
      "create_ticket.bitte_unterkategorie_waehlen": "Выберите подкатегорию...",
      "create_ticket.bitte_zuerst_einen_kunden_waehlen": "Сначала выберите клиента...",
      "create_ticket.datei_hochladen": "Загрузить файл",
      "create_ticket.datei_hochladen_2": "Загрузить файл",
      "create_ticket.datei_zu_gross_max_10_mb": "Файл слишком большой (макс. 10 МБ)",
      "create_ticket.dateityp_nicht_erlaubt": "Тип файла не разрешён",
      "create_ticket.erste_antwort": "Первый ответ",
      "create_ticket.fehlermeldungen_und_screenshots_beifuegen": "Приложите сообщения об ошибках и скриншоты",
      "create_ticket.keine_mitarbeiter_hinterlegt": "Сотрудники не заданы",
      "create_ticket.letzte_kunden_tickets": "Последние заявки клиента",
      "create_ticket.loesung": "Решение",
      "create_ticket.neues_ticket": "Новая заявка",
      "create_ticket.nur_geschaeftszeiten": "Только рабочее время",
      "create_ticket.praeziser_betreff_hilft_bei_der_zuordnung": "Точная тема помогает при распределении",
      "create_ticket.priority_high": "Высокий",
      "create_ticket.priority_low": "Низкий",
      "create_ticket.priority_medium": "Средний",
      "create_ticket.priority_urgent": "Срочный",
      "create_ticket.schritte_zur_reproduktion_angeben": "Укажите шаги для воспроизведения",
      "create_ticket.stoerung": "Инцидент",
      "create_ticket.text_mit_ki_verbessern": "Улучшить текст с помощью ИИ",
      "create_ticket.ticket_erstellt": "Заявка создана!",
      "create_ticket.uebernehmen": "Применить",
      "create_ticket.ueberschrift": "Заголовок",
      "create_ticket.vielleicht_loest_ein_artikel_das_problem_ber": "Возможно, проблему уже решает одна из статей?",
      "create_ticket.vorlage_einfuegen": "Вставить шаблон",
      "create_ticket.waehlen_sie_einen_kunden_aus_um_dessen_asset": "Выберите клиента, чтобы связать его активы.",
      "create_ticket.werden_bei_erstellung_ausgeloest": "Срабатывают при создании",
      "create_ticket.zurueck": "Назад",
      "created_at": "Создано",
      "critical_priority_sla": "Приоритет / SLA",
      "customer": "Клиент",
      "customer_assets.no_assets": "Для этого клиента не зарегистрировано активов. При наличии у актива идентификатора узла Zabbix или монитора доступности здесь появятся сведения о состоянии.",
      "customer_assets.no_assets_unconfigured": "Активы не зарегистрированы. Discovery или интеграция мониторинга может автоматизировать инвентаризацию.",
      "customer_assets.no_zabbix_id": "У актива нет идентификатора узла Zabbix",
      "customer_assets.start_rd": "Запустить RustDesk",
      "customer_assets.start_tv": "Запустить TeamViewer",
      "customer_form.adresse_eingeben_um_karte_anzuzeigen": "Введите адрес, чтобы показать карту",
      "customer_form.client_secret": "Client Secret",
      "customer_form.domain_entfernen": "Удалить домен",
      "customer_form.domain_hinzufuegen": "+ Добавить домен",
      "customer_form.domains_mit_zugeordneten_mitarbeitern_koenne": "Домены с назначенными сотрудниками удалить нельзя.",
      "customer_form.geschaeftsfuehrer": "Генеральный директор",
      "customer_form.in_openstreetmap_oeffnen": "Открыть в OpenStreetMap ↗",
      "customer_form.interne_notizen_zu_diesem_kunden": "Внутренние заметки об этом клиенте...",
      "customer_form.kontakt_in_lexoffice_anlegen_uuid_hier_eintr": "Создайте контакт в Lexoffice и введите UUID здесь",
      "customer_form.lexoffice_kontakt_id_uuid": "ID контакта Lexoffice (UUID)",
      "customer_form.logo_kann_nach_dem_erstellen_des_kunden_hoch": "Логотип можно загрузить после создания клиента.",
      "customer_form.mitarbeiter_koennen_sich_per_microsoft_konto": "Сотрудники могут входить через учётную запись Microsoft",
      "customer_form.mloffice_badge": "Von MLOffice verwaltet",
      "customer_form.mloffice_banner": "Dieser Kunde wird mit MLOffice abgeglichen. Stammdaten (Name, E-Mail, Telefon, Anschrift, USt-ID) werden von MLOffice verwaltet und sind hier gesperrt.",
      "customer_form.mloffice_feld_hinweis": "Dieses Feld wird von MLOffice verwaltet — Änderungen bitte dort vornehmen; sie werden automatisch übernommen.",
      "customer_form.mloffice_geloest": "Verknüpfung gelöst — die Felder sind wieder bearbeitbar.",
      "customer_form.mloffice_loesen": "Verknüpfung lösen…",
      "customer_form.mloffice_loesen_fehler": "Verknüpfung konnte nicht gelöst werden.",
      "customer_form.mloffice_loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "customer_form.mloffice_loest": "Löse…",
      "customer_form.mloffice_verwaltung_hinweis": "Verwaltung der Verknüpfung unter Stammdaten & Organisation → MLOffice (erfordert Systemrechte).",
      "customer_form.registrieren_sie_eine_app_in_azure_portal_ap": "Зарегистрируйте приложение в Azure Portal → «Регистрация приложений». Redirect URI:",
      "customer_form.strasse": "Улица",
      "customer_form.tab_address": "Адрес",
      "customer_form.tab_domains": "Домены",
      "customer_form.tab_general": "Общее",
      "customer_form.tab_notes": "Заметки",
      "customer_form.tab_sso": "SSO",
      "customer_form.tab_tax": "Налоги и SLA",
      "customer_form.zuordnung_ticket_system_kunde_lexoffice_kont": "Сопоставление клиента системы заявок с контактом Lexoffice для черновиков счетов (Admin → Учёт времени).",
      "customer_inactive": "Клиент неактивен",
      "customer_not_found": "Клиент не найден",
      "customer_notified_by_email": "Клиент будет уведомлен по эл. почте",
      "customer_number_abbrev": "№ Кл",
      "customer_portal.action_required": "Требуется действие",
      "customer_portal.action_required_desc": "Служба поддержки ожидает Вашего ответа по этой заявке.",
      "customer_portal.action_required_title": "Требуется Ваш ответ",
      "customer_portal.assignee": "Исполнитель",
      "customer_portal.attachments_count": "Вложения ({{count}})",
      "customer_portal.attachments_load_failed": "Weitere Anhänge konnten nicht geladen werden.",
      "customer_portal.back": "← Назад",
      "customer_portal.back_to_my_tickets": "← Назад к моим заявкам",
      "customer_portal.close": "Закрыть",
      "customer_portal.close_failed": "Не удалось закрыть заявку.",
      "customer_portal.collapse_replies": "Ältere schließen",
      "customer_portal.compact_replies": "Ältere Antworten sind eingeklappt. Die letzte Antwort bleibt geöffnet.",
      "customer_portal.confirm_close": "Вы действительно хотите закрыть эту заявку?",
      "customer_portal.confirm_reopen": "Вы действительно хотите снова открыть эту заявку?",
      "customer_portal.contracts.hours_minutes": "{{hours}} ч {{minutes}} мин",
      "customer_portal.contracts.hours_only": "{{hours}} ч",
      "customer_portal.contracts.minutes_only": "{{minutes}} мин",
      "customer_portal.create_first_ticket": "Создать заявку",
      "customer_portal.created": "Создано",
      "customer_portal.customer_colleague": "Kollegin/Kollege",
      "customer_portal.dashboard.active_count": "{{count}} активных",
      "customer_portal.dashboard.avg_resolution": "Среднее время решения",
      "customer_portal.dashboard.click_to_view_waiting": "Нажмите здесь, чтобы посмотреть заявки",
      "customer_portal.dashboard.create_first_link": "Создать первую заявку →",
      "customer_portal.dashboard.create_new_ticket_link": "Создать заявку",
      "customer_portal.dashboard.history_trend": "Динамика заявок (за последние 12 месяцев)",
      "customer_portal.dashboard.kb": "Помощь и база знаний",
      "customer_portal.dashboard.kb_desc": "Инструкции и часто задаваемые вопросы",
      "customer_portal.dashboard.my_tickets": "Мои заявки",
      "customer_portal.dashboard.no_tickets": "Заявок пока нет",
      "customer_portal.dashboard.no_tickets_status": "Нет заявок",
      "customer_portal.dashboard.open_active": "Открытые / активные",
      "customer_portal.dashboard.processing_time": "Время обработки",
      "customer_portal.dashboard.recent_tickets": "Последние заявки",
      "customer_portal.dashboard.report_incident": "Сообщить о сбое",
      "customer_portal.dashboard.report_incident_desc": "Сообщить о срочной проблеме или отказе",
      "customer_portal.dashboard.reports": "Обзор и отчёты",
      "customer_portal.dashboard.reports_desc": "Фильтрация и анализ всех заявок",
      "customer_portal.dashboard.search_kb_link": "Искать в базе знаний",
      "customer_portal.dashboard.service_request": "Сервисный запрос",
      "customer_portal.dashboard.service_request_desc": "Запросы по настраиваемым формам",
      "customer_portal.dashboard.show_all_link": "Показать все →",
      "customer_portal.dashboard.status_overview": "Обзор статусов",
      "customer_portal.dashboard.subtitle": "Ваш обзор поддержки с первого взгляда",
      "customer_portal.dashboard.total_tickets": "Всего заявок",
      "customer_portal.dashboard.waiting_tickets_warning": "1 заявка требует Вашего ответа",
      "customer_portal.dashboard.waiting_tickets_warning_plural": "{{count}} заявок требуют Вашего ответа",
      "customer_portal.dashboard.welcome": "Добро пожаловать",
      "customer_portal.dashboard.widget_unknown": "Виджет: {{type}}",
      "customer_portal.dashboard.your_reply": "Ваш ответ",
      "customer_portal.details_title": "Детали",
      "customer_portal.editor.bold": "Полужирный",
      "customer_portal.editor.code": "Код",
      "customer_portal.editor.italic": "Курсив",
      "customer_portal.editor.list": "Список",
      "customer_portal.expand_replies": "Alle öffnen",
      "customer_portal.files_draft_failed": "Anhänge konnten nicht dauerhaft im Entwurf gespeichert werden.",
      "customer_portal.files_need_reselect": "Anhänge können aus Sicherheitsgründen nicht wiederhergestellt werden. Bitte wählen Sie sie erneut aus.",
      "customer_portal.filters.active": "Активные",
      "customer_portal.filters.all": "Все",
      "customer_portal.filters.closed": "Закрытые",
      "customer_portal.filters.external": "Extern",
      "customer_portal.filters.waiting_customer": "Ваш ответ",
      "customer_portal.history_title": "История",
      "customer_portal.impersonation_banner": "Сейчас Вы просматриваете портал в режиме имперсонации (предпросмотр для агентов) от имени клиента:",
      "customer_portal.incident_badge": "Сбой",
      "customer_portal.kb.title": "База знаний",
      "customer_portal.load_more_attachments": "Weitere Anhänge laden",
      "customer_portal.login.betreut_von": "ПОДДЕРЖКА NALVRA",
      "customer_portal.login.claim": "Прямая связь с поддержкой — сообщить о проблеме, узнать статус, найти ответ.",
      "customer_portal.login.copyright_text": "© {{year}} {{appName}}. Все права защищены.",
      "customer_portal.login.default_subtitle": "Войдите, чтобы управлять своими заявками.",
      "customer_portal.login.default_welcome": "Добро пожаловать в {{appName}}",
      "customer_portal.login.email": "Электронная почта",
      "customer_portal.login.email_placeholder": "name@company.ru",
      "customer_portal.login.eyebrow": "КЛИЕНТСКИЙ ПОРТАЛ · ДОСТУПЕН 24/7",
      "customer_portal.login.forgot_password": "Забыли пароль?",
      "customer_portal.login.kein_zugang": "Ещё нет доступа? Обратитесь к своему контактному лицу в службе поддержки.",
      "customer_portal.login.kundenanmeldung": "Вход для клиентов",
      "customer_portal.login.kundenportal": "КЛИЕНТСКИЙ ПОРТАЛ",
      "customer_portal.login.microsoft_signin": "Войти через Microsoft",
      "customer_portal.login.mit_hinterlegter_adresse": "Войдите с помощью указанного адреса электронной почты.",
      "customer_portal.login.or_password": "или по паролю",
      "customer_portal.login.password": "Пароль",
      "customer_portal.login.password_placeholder": "Ваш пароль",
      "customer_portal.login.reset_back": "Назад ко входу",
      "customer_portal.login.reset_button": "Отправить ссылку",
      "customer_portal.login.reset_instruction": "Укажите адрес электронной почты. Мы отправим ссылку для сброса пароля.",
      "customer_portal.login.reset_sent_message": "Если учётная запись с этим адресом существует, мы отправили ссылку для сброса пароля.",
      "customer_portal.login.reset_sent_title": "Письмо отправлено",
      "customer_portal.login.reset_title": "Сброс пароля",
      "customer_portal.login.sicherheitszeile": "Шифрованное соединение · Доступ только для зарегистрированных контактов",
      "customer_portal.login.signin_button": "Войти",
      "customer_portal.login.signing_in": "Выполняется вход …",
      "customer_portal.login.sso_available": "Доступен единый вход",
      "customer_portal.login.sso_failed": "Не удалось войти через SSO",
      "customer_portal.login.sso_logging_in": "Выполняется вход …",
      "customer_portal.menu.dashboard": "Панель управления",
      "customer_portal.menu.edit_profile": "Редактировать профиль",
      "customer_portal.menu.logout": "Выйти",
      "customer_portal.menu.profile": "Mein Profil",
      "customer_portal.message_placeholder": "Ваше сообщение...",
      "customer_portal.nav.contracts": "Договоры",
      "customer_portal.nav.create_request": "Anfrage erstellen",
      "customer_portal.nav.dashboard": "Панель управления",
      "customer_portal.nav.documents": "Документы",
      "customer_portal.nav.downloads": "Downloads",
      "customer_portal.nav.help": "Hilfe & Kurztour",
      "customer_portal.nav.kb": "База знаний",
      "customer_portal.nav.my_tickets": "Мои заявки",
      "customer_portal.nav.profile": "Профиль",
      "customer_portal.nav.report_incident": "Сообщить о сбое",
      "customer_portal.nav.service_request": "Сервисный запрос",
      "customer_portal.nav.support": "Support erhalten",
      "customer_portal.navigation": "Portal-Navigation",
      "customer_portal.new_ticket": "Новая заявка",
      "customer_portal.new_ticket.add_attachment": "Добавить",
      "customer_portal.new_ticket.ai_improve_btn": "Улучшить описание",
      "customer_portal.new_ticket.ai_improving": "Выполняется улучшение...",
      "customer_portal.new_ticket.ai_preanswer_title": "Предложение ИИ по Вашей проблеме",
      "customer_portal.new_ticket.ai_suggestion_title": "Предложение ИИ по улучшению",
      "customer_portal.new_ticket.allowed_types_tip": "Только разрешённые типы файлов (см. указания Вашего администратора)",
      "customer_portal.new_ticket.apply": "Применить",
      "customer_portal.new_ticket.attach_file": "Прикрепить файл",
      "customer_portal.new_ticket.attachment_plural": "Вложения",
      "customer_portal.new_ticket.attachment_singular": "Вложение",
      "customer_portal.new_ticket.back_step_1": "Zurück zu Schritt 1",
      "customer_portal.new_ticket.back_step_2": "Zurück zu Schritt 2",
      "customer_portal.new_ticket.categories_error": "Kategorien konnten nicht geladen werden.",
      "customer_portal.new_ticket.categories_loading": "Kategorien werden geladen …",
      "customer_portal.new_ticket.category_assignment": "Kategorie zuordnen",
      "customer_portal.new_ticket.category_by_support": "Zuordnung durch den Support",
      "customer_portal.new_ticket.category_hint": "Sie sind unsicher? Lassen Sie die Kategorie offen. Der Support übernimmt die Zuordnung.",
      "customer_portal.new_ticket.category_question": "Welche Kategorie passt zu Ihrem Anliegen?",
      "customer_portal.new_ticket.char_count": "{{count}} символов",
      "customer_portal.new_ticket.continue_step_2": "Weiter zu Schritt 2",
      "customer_portal.new_ticket.continue_step_3": "Weiter zu Schritt 3",
      "customer_portal.new_ticket.create": "Создать",
      "customer_portal.new_ticket.create_anyway": "Всё равно создать заявку",
      "customer_portal.new_ticket.create_ticket": "Создать заявку",
      "customer_portal.new_ticket.creating": "Выполняется создание...",
      "customer_portal.new_ticket.days_count": "{{count}} рабочих дн.",
      "customer_portal.new_ticket.description_label": "Описание *",
      "customer_portal.new_ticket.description_placeholder": "Опишите Вашу проблему подробно...\\n\\n• Что не работает?\\n• С какого момента возникает проблема?\\n• Есть ли сообщение об ошибке?\\n• Какая система / какое устройство затронуты?\\n\\nСовет: скриншоты можно вставить сочетанием Ctrl+V",
      "customer_portal.new_ticket.description_required": "Bitte beschreiben Sie Ihr Problem.",
      "customer_portal.new_ticket.discard": "Отклонить",
      "customer_portal.new_ticket.drag_more": "Перетащите сюда другие файлы · Доступно ещё {{count}}",
      "customer_portal.new_ticket.drag_or_click": "Перетащите файлы сюда или нажмите",
      "customer_portal.new_ticket.drop_here": "Отпустите файлы здесь...",
      "customer_portal.new_ticket.error_create_failed": "Ошибка при создании заявки.",
      "customer_portal.new_ticket.expected_first_response": "Первый ответ",
      "customer_portal.new_ticket.go_to_step": "Schritt {{step}}: {{label}}",
      "customer_portal.new_ticket.hide": "Скрыть",
      "customer_portal.new_ticket.hours_count": "{{count}} часов",
      "customer_portal.new_ticket.insert_template": "Вставить шаблон",
      "customer_portal.new_ticket.kb_article_error": "Dieser Artikel konnte nicht geladen werden. Sie können es erneut versuchen oder mit Ihrem Ticket fortfahren.",
      "customer_portal.new_ticket.kb_close_article": "Artikel schließen",
      "customer_portal.new_ticket.kb_did_help": "Hat dieser Artikel Ihr Problem gelöst?",
      "customer_portal.new_ticket.kb_draft_retained": "Ihr Ticketentwurf bleibt erhalten. Sie entscheiden, ob Sie ihn weiter bearbeiten.",
      "customer_portal.new_ticket.kb_feedback_error": "Ihre Rückmeldung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut. Ihr Entwurf bleibt erhalten.",
      "customer_portal.new_ticket.kb_helped": "Artikel hat mir geholfen",
      "customer_portal.new_ticket.kb_loading_article": "Artikel wird geladen",
      "customer_portal.new_ticket.kb_resolved_message": "Ihre Rückmeldung wurde gespeichert. Es wurde kein Ticket erstellt.",
      "customer_portal.new_ticket.kb_resolved_title": "Schön, dass die Anleitung geholfen hat",
      "customer_portal.new_ticket.kb_resume_draft": "Ticketentwurf weiter bearbeiten",
      "customer_portal.new_ticket.kb_retry": "Erneut laden",
      "customer_portal.new_ticket.kb_saved_draft": "Ihr Entwurf bleibt für Sie gespeichert, falls Sie später doch Unterstützung benötigen.",
      "customer_portal.new_ticket.kb_searching": "Lösungen werden gesucht",
      "customer_portal.new_ticket.kb_suggestions_hint": "Passende Anleitungen aus der Wissensbasis. Lesen Sie einen Artikel, bevor Sie Ihr Ticket erstellen.",
      "customer_portal.new_ticket.kb_suggestions_title": "Vielleicht ist die Lösung schon da",
      "customer_portal.new_ticket.kb_to_dashboard": "Zurück zum Dashboard",
      "customer_portal.new_ticket.max_files": "Не более {{count}} файлов",
      "customer_portal.new_ticket.max_size": "Не более {{count}} МБ на файл",
      "customer_portal.new_ticket.minutes_count": "{{count}} минут",
      "customer_portal.new_ticket.no_category": "Выберите категорию...",
      "customer_portal.new_ticket.optional": "Optional",
      "customer_portal.new_ticket.preanswer_might_resolve": "Это Вам помогло? Тогда, возможно, создавать заявку не потребуется.",
      "customer_portal.new_ticket.presubmit_kb_desc": "Не нашли подходящую статью? Не беда — создайте заявку.",
      "customer_portal.new_ticket.presubmit_kb_title": "Возможно, это уже решит Вашу проблему",
      "customer_portal.new_ticket.prio_desc_critical": "Немедленно",
      "customer_portal.new_ticket.prio_desc_high": "Срочно",
      "customer_portal.new_ticket.prio_desc_low": "Может подождать",
      "customer_portal.new_ticket.prio_desc_medium": "Обычный",
      "customer_portal.new_ticket.progress": "Fortschritt der Ticketerstellung",
      "customer_portal.new_ticket.relevant_articles": "Подходящие статьи:",
      "customer_portal.new_ticket.reply_by_email_tip": "На эту заявку Вы можете ответить также по электронной почте",
      "customer_portal.new_ticket.resolution": "Решение",
      "customer_portal.new_ticket.response_time_typical": "Как правило, ответ в течение нескольких часов",
      "customer_portal.new_ticket.retry_categories": "Erneut laden",
      "customer_portal.new_ticket.screenshot_tip": "Скриншоты вставляются сочетанием Ctrl+V",
      "customer_portal.new_ticket.similar_tickets": "Похожие заявки",
      "customer_portal.new_ticket.step_attachments": "Anhänge",
      "customer_portal.new_ticket.step_attachments_detail": "Kategorie, Anhänge und Absenden",
      "customer_portal.new_ticket.step_count": "Schritt {{step}} von 3",
      "customer_portal.new_ticket.step_details": "Details",
      "customer_portal.new_ticket.step_details_detail": "Beschreibung und Priorität",
      "customer_portal.new_ticket.step_subject": "Betreff",
      "customer_portal.new_ticket.step_subject_detail": "Person, Betreff und Wissensbasis",
      "customer_portal.new_ticket.subject_desc_required": "Тема и описание обязательны для заполнения.",
      "customer_portal.new_ticket.subject_label": "Тема *",
      "customer_portal.new_ticket.subject_placeholder": "Краткое описание проблемы или Вашего запроса",
      "customer_portal.new_ticket.subject_required": "Bitte geben Sie einen Betreff ein.",
      "customer_portal.new_ticket.subtitle": "Технический сбой или срочная проблема — будет передано в поддержку в виде заявки.",
      "customer_portal.new_ticket.subtitle_2": "Опишите Ваш вопрос, и мы им займёмся.",
      "customer_portal.new_ticket.success_desc": "Благодарим Вас. Мы свяжемся с Вами в кратчайшие сроки.",
      "customer_portal.new_ticket.success_title": "Заявка создана!",
      "customer_portal.new_ticket.template_btn": "Пример",
      "customer_portal.new_ticket.view_ticket": "Открыть заявку",
      "customer_portal.no_attachments": "Keine Anhänge vorhanden.",
      "customer_portal.no_tickets_create_desc": "Создайте свою первую заявку.",
      "customer_portal.no_tickets_filter_desc": "Попробуйте другой фильтр.",
      "customer_portal.no_tickets_search_desc": "Попробуйте другой поисковый запрос.",
      "customer_portal.no_tickets_title": "Заявки не найдены",
      "customer_portal.pagination_of": "von",
      "customer_portal.password.btn": "Изменить пароль",
      "customer_portal.password.cancel": "Отмена",
      "customer_portal.password.changing": "Выполняется изменение...",
      "customer_portal.password.confirm": "Подтвердите новый пароль",
      "customer_portal.password.current": "Текущий пароль",
      "customer_portal.password.error_change": "Ошибка при изменении.",
      "customer_portal.password.error_min_length": "Не менее 8 символов.",
      "customer_portal.password.error_mismatch": "Пароли не совпадают.",
      "customer_portal.password.error_same": "Новый пароль должен отличаться от текущего.",
      "customer_portal.password.logout": "Выйти",
      "customer_portal.password.mismatch_warning": "Пароли не совпадают",
      "customer_portal.password.must_change_desc": "Пожалуйста, измените пароль, прежде чем продолжить.",
      "customer_portal.password.new": "Новый пароль (не менее 8 символов)",
      "customer_portal.password.redirecting": "Выполняется перенаправление...",
      "customer_portal.password.success": "Пароль успешно изменён!",
      "customer_portal.password.title": "Изменение пароля",
      "customer_portal.priority_help.high": "Mehrere Mitarbeitende oder eine wichtige Funktion sind stark beeinträchtigt. Es gibt keine praktikable Ausweichlösung, der übrige Betrieb läuft jedoch weiter.",
      "customer_portal.priority_help.low": "Kleine Einschränkung oder allgemeine Frage. Sie können normal weiterarbeiten, zum Beispiel bei einem Darstellungsfehler oder einem Änderungswunsch.",
      "customer_portal.priority_help.medium": "Die Arbeit ist eingeschränkt, aber eine Ausweichlösung ist möglich. Beispiel: Ein Drucker fällt aus, ein anderer kann genutzt werden.",
      "customer_portal.priority_help.urgent": "Der Betrieb oder ein geschäftskritischer Prozess steht still. Es gibt keine Ausweichlösung, zum Beispiel bei einem vollständigen Ausfall des zentralen Systems. Bitte nicht nur wegen eines persönlichen Wunschtermins wählen.",
      "customer_portal.processing_time": "Время обработки",
      "customer_portal.profile.cancel": "Отмена",
      "customer_portal.profile.change_password_btn": "Изменить пароль",
      "customer_portal.profile.change_photo": "Profilbild ändern",
      "customer_portal.profile.closed": "Закрытые",
      "customer_portal.profile.company": "Компания",
      "customer_portal.profile.company_account": "Компания и учётная запись",
      "customer_portal.profile.days_count": "{{count}} раб. дн.",
      "customer_portal.profile.department": "Отдел",
      "customer_portal.profile.edit": "Редактировать",
      "customer_portal.profile.email": "Электронная почта",
      "customer_portal.profile.error_save": "Ошибка при сохранении",
      "customer_portal.profile.error_upload": "Ошибка при загрузке",
      "customer_portal.profile.first_name": "Имя",
      "customer_portal.profile.first_response": "Первый ответ",
      "customer_portal.profile.hours_count": "{{count}} ч.",
      "customer_portal.profile.last_name": "Фамилия",
      "customer_portal.profile.loading": "Загрузка профиля...",
      "customer_portal.profile.location": "Местоположение",
      "customer_portal.profile.member_since": "В системе с",
      "customer_portal.profile.minutes_count": "{{count}} мин.",
      "customer_portal.profile.mobile": "Мобильный",
      "customer_portal.profile.mobile_placeholder": "например, +49 170 12345",
      "customer_portal.profile.open": "Открытые",
      "customer_portal.profile.personal_data": "Личные данные",
      "customer_portal.profile.phone": "Телефон",
      "customer_portal.profile.phone_placeholder": "например, +49 221 12345",
      "customer_portal.profile.position": "Должность",
      "customer_portal.profile.resolution": "Решение",
      "customer_portal.profile.save": "Сохранить",
      "customer_portal.profile.security": "Безопасность",
      "customer_portal.profile.security_desc": "Регулярно меняйте пароль для повышения безопасности.",
      "customer_portal.profile.service_level": "Уровень обслуживания",
      "customer_portal.profile.show_dashboard": "Показать панель управления",
      "customer_portal.profile.sla_tier": "Уровень SLA",
      "customer_portal.profile.sso_active": "Аутентификация SSO активна",
      "customer_portal.profile.success_photo": "Фото профиля обновлено",
      "customer_portal.profile.success_update": "Профиль успешно обновлён",
      "customer_portal.profile.ticket_overview": "Обзор заявок",
      "customer_portal.profile.total": "Всего",
      "customer_portal.reopen": "Открыть повторно",
      "customer_portal.reopen_failed": "Не удалось снова открыть заявку.",
      "customer_portal.reopen_ticket": "Открыть заявку повторно",
      "customer_portal.replies_load_failed": "Ältere Antworten konnten nicht geladen werden.",
      "customer_portal.reply_btn": "Ответить",
      "customer_portal.reply_failed": "Не удалось отправить Ваш ответ. Пожалуйста, попробуйте ещё раз.",
      "customer_portal.reply_plural": "Ответы",
      "customer_portal.reply_singular": "Ответ",
      "customer_portal.request_badge": "Запрос",
      "customer_portal.requests.attachments": "Вложения",
      "customer_portal.requests.category": "Категория",
      "customer_portal.requests.description": "Описание",
      "customer_portal.requests.priority": "Приоритет",
      "customer_portal.search_label": "Tickets suchen",
      "customer_portal.search_placeholder": "Поиск по номеру заявки или теме...",
      "customer_portal.sending": "Выполняется отправка...",
      "customer_portal.service_level": "Уровень обслуживания",
      "customer_portal.show_older_replies": "Показать предыдущие ответы ({{count}})...",
      "customer_portal.sla.met": "Выполнен",
      "customer_portal.sla.on_track": "В графике",
      "customer_portal.sla.overdue": "Просрочен",
      "customer_portal.sla.warning": "Скоро истекает",
      "customer_portal.source": "Источник",
      "customer_portal.source_portal": "Портал",
      "customer_portal.stop_impersonation": "Завершить имперсонацию",
      "customer_portal.support_team": "Служба поддержки",
      "customer_portal.ticket_closed_desc": "Эта заявка закрыта.",
      "customer_portal.ticket_load_failed": "Ticket konnte nicht geladen werden",
      "customer_portal.ticket_load_failed_desc": "Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "customer_portal.ticket_not_found": "Заявка не найдена",
      "customer_portal.ticket_owner": "Ihr zuständiger Support-Agent",
      "customer_portal.ticket_plural": "Заявки",
      "customer_portal.ticket_singular": "Заявка",
      "customer_portal.tickets_load_failed": "Tickets konnten nicht geladen werden",
      "customer_portal.tickets_load_failed_desc": "Ihre Daten wurden nicht verändert.",
      "customer_portal.times_title": "Сроки",
      "customer_portal.unassigned_owner": "Noch nicht zugewiesen",
      "customer_portal.unsaved_warning": "Ihr nicht gesendeter Entwurf geht beim Verlassen möglicherweise verloren.",
      "customer_portal.updated": "Обновлено",
      "customer_portal.via_email": "по электронной почте",
      "customer_portal.write_reply": "Написать ответ",
      "customer_portal.you": "Вы",
      "customer_tickets_summary": "{{open}} откр. / {{total}} всего",
      "customers": "Клиенты",
      "customize": "Настроить",
      "dark_mode": "Темная тема",
      "dashboard": "Панель управления",
      "dashboard_sub": "Здесь представлены ваши операционные показатели, статус SLA и статистика тикетов.",
      "days_ago": "{{count}} дн. назад",
      "delete": "Удалить",
      "density": "Плотность:",
      "density_comfort_label": "Komfort",
      "density_comfortable": "Обычный",
      "density_compact": "Компактный",
      "density_spacious": "Просторный",
      "density_standard_label": "Standard",
      "device_actions": "Geräte & Lizenzen",
      "device_actions_hint": "Fernwartung, Remote-Terminal, Behebung und Lizenzen der verknüpften Geräte",
      "document.all": "Все",
      "document.category.certificate": "Сертификат",
      "document.category.contract": "Договор",
      "document.category.correspondence": "Переписка",
      "document.category.general": "Общее",
      "document.category.invoice": "Счёт",
      "document.category.manual": "Инструкция",
      "document.category.report": "Отчёт",
      "document.none_found": "Документы не найдены",
      "document.none_found_desc": "Попробуйте другой поисковый запрос",
      "document.none_shared": "Для Вас пока не открыт доступ ни к одному документу",
      "document.none_shared_desc": "Ваш контактный менеджер может размещать здесь документы для Вас",
      "document.plural": "Документы",
      "document.search_placeholder": "Поиск по документам...",
      "document.singular": "Документ",
      "document.subtitle": "Ваши доступные документы, договоры и материалы",
      "document.total_suffix": "всего",
      "domains": "Домены",
      "draft_present": "Черновик",
      "draft_saved": "Черновик сохранен",
      "drag_to_move": "{{label}} (перетащите для перемещения)",
      "drag_to_sort": "Перетаскивайте для сортировки, кликайте для скрытия",
      "duration": "Продолжительность (мин.)",
      "duration_minutes": "{{count}} мин.",
      "edit": "Редактировать",
      "edit_customer": "Редактировать клиента",
      "edit_master_data_admin": "Редактировать основные данные в администрировании",
      "edit_widgets_title": "Показать и упорядочить виджеты",
      "email": "Эл. почта",
      "email_channel": "Канал эл. почты",
      "employee_form.account_erstellt": "Учётная запись создана:",
      "employee_form.bitte_zuerst_kunde_auswaehlen": "Сначала выберите клиента",
      "employee_form.dieser_mitarbeiter_hat_noch_keinen_zugang_zu": "У этого сотрудника ещё нет доступа к клиентскому порталу. Создайте учётную запись с паролем.",
      "employee_form.domain_waehlen": "Выберите домен",
      "employee_form.domains_werden_geladen": "Загрузка доменов...",
      "employee_form.e_mail_server_nicht_konfiguriert": "Почтовый сервер не настроен",
      "employee_form.initialpasswort_vergeben": "Задайте начальный пароль...",
      "employee_form.interne_notizen_zum_mitarbeiter": "Внутренние заметки о сотруднике...",
      "employee_form.kein_portal_zugang_vorhanden": "Доступ к порталу отсутствует",
      "employee_form.keine_domains_fuer_diesen_kunden_hinterlegt": "Для этого клиента не заданы домены.",
      "employee_form.kunde_auswaehlen": "Выберите клиента",
      "employee_form.lade_account_informationen": "Загрузка данных учётной записи...",
      "employee_form.leer_lassen_wenn_kein_portal_zugang_benoetig": "Оставьте пустым, если доступ к порталу не нужен (например, при SSO).",
      "employee_form.letzter_login": "Последний вход:",
      "employee_form.neues_passwort": "Новый пароль...",
      "employee_form.neues_passwort_min_8_zeichen": "Новый пароль (мин. 8 символов)",
      "employee_form.passwort_fuer_neuen_account_min_8_zeichen": "Пароль для новой учётной записи (мин. 8 символов)",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge": "Требовать смену пароля при первом входе",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge_2": "Требовать смену пароля при первом входе",
      "employee_form.passwortaenderung_beim_naechsten_login_erzwi": "Требовать смену пароля при следующем входе",
      "employee_form.profilbild_kann_nach_dem_erstellen_hochgelad": "Фото профиля можно загрузить после создания.",
      "employee_form.pw_aenderung_ausstehend": "Ожидается смена пароля",
      "employee_form.reset_link_24h_gueltig": "Ссылка для сброса (действует 24 ч):",
      "employee_form.tab_access": "Клиентский портал",
      "employee_form.tab_it": "ИТ и рабочее место",
      "employee_form.tab_notes": "Заметки",
      "employee_form.tab_personal": "Персональные данные",
      "employee_form.tab_work": "Работа и контакты",
      "employee_form.weitere_it_informationen_wie_betriebssystem": "Дополнительные ИТ-сведения, например операционную систему и установленное ПО, можно указать в заметках.",
      "employee_form.z_b_koeln_buero_3_og": "например, Кёльн, офис на 3-м этаже",
      "employees": "Сотрудники",
      "employees_ca": "Сотрудники (прибл.)",
      "end_edit": "Закончить редактирование",
      "enter_title_error": "Пожалуйста, введите название.",
      "escalate": "Эскалировать",
      "escalated": "Эскалированные",
      "escalated_badge": "Эскалирован",
      "expand_sidebar": "Развернуть боковую панель",
      "expired": "Истек",
      "expires_at": "Истекает",
      "expiring_soon": "Скоро истекает",
      "export_csv": "Файл CSV",
      "export_pdf": "Документ PDF",
      "export_png": "Диаграмма PNG",
      "export_xlsx": "Excel (XLSX)",
      "filter_active": "Фильтр активен",
      "filter_all_az": "Все А–Я",
      "filter_list_placeholder": "Фильтровать список...",
      "filter_open_first": "Сначала открытые",
      "filter_open_only": "Только с открытыми",
      "filter_with_sla": "С уровнем SLA",
      "first_post_attachments": "Вложения к первому сообщению",
      "first_response": "Первый ответ",
      "follow_ups": "Ожидание клиента",
      "generating": "Генерация...",
      "greeting_day": "Добрый день, {{name}} 👋",
      "held_review": "Требуется проверка",
      "high_priority": "Высокий приоритет",
      "hours": "Часы",
      "hours_ago": "{{count}} ч. назад",
      "inactive": "Неактивен",
      "included_hours": "Вкл. часы",
      "industry": "Отрасль",
      "internal": "Внутренний",
      "internal_chat": "Внутренний чат",
      "internal_note": "Внутренняя заметка",
      "internal_notes": "Внутренние заметки",
      "internal_notes_placeholder": "Внутренние заметки о клиенте...",
      "invalid_datetime_error": "Неверная дата или время.",
      "just_now": "Только что",
      "kb.all_articles": "Все статьи",
      "kb.author": "Автор",
      "kb.back_to_overview": "Назад к обзору",
      "kb.browse_more": "← Смотреть другие статьи",
      "kb.no_articles": "Статьи базы знаний пока недоступны",
      "kb.no_articles_desc": "Здесь скоро появятся полезные статьи",
      "kb.pinned": "Закреплено",
      "kb.read_time": "{{count}} мин. чтения",
      "kb.search_placeholder": "Что Вы ищете? Например, VPN, пароль, электронная почта...",
      "kb.subtitle": "Инструкции, советы и помощь по Вашим вопросам",
      "kb.try_different_search": "Попробуйте другой поисковый запрос",
      "kb.updated_at": "Обновлено {{date}}",
      "kb.views_count": "{{count}} просмотров",
      "keyboard_shortcuts": "Горячие клавиши",
      "knowledge": "База знаний",
      "knowledge_base": "База знаний",
      "kpi_held": "Отправитель не определён",
      "kpi_important": "важно",
      "kpi_open": "открыто",
      "kpi_sla_breached": "Нарушение SLA",
      "kunde_loeschen.artikel": "Wissensartikel",
      "kunde_loeschen.bestaetigung_label": "Zur Bestätigung den Firmennamen eingeben",
      "kunde_loeschen.connectoren": "Connectoren",
      "kunde_loeschen.dokumente": "Dokumente",
      "kunde_loeschen.einleitung": "Dieser Kunde hat keine Tickets und keine Rechnungen. Er kann vollständig entfernt werden — mitsamt seinem Mandantenbereich in der Datenbank. Das lässt sich nicht rückgängig machen.",
      "kunde_loeschen.endgueltig_loeschen": "Endgültig löschen",
      "kunde_loeschen.fehlgeschlagen": "Das Löschen ist fehlgeschlagen.",
      "kunde_loeschen.geraete": "Geräte im Inventar",
      "kunde_loeschen.lizenzen": "Softwarelizenzen",
      "kunde_loeschen.mitarbeiter": "Mitarbeiter",
      "kunde_loeschen.netzgeraete": "Gefundene Netzwerkgeräte",
      "kunde_loeschen.nichts_dran": "An diesem Kunden hängen keine weiteren Daten.",
      "kunde_loeschen.portalbenutzer": "Portalzugänge",
      "kunde_loeschen.pruefung_fehlgeschlagen": "Die Prüfung ist fehlgeschlagen.",
      "kunde_loeschen.titel": "Kunde endgültig löschen",
      "kunde_loeschen.tokens": "API-Token",
      "kunde_loeschen.vertraege": "Verträge",
      "kunde_loeschen.wird_geprueft": "Wird geprüft …",
      "kunde_loeschen.wird_mitgeloescht": "Wird mitgelöscht",
      "kunde_loeschen.zeiten": "Zeiteinträge",
      "language": "Язык",
      "license.cluster_audit": "Аудит",
      "license.cluster_balance": "Баланс",
      "license.cluster_calc": "Калькулятор",
      "license.cluster_contracts": "Договоры и лицензии",
      "license.cluster_optimize": "Оптимизация",
      "license.tab_ad_coupling": "Связка CAL-AD",
      "license.tab_cal_calc": "Калькулятор CAL",
      "license.tab_catalog": "Каталог ПО",
      "license.tab_contracts": "Договоры",
      "license.tab_dashboard": "Баланс лицензий и Тренды",
      "license.tab_licenses": "Управление лицензиями",
      "license.tab_more_views": "Другие виды",
      "license.tab_reclaims": "Оптимизация и Возврат",
      "license.tab_remediation": "Исправление",
      "license.tab_sealed": "Архив аудитов",
      "license.tab_sql_calc": "Калькулятор лицензий SQL",
      "license.tab_steering": "Управление",
      "license.tab_suite_config": "Конфигуратор пакетов",
      "license_compliance.actions": "Действия",
      "license_compliance.assign_license_metric": "Назначить метрику лицензирования",
      "license_compliance.confirm_delete_assignment": "Действительно удалить назначение?",
      "license_compliance.confirm_delete_contract": "Действительно удалить договор? Связанные лицензии сохранятся, но будут отвязаны от договора.",
      "license_compliance.contract_expiry_alert": "Истечение срока договора",
      "license_compliance.deficit_forecast_desc": "По данным актуальных сканирований к годовщине возникнут доплаты за продукты с недостаточным лицензированием.",
      "license_compliance.edit_contract": "Изменить договор",
      "license_compliance.edit_license": "Изменить лицензию",
      "license_compliance.expired_contracts_title": "Обнаружены истёкшие договоры на ПО!",
      "license_compliance.expired_contracts_warning_desc": "Лицензии, привязанные к этим договорам, не учитываются при расчёте соответствия.",
      "license_compliance.forecasted_payment": "Прогнозируемая доплата",
      "license_compliance.license_deficit_alert": "Дефицит лицензий",
      "license_compliance.mark_license_required_btn": "Отметить как требующее лицензии",
      "license_compliance.new_contract": "Создать договор",
      "license_compliance.new_license": "Создать лицензию",
      "license_compliance.no_deficit_desc": "Поздравляем! Ваши назначения Microsoft Core/CAL покрывают все результаты сканирования.",
      "license_compliance.not_catalogued": "Не каталогизировано",
      "license_compliance.reconciliation_desc": "Запускает ручной цикл сверки для этого арендатора. Заново рассчитывает в реальном времени VM-стекинг, состояние WMI-обнаружения, периоды Software Assurance и сроки действия договоров.",
      "license_compliance.reconciliation_running": "Выполняется сверка...",
      "license_compliance.run_reconciliation": "Выполнить сверку",
      "license_compliance.sam_warnings_title": "Предупреждения SAM и соответствие требованиям",
      "license_compliance.save_contract": "Сохранить договор",
      "license_compliance.save_license": "Сохранить лицензию",
      "license_compliance.seal_audit": "Опечатать аудит",
      "license_compliance.seal_audit_btn": "Опечатать юридически значимо",
      "license_compliance.sealing": "Выполняется опечатывание...",
      "license_compliance.toast.add_suite_component_error": "Ошибка при привязке компонента пакета",
      "license_compliance.toast.assignment_completed": "Назначение лицензии выполнено успешно.",
      "license_compliance.toast.assignment_error": "Ошибка при выполнении назначения",
      "license_compliance.toast.bulk_classify_error": "Ошибка при массовой классификации",
      "license_compliance.toast.bulk_classify_success": "Успешно классифицировано записей ПО: {{count}}.",
      "license_compliance.toast.calc_audit_error": "Ошибка при расчёте аудита лицензий",
      "license_compliance.toast.contract_created": "Договор успешно создан.",
      "license_compliance.toast.contract_deleted": "Договор удалён.",
      "license_compliance.toast.contract_updated": "Договор успешно обновлён.",
      "license_compliance.toast.create_purchase_req_error": "Ошибка при создании заявки на закупку",
      "license_compliance.toast.delete_contract_error": "Ошибка при удалении договора",
      "license_compliance.toast.delete_license_error": "Ошибка при удалении лицензии",
      "license_compliance.toast.delete_suite_component_error": "Ошибка при удалении привязки",
      "license_compliance.toast.license_created": "Лицензия успешно создана.",
      "license_compliance.toast.license_deleted": "Лицензия удалена.",
      "license_compliance.toast.license_updated": "Лицензия успешно обновлена.",
      "license_compliance.toast.load_customers_error": "Ошибка при загрузке списка клиентов",
      "license_compliance.toast.purchase_req_created": "Заявка на закупку {{units}}x {{model}} (True-Up: {{cost}}) создана как заявка {{ticket}}.",
      "license_compliance.toast.reconcile_completed": "Сверка успешно завершена. Показатели соответствия пересчитаны в реальном времени.",
      "license_compliance.toast.reconcile_error": "Ошибка при сверке",
      "license_compliance.toast.sam_settings_saved": "Настройки SAM успешно сохранены.",
      "license_compliance.toast.save_contract_error": "Ошибка при сохранении договора",
      "license_compliance.toast.save_license_error": "Ошибка при сохранении лицензии",
      "license_compliance.toast.save_sam_settings_error": "Ошибка при сохранении настроек SAM",
      "license_compliance.toast.seal_audit_error": "Ошибка при опечатывании аудита лицензий",
      "license_compliance.toast.seal_audit_success": "Аудит лицензий успешно опечатан.",
      "license_compliance.toast.suite_component_added": "Компонент успешно привязан к пакету.",
      "license_compliance.toast.suite_component_deleted": "Привязка удалена.",
      "license_compliance.toast.uninstall_error": "Ошибка при запуске удаления программ",
      "license_compliance.toast.uninstall_triggered": "Команды на удаление поставлены в очередь.",
      "license_compliance.update_contract": "Обновить договор",
      "license_compliance.update_license": "Обновить лицензию",
      "licenses": "Лицензии",
      "light_mode": "Светлая тема",
      "link_asset_btn": "+ Привязать актив",
      "live_activity": "Живая активность",
      "loading": "Wird geladen…",
      "loading_ellipsis": "Загрузка...",
      "location_on_map": "Местоположение на карте",
      "login.abbrechen": "Отмена",
      "login.administratoradresse_konnte_nicht_geaendert_werden": "Die Administratoradresse konnte nicht geändert werden.",
      "login.adresse_aendern": "Adresse ändern",
      "login.adresse_wird_geaendert": "Adresse wird geändert…",
      "login.aendern": "Изменить",
      "login.aktivierung": "Активация…",
      "login.aktivierung_fehlgeschlagen_code_pruefen": "Не удалось активировать. Проверьте код.",
      "login.alle_rechte_vorbehalten": "· Все права защищены.",
      "login.anmelden": "Войти",
      "login.anmelden_laeuft": "Вход…",
      "login.anmeldung": "Вход…",
      "login.bestaetigen": "Подтвердить",
      "login.bitte_geben_sie_eine_gueltige_e_mail_adresse": "Введите действительный адрес эл. почты.",
      "login.bitte_geben_sie_ihr_passwort_ein": "Введите пароль.",
      "login.bitte_geben_sie_zuerst_ihre_e_mail_adresse_e": "Сначала введите адрес эл. почты.",
      "login.claim": "Служба поддержки, оборудование и лицензии — одна база данных, один процесс.",
      "login.datenschutz": "Конфиденциальность",
      "login.e_mail_adresse_erfolgreich_geaendert": "E-Mail-Adresse erfolgreich geändert. Melden Sie sich jetzt mit der neuen Adresse an.",
      "login.ein_fehler_ist_aufgetreten": "Произошла ошибка.",
      "login.einloggen_schliessen": "Войти и закрыть",
      "login.erstanmeldung": "Первый вход:",
      "login.falls_ein_konto_existiert_wurde_eine_e_mail": "Если учётная запись существует, письмо для сброса пароля отправлено.",
      "login.fehler_beim_laden_des_mfa_setups": "Не удалось загрузить настройку MFA",
      "login.fehler_beim_ueberpruefen_der_e_mail_adresse": "Не удалось проверить адрес электронной почты.",
      "login.geben_sie_den_6_stelligen_code_aus_ihrer_aut": "Введите 6-значный код из приложения-аутентификатора или код восстановления.",
      "login.geschaeftliche_e_mail": "Рабочая почта",
      "login.ihr_account_ist_deaktiviert": "Ваша учётная запись деактивирована.",
      "login.ihr_administrator_erfordert_die_einrichtung": "Ваш администратор требует настроить двухфакторную аутентификацию.",
      "login.impressum": "Правовая информация",
      "login.kunden_account_erkannt": "Обнаружена учётная запись клиента",
      "login.manueller_schluessel": "Ключ для ручного ввода",
      "login.melden_sie_sich_an_ihrem_service_desk_an": "Войдите в свою службу поддержки.",
      "login.mfa_aktivieren_weiter": "Включить MFA и продолжить",
      "login.mfa_einrichtung_erforderlich": "Требуется настройка MFA",
      "login.mfa_einrichtung_fehlgeschlagen": "Не удалось настроить MFA.",
      "login.mfa_erfolgreich_aktiviert": "MFA успешно включена",
      "login.neue_geschaeftliche_e_mail": "Neue geschäftliche E-Mail",
      "login.oder": "ИЛИ",
      "login.passwort": "Пароль",
      "login.qr_code_fuer_die_authenticator_app": "QR-код для приложения-аутентификатора",
      "login.sechsstelliger_verifizierungscode": "6-значный код подтверждения",
      "login.sende": "Отправка…",
      "login.sicherheitszeile": "AES-256 · Двухфакторная защита · Размещение на своих серверах",
      "login.sicherheitszeile_kurz": "AES-256 · Zwei-Faktor",
      "login.sie_werden_automatisch_zum_kundenportal_weit": "Вы будете автоматически перенаправлены на клиентский портал для входа...",
      "login.single_sign_on_entra_id": "Single Sign-On (Entra ID)",
      "login.speichern_sie_diese_einmal_wiederherstellung": "Надёжно сохраните эти одноразовые коды восстановления! Они пригодятся, если Вы потеряете доступ к своему приложению.",
      "login.sso_anmeldung_fehlgeschlagen": "Не удалось войти через SSO",
      "login.startkonto_bestaetigt_adresse_festlegen": "Die Zugangsdaten des Startkontos wurden bestätigt. Legen Sie jetzt die geschäftliche Adresse für den Administrator fest.",
      "login.ueberpruefe": "Проверка...",
      "login.ungueltiger_oder_abgelaufener_mfa_code": "Неверный или истёкший код MFA.",
      "login.verifiziere": "Проверка…",
      "login.weiter": "Далее",
      "login.willkommen_zurueck": "С возвращением",
      "login.zurueck_zum_login": "Назад ко входу",
      "login.zuruecksetzen": "Сбросить",
      "login.zwei_faktor_code_totp": "Код двухфакторной защиты (TOTP)",
      "logout": "Выйти",
      "main_navigation_rail": "Главная панель навигации",
      "managing_director": "Генеральный директор",
      "managing_director_abbrev": "ГД",
      "managing_director_prefix": "Руководство:",
      "mark_all_read": "Отметить все как прочитанные",
      "mark_as_resolved": "Отметить как решенный",
      "mati.connection_error": "Ошибка соединения",
      "mati.delete": "Удалить",
      "mati.error_failed_connection": "Не удалось подключиться к сервису ИИ.",
      "mati.error_generation": "Ошибка при генерации ответа. Пожалуйста, попробуйте ещё раз.",
      "mati.gdpr_warning": "Фильтр GDPR активен: персональные данные автоматически обезличиваются перед передачей.",
      "mati.greeting": "Привет, {{name}}! Я — {{mascot}}. Чем помочь тебе в работе сегодня? 🔮\\n\\nТы можешь спросить меня о:\\n- Состоянии системы или загрузке агентов\\n- Поиске заявок («Найди нерешённые заявки с высоким приоритетом»)\\n- Создании заявок («Создай заявку: закончился картридж принтера на 2-м этаже»)",
      "mati.history": "История",
      "mati.input_placeholder": "Спросите меня о заявках, загрузке или создайте заявку...",
      "mati.new_chat": "Новый чат",
      "mati.online_intelligent": "В сети и готов помочь",
      "mati.rename": "Переименовать",
      "mati.restore_bead": "Показать плавающего помощника",
      "mati.restore_bead_tooltip": "Снова показать плавающего помощника (Bead) у края экрана",
      "mati.send_btn": "Отправить",
      "mati.suggest.create_ticket.desc": "Неисправен принтер на 1-м этаже",
      "mati.suggest.create_ticket.prompt": "Создай заявку о неисправном принтере на 1-м этаже, приоритет средний.",
      "mati.suggest.create_ticket.title": "Создать заявку",
      "mati.suggest.search_tickets.desc": "Поисковый запрос «база данных»",
      "mati.suggest.search_tickets.prompt": "Найди заявки, содержащие слово «база данных».",
      "mati.suggest.search_tickets.title": "Поиск заявок",
      "mati.suggest.support_help.desc": "Помощь в подготовке ответов для FAQ",
      "mati.suggest.support_help.prompt": "Как вежливо сформулировать отказ на запрос о возврате средств?",
      "mati.suggest.support_help.title": "Помощь поддержки",
      "mati.suggest.system_status.desc": "Показать текущую загрузку",
      "mati.suggest.system_status.prompt": "Покажи текущее состояние системы и обзор загрузки агентов.",
      "mati.suggest.system_status.title": "Состояние системы",
      "mati.typing_text": "{{name}} печатает...",
      "mati.welcome_subtitle": "Я — твой интеллектуальный ИИ-помощник. Я помогу тебе управлять заявками, искать в системе и просматривать статистику системы.",
      "mati.welcome_title": "Здравствуйте! Я — {{name}}",
      "mati_gdpr_warning": "Фильтр GDPR активен: Личные данные автоматически анонимизируются перед отправкой.",
      "mati_placeholder": "Спроси меня о тикетах, нагрузке или создай тикет...",
      "mati_welcome": "Привет! Я {{name}}",
      "meeting_error_title": "Не удалось создать встречу Teams.",
      "meeting_success": "Встреча Teams создана.",
      "meeting_success_copy": "Встреча Teams создана, ссылка скопирована в буфер обмена.",
      "megamenu.active_label": "Работа",
      "megamenu.calendar_desc": "Встречи и интеграция с календарём.",
      "megamenu.licenses_desc": "Соответствие лицензий, пакеты и планирование True-Up.",
      "megamenu.modules": "Модули",
      "megamenu.open_calendar": "Открыть календарь",
      "megamenu.open_licenses": "Открыть лицензии",
      "megamenu.open_problems": "Открыть проблемы",
      "megamenu.problems_desc": "Управление проблемами и RCA (анализ первопричин).",
      "megamenu.quick_search_commands": "Быстрый поиск и команды",
      "merge": "Zusammenführen",
      "merge_tickets": "Die beiden markierten Tickets zusammenführen",
      "mfa_settings": "Настройки MFA",
      "minutes_ago": "{{count}} мин. назад",
      "mloffice.abgleich_fehler": "Abgleich konnte nicht gestartet werden.",
      "mloffice.abgleich_fehlgeschlagen": "Letzter Abgleich fehlgeschlagen: {{fehler}}",
      "mloffice.abgleich_gestartet": "Voll-Abgleich gestartet.",
      "mloffice.abgleich_laeuft": "Abgleich läuft",
      "mloffice.adresse": "MLOffice-Adresse",
      "mloffice.adresse_hinweis": "Basisadresse der MLOffice-Installation — ohne /api/v1.",
      "mloffice.agenten_titel": "Agenten ↔ MLOffice-Benutzer",
      "mloffice.aktion_anlegen": "Neu anlegen",
      "mloffice.aktion_entkoppeln": "Entkoppeln",
      "mloffice.aktion_entkoppeln_hinweis": "Aus dem Abgleich nehmen — der Kunde bleibt bestehen und wird wieder editierbar.",
      "mloffice.aktion_verknuepfen": "Verknüpfen",
      "mloffice.aktiv": "Aktiv",
      "mloffice.aktivieren": "Anbindung aktiv",
      "mloffice.auswahl_fehler": "Auswahl konnte nicht gespeichert werden.",
      "mloffice.bereits_uebertragen": "{{n}} Einträge im Zeitraum sind bereits übertragen und werden übersprungen.",
      "mloffice.email_eingeben": "Der Partner hat in MLOffice keine E-Mail-Adresse. E-Mail für den neuen Kunden:",
      "mloffice.entwurf_anlegen": "Entwurf anlegen",
      "mloffice.entwurf_fehler": "Entwurf konnte nicht angelegt werden.",
      "mloffice.entwurf_hinweis": "Erzeugt aus den bereits übertragenen Zeiten des Zeitraums einen ENTWURF in MLOffice. Belegnummer, Festschreibung und Versand bleiben MLOffice vorbehalten.",
      "mloffice.entwurf_ok": "Entwurf über {{h}} h in MLOffice angelegt — Festschreiben und Versand dort.",
      "mloffice.entwurf_titel": "Rechnungsentwurf in MLOffice",
      "mloffice.ereignis_closed": "Ticket geschlossen",
      "mloffice.ereignis_created": "Ticket eröffnet",
      "mloffice.ereignis_escalated": "Ticket eskaliert",
      "mloffice.ereignisse_titel": "Ticket-Ereignisse in die MLOffice-Kontakthistorie melden (nur Referenz, nie Inhalt):",
      "mloffice.erst_aktivieren": "Bitte zuerst die Anbindung aktivieren und die Verbindung testen — dann erscheint hier der MLOffice-Kundenbestand.",
      "mloffice.erst_aktivieren_abrechnung": "Bitte zuerst die Anbindung aktivieren — dann erscheinen hier offene Posten und der Kontingent-Abgleich.",
      "mloffice.erst_aktivieren_zeiten": "Bitte zuerst die Anbindung aktivieren — dann lassen sich Zeiten per Übertragungslauf nach MLOffice geben.",
      "mloffice.fallback_hinweis": "{{n}} Einträge ohne Agenten-Zuordnung werden über den technischen Benutzer gebucht (Agentenname in der Beschreibung).",
      "mloffice.feld_bis": "Bis",
      "mloffice.feld_kunde": "Kunde",
      "mloffice.feld_projekt": "MLOffice-Projekt",
      "mloffice.feld_satz": "Stundensatz (netto)",
      "mloffice.feld_von": "Von",
      "mloffice.gespeichert": "MLOffice-Einstellungen gespeichert.",
      "mloffice.gueltig_180": "180 Tage",
      "mloffice.gueltig_365": "365 Tage",
      "mloffice.gueltig_90": "90 Tage",
      "mloffice.gueltig_unbegrenzt": "Unbegrenzt",
      "mloffice.hoheit_frage": "MLOffice übernimmt die Hoheit über: {{felder}}.\\n\\nDiese Felder sind in AISupportDesk dann gesperrt und werden fortlaufend aus MLOffice übernommen. Fortfahren?",
      "mloffice.inaktiv": "Inaktiv",
      "mloffice.keine_partner": "Noch keine MLOffice-Kunden geladen. „Liste aus MLOffice laden“ holt den Bestand.",
      "mloffice.keine_zuordnung": "— keine Zuordnung —",
      "mloffice.konflikt_fehler": "Konnte nicht übernommen werden.",
      "mloffice.konflikt_geloest": "Übernommen.",
      "mloffice.konflikt_hinweis": "Übernahme braucht eine Entscheidung — siehe Konfliktzeile.",
      "mloffice.kopieren": "Kopieren",
      "mloffice.kunde_waehlen": "— Kunde wählen —",
      "mloffice.kunden_erklaerung": "Wähle aus, welche MLOffice-Kunden hier geführt werden. Ausgewählte Kunden werden fortlaufend abgeglichen; ihre Stammdaten sind hier gesperrt. Abwählen entkoppelt nur — der Kunde bleibt bestehen.",
      "mloffice.laden_fehler": "MLOffice-Einstellungen konnten nicht geladen werden.",
      "mloffice.laeufe_titel": "Bisherige Übertragungsläufe",
      "mloffice.lauf_detail": "Lauf #{{id}} — Einzelposten",
      "mloffice.lauf_fehler": "Lauf konnte nicht gestartet werden.",
      "mloffice.lauf_fertig": "Fertig",
      "mloffice.lauf_gestartet": "Übertragungslauf gestartet.",
      "mloffice.lauf_laeuft": "Läuft",
      "mloffice.lauf_starten": "Übertragung starten",
      "mloffice.lauf_teilfehler": "Mit Fehlern",
      "mloffice.linktoken_abgelaufen": "Das Verbindungstoken ist abgelaufen — MLOffice kann sich nicht mehr ausweisen. Neues Token erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_ablauf_teil": ", gültig bis {{datum}}",
      "mloffice.linktoken_einmal": "Jetzt kopieren — dieses Token wird nur EINMAL angezeigt:",
      "mloffice.linktoken_eintragen": "In MLOffice unter Einstellungen → AISupportDesk-Anbindung eintragen.",
      "mloffice.linktoken_erklaerung": "Dieses Token wird HIER erzeugt und in MLOffice unter „AISupportDesk-Anbindung“ eingetragen. MLOffice weist sich damit aus (Verbindungsstatus, Webhooks). Wird die Anbindung hier gelöst oder das Token widerrufen, zeigt MLOffice die Verbindung als gelöst.",
      "mloffice.linktoken_erzeugen": "Token erzeugen",
      "mloffice.linktoken_fehler": "Verbindungstoken konnte nicht erzeugt werden.",
      "mloffice.linktoken_gueltigkeit": "Gültigkeit",
      "mloffice.linktoken_kopiert": "Token kopiert.",
      "mloffice.linktoken_laeuft_ab": "Das Verbindungstoken läuft in {{tage}} Tagen ab. Rechtzeitig neu erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_neu": "Neues Token erzeugen",
      "mloffice.linktoken_rotieren_frage": "Es existiert bereits ein Verbindungstoken. Ein neues macht das alte sofort ungültig — MLOffice muss dann das neue Token eintragen. Fortfahren?",
      "mloffice.linktoken_status": "Hinterlegt ({{hint}}), erzeugt {{erzeugt}}{{ablauf}}.",
      "mloffice.linktoken_titel": "Verbindungstoken für MLOffice",
      "mloffice.linktoken_unbegrenzt_teil": ", unbegrenzt gültig",
      "mloffice.linktoken_widerruf_fehler": "Widerruf fehlgeschlagen.",
      "mloffice.linktoken_widerruf_frage": "Verbindungstoken widerrufen? MLOffice zeigt die Verbindung danach als gelöst; Webhooks und Statusabfragen von MLOffice werden abgewiesen.",
      "mloffice.linktoken_widerrufen": "Verbindungstoken widerrufen.",
      "mloffice.linktoken_widerrufen_btn": "Widerrufen",
      "mloffice.liste_aktualisieren": "Liste aus MLOffice laden",
      "mloffice.loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "mloffice.nur_verknuepfte": "Nur mit MLOffice verknüpfte Kunden.",
      "mloffice.ohne_email": "ohne E-Mail",
      "mloffice.op_aktualisiert": "Offene Posten aktualisiert.",
      "mloffice.op_belege": "Belege",
      "mloffice.op_fehler": "Offene Posten konnten nicht geladen werden.",
      "mloffice.op_laden": "Offene Posten aus MLOffice laden",
      "mloffice.op_stand": "Stand: {{zeit}}",
      "mloffice.op_titel": "Offene Posten (MLOffice)",
      "mloffice.partner_laden_fehler": "MLOffice-Kundenliste konnte nicht geladen werden.",
      "mloffice.posten_ok": "übertragen",
      "mloffice.posten_retry": "Erneut",
      "mloffice.posten_skip": "Überspringen",
      "mloffice.projekt_pflicht": "Bitte oben ein MLOffice-Projekt wählen.",
      "mloffice.projekt_waehlen": "— Projekt wählen —",
      "mloffice.rechte_fehlen": "Dem Token fehlen Rechte:",
      "mloffice.recon_asd": "Support-Sicht (NALVRA SERVICE)",
      "mloffice.recon_diff": "Abweichung Support- zu Abrechnungs-Sicht: {{min}} Min.",
      "mloffice.recon_gebucht": "{{min}} Min. im Projekt „{{projekt}}“ gebucht",
      "mloffice.recon_gesperrt_bis": "Erfassung gesperrt bis: {{d}}",
      "mloffice.recon_kein_projekt": "Kein MLOffice-Projekt zugeordnet (Tab „Zuordnung“).",
      "mloffice.recon_kein_vertrag": "Kein aktiver Vertrag mit Kontingent für diesen Kunden.",
      "mloffice.recon_mlo": "Abrechnungs-Sicht (MLOffice)",
      "mloffice.recon_offen": "{{min}} Min. der laufenden Periode sind noch nicht an MLOffice übertragen — Übertragungslauf im Tab „Zeiten-Übertragung“ starten.",
      "mloffice.recon_titel": "Kontingent-Abgleich",
      "mloffice.recon_verbrauch": "{{used}} von {{incl}} Min. verbraucht — {{rest}} Min. übrig",
      "mloffice.schon_drueben": "übertragen",
      "mloffice.sp_agent": "Agent",
      "mloffice.sp_beschreibung": "Beschreibung",
      "mloffice.sp_datum": "Datum",
      "mloffice.sp_fortschritt": "Gesendet / Fehler / Gesamt",
      "mloffice.sp_kunde": "Kunde",
      "mloffice.sp_minuten": "Min.",
      "mloffice.sp_status": "Status",
      "mloffice.sp_ticket": "Ticket",
      "mloffice.sp_zeitraum": "Zeitraum",
      "mloffice.spalte_kunde": "MLOffice-Kunde",
      "mloffice.spalte_status": "Status",
      "mloffice.spalte_sync": "Sync",
      "mloffice.spalte_zuordnung": "Zuordnung in NALVRA SERVICE",
      "mloffice.speichern": "Speichern",
      "mloffice.speichern_fehler": "Speichern fehlgeschlagen.",
      "mloffice.status_archiviert": "In MLOffice archiviert",
      "mloffice.status_delta": "Letzter Kundenabgleich: {{zeit}}",
      "mloffice.status_entkoppelt": "Entkoppelt",
      "mloffice.status_failed": "{{n}} Übertragungen fehlgeschlagen",
      "mloffice.status_kein_linktoken": "Kein Verbindungstoken für MLOffice erzeugt",
      "mloffice.status_konflikt": "Entscheidung nötig",
      "mloffice.status_linktoken_abgelaufen": "Verbindungstoken abgelaufen — neu erzeugen und in MLOffice eintragen",
      "mloffice.status_neu": "Neu",
      "mloffice.status_op": "Offene Posten: {{zeit}}",
      "mloffice.status_pending": "{{n}} Übertragungen offen",
      "mloffice.status_ratelimit": "MLOffice-Ratenbegrenzung — kurze Pause",
      "mloffice.status_sync_fehler": "Letzter Abgleich mit Fehler",
      "mloffice.status_uebernommen": "Übernommen",
      "mloffice.tab_abrechnung": "Abrechnung",
      "mloffice.tab_kunden": "Kundenabgleich",
      "mloffice.tab_verbindung": "Verbindung",
      "mloffice.tab_zeiten": "Zeiten-Übertragung",
      "mloffice.tab_zuordnung": "Zuordnung",
      "mloffice.techuser_hinweis": "Wird für Zeitbuchungen ohne Agenten-Zuordnung verwendet; der Agentenname wandert dann in die Buchungsbeschreibung.",
      "mloffice.techuser_titel": "Technischer Benutzer (Fallback)",
      "mloffice.test_fehler": "Verbindungstest fehlgeschlagen.",
      "mloffice.test_nicht_verbunden": "Keine Verbindung",
      "mloffice.test_ok": "Verbindung zu MLOffice steht.",
      "mloffice.test_verbunden": "Verbunden mit Mandant „{{tenant}}“",
      "mloffice.testen": "Verbindung testen",
      "mloffice.titel": "MLOffice-Anbindung",
      "mloffice.token": "API-Token",
      "mloffice.token_gesetzt": "hinterlegt ({{hint}})",
      "mloffice.token_hinweis": "In MLOffice unter Einstellungen → API-Tokens anlegen. Benötigte Rechte prüft der Verbindungstest.",
      "mloffice.token_name": "Token: {{name}}",
      "mloffice.token_unveraendert": "Leer lassen = unverändert",
      "mloffice.untertitel": "Kundenstammdaten, Abrechnung, Zeiterfassung und CRM mit MLOffice koppeln. MLOffice ist das führende System für Stammdaten und Rechnungen.",
      "mloffice.users_dropdown": "Zeitbuchungen werden in MLOffice unter dem zugeordneten Benutzer geführt. Ohne Zuordnung greift der technische Benutzer.",
      "mloffice.users_manuell": "MLOffice stellt (noch) keine Benutzerliste bereit — MLOffice-User-UUID bitte manuell eintragen (in MLOffice unter Benutzerverwaltung kopieren).",
      "mloffice.uuid_platzhalter": "MLOffice-User-UUID",
      "mloffice.verbindung": "Verbindung",
      "mloffice.vollabgleich": "Voll-Abgleich starten",
      "mloffice.vorschau": "Vorschau",
      "mloffice.vorschau_anlegen": "Wird neu angelegt",
      "mloffice.vorschau_email_fehlt": "E-Mail fehlt — wird bei Übernahme abgefragt",
      "mloffice.vorschau_fehler": "Vorschau fehlgeschlagen.",
      "mloffice.vorschau_titel": "Vorschau: {{n}} Einträge, {{h}} h werden übertragen",
      "mloffice.vorschau_verknuepfung": "Vorschlag: mit „{{name}}“ verknüpfen ({{grund}})",
      "mloffice.zeiten_erklaerung": "Zeiten werden NICHT automatisch übertragen. Du wählst Kunde und Zeitraum, prüfst die Vorschau und bestätigst — erst dann gehen die Buchungen nach MLOffice. Übertragene Buchungen sind dort unumkehrbar und hier gesperrt.",
      "mloffice.zeitraum_bis_heute": "Bis heute",
      "mloffice.zeitraum_dieser_monat": "Dieser Monat",
      "mloffice.zeitraum_letzter_monat": "Letzter Monat",
      "mloffice.zuordnung_fehler": "Zuordnung konnte nicht gespeichert werden.",
      "mloffice.zuordnung_fehlt": "{{n}} Einträge ohne Agenten-Zuordnung — bitte unter „Zuordnung“ pflegen oder einen technischen Benutzer hinterlegen.",
      "mloffice.zuordnung_gespeichert": "Zuordnung gespeichert.",
      "mobile": "Моб. телефон",
      "move_ticket": "Verschieben",
      "my_tickets": "Мои тикеты",
      "navbar_search_placeholder": "Поиск тикетов, клиентов или базы знаний...",
      "new": "Новый",
      "new_activity_aria": "Новая активность",
      "new_activity_title": "Новая активность с момента последнего просмотра",
      "new_company": "Neue Firma",
      "new_label": "Новый",
      "new_ticket": "Новый тикет",
      "next": "Weiter",
      "no_activities_recorded": "Активность пока не зарегистрирована.",
      "no_canned_responses": "Нет шаблонов ответов",
      "no_canned_responses_hint": "Управление осуществляется в разделе администрирования.",
      "no_critical_tickets": "Нет критических тикетов",
      "no_customer_assigned": "Клиент не назначен",
      "no_customer_data": "Нет данных о клиентах.",
      "no_customers_found": "Клиенты не найдены",
      "no_customers_matching": "Не удалось найти клиентов по выбранным фильтрам или поисковому запросу.",
      "no_data_available": "Нет доступных данных",
      "no_employees_found": "Нет зарегистрированных сотрудников",
      "no_notes_placeholder": "Заметок нет. Нажмите \"Редактировать\", чтобы добавить заметки.",
      "no_notifications": "Нет уведомлений",
      "no_other_agents_online": "В данный момент других членов команды в сети нет.",
      "no_results": "Совпадений не найдено",
      "no_tickets_found": "Тикеты не найдены",
      "no_tickets_found_desc": "В этой очереди фильтрации в данный момент нет элементов.",
      "no_tickets_risk": "В настоящее время нет тикетов в критическом окне предупреждения SLA.",
      "not_spam": "Не спам",
      "notification_settings": "Настройки уведомлений",
      "notification_settings_desc": "Выберите, какие уведомления вы хотите получать.",
      "notification_settings_saved": "Настройки уведомлений сохранены.",
      "notifications": "Уведомления",
      "notify_license_change": "Изменения лицензий",
      "notify_new_reply": "Новые ответы",
      "notify_new_ticket": "Новые тикеты",
      "notify_status_changed": "Изменения статуса",
      "observers_title": "Наблюдатели",
      "only_visible_for": "Только {{name}}",
      "only_visible_to_agents": "Видно только сотрудникам",
      "open_administration": "Открыть администрирование",
      "open_btn": "Открыть",
      "open_password_vault": "Открыть сейф паролей",
      "open_quick_search": "Открыть быстрый поиск",
      "open_tickets": "Открытые тикеты",
      "other_tickets_count": "Другие тикеты ({{count}})",
      "other_tickets_requester_count": "Другие тикеты заявителя ({{count}})",
      "overdue": "Просроченные",
      "overview_option_1": "1. Стандартная панель KPI",
      "overview_option_10": "10. Уровень нарушений SLA по приоритетам",
      "overview_option_2": "2. Доля решений при первом контакте (FCR) и время ответа",
      "overview_option_3": "3. Динамика объема тикетов и пиковые часы",
      "overview_option_4": "4. Тенденции скорости решения (Создано против Решено)",
      "overview_option_5": "5. Матрица удовлетворенности (CSAT) против времени решения",
      "overview_option_6": "6. Каналы тикетов и разбивка источников",
      "overview_option_7": "7. Показатели эскалации и анализ путей эскалации",
      "overview_option_8": "8. Средний жизненный цикл тикета (старение)",
      "overview_option_9": "9. Статус бэклога и старение",
      "performance_queues": "Эффективность и очереди",
      "phone": "Телефон",
      "plan_teams_meeting": "Запланировать встречу Teams",
      "planning": "Планирование",
      "please_enter_text": "Пожалуйста, введите текст",
      "policy": "Политика",
      "portal_company.load_failed": "Dokumente konnten nicht geladen werden.",
      "portal_company.primary_contact": "Hauptansprechpartner",
      "portal_session.continue": "Weiterarbeiten",
      "portal_session.login": "Erneut anmelden",
      "portal_session.warning": "Ihre Sitzung endet in {{seconds}} Sekunden. Gespeicherte Entwürfe bleiben erhalten.",
      "portal_speech.denied": "Mikrofonzugriff oder Spracherkennung wurde nicht erlaubt. Bitte die Browserberechtigung prüfen.",
      "portal_speech.failed": "Spracheingabe nicht verfügbar. Bitte Mikrofon und Verbindung prüfen oder weitertippen.",
      "portal_speech.listening": "Mikrofon aktiv – bitte sprechen …",
      "portal_speech.notice": "Diktierter Text wird unten an die Beschreibung angefügt. Der Browser kann Audio zur Erkennung an seinen Sprachdienst senden.",
      "portal_speech.silence": "Keine Sprache erkannt. Bitte erneut starten.",
      "portal_speech.start": "Diktat starten",
      "portal_speech.stop": "Stoppen",
      "portal_speech.title": "Spracheingabe",
      "portal_speech.unsupported": "Dieser Browser unterstützt hier keine Spracheingabe. Sie können die Diktierfunktion Ihrer Tastatur verwenden.",
      "preview": "Предварительный просмотр",
      "previous": "Zurück",
      "primary": "Первичный",
      "priority": "Приоритет",
      "priority_": "",
      "priority_critical": "Критический",
      "priority_high": "Высокий",
      "priority_low": "Низкий",
      "priority_medium": "Средний",
      "priority_urgent": "Срочный",
      "problem_cascade_close_checkbox": "Да, автоматически закрыть все связанные инциденты (рекомендуется)",
      "problem_cascade_close_desc": "Имеются связанные открытые инциденты. Вы хотите автоматически закрыть их и добавить комментарий с первопричиной и решением?",
      "problem_cascade_close_title": "Каскадное закрытие",
      "problem_confirm_resolve": "Подтвердить и решить",
      "problem_create_btn": "Создать проблему",
      "problem_create_error": "Ошибка при создании проблемы",
      "problem_create_success": "Заявка на проблему создана.",
      "problem_create_title": "Создать новый проблемный тикет",
      "problem_created_by_on": "Создано {{creator}} {{date}}",
      "problem_description_label": "Описание проблемы",
      "problem_detail_load_error": "Ошибка при загрузке деталей проблемы",
      "problem_incidents_linked": "Связанные инциденты",
      "problem_kedb_empty": "Известных ошибок нет",
      "problem_kedb_empty_desc": "Проблемы, классифицированные как известные ошибки, отображаются здесь с указанием причины и обходного решения.",
      "problem_kedb_load_error": "Ошибка при загрузке известных ошибок",
      "problem_kedb_search_placeholder": "Поиск по известным ошибкам...",
      "problem_kedb_title": "Известные ошибки (Known Errors)",
      "problem_known_error_badge": "Известная ошибка",
      "problem_known_error_checkbox": "Классифицировать как Known Error (Известная ошибка)",
      "problem_known_error_only": "Только известные ошибки",
      "problem_link_btn": "Связать",
      "problem_link_error": "Ошибка при связывании инцидентов",
      "problem_link_incident_btn": "Связать инцидент",
      "problem_link_incidents_title": "Связать инциденты",
      "problem_link_success": "Инциденты связаны.",
      "problem_linked_incidents": "Связанные инциденты",
      "problem_load_error": "Ошибка при загрузке проблем",
      "problem_loading": "Загрузка управления проблемами ITIL...",
      "problem_mark_known_error": "Отметить как Known Error",
      "problem_no_incidents_found": "Связанных инцидентов не найдено.",
      "problem_no_tickets": "Нет проблемных тикетов",
      "problem_no_tickets_desc": "В настоящее время проблемные тикеты ITIL не зарегистрированы.",
      "problem_no_unlinked_found": "Открытых несвязанных инцидентов не найдено.",
      "problem_none": "—",
      "problem_none_selected": "Проблема не выбрана",
      "problem_none_selected_desc": "Выберите проблемный тикет ITIL слева или создайте новый для управления данными анализа первопричин (RCA).",
      "problem_open_change_confirm": "Открыть новую заявку на изменение {{num}} сейчас?",
      "problem_raise_change_btn": "Создать изменение",
      "problem_raise_change_error": "Ошибка при создании изменения",
      "problem_raise_change_success": "Заявка на изменение создана: {{num}}",
      "problem_raise_change_title": "Создать изменение на основе этой проблемы",
      "problem_rca_title": "Проблемы ITIL (RCA)",
      "problem_resolution_note": "Заметка о решении",
      "problem_resolution_note_placeholder": "Введите подробности окончательного решения проблемы...",
      "problem_resolve_btn": "Решить проблему",
      "problem_resolve_error": "Ошибка при решении проблемы",
      "problem_resolve_success": "Проблема решена.",
      "problem_root_cause_label": "Предполагаемая первопричина",
      "problem_root_cause_short": "Первопричина",
      "problem_search_placeholder": "Поиск по проблемам...",
      "problem_stage_closed": "Закрыта",
      "problem_stage_known_error": "Известная ошибка",
      "problem_stage_label": "Статус жизненного цикла (стадия проблемы)",
      "problem_stage_open": "Открыта",
      "problem_stage_resolved": "Решена",
      "problem_stage_under_investigation": "На расследовании",
      "problem_stage_updated": "Статус жизненного цикла обновлён.",
      "problem_stage_workaround_found": "Найдено обходное решение",
      "problem_tab_kedb": "База известных ошибок (KEDB)",
      "problem_tab_problems": "Проблемы (RCA)",
      "problem_title": "ITIL Проблема: Повторяющийся инцидент",
      "problem_title_label": "Название проблемы",
      "problem_unlink_btn": "Отменить связь",
      "problem_unlink_error": "Ошибка при отмене связи",
      "problem_unlink_success": "Связь отменена.",
      "problem_update_error": "Ошибка при обновлении проблемы",
      "problem_update_success": "Проблема успешно обновлена.",
      "problem_workaround_label": "Известный обходной путь",
      "problem_workaround_short": "Обходное решение",
      "problems": "Проблемы",
      "queue.": "queue.",
      "queue_external_processing": "Externe Bearbeitung",
      "queues": "Очереди",
      "quick_access_views": "Быстрый доступ и просмотры",
      "quick_search": "Быстрый поиск",
      "read_ticket_also": "также читает этот тикет",
      "reading_ticket": "Читает тикет #{{id}}",
      "reassign_to": "Переназначить ({{name}})...",
      "recent_activities_description": "Последние тикеты и ответы для этого клиента.",
      "recent_tickets": "Последние тикеты",
      "refresh": "Обновить",
      "remove_assignment": "Удалить назначение",
      "remove_attachment_aria": "Удалить вложение {{filename}}",
      "remove_filter": "Filter entfernen",
      "reopen": "Открыть заново",
      "reply": "Ответ",
      "reply_keyboard_shortcut_hint": "Горячие клавиши: Ctrl или Cmd + Enter для отправки, когда курсор находится в поле ввода.",
      "report_active_breaches": "Активные нарушения",
      "report_ai_analysis": "ИИ-анализ",
      "report_ai_analyzing": "ИИ анализирует данные отчета...",
      "report_ai_highlights": "Особенности",
      "report_ai_recommendations": "Рекомендации",
      "report_billable": "Оплачиваемое",
      "report_compliance": "Соответствие SLA",
      "report_export": "Экспорт",
      "report_exporting": "Экспорт...",
      "report_no_data": "Нет доступных данных",
      "report_no_data_desc": "Не удалось загрузить данные отчета за этот период.",
      "report_range": "Вид отчета:",
      "report_total_time": "Всего времени",
      "reports": "Отчеты",
      "reports_desc": "Отчеты и аналитика управления услугами",
      "request.additional_info": "Дополнительные сведения",
      "request.back_to_dashboard": "Назад к панели управления",
      "request.back_to_dashboard_link": "← Панель управления",
      "request.back_to_list": "К обзору",
      "request.back_to_requests": "← Все запросы",
      "request.catalog_subtitle": "Выберите тип запроса — Вы получите соответствующую форму.",
      "request.choose_files": "Выбрать файлы",
      "request.description_placeholder": "Опишите Ваш вопрос…",
      "request.description_required": "Пожалуйста, введите описание.",
      "request.failed_load_catalog": "Не удалось загрузить каталог",
      "request.file_too_large": "Файл слишком большой (макс. {{max}} МБ): {{name}}",
      "request.file_type_not_allowed": "Dateityp nicht erlaubt: {{name}}",
      "request.no_requests": "В портале не активировано ни одного сервисного запроса.",
      "request.not_available": "Этот запрос недоступен или не опубликован.",
      "request.optional_select": "— Необязательно —",
      "request.please_select": "— Выберите —",
      "request.remove_file": "Удалить",
      "request.required_field": "Обязательное поле: {{label}}",
      "request.standard_fields_info": "Стандартные поля: приоритет, категория, описание и вложения включены в каждый сервисный запрос. Ниже при необходимости следуют дополнительные поля для данного типа запроса.",
      "request.submit_btn": "Отправить запрос",
      "request.submit_failed": "Не удалось отправить",
      "request.submitting_btn": "Выполняется отправка…",
      "request_type": "Тип запроса",
      "requester_title": "Создатель",
      "reset": "Сбросить",
      "reset_all_filters": "Alle Filter zurücksetzen",
      "reset_filter": "Сбросить фильтр",
      "reset_kpi_filter": "Kachel-Filter zurücksetzen",
      "reset_to_default": "Сбросить по умолчанию",
      "resolution": "Решение",
      "resolve": "Решить",
      "resolved_label": "Решен",
      "retry": "Erneut versuchen",
      "risk": "Риск",
      "risk_minutes": "{{count}} мин",
      "save": "Сохранить",
      "save_changes": "Сохранить изменения",
      "save_note": "Сохранить заметку",
      "saving": "Сохранение...",
      "scroll_to_reply": "Прокрутить к ответу",
      "search": "Поиск...",
      "search_canned_responses": "Поиск по шаблонам ответов…",
      "search_customers": "Искать клиентов...",
      "select_company": "Firma auswählen…",
      "select_customer_placeholder": "Выберите клиента из списка",
      "self_healing": "Самовосстановление",
      "send": "Отправить",
      "sending_ellipsis": "Отправка...",
      "settings": "Настройки",
      "seven_days": "7 дней",
      "shortcut_back_close": "Назад / Закрыть",
      "shortcut_escalate": "Эскалировать",
      "shortcut_focus_mode": "Режим фокусировки",
      "shortcut_help": "Эта справка",
      "shortcut_internal_note": "Внутренняя заметка",
      "shortcut_next_prev": "Следующий / Предыдущий тикет",
      "shortcut_quick_search": "Быстрый поиск",
      "shortcut_write_reply": "Написать ответ",
      "show_all": "Показать все",
      "show_full_ticket_backlog": "Показать весь бэклог тикетов",
      "show_older_replies": "Показать еще {{count}} ответов...",
      "sla_and_contract_title": "SLA и договор",
      "sla_breached_both": "Срок ответа и решения превышен",
      "sla_breached_exclamation": "SLA нарушено!",
      "sla_breached_resolution": "Срок решения превышен",
      "sla_breached_response": "Срок ответа превышен",
      "sla_breaches": "Нарушения SLA:",
      "sla_compliance": "Соблюдение SLA",
      "sla_level": "Уровень SLA:",
      "sla_option_1": "1. Соответствие SLA и тенденции (Обзор)",
      "sla_option_10": "10. Статистика SLA по выходным и праздничным дням",
      "sla_option_2": "2. Нарушения SLA и тикеты под угрозой",
      "sla_option_3": "3. SLA по приоритетам",
      "sla_option_4": "4. SLA по клиентам / сервисным планам",
      "sla_option_5": "5. Соблюдение SLA по времени ответа",
      "sla_option_6": "6. Соблюдение SLA по времени решения",
      "sla_option_7": "7. Нарушения SLA по агентам/группам",
      "sla_option_8": "8. Причины нарушений SLA",
      "sla_option_9": "9. Просмотр штрафов и компенсаций (Финансовый риск)",
      "sla_performance_breaches": "Эффективность SLA и нарушения",
      "sla_risk": "Риск SLA",
      "sla_status_ok": "ОК",
      "sort_by_label": "Сортировать по {{label}}",
      "spam": "Спам",
      "starred": "Избранные",
      "start": "Начало",
      "status": "Статус",
      "status_closed": "Закрыт",
      "status_in_progress": "В работе",
      "status_new": "Новый",
      "status_on_hold": "Приостановлено",
      "status_open": "Открыт",
      "status_resolved": "Решен",
      "status_waiting": "Ожидание",
      "status_waiting_customer": "Ожидание клиента",
      "street": "Улица",
      "subtasks": "Teilaufgaben",
      "supporting_agents": "Поддерживающие агенты",
      "switch_language": "Сменить язык",
      "system_logs": "Системные логи",
      "tab_": "",
      "tab_activity": "Активность",
      "tab_agents": "Агенты",
      "tab_assets": "Активы",
      "tab_contracts": "Договоры",
      "tab_csat": "CSAT",
      "tab_custom": "Свои отчеты",
      "tab_customers": "Клиенты",
      "tab_documents": "Документы",
      "tab_employees": "Сотрудники",
      "tab_incidents": "Инциденты",
      "tab_licenses": "Лицензии",
      "tab_notes": "Заметки",
      "tab_overview": "Обзор",
      "tab_sla": "SLA",
      "tab_tickets": "Тикеты",
      "tab_time": "Учет времени",
      "tab_trends": "Тренды",
      "tag_add_placeholder": "Добавить тег...",
      "tag_label": "Тег",
      "tax_number": "ИНН",
      "teams_call_start": "Начать звонок Teams",
      "teams_chat_open": "Открыть чат Teams",
      "teams_meeting_subject": "Встреча {{number}}",
      "teams_meeting_title": "Встреча Teams",
      "thirty_days": "30 дней",
      "ticket_assets.action_col": "Действие",
      "ticket_assets.agent_offline": "Агент не в сети",
      "ticket_assets.agent_ready": "Готов",
      "ticket_assets.assigned_assets": "Активы, назначенные сотруднику",
      "ticket_assets.bios_label": "Версия BIOS:",
      "ticket_assets.calculating_compliance": "Выполняется расчёт аудита лицензий...",
      "ticket_assets.clean_temp": "Очистить Temp",
      "ticket_assets.cmd_status_completed": "Готово",
      "ticket_assets.cmd_status_failed": "Ошибка",
      "ticket_assets.cmd_status_pending": "Ожидание",
      "ticket_assets.cmd_status_running": "Выполняется...",
      "ticket_assets.cmdb_alert_desc": "Этот актив зависит от / связан с:",
      "ticket_assets.cmdb_alert_title": "Каскадное предупреждение CMDB: сбой зависимости!",
      "ticket_assets.command_execution_failed": "Не удалось выполнить команду.",
      "ticket_assets.command_placeholder": "например, ipconfig /all, systeminfo, dir",
      "ticket_assets.command_running": "Команда сейчас выполняется на клиентском устройстве...",
      "ticket_assets.command_success_solved": "Успешно выполнено! Заявка была решена автоматически.",
      "ticket_assets.command_timeout": "Превышено время ожидания при выполнении команды.",
      "ticket_assets.compliant": "Соответствует",
      "ticket_assets.confirm_kill_process": "Вы действительно хотите завершить процесс с PID {{pid}}?",
      "ticket_assets.cpu_cores_label": "Ядра:",
      "ticket_assets.cpu_label": "Процессор (CPU)",
      "ticket_assets.cpu_sockets_label": "Сокеты:",
      "ticket_assets.cpu_util_label": "Загрузка CPU",
      "ticket_assets.created_label": "Создано:",
      "ticket_assets.device_scan_label": "Сканирование устройства",
      "ticket_assets.disk_free_label": "свободно",
      "ticket_assets.disk_used_label": "Занято",
      "ticket_assets.disks_label": "Диски / накопители",
      "ticket_assets.domain_label": "Рабочая группа/домен:",
      "ticket_assets.edition_id_label": "Идентификатор выпуска:",
      "ticket_assets.employee_assets": "Активы сотрудника",
      "ticket_assets.error_kill_process": "Ошибка при завершении процесса: {{error}}",
      "ticket_assets.error_loading_monitoring": "Ошибка при загрузке данных мониторинга",
      "ticket_assets.error_sending_command": "Ошибка при отправке команды.",
      "ticket_assets.error_submit_command": "Не удалось передать команду: {{error}}",
      "ticket_assets.executed_label": "Выполнено:",
      "ticket_assets.fetch_logs_btn": "Получить журналы",
      "ticket_assets.filter_processes_placeholder": "Фильтр процессов (имя, PID)...",
      "ticket_assets.fix_dns": "Исправить DNS",
      "ticket_assets.fix_spooler": "Исправить диспетчер печати",
      "ticket_assets.hostname_label": "Сетевое имя:",
      "ticket_assets.incomplete_summary": "Сводка по соответствию неполная.",
      "ticket_assets.invalid_json_response": "Некорректный ответ сервера",
      "ticket_assets.kill_btn": "Завершить",
      "ticket_assets.killing_proc": "Завершение...",
      "ticket_assets.last_scan_label": "Последнее сканирование:",
      "ticket_assets.license_compliance": "Соответствие лицензий",
      "ticket_assets.link": "Связать",
      "ticket_assets.link_asset_title": "Связать актив",
      "ticket_assets.linked": "Связано",
      "ticket_assets.linked_assets": "Активы, связанные с заявкой",
      "ticket_assets.loading": "Загрузка активов...",
      "ticket_assets.loading_command_queue": "Загрузка очереди команд...",
      "ticket_assets.loading_logs": "Загрузка журналов событий...",
      "ticket_assets.loading_monitoring": "Загрузка мониторинга в реальном времени и проверки CMDB...",
      "ticket_assets.log_name_label": "Имя журнала",
      "ticket_assets.memory_col": "Оперативная память",
      "ticket_assets.model_label": "Модель:",
      "ticket_assets.monitored_ok": "Под наблюдением (OK)",
      "ticket_assets.more_params_title": "Дополнительные параметры",
      "ticket_assets.motherboard_label": "Материнская плата:",
      "ticket_assets.no_active_zabbix_alerts": "Активных оповещений Zabbix нет.",
      "ticket_assets.no_assets_assigned": "Этому сотруднику не назначено ни одного ИТ-актива.",
      "ticket_assets.no_assets_linked": "Активы не связаны.",
      "ticket_assets.no_commands_executed": "Команды ещё не выполнялись. Введите команду ниже.",
      "ticket_assets.no_compliance_available": "Лицензии или отчёт о соответствии недоступны.",
      "ticket_assets.no_employee_assigned": "Для заявки не назначен сотрудник.",
      "ticket_assets.no_hardware_details": "Сведения об оборудовании не отсканированы.",
      "ticket_assets.no_matching_software": "Совпадающие записи ПО не найдены.",
      "ticket_assets.no_monitoring_data": "Данные мониторинга недоступны",
      "ticket_assets.os_arch_label": "Архитектура:",
      "ticket_assets.os_label": "Операционная система",
      "ticket_assets.os_ver_label": "Версия:",
      "ticket_assets.overlicensed": "Избыточное лицензирование",
      "ticket_assets.pagination_text": "Страница {{page}} из {{total}} (записей: {{count}})",
      "ticket_assets.process_name_col": "Имя процесса",
      "ticket_assets.publisher_col": "Издатель",
      "ticket_assets.query_realtime_btn": "Запросить в реальном времени",
      "ticket_assets.ram_label": "Оперативная память (RAM)",
      "ticket_assets.ram_util_label": "Загрузка RAM",
      "ticket_assets.scan_details_btn": "Детали сканирования",
      "ticket_assets.scan_never": "никогда",
      "ticket_assets.search_logs_placeholder": "Поиск по результатам (источник, ID, сообщение)...",
      "ticket_assets.search_placeholder": "Поиск по имени, IP или серийному номеру...",
      "ticket_assets.search_software_placeholder": "Поиск по программному обеспечению...",
      "ticket_assets.self_healing_title": "Самовосстановление и автоматизация",
      "ticket_assets.send_btn": "Отправить",
      "ticket_assets.sending_command_failed": "Не удалось отправить команду.",
      "ticket_assets.serial_number_label": "Серийный номер:",
      "ticket_assets.severity_all": "Все",
      "ticket_assets.severity_error": "Ошибка (Error)",
      "ticket_assets.severity_info": "Информация",
      "ticket_assets.severity_label": "Уровень серьёзности",
      "ticket_assets.severity_warning": "Предупреждение (Warning)",
      "ticket_assets.sn_label": "S/N:",
      "ticket_assets.software_name_col": "Название ПО",
      "ticket_assets.sql_instance_label": "Экземпляр:",
      "ticket_assets.sql_instances_title": "Обнаруженные экземпляры SQL Server",
      "ticket_assets.sql_patchlevel_label": "Уровень обновлений:",
      "ticket_assets.success_kill_process": "Процесс успешно завершён.",
      "ticket_assets.surplus_label": "Излишек:",
      "ticket_assets.timeout_kill_process": "Превышено время ожидания при завершении процесса.",
      "ticket_assets.total_ram_desc": "Всего физической памяти",
      "ticket_assets.underlicensed": "Недостаточное лицензирование",
      "ticket_assets.unlink_asset_title": "Отменить связь",
      "ticket_assets.unreachable": "Недоступен",
      "ticket_assets.version_col": "Версия",
      "ticket_assets.virtualization_label": "Виртуализация:",
      "ticket_assets.waiting_agent_response": "Ожидание ответа от агента...",
      "ticket_assets.waiting_agent_timeout": "Превышено время ожидания: агент не ответил вовремя.",
      "ticket_assets.zabbix_live_status": "Состояние Zabbix в реальном времени",
      "ticket_created": "Тикет создан",
      "ticket_detail.achtung_ueberschneidungskollisionen_ci_abhae": "Внимание: обнаружены пересечения по времени (зависимости CI)!",
      "ticket_detail.aktivitaeten": "Активность",
      "ticket_detail.aktivitaets_verlauf": "История активности",
      "ticket_detail.als_diesen_kunden_im_portal_anmelden": "Войти в портал от имени этого клиента",
      "ticket_detail.anhaenge": "Вложения",
      "ticket_detail.begruendung_kommentare": "Обоснование / комментарии",
      "ticket_detail.bekannter_fehler_workaround_verfuegbar": "Известная ошибка — доступно обходное решение",
      "ticket_detail.cab_hat_die_aenderung_abgelehnt": "CAB отклонил изменение",
      "ticket_detail.change_advisory_board_cab_stimmen": "Голоса Change Advisory Board (CAB)",
      "ticket_detail.das_ticket_existiert_nicht_oder_wurde_geloes": "Заявка не существует или была удалена.",
      "ticket_detail.der_status_kann_erst_auf_in_bearbeitung_oder": "Статус можно перевести в «В работе» или «Решено» только после того, как большинство CAB проголосует за.",
      "ticket_detail.detaillierte_schritte_zur_durchfuehrung": "Подробные шаги выполнения...",
      "ticket_detail.es_wurde_noch_kein_change_plan_fuer_dieses_t": "Для этой заявки ещё не создан план изменения.",
      "ticket_detail.es_wurden_andere_aktive_tickets_auf_denselbe": "На тот же период запланированы другие активные заявки по тем же или зависимым активам CMDB:",
      "ticket_detail.extrahierte_daten": "Извлечённые данные",
      "ticket_detail.geplanter_start_wartungsfenster": "Плановое начало (окно обслуживания)",
      "ticket_detail.geplantes_ende": "Плановое окончание",
      "ticket_detail.geplantes_wartungsfenster": "Плановое окно обслуживания:",
      "ticket_detail.hinzufuegen": "Добавить",
      "ticket_detail.keine_aktivitaeten_vorhanden": "Записей активности нет",
      "ticket_detail.keine_anhaenge_vorhanden": "Вложений нет",
      "ticket_detail.keine_kategorie": "Без категории",
      "ticket_detail.kommentar_zur_entscheidung_optional": "Комментарий к решению (необязательно)...",
      "ticket_detail.loeschen": "Удалить",
      "ticket_detail.niemand_zugewiesen": "Исполнитель не назначен",
      "ticket_detail.noch_keine_stimmen_abgegeben": "Голосов пока нет.",
      "ticket_detail.noch_keine_zeit_erfasst": "Время пока не учтено",
      "ticket_detail.nur_fuer_mitarbeiter_sichtbar": "Видно только сотрудникам",
      "ticket_detail.prioritaet": "Приоритет",
      "ticket_detail.sprachnotizen_in_administration_ki_einstellu": "Включите голосовые заметки в разделе «Администрирование → Настройки ИИ».",
      "ticket_detail.sprachnotizen_nicht_aktiv": "Голосовые заметки не активны",
      "ticket_detail.stimme_uebermitteln": "Отправить голос",
      "ticket_detail.tag_entfernen": "Удалить тег",
      "ticket_detail.tag_hinzufuegen": "Добавить тег…",
      "ticket_detail.tag_hinzufuegen_2": "Добавить тег",
      "ticket_detail.ticket_nicht_gefunden": "Заявка не найдена",
      "ticket_detail.ticket_wird_geladen": "Загрузка заявки...",
      "ticket_detail.timer_laeuft_fuer_anderes_ticket": "Таймер запущен для другой заявки",
      "ticket_detail.timer_starten": "Запустить таймер",
      "ticket_detail.timer_stoppen": "Остановить таймер",
      "ticket_detail.uebersicht": "Обзор",
      "ticket_detail.veroeffentlicht": "Опубликовано",
      "ticket_detail.was_wurde_erledigt": "Что было сделано?",
      "ticket_detail.welches_risiko_besteht_fuer_den_betrieb": "Какой риск для эксплуатации?",
      "ticket_detail.wie_machen_wir_aenderungen_rueckgaengig": "Как откатить изменения?",
      "ticket_detail.wie_wird_die_funktion_verifiziert": "Как проверяется работоспособность?",
      "ticket_detail.zeiteintraege": "Записи времени",
      "ticket_detail.zugewiesen_an": "Исполнитель",
      "ticket_detail.zugewiesen_an_2": "Исполнитель",
      "ticket_detail.zurueck_zur_uebersicht": "Назад к обзору",
      "ticket_detail.zustimmung_des_change_advisory_boards_cab_zw": "Обязательно требуется согласование Change Advisory Board (CAB)",
      "ticket_filter_active_label": "Filter aktiv",
      "ticket_inventory_kpis": "Kennzahlen & Arbeitslast",
      "ticket_properties_title": "Тикет",
      "ticket_relations": "Verknüpfte Tickets",
      "ticket_view_search_label": "Diese Ticketansicht durchsuchen",
      "tickets": "Тикеты",
      "tickets_exist_hint": "Insgesamt sind {{count}} Tickets vorhanden.",
      "tickets_near_sla_breach": "Тикеты на грани нарушения SLA",
      "tickets_plural": "{{count}} тикетов",
      "tickets_ratio_label": "{{count}} из {{total}} тикетов",
      "tickets_selected": "Выбрано тикетов: {{count}}",
      "tickets_without_assignee": "Тикеты без исполнителя",
      "time_logged": "Время записано: {{time}}",
      "time_minutes": "Zeit in Minuten",
      "title": "Название",
      "to_reply_composer": "К ответу (Редактор)",
      "today_due": "Срок сегодня",
      "toggle_design_mode": "Переключить тему оформления",
      "toggle_favorite": "Переключить избранное",
      "tracked_hours": "{{hours}} ч.",
      "tracked_hours_min": "{{hours}} ч. {{minutes}} мин.",
      "tracked_min": "{{minutes}} мин.",
      "tracked_time": "Записанное время",
      "unassigned": "Не назначено",
      "unlink_asset": "Отвязать",
      "unread": "Непрочитано",
      "update": "Обновить",
      "updated_at": "Обновлено",
      "urgent": "Срочно",
      "user_profile_logout": "Профиль пользователя и выход",
      "vat_id": "КПП",
      "views": "Просмотры",
      "voice_notes_admin_hint": "Голосовые заметки: Включите 'Голосовые заметки' в Администрирование → Настройки ИИ.",
      "voice_notes_enable_info": "Включите голосовые заметки в Администрирование → Настройки ИИ (переключатель 'Голосовые заметки').",
      "voice_notes_not_active": "Голосовые заметки не активны",
      "website": "Веб-сайт",
      "widget_critical_tickets": "Критические тикеты (Срочные)",
      "widget_group_analytics_team": "Аналитика и команда",
      "widget_group_overview_performance": "Обзор и эффективность",
      "widget_group_volume_trends": "Объем и тенденции",
      "widget_my_open_tickets": "Мои открытые тикеты",
      "widget_performance_times": "Время работы и трудозатраты",
      "widget_priority_chart": "Распределение приоритетов",
      "widget_sla_compliance": "Соответствие SLA и риски",
      "widget_status_chart": "Распределение статусов тикетов",
      "widget_team_presence": "Присутствие команды и активность",
      "widget_ticket_trends": "Тенденции тикетов и объем",
      "widget_top_customers": "Лучшие клиенты по тикетам",
      "zip_code": "Индекс"
    }
  },
  "pt": {
    "translation": {
      "access_denied": "Acesso negado",
      "access_denied_desc": "Você precisa de privilégios de agente ou administrador.",
      "actions": "Ações",
      "activate_dark_mode": "Ativar modo escuro",
      "activate_light_mode": "Ativar modo claro",
      "active": "Ativo",
      "active_filters": "Aktive Filter",
      "active_open_assignments": "Atribuições ativas e abertas",
      "activity_optional": "Atividade (opcional)",
      "admin": "Admin",
      "admin_dashboard.administrative_berechtigungen": "Permissões administrativas",
      "admin_dashboard.aendern": "Alterar",
      "admin_dashboard.agent_deaktiviert": "Agente desativado",
      "admin_dashboard.agent_erstellt": "Agente criado",
      "admin_dashboard.agent_gespeichert": "Agente salvo",
      "admin_dashboard.agent_ohne_zuordnung_hinweis": "Sem atribuição, este agente vê {{umfang}} os clientes. Assim que pelo menos um cliente for atribuído, o agente fica limitado a esses clientes — tickets, relatórios e ativos.",
      "admin_dashboard.agenten_in_der_kundenkonsole": "Agentes no console do cliente",
      "admin_dashboard.aktuelles_passwort": "Senha atual",
      "admin_dashboard.alle_eingehenden_befehle_wurden_bereits_vera": "Todos os comandos recebidos já foram processados ou liberados.",
      "admin_dashboard.alle_kunden": "Todos os clientes",
      "admin_dashboard.als_hauptkategorie_erstellen": "Criar como categoria principal",
      "admin_dashboard.api_token_hinweis": "Se necessário, crie antes um token de API na aba {{reiter}} com o escopo {{scope}}.",
      "admin_dashboard.aufloesungszeit": "Tempo de resolução *",
      "admin_dashboard.basic_auth_benutzername_passwort": "Basic Auth (usuário/senha)",
      "admin_dashboard.bei_prefix_u00c4nderung_werden_alle_bestehen": "Ao alterar o prefixo, todos os tickets existentes são renomeados automaticamente.",
      "admin_dashboard.benoetigte_berechtigung": "Permissão necessária:",
      "admin_dashboard.bestaetigen": "Confirmar",
      "admin_dashboard.bezeichnung_positionszeile": "Descrição da linha de item",
      "admin_dashboard.bitte_kunde_waehlen": "Selecione o cliente...",
      "admin_dashboard.bitte_kunde_waehlen_2": "Selecione o cliente...",
      "admin_dashboard.definieren_sie_hauptkategorien_und_bis_zu_zw": "Defina categorias principais e até dois níveis de subcategorias. Elas são oferecidas como opção na criação de tickets.",
      "admin_dashboard.definiert_die_standard_reihenfolge_der_queue": "Define a ordem padrão das filas na barra lateral do agente.",
      "admin_dashboard.details_anzeigen": "Exibir detalhes",
      "admin_dashboard.details_anzeigen_2": "Exibir detalhes",
      "admin_dashboard.die_smtp_einstellungen_fuer_den_e_mail_versa": "As configurações de SMTP para o envio de e-mails agora são gerenciadas de forma centralizada em",
      "admin_dashboard.e_mail_versand_smtp_wird_unter_e_mail_einste": "O envio de e-mails (SMTP) é configurado em Configurações de e-mail",
      "admin_dashboard.eine_sicherheitsgruppe_legt_fest_welche_kons": "Um grupo de segurança define quais módulos do console um agente enxerga. “Acesso total” = todos os módulos. Os direitos de administrador são independentes disso.",
      "admin_dashboard.einstellungen_speichern": "Salvar configurações",
      "admin_dashboard.eintraege": "Registros",
      "admin_dashboard.endgeraet": "Dispositivo",
      "admin_dashboard.endgueltig_loeschen": "Endgültig löschen",
      "admin_dashboard.entwurfsrechnung_aus_zeiteintraegen": "Rascunho de fatura a partir dos registros de tempo",
      "admin_dashboard.erstellen_sie_ihre_erste_automatisierung": "Crie a sua primeira automação",
      "admin_dashboard.erstellen_sie_oben_ihre_erste_hauptkategorie": "Crie acima a sua primeira categoria principal",
      "admin_dashboard.externer_mitarbeiter_dienstleister": "Funcionário externo / prestador de serviços",
      "admin_dashboard.fehler_beim_deaktivieren": "Erro ao desativar",
      "admin_dashboard.fehler_beim_deaktivieren_2": "Erro ao desativar",
      "admin_dashboard.fehler_beim_deaktivieren_3": "Erro ao desativar",
      "admin_dashboard.fehler_beim_loeschen": "Erro ao excluir",
      "admin_dashboard.firma_adresse_kontakt_steuernummern_in_der_u": "Empresa, endereço, contato e números fiscais podem ser editados na visão geral. Desativar clientes continua restrito ao administrador.",
      "admin_dashboard.fuer_entra_id_benoetigen_sie_eine_app_regist": "Para o Entra ID, você precisa de um registro de aplicativo no portal do Azure com a permissão Mail.Read.",
      "admin_dashboard.geloescht": "Excluído",
      "admin_dashboard.geloescht_2": "Excluído",
      "admin_dashboard.installationspaket_herunterladen": "Baixar pacote de instalação",
      "admin_dashboard.kategorie_aktualisiert": "Categoria atualizada",
      "admin_dashboard.kategorie_erstellt": "Categoria criada",
      "admin_dashboard.kategorie_geloescht": "Categoria excluída",
      "admin_dashboard.keine_abteilung": "Sem departamento",
      "admin_dashboard.keine_ausstehenden_befehls_freigaben_vorhand": "Não há liberações de comando pendentes.",
      "admin_dashboard.keine_workflows_konfiguriert": "Nenhum workflow configurado",
      "admin_dashboard.keine_zuordnung_dieser_agent_sieht_alle_kund": "Sem atribuição — este agente vê todos os clientes.",
      "admin_dashboard.konfigurieren_sie_sprachmodelle_auto_respons": "Configure modelos de linguagem, prompts de resposta automática e modelos de sistema",
      "admin_dashboard.kunde_auswaehlen": "Selecionar cliente *",
      "admin_dashboard.kunde_deaktiviert": "Cliente desativado",
      "admin_dashboard.kunde_erstellt": "Cliente criado",
      "admin_dashboard.kunde_geloescht": "Kunde „{{firma}}\" wurde endgültig gelöscht",
      "admin_dashboard.kunde_gespeichert": "Cliente salvo",
      "admin_dashboard.kunde_waehlen": "Selecionar cliente…",
      "admin_dashboard.kundenzuordnung_verwalten": "Gerenciar atribuição de clientes",
      "admin_dashboard.laden_sie_ein_fertiges_zip_archiv_fuer": "Baixe um arquivo ZIP pronto para",
      "admin_dashboard.laedt": "Carregando…",
      "admin_dashboard.laengengrad": "Longitude",
      "admin_dashboard.legen_sie_fest_welche_daten_der_installierte": "Defina quais dados o agente instalado coleta e configure o scanner de rede opcional sem agente (ping de sub-rede).",
      "admin_dashboard.letzte_exporte": "Últimas exportações",
      "admin_dashboard.lexoffice_artikel_uuid_optional_dienstleistu": "UUID do artigo no Lexoffice (opcional, serviço)",
      "admin_dashboard.lexoffice_deaktiviert_hinweis": "A integração com o LexOffice está desativada no momento. Você só poderá criar rascunhos de faturas depois de ativar e configurar a integração em {{bereich}}.",
      "admin_dashboard.lexoffice_einstellungen_konnten_nicht_gelade": "Não foi possível carregar as configurações do Lexoffice (execute a migração / reinicie o servidor).",
      "admin_dashboard.loeschen": "Excluir",
      "admin_dashboard.loeschen_2": "Excluir",
      "admin_dashboard.mailbox_empfang_imap_oauth_wird_unter_postfa": "O recebimento de e-mails (IMAP/OAuth) é configurado em Caixas de correio",
      "admin_dashboard.mailbox_speichern": "Salvar caixa de correio",
      "admin_dashboard.microsoft_graph_api": "Microsoft Graph API",
      "admin_dashboard.mit_einem_frisch_generierten_api_schluessel": "com uma chave de API recém-gerada e um",
      "admin_dashboard.mitarbeiter_deaktiviert": "Funcionário desativado",
      "admin_dashboard.mitarbeiter_erstellt": "Funcionário criado",
      "admin_dashboard.mitarbeiter_gespeichert": "Funcionário salvo",
      "admin_dashboard.mloffice_gefuehrt": "Stammdaten werden von MLOffice geführt",
      "admin_dashboard.mloffice_geloest": "Mit MLOffice verknüpft — Abgleich derzeit gelöst",
      "admin_dashboard.module_assets": "Ativos",
      "admin_dashboard.module_calendar": "Calendário",
      "admin_dashboard.module_customers": "Clientes",
      "admin_dashboard.module_knowledge": "Base de conhecimento",
      "admin_dashboard.module_licenses": "Licenças",
      "admin_dashboard.module_problems": "Problemas",
      "admin_dashboard.module_reports": "Relatórios",
      "admin_dashboard.module_tickets": "Tickets",
      "admin_dashboard.nach_kunde_filtern": "Filtrar por cliente",
      "admin_dashboard.neue_mailbox_konfiguration": "Nova configuração de caixa de correio",
      "admin_dashboard.neuer_workflow": "Novo workflow",
      "admin_dashboard.neues_passwort": "Nova senha",
      "admin_dashboard.nicht_abrechenbar": "Não faturável",
      "admin_dashboard.noch_keine_kategorien_definiert": "Nenhuma categoria definida ainda",
      "admin_dashboard.noch_keine_zeiteintraege_vorhanden": "Ainda não há registros de tempo",
      "admin_dashboard.nur_abrechenbare_eintraege_ohne_vorherigen_l": "Apenas registros faturáveis sem exportação anterior para o Lexoffice; opcionalmente, filtre por ID do contrato.",
      "admin_dashboard.optionale_beschreibung_des_sla_umfangs": "Descrição opcional do escopo do SLA",
      "admin_dashboard.passwort_aendern": "Alterar senha",
      "admin_dashboard.primaer": "Primário",
      "admin_dashboard.prioritaet_geaendert": "• Prioridade alterada",
      "admin_dashboard.pruefinterval_minuten": "Intervalo de verificação (minutos)",
      "admin_dashboard.refresh_token": "Refresh Token",
      "admin_dashboard.sie_koennen_den_agenten_auch_manuell_registr": "Você também pode registrar o agente manualmente. Para isso, use a seguinte sintaxe no cliente (requer direitos de administrador):",
      "admin_dashboard.standardmaessig_duerfen_agenten_kunden_stamm": "Por padrão, os agentes só podem ler os dados cadastrais dos clientes e apenas visualizar os documentos dos clientes. Aqui você pode ativar direitos de escrita ampliados por instalação.",
      "admin_dashboard.status_geaendert": "• Status alterado",
      "admin_dashboard.stundensatz_ueberschreiben_optional": "Substituir o valor por hora (opcional)",
      "admin_dashboard.tarif_erweitern": "Ampliar o plano",
      "admin_dashboard.ticket_id_format_und_admin_passwort_koennen": "O formato do ID do ticket e a senha do Admin podem ser configurados aqui",
      "admin_dashboard.top_kunden_nach_ticketvolumen": "Principais clientes por volume de tickets",
      "admin_dashboard.uebergeordnete_kategorie": "Categoria superior",
      "admin_dashboard.unterkategorie_hinzufuegen": "Adicionar subcategoria",
      "admin_dashboard.upload_metadaten_bearbeiten_und_loeschen_von": "Upload, edição de metadados e exclusão de arquivos na aba “Documentos” do cliente.",
      "admin_dashboard.verfuegbare_trigger": "Gatilhos disponíveis",
      "admin_dashboard.verwalten_und_genehmigen_sie_ausstehende_adm": "Gerencie e aprove comandos administrativos pendentes de outros administradores antes da execução nos dispositivos cliente.",
      "admin_dashboard.voller_zugriff_alle_module": "Acesso total (todos os módulos)",
      "admin_dashboard.vorkonfiguriertes_paket_zip": "Pacote pré-configurado (.zip)",
      "admin_dashboard.was_bedeuten_die_gruppen": "O que significam os grupos?",
      "admin_dashboard.workflow_automatisierungen": "Automações de workflow",
      "admin_dashboard.z_b_hauptsitz_koeln": "ex.: Matriz São Paulo",
      "admin_dashboard.zeit_standardmaessig_abrechenbar": "Tempo faturável por padrão",
      "admin_dashboard.zeitbuchung_bei_ticket_schliessung_erforderl": "Registro de tempo obrigatório ao fechar o ticket",
      "admin_dashboard.zeitbuchungen_erscheinen_hier_sobald_agenten": "Os registros de tempo aparecem aqui assim que os agentes lançarem tempo nos tickets.",
      "admin_dashboard.zeiteintraege": "Registros de tempo",
      "admin_dashboard.zeiterfassung_aktivieren": "Ativar registro de tempo",
      "admin_dashboard.zeiterfassung_einstellungen": "Configurações de registro de tempo",
      "admin_dashboard.zugriff_verweigert": "Acesso negado",
      "admin_dashboard.zugriff_verweigert_text": "Você não possui as permissões administrativas necessárias para visualizar ou gerenciar a área {{bereich}}.",
      "admin_dashboard.zuordnung_entfernen": "Remover atribuição",
      "admin_dashboard.zusaetzliche_admin_rechte": "Direitos de Admin adicionais",
      "admin_default": "Padrão do administrador",
      "admin_only_change": "(apenas um administrador pode alterar a atribuição.)",
      "admin_overview.aktive_warnungen_risiken": "Avisos e riscos ativos",
      "admin_overview.alles_in_ordnung": "Tudo em ordem",
      "admin_overview.datenbank_engine": "Engine do banco de dados",
      "admin_overview.einstellungen_filtern": "Filtrar configurações...",
      "admin_overview.hinweis_fuer_administratoren": "Aviso para administradores:",
      "admin_overview.keine_ergebnisse_gefunden": "Nenhum resultado encontrado",
      "admin_overview.keine_warnungen_oder_kritischen_meldungen": "Nenhum aviso ou mensagem crítica.",
      "admin_overview.lade_dashboard_daten": "Carregando os dados do dashboard...",
      "admin_overview.system_status": "Status do sistema",
      "admin_overview.upgrade_erforderlich": "Upgrade necessário",
      "admin_overview.upgrade_erforderlich_2": "Upgrade necessário",
      "admin_overview.versuchen_sie_es_mit_einem_anderen_suchbegri": "Tente outro termo de busca.",
      "admin_overview.zurueck_zum_agent_dashboard": "Voltar ao dashboard do agente",
      "admin_view": "Vista de Administrador",
      "administration": "Administração",
      "administrator": "Administrador",
      "agent": "Agente",
      "agent_available": "Disponível",
      "agent_console": "Consola de agente",
      "agent_console.alle_als_gelesen": "Marcar todas como lidas",
      "agent_console.anhaenge": "Anexos",
      "agent_console.anhaenge_zum_eroeffnungsbeitrag": "Anexos da mensagem de abertura",
      "agent_console.back_to_ticket_list": "Zurück zur Liste",
      "agent_console.beschreiben_sie_hier_details_die_dem_partner": "Descreva aqui os detalhes que devem ser informados ao parceiro...",
      "agent_console.bitte_waehlen": "-- Selecione --",
      "agent_console.detailansicht_schliessen": "Fechar a visualização detalhada",
      "agent_console.erneut_oeffnen": "Reabrir",
      "agent_console.hinweis_der_partner_erhaelt_eine_benachricht": "Aviso: o parceiro recebe um e-mail de notificação com as suas informações e um link seguro para tratar o ticket.",
      "agent_console.interner_chat": "Chat interno",
      "agent_console.interner_chat_2": "Chat interno",
      "agent_console.keine_benachrichtigungen": "Nenhuma notificação",
      "agent_console.language_selection": "Seleção de idioma",
      "agent_console.loesen": "Resolver",
      "agent_console.mir_zuweisen": "Atribuir a mim",
      "agent_console.nachricht_notiz_fuer_den_partner_optional": "Mensagem / observação para o parceiro (opcional)",
      "agent_console.neues_ticket": "Novo ticket",
      "agent_console.neues_ticket_2": "Novo ticket",
      "agent_console.partner_dienstleister_waehlen": "Selecionar parceiro / prestador de serviços",
      "agent_console.schliessen": "Fechar",
      "agent_console.schliessen_2": "Fechar",
      "agent_console.schliessungsgrund": "Motivo do fechamento:",
      "agent_console.schnellsuche_oeffnen": "Abrir a busca rápida",
      "agent_console.sie_benoetigen_agent_oder_admin_rechte": "Você precisa de direitos de agente ou de Admin.",
      "agent_console.tastenkuerzel": "Atalhos de teclado",
      "agent_console.ticket_erstellt": "Ticket criado",
      "agent_console.ticket_schliessen": "Fechar ticket",
      "agent_console.zugriff_verweigert": "Acesso negado",
      "agent_console.zur_antwort_composer": "Ir para a resposta (editor)",
      "agent_console.zur_antwort_scrollen": "Rolar até a resposta",
      "agent_console.zusammenfuehren": "Zusammenführen",
      "agent_console.zuweisung_entfernen": "Remover atribuição",
      "ai": "IA",
      "ai_analysis_running": "Análise em execução...",
      "ai_assistance": "Assistência de IA",
      "ai_confidence_label": "{{pct}}% de confiança",
      "ai_context_title": "KI-Kontext & Prognosen",
      "ai_generate_summary": "Gerar resumo",
      "ai_key_points": "Pontos-chave",
      "ai_next_steps": "Próximos passos",
      "ai_requested_action": "Ação solicitada",
      "ai_risks": "Riscos",
      "ai_solution_assistant_title": "Assistente de solução de IA",
      "ai_stale": "Desatualizado",
      "ai_summary_title": "Resumo de IA",
      "all": "Todos",
      "all_active_tickets": "Todos os tickets ativos",
      "all_categories": "Todas as categorias",
      "all_customers": "Todos os clientes",
      "all_deadlines_ok": "Todos os prazos estão dentro do prazo.",
      "all_open": "Todos abertos",
      "all_tickets": "Todos os tickets",
      "allgemein.abbrechen": "Abbrechen",
      "allgemein.schliessen": "Schließen",
      "analyze_again": "Analisar novamente",
      "article": "Artigo",
      "article_ai_generate": "Criar artigo com IA",
      "article_ai_generate_btn": "Gerar artigo",
      "article_ai_generate_desc": "Descreva o tópico e a IA gerará um rascunho",
      "article_ai_improve": "Melhorar texto",
      "article_ai_keywords": "Palavras-chave (opcional)",
      "article_ai_keywords_placeholder": "ex., Windows 11, OpenVPN, certificado",
      "article_ai_language": "Idioma",
      "article_ai_len_long": "Longo / detalhado",
      "article_ai_len_medium": "Médio",
      "article_ai_len_short": "Curto",
      "article_ai_length": "Extensão",
      "article_ai_style": "Estilo de linguagem",
      "article_ai_style_balanced": "Equilibrado",
      "article_ai_style_enduser": "Usuário final (passo a passo)",
      "article_ai_style_formal": "Formal",
      "article_ai_style_simple": "Simples / fácil de entender",
      "article_ai_style_technical": "Técnico (profissionais de TI)",
      "article_ai_summarize": "Gerar resumo",
      "article_ai_topic": "Tópico *",
      "article_ai_topic_placeholder": "ex., Configurar conexão VPN no Windows",
      "article_all_customers": "Todos os clientes",
      "article_all_statuses": "Todos os status",
      "article_all_visible": "Visível para todos os clientes",
      "article_archived": "Arquivado",
      "article_category": "Categoria",
      "article_content_placeholder": "Comece a escrever seu artigo aqui...",
      "article_create_first": "Criar primeiro artigo",
      "article_create_first_desc": "Crie seu primeiro artigo de conhecimento para compartilhar informações com sua equipe.",
      "article_create_with_ai": "Criar com IA",
      "article_delete_confirm": "Tem certeza que deseja excluir este artigo?",
      "article_draft": "Rascunho",
      "article_excerpt_placeholder": "Um breve resumo do artigo...",
      "article_manage": "Gerenciar artigos",
      "article_new": "Novo artigo",
      "article_no_articles": "Nenhum artigo disponível ainda",
      "article_no_categories_desc": "Nenhuma categoria disponível. Crie-as na área de administração.",
      "article_no_category": "Sem categoria",
      "article_not_found": "Nenhum artigo encontrado",
      "article_not_found_desc": "Nenhum artigo pôde ser encontrado para sua busca.",
      "article_only_visible": "Visível apenas para {{name}}",
      "article_pinned": "Fixado",
      "article_pinned_desc": "Será exibido no topo da lista",
      "article_plural": "Todos os artigos",
      "article_published": "Publicado",
      "article_search": "Buscar artigos...",
      "article_views": "visualizações",
      "article_visibility": "Visibilidade do cliente",
      "article_write_content": "Conteúdo do artigo",
      "article_write_excerpt": "Resumo",
      "article_write_title": "Insira o título do artigo...",
      "asset.discovery_agents": "Agentes de descoberta",
      "asset.event_logs": "Logs de eventos",
      "asset.general": "Geral",
      "asset.hardware_wmi": "Hardware (WMI)",
      "asset.history_changes": "Histórico e Alterações",
      "asset.more": "Mais",
      "asset.network": "Rede",
      "asset.network_discovery": "Descoberta de rede",
      "asset.printers": "Impressoras",
      "asset.processes": "Processos",
      "asset.relationships": "Relações",
      "asset.remote_control": "Controle remoto",
      "asset.remote_terminal": "Terminal remoto",
      "asset.scan_history": "Histórico de varreduras",
      "asset.security": "Segurança",
      "asset.services": "Serviços",
      "asset.software_catalog": "Catálogo de software (SAM)",
      "asset.software_count": "Software",
      "asset.system_assets": "Ativos do sistema",
      "asset.updates": "Atualizações",
      "asset_": "asset_",
      "asset_active": "Ativo",
      "asset_agent.offline": "Offline",
      "asset_agent.online_active": "Online (ativo)",
      "asset_agent.recently_active": "Ativo recentemente",
      "asset_inactive": "Inativo",
      "asset_maintenance": "Manutenção",
      "asset_management": "Gerenciamento de ativos",
      "asset_panel.confirm_delete_asset": "Deseja realmente excluir \"{{name}}\"?",
      "asset_panel.confirm_delete_category": "Excluir a categoria \"{{name}}\"? Os ativos serão desvinculados.",
      "asset_panel.edit_asset": "Editar ativo",
      "asset_panel.edit_category": "Editar categoria",
      "asset_panel.import_as_managed_btn": "Importar como ativo gerenciado",
      "asset_panel.import_device": "Importar dispositivo",
      "asset_panel.new_asset": "Novo ativo",
      "asset_panel.new_category": "Nova categoria",
      "asset_panel.print_asset_tag": "Imprimir etiqueta do ativo",
      "asset_panel.print_now_btn": "Imprimir agora",
      "asset_panel.toast.agent_no_response_hint": "O agente não respondeu a tempo.",
      "asset_panel.toast.assets_imported": "{{count}} ativo(s) importado(s)",
      "asset_panel.toast.command_queued": "Comando enfileirado com sucesso",
      "asset_panel.toast.create_problem_error": "Erro ao criar o ticket de problema",
      "asset_panel.toast.csv_import_failed": "Falha na importação CSV",
      "asset_panel.toast.device_ignored": "Dispositivo ignorado com sucesso",
      "asset_panel.toast.device_imported": "Dispositivo importado com sucesso para os ativos gerenciados",
      "asset_panel.toast.ignore_device_error": "Erro ao ignorar o dispositivo",
      "asset_panel.toast.import_device_error": "Erro ao importar o dispositivo",
      "asset_panel.toast.import_with_errors": "Importação concluída com erros",
      "asset_panel.toast.itil_correlation_error": "Erro na correlação de problemas ITIL",
      "asset_panel.toast.less_than_3_tickets": "Menos de 3 tickets nos últimos 30 dias.",
      "asset_panel.toast.manual_scan_error": "Erro na varredura manual",
      "asset_panel.toast.problem_ticket_created": "Ticket de problema criado e incidentes vinculados!",
      "asset_panel.toast.queue_command_error": "Não foi possível enfileirar o comando",
      "asset_panel.toast.request_scan_error": "Erro ao solicitar a varredura",
      "asset_panel.toast.scan_completed": "Varredura concluída com sucesso",
      "asset_panel.toast.scan_failed": "Falha na varredura",
      "asset_panel.toast.scan_requested": "{{type}} solicitado",
      "asset_panel.toast.template_downloaded": "Modelo \"asset-import-vorlage.csv\" baixado",
      "asset_panel.toast.template_load_error": "Não foi possível carregar o modelo",
      "asset_remote_client_disconnected": "Cliente desconectado",
      "asset_remote_client_disconnected_desc": "O usuário no dispositivo cliente encerrou a sessão de assistência remota.",
      "asset_remote_closed_desc": "A sessão de assistência remota foi fechada com sucesso.",
      "asset_remote_code_placeholder": "ex. 123 456",
      "asset_remote_conn_disconnected": "Desconectado",
      "asset_remote_conn_failed": "A conexão ao servidor remoto falhou",
      "asset_remote_conn_rejected": "Conexão rejeitada",
      "asset_remote_consent_hint": "Um diálogo de consentimento é exibido na tela do cliente. Peça ao cliente para aceitar.",
      "asset_remote_disconnect": "Desconectar",
      "asset_remote_enter_code_hint": "Insira o código de acesso de 6 dígitos exibido na tela do usuário:",
      "asset_remote_invalid_code": "Código de entrada incorreto",
      "asset_remote_live_focus": "AO VIVO · Foco para entrada de teclado",
      "asset_remote_loading_screen": "Carregando tela ao vivo...",
      "asset_remote_preparing": "Preparando conexão...",
      "asset_remote_protocol2_code_label": "Zwölfstelliger Zugangscode",
      "asset_remote_protocol2_code_placeholder": "ABCD EFGH 2345",
      "asset_remote_protocol2_enter_code_hint": "Geben Sie den zwölfstelligen Zugangscode vom Bildschirm des Benutzers ein:",
      "asset_remote_protocol2_request_desc": "Sendet eine Verbindungsanfrage an den Client-Rechner. Der Benutzer muss zustimmen und den zwölfstelligen Zugangscode übermitteln.",
      "asset_remote_rejected_desc": "A solicitação de conexão foi rejeitada pelo usuário no dispositivo cliente.",
      "asset_remote_req": "Solicitar sessão remota",
      "asset_remote_request_again": "Solicitar novamente",
      "asset_remote_request_desc": "Envia uma solicitação de conexão à máquina cliente. O usuário deve dar seu consentimento e compartilhar um código de acesso de 6 dígitos.",
      "asset_remote_request_title": "Solicitar Suporte Remoto",
      "asset_remote_start_error": "Não foi possível iniciar a sessão de assistência remota",
      "asset_remote_start_new": "Iniciar nova sessão",
      "asset_remote_support": "Suporte remoto integrado",
      "asset_remote_support_desc": "Controle remoto direto da tela sem software externo (TeamViewer/RustDesk).",
      "asset_remote_user_consented": "O usuário consentiu",
      "asset_remote_verifying_code": "Verificando código...",
      "asset_remote_waiting_consent": "Aguardando o consentimento do usuário...",
      "asset_retired": "Aposentado",
      "assets": "Ativos",
      "assign_to": "Atribuir...",
      "assign_to_me": "Atribuir a mim",
      "assigned_agents": "Agentes atribuídos",
      "assigned_to": "Atribuído a",
      "at_risk_title": "Em risco (Aviso de SLA):",
      "attach_local_file": "Anexar arquivo local",
      "attachments": "Anexos",
      "attachments_tools": "Anexos e Ferramentas",
      "attendees_emails": "Participantes (E-mails, separados por vírgula)",
      "automation": "Automação",
      "avg_first_response": "Tempo de primeira resposta",
      "avg_resolution": "Tempo médio de resolução",
      "billable": "Faturável",
      "billable_time": "Faturável: {{time}}",
      "book_on_send": "Registrar ao enviar",
      "book_time_with_reply": "Registrar tempo com a resposta",
      "calendar": "Calendário",
      "calendar_enter_title_warning": "Por favor, insira um título.",
      "calendar_event_attendees": "E-mails dos participantes (opcional, separados por vírgula)",
      "calendar_event_created_error": "Não foi possível criar o evento.",
      "calendar_event_created_success": "Evento criado.",
      "calendar_event_description": "Descrição (opcional)",
      "calendar_event_title": "Título",
      "calendar_meeting_created_error": "Não foi possível criar a reunião.",
      "calendar_meeting_link_copied": "Link da reunião copiado para a área de transferência.",
      "calendar_new_event": "Novo evento",
      "calendar_no_integration_or": "ou",
      "calendar_no_integration_prefix": "Nenhuma integração de calendário ou reunião ativa. Por favor, configure",
      "calendar_no_integration_suffix": "com planejamento de reuniões ativo nas integrações.",
      "calendar_only_event": "Apenas evento do calendário",
      "calendar_talk_meeting": "Reunião Talk",
      "calendar_talk_room_created": "Sala Talk criada.",
      "calendar_teams_meeting": "Reunião do Teams",
      "calendar_teams_meeting_created": "Reunião do Teams criada.",
      "cancel": "Cancelar",
      "canned_responses": "Inserir respostas prontas",
      "canned_responses_short": "Resposta pronta",
      "categories": "Categorias",
      "category": "Categoria",
      "change_priority": "Alterar prioridade...",
      "change_status_after_send": "Após enviar, alterar para",
      "change_ticket_company": "Ticket anderer Firma zuordnen",
      "change_ticket_company_warning": "Portal-Ersteller, CC, Mitarbeiter, Bearbeiter, Kategorie, SLA, Assets und laufende Timer werden für die neue Firma zurückgesetzt.",
      "characters": "caracteres",
      "city": "Cidade",
      "clear_selection": "Limpar seleção",
      "click_to_logout": "Clique para sair",
      "close": "Fechar",
      "close_detail_view": "Fechar visualização detalhada",
      "close_ticket": "Fechar ticket",
      "closed": "Fechados",
      "collapse": "Recolher",
      "collapse_composer": "Recolher editor",
      "collapse_sidebar": "Recolher barra lateral",
      "column_assignee_name": "Atribuído",
      "column_category_name": "Categoria",
      "column_channel": "Canal",
      "column_created_at": "Criado",
      "column_customer_name": "Cliente",
      "column_priority": "Prioridade",
      "column_reply_count": "Respostas",
      "column_requester_name": "Solicitante",
      "column_sla": "SLA",
      "column_status": "Estado",
      "column_subject": "Assunto",
      "column_tags": "Tags",
      "column_ticket_number": "Nº",
      "column_updated_at": "Atualizado",
      "columns_btn": "Colunas",
      "common.abbrechen": "Abbrechen",
      "company_name": "Nome da empresa",
      "company_title": "Empresa",
      "compliance_rate": "Taxa de conformidade",
      "composer_internal": "Interno",
      "composer_internal_placeholder": "Nota interna...",
      "composer_public": "Público",
      "composer_public_placeholder": "Escrever resposta...",
      "configure_columns": "Configurar colunas",
      "connect": "Conectar",
      "contact_and_master_data": "Contato e Dados mestre",
      "contact_person": "Pessoa de contato",
      "contact_person_abbrev": "PC",
      "contract": "Contrato",
      "contract.auto_renew": "Renovação automática",
      "contract.auto_renews_suffix": " (renovado automaticamente)",
      "contract.back_to_overview": "Voltar à visão geral",
      "contract.billing": "Faturamento",
      "contract.billing_model": "Modelo de faturamento",
      "contract.conditions": "Condições",
      "contract.days": "{{count}} dias",
      "contract.end_date": "Data de término",
      "contract.expires_in_days": "Expira em {{count}} dias",
      "contract.first_response": "Primeira resposta",
      "contract.hourly_rate": "Valor por hora",
      "contract.hours_quota": "Cota de horas",
      "contract.included_hours": "Horas incluídas",
      "contract.no_contracts": "Nenhum contrato disponível",
      "contract.no_contracts_desc": "Entre em contato conosco para uma proposta personalizada",
      "contract.notice_period": "Prazo de rescisão: {{count}} dias",
      "contract.period_per": "{{count}}h / período",
      "contract.quota_summary": "{{remaining}} restante(s) ({{percent}}% utilizado)",
      "contract.remaining": "Restante",
      "contract.resolution": "Solução",
      "contract.runtime": "Vigência",
      "contract.sla_tier": "SLA",
      "contract.start_date": "Data de início",
      "contract.status.active": "Ativo",
      "contract.status.expired": "Expirado",
      "contract.status.expiring_soon": "Expira em breve",
      "contract.status.future": "Futuro",
      "contract.subtitle": "Visão geral dos seus contratos ativos e acordos de nível de serviço",
      "contract.unlimited": "Por prazo indeterminado",
      "contract.used": "Utilizado",
      "contracts": "Contratos",
      "copied_to_clipboard": "Copiado para a área de transferência",
      "country": "País",
      "create": "Criar",
      "create_ticket.aehnliche_tickets": "Tickets semelhantes",
      "create_ticket.angehaengte_cloud_dateien": "Arquivos da nuvem anexados:",
      "create_ticket.anhaenge": "Anexos",
      "create_ticket.asset_verknuepfen_optional": "Vincular ativo (opcional):",
      "create_ticket.assets_filtern": "Filtrar ativos:",
      "create_ticket.assets_werden_geladen": "Carregando os ativos...",
      "create_ticket.beschreiben_sie_das_problem_so_detailliert_w": "Descreva o problema com o máximo de detalhes possível...",
      "create_ticket.betroffene_systeme_benutzer_nennen": "Informe os sistemas/usuários afetados",
      "create_ticket.bitte_betreff_und_beschreibung_ausfuellen": "Preencha o assunto e a descrição",
      "create_ticket.bitte_eine_beschreibung_angeben": "Informe uma descrição.",
      "create_ticket.bitte_einen_kunden_auswaehlen": "Selecione um cliente.",
      "create_ticket.bitte_hauptkategorie_waehlen": "Selecione a categoria principal...",
      "create_ticket.bitte_klassifizierung_waehlen": "Selecione a classificação...",
      "create_ticket.bitte_kunde_waehlen": "Selecione o cliente...",
      "create_ticket.bitte_unterkategorie_waehlen": "Selecione a subcategoria...",
      "create_ticket.bitte_zuerst_einen_kunden_waehlen": "Selecione primeiro um cliente...",
      "create_ticket.datei_hochladen": "Enviar arquivo",
      "create_ticket.datei_hochladen_2": "Enviar arquivo",
      "create_ticket.datei_zu_gross_max_10_mb": "Arquivo muito grande (máx. 10 MB)",
      "create_ticket.dateityp_nicht_erlaubt": "Tipo de arquivo não permitido",
      "create_ticket.erste_antwort": "Primeira resposta",
      "create_ticket.fehlermeldungen_und_screenshots_beifuegen": "Anexe mensagens de erro e capturas de tela",
      "create_ticket.keine_mitarbeiter_hinterlegt": "Nenhum funcionário cadastrado",
      "create_ticket.letzte_kunden_tickets": "Últimos tickets do cliente",
      "create_ticket.loesung": "Solução",
      "create_ticket.neues_ticket": "Novo ticket",
      "create_ticket.nur_geschaeftszeiten": "Somente em horário comercial",
      "create_ticket.praeziser_betreff_hilft_bei_der_zuordnung": "Um assunto preciso ajuda na atribuição",
      "create_ticket.priority_high": "Alta",
      "create_ticket.priority_low": "Baixa",
      "create_ticket.priority_medium": "Média",
      "create_ticket.priority_urgent": "Urgente",
      "create_ticket.schritte_zur_reproduktion_angeben": "Informe os passos para reproduzir",
      "create_ticket.stoerung": "Incidente",
      "create_ticket.text_mit_ki_verbessern": "Melhorar o texto com IA",
      "create_ticket.ticket_erstellt": "Ticket criado!",
      "create_ticket.uebernehmen": "Aplicar",
      "create_ticket.ueberschrift": "Título",
      "create_ticket.vielleicht_loest_ein_artikel_das_problem_ber": "Talvez um artigo já resolva o problema?",
      "create_ticket.vorlage_einfuegen": "Inserir modelo",
      "create_ticket.waehlen_sie_einen_kunden_aus_um_dessen_asset": "Selecione um cliente para poder vincular os ativos dele.",
      "create_ticket.werden_bei_erstellung_ausgeloest": "São acionados na criação",
      "create_ticket.zurueck": "Voltar",
      "created_at": "Criado em",
      "critical_priority_sla": "Prioridade / SLA",
      "customer": "Cliente",
      "customer_assets.no_assets": "Nenhum ativo registrado para este cliente. Com um ID de host Zabbix ou um monitor de disponibilidade em um ativo, os avisos de status aparecem aqui.",
      "customer_assets.no_assets_unconfigured": "Nenhum ativo registrado. O Discovery ou uma integração de monitorização pode automatizar o inventário.",
      "customer_assets.no_zabbix_id": "Nenhum ID de host Zabbix no ativo",
      "customer_assets.start_rd": "Iniciar RustDesk",
      "customer_assets.start_tv": "Iniciar TeamViewer",
      "customer_form.adresse_eingeben_um_karte_anzuzeigen": "Informe o endereço para exibir o mapa",
      "customer_form.client_secret": "Client Secret",
      "customer_form.domain_entfernen": "Remover domínio",
      "customer_form.domain_hinzufuegen": "+ Adicionar domínio",
      "customer_form.domains_mit_zugeordneten_mitarbeitern_koenne": "Domínios com funcionários atribuídos não podem ser removidos.",
      "customer_form.geschaeftsfuehrer": "Diretor-geral",
      "customer_form.in_openstreetmap_oeffnen": "Abrir no OpenStreetMap ↗",
      "customer_form.interne_notizen_zu_diesem_kunden": "Notas internas sobre este cliente...",
      "customer_form.kontakt_in_lexoffice_anlegen_uuid_hier_eintr": "Crie o contato no Lexoffice e informe o UUID aqui",
      "customer_form.lexoffice_kontakt_id_uuid": "ID de contato do Lexoffice (UUID)",
      "customer_form.logo_kann_nach_dem_erstellen_des_kunden_hoch": "O logotipo pode ser enviado após a criação do cliente.",
      "customer_form.mitarbeiter_koennen_sich_per_microsoft_konto": "Os funcionários podem entrar com a conta Microsoft",
      "customer_form.mloffice_badge": "Von MLOffice verwaltet",
      "customer_form.mloffice_banner": "Dieser Kunde wird mit MLOffice abgeglichen. Stammdaten (Name, E-Mail, Telefon, Anschrift, USt-ID) werden von MLOffice verwaltet und sind hier gesperrt.",
      "customer_form.mloffice_feld_hinweis": "Dieses Feld wird von MLOffice verwaltet — Änderungen bitte dort vornehmen; sie werden automatisch übernommen.",
      "customer_form.mloffice_geloest": "Verknüpfung gelöst — die Felder sind wieder bearbeitbar.",
      "customer_form.mloffice_loesen": "Verknüpfung lösen…",
      "customer_form.mloffice_loesen_fehler": "Verknüpfung konnte nicht gelöst werden.",
      "customer_form.mloffice_loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "customer_form.mloffice_loest": "Löse…",
      "customer_form.mloffice_verwaltung_hinweis": "Verwaltung der Verknüpfung unter Stammdaten & Organisation → MLOffice (erfordert Systemrechte).",
      "customer_form.registrieren_sie_eine_app_in_azure_portal_ap": "Registre um aplicativo no portal do Azure → Registros de aplicativo. URI de redirecionamento:",
      "customer_form.strasse": "Rua",
      "customer_form.tab_address": "Endereço",
      "customer_form.tab_domains": "Domínios",
      "customer_form.tab_general": "Geral",
      "customer_form.tab_notes": "Notas",
      "customer_form.tab_sso": "SSO",
      "customer_form.tab_tax": "Impostos e SLA",
      "customer_form.zuordnung_ticket_system_kunde_lexoffice_kont": "Vínculo entre o cliente do sistema de tickets → contato do Lexoffice para rascunhos de fatura (Admin → Registro de tempo).",
      "customer_inactive": "Cliente inativo",
      "customer_not_found": "Cliente não encontrado",
      "customer_notified_by_email": "O cliente será notificado por e-mail",
      "customer_number_abbrev": "Nº Cli",
      "customer_portal.action_required": "Ação necessária",
      "customer_portal.action_required_desc": "A equipe de suporte está aguardando o seu retorno sobre este ticket.",
      "customer_portal.action_required_title": "Sua resposta é necessária",
      "customer_portal.assignee": "Responsável",
      "customer_portal.attachments_count": "Anexos ({{count}})",
      "customer_portal.attachments_load_failed": "Weitere Anhänge konnten nicht geladen werden.",
      "customer_portal.back": "← Voltar",
      "customer_portal.back_to_my_tickets": "← Voltar para Meus tickets",
      "customer_portal.close": "Fechar",
      "customer_portal.close_failed": "Não foi possível fechar o ticket.",
      "customer_portal.collapse_replies": "Ältere schließen",
      "customer_portal.compact_replies": "Ältere Antworten sind eingeklappt. Die letzte Antwort bleibt geöffnet.",
      "customer_portal.confirm_close": "Deseja realmente fechar este ticket?",
      "customer_portal.confirm_reopen": "Deseja reabrir este ticket?",
      "customer_portal.contracts.hours_minutes": "{{hours}}h {{minutes}}min",
      "customer_portal.contracts.hours_only": "{{hours}}h",
      "customer_portal.contracts.minutes_only": "{{minutes}}min",
      "customer_portal.create_first_ticket": "Criar novo ticket",
      "customer_portal.created": "Criado",
      "customer_portal.customer_colleague": "Kollegin/Kollege",
      "customer_portal.dashboard.active_count": "{{count}} ativo(s)",
      "customer_portal.dashboard.avg_resolution": "Ø Tempo de solução",
      "customer_portal.dashboard.click_to_view_waiting": "Clique aqui para exibir os tickets",
      "customer_portal.dashboard.create_first_link": "Criar o primeiro ticket →",
      "customer_portal.dashboard.create_new_ticket_link": "Criar novo ticket",
      "customer_portal.dashboard.history_trend": "Histórico de tickets (últimos 12 meses)",
      "customer_portal.dashboard.kb": "Ajuda e base de conhecimento",
      "customer_portal.dashboard.kb_desc": "Guias e perguntas frequentes",
      "customer_portal.dashboard.my_tickets": "Meus tickets",
      "customer_portal.dashboard.no_tickets": "Ainda não há tickets",
      "customer_portal.dashboard.no_tickets_status": "Nenhum ticket",
      "customer_portal.dashboard.open_active": "Aberto / Ativo",
      "customer_portal.dashboard.processing_time": "Tempo de atendimento",
      "customer_portal.dashboard.recent_tickets": "Últimos tickets",
      "customer_portal.dashboard.report_incident": "Relatar incidente",
      "customer_portal.dashboard.report_incident_desc": "Relatar um problema urgente ou uma indisponibilidade",
      "customer_portal.dashboard.reports": "Visão geral e relatórios",
      "customer_portal.dashboard.reports_desc": "Filtrar e analisar todos os tickets",
      "customer_portal.dashboard.search_kb_link": "Pesquisar na base de conhecimento",
      "customer_portal.dashboard.service_request": "Solicitação de serviço",
      "customer_portal.dashboard.service_request_desc": "Solicitações por meio de formulários configuráveis",
      "customer_portal.dashboard.show_all_link": "Exibir todos →",
      "customer_portal.dashboard.status_overview": "Visão geral de status",
      "customer_portal.dashboard.subtitle": "Sua visão geral de suporte em um relance",
      "customer_portal.dashboard.total_tickets": "Total de tickets",
      "customer_portal.dashboard.waiting_tickets_warning": "1 ticket precisa da sua resposta",
      "customer_portal.dashboard.waiting_tickets_warning_plural": "{{count}} tickets precisam da sua resposta",
      "customer_portal.dashboard.welcome": "Bem-vindo",
      "customer_portal.dashboard.widget_unknown": "Widget: {{type}}",
      "customer_portal.dashboard.your_reply": "Sua resposta",
      "customer_portal.details_title": "Detalhes",
      "customer_portal.editor.bold": "Negrito",
      "customer_portal.editor.code": "Código",
      "customer_portal.editor.italic": "Itálico",
      "customer_portal.editor.list": "Lista",
      "customer_portal.expand_replies": "Alle öffnen",
      "customer_portal.files_draft_failed": "Anhänge konnten nicht dauerhaft im Entwurf gespeichert werden.",
      "customer_portal.files_need_reselect": "Anhänge können aus Sicherheitsgründen nicht wiederhergestellt werden. Bitte wählen Sie sie erneut aus.",
      "customer_portal.filters.active": "Ativos",
      "customer_portal.filters.all": "Todos",
      "customer_portal.filters.closed": "Fechados",
      "customer_portal.filters.external": "Extern",
      "customer_portal.filters.waiting_customer": "Sua resposta",
      "customer_portal.history_title": "Histórico",
      "customer_portal.impersonation_banner": "Você está visualizando este portal no modo de personificação (prévia para agentes) como cliente:",
      "customer_portal.incident_badge": "Incidente",
      "customer_portal.kb.title": "Base de conhecimento",
      "customer_portal.load_more_attachments": "Weitere Anhänge laden",
      "customer_portal.login.betreut_von": "APOIADO POR NALVRA",
      "customer_portal.login.claim": "A sua linha direta com o suporte — comunicar, acompanhar, encontrar respostas.",
      "customer_portal.login.copyright_text": "© {{year}} {{appName}}. Todos os direitos reservados.",
      "customer_portal.login.default_subtitle": "Entre para gerenciar suas solicitações.",
      "customer_portal.login.default_welcome": "Bem-vindo ao {{appName}}",
      "customer_portal.login.email": "E-mail",
      "customer_portal.login.email_placeholder": "nome@empresa.com.br",
      "customer_portal.login.eyebrow": "PORTAL DO CLIENTE · DISPONÍVEL 24/7",
      "customer_portal.login.forgot_password": "Esqueceu sua senha?",
      "customer_portal.login.kein_zugang": "Ainda sem acesso? Contacte a sua pessoa de contacto no suporte.",
      "customer_portal.login.kundenanmeldung": "Início de sessão de cliente",
      "customer_portal.login.kundenportal": "PORTAL DO CLIENTE",
      "customer_portal.login.microsoft_signin": "Entrar com a Microsoft",
      "customer_portal.login.mit_hinterlegter_adresse": "Inicie sessão com o endereço de e-mail registado.",
      "customer_portal.login.or_password": "ou com senha",
      "customer_portal.login.password": "Senha",
      "customer_portal.login.password_placeholder": "Sua senha",
      "customer_portal.login.reset_back": "Voltar para o login",
      "customer_portal.login.reset_button": "Enviar link",
      "customer_portal.login.reset_instruction": "Informe seu e-mail. Enviaremos um link para redefinir a senha.",
      "customer_portal.login.reset_sent_message": "Se existir uma conta com este endereço, enviamos um link para redefinir a senha.",
      "customer_portal.login.reset_sent_title": "E-mail enviado",
      "customer_portal.login.reset_title": "Redefinir senha",
      "customer_portal.login.sicherheitszeile": "Ligação encriptada · Acesso apenas a contactos registados",
      "customer_portal.login.signin_button": "Entrar",
      "customer_portal.login.signing_in": "Entrando …",
      "customer_portal.login.sso_available": "Login único disponível",
      "customer_portal.login.sso_failed": "Falha no início de sessão SSO",
      "customer_portal.login.sso_logging_in": "Entrando …",
      "customer_portal.menu.dashboard": "Dashboard",
      "customer_portal.menu.edit_profile": "Editar perfil",
      "customer_portal.menu.logout": "Sair",
      "customer_portal.menu.profile": "Mein Profil",
      "customer_portal.message_placeholder": "Sua mensagem...",
      "customer_portal.nav.contracts": "Contratos",
      "customer_portal.nav.create_request": "Anfrage erstellen",
      "customer_portal.nav.dashboard": "Dashboard",
      "customer_portal.nav.documents": "Documentos",
      "customer_portal.nav.downloads": "Downloads",
      "customer_portal.nav.help": "Hilfe & Kurztour",
      "customer_portal.nav.kb": "Base de conhecimento",
      "customer_portal.nav.my_tickets": "Meus tickets",
      "customer_portal.nav.profile": "Perfil",
      "customer_portal.nav.report_incident": "Relatar incidente",
      "customer_portal.nav.service_request": "Solicitação de serviço",
      "customer_portal.nav.support": "Support erhalten",
      "customer_portal.navigation": "Portal-Navigation",
      "customer_portal.new_ticket": "Novo ticket",
      "customer_portal.new_ticket.add_attachment": "Adicionar",
      "customer_portal.new_ticket.ai_improve_btn": "Melhorar descrição",
      "customer_portal.new_ticket.ai_improving": "Melhorando...",
      "customer_portal.new_ticket.ai_preanswer_title": "Sugestão da IA para o seu problema",
      "customer_portal.new_ticket.ai_suggestion_title": "Sugestão de melhoria da IA",
      "customer_portal.new_ticket.allowed_types_tip": "Apenas os tipos de arquivo configurados (consulte a orientação do seu administrador)",
      "customer_portal.new_ticket.apply": "Aplicar",
      "customer_portal.new_ticket.attach_file": "Anexar arquivo",
      "customer_portal.new_ticket.attachment_plural": "Anexos",
      "customer_portal.new_ticket.attachment_singular": "Anexo",
      "customer_portal.new_ticket.back_step_1": "Zurück zu Schritt 1",
      "customer_portal.new_ticket.back_step_2": "Zurück zu Schritt 2",
      "customer_portal.new_ticket.categories_error": "Kategorien konnten nicht geladen werden.",
      "customer_portal.new_ticket.categories_loading": "Kategorien werden geladen …",
      "customer_portal.new_ticket.category_assignment": "Kategorie zuordnen",
      "customer_portal.new_ticket.category_by_support": "Zuordnung durch den Support",
      "customer_portal.new_ticket.category_hint": "Sie sind unsicher? Lassen Sie die Kategorie offen. Der Support übernimmt die Zuordnung.",
      "customer_portal.new_ticket.category_question": "Welche Kategorie passt zu Ihrem Anliegen?",
      "customer_portal.new_ticket.char_count": "{{count}} caracteres",
      "customer_portal.new_ticket.continue_step_2": "Weiter zu Schritt 2",
      "customer_portal.new_ticket.continue_step_3": "Weiter zu Schritt 3",
      "customer_portal.new_ticket.create": "Criar",
      "customer_portal.new_ticket.create_anyway": "Criar ticket mesmo assim",
      "customer_portal.new_ticket.create_ticket": "Criar ticket",
      "customer_portal.new_ticket.creating": "Criando...",
      "customer_portal.new_ticket.days_count": "{{count}} dias úteis",
      "customer_portal.new_ticket.description_label": "Descrição *",
      "customer_portal.new_ticket.description_placeholder": "Descreva seu problema em detalhes...\\n\\n• O que não está funcionando?\\n• Desde quando o problema ocorre?\\n• Existe alguma mensagem de erro?\\n• Qual sistema / dispositivo está afetado?\\n\\nDica: cole capturas de tela com Ctrl+V",
      "customer_portal.new_ticket.description_required": "Bitte beschreiben Sie Ihr Problem.",
      "customer_portal.new_ticket.discard": "Descartar",
      "customer_portal.new_ticket.drag_more": "Arraste mais arquivos para cá · Ainda {{count}} possível(is)",
      "customer_portal.new_ticket.drag_or_click": "Arraste arquivos para cá ou clique",
      "customer_portal.new_ticket.drop_here": "Solte os arquivos aqui...",
      "customer_portal.new_ticket.error_create_failed": "Erro ao criar o ticket.",
      "customer_portal.new_ticket.expected_first_response": "Primeira resposta",
      "customer_portal.new_ticket.go_to_step": "Schritt {{step}}: {{label}}",
      "customer_portal.new_ticket.hide": "Ocultar",
      "customer_portal.new_ticket.hours_count": "{{count}} horas",
      "customer_portal.new_ticket.insert_template": "Inserir modelo",
      "customer_portal.new_ticket.kb_article_error": "Dieser Artikel konnte nicht geladen werden. Sie können es erneut versuchen oder mit Ihrem Ticket fortfahren.",
      "customer_portal.new_ticket.kb_close_article": "Artikel schließen",
      "customer_portal.new_ticket.kb_did_help": "Hat dieser Artikel Ihr Problem gelöst?",
      "customer_portal.new_ticket.kb_draft_retained": "Ihr Ticketentwurf bleibt erhalten. Sie entscheiden, ob Sie ihn weiter bearbeiten.",
      "customer_portal.new_ticket.kb_feedback_error": "Ihre Rückmeldung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut. Ihr Entwurf bleibt erhalten.",
      "customer_portal.new_ticket.kb_helped": "Artikel hat mir geholfen",
      "customer_portal.new_ticket.kb_loading_article": "Artikel wird geladen",
      "customer_portal.new_ticket.kb_resolved_message": "Ihre Rückmeldung wurde gespeichert. Es wurde kein Ticket erstellt.",
      "customer_portal.new_ticket.kb_resolved_title": "Schön, dass die Anleitung geholfen hat",
      "customer_portal.new_ticket.kb_resume_draft": "Ticketentwurf weiter bearbeiten",
      "customer_portal.new_ticket.kb_retry": "Erneut laden",
      "customer_portal.new_ticket.kb_saved_draft": "Ihr Entwurf bleibt für Sie gespeichert, falls Sie später doch Unterstützung benötigen.",
      "customer_portal.new_ticket.kb_searching": "Lösungen werden gesucht",
      "customer_portal.new_ticket.kb_suggestions_hint": "Passende Anleitungen aus der Wissensbasis. Lesen Sie einen Artikel, bevor Sie Ihr Ticket erstellen.",
      "customer_portal.new_ticket.kb_suggestions_title": "Vielleicht ist die Lösung schon da",
      "customer_portal.new_ticket.kb_to_dashboard": "Zurück zum Dashboard",
      "customer_portal.new_ticket.max_files": "Máx. {{count}} arquivos",
      "customer_portal.new_ticket.max_size": "Máx. {{count}} MB / arquivo",
      "customer_portal.new_ticket.minutes_count": "{{count}} minutos",
      "customer_portal.new_ticket.no_category": "Selecione uma categoria...",
      "customer_portal.new_ticket.optional": "Optional",
      "customer_portal.new_ticket.preanswer_might_resolve": "Isso ajudou você? Então talvez não seja necessário abrir um ticket.",
      "customer_portal.new_ticket.presubmit_kb_desc": "Nenhum artigo adequado? Sem problema — crie o seu ticket.",
      "customer_portal.new_ticket.presubmit_kb_title": "Isto já pode resolver o seu problema",
      "customer_portal.new_ticket.prio_desc_critical": "Imediato",
      "customer_portal.new_ticket.prio_desc_high": "Urgente",
      "customer_portal.new_ticket.prio_desc_low": "Pode esperar",
      "customer_portal.new_ticket.prio_desc_medium": "Normal",
      "customer_portal.new_ticket.progress": "Fortschritt der Ticketerstellung",
      "customer_portal.new_ticket.relevant_articles": "Artigos relevantes:",
      "customer_portal.new_ticket.reply_by_email_tip": "Você também pode responder a este ticket por e-mail",
      "customer_portal.new_ticket.resolution": "Solução",
      "customer_portal.new_ticket.response_time_typical": "Resposta normalmente dentro de poucas horas",
      "customer_portal.new_ticket.retry_categories": "Erneut laden",
      "customer_portal.new_ticket.screenshot_tip": "Cole capturas de tela com Ctrl+V",
      "customer_portal.new_ticket.similar_tickets": "Tickets semelhantes",
      "customer_portal.new_ticket.step_attachments": "Anhänge",
      "customer_portal.new_ticket.step_attachments_detail": "Kategorie, Anhänge und Absenden",
      "customer_portal.new_ticket.step_count": "Schritt {{step}} von 3",
      "customer_portal.new_ticket.step_details": "Details",
      "customer_portal.new_ticket.step_details_detail": "Beschreibung und Priorität",
      "customer_portal.new_ticket.step_subject": "Betreff",
      "customer_portal.new_ticket.step_subject_detail": "Person, Betreff und Wissensbasis",
      "customer_portal.new_ticket.subject_desc_required": "Assunto e descrição são obrigatórios.",
      "customer_portal.new_ticket.subject_label": "Assunto *",
      "customer_portal.new_ticket.subject_placeholder": "Breve descrição do problema ou da sua solicitação",
      "customer_portal.new_ticket.subject_required": "Bitte geben Sie einen Betreff ein.",
      "customer_portal.new_ticket.subtitle": "Falha técnica ou problema urgente — será encaminhado ao suporte como ticket.",
      "customer_portal.new_ticket.subtitle_2": "Descreva a sua solicitação e cuidaremos dela.",
      "customer_portal.new_ticket.success_desc": "Muito obrigado. Entraremos em contato com você o mais rápido possível.",
      "customer_portal.new_ticket.success_title": "Ticket criado!",
      "customer_portal.new_ticket.template_btn": "Exemplo",
      "customer_portal.new_ticket.view_ticket": "Ver ticket",
      "customer_portal.no_attachments": "Keine Anhänge vorhanden.",
      "customer_portal.no_tickets_create_desc": "Crie o seu primeiro ticket.",
      "customer_portal.no_tickets_filter_desc": "Tente outro filtro.",
      "customer_portal.no_tickets_search_desc": "Tente outro termo de busca.",
      "customer_portal.no_tickets_title": "Nenhum ticket encontrado",
      "customer_portal.pagination_of": "von",
      "customer_portal.password.btn": "Alterar senha",
      "customer_portal.password.cancel": "Cancelar",
      "customer_portal.password.changing": "Alterando...",
      "customer_portal.password.confirm": "Confirmar nova senha",
      "customer_portal.password.current": "Senha atual",
      "customer_portal.password.error_change": "Erro ao alterar.",
      "customer_portal.password.error_min_length": "No mínimo 8 caracteres.",
      "customer_portal.password.error_mismatch": "As senhas não coincidem.",
      "customer_portal.password.error_same": "A nova senha precisa ser diferente.",
      "customer_portal.password.logout": "Sair",
      "customer_portal.password.mismatch_warning": "As senhas não coincidem",
      "customer_portal.password.must_change_desc": "Altere a sua senha antes de continuar.",
      "customer_portal.password.new": "Nova senha (mín. 8 caracteres)",
      "customer_portal.password.redirecting": "Você está sendo redirecionado...",
      "customer_portal.password.success": "Senha alterada com sucesso!",
      "customer_portal.password.title": "Alterar senha",
      "customer_portal.priority_help.high": "Mehrere Mitarbeitende oder eine wichtige Funktion sind stark beeinträchtigt. Es gibt keine praktikable Ausweichlösung, der übrige Betrieb läuft jedoch weiter.",
      "customer_portal.priority_help.low": "Kleine Einschränkung oder allgemeine Frage. Sie können normal weiterarbeiten, zum Beispiel bei einem Darstellungsfehler oder einem Änderungswunsch.",
      "customer_portal.priority_help.medium": "Die Arbeit ist eingeschränkt, aber eine Ausweichlösung ist möglich. Beispiel: Ein Drucker fällt aus, ein anderer kann genutzt werden.",
      "customer_portal.priority_help.urgent": "Der Betrieb oder ein geschäftskritischer Prozess steht still. Es gibt keine Ausweichlösung, zum Beispiel bei einem vollständigen Ausfall des zentralen Systems. Bitte nicht nur wegen eines persönlichen Wunschtermins wählen.",
      "customer_portal.processing_time": "Tempo de atendimento",
      "customer_portal.profile.cancel": "Cancelar",
      "customer_portal.profile.change_password_btn": "Alterar senha",
      "customer_portal.profile.change_photo": "Profilbild ändern",
      "customer_portal.profile.closed": "Fechados",
      "customer_portal.profile.company": "Empresa",
      "customer_portal.profile.company_account": "Empresa e conta",
      "customer_portal.profile.days_count": "{{count}} dia(s) útil(eis)",
      "customer_portal.profile.department": "Departamento",
      "customer_portal.profile.edit": "Editar",
      "customer_portal.profile.email": "E-mail",
      "customer_portal.profile.error_save": "Erro ao salvar",
      "customer_portal.profile.error_upload": "Erro ao enviar",
      "customer_portal.profile.first_name": "Nome",
      "customer_portal.profile.first_response": "Primeira resposta",
      "customer_portal.profile.hours_count": "{{count}} h",
      "customer_portal.profile.last_name": "Sobrenome",
      "customer_portal.profile.loading": "Carregando o perfil...",
      "customer_portal.profile.location": "Localidade",
      "customer_portal.profile.member_since": "Membro desde",
      "customer_portal.profile.minutes_count": "{{count}} min",
      "customer_portal.profile.mobile": "Celular",
      "customer_portal.profile.mobile_placeholder": "ex.: +49 170 12345",
      "customer_portal.profile.open": "Abertos",
      "customer_portal.profile.personal_data": "Dados pessoais",
      "customer_portal.profile.phone": "Telefone",
      "customer_portal.profile.phone_placeholder": "ex.: +49 221 12345",
      "customer_portal.profile.position": "Cargo",
      "customer_portal.profile.resolution": "Solução",
      "customer_portal.profile.save": "Salvar",
      "customer_portal.profile.security": "Segurança",
      "customer_portal.profile.security_desc": "Altere a sua senha regularmente para mais segurança.",
      "customer_portal.profile.service_level": "Nível de serviço",
      "customer_portal.profile.show_dashboard": "Exibir dashboard",
      "customer_portal.profile.sla_tier": "Nível de SLA",
      "customer_portal.profile.sso_active": "Autenticação SSO ativa",
      "customer_portal.profile.success_photo": "Foto do perfil atualizada",
      "customer_portal.profile.success_update": "Perfil atualizado com sucesso",
      "customer_portal.profile.ticket_overview": "Visão geral dos tickets",
      "customer_portal.profile.total": "Total",
      "customer_portal.reopen": "Reabrir",
      "customer_portal.reopen_failed": "Não foi possível reabrir o ticket.",
      "customer_portal.reopen_ticket": "Reabrir ticket",
      "customer_portal.replies_load_failed": "Ältere Antworten konnten nicht geladen werden.",
      "customer_portal.reply_btn": "Responder",
      "customer_portal.reply_failed": "Não foi possível enviar a sua resposta. Tente novamente.",
      "customer_portal.reply_plural": "Respostas",
      "customer_portal.reply_singular": "Resposta",
      "customer_portal.request_badge": "Solicitação",
      "customer_portal.requests.attachments": "Anexos",
      "customer_portal.requests.category": "Categoria",
      "customer_portal.requests.description": "Descrição",
      "customer_portal.requests.priority": "Prioridade",
      "customer_portal.search_label": "Tickets suchen",
      "customer_portal.search_placeholder": "Buscar nº do ticket ou assunto...",
      "customer_portal.sending": "Enviando...",
      "customer_portal.service_level": "Nível de serviço",
      "customer_portal.show_older_replies": "Exibir {{count}} respostas mais antigas...",
      "customer_portal.sla.met": "Cumprido",
      "customer_portal.sla.on_track": "Dentro do prazo",
      "customer_portal.sla.overdue": "Vencido",
      "customer_portal.sla.warning": "Vence em breve",
      "customer_portal.source": "Origem",
      "customer_portal.source_portal": "Portal",
      "customer_portal.stop_impersonation": "Encerrar personificação",
      "customer_portal.support_team": "Equipe de suporte",
      "customer_portal.ticket_closed_desc": "Este ticket está fechado.",
      "customer_portal.ticket_load_failed": "Ticket konnte nicht geladen werden",
      "customer_portal.ticket_load_failed_desc": "Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "customer_portal.ticket_not_found": "Ticket não encontrado",
      "customer_portal.ticket_owner": "Ihr zuständiger Support-Agent",
      "customer_portal.ticket_plural": "Tickets",
      "customer_portal.ticket_singular": "Ticket",
      "customer_portal.tickets_load_failed": "Tickets konnten nicht geladen werden",
      "customer_portal.tickets_load_failed_desc": "Ihre Daten wurden nicht verändert.",
      "customer_portal.times_title": "Tempos",
      "customer_portal.unassigned_owner": "Noch nicht zugewiesen",
      "customer_portal.unsaved_warning": "Ihr nicht gesendeter Entwurf geht beim Verlassen möglicherweise verloren.",
      "customer_portal.updated": "Atualizado",
      "customer_portal.via_email": "por e-mail",
      "customer_portal.write_reply": "Escrever resposta",
      "customer_portal.you": "Você",
      "customer_tickets_summary": "{{open}} abertos / {{total}} total",
      "customers": "Clientes",
      "customize": "Personalizar",
      "dark_mode": "Modo escuro",
      "dashboard": "Painel de controle",
      "dashboard_sub": "Aqui estão seus KPIs operacionais, estados de SLA e estatísticas de tickets.",
      "days_ago": "Há {{count}} dias",
      "delete": "Excluir",
      "density": "Densidade:",
      "density_comfort_label": "Komfort",
      "density_comfortable": "Normal",
      "density_compact": "Compacto",
      "density_spacious": "Espaçoso",
      "density_standard_label": "Standard",
      "device_actions": "Geräte & Lizenzen",
      "device_actions_hint": "Fernwartung, Remote-Terminal, Behebung und Lizenzen der verknüpften Geräte",
      "document.all": "Todos",
      "document.category.certificate": "Certificado",
      "document.category.contract": "Contrato",
      "document.category.correspondence": "Correspondência",
      "document.category.general": "Geral",
      "document.category.invoice": "Fatura",
      "document.category.manual": "Manual",
      "document.category.report": "Relatório",
      "document.none_found": "Nenhum documento encontrado",
      "document.none_found_desc": "Tente outro termo de busca",
      "document.none_shared": "Ainda não há documentos compartilhados com você",
      "document.none_shared_desc": "O seu contato pode disponibilizar documentos para você aqui",
      "document.plural": "Documentos",
      "document.search_placeholder": "Pesquisar documentos...",
      "document.singular": "Documento",
      "document.subtitle": "Os seus documentos, contratos e arquivos compartilhados",
      "document.total_suffix": "no total",
      "domains": "Domínios",
      "draft_present": "Rascunho",
      "draft_saved": "Rascunho salvo",
      "drag_to_move": "{{label}} (arrastar para mover)",
      "drag_to_sort": "Arrastar para ordenar, clicar para mostrar/ocultar",
      "duration": "Duração (min.)",
      "duration_minutes": "{{count}} minutos",
      "edit": "Editar",
      "edit_customer": "Editar cliente",
      "edit_master_data_admin": "Editar dados mestre na administração",
      "edit_widgets_title": "Mostrar e ordenar widgets",
      "email": "E-mail",
      "email_channel": "Canal de e-mail",
      "employee_form.account_erstellt": "Conta criada:",
      "employee_form.bitte_zuerst_kunde_auswaehlen": "Selecione primeiro o cliente",
      "employee_form.dieser_mitarbeiter_hat_noch_keinen_zugang_zu": "Este funcionário ainda não tem acesso ao portal do cliente. Crie uma conta com senha.",
      "employee_form.domain_waehlen": "Selecionar domínio",
      "employee_form.domains_werden_geladen": "Carregando os domínios...",
      "employee_form.e_mail_server_nicht_konfiguriert": "Servidor de e-mail não configurado",
      "employee_form.initialpasswort_vergeben": "Definir a senha inicial...",
      "employee_form.interne_notizen_zum_mitarbeiter": "Notas internas sobre o funcionário...",
      "employee_form.kein_portal_zugang_vorhanden": "Nenhum acesso ao portal disponível",
      "employee_form.keine_domains_fuer_diesen_kunden_hinterlegt": "Nenhum domínio cadastrado para este cliente.",
      "employee_form.kunde_auswaehlen": "Selecionar cliente",
      "employee_form.lade_account_informationen": "Carregando as informações da conta...",
      "employee_form.leer_lassen_wenn_kein_portal_zugang_benoetig": "Deixe em branco se não for necessário acesso ao portal (ex.: com SSO).",
      "employee_form.letzter_login": "Último login:",
      "employee_form.neues_passwort": "Nova senha...",
      "employee_form.neues_passwort_min_8_zeichen": "Nova senha (mín. 8 caracteres)",
      "employee_form.passwort_fuer_neuen_account_min_8_zeichen": "Senha da nova conta (mín. 8 caracteres)",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge": "Exigir alteração de senha no primeiro login",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge_2": "Exigir alteração de senha no primeiro login",
      "employee_form.passwortaenderung_beim_naechsten_login_erzwi": "Exigir alteração de senha no próximo login",
      "employee_form.profilbild_kann_nach_dem_erstellen_hochgelad": "A foto de perfil pode ser enviada após a criação.",
      "employee_form.pw_aenderung_ausstehend": "Alteração de senha pendente",
      "employee_form.reset_link_24h_gueltig": "Link de redefinição (válido por 24 h):",
      "employee_form.tab_access": "Portal do cliente",
      "employee_form.tab_it": "TI e estação de trabalho",
      "employee_form.tab_notes": "Notas",
      "employee_form.tab_personal": "Pessoal",
      "employee_form.tab_work": "Trabalho e contato",
      "employee_form.weitere_it_informationen_wie_betriebssystem": "Outras informações de TI, como sistema operacional, softwares instalados etc., podem ser registradas nas notas.",
      "employee_form.z_b_koeln_buero_3_og": "ex.: São Paulo, escritório 3º andar",
      "employees": "Funcionários",
      "employees_ca": "Funcionários (aprox.)",
      "end_edit": "Finalizar edição",
      "enter_title_error": "Por favor, insira um título.",
      "escalate": "Escalar",
      "escalated": "Escalados",
      "escalated_badge": "Escalado",
      "expand_sidebar": "Expandir barra lateral",
      "expired": "Expirado",
      "expires_at": "Expira em",
      "expiring_soon": "Expira em breve",
      "export_csv": "Arquivo CSV",
      "export_pdf": "Documento PDF",
      "export_png": "Gráfico PNG",
      "export_xlsx": "Excel (XLSX)",
      "filter_active": "Filtro ativo",
      "filter_all_az": "Todos A–Z",
      "filter_list_placeholder": "Filtrar lista...",
      "filter_open_first": "Abertos primeiro",
      "filter_open_only": "Apenas com abertos",
      "filter_with_sla": "Com nível SLA",
      "first_post_attachments": "Anexos da primeira mensagem",
      "first_response": "Primeira resposta",
      "follow_ups": "Aguardando cliente",
      "generating": "Gerando...",
      "greeting_day": "Bom dia, {{name}} 👋",
      "held_review": "Verificação necessária",
      "high_priority": "Alta prioridade",
      "hours": "Horas",
      "hours_ago": "Há {{count}} h",
      "inactive": "Inativo",
      "included_hours": "Horas incl.",
      "industry": "Setor",
      "internal": "Interno",
      "internal_chat": "Chat interno",
      "internal_note": "Nota interna",
      "internal_notes": "Notas internas",
      "internal_notes_placeholder": "Notas internas sobre o cliente...",
      "invalid_datetime_error": "Data ou hora inválida.",
      "just_now": "Agora mesmo",
      "kb.all_articles": "Todos os artigos",
      "kb.author": "Autor",
      "kb.back_to_overview": "Voltar à visão geral",
      "kb.browse_more": "← Explorar mais artigos",
      "kb.no_articles": "Ainda não há artigos de conhecimento disponíveis",
      "kb.no_articles_desc": "Em breve, artigos úteis aparecerão aqui",
      "kb.pinned": "Fixado",
      "kb.read_time": "{{count}} min de leitura",
      "kb.search_placeholder": "O que você procura? Ex.: VPN, senha, e-mail...",
      "kb.subtitle": "Guias, dicas e orientações para as suas dúvidas",
      "kb.try_different_search": "Tente outro termo de busca",
      "kb.updated_at": "Atualizado em {{date}}",
      "kb.views_count": "{{count}} visualizações",
      "keyboard_shortcuts": "Atalhos de teclado",
      "knowledge": "Base de conhecimento",
      "knowledge_base": "Base de conhecimento",
      "kpi_held": "Remetente indefinido",
      "kpi_important": "importante",
      "kpi_open": "aberto",
      "kpi_sla_breached": "Violação de SLA",
      "kunde_loeschen.artikel": "Wissensartikel",
      "kunde_loeschen.bestaetigung_label": "Zur Bestätigung den Firmennamen eingeben",
      "kunde_loeschen.connectoren": "Connectoren",
      "kunde_loeschen.dokumente": "Dokumente",
      "kunde_loeschen.einleitung": "Dieser Kunde hat keine Tickets und keine Rechnungen. Er kann vollständig entfernt werden — mitsamt seinem Mandantenbereich in der Datenbank. Das lässt sich nicht rückgängig machen.",
      "kunde_loeschen.endgueltig_loeschen": "Endgültig löschen",
      "kunde_loeschen.fehlgeschlagen": "Das Löschen ist fehlgeschlagen.",
      "kunde_loeschen.geraete": "Geräte im Inventar",
      "kunde_loeschen.lizenzen": "Softwarelizenzen",
      "kunde_loeschen.mitarbeiter": "Mitarbeiter",
      "kunde_loeschen.netzgeraete": "Gefundene Netzwerkgeräte",
      "kunde_loeschen.nichts_dran": "An diesem Kunden hängen keine weiteren Daten.",
      "kunde_loeschen.portalbenutzer": "Portalzugänge",
      "kunde_loeschen.pruefung_fehlgeschlagen": "Die Prüfung ist fehlgeschlagen.",
      "kunde_loeschen.titel": "Kunde endgültig löschen",
      "kunde_loeschen.tokens": "API-Token",
      "kunde_loeschen.vertraege": "Verträge",
      "kunde_loeschen.wird_geprueft": "Wird geprüft …",
      "kunde_loeschen.wird_mitgeloescht": "Wird mitgelöscht",
      "kunde_loeschen.zeiten": "Zeiteinträge",
      "language": "Idioma",
      "license.cluster_audit": "Auditoria",
      "license.cluster_balance": "Balanço",
      "license.cluster_calc": "Calculadora",
      "license.cluster_contracts": "Contratos e licenças",
      "license.cluster_optimize": "Otimização",
      "license.tab_ad_coupling": "Acoplamento CAL-AD",
      "license.tab_cal_calc": "Calculadora de CAL",
      "license.tab_catalog": "Catálogo de software",
      "license.tab_contracts": "Contratos",
      "license.tab_dashboard": "Balanço de licenças e Tendências",
      "license.tab_licenses": "Gerenciamento de licenças",
      "license.tab_more_views": "Mais visualizações",
      "license.tab_reclaims": "Otimização e Recuperações",
      "license.tab_remediation": "Remediação",
      "license.tab_sealed": "Arquivo de auditoria",
      "license.tab_sql_calc": "Calculadora de licenças SQL",
      "license.tab_steering": "Controle",
      "license.tab_suite_config": "Configurador de suítes",
      "license_compliance.actions": "Ações",
      "license_compliance.assign_license_metric": "Atribuir métrica de licença",
      "license_compliance.confirm_delete_assignment": "Deseja realmente excluir a atribuição?",
      "license_compliance.confirm_delete_contract": "Deseja realmente excluir o contrato? As licenças vinculadas permanecem, mas serão desvinculadas do contrato.",
      "license_compliance.contract_expiry_alert": "Vencimento do contrato",
      "license_compliance.deficit_forecast_desc": "Com base nas varreduras ao vivo, na data de aniversário serão cobradas taxas de complementação para os produtos sublicenciados.",
      "license_compliance.edit_contract": "Editar contrato",
      "license_compliance.edit_license": "Editar licença",
      "license_compliance.expired_contracts_title": "Contratos de software vencidos identificados!",
      "license_compliance.expired_contracts_warning_desc": "As licenças atribuídas a esses contratos são ignoradas no cálculo de conformidade.",
      "license_compliance.forecasted_payment": "Pagamento adicional previsto",
      "license_compliance.license_deficit_alert": "Déficit de licenças",
      "license_compliance.mark_license_required_btn": "Marcar como sujeito a licenciamento",
      "license_compliance.new_contract": "Criar novo contrato",
      "license_compliance.new_license": "Criar nova licença",
      "license_compliance.no_deficit_desc": "Parabéns! As suas atribuições Microsoft Core/CAL cobrem todos os resultados da varredura.",
      "license_compliance.not_catalogued": "Não catalogado",
      "license_compliance.reconciliation_desc": "Inicia um ciclo manual de reconciliação para este locatário. Recalcula ao vivo o VM stacking, o estado da descoberta WMI, os períodos de Software Assurance e a validade dos contratos.",
      "license_compliance.reconciliation_running": "Reconciliação em andamento...",
      "license_compliance.run_reconciliation": "Executar reconciliação",
      "license_compliance.sam_warnings_title": "Avisos de SAM e conformidade",
      "license_compliance.save_contract": "Salvar contrato",
      "license_compliance.save_license": "Salvar licença",
      "license_compliance.seal_audit": "Selar auditoria",
      "license_compliance.seal_audit_btn": "Selar com validade jurídica",
      "license_compliance.sealing": "Selando...",
      "license_compliance.toast.add_suite_component_error": "Erro ao atribuir o componente da suíte",
      "license_compliance.toast.assignment_completed": "Atribuição de licença realizada com sucesso.",
      "license_compliance.toast.assignment_error": "Erro ao realizar a atribuição",
      "license_compliance.toast.bulk_classify_error": "Erro na classificação em massa",
      "license_compliance.toast.bulk_classify_success": "{{count}} registros de software classificados com sucesso.",
      "license_compliance.toast.calc_audit_error": "Erro ao calcular a auditoria de licenças",
      "license_compliance.toast.contract_created": "Contrato criado com sucesso.",
      "license_compliance.toast.contract_deleted": "Contrato excluído.",
      "license_compliance.toast.contract_updated": "Contrato atualizado com sucesso.",
      "license_compliance.toast.create_purchase_req_error": "Erro ao criar a solicitação de compra",
      "license_compliance.toast.delete_contract_error": "Erro ao excluir o contrato",
      "license_compliance.toast.delete_license_error": "Erro ao excluir a licença",
      "license_compliance.toast.delete_suite_component_error": "Erro ao excluir a atribuição",
      "license_compliance.toast.license_created": "Licença criada com sucesso.",
      "license_compliance.toast.license_deleted": "Licença excluída.",
      "license_compliance.toast.license_updated": "Licença atualizada com sucesso.",
      "license_compliance.toast.load_customers_error": "Erro ao carregar a lista de clientes",
      "license_compliance.toast.purchase_req_created": "Solicitação de compra de {{units}}x {{model}} (true-up: {{cost}}) criada como ticket {{ticket}}.",
      "license_compliance.toast.reconcile_completed": "Reconciliação concluída com sucesso. Os indicadores de conformidade foram recalculados ao vivo.",
      "license_compliance.toast.reconcile_error": "Erro na reconciliação",
      "license_compliance.toast.sam_settings_saved": "Configurações de SAM salvas com sucesso.",
      "license_compliance.toast.save_contract_error": "Erro ao salvar o contrato",
      "license_compliance.toast.save_license_error": "Erro ao salvar a licença",
      "license_compliance.toast.save_sam_settings_error": "Erro ao salvar as configurações de SAM",
      "license_compliance.toast.seal_audit_error": "Erro ao selar a auditoria de licenças",
      "license_compliance.toast.seal_audit_success": "Auditoria de licenças selada com sucesso.",
      "license_compliance.toast.suite_component_added": "Componente atribuído à suíte com sucesso.",
      "license_compliance.toast.suite_component_deleted": "Atribuição excluída.",
      "license_compliance.toast.uninstall_error": "Erro ao iniciar as desinstalações",
      "license_compliance.toast.uninstall_triggered": "Comandos de desinstalação enfileirados.",
      "license_compliance.update_contract": "Atualizar contrato",
      "license_compliance.update_license": "Atualizar licença",
      "licenses": "Licenças",
      "light_mode": "Modo claro",
      "link_asset_btn": "+ Vincular Ativo",
      "live_activity": "Atividade ao vivo",
      "loading": "Wird geladen…",
      "loading_ellipsis": "Carregando...",
      "location_on_map": "Localização no mapa",
      "login.abbrechen": "Cancelar",
      "login.administratoradresse_konnte_nicht_geaendert_werden": "Die Administratoradresse konnte nicht geändert werden.",
      "login.adresse_aendern": "Adresse ändern",
      "login.adresse_wird_geaendert": "Adresse wird geändert…",
      "login.aendern": "Alterar",
      "login.aktivierung": "A ativar…",
      "login.aktivierung_fehlgeschlagen_code_pruefen": "Falha na ativação. Verifique o código.",
      "login.alle_rechte_vorbehalten": "· Todos os direitos reservados.",
      "login.anmelden": "Iniciar sessão",
      "login.anmelden_laeuft": "A iniciar sessão…",
      "login.anmeldung": "A iniciar sessão…",
      "login.bestaetigen": "Confirmar",
      "login.bitte_geben_sie_eine_gueltige_e_mail_adresse": "Informe um endereço de e-mail válido.",
      "login.bitte_geben_sie_ihr_passwort_ein": "Informe a sua senha.",
      "login.bitte_geben_sie_zuerst_ihre_e_mail_adresse_e": "Informe primeiro o seu endereço de e-mail.",
      "login.claim": "Service desk, ativos e licenças — uma base de dados, um processo.",
      "login.datenschutz": "Privacidade",
      "login.e_mail_adresse_erfolgreich_geaendert": "E-Mail-Adresse erfolgreich geändert. Melden Sie sich jetzt mit der neuen Adresse an.",
      "login.ein_fehler_ist_aufgetreten": "Ocorreu um erro.",
      "login.einloggen_schliessen": "Entrar e fechar",
      "login.erstanmeldung": "Primeiro início de sessão:",
      "login.falls_ein_konto_existiert_wurde_eine_e_mail": "Se existir uma conta, um e-mail de redefinição foi enviado.",
      "login.fehler_beim_laden_des_mfa_setups": "Não foi possível carregar a configuração de MFA",
      "login.fehler_beim_ueberpruefen_der_e_mail_adresse": "Não foi possível verificar o endereço de e-mail.",
      "login.geben_sie_den_6_stelligen_code_aus_ihrer_aut": "Digite o código de 6 dígitos do seu aplicativo autenticador ou um código de recuperação.",
      "login.geschaeftliche_e_mail": "E-mail profissional",
      "login.ihr_account_ist_deaktiviert": "A sua conta está desativada.",
      "login.ihr_administrator_erfordert_die_einrichtung": "O seu administrador exige a configuração da autenticação de dois fatores.",
      "login.impressum": "Aviso legal",
      "login.kunden_account_erkannt": "Conta de cliente detetada",
      "login.manueller_schluessel": "Chave manual",
      "login.melden_sie_sich_an_ihrem_service_desk_an": "Inicie sessão no seu service desk.",
      "login.mfa_aktivieren_weiter": "Ativar MFA e continuar",
      "login.mfa_einrichtung_erforderlich": "É necessário configurar a MFA",
      "login.mfa_einrichtung_fehlgeschlagen": "Falha ao configurar a MFA.",
      "login.mfa_erfolgreich_aktiviert": "MFA ativada com êxito",
      "login.neue_geschaeftliche_e_mail": "Neue geschäftliche E-Mail",
      "login.oder": "OU",
      "login.passwort": "Palavra-passe",
      "login.qr_code_fuer_die_authenticator_app": "Código QR para a aplicação de autenticação",
      "login.sechsstelliger_verifizierungscode": "Código de verificação de 6 dígitos",
      "login.sende": "A enviar…",
      "login.sicherheitszeile": "AES-256 · Dois fatores · Alojamento próprio",
      "login.sicherheitszeile_kurz": "AES-256 · Zwei-Faktor",
      "login.sie_werden_automatisch_zum_kundenportal_weit": "Você será redirecionado automaticamente ao portal do cliente para fazer login...",
      "login.single_sign_on_entra_id": "Single Sign-On (Entra ID)",
      "login.speichern_sie_diese_einmal_wiederherstellung": "Guarde bem estes códigos de recuperação de uso único! Você pode usá-los caso perca o acesso ao seu aplicativo.",
      "login.sso_anmeldung_fehlgeschlagen": "Falha no início de sessão SSO",
      "login.startkonto_bestaetigt_adresse_festlegen": "Die Zugangsdaten des Startkontos wurden bestätigt. Legen Sie jetzt die geschäftliche Adresse für den Administrator fest.",
      "login.ueberpruefe": "Verificando...",
      "login.ungueltiger_oder_abgelaufener_mfa_code": "Código MFA inválido ou expirado.",
      "login.verifiziere": "A verificar…",
      "login.weiter": "Continuar",
      "login.willkommen_zurueck": "Bem-vindo de volta",
      "login.zurueck_zum_login": "Voltar ao login",
      "login.zuruecksetzen": "Repor",
      "login.zwei_faktor_code_totp": "Código de dois fatores (TOTP)",
      "logout": "Sair",
      "main_navigation_rail": "Barra de navegação principal",
      "managing_director": "Diretor executivo",
      "managing_director_abbrev": "DG",
      "managing_director_prefix": "Diretoria:",
      "mark_all_read": "Marcar todas como lidas",
      "mark_as_resolved": "Marcar como resolvido",
      "mati.connection_error": "Erro de conexão",
      "mati.delete": "Excluir",
      "mati.error_failed_connection": "Falha na conexão com o serviço de IA.",
      "mati.error_generation": "Erro ao gerar a resposta. Tente novamente.",
      "mati.gdpr_warning": "Filtro GDPR ativo: os dados pessoais são anonimizados automaticamente antes da transmissão.",
      "mati.greeting": "Olá {{name}}! Eu sou {{mascot}}. Como posso apoiar você no seu trabalho hoje? 🔮\\n\\nVocê pode me perguntar sobre:\\n- O status do sistema ou a carga de trabalho dos agentes\\n- Buscas de tickets (\"Encontre tickets não resolvidos com prioridade alta\")\\n- Criação de tickets (\"Crie um ticket: cartucho de impressora vazio no 2º andar\")",
      "mati.history": "Histórico",
      "mati.input_placeholder": "Pergunte-me sobre tickets, carga de trabalho ou crie um ticket...",
      "mati.new_chat": "Novo chat",
      "mati.online_intelligent": "Online e inteligente",
      "mati.rename": "Renomear",
      "mati.restore_bead": "Exibir o assistente flutuante",
      "mati.restore_bead_tooltip": "Exibir novamente o assistente flutuante (bead) na borda da tela",
      "mati.send_btn": "Enviar",
      "mati.suggest.create_ticket.desc": "Impressora com defeito no 1º andar",
      "mati.suggest.create_ticket.prompt": "Crie um ticket para uma impressora com defeito no 1º andar, prioridade média.",
      "mati.suggest.create_ticket.title": "Criar ticket",
      "mati.suggest.search_tickets.desc": "Consulta de busca \"banco de dados\"",
      "mati.suggest.search_tickets.prompt": "Encontre tickets que contenham a palavra \"banco de dados\".",
      "mati.suggest.search_tickets.title": "Buscar tickets",
      "mati.suggest.support_help.desc": "Ajuda com rascunhos de FAQ",
      "mati.suggest.support_help.prompt": "Como formulo uma recusa cordial a um pedido de reembolso?",
      "mati.suggest.support_help.title": "Ajuda de suporte",
      "mati.suggest.system_status.desc": "Exibir a carga atual",
      "mati.suggest.system_status.prompt": "Mostre-me o status atual do sistema e uma visão geral da carga dos agentes.",
      "mati.suggest.system_status.title": "Status do sistema",
      "mati.typing_text": "{{name}} está digitando...",
      "mati.welcome_subtitle": "Eu sou o seu copiloto de IA inteligente. Posso ajudar você a gerenciar tickets, pesquisar no sistema ou consultar estatísticas do sistema.",
      "mati.welcome_title": "Olá! Eu sou {{name}}",
      "mati_gdpr_warning": "Filtro RGPD ativo: Dados pessoais são anonimizados automaticamente antes do envio.",
      "mati_placeholder": "Pergunte-me qualquer coisa sobre tickets, carga de trabalho, ou crie um ticket...",
      "mati_welcome": "Olá! Eu sou {{name}}",
      "meeting_error_title": "Não foi possível criar a reunião do Teams.",
      "meeting_success": "Reunião do Teams criada.",
      "meeting_success_copy": "Reunião do Teams criada, link copiado para a área de transferência.",
      "megamenu.active_label": "Trabalho",
      "megamenu.calendar_desc": "Compromissos e integração de calendário.",
      "megamenu.licenses_desc": "Conformidade de licenças, suítes e planejamento de true-up.",
      "megamenu.modules": "Módulos",
      "megamenu.open_calendar": "Abrir calendário",
      "megamenu.open_licenses": "Abrir licenças",
      "megamenu.open_problems": "Abrir problemas",
      "megamenu.problems_desc": "Gestão de problemas e RCA (análise de causa raiz).",
      "megamenu.quick_search_commands": "Busca rápida e comandos",
      "merge": "Zusammenführen",
      "merge_tickets": "Die beiden markierten Tickets zusammenführen",
      "mfa_settings": "Configurações MFA",
      "minutes_ago": "Há {{count}} min",
      "mloffice.abgleich_fehler": "Abgleich konnte nicht gestartet werden.",
      "mloffice.abgleich_fehlgeschlagen": "Letzter Abgleich fehlgeschlagen: {{fehler}}",
      "mloffice.abgleich_gestartet": "Voll-Abgleich gestartet.",
      "mloffice.abgleich_laeuft": "Abgleich läuft",
      "mloffice.adresse": "MLOffice-Adresse",
      "mloffice.adresse_hinweis": "Basisadresse der MLOffice-Installation — ohne /api/v1.",
      "mloffice.agenten_titel": "Agenten ↔ MLOffice-Benutzer",
      "mloffice.aktion_anlegen": "Neu anlegen",
      "mloffice.aktion_entkoppeln": "Entkoppeln",
      "mloffice.aktion_entkoppeln_hinweis": "Aus dem Abgleich nehmen — der Kunde bleibt bestehen und wird wieder editierbar.",
      "mloffice.aktion_verknuepfen": "Verknüpfen",
      "mloffice.aktiv": "Aktiv",
      "mloffice.aktivieren": "Anbindung aktiv",
      "mloffice.auswahl_fehler": "Auswahl konnte nicht gespeichert werden.",
      "mloffice.bereits_uebertragen": "{{n}} Einträge im Zeitraum sind bereits übertragen und werden übersprungen.",
      "mloffice.email_eingeben": "Der Partner hat in MLOffice keine E-Mail-Adresse. E-Mail für den neuen Kunden:",
      "mloffice.entwurf_anlegen": "Entwurf anlegen",
      "mloffice.entwurf_fehler": "Entwurf konnte nicht angelegt werden.",
      "mloffice.entwurf_hinweis": "Erzeugt aus den bereits übertragenen Zeiten des Zeitraums einen ENTWURF in MLOffice. Belegnummer, Festschreibung und Versand bleiben MLOffice vorbehalten.",
      "mloffice.entwurf_ok": "Entwurf über {{h}} h in MLOffice angelegt — Festschreiben und Versand dort.",
      "mloffice.entwurf_titel": "Rechnungsentwurf in MLOffice",
      "mloffice.ereignis_closed": "Ticket geschlossen",
      "mloffice.ereignis_created": "Ticket eröffnet",
      "mloffice.ereignis_escalated": "Ticket eskaliert",
      "mloffice.ereignisse_titel": "Ticket-Ereignisse in die MLOffice-Kontakthistorie melden (nur Referenz, nie Inhalt):",
      "mloffice.erst_aktivieren": "Bitte zuerst die Anbindung aktivieren und die Verbindung testen — dann erscheint hier der MLOffice-Kundenbestand.",
      "mloffice.erst_aktivieren_abrechnung": "Bitte zuerst die Anbindung aktivieren — dann erscheinen hier offene Posten und der Kontingent-Abgleich.",
      "mloffice.erst_aktivieren_zeiten": "Bitte zuerst die Anbindung aktivieren — dann lassen sich Zeiten per Übertragungslauf nach MLOffice geben.",
      "mloffice.fallback_hinweis": "{{n}} Einträge ohne Agenten-Zuordnung werden über den technischen Benutzer gebucht (Agentenname in der Beschreibung).",
      "mloffice.feld_bis": "Bis",
      "mloffice.feld_kunde": "Kunde",
      "mloffice.feld_projekt": "MLOffice-Projekt",
      "mloffice.feld_satz": "Stundensatz (netto)",
      "mloffice.feld_von": "Von",
      "mloffice.gespeichert": "MLOffice-Einstellungen gespeichert.",
      "mloffice.gueltig_180": "180 Tage",
      "mloffice.gueltig_365": "365 Tage",
      "mloffice.gueltig_90": "90 Tage",
      "mloffice.gueltig_unbegrenzt": "Unbegrenzt",
      "mloffice.hoheit_frage": "MLOffice übernimmt die Hoheit über: {{felder}}.\\n\\nDiese Felder sind in AISupportDesk dann gesperrt und werden fortlaufend aus MLOffice übernommen. Fortfahren?",
      "mloffice.inaktiv": "Inaktiv",
      "mloffice.keine_partner": "Noch keine MLOffice-Kunden geladen. „Liste aus MLOffice laden“ holt den Bestand.",
      "mloffice.keine_zuordnung": "— keine Zuordnung —",
      "mloffice.konflikt_fehler": "Konnte nicht übernommen werden.",
      "mloffice.konflikt_geloest": "Übernommen.",
      "mloffice.konflikt_hinweis": "Übernahme braucht eine Entscheidung — siehe Konfliktzeile.",
      "mloffice.kopieren": "Kopieren",
      "mloffice.kunde_waehlen": "— Kunde wählen —",
      "mloffice.kunden_erklaerung": "Wähle aus, welche MLOffice-Kunden hier geführt werden. Ausgewählte Kunden werden fortlaufend abgeglichen; ihre Stammdaten sind hier gesperrt. Abwählen entkoppelt nur — der Kunde bleibt bestehen.",
      "mloffice.laden_fehler": "MLOffice-Einstellungen konnten nicht geladen werden.",
      "mloffice.laeufe_titel": "Bisherige Übertragungsläufe",
      "mloffice.lauf_detail": "Lauf #{{id}} — Einzelposten",
      "mloffice.lauf_fehler": "Lauf konnte nicht gestartet werden.",
      "mloffice.lauf_fertig": "Fertig",
      "mloffice.lauf_gestartet": "Übertragungslauf gestartet.",
      "mloffice.lauf_laeuft": "Läuft",
      "mloffice.lauf_starten": "Übertragung starten",
      "mloffice.lauf_teilfehler": "Mit Fehlern",
      "mloffice.linktoken_abgelaufen": "Das Verbindungstoken ist abgelaufen — MLOffice kann sich nicht mehr ausweisen. Neues Token erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_ablauf_teil": ", gültig bis {{datum}}",
      "mloffice.linktoken_einmal": "Jetzt kopieren — dieses Token wird nur EINMAL angezeigt:",
      "mloffice.linktoken_eintragen": "In MLOffice unter Einstellungen → AISupportDesk-Anbindung eintragen.",
      "mloffice.linktoken_erklaerung": "Dieses Token wird HIER erzeugt und in MLOffice unter „AISupportDesk-Anbindung“ eingetragen. MLOffice weist sich damit aus (Verbindungsstatus, Webhooks). Wird die Anbindung hier gelöst oder das Token widerrufen, zeigt MLOffice die Verbindung als gelöst.",
      "mloffice.linktoken_erzeugen": "Token erzeugen",
      "mloffice.linktoken_fehler": "Verbindungstoken konnte nicht erzeugt werden.",
      "mloffice.linktoken_gueltigkeit": "Gültigkeit",
      "mloffice.linktoken_kopiert": "Token kopiert.",
      "mloffice.linktoken_laeuft_ab": "Das Verbindungstoken läuft in {{tage}} Tagen ab. Rechtzeitig neu erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_neu": "Neues Token erzeugen",
      "mloffice.linktoken_rotieren_frage": "Es existiert bereits ein Verbindungstoken. Ein neues macht das alte sofort ungültig — MLOffice muss dann das neue Token eintragen. Fortfahren?",
      "mloffice.linktoken_status": "Hinterlegt ({{hint}}), erzeugt {{erzeugt}}{{ablauf}}.",
      "mloffice.linktoken_titel": "Verbindungstoken für MLOffice",
      "mloffice.linktoken_unbegrenzt_teil": ", unbegrenzt gültig",
      "mloffice.linktoken_widerruf_fehler": "Widerruf fehlgeschlagen.",
      "mloffice.linktoken_widerruf_frage": "Verbindungstoken widerrufen? MLOffice zeigt die Verbindung danach als gelöst; Webhooks und Statusabfragen von MLOffice werden abgewiesen.",
      "mloffice.linktoken_widerrufen": "Verbindungstoken widerrufen.",
      "mloffice.linktoken_widerrufen_btn": "Widerrufen",
      "mloffice.liste_aktualisieren": "Liste aus MLOffice laden",
      "mloffice.loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "mloffice.nur_verknuepfte": "Nur mit MLOffice verknüpfte Kunden.",
      "mloffice.ohne_email": "ohne E-Mail",
      "mloffice.op_aktualisiert": "Offene Posten aktualisiert.",
      "mloffice.op_belege": "Belege",
      "mloffice.op_fehler": "Offene Posten konnten nicht geladen werden.",
      "mloffice.op_laden": "Offene Posten aus MLOffice laden",
      "mloffice.op_stand": "Stand: {{zeit}}",
      "mloffice.op_titel": "Offene Posten (MLOffice)",
      "mloffice.partner_laden_fehler": "MLOffice-Kundenliste konnte nicht geladen werden.",
      "mloffice.posten_ok": "übertragen",
      "mloffice.posten_retry": "Erneut",
      "mloffice.posten_skip": "Überspringen",
      "mloffice.projekt_pflicht": "Bitte oben ein MLOffice-Projekt wählen.",
      "mloffice.projekt_waehlen": "— Projekt wählen —",
      "mloffice.rechte_fehlen": "Dem Token fehlen Rechte:",
      "mloffice.recon_asd": "Support-Sicht (NALVRA SERVICE)",
      "mloffice.recon_diff": "Abweichung Support- zu Abrechnungs-Sicht: {{min}} Min.",
      "mloffice.recon_gebucht": "{{min}} Min. im Projekt „{{projekt}}“ gebucht",
      "mloffice.recon_gesperrt_bis": "Erfassung gesperrt bis: {{d}}",
      "mloffice.recon_kein_projekt": "Kein MLOffice-Projekt zugeordnet (Tab „Zuordnung“).",
      "mloffice.recon_kein_vertrag": "Kein aktiver Vertrag mit Kontingent für diesen Kunden.",
      "mloffice.recon_mlo": "Abrechnungs-Sicht (MLOffice)",
      "mloffice.recon_offen": "{{min}} Min. der laufenden Periode sind noch nicht an MLOffice übertragen — Übertragungslauf im Tab „Zeiten-Übertragung“ starten.",
      "mloffice.recon_titel": "Kontingent-Abgleich",
      "mloffice.recon_verbrauch": "{{used}} von {{incl}} Min. verbraucht — {{rest}} Min. übrig",
      "mloffice.schon_drueben": "übertragen",
      "mloffice.sp_agent": "Agent",
      "mloffice.sp_beschreibung": "Beschreibung",
      "mloffice.sp_datum": "Datum",
      "mloffice.sp_fortschritt": "Gesendet / Fehler / Gesamt",
      "mloffice.sp_kunde": "Kunde",
      "mloffice.sp_minuten": "Min.",
      "mloffice.sp_status": "Status",
      "mloffice.sp_ticket": "Ticket",
      "mloffice.sp_zeitraum": "Zeitraum",
      "mloffice.spalte_kunde": "MLOffice-Kunde",
      "mloffice.spalte_status": "Status",
      "mloffice.spalte_sync": "Sync",
      "mloffice.spalte_zuordnung": "Zuordnung in NALVRA SERVICE",
      "mloffice.speichern": "Speichern",
      "mloffice.speichern_fehler": "Speichern fehlgeschlagen.",
      "mloffice.status_archiviert": "In MLOffice archiviert",
      "mloffice.status_delta": "Letzter Kundenabgleich: {{zeit}}",
      "mloffice.status_entkoppelt": "Entkoppelt",
      "mloffice.status_failed": "{{n}} Übertragungen fehlgeschlagen",
      "mloffice.status_kein_linktoken": "Kein Verbindungstoken für MLOffice erzeugt",
      "mloffice.status_konflikt": "Entscheidung nötig",
      "mloffice.status_linktoken_abgelaufen": "Verbindungstoken abgelaufen — neu erzeugen und in MLOffice eintragen",
      "mloffice.status_neu": "Neu",
      "mloffice.status_op": "Offene Posten: {{zeit}}",
      "mloffice.status_pending": "{{n}} Übertragungen offen",
      "mloffice.status_ratelimit": "MLOffice-Ratenbegrenzung — kurze Pause",
      "mloffice.status_sync_fehler": "Letzter Abgleich mit Fehler",
      "mloffice.status_uebernommen": "Übernommen",
      "mloffice.tab_abrechnung": "Abrechnung",
      "mloffice.tab_kunden": "Kundenabgleich",
      "mloffice.tab_verbindung": "Verbindung",
      "mloffice.tab_zeiten": "Zeiten-Übertragung",
      "mloffice.tab_zuordnung": "Zuordnung",
      "mloffice.techuser_hinweis": "Wird für Zeitbuchungen ohne Agenten-Zuordnung verwendet; der Agentenname wandert dann in die Buchungsbeschreibung.",
      "mloffice.techuser_titel": "Technischer Benutzer (Fallback)",
      "mloffice.test_fehler": "Verbindungstest fehlgeschlagen.",
      "mloffice.test_nicht_verbunden": "Keine Verbindung",
      "mloffice.test_ok": "Verbindung zu MLOffice steht.",
      "mloffice.test_verbunden": "Verbunden mit Mandant „{{tenant}}“",
      "mloffice.testen": "Verbindung testen",
      "mloffice.titel": "MLOffice-Anbindung",
      "mloffice.token": "API-Token",
      "mloffice.token_gesetzt": "hinterlegt ({{hint}})",
      "mloffice.token_hinweis": "In MLOffice unter Einstellungen → API-Tokens anlegen. Benötigte Rechte prüft der Verbindungstest.",
      "mloffice.token_name": "Token: {{name}}",
      "mloffice.token_unveraendert": "Leer lassen = unverändert",
      "mloffice.untertitel": "Kundenstammdaten, Abrechnung, Zeiterfassung und CRM mit MLOffice koppeln. MLOffice ist das führende System für Stammdaten und Rechnungen.",
      "mloffice.users_dropdown": "Zeitbuchungen werden in MLOffice unter dem zugeordneten Benutzer geführt. Ohne Zuordnung greift der technische Benutzer.",
      "mloffice.users_manuell": "MLOffice stellt (noch) keine Benutzerliste bereit — MLOffice-User-UUID bitte manuell eintragen (in MLOffice unter Benutzerverwaltung kopieren).",
      "mloffice.uuid_platzhalter": "MLOffice-User-UUID",
      "mloffice.verbindung": "Verbindung",
      "mloffice.vollabgleich": "Voll-Abgleich starten",
      "mloffice.vorschau": "Vorschau",
      "mloffice.vorschau_anlegen": "Wird neu angelegt",
      "mloffice.vorschau_email_fehlt": "E-Mail fehlt — wird bei Übernahme abgefragt",
      "mloffice.vorschau_fehler": "Vorschau fehlgeschlagen.",
      "mloffice.vorschau_titel": "Vorschau: {{n}} Einträge, {{h}} h werden übertragen",
      "mloffice.vorschau_verknuepfung": "Vorschlag: mit „{{name}}“ verknüpfen ({{grund}})",
      "mloffice.zeiten_erklaerung": "Zeiten werden NICHT automatisch übertragen. Du wählst Kunde und Zeitraum, prüfst die Vorschau und bestätigst — erst dann gehen die Buchungen nach MLOffice. Übertragene Buchungen sind dort unumkehrbar und hier gesperrt.",
      "mloffice.zeitraum_bis_heute": "Bis heute",
      "mloffice.zeitraum_dieser_monat": "Dieser Monat",
      "mloffice.zeitraum_letzter_monat": "Letzter Monat",
      "mloffice.zuordnung_fehler": "Zuordnung konnte nicht gespeichert werden.",
      "mloffice.zuordnung_fehlt": "{{n}} Einträge ohne Agenten-Zuordnung — bitte unter „Zuordnung“ pflegen oder einen technischen Benutzer hinterlegen.",
      "mloffice.zuordnung_gespeichert": "Zuordnung gespeichert.",
      "mobile": "Celular",
      "move_ticket": "Verschieben",
      "my_tickets": "Meus tickets",
      "navbar_search_placeholder": "Buscar tickets, clientes ou KB...",
      "new": "Novo",
      "new_activity_aria": "Nova atividade",
      "new_activity_title": "Nova atividade desde a última visualização",
      "new_company": "Neue Firma",
      "new_label": "Novo",
      "new_ticket": "Novo ticket",
      "next": "Weiter",
      "no_activities_recorded": "Nenhuma atividade registrada ainda.",
      "no_canned_responses": "Nenhuma resposta pronta",
      "no_canned_responses_hint": "Podem ser gerenciadas na administração.",
      "no_critical_tickets": "Nenhum ticket crítico",
      "no_customer_assigned": "Nenhum cliente atribuído",
      "no_customer_data": "Nenhum dado do cliente carregado.",
      "no_customers_found": "Nenhum cliente encontrado",
      "no_customers_matching": "Nenhum cliente foi encontrado para a seleção de filtro ou consulta de busca.",
      "no_data_available": "Nenhum dado disponível",
      "no_employees_found": "Nenhum funcionário cadastrado",
      "no_notes_placeholder": "Nenhuma nota disponível. Clique em \"Editar\" para adicionar notas.",
      "no_notifications": "Sem notificações",
      "no_other_agents_online": "Atualmente, nenhum outro membro da equipe está online.",
      "no_results": "Nenhum resultado",
      "no_tickets_found": "Nenhum ticket encontrado",
      "no_tickets_found_desc": "Atualmente não há itens nesta fila de filtragem.",
      "no_tickets_risk": "Atualmente não há tickets na janela crítica de aviso de SLA.",
      "not_spam": "Não é spam",
      "notification_settings": "Configurações de Notificação",
      "notification_settings_desc": "Escolha quais notificações você deseja receber.",
      "notification_settings_saved": "Configurações de notificação salvas.",
      "notifications": "Notificações",
      "notify_license_change": "Alterações de licença",
      "notify_new_reply": "Novas respostas",
      "notify_new_ticket": "Novos tickets",
      "notify_status_changed": "Alterações de status",
      "observers_title": "Observadores",
      "only_visible_for": "Apenas {{name}}",
      "only_visible_to_agents": "Visível apenas para agentes",
      "open_administration": "Abrir administração",
      "open_btn": "Abrir",
      "open_password_vault": "Abrir cofre de senhas",
      "open_quick_search": "Abrir busca rápida",
      "open_tickets": "Tickets abertos",
      "other_tickets_count": "Outros Tickets ({{count}})",
      "other_tickets_requester_count": "Outros tickets do solicitante ({{count}})",
      "overdue": "Atrasados",
      "overview_option_1": "1. Painel de KPI padrão",
      "overview_option_10": "10. Taxa de violação de SLA por prioridades",
      "overview_option_2": "2. Taxa de resolução no primeiro contacto (FCR) & tempo de resposta",
      "overview_option_3": "3. Desenvolvimento do volume de tickets & horas de pico",
      "overview_option_4": "4. Tendências de taxa de resolução (Criados vs. Resolvidos)",
      "overview_option_5": "5. Matriz CSAT vs. tempo de resolução",
      "overview_option_6": "6. Canais de tickets & detalhamento da origem",
      "overview_option_7": "7. Taxas de escalabilidade & análise de caminho de escalonamento",
      "overview_option_8": "8. Tempo de vida médio do ticket (Envelhecimento)",
      "overview_option_9": "9. Status do backlog & envelhecimento",
      "performance_queues": "Desempenho e Filas",
      "phone": "Telefone",
      "plan_teams_meeting": "Agendar reunião do Teams",
      "planning": "Planejamento",
      "please_enter_text": "Por favor, insira o texto",
      "policy": "Política",
      "portal_company.load_failed": "Dokumente konnten nicht geladen werden.",
      "portal_company.primary_contact": "Hauptansprechpartner",
      "portal_session.continue": "Weiterarbeiten",
      "portal_session.login": "Erneut anmelden",
      "portal_session.warning": "Ihre Sitzung endet in {{seconds}} Sekunden. Gespeicherte Entwürfe bleiben erhalten.",
      "portal_speech.denied": "Mikrofonzugriff oder Spracherkennung wurde nicht erlaubt. Bitte die Browserberechtigung prüfen.",
      "portal_speech.failed": "Spracheingabe nicht verfügbar. Bitte Mikrofon und Verbindung prüfen oder weitertippen.",
      "portal_speech.listening": "Mikrofon aktiv – bitte sprechen …",
      "portal_speech.notice": "Diktierter Text wird unten an die Beschreibung angefügt. Der Browser kann Audio zur Erkennung an seinen Sprachdienst senden.",
      "portal_speech.silence": "Keine Sprache erkannt. Bitte erneut starten.",
      "portal_speech.start": "Diktat starten",
      "portal_speech.stop": "Stoppen",
      "portal_speech.title": "Spracheingabe",
      "portal_speech.unsupported": "Dieser Browser unterstützt hier keine Spracheingabe. Sie können die Diktierfunktion Ihrer Tastatur verwenden.",
      "preview": "Visualização",
      "previous": "Zurück",
      "primary": "Primário",
      "priority": "Prioridade",
      "priority_": "",
      "priority_critical": "Crítico",
      "priority_high": "Alta",
      "priority_low": "Baixa",
      "priority_medium": "Média",
      "priority_urgent": "Urgente",
      "problem_cascade_close_checkbox": "Sim, fechar todos os incidentes vinculados (recomendado)",
      "problem_cascade_close_desc": "Existem incidentes abertos vinculados. Deseja resolvê-los automaticamente e adicionar um comentário com a causa raiz e resolução?",
      "problem_cascade_close_title": "Fechamento em Cascata",
      "problem_confirm_resolve": "Confirmar e Resolver",
      "problem_create_btn": "Criar Problema",
      "problem_create_error": "Erro ao criar o problema",
      "problem_create_success": "Ticket de problema criado.",
      "problem_create_title": "Criar Novo Ticket de Problema",
      "problem_created_by_on": "Criado por {{creator}} em {{date}}",
      "problem_description_label": "Descrição do Problema",
      "problem_detail_load_error": "Erro ao carregar os detalhes do problema",
      "problem_incidents_linked": "Incidents vinculados",
      "problem_kedb_empty": "Nenhum erro conhecido",
      "problem_kedb_empty_desc": "Os problemas classificados como erro conhecido aparecem aqui com a causa e a solução de contorno.",
      "problem_kedb_load_error": "Erro ao carregar os erros conhecidos",
      "problem_kedb_search_placeholder": "Pesquisar erros conhecidos...",
      "problem_kedb_title": "Erros conhecidos (Known Errors)",
      "problem_known_error_badge": "Erro conhecido",
      "problem_known_error_checkbox": "Classificar como Known Error (Erro Conhecido)",
      "problem_known_error_only": "Apenas erros conhecidos",
      "problem_link_btn": "Vincular",
      "problem_link_error": "Erro ao vincular os incidentes",
      "problem_link_incident_btn": "Vincular Incidente",
      "problem_link_incidents_title": "Vincular Incidentes",
      "problem_link_success": "Incidentes vinculados.",
      "problem_linked_incidents": "Incidentes Vinculados",
      "problem_load_error": "Erro ao carregar os problemas",
      "problem_loading": "Carregando gerenciamento de problemas ITIL...",
      "problem_mark_known_error": "Marcar como Known Error",
      "problem_no_incidents_found": "Nenhum incidente vinculado encontrado.",
      "problem_no_tickets": "Sem tickets de problema",
      "problem_no_tickets_desc": "Não há tickets de problema ITIL registrados no momento.",
      "problem_no_unlinked_found": "Nenhum incidente aberto e não vinculado encontrado.",
      "problem_none": "—",
      "problem_none_selected": "Nenhum problema selecionado",
      "problem_none_selected_desc": "Selecione um ticket de problema ITIL à esquerda ou crie um novo para gerenciar dados de RCA.",
      "problem_open_change_confirm": "Abrir agora o novo ticket de mudança {{num}}?",
      "problem_raise_change_btn": "Derivar mudança",
      "problem_raise_change_error": "Erro ao derivar a mudança",
      "problem_raise_change_success": "Ticket de mudança criado: {{num}}",
      "problem_raise_change_title": "Derivar uma mudança deste problema",
      "problem_rca_title": "Problemas ITIL (RCA)",
      "problem_resolution_note": "Nota de Resolução",
      "problem_resolution_note_placeholder": "Insira detalhes sobre a solução final...",
      "problem_resolve_btn": "Resolver Problema",
      "problem_resolve_error": "Erro ao resolver o problema",
      "problem_resolve_success": "Problema resolvido.",
      "problem_root_cause_label": "Causa Raiz Suspeita",
      "problem_root_cause_short": "Causa raiz",
      "problem_search_placeholder": "Pesquisar problemas...",
      "problem_stage_closed": "Fechado",
      "problem_stage_known_error": "Erro conhecido",
      "problem_stage_label": "Status do ciclo de vida (estágio do problema)",
      "problem_stage_open": "Aberto",
      "problem_stage_resolved": "Resolvido",
      "problem_stage_under_investigation": "Em investigação",
      "problem_stage_updated": "Status do ciclo de vida atualizado.",
      "problem_stage_workaround_found": "Solução de contorno encontrada",
      "problem_tab_kedb": "Banco de erros conhecidos (KEDB)",
      "problem_tab_problems": "Problemas (RCA)",
      "problem_title": "Problema ITIL: Incidente recorrente",
      "problem_title_label": "Título do Problema",
      "problem_unlink_btn": "Desvincular",
      "problem_unlink_error": "Erro ao remover o vínculo",
      "problem_unlink_success": "Vínculo removido.",
      "problem_update_error": "Erro ao atualizar o problema",
      "problem_update_success": "Problema atualizado com sucesso.",
      "problem_workaround_label": "Workaround Conhecido",
      "problem_workaround_short": "Solução de contorno",
      "problems": "Problemas",
      "queue.": "queue.",
      "queue_external_processing": "Externe Bearbeitung",
      "queues": "Filas",
      "quick_access_views": "Acessos rápidos e visualizações",
      "quick_search": "Busca rápida",
      "read_ticket_also": "também está lendo este ticket",
      "reading_ticket": "Lendo ticket #{{id}}",
      "reassign_to": "Reatribuir ({{name}})...",
      "recent_activities_description": "Atividades recentes de tickets e respostas para este cliente.",
      "recent_tickets": "Tickets recentes",
      "refresh": "Atualizar",
      "remove_assignment": "Remover atribuição",
      "remove_attachment_aria": "Remover anexo {{filename}}",
      "remove_filter": "Filter entfernen",
      "reopen": "Reabrir",
      "reply": "Responder",
      "reply_keyboard_shortcut_hint": "Atalho de teclado: Ctrl ou Cmd + Enter para enviar quando o cursor estiver no texto.",
      "report_active_breaches": "Violações ativas",
      "report_ai_analysis": "Análise de IA",
      "report_ai_analyzing": "A IA está analizando os dados do relatório...",
      "report_ai_highlights": "Destaques",
      "report_ai_recommendations": "Recomendações",
      "report_billable": "Faturável",
      "report_compliance": "Conformidade",
      "report_export": "Exportar",
      "report_exporting": "Exportando...",
      "report_no_data": "Nenhum dado disponível",
      "report_no_data_desc": "Não foi possível carregar dados do relatório para este período.",
      "report_range": "Visualização do relatório:",
      "report_total_time": "Tempo total",
      "reports": "Relatórios",
      "reports_desc": "Relatórios & análises de gerenciamento de serviços",
      "request.additional_info": "Informações adicionais",
      "request.back_to_dashboard": "Voltar ao dashboard",
      "request.back_to_dashboard_link": "← Dashboard",
      "request.back_to_list": "Ir para a visão geral",
      "request.back_to_requests": "← Todas as solicitações",
      "request.catalog_subtitle": "Selecione um tipo de solicitação — você receberá o formulário correspondente.",
      "request.choose_files": "Selecionar arquivos",
      "request.description_placeholder": "Descreva a sua solicitação…",
      "request.description_required": "Informe uma descrição.",
      "request.failed_load_catalog": "Não foi possível carregar o catálogo",
      "request.file_too_large": "Arquivo muito grande (máx. {{max}} MB): {{name}}",
      "request.file_type_not_allowed": "Dateityp nicht erlaubt: {{name}}",
      "request.no_requests": "Nenhuma solicitação de serviço está liberada no portal.",
      "request.not_available": "Esta solicitação não está disponível ou não foi publicada.",
      "request.optional_select": "— Opcional —",
      "request.please_select": "— Selecione —",
      "request.remove_file": "Remover",
      "request.required_field": "Campo obrigatório: {{label}}",
      "request.standard_fields_info": "Campos padrão: prioridade, categoria, descrição e anexos estão incluídos em toda solicitação de serviço. Abaixo podem aparecer campos adicionais para este tipo de solicitação.",
      "request.submit_btn": "Enviar solicitação",
      "request.submit_failed": "Falha no envio",
      "request.submitting_btn": "Enviando…",
      "request_type": "Tipo de solicitação",
      "requester_title": "Solicitante",
      "reset": "Redefinir",
      "reset_all_filters": "Alle Filter zurücksetzen",
      "reset_filter": "Redefinir filtro",
      "reset_kpi_filter": "Kachel-Filter zurücksetzen",
      "reset_to_default": "Redefinir para o padrão",
      "resolution": "Resolução",
      "resolve": "Resolver",
      "resolved_label": "Resolvido",
      "retry": "Erneut versuchen",
      "risk": "Risco",
      "risk_minutes": "{{count}} min",
      "save": "Salvar",
      "save_changes": "Salvar Alterações",
      "save_note": "Salvar nota",
      "saving": "Salvando...",
      "scroll_to_reply": "Rolar para a resposta",
      "search": "Buscar...",
      "search_canned_responses": "Pesquisar respostas prontas…",
      "search_customers": "Buscar clientes...",
      "select_company": "Firma auswählen…",
      "select_customer_placeholder": "Selecione um cliente da lista",
      "self_healing": "Auto-resolução",
      "send": "Enviar",
      "sending_ellipsis": "Enviando...",
      "settings": "Configurações",
      "seven_days": "7 dias",
      "shortcut_back_close": "Voltar / Fechar",
      "shortcut_escalate": "Escalar",
      "shortcut_focus_mode": "Modo foco",
      "shortcut_help": "Esta ajuda",
      "shortcut_internal_note": "Nota interna",
      "shortcut_next_prev": "Próximo / Anterior ticket",
      "shortcut_quick_search": "Busca rápida",
      "shortcut_write_reply": "Escrever resposta",
      "show_all": "Mostrar tudo",
      "show_full_ticket_backlog": "Ver todo o backlog de tickets",
      "show_older_replies": "Exibir {{count}} respostas anteriores...",
      "sla_and_contract_title": "SLA e Contrato",
      "sla_breached_both": "Resposta e resolução violadas",
      "sla_breached_exclamation": "SLA violado!",
      "sla_breached_resolution": "Resolução violada",
      "sla_breached_response": "Resposta violada",
      "sla_breaches": "Violações de SLA:",
      "sla_compliance": "Conformidade de SLA",
      "sla_level": "Nível SLA:",
      "sla_option_1": "1. Conformidade de SLA & tendências (Visão geral)",
      "sla_option_10": "10. Estatísticas de SLA de fins de semana & feriados",
      "sla_option_2": "2. Violações de SLA & tickets em risco",
      "sla_option_3": "3. SLA por prioridade",
      "sla_option_4": "4. SLA por cliente / plano de serviço",
      "sla_option_5": "5. Conformidade de SLA de tempo de resposta",
      "sla_option_6": "6. Conformidade de SLA de tempo de resolução",
      "sla_option_7": "7. Violações de SLA por agente/grupo",
      "sla_option_8": "8. Causas das violações de SLA",
      "sla_option_9": "9. Prévia de multas & créditos (Risco financeiro)",
      "sla_performance_breaches": "Desempenho de SLA e Violações",
      "sla_risk": "Risco SLA",
      "sla_status_ok": "OK",
      "sort_by_label": "Ordenar por {{label}}",
      "spam": "Spam",
      "starred": "Favoritos",
      "start": "Início",
      "status": "Estado",
      "status_closed": "Fechado",
      "status_in_progress": "Em andamento",
      "status_new": "Novo",
      "status_on_hold": "Em espera",
      "status_open": "Aberto",
      "status_resolved": "Resolvido",
      "status_waiting": "Aguardando",
      "status_waiting_customer": "Aguardando cliente",
      "street": "Rua",
      "subtasks": "Teilaufgaben",
      "supporting_agents": "Agentes de suporte",
      "switch_language": "Mudar de idioma",
      "system_logs": "Logs do sistema",
      "tab_": "",
      "tab_activity": "Atividade",
      "tab_agents": "Agentes",
      "tab_assets": "Ativos",
      "tab_contracts": "Contratos",
      "tab_csat": "CSAT",
      "tab_custom": "Relatórios personalizados",
      "tab_customers": "Clientes",
      "tab_documents": "Documentos",
      "tab_employees": "Funcionários",
      "tab_incidents": "Incidentes",
      "tab_licenses": "Licenças",
      "tab_notes": "Notas",
      "tab_overview": "Visão geral",
      "tab_sla": "SLA",
      "tab_tickets": "Tickets",
      "tab_time": "Registro de tempo",
      "tab_trends": "Tendências",
      "tag_add_placeholder": "Adicionar etiqueta...",
      "tag_label": "Etiqueta",
      "tax_number": "Número de identificação fiscal",
      "teams_call_start": "Iniciar chamada do Teams",
      "teams_chat_open": "Abrir chat do Teams",
      "teams_meeting_subject": "Reunião {{number}}",
      "teams_meeting_title": "Reunião do Teams",
      "thirty_days": "30 dias",
      "ticket_assets.action_col": "Ação",
      "ticket_assets.agent_offline": "Agente offline",
      "ticket_assets.agent_ready": "Pronto",
      "ticket_assets.assigned_assets": "Ativos atribuídos ao funcionário",
      "ticket_assets.bios_label": "Versão do BIOS:",
      "ticket_assets.calculating_compliance": "Calculando a auditoria de licenças...",
      "ticket_assets.clean_temp": "Limpar temporários",
      "ticket_assets.cmd_status_completed": "Concluído",
      "ticket_assets.cmd_status_failed": "Erro",
      "ticket_assets.cmd_status_pending": "Aguardando",
      "ticket_assets.cmd_status_running": "Em execução...",
      "ticket_assets.cmdb_alert_desc": "Este ativo depende de / está conectado a:",
      "ticket_assets.cmdb_alert_title": "Alerta de cascata da CMDB: falha de dependência!",
      "ticket_assets.command_execution_failed": "Falha na execução do comando.",
      "ticket_assets.command_placeholder": "ex.: ipconfig /all, systeminfo, dir",
      "ticket_assets.command_running": "O comando está sendo executado no dispositivo cliente...",
      "ticket_assets.command_success_solved": "Executado com sucesso! O ticket foi resolvido automaticamente.",
      "ticket_assets.command_timeout": "Tempo esgotado na execução do comando.",
      "ticket_assets.compliant": "Conforme",
      "ticket_assets.confirm_kill_process": "Deseja realmente encerrar o processo com o PID {{pid}}?",
      "ticket_assets.cpu_cores_label": "Núcleos:",
      "ticket_assets.cpu_label": "Processador (CPU)",
      "ticket_assets.cpu_sockets_label": "Soquetes:",
      "ticket_assets.cpu_util_label": "Uso de CPU",
      "ticket_assets.created_label": "Criado:",
      "ticket_assets.device_scan_label": "Varredura do dispositivo",
      "ticket_assets.disk_free_label": "livre",
      "ticket_assets.disk_used_label": "Utilizado",
      "ticket_assets.disks_label": "Discos / unidades",
      "ticket_assets.domain_label": "Grupo de trabalho/domínio:",
      "ticket_assets.edition_id_label": "ID da edição:",
      "ticket_assets.employee_assets": "Ativos do funcionário",
      "ticket_assets.error_kill_process": "Erro ao encerrar o processo: {{error}}",
      "ticket_assets.error_loading_monitoring": "Erro ao carregar o monitoramento",
      "ticket_assets.error_sending_command": "Erro ao enviar o comando.",
      "ticket_assets.error_submit_command": "Não foi possível transmitir o comando: {{error}}",
      "ticket_assets.executed_label": "Executado:",
      "ticket_assets.fetch_logs_btn": "Obter logs",
      "ticket_assets.filter_processes_placeholder": "Filtrar processos (nome, PID)...",
      "ticket_assets.fix_dns": "Reparar DNS",
      "ticket_assets.fix_spooler": "Reparar spooler",
      "ticket_assets.hostname_label": "Nome de rede:",
      "ticket_assets.incomplete_summary": "Resumo de conformidade incompleto.",
      "ticket_assets.invalid_json_response": "Resposta inválida do servidor",
      "ticket_assets.kill_btn": "Encerrar",
      "ticket_assets.killing_proc": "Encerrando...",
      "ticket_assets.last_scan_label": "Última varredura:",
      "ticket_assets.license_compliance": "Conformidade de licenças",
      "ticket_assets.link": "Vincular",
      "ticket_assets.link_asset_title": "Vincular ativo",
      "ticket_assets.linked": "Vinculado",
      "ticket_assets.linked_assets": "Ativos vinculados ao ticket",
      "ticket_assets.loading": "Carregando os ativos...",
      "ticket_assets.loading_command_queue": "Carregando a fila de comandos...",
      "ticket_assets.loading_logs": "Carregando os logs de eventos...",
      "ticket_assets.loading_monitoring": "Carregando o monitoramento ao vivo e a verificação da CMDB...",
      "ticket_assets.log_name_label": "Nome do log",
      "ticket_assets.memory_col": "Memória",
      "ticket_assets.model_label": "Modelo:",
      "ticket_assets.monitored_ok": "Monitorado (OK)",
      "ticket_assets.more_params_title": "Outros parâmetros",
      "ticket_assets.motherboard_label": "Placa-mãe:",
      "ticket_assets.no_active_zabbix_alerts": "Nenhum alarme ativo do Zabbix.",
      "ticket_assets.no_assets_assigned": "Nenhum ativo de TI está atribuído a este funcionário.",
      "ticket_assets.no_assets_linked": "Nenhum ativo vinculado.",
      "ticket_assets.no_commands_executed": "Nenhum comando executado ainda. Digite um comando abaixo.",
      "ticket_assets.no_compliance_available": "Nenhuma licença ou relatório de conformidade disponível.",
      "ticket_assets.no_employee_assigned": "Nenhum funcionário atribuído ao ticket.",
      "ticket_assets.no_hardware_details": "Nenhum detalhe de hardware coletado na varredura.",
      "ticket_assets.no_matching_software": "Nenhum registro de software correspondente encontrado.",
      "ticket_assets.no_monitoring_data": "Nenhum dado de monitoramento disponível",
      "ticket_assets.os_arch_label": "Arquitetura:",
      "ticket_assets.os_label": "Sistema operacional",
      "ticket_assets.os_ver_label": "Versão:",
      "ticket_assets.overlicensed": "Sobrelicenciado",
      "ticket_assets.pagination_text": "Página {{page}} de {{total}} ({{count}} registros)",
      "ticket_assets.process_name_col": "Nome do processo",
      "ticket_assets.publisher_col": "Fabricante",
      "ticket_assets.query_realtime_btn": "Consultar em tempo real",
      "ticket_assets.ram_label": "Memória (RAM)",
      "ticket_assets.ram_util_label": "Uso de RAM",
      "ticket_assets.scan_details_btn": "Detalhes da varredura",
      "ticket_assets.scan_never": "nunca",
      "ticket_assets.search_logs_placeholder": "Pesquisar nos resultados (origem, ID, mensagem)...",
      "ticket_assets.search_placeholder": "Buscar nome, IP ou n/s...",
      "ticket_assets.search_software_placeholder": "Pesquisar software...",
      "ticket_assets.self_healing_title": "Autocorreção e automação",
      "ticket_assets.send_btn": "Enviar",
      "ticket_assets.sending_command_failed": "Falha ao enviar o comando.",
      "ticket_assets.serial_number_label": "Número de série:",
      "ticket_assets.severity_all": "Todos",
      "ticket_assets.severity_error": "Erro (Error)",
      "ticket_assets.severity_info": "Informação",
      "ticket_assets.severity_label": "Severidade",
      "ticket_assets.severity_warning": "Aviso (Warning)",
      "ticket_assets.sn_label": "N/S:",
      "ticket_assets.software_name_col": "Nome do software",
      "ticket_assets.sql_instance_label": "Instância:",
      "ticket_assets.sql_instances_title": "Instâncias do SQL Server detectadas",
      "ticket_assets.sql_patchlevel_label": "Nível de patch:",
      "ticket_assets.success_kill_process": "Processo encerrado com sucesso.",
      "ticket_assets.surplus_label": "Excedente:",
      "ticket_assets.timeout_kill_process": "Tempo esgotado ao encerrar o processo.",
      "ticket_assets.total_ram_desc": "Memória física total",
      "ticket_assets.underlicensed": "Sublicenciado",
      "ticket_assets.unlink_asset_title": "Remover vínculo",
      "ticket_assets.unreachable": "Inacessível",
      "ticket_assets.version_col": "Versão",
      "ticket_assets.virtualization_label": "Virtualização:",
      "ticket_assets.waiting_agent_response": "Aguardando a resposta do agente...",
      "ticket_assets.waiting_agent_timeout": "Tempo esgotado: o agente não respondeu a tempo.",
      "ticket_assets.zabbix_live_status": "Status ao vivo do Zabbix",
      "ticket_created": "Ticket criado",
      "ticket_detail.achtung_ueberschneidungskollisionen_ci_abhae": "Atenção: foram detectadas sobreposições de agendamento (dependências de CI)!",
      "ticket_detail.aktivitaeten": "Atividades",
      "ticket_detail.aktivitaets_verlauf": "Histórico de atividades",
      "ticket_detail.als_diesen_kunden_im_portal_anmelden": "Entrar no portal como este cliente",
      "ticket_detail.anhaenge": "Anexos",
      "ticket_detail.begruendung_kommentare": "Justificativa / comentários",
      "ticket_detail.bekannter_fehler_workaround_verfuegbar": "Erro conhecido — solução de contorno disponível",
      "ticket_detail.cab_hat_die_aenderung_abgelehnt": "O CAB rejeitou a mudança",
      "ticket_detail.change_advisory_board_cab_stimmen": "Votos do Change Advisory Board (CAB)",
      "ticket_detail.das_ticket_existiert_nicht_oder_wurde_geloes": "O ticket não existe ou foi excluído.",
      "ticket_detail.der_status_kann_erst_auf_in_bearbeitung_oder": "O status só pode ser definido como “Em andamento” ou “Resolvido” depois que a maioria do CAB tiver aprovado.",
      "ticket_detail.detaillierte_schritte_zur_durchfuehrung": "Passos detalhados para a execução...",
      "ticket_detail.es_wurde_noch_kein_change_plan_fuer_dieses_t": "Ainda não há um plano de mudança para este ticket.",
      "ticket_detail.es_wurden_andere_aktive_tickets_auf_denselbe": "Foram agendados outros tickets ativos nos mesmos ativos da CMDB, ou em ativos dependentes, no mesmo período:",
      "ticket_detail.extrahierte_daten": "Dados extraídos",
      "ticket_detail.geplanter_start_wartungsfenster": "Início planejado (janela de manutenção)",
      "ticket_detail.geplantes_ende": "Término planejado",
      "ticket_detail.geplantes_wartungsfenster": "Janela de manutenção planejada:",
      "ticket_detail.hinzufuegen": "Adicionar",
      "ticket_detail.keine_aktivitaeten_vorhanden": "Nenhuma atividade registrada",
      "ticket_detail.keine_anhaenge_vorhanden": "Nenhum anexo disponível",
      "ticket_detail.keine_kategorie": "Sem categoria",
      "ticket_detail.kommentar_zur_entscheidung_optional": "Comentário sobre a decisão (opcional)...",
      "ticket_detail.loeschen": "Excluir",
      "ticket_detail.niemand_zugewiesen": "Ninguém atribuído",
      "ticket_detail.noch_keine_stimmen_abgegeben": "Nenhum voto registrado ainda.",
      "ticket_detail.noch_keine_zeit_erfasst": "Nenhum tempo registrado ainda",
      "ticket_detail.nur_fuer_mitarbeiter_sichtbar": "Visível somente para a equipe interna",
      "ticket_detail.prioritaet": "Prioridade",
      "ticket_detail.sprachnotizen_in_administration_ki_einstellu": "Ative as notas de voz em Administração → Configurações de IA.",
      "ticket_detail.sprachnotizen_nicht_aktiv": "Notas de voz não ativas",
      "ticket_detail.stimme_uebermitteln": "Enviar voto",
      "ticket_detail.tag_entfernen": "Remover tag",
      "ticket_detail.tag_hinzufuegen": "Adicionar tag…",
      "ticket_detail.tag_hinzufuegen_2": "Adicionar tag",
      "ticket_detail.ticket_nicht_gefunden": "Ticket não encontrado",
      "ticket_detail.ticket_wird_geladen": "Carregando o ticket...",
      "ticket_detail.timer_laeuft_fuer_anderes_ticket": "O timer está em execução para outro ticket",
      "ticket_detail.timer_starten": "Iniciar timer",
      "ticket_detail.timer_stoppen": "Parar timer",
      "ticket_detail.uebersicht": "Visão geral",
      "ticket_detail.veroeffentlicht": "Publicado",
      "ticket_detail.was_wurde_erledigt": "O que foi feito?",
      "ticket_detail.welches_risiko_besteht_fuer_den_betrieb": "Qual é o risco para a operação?",
      "ticket_detail.wie_machen_wir_aenderungen_rueckgaengig": "Como revertemos as alterações?",
      "ticket_detail.wie_wird_die_funktion_verifiziert": "Como a funcionalidade será verificada?",
      "ticket_detail.zeiteintraege": "Registros de tempo",
      "ticket_detail.zugewiesen_an": "Atribuído a",
      "ticket_detail.zugewiesen_an_2": "Atribuído a",
      "ticket_detail.zurueck_zur_uebersicht": "Voltar à visão geral",
      "ticket_detail.zustimmung_des_change_advisory_boards_cab_zw": "A aprovação do Change Advisory Board (CAB) é obrigatória",
      "ticket_filter_active_label": "Filter aktiv",
      "ticket_inventory_kpis": "Kennzahlen & Arbeitslast",
      "ticket_properties_title": "Ticket",
      "ticket_relations": "Verknüpfte Tickets",
      "ticket_view_search_label": "Diese Ticketansicht durchsuchen",
      "tickets": "Tickets",
      "tickets_exist_hint": "Insgesamt sind {{count}} Tickets vorhanden.",
      "tickets_near_sla_breach": "Tickets próximos a violar o SLA",
      "tickets_plural": "{{count}} tickets",
      "tickets_ratio_label": "{{count}} de {{total}} tickets",
      "tickets_selected": "{{count}} tickets selecionados",
      "tickets_without_assignee": "Tickets sem responsável",
      "time_logged": "Tempo registrado: {{time}}",
      "time_minutes": "Zeit in Minuten",
      "title": "Título",
      "to_reply_composer": "Ir para a resposta (Composer)",
      "today_due": "Vence hoje",
      "toggle_design_mode": "Alternar modo de design",
      "toggle_favorite": "Alternar favorito",
      "tracked_hours": "{{hours}} h",
      "tracked_hours_min": "{{hours}} h {{minutes}} min.",
      "tracked_min": "{{minutes}} min.",
      "tracked_time": "Tempo registrado",
      "unassigned": "Não atribuídos",
      "unlink_asset": "Desvincular",
      "unread": "Não lido",
      "update": "Atualizar",
      "updated_at": "Atualizado",
      "urgent": "Urgente",
      "user_profile_logout": "Perfil de usuário e sair",
      "vat_id": "NIF/IVA",
      "views": "Visualizações",
      "voice_notes_admin_hint": "Notas de voz: Ative 'Notas de Voz' em Administração → Configurações de IA.",
      "voice_notes_enable_info": "Ative as notas de voz em Administração → Configurações de IA (ative 'Notas de Voz').",
      "voice_notes_not_active": "Notas de voz inativas",
      "website": "Site",
      "widget_critical_tickets": "Tickets críticos (Urgências)",
      "widget_group_analytics_team": "Análises e Equipe",
      "widget_group_overview_performance": "Visão Geral e Desempenho",
      "widget_group_volume_trends": "Volume e Tendências",
      "widget_my_open_tickets": "Meus tickets abertos",
      "widget_performance_times": "Tempos de desempenho e esforço",
      "widget_priority_chart": "Distribuição de prioridades",
      "widget_sla_compliance": "Conformidade SLA e risco",
      "widget_status_chart": "Distribuição de status de tickets",
      "widget_team_presence": "Presença e atividade da equipe",
      "widget_ticket_trends": "Tendências de tickets e volume",
      "widget_top_customers": "Principais clientes por tickets",
      "zip_code": "Código postal"
    }
  },
  "pl": {
    "translation": {
      "access_denied": "Dostęp zabroniony",
      "access_denied_desc": "Wymagane uprawnienia agenta lub administratora.",
      "actions": "Akcje",
      "activate_dark_mode": "Aktywuj ciemny motyw",
      "activate_light_mode": "Aktywuj jasny motyw",
      "active": "Aktywny",
      "active_filters": "Aktive Filter",
      "active_open_assignments": "Aktywne, otwarte przypisania",
      "activity_optional": "Czynność (opcjonalnie)",
      "admin": "Admin",
      "admin_dashboard.administrative_berechtigungen": "Uprawnienia administracyjne",
      "admin_dashboard.aendern": "Zmień",
      "admin_dashboard.agent_deaktiviert": "Agent dezaktywowany",
      "admin_dashboard.agent_erstellt": "Agent utworzony",
      "admin_dashboard.agent_gespeichert": "Agent zapisany",
      "admin_dashboard.agent_ohne_zuordnung_hinweis": "Bez przypisania ten agent widzi {{umfang}} klientów. Gdy tylko zostanie przypisany co najmniej jeden klient, agent jest ograniczony do tych klientów — zgłoszenia, raporty i zasoby.",
      "admin_dashboard.agenten_in_der_kundenkonsole": "Agenci w konsoli klienta",
      "admin_dashboard.aktuelles_passwort": "Aktualne hasło",
      "admin_dashboard.alle_eingehenden_befehle_wurden_bereits_vera": "Wszystkie przychodzące polecenia zostały już przetworzone lub zatwierdzone.",
      "admin_dashboard.alle_kunden": "Wszyscy klienci",
      "admin_dashboard.als_hauptkategorie_erstellen": "Utwórz jako kategorię główną",
      "admin_dashboard.api_token_hinweis": "W razie potrzeby utwórz wcześniej token API na karcie {{reiter}} z zakresem {{scope}}.",
      "admin_dashboard.aufloesungszeit": "Czas rozwiązania *",
      "admin_dashboard.basic_auth_benutzername_passwort": "Basic Auth (nazwa użytkownika/hasło)",
      "admin_dashboard.bei_prefix_u00c4nderung_werden_alle_bestehen": "Po zmianie prefiksu wszystkie istniejące zgłoszenia zostaną automatycznie przemianowane.",
      "admin_dashboard.benoetigte_berechtigung": "Wymagane uprawnienie:",
      "admin_dashboard.bestaetigen": "Potwierdź",
      "admin_dashboard.bezeichnung_positionszeile": "Nazwa pozycji",
      "admin_dashboard.bitte_kunde_waehlen": "Wybierz klienta...",
      "admin_dashboard.bitte_kunde_waehlen_2": "Wybierz klienta...",
      "admin_dashboard.definieren_sie_hauptkategorien_und_bis_zu_zw": "Zdefiniuj kategorie główne oraz maksymalnie dwa poziomy podkategorii. Będą one oferowane do wyboru podczas tworzenia zgłoszenia.",
      "admin_dashboard.definiert_die_standard_reihenfolge_der_queue": "Określa domyślną kolejność kolejek na pasku bocznym agenta.",
      "admin_dashboard.details_anzeigen": "Pokaż szczegóły",
      "admin_dashboard.details_anzeigen_2": "Pokaż szczegóły",
      "admin_dashboard.die_smtp_einstellungen_fuer_den_e_mail_versa": "Ustawienia SMTP dla wysyłki e-mail są teraz konfigurowane centralnie w sekcji",
      "admin_dashboard.e_mail_versand_smtp_wird_unter_e_mail_einste": "Wysyłkę e-mail (SMTP) konfiguruje się w ustawieniach e-mail",
      "admin_dashboard.eine_sicherheitsgruppe_legt_fest_welche_kons": "Grupa zabezpieczeń określa, które moduły konsoli widzi agent. „Pełny dostęp” = wszystkie moduły. Uprawnienia administratora są od tego niezależne.",
      "admin_dashboard.einstellungen_speichern": "Zapisz ustawienia",
      "admin_dashboard.eintraege": "Wpisy",
      "admin_dashboard.endgeraet": "Urządzenie końcowe",
      "admin_dashboard.endgueltig_loeschen": "Endgültig löschen",
      "admin_dashboard.entwurfsrechnung_aus_zeiteintraegen": "Projekt faktury z wpisów czasu",
      "admin_dashboard.erstellen_sie_ihre_erste_automatisierung": "Utwórz swoją pierwszą automatyzację",
      "admin_dashboard.erstellen_sie_oben_ihre_erste_hauptkategorie": "Utwórz powyżej swoją pierwszą kategorię główną",
      "admin_dashboard.externer_mitarbeiter_dienstleister": "Pracownik zewnętrzny / usługodawca",
      "admin_dashboard.fehler_beim_deaktivieren": "Błąd podczas dezaktywacji",
      "admin_dashboard.fehler_beim_deaktivieren_2": "Błąd podczas dezaktywacji",
      "admin_dashboard.fehler_beim_deaktivieren_3": "Błąd podczas dezaktywacji",
      "admin_dashboard.fehler_beim_loeschen": "Błąd podczas usuwania",
      "admin_dashboard.firma_adresse_kontakt_steuernummern_in_der_u": "Firma, adres, kontakt i numery podatkowe można edytować w przeglądzie. Dezaktywacja klientów pozostaje zastrzeżona dla administratora.",
      "admin_dashboard.fuer_entra_id_benoetigen_sie_eine_app_regist": "Dla Entra ID wymagana jest rejestracja aplikacji w Azure Portal z uprawnieniem Mail.Read.",
      "admin_dashboard.geloescht": "Usunięto",
      "admin_dashboard.geloescht_2": "Usunięto",
      "admin_dashboard.installationspaket_herunterladen": "Pobierz pakiet instalacyjny",
      "admin_dashboard.kategorie_aktualisiert": "Kategoria zaktualizowana",
      "admin_dashboard.kategorie_erstellt": "Kategoria utworzona",
      "admin_dashboard.kategorie_geloescht": "Kategoria usunięta",
      "admin_dashboard.keine_abteilung": "Brak działu",
      "admin_dashboard.keine_ausstehenden_befehls_freigaben_vorhand": "Brak oczekujących zatwierdzeń poleceń.",
      "admin_dashboard.keine_workflows_konfiguriert": "Nie skonfigurowano żadnych przepływów pracy",
      "admin_dashboard.keine_zuordnung_dieser_agent_sieht_alle_kund": "Brak przypisania — ten agent widzi wszystkich klientów.",
      "admin_dashboard.konfigurieren_sie_sprachmodelle_auto_respons": "Skonfiguruj modele językowe, prompty automatycznych odpowiedzi i szablony systemowe",
      "admin_dashboard.kunde_auswaehlen": "Wybierz klienta *",
      "admin_dashboard.kunde_deaktiviert": "Klient dezaktywowany",
      "admin_dashboard.kunde_erstellt": "Klient utworzony",
      "admin_dashboard.kunde_geloescht": "Kunde „{{firma}}\" wurde endgültig gelöscht",
      "admin_dashboard.kunde_gespeichert": "Klient zapisany",
      "admin_dashboard.kunde_waehlen": "Wybierz klienta…",
      "admin_dashboard.kundenzuordnung_verwalten": "Zarządzaj przypisaniem klientów",
      "admin_dashboard.laden_sie_ein_fertiges_zip_archiv_fuer": "Pobierz gotowe archiwum ZIP dla",
      "admin_dashboard.laedt": "Ładowanie…",
      "admin_dashboard.laengengrad": "Długość geograficzna",
      "admin_dashboard.legen_sie_fest_welche_daten_der_installierte": "Określ, jakie dane zbiera zainstalowany agent, i skonfiguruj opcjonalny bezagentowy skaner sieci (ping podsieci).",
      "admin_dashboard.letzte_exporte": "Ostatnie eksporty",
      "admin_dashboard.lexoffice_artikel_uuid_optional_dienstleistu": "UUID artykułu Lexoffice (opcjonalnie, usługa)",
      "admin_dashboard.lexoffice_deaktiviert_hinweis": "Integracja z LexOffice jest obecnie wyłączona. Wersje robocze faktur można tworzyć dopiero po włączeniu i skonfigurowaniu integracji w sekcji {{bereich}}.",
      "admin_dashboard.lexoffice_einstellungen_konnten_nicht_gelade": "Nie udało się wczytać ustawień Lexoffice (wykonaj migrację / uruchom ponownie serwer).",
      "admin_dashboard.loeschen": "Usuń",
      "admin_dashboard.loeschen_2": "Usuń",
      "admin_dashboard.mailbox_empfang_imap_oauth_wird_unter_postfa": "Odbiór poczty (IMAP/OAuth) konfiguruje się w skrzynkach pocztowych",
      "admin_dashboard.mailbox_speichern": "Zapisz skrzynkę pocztową",
      "admin_dashboard.microsoft_graph_api": "Microsoft Graph API",
      "admin_dashboard.mit_einem_frisch_generierten_api_schluessel": "ze świeżo wygenerowanym kluczem API oraz",
      "admin_dashboard.mitarbeiter_deaktiviert": "Pracownik dezaktywowany",
      "admin_dashboard.mitarbeiter_erstellt": "Pracownik utworzony",
      "admin_dashboard.mitarbeiter_gespeichert": "Pracownik zapisany",
      "admin_dashboard.mloffice_gefuehrt": "Stammdaten werden von MLOffice geführt",
      "admin_dashboard.mloffice_geloest": "Mit MLOffice verknüpft — Abgleich derzeit gelöst",
      "admin_dashboard.module_assets": "Zasoby",
      "admin_dashboard.module_calendar": "Kalendarz",
      "admin_dashboard.module_customers": "Klienci",
      "admin_dashboard.module_knowledge": "Baza wiedzy",
      "admin_dashboard.module_licenses": "Licencje",
      "admin_dashboard.module_problems": "Problemy",
      "admin_dashboard.module_reports": "Raporty",
      "admin_dashboard.module_tickets": "Zgłoszenia",
      "admin_dashboard.nach_kunde_filtern": "Filtruj według klienta",
      "admin_dashboard.neue_mailbox_konfiguration": "Nowa konfiguracja skrzynki pocztowej",
      "admin_dashboard.neuer_workflow": "Nowy przepływ pracy",
      "admin_dashboard.neues_passwort": "Nowe hasło",
      "admin_dashboard.nicht_abrechenbar": "Nierozliczalne",
      "admin_dashboard.noch_keine_kategorien_definiert": "Nie zdefiniowano jeszcze żadnych kategorii",
      "admin_dashboard.noch_keine_zeiteintraege_vorhanden": "Brak wpisów czasu",
      "admin_dashboard.nur_abrechenbare_eintraege_ohne_vorherigen_l": "Tylko wpisy rozliczalne bez wcześniejszego eksportu do Lexoffice; opcjonalnie filtruj według ID umowy.",
      "admin_dashboard.optionale_beschreibung_des_sla_umfangs": "Opcjonalny opis zakresu SLA",
      "admin_dashboard.passwort_aendern": "Zmień hasło",
      "admin_dashboard.primaer": "Podstawowy",
      "admin_dashboard.prioritaet_geaendert": "• Priorytet zmieniony",
      "admin_dashboard.pruefinterval_minuten": "Interwał sprawdzania (minuty)",
      "admin_dashboard.refresh_token": "Refresh Token",
      "admin_dashboard.sie_koennen_den_agenten_auch_manuell_registr": "Agenta można również zarejestrować ręcznie. Użyj w tym celu następującej składni na komputerze klienckim (wymaga uprawnień administratora):",
      "admin_dashboard.standardmaessig_duerfen_agenten_kunden_stamm": "Domyślnie agenci mogą jedynie odczytywać dane podstawowe klientów i przeglądać dokumenty klientów. Tutaj można włączyć rozszerzone prawa zapisu dla poszczególnych funkcji.",
      "admin_dashboard.status_geaendert": "• Status zmieniony",
      "admin_dashboard.stundensatz_ueberschreiben_optional": "Nadpisz stawkę godzinową (opcjonalnie)",
      "admin_dashboard.tarif_erweitern": "Rozszerz taryfę",
      "admin_dashboard.ticket_id_format_und_admin_passwort_koennen": "Format ID zgłoszenia i hasło administratora można skonfigurować tutaj",
      "admin_dashboard.top_kunden_nach_ticketvolumen": "Najwięksi klienci według liczby zgłoszeń",
      "admin_dashboard.uebergeordnete_kategorie": "Kategoria nadrzędna",
      "admin_dashboard.unterkategorie_hinzufuegen": "Dodaj podkategorię",
      "admin_dashboard.upload_metadaten_bearbeiten_und_loeschen_von": "Przesyłanie, edycja metadanych i usuwanie plików w zakładce klienta „Dokumenty”.",
      "admin_dashboard.verfuegbare_trigger": "Dostępne wyzwalacze",
      "admin_dashboard.verwalten_und_genehmigen_sie_ausstehende_adm": "Zarządzaj oczekującymi poleceniami administracyjnymi od innych administratorów i zatwierdzaj je przed wykonaniem na urządzeniach końcowych klientów.",
      "admin_dashboard.voller_zugriff_alle_module": "Pełny dostęp (wszystkie moduły)",
      "admin_dashboard.vorkonfiguriertes_paket_zip": "Wstępnie skonfigurowany pakiet (.zip)",
      "admin_dashboard.was_bedeuten_die_gruppen": "Co oznaczają grupy?",
      "admin_dashboard.workflow_automatisierungen": "Automatyzacje przepływów pracy",
      "admin_dashboard.z_b_hauptsitz_koeln": "np. siedziba główna Kolonia",
      "admin_dashboard.zeit_standardmaessig_abrechenbar": "Czas domyślnie rozliczalny",
      "admin_dashboard.zeitbuchung_bei_ticket_schliessung_erforderl": "Rejestracja czasu wymagana przy zamykaniu zgłoszenia",
      "admin_dashboard.zeitbuchungen_erscheinen_hier_sobald_agenten": "Wpisy czasu pojawią się tutaj, gdy agenci zaczną rejestrować czas na zgłoszeniach.",
      "admin_dashboard.zeiteintraege": "Wpisy czasu",
      "admin_dashboard.zeiterfassung_aktivieren": "Włącz rejestrację czasu",
      "admin_dashboard.zeiterfassung_einstellungen": "Ustawienia rejestracji czasu",
      "admin_dashboard.zugriff_verweigert": "Odmowa dostępu",
      "admin_dashboard.zugriff_verweigert_text": "Nie masz uprawnień administracyjnych wymaganych do przeglądania obszaru {{bereich}} ani zarządzania nim.",
      "admin_dashboard.zuordnung_entfernen": "Usuń przypisanie",
      "admin_dashboard.zusaetzliche_admin_rechte": "Dodatkowe uprawnienia administratora",
      "admin_default": "Standard administratora",
      "admin_only_change": "(tylko administrator może zmienić przypisanie.)",
      "admin_overview.aktive_warnungen_risiken": "Aktywne ostrzeżenia i ryzyka",
      "admin_overview.alles_in_ordnung": "Wszystko w porządku",
      "admin_overview.datenbank_engine": "Silnik bazy danych",
      "admin_overview.einstellungen_filtern": "Filtruj ustawienia...",
      "admin_overview.hinweis_fuer_administratoren": "Wskazówka dla administratorów:",
      "admin_overview.keine_ergebnisse_gefunden": "Nie znaleziono wyników",
      "admin_overview.keine_warnungen_oder_kritischen_meldungen": "Brak ostrzeżeń i komunikatów krytycznych.",
      "admin_overview.lade_dashboard_daten": "Wczytywanie danych pulpitu...",
      "admin_overview.system_status": "Status systemu",
      "admin_overview.upgrade_erforderlich": "Wymagana aktualizacja",
      "admin_overview.upgrade_erforderlich_2": "Wymagana aktualizacja",
      "admin_overview.versuchen_sie_es_mit_einem_anderen_suchbegri": "Spróbuj innego hasła wyszukiwania.",
      "admin_overview.zurueck_zum_agent_dashboard": "Powrót do pulpitu agenta",
      "admin_view": "Widok administratora",
      "administration": "Administracja",
      "administrator": "Administrator",
      "agent": "Agent",
      "agent_available": "Dostępny",
      "agent_console": "Konsola agenta",
      "agent_console.alle_als_gelesen": "Wszystkie jako przeczytane",
      "agent_console.anhaenge": "Załączniki",
      "agent_console.anhaenge_zum_eroeffnungsbeitrag": "Załączniki do wpisu otwierającego",
      "agent_console.back_to_ticket_list": "Zurück zur Liste",
      "agent_console.beschreiben_sie_hier_details_die_dem_partner": "Opisz tutaj szczegóły, które mają zostać przekazane partnerowi...",
      "agent_console.bitte_waehlen": "-- Wybierz --",
      "agent_console.detailansicht_schliessen": "Zamknij widok szczegółów",
      "agent_console.erneut_oeffnen": "Otwórz ponownie",
      "agent_console.hinweis_der_partner_erhaelt_eine_benachricht": "Wskazówka: partner otrzyma wiadomość e-mail z powiadomieniem zawierającą podane dane oraz bezpieczny link do obsługi zgłoszenia.",
      "agent_console.interner_chat": "Czat wewnętrzny",
      "agent_console.interner_chat_2": "Czat wewnętrzny",
      "agent_console.keine_benachrichtigungen": "Brak powiadomień",
      "agent_console.language_selection": "Wybór języka",
      "agent_console.loesen": "Rozwiąż",
      "agent_console.mir_zuweisen": "Przypisz do mnie",
      "agent_console.nachricht_notiz_fuer_den_partner_optional": "Wiadomość / notatka dla partnera (opcjonalnie)",
      "agent_console.neues_ticket": "Nowe zgłoszenie",
      "agent_console.neues_ticket_2": "Nowe zgłoszenie",
      "agent_console.partner_dienstleister_waehlen": "Wybierz partnera / usługodawcę",
      "agent_console.schliessen": "Zamknij",
      "agent_console.schliessen_2": "Zamknij",
      "agent_console.schliessungsgrund": "Powód zamknięcia:",
      "agent_console.schnellsuche_oeffnen": "Otwórz szybkie wyszukiwanie",
      "agent_console.sie_benoetigen_agent_oder_admin_rechte": "Wymagane są uprawnienia agenta lub administratora.",
      "agent_console.tastenkuerzel": "Skróty klawiszowe",
      "agent_console.ticket_erstellt": "Zgłoszenie utworzone",
      "agent_console.ticket_schliessen": "Zamknij zgłoszenie",
      "agent_console.zugriff_verweigert": "Odmowa dostępu",
      "agent_console.zur_antwort_composer": "Do odpowiedzi (edytor)",
      "agent_console.zur_antwort_scrollen": "Przewiń do odpowiedzi",
      "agent_console.zusammenfuehren": "Zusammenführen",
      "agent_console.zuweisung_entfernen": "Usuń przypisanie",
      "ai": "SI",
      "ai_analysis_running": "Trwa analiza...",
      "ai_assistance": "Asystent SI",
      "ai_confidence_label": "Pewność {{pct}}%",
      "ai_context_title": "KI-Kontext & Prognosen",
      "ai_generate_summary": "Generuj podsumowanie",
      "ai_key_points": "Kluczowe punkty",
      "ai_next_steps": "Następne kroki",
      "ai_requested_action": "Wnioskowane działanie",
      "ai_risks": "Ryzyka",
      "ai_solution_assistant_title": "Asystent rozwiązań SI",
      "ai_stale": "Nieaktualne",
      "ai_summary_title": "Podsumowanie SI",
      "all": "Wszystkie",
      "all_active_tickets": "Wszystkie aktywne zgłoszenia",
      "all_categories": "Wszystkie kategorie",
      "all_customers": "Wszyscy klienci",
      "all_deadlines_ok": "Wszystkie terminy są w porządku.",
      "all_open": "Wszystkie otwarte",
      "all_tickets": "Wszystkie zgłoszenia",
      "allgemein.abbrechen": "Abbrechen",
      "allgemein.schliessen": "Schließen",
      "analyze_again": "Analizuj ponownie",
      "article": "Artykuł",
      "article_ai_generate": "Utwórz artykuł za pomocą SI",
      "article_ai_generate_btn": "Generuj artykuł",
      "article_ai_generate_desc": "Opisz temat, a SI wygeneruje szkic",
      "article_ai_improve": "Ulepsz tekst",
      "article_ai_keywords": "Słowa kluczowe (opcjonalnie)",
      "article_ai_keywords_placeholder": "np. Windows 11, OpenVPN, certyfikat",
      "article_ai_language": "Język",
      "article_ai_len_long": "Długi / szczegółowy",
      "article_ai_len_medium": "Średni",
      "article_ai_len_short": "Krótki",
      "article_ai_length": "Długość",
      "article_ai_style": "Styl języka",
      "article_ai_style_balanced": "Zrównoważony",
      "article_ai_style_enduser": "Użytkownik końcowy (krok po kroku)",
      "article_ai_style_formal": "Formalny",
      "article_ai_style_simple": "Prosty / łatwy do zrozumienia",
      "article_ai_style_technical": "Techniczny (specjaliści IT)",
      "article_ai_summarize": "Generuj podsumowanie",
      "article_ai_topic": "Temat *",
      "article_ai_topic_placeholder": "np. Skonfiguruj połączenie VPN w systemie Windows",
      "article_all_customers": "Wszyscy klienci",
      "article_all_statuses": "Wszystkie statusy",
      "article_all_visible": "Widoczny dla wszystkich klientów",
      "article_archived": "Zarchiwizowane",
      "article_category": "Kategoria",
      "article_content_placeholder": "Zacznij pisać artykuł tutaj...",
      "article_create_first": "Utwórz pierwszy artykuł",
      "article_create_first_desc": "Utwórz swój pierwszy artykuł bazy wiedzy, aby podzielić się informacjami z zespołem.",
      "article_create_with_ai": "Utwórz za pomocą SI",
      "article_delete_confirm": "Czy na pewno chcesz usunąć ten artykuł?",
      "article_draft": "Szkic",
      "article_excerpt_placeholder": "Krótkie podsumowanie artykułu...",
      "article_manage": "Zarządzaj artykułami",
      "article_new": "Nowy artykuł",
      "article_no_articles": "Brak dostępnych artykułów",
      "article_no_categories_desc": "Brak dostępnych kategorii. Utwórz je w obszarze administracyjnym.",
      "article_no_category": "Brak kategorii",
      "article_not_found": "Nie znaleziono artykułów",
      "article_not_found_desc": "Nie znaleziono artykułów dla Twojego zapytania.",
      "article_only_visible": "Widoczny tylko dla {{name}}",
      "article_pinned": "Przypięty",
      "article_pinned_desc": "Będzie wyświetlany na górze listy",
      "article_plural": "Wszystkie artykuły",
      "article_published": "Opublikowano",
      "article_search": "Szukaj artykułów...",
      "article_views": "wyświetleń",
      "article_visibility": "Widoczność dla klientów",
      "article_write_content": "Treść artykułu",
      "article_write_excerpt": "Wyciąg",
      "article_write_title": "Wpisz tytuł artykułu...",
      "asset.discovery_agents": "Agenci wykrywania",
      "asset.event_logs": "Dzienniki zdarzeń",
      "asset.general": "Ogólne",
      "asset.hardware_wmi": "Sprzęt (WMI)",
      "asset.history_changes": "Historia i Zmiany",
      "asset.more": "Więcej",
      "asset.network": "Sieć",
      "asset.network_discovery": "Wykrywanie sieci",
      "asset.printers": "Drukarki",
      "asset.processes": "Procesy",
      "asset.relationships": "Relacje",
      "asset.remote_control": "Zdalne sterowanie",
      "asset.remote_terminal": "Terminal zdalny",
      "asset.scan_history": "Historia skanowania",
      "asset.security": "Bezpieczeństwo",
      "asset.services": "Usługi",
      "asset.software_catalog": "Katalog oprogramowania (SAM)",
      "asset.software_count": "Oprogramowanie",
      "asset.system_assets": "Zasoby systemowe",
      "asset.updates": "Aktualizacje",
      "asset_": "asset_",
      "asset_active": "Aktywny",
      "asset_agent.offline": "Offline",
      "asset_agent.online_active": "Online (aktywny)",
      "asset_agent.recently_active": "Ostatnio aktywny",
      "asset_inactive": "Nieaktywny",
      "asset_maintenance": "Konserwacja",
      "asset_management": "Zarządzanie zasobami",
      "asset_panel.confirm_delete_asset": "Czy na pewno usunąć \"{{name}}\"?",
      "asset_panel.confirm_delete_category": "Usunąć kategorię \"{{name}}\"? Zasoby zostaną od niej odłączone.",
      "asset_panel.edit_asset": "Edytuj zasób",
      "asset_panel.edit_category": "Edytuj kategorię",
      "asset_panel.import_as_managed_btn": "Importuj jako zarządzany zasób",
      "asset_panel.import_device": "Importuj urządzenie",
      "asset_panel.new_asset": "Nowy zasób",
      "asset_panel.new_category": "Nowa kategoria",
      "asset_panel.print_asset_tag": "Drukuj etykietę zasobu",
      "asset_panel.print_now_btn": "Drukuj teraz",
      "asset_panel.toast.agent_no_response_hint": "Agent nie odpowiedział na czas.",
      "asset_panel.toast.assets_imported": "Zaimportowano zasoby: {{count}}",
      "asset_panel.toast.command_queued": "Polecenie zostało dodane do kolejki",
      "asset_panel.toast.create_problem_error": "Błąd podczas tworzenia zgłoszenia problemu",
      "asset_panel.toast.csv_import_failed": "Import CSV nie powiódł się",
      "asset_panel.toast.device_ignored": "Urządzenie zostało zignorowane",
      "asset_panel.toast.device_imported": "Urządzenie zostało zaimportowane do zarządzanych zasobów",
      "asset_panel.toast.ignore_device_error": "Błąd podczas ignorowania urządzenia",
      "asset_panel.toast.import_device_error": "Błąd podczas importowania urządzenia",
      "asset_panel.toast.import_with_errors": "Import zakończony z błędami",
      "asset_panel.toast.itil_correlation_error": "Błąd korelacji problemów ITIL",
      "asset_panel.toast.less_than_3_tickets": "Mniej niż 3 zgłoszenia w ciągu ostatnich 30 dni.",
      "asset_panel.toast.manual_scan_error": "Błąd podczas skanowania ręcznego",
      "asset_panel.toast.problem_ticket_created": "Utworzono zgłoszenie problemu i powiązano incydenty!",
      "asset_panel.toast.queue_command_error": "Nie udało się dodać polecenia do kolejki",
      "asset_panel.toast.request_scan_error": "Błąd podczas żądania skanowania",
      "asset_panel.toast.scan_completed": "Skanowanie zakończone pomyślnie",
      "asset_panel.toast.scan_failed": "Skanowanie nie powiodło się",
      "asset_panel.toast.scan_requested": "Zażądano: {{type}}",
      "asset_panel.toast.template_downloaded": "Pobrano szablon „asset-import-vorlage.csv”",
      "asset_panel.toast.template_load_error": "Nie udało się załadować szablonu",
      "asset_remote_client_disconnected": "Klient rozłączył się",
      "asset_remote_client_disconnected_desc": "Użytkownik na urządzeniu klienckim zakończył sesję zdalnego wsparcia.",
      "asset_remote_closed_desc": "Sesja zdalnego wsparcia została pomyślnie zamknięta.",
      "asset_remote_code_placeholder": "np. 123 456",
      "asset_remote_conn_disconnected": "Rozłączono",
      "asset_remote_conn_failed": "Połączenie z serwerem zdalnym nie powiodło się",
      "asset_remote_conn_rejected": "Połączenie odrzucone",
      "asset_remote_consent_hint": "Na ekranie klienta wyświetli się okno zgody. Poproś klienta o zaakceptowanie.",
      "asset_remote_disconnect": "Rozłącz",
      "asset_remote_enter_code_hint": "Wprowadź 6-cyfrowy kod dostępu wyświetlony na ekranie użytkownika:",
      "asset_remote_invalid_code": "Nieprawidłowy kod dostępu",
      "asset_remote_live_focus": "NA ŻYWO · Aktywny obszar wprowadzania danych",
      "asset_remote_loading_screen": "Ładowanie ekranu na żywo...",
      "asset_remote_preparing": "Przygotowywanie połączenia...",
      "asset_remote_protocol2_code_label": "Zwölfstelliger Zugangscode",
      "asset_remote_protocol2_code_placeholder": "ABCD EFGH 2345",
      "asset_remote_protocol2_enter_code_hint": "Geben Sie den zwölfstelligen Zugangscode vom Bildschirm des Benutzers ein:",
      "asset_remote_protocol2_request_desc": "Sendet eine Verbindungsanfrage an den Client-Rechner. Der Benutzer muss zustimmen und den zwölfstelligen Zugangscode übermitteln.",
      "asset_remote_rejected_desc": "Żądanie połączenia zostało odrzucone przez użytkownika na urządzeniu klienckim.",
      "asset_remote_req": "Zażądaj sesji zdalnej",
      "asset_remote_request_again": "Zażądaj ponownie",
      "asset_remote_request_desc": "Wysyła żądanie połączenia do maszyny klienckiej. Użytkownik musi wyrazić zgodę i udostępnić 6-cyfrowy kod dostępu.",
      "asset_remote_request_title": "Zażądaj Zdalnego Wsparcia",
      "asset_remote_start_error": "Nie można uruchomić sesji zdalnego wsparcia",
      "asset_remote_start_new": "Uruchom nową sesję",
      "asset_remote_support": "Zintegrowane wsparcie zdalne",
      "asset_remote_support_desc": "Bezpośrednie zdalne sterowanie ekranem bez zewnętrznego oprogramowania (TeamViewer/RustDesk).",
      "asset_remote_user_consented": "Użytkownik wyraził zgodę",
      "asset_remote_verifying_code": "Weryfikacja kodu...",
      "asset_remote_waiting_consent": "Oczekiwanie na zgodę użytkownika...",
      "asset_retired": "Wycofany",
      "assets": "Zasoby",
      "assign_to": "Przypisz...",
      "assign_to_me": "Przypisz do mnie",
      "assigned_agents": "Przypisani agenci",
      "assigned_to": "Przypisane do",
      "at_risk_title": "Zagrożone (Ostrzeżenie SLA):",
      "attach_local_file": "Załącz plik lokalny",
      "attachments": "Załączniki",
      "attachments_tools": "Załączniki i Narzędzia",
      "attendees_emails": "Uczestnicy (e-maile, oddzielone przecinkami)",
      "automation": "Automatyzacja",
      "avg_first_response": "Czas pierwszej odpowiedzi",
      "avg_resolution": "Średni czas rozwiązania",
      "billable": "Płatne",
      "billable_time": "Płatne: {{time}}",
      "book_on_send": "Zapisz przy wysyłce",
      "book_time_with_reply": "Zarejestruj czas z odpowiedzią",
      "calendar": "Kalendarz",
      "calendar_enter_title_warning": "Proszę wpisać tytuł.",
      "calendar_event_attendees": "Adresy e-mail uczestników (opcjonalnie, oddzielone przecinkami)",
      "calendar_event_created_error": "Nie można utworzyć wydarzenia.",
      "calendar_event_created_success": "Wydarzenie utworzone.",
      "calendar_event_description": "Opis (opcjonalnie)",
      "calendar_event_title": "Tytuł",
      "calendar_meeting_created_error": "Nie można utworzyć spotkania.",
      "calendar_meeting_link_copied": "Link do spotkania skopiowany do schowka.",
      "calendar_new_event": "Nowe wydarzenie",
      "calendar_no_integration_or": "lub",
      "calendar_no_integration_prefix": "Brak aktywnej integracji kalendarza lub spotkań. Skonfiguruj",
      "calendar_no_integration_suffix": "z aktywnym planowaniem spotkań w integracjach.",
      "calendar_only_event": "Tylko wydarzenie w kalendarzu",
      "calendar_talk_meeting": "Spotkanie Talk",
      "calendar_talk_room_created": "Pokój Talk utworzony.",
      "calendar_teams_meeting": "Spotkanie Teams",
      "calendar_teams_meeting_created": "Spotkanie Teams utworzone.",
      "cancel": "Anuluj",
      "canned_responses": "Wstaw gotowe odpowiedzi",
      "canned_responses_short": "Gotowa odpowiedź",
      "categories": "Kategorie",
      "category": "Kategoria",
      "change_priority": "Zmień priorytet...",
      "change_status_after_send": "Po wysłaniu zmień na",
      "change_ticket_company": "Ticket anderer Firma zuordnen",
      "change_ticket_company_warning": "Portal-Ersteller, CC, Mitarbeiter, Bearbeiter, Kategorie, SLA, Assets und laufende Timer werden für die neue Firma zurückgesetzt.",
      "characters": "znaki",
      "city": "Miasto",
      "clear_selection": "Wyczyść wybór",
      "click_to_logout": "Kliknij, aby się wylogować",
      "close": "Zamknij",
      "close_detail_view": "Zamknij widok szczegółowy",
      "close_ticket": "Zamknij zgłoszenie",
      "closed": "Zamknięte",
      "collapse": "Zwiń",
      "collapse_composer": "Zwiń edytor",
      "collapse_sidebar": "Zwiń panel boczny",
      "column_assignee_name": "Przypisany",
      "column_category_name": "Kategoria",
      "column_channel": "Kanał",
      "column_created_at": "Utworzono",
      "column_customer_name": "Klient",
      "column_priority": "Priorytet",
      "column_reply_count": "Odpowiedzi",
      "column_requester_name": "Zgłaszający",
      "column_sla": "SLA",
      "column_status": "Status",
      "column_subject": "Temat",
      "column_tags": "Tagi",
      "column_ticket_number": "Nr",
      "column_updated_at": "Zaktualizowano",
      "columns_btn": "Kolumny",
      "common.abbrechen": "Abbrechen",
      "company_name": "Nazwa firmy",
      "company_title": "Firma",
      "compliance_rate": "Wskaźnik zgodności",
      "composer_internal": "Wewnętrzny",
      "composer_internal_placeholder": "Notatka wewnętrzna...",
      "composer_public": "Publiczny",
      "composer_public_placeholder": "Napisz odpowiedź...",
      "configure_columns": "Konfiguracja kolumn",
      "connect": "Połącz",
      "contact_and_master_data": "Kontakt i Dane podstawowe",
      "contact_person": "Osoba kontaktowa",
      "contact_person_abbrev": "OK",
      "contract": "Umowa",
      "contract.auto_renew": "Automatyczne przedłużenie",
      "contract.auto_renews_suffix": " (przedłuża się automatycznie)",
      "contract.back_to_overview": "Powrót do przeglądu",
      "contract.billing": "Rozliczenie",
      "contract.billing_model": "Model rozliczenia",
      "contract.conditions": "Warunki",
      "contract.days": "{{count}} dni",
      "contract.end_date": "Data zakończenia",
      "contract.expires_in_days": "Wygasa za {{count}} dni",
      "contract.first_response": "Pierwsza reakcja",
      "contract.hourly_rate": "Stawka godzinowa",
      "contract.hours_quota": "Pula godzin",
      "contract.included_hours": "Godziny w abonamencie",
      "contract.no_contracts": "Brak umów",
      "contract.no_contracts_desc": "Prosimy o kontakt w sprawie indywidualnej oferty",
      "contract.notice_period": "Okres wypowiedzenia: {{count}} dni",
      "contract.period_per": "{{count}} h / okres",
      "contract.quota_summary": "Pozostało: {{remaining}} (wykorzystano {{percent}}%)",
      "contract.remaining": "Pozostało",
      "contract.resolution": "Rozwiązanie",
      "contract.runtime": "Okres obowiązywania",
      "contract.sla_tier": "SLA",
      "contract.start_date": "Data rozpoczęcia",
      "contract.status.active": "Aktywna",
      "contract.status.expired": "Wygasła",
      "contract.status.expiring_soon": "Wkrótce wygasa",
      "contract.status.future": "Przyszła",
      "contract.subtitle": "Przegląd Państwa aktywnych umów i umów o poziomie usług (SLA)",
      "contract.unlimited": "Bezterminowa",
      "contract.used": "Wykorzystano",
      "contracts": "Umowy",
      "copied_to_clipboard": "Skopiowano do schowka",
      "country": "Kraj",
      "create": "Utwórz",
      "create_ticket.aehnliche_tickets": "Podobne zgłoszenia",
      "create_ticket.angehaengte_cloud_dateien": "Załączone pliki z chmury:",
      "create_ticket.anhaenge": "Załączniki",
      "create_ticket.asset_verknuepfen_optional": "Powiąż zasób (opcjonalnie):",
      "create_ticket.assets_filtern": "Filtruj zasoby:",
      "create_ticket.assets_werden_geladen": "Wczytywanie zasobów...",
      "create_ticket.beschreiben_sie_das_problem_so_detailliert_w": "Opisz problem tak szczegółowo, jak to możliwe...",
      "create_ticket.betroffene_systeme_benutzer_nennen": "Wskaż systemy i użytkowników, których dotyczy problem",
      "create_ticket.bitte_betreff_und_beschreibung_ausfuellen": "Wypełnij temat i opis",
      "create_ticket.bitte_eine_beschreibung_angeben": "Podaj opis.",
      "create_ticket.bitte_einen_kunden_auswaehlen": "Wybierz klienta.",
      "create_ticket.bitte_hauptkategorie_waehlen": "Wybierz kategorię główną...",
      "create_ticket.bitte_klassifizierung_waehlen": "Wybierz klasyfikację...",
      "create_ticket.bitte_kunde_waehlen": "Wybierz klienta...",
      "create_ticket.bitte_unterkategorie_waehlen": "Wybierz podkategorię...",
      "create_ticket.bitte_zuerst_einen_kunden_waehlen": "Najpierw wybierz klienta...",
      "create_ticket.datei_hochladen": "Prześlij plik",
      "create_ticket.datei_hochladen_2": "Prześlij plik",
      "create_ticket.datei_zu_gross_max_10_mb": "Plik za duży (maks. 10 MB)",
      "create_ticket.dateityp_nicht_erlaubt": "Niedozwolony typ pliku",
      "create_ticket.erste_antwort": "Pierwsza odpowiedź",
      "create_ticket.fehlermeldungen_und_screenshots_beifuegen": "Dołącz komunikaty o błędach i zrzuty ekranu",
      "create_ticket.keine_mitarbeiter_hinterlegt": "Nie zapisano żadnych pracowników",
      "create_ticket.letzte_kunden_tickets": "Ostatnie zgłoszenia klienta",
      "create_ticket.loesung": "Rozwiązanie",
      "create_ticket.neues_ticket": "Nowe zgłoszenie",
      "create_ticket.nur_geschaeftszeiten": "Tylko godziny robocze",
      "create_ticket.praeziser_betreff_hilft_bei_der_zuordnung": "Precyzyjny temat ułatwia przypisanie",
      "create_ticket.priority_high": "Wysoki",
      "create_ticket.priority_low": "Niski",
      "create_ticket.priority_medium": "Średni",
      "create_ticket.priority_urgent": "Pilny",
      "create_ticket.schritte_zur_reproduktion_angeben": "Podaj kroki prowadzące do odtworzenia problemu",
      "create_ticket.stoerung": "Awaria",
      "create_ticket.text_mit_ki_verbessern": "Popraw tekst za pomocą AI",
      "create_ticket.ticket_erstellt": "Zgłoszenie utworzone!",
      "create_ticket.uebernehmen": "Zastosuj",
      "create_ticket.ueberschrift": "Nagłówek",
      "create_ticket.vielleicht_loest_ein_artikel_das_problem_ber": "Może któryś artykuł już rozwiązuje ten problem?",
      "create_ticket.vorlage_einfuegen": "Wstaw szablon",
      "create_ticket.waehlen_sie_einen_kunden_aus_um_dessen_asset": "Wybierz klienta, aby móc powiązać jego zasoby.",
      "create_ticket.werden_bei_erstellung_ausgeloest": "Wyzwalane przy utworzeniu",
      "create_ticket.zurueck": "Wstecz",
      "created_at": "Utworzono",
      "critical_priority_sla": "Priorytet / SLA",
      "customer": "Klient",
      "customer_assets.no_assets": "Brak zasobów zarejestrowanych dla tego klienta. Po podaniu identyfikatora hosta Zabbix lub monitora dostępności przy zasobie pojawią się tutaj informacje o statusie.",
      "customer_assets.no_assets_unconfigured": "Brak zarejestrowanych zasobów. Discovery lub integracja monitoringu może zautomatyzować inwentaryzację.",
      "customer_assets.no_zabbix_id": "Brak identyfikatora hosta Zabbix przy zasobie",
      "customer_assets.start_rd": "Uruchom RustDesk",
      "customer_assets.start_tv": "Uruchom TeamViewer",
      "customer_form.adresse_eingeben_um_karte_anzuzeigen": "Wprowadź adres, aby wyświetlić mapę",
      "customer_form.client_secret": "Client Secret",
      "customer_form.domain_entfernen": "Usuń domenę",
      "customer_form.domain_hinzufuegen": "+ Dodaj domenę",
      "customer_form.domains_mit_zugeordneten_mitarbeitern_koenne": "Nie można usunąć domen z przypisanymi pracownikami.",
      "customer_form.geschaeftsfuehrer": "Dyrektor zarządzający",
      "customer_form.in_openstreetmap_oeffnen": "Otwórz w OpenStreetMap ↗",
      "customer_form.interne_notizen_zu_diesem_kunden": "Notatki wewnętrzne dotyczące tego klienta...",
      "customer_form.kontakt_in_lexoffice_anlegen_uuid_hier_eintr": "Utwórz kontakt w Lexoffice i wpisz tutaj UUID",
      "customer_form.lexoffice_kontakt_id_uuid": "ID kontaktu Lexoffice (UUID)",
      "customer_form.logo_kann_nach_dem_erstellen_des_kunden_hoch": "Logo można przesłać po utworzeniu klienta.",
      "customer_form.mitarbeiter_koennen_sich_per_microsoft_konto": "Pracownicy mogą logować się za pomocą konta Microsoft",
      "customer_form.mloffice_badge": "Von MLOffice verwaltet",
      "customer_form.mloffice_banner": "Dieser Kunde wird mit MLOffice abgeglichen. Stammdaten (Name, E-Mail, Telefon, Anschrift, USt-ID) werden von MLOffice verwaltet und sind hier gesperrt.",
      "customer_form.mloffice_feld_hinweis": "Dieses Feld wird von MLOffice verwaltet — Änderungen bitte dort vornehmen; sie werden automatisch übernommen.",
      "customer_form.mloffice_geloest": "Verknüpfung gelöst — die Felder sind wieder bearbeitbar.",
      "customer_form.mloffice_loesen": "Verknüpfung lösen…",
      "customer_form.mloffice_loesen_fehler": "Verknüpfung konnte nicht gelöst werden.",
      "customer_form.mloffice_loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "customer_form.mloffice_loest": "Löse…",
      "customer_form.mloffice_verwaltung_hinweis": "Verwaltung der Verknüpfung unter Stammdaten & Organisation → MLOffice (erfordert Systemrechte).",
      "customer_form.registrieren_sie_eine_app_in_azure_portal_ap": "Zarejestruj aplikację w Azure Portal → Rejestracje aplikacji. Redirect URI:",
      "customer_form.strasse": "Ulica",
      "customer_form.tab_address": "Adres",
      "customer_form.tab_domains": "Domeny",
      "customer_form.tab_general": "Ogólne",
      "customer_form.tab_notes": "Notatki",
      "customer_form.tab_sso": "SSO",
      "customer_form.tab_tax": "Podatki i SLA",
      "customer_form.zuordnung_ticket_system_kunde_lexoffice_kont": "Przypisanie klienta systemu zgłoszeń → kontakt w Lexoffice na potrzeby projektów faktur (Admin → Rejestracja czasu).",
      "customer_inactive": "Klient nieaktywny",
      "customer_not_found": "Nie znaleziono klienta",
      "customer_notified_by_email": "Klient zostanie powiadomiony e-mailem",
      "customer_number_abbrev": "Nr Kl",
      "customer_portal.action_required": "Wymagane działanie",
      "customer_portal.action_required_desc": "Zespół wsparcia czeka na Państwa odpowiedź w tym zgłoszeniu.",
      "customer_portal.action_required_title": "Potrzebna jest Państwa odpowiedź",
      "customer_portal.assignee": "Osoba odpowiedzialna",
      "customer_portal.attachments_count": "Załączniki ({{count}})",
      "customer_portal.attachments_load_failed": "Weitere Anhänge konnten nicht geladen werden.",
      "customer_portal.back": "← Wstecz",
      "customer_portal.back_to_my_tickets": "← Powrót do moich zgłoszeń",
      "customer_portal.close": "Zamknij",
      "customer_portal.close_failed": "Nie udało się zamknąć zgłoszenia.",
      "customer_portal.collapse_replies": "Ältere schließen",
      "customer_portal.compact_replies": "Ältere Antworten sind eingeklappt. Die letzte Antwort bleibt geöffnet.",
      "customer_portal.confirm_close": "Czy na pewno chcą Państwo zamknąć to zgłoszenie?",
      "customer_portal.confirm_reopen": "Czy chcą Państwo ponownie otworzyć to zgłoszenie?",
      "customer_portal.contracts.hours_minutes": "{{hours}} godz. {{minutes}} min",
      "customer_portal.contracts.hours_only": "{{hours}} godz.",
      "customer_portal.contracts.minutes_only": "{{minutes}} min",
      "customer_portal.create_first_ticket": "Utwórz nowe zgłoszenie",
      "customer_portal.created": "Utworzono",
      "customer_portal.customer_colleague": "Kollegin/Kollege",
      "customer_portal.dashboard.active_count": "{{count}} aktywnych",
      "customer_portal.dashboard.avg_resolution": "Ø czas rozwiązania",
      "customer_portal.dashboard.click_to_view_waiting": "Prosimy kliknąć, aby wyświetlić zgłoszenia",
      "customer_portal.dashboard.create_first_link": "Utwórz pierwsze zgłoszenie →",
      "customer_portal.dashboard.create_new_ticket_link": "Utwórz nowe zgłoszenie",
      "customer_portal.dashboard.history_trend": "Historia zgłoszeń (ostatnie 12 miesięcy)",
      "customer_portal.dashboard.kb": "Pomoc i baza wiedzy",
      "customer_portal.dashboard.kb_desc": "Instrukcje i najczęstsze pytania",
      "customer_portal.dashboard.my_tickets": "Moje zgłoszenia",
      "customer_portal.dashboard.no_tickets": "Brak zgłoszeń",
      "customer_portal.dashboard.no_tickets_status": "Brak zgłoszeń",
      "customer_portal.dashboard.open_active": "Otwarte / aktywne",
      "customer_portal.dashboard.processing_time": "Czas realizacji",
      "customer_portal.dashboard.recent_tickets": "Ostatnie zgłoszenia",
      "customer_portal.dashboard.report_incident": "Zgłoś awarię",
      "customer_portal.dashboard.report_incident_desc": "Zgłoś pilny problem lub awarię",
      "customer_portal.dashboard.reports": "Przegląd i raporty",
      "customer_portal.dashboard.reports_desc": "Filtrowanie i analiza wszystkich zgłoszeń",
      "customer_portal.dashboard.search_kb_link": "Przeszukaj bazę wiedzy",
      "customer_portal.dashboard.service_request": "Wniosek serwisowy",
      "customer_portal.dashboard.service_request_desc": "Wnioski na podstawie konfigurowalnych formularzy",
      "customer_portal.dashboard.show_all_link": "Pokaż wszystkie →",
      "customer_portal.dashboard.status_overview": "Przegląd statusów",
      "customer_portal.dashboard.subtitle": "Przegląd Państwa wsparcia w jednym miejscu",
      "customer_portal.dashboard.total_tickets": "Zgłoszenia łącznie",
      "customer_portal.dashboard.waiting_tickets_warning": "1 zgłoszenie wymaga Państwa odpowiedzi",
      "customer_portal.dashboard.waiting_tickets_warning_plural": "{{count}} zgłoszeń wymaga Państwa odpowiedzi",
      "customer_portal.dashboard.welcome": "Witamy",
      "customer_portal.dashboard.widget_unknown": "Widżet: {{type}}",
      "customer_portal.dashboard.your_reply": "Państwa odpowiedź",
      "customer_portal.details_title": "Szczegóły",
      "customer_portal.editor.bold": "Pogrubienie",
      "customer_portal.editor.code": "Kod",
      "customer_portal.editor.italic": "Kursywa",
      "customer_portal.editor.list": "Lista",
      "customer_portal.expand_replies": "Alle öffnen",
      "customer_portal.files_draft_failed": "Anhänge konnten nicht dauerhaft im Entwurf gespeichert werden.",
      "customer_portal.files_need_reselect": "Anhänge können aus Sicherheitsgründen nicht wiederhergestellt werden. Bitte wählen Sie sie erneut aus.",
      "customer_portal.filters.active": "Aktywne",
      "customer_portal.filters.all": "Wszystkie",
      "customer_portal.filters.closed": "Zamknięte",
      "customer_portal.filters.external": "Extern",
      "customer_portal.filters.waiting_customer": "Państwa odpowiedź",
      "customer_portal.history_title": "Historia",
      "customer_portal.impersonation_banner": "Przeglądają Państwo ten portal w trybie personifikacji (podgląd dla agentów) jako klient:",
      "customer_portal.incident_badge": "Awaria",
      "customer_portal.kb.title": "Baza wiedzy",
      "customer_portal.load_more_attachments": "Weitere Anhänge laden",
      "customer_portal.login.betreut_von": "OBSŁUGIWANE PRZEZ NALVRA",
      "customer_portal.login.claim": "Twoja bezpośrednia linia do wsparcia — zgłoś, śledź status, znajdź odpowiedzi.",
      "customer_portal.login.copyright_text": "© {{year}} {{appName}}. Wszelkie prawa zastrzeżone.",
      "customer_portal.login.default_subtitle": "Zaloguj się, aby zarządzać swoimi zgłoszeniami.",
      "customer_portal.login.default_welcome": "Witamy w {{appName}}",
      "customer_portal.login.email": "E-mail",
      "customer_portal.login.email_placeholder": "imie@firma.pl",
      "customer_portal.login.eyebrow": "PORTAL KLIENTA · DOSTĘPNY 24/7",
      "customer_portal.login.forgot_password": "Nie pamiętasz hasła?",
      "customer_portal.login.kein_zugang": "Nie masz jeszcze dostępu? Skontaktuj się ze swoim opiekunem w dziale wsparcia.",
      "customer_portal.login.kundenanmeldung": "Logowanie klienta",
      "customer_portal.login.kundenportal": "PORTAL KLIENTA",
      "customer_portal.login.microsoft_signin": "Zaloguj się przez Microsoft",
      "customer_portal.login.mit_hinterlegter_adresse": "Zaloguj się zapisanym adresem e-mail.",
      "customer_portal.login.or_password": "lub hasłem",
      "customer_portal.login.password": "Hasło",
      "customer_portal.login.password_placeholder": "Twoje hasło",
      "customer_portal.login.reset_back": "Powrót do logowania",
      "customer_portal.login.reset_button": "Wyślij link",
      "customer_portal.login.reset_instruction": "Podaj swój adres e-mail. Wyślemy link do zresetowania hasła.",
      "customer_portal.login.reset_sent_message": "Jeśli konto z tym adresem istnieje, wysłaliśmy link do zresetowania hasła.",
      "customer_portal.login.reset_sent_title": "E-mail wysłany",
      "customer_portal.login.reset_title": "Resetowanie hasła",
      "customer_portal.login.sicherheitszeile": "Połączenie szyfrowane · Dostęp tylko dla zarejestrowanych kontaktów",
      "customer_portal.login.signin_button": "Zaloguj się",
      "customer_portal.login.signing_in": "Logowanie …",
      "customer_portal.login.sso_available": "Dostępne logowanie jednokrotne",
      "customer_portal.login.sso_failed": "Logowanie SSO nie powiodło się",
      "customer_portal.login.sso_logging_in": "Logowanie …",
      "customer_portal.menu.dashboard": "Pulpit",
      "customer_portal.menu.edit_profile": "Edytuj profil",
      "customer_portal.menu.logout": "Wyloguj się",
      "customer_portal.menu.profile": "Mein Profil",
      "customer_portal.message_placeholder": "Państwa wiadomość...",
      "customer_portal.nav.contracts": "Umowy",
      "customer_portal.nav.create_request": "Anfrage erstellen",
      "customer_portal.nav.dashboard": "Pulpit",
      "customer_portal.nav.documents": "Dokumenty",
      "customer_portal.nav.downloads": "Downloads",
      "customer_portal.nav.help": "Hilfe & Kurztour",
      "customer_portal.nav.kb": "Baza wiedzy",
      "customer_portal.nav.my_tickets": "Moje zgłoszenia",
      "customer_portal.nav.profile": "Profil",
      "customer_portal.nav.report_incident": "Zgłoś awarię",
      "customer_portal.nav.service_request": "Wniosek serwisowy",
      "customer_portal.nav.support": "Support erhalten",
      "customer_portal.navigation": "Portal-Navigation",
      "customer_portal.new_ticket": "Nowe zgłoszenie",
      "customer_portal.new_ticket.add_attachment": "Dodaj",
      "customer_portal.new_ticket.ai_improve_btn": "Ulepsz opis",
      "customer_portal.new_ticket.ai_improving": "Trwa ulepszanie...",
      "customer_portal.new_ticket.ai_preanswer_title": "Propozycja AI dotycząca Państwa problemu",
      "customer_portal.new_ticket.ai_suggestion_title": "Propozycja ulepszenia od AI",
      "customer_portal.new_ticket.allowed_types_tip": "Tylko skonfigurowane typy plików (patrz wskazówka administratora)",
      "customer_portal.new_ticket.apply": "Zastosuj",
      "customer_portal.new_ticket.attach_file": "Dołącz plik",
      "customer_portal.new_ticket.attachment_plural": "Załączniki",
      "customer_portal.new_ticket.attachment_singular": "Załącznik",
      "customer_portal.new_ticket.back_step_1": "Zurück zu Schritt 1",
      "customer_portal.new_ticket.back_step_2": "Zurück zu Schritt 2",
      "customer_portal.new_ticket.categories_error": "Kategorien konnten nicht geladen werden.",
      "customer_portal.new_ticket.categories_loading": "Kategorien werden geladen …",
      "customer_portal.new_ticket.category_assignment": "Kategorie zuordnen",
      "customer_portal.new_ticket.category_by_support": "Zuordnung durch den Support",
      "customer_portal.new_ticket.category_hint": "Sie sind unsicher? Lassen Sie die Kategorie offen. Der Support übernimmt die Zuordnung.",
      "customer_portal.new_ticket.category_question": "Welche Kategorie passt zu Ihrem Anliegen?",
      "customer_portal.new_ticket.char_count": "{{count}} znaków",
      "customer_portal.new_ticket.continue_step_2": "Weiter zu Schritt 2",
      "customer_portal.new_ticket.continue_step_3": "Weiter zu Schritt 3",
      "customer_portal.new_ticket.create": "Utwórz",
      "customer_portal.new_ticket.create_anyway": "Mimo to utwórz zgłoszenie",
      "customer_portal.new_ticket.create_ticket": "Utwórz zgłoszenie",
      "customer_portal.new_ticket.creating": "Trwa tworzenie...",
      "customer_portal.new_ticket.days_count": "{{count}} dni roboczych",
      "customer_portal.new_ticket.description_label": "Opis *",
      "customer_portal.new_ticket.description_placeholder": "Prosimy szczegółowo opisać problem...\\n\\n• Co nie działa?\\n• Od kiedy występuje problem?\\n• Czy pojawia się komunikat o błędzie?\\n• Którego systemu / urządzenia dotyczy?\\n\\nWskazówka: zrzuty ekranu można wkleić skrótem Ctrl+V",
      "customer_portal.new_ticket.description_required": "Bitte beschreiben Sie Ihr Problem.",
      "customer_portal.new_ticket.discard": "Odrzuć",
      "customer_portal.new_ticket.drag_more": "Przeciągnij tutaj kolejne pliki · Pozostało: {{count}}",
      "customer_portal.new_ticket.drag_or_click": "Przeciągnij pliki tutaj lub kliknij",
      "customer_portal.new_ticket.drop_here": "Upuść pliki tutaj...",
      "customer_portal.new_ticket.error_create_failed": "Błąd podczas tworzenia zgłoszenia.",
      "customer_portal.new_ticket.expected_first_response": "Pierwsza odpowiedź",
      "customer_portal.new_ticket.go_to_step": "Schritt {{step}}: {{label}}",
      "customer_portal.new_ticket.hide": "Ukryj",
      "customer_portal.new_ticket.hours_count": "{{count}} godzin",
      "customer_portal.new_ticket.insert_template": "Wstaw szablon",
      "customer_portal.new_ticket.kb_article_error": "Dieser Artikel konnte nicht geladen werden. Sie können es erneut versuchen oder mit Ihrem Ticket fortfahren.",
      "customer_portal.new_ticket.kb_close_article": "Artikel schließen",
      "customer_portal.new_ticket.kb_did_help": "Hat dieser Artikel Ihr Problem gelöst?",
      "customer_portal.new_ticket.kb_draft_retained": "Ihr Ticketentwurf bleibt erhalten. Sie entscheiden, ob Sie ihn weiter bearbeiten.",
      "customer_portal.new_ticket.kb_feedback_error": "Ihre Rückmeldung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut. Ihr Entwurf bleibt erhalten.",
      "customer_portal.new_ticket.kb_helped": "Artikel hat mir geholfen",
      "customer_portal.new_ticket.kb_loading_article": "Artikel wird geladen",
      "customer_portal.new_ticket.kb_resolved_message": "Ihre Rückmeldung wurde gespeichert. Es wurde kein Ticket erstellt.",
      "customer_portal.new_ticket.kb_resolved_title": "Schön, dass die Anleitung geholfen hat",
      "customer_portal.new_ticket.kb_resume_draft": "Ticketentwurf weiter bearbeiten",
      "customer_portal.new_ticket.kb_retry": "Erneut laden",
      "customer_portal.new_ticket.kb_saved_draft": "Ihr Entwurf bleibt für Sie gespeichert, falls Sie später doch Unterstützung benötigen.",
      "customer_portal.new_ticket.kb_searching": "Lösungen werden gesucht",
      "customer_portal.new_ticket.kb_suggestions_hint": "Passende Anleitungen aus der Wissensbasis. Lesen Sie einen Artikel, bevor Sie Ihr Ticket erstellen.",
      "customer_portal.new_ticket.kb_suggestions_title": "Vielleicht ist die Lösung schon da",
      "customer_portal.new_ticket.kb_to_dashboard": "Zurück zum Dashboard",
      "customer_portal.new_ticket.max_files": "Maks. {{count}} plików",
      "customer_portal.new_ticket.max_size": "Maks. {{count}} MB / plik",
      "customer_portal.new_ticket.minutes_count": "{{count}} minut",
      "customer_portal.new_ticket.no_category": "Prosimy wybrać kategorię...",
      "customer_portal.new_ticket.optional": "Optional",
      "customer_portal.new_ticket.preanswer_might_resolve": "Czy to pomogło? W takim razie utworzenie zgłoszenia może nie być konieczne.",
      "customer_portal.new_ticket.presubmit_kb_desc": "Brak pasującego artykułu? Nic nie szkodzi — prosimy utworzyć zgłoszenie.",
      "customer_portal.new_ticket.presubmit_kb_title": "To może już rozwiązać Państwa problem",
      "customer_portal.new_ticket.prio_desc_critical": "Natychmiast",
      "customer_portal.new_ticket.prio_desc_high": "Pilne",
      "customer_portal.new_ticket.prio_desc_low": "Może poczekać",
      "customer_portal.new_ticket.prio_desc_medium": "Normalne",
      "customer_portal.new_ticket.progress": "Fortschritt der Ticketerstellung",
      "customer_portal.new_ticket.relevant_articles": "Pasujące artykuły:",
      "customer_portal.new_ticket.reply_by_email_tip": "Na to zgłoszenie mogą Państwo odpowiedzieć również e-mailem",
      "customer_portal.new_ticket.resolution": "Rozwiązanie",
      "customer_portal.new_ticket.response_time_typical": "Odpowiedź zwykle w ciągu kilku godzin",
      "customer_portal.new_ticket.retry_categories": "Erneut laden",
      "customer_portal.new_ticket.screenshot_tip": "Zrzuty ekranu wklej skrótem Ctrl+V",
      "customer_portal.new_ticket.similar_tickets": "Podobne zgłoszenia",
      "customer_portal.new_ticket.step_attachments": "Anhänge",
      "customer_portal.new_ticket.step_attachments_detail": "Kategorie, Anhänge und Absenden",
      "customer_portal.new_ticket.step_count": "Schritt {{step}} von 3",
      "customer_portal.new_ticket.step_details": "Details",
      "customer_portal.new_ticket.step_details_detail": "Beschreibung und Priorität",
      "customer_portal.new_ticket.step_subject": "Betreff",
      "customer_portal.new_ticket.step_subject_detail": "Person, Betreff und Wissensbasis",
      "customer_portal.new_ticket.subject_desc_required": "Temat i opis są wymagane.",
      "customer_portal.new_ticket.subject_label": "Temat *",
      "customer_portal.new_ticket.subject_placeholder": "Krótki opis problemu lub Państwa zapytania",
      "customer_portal.new_ticket.subject_required": "Bitte geben Sie einen Betreff ein.",
      "customer_portal.new_ticket.subtitle": "Awaria techniczna lub pilny problem — zostanie przekazany do wsparcia jako zgłoszenie.",
      "customer_portal.new_ticket.subtitle_2": "Prosimy opisać sprawę, a my się nią zajmiemy.",
      "customer_portal.new_ticket.success_desc": "Dziękujemy. Skontaktujemy się z Państwem najszybciej, jak to możliwe.",
      "customer_portal.new_ticket.success_title": "Zgłoszenie utworzone!",
      "customer_portal.new_ticket.template_btn": "Przykład",
      "customer_portal.new_ticket.view_ticket": "Zobacz zgłoszenie",
      "customer_portal.no_attachments": "Keine Anhänge vorhanden.",
      "customer_portal.no_tickets_create_desc": "Prosimy utworzyć pierwsze zgłoszenie.",
      "customer_portal.no_tickets_filter_desc": "Prosimy spróbować innego filtra.",
      "customer_portal.no_tickets_search_desc": "Prosimy spróbować innego hasła wyszukiwania.",
      "customer_portal.no_tickets_title": "Nie znaleziono zgłoszeń",
      "customer_portal.pagination_of": "von",
      "customer_portal.password.btn": "Zmień hasło",
      "customer_portal.password.cancel": "Anuluj",
      "customer_portal.password.changing": "Trwa zmiana...",
      "customer_portal.password.confirm": "Potwierdź nowe hasło",
      "customer_portal.password.current": "Aktualne hasło",
      "customer_portal.password.error_change": "Błąd podczas zmiany.",
      "customer_portal.password.error_min_length": "Co najmniej 8 znaków.",
      "customer_portal.password.error_mismatch": "Hasła nie są zgodne.",
      "customer_portal.password.error_same": "Nowe hasło musi się różnić od dotychczasowego.",
      "customer_portal.password.logout": "Wyloguj się",
      "customer_portal.password.mismatch_warning": "Hasła nie są zgodne",
      "customer_portal.password.must_change_desc": "Prosimy zmienić hasło przed kontynuowaniem.",
      "customer_portal.password.new": "Nowe hasło (min. 8 znaków)",
      "customer_portal.password.redirecting": "Trwa przekierowanie...",
      "customer_portal.password.success": "Hasło zostało zmienione!",
      "customer_portal.password.title": "Zmiana hasła",
      "customer_portal.priority_help.high": "Mehrere Mitarbeitende oder eine wichtige Funktion sind stark beeinträchtigt. Es gibt keine praktikable Ausweichlösung, der übrige Betrieb läuft jedoch weiter.",
      "customer_portal.priority_help.low": "Kleine Einschränkung oder allgemeine Frage. Sie können normal weiterarbeiten, zum Beispiel bei einem Darstellungsfehler oder einem Änderungswunsch.",
      "customer_portal.priority_help.medium": "Die Arbeit ist eingeschränkt, aber eine Ausweichlösung ist möglich. Beispiel: Ein Drucker fällt aus, ein anderer kann genutzt werden.",
      "customer_portal.priority_help.urgent": "Der Betrieb oder ein geschäftskritischer Prozess steht still. Es gibt keine Ausweichlösung, zum Beispiel bei einem vollständigen Ausfall des zentralen Systems. Bitte nicht nur wegen eines persönlichen Wunschtermins wählen.",
      "customer_portal.processing_time": "Czas realizacji",
      "customer_portal.profile.cancel": "Anuluj",
      "customer_portal.profile.change_password_btn": "Zmień hasło",
      "customer_portal.profile.change_photo": "Profilbild ändern",
      "customer_portal.profile.closed": "Zamknięte",
      "customer_portal.profile.company": "Firma",
      "customer_portal.profile.company_account": "Firma i konto",
      "customer_portal.profile.days_count": "{{count}} dni roboczych",
      "customer_portal.profile.department": "Dział",
      "customer_portal.profile.edit": "Edytuj",
      "customer_portal.profile.email": "E-mail",
      "customer_portal.profile.error_save": "Błąd podczas zapisywania",
      "customer_portal.profile.error_upload": "Błąd podczas przesyłania",
      "customer_portal.profile.first_name": "Imię",
      "customer_portal.profile.first_response": "Pierwsza odpowiedź",
      "customer_portal.profile.hours_count": "{{count}} godz.",
      "customer_portal.profile.last_name": "Nazwisko",
      "customer_portal.profile.loading": "Trwa ładowanie profilu...",
      "customer_portal.profile.location": "Lokalizacja",
      "customer_portal.profile.member_since": "Członek od",
      "customer_portal.profile.minutes_count": "{{count}} min",
      "customer_portal.profile.mobile": "Telefon komórkowy",
      "customer_portal.profile.mobile_placeholder": "np. +48 601 234 567",
      "customer_portal.profile.open": "Otwarte",
      "customer_portal.profile.personal_data": "Dane osobowe",
      "customer_portal.profile.phone": "Telefon",
      "customer_portal.profile.phone_placeholder": "np. +48 22 123 45 67",
      "customer_portal.profile.position": "Stanowisko",
      "customer_portal.profile.resolution": "Rozwiązanie",
      "customer_portal.profile.save": "Zapisz",
      "customer_portal.profile.security": "Bezpieczeństwo",
      "customer_portal.profile.security_desc": "Dla większego bezpieczeństwa prosimy regularnie zmieniać hasło.",
      "customer_portal.profile.service_level": "Poziom usługi",
      "customer_portal.profile.show_dashboard": "Pokaż pulpit",
      "customer_portal.profile.sla_tier": "Poziom SLA",
      "customer_portal.profile.sso_active": "Uwierzytelnianie SSO aktywne",
      "customer_portal.profile.success_photo": "Zdjęcie profilowe zaktualizowane",
      "customer_portal.profile.success_update": "Profil został zaktualizowany",
      "customer_portal.profile.ticket_overview": "Przegląd zgłoszeń",
      "customer_portal.profile.total": "Łącznie",
      "customer_portal.reopen": "Otwórz ponownie",
      "customer_portal.reopen_failed": "Nie udało się ponownie otworzyć zgłoszenia.",
      "customer_portal.reopen_ticket": "Otwórz zgłoszenie ponownie",
      "customer_portal.replies_load_failed": "Ältere Antworten konnten nicht geladen werden.",
      "customer_portal.reply_btn": "Odpowiedz",
      "customer_portal.reply_failed": "Nie udało się wysłać Państwa odpowiedzi. Prosimy spróbować ponownie.",
      "customer_portal.reply_plural": "Odpowiedzi",
      "customer_portal.reply_singular": "Odpowiedź",
      "customer_portal.request_badge": "Wniosek",
      "customer_portal.requests.attachments": "Załączniki",
      "customer_portal.requests.category": "Kategoria",
      "customer_portal.requests.description": "Opis",
      "customer_portal.requests.priority": "Priorytet",
      "customer_portal.search_label": "Tickets suchen",
      "customer_portal.search_placeholder": "Szukaj numeru zgłoszenia lub tematu...",
      "customer_portal.sending": "Trwa wysyłanie...",
      "customer_portal.service_level": "Poziom usługi",
      "customer_portal.show_older_replies": "Pokaż starsze odpowiedzi ({{count}})...",
      "customer_portal.sla.met": "Spełnione",
      "customer_portal.sla.on_track": "Zgodnie z planem",
      "customer_portal.sla.overdue": "Przekroczone",
      "customer_portal.sla.warning": "Wkrótce upływa",
      "customer_portal.source": "Źródło",
      "customer_portal.source_portal": "Portal",
      "customer_portal.stop_impersonation": "Zakończ personifikację",
      "customer_portal.support_team": "Zespół wsparcia",
      "customer_portal.ticket_closed_desc": "To zgłoszenie jest zamknięte.",
      "customer_portal.ticket_load_failed": "Ticket konnte nicht geladen werden",
      "customer_portal.ticket_load_failed_desc": "Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "customer_portal.ticket_not_found": "Nie znaleziono zgłoszenia",
      "customer_portal.ticket_owner": "Ihr zuständiger Support-Agent",
      "customer_portal.ticket_plural": "Zgłoszenia",
      "customer_portal.ticket_singular": "Zgłoszenie",
      "customer_portal.tickets_load_failed": "Tickets konnten nicht geladen werden",
      "customer_portal.tickets_load_failed_desc": "Ihre Daten wurden nicht verändert.",
      "customer_portal.times_title": "Czasy",
      "customer_portal.unassigned_owner": "Noch nicht zugewiesen",
      "customer_portal.unsaved_warning": "Ihr nicht gesendeter Entwurf geht beim Verlassen möglicherweise verloren.",
      "customer_portal.updated": "Zaktualizowano",
      "customer_portal.via_email": "przez e-mail",
      "customer_portal.write_reply": "Napisz odpowiedź",
      "customer_portal.you": "Państwo",
      "customer_tickets_summary": "{{open}} otwarte / {{total}} suma",
      "customers": "Klienci",
      "customize": "Dostosuj",
      "dark_mode": "Ciemny motyw",
      "dashboard": "Panel główny",
      "dashboard_sub": "Oto Twoje operacyjne wskaźniki KPI, stany SLA i statystyki zgłoszeń.",
      "days_ago": "{{count}} dni temu",
      "delete": "Usuń",
      "density": "Gęstość:",
      "density_comfort_label": "Komfort",
      "density_comfortable": "Normalny",
      "density_compact": "Kompaktowy",
      "density_spacious": "Przestronny",
      "density_standard_label": "Standard",
      "device_actions": "Geräte & Lizenzen",
      "device_actions_hint": "Fernwartung, Remote-Terminal, Behebung und Lizenzen der verknüpften Geräte",
      "document.all": "Wszystkie",
      "document.category.certificate": "Certyfikat",
      "document.category.contract": "Umowa",
      "document.category.correspondence": "Korespondencja",
      "document.category.general": "Ogólne",
      "document.category.invoice": "Faktura",
      "document.category.manual": "Instrukcja",
      "document.category.report": "Raport",
      "document.none_found": "Nie znaleziono dokumentów",
      "document.none_found_desc": "Prosimy spróbować innego hasła wyszukiwania",
      "document.none_shared": "Nie udostępniono Państwu jeszcze żadnych dokumentów",
      "document.none_shared_desc": "Państwa opiekun może udostępniać tutaj dokumenty",
      "document.plural": "Dokumenty",
      "document.search_placeholder": "Przeszukaj dokumenty...",
      "document.singular": "Dokument",
      "document.subtitle": "Udostępnione Państwu dokumenty, umowy i materiały",
      "document.total_suffix": "łącznie",
      "domains": "Domeny",
      "draft_present": "Wersja robocza",
      "draft_saved": "Szkic zapisany",
      "drag_to_move": "{{label}} (przeciągnij, aby przenieść)",
      "drag_to_sort": "Przeciągnij, aby posortować, kliknij, aby ukryć/pokazać",
      "duration": "Czas trwania (min)",
      "duration_minutes": "{{count}} minut",
      "edit": "Edytuj",
      "edit_customer": "Edytuj klienta",
      "edit_master_data_admin": "Edytuj dane podstawowe w administracji",
      "edit_widgets_title": "Pokazuj i sortuj widgety",
      "email": "E-mail",
      "email_channel": "Kanał e-mail",
      "employee_form.account_erstellt": "Konto utworzone:",
      "employee_form.bitte_zuerst_kunde_auswaehlen": "Najpierw wybierz klienta",
      "employee_form.dieser_mitarbeiter_hat_noch_keinen_zugang_zu": "Ten pracownik nie ma jeszcze dostępu do portalu klienta. Utwórz konto z hasłem.",
      "employee_form.domain_waehlen": "Wybierz domenę",
      "employee_form.domains_werden_geladen": "Wczytywanie domen...",
      "employee_form.e_mail_server_nicht_konfiguriert": "Serwer e-mail nie jest skonfigurowany",
      "employee_form.initialpasswort_vergeben": "Nadaj hasło początkowe...",
      "employee_form.interne_notizen_zum_mitarbeiter": "Notatki wewnętrzne dotyczące pracownika...",
      "employee_form.kein_portal_zugang_vorhanden": "Brak dostępu do portalu",
      "employee_form.keine_domains_fuer_diesen_kunden_hinterlegt": "Dla tego klienta nie zapisano żadnych domen.",
      "employee_form.kunde_auswaehlen": "Wybierz klienta",
      "employee_form.lade_account_informationen": "Wczytywanie informacji o koncie...",
      "employee_form.leer_lassen_wenn_kein_portal_zugang_benoetig": "Pozostaw puste, jeśli dostęp do portalu nie jest potrzebny (np. przy SSO).",
      "employee_form.letzter_login": "Ostatnie logowanie:",
      "employee_form.neues_passwort": "Nowe hasło...",
      "employee_form.neues_passwort_min_8_zeichen": "Nowe hasło (min. 8 znaków)",
      "employee_form.passwort_fuer_neuen_account_min_8_zeichen": "Hasło do nowego konta (min. 8 znaków)",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge": "Wymuś zmianę hasła przy pierwszym logowaniu",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge_2": "Wymuś zmianę hasła przy pierwszym logowaniu",
      "employee_form.passwortaenderung_beim_naechsten_login_erzwi": "Wymuś zmianę hasła przy następnym logowaniu",
      "employee_form.profilbild_kann_nach_dem_erstellen_hochgelad": "Zdjęcie profilowe można przesłać po utworzeniu.",
      "employee_form.pw_aenderung_ausstehend": "Zmiana hasła oczekuje",
      "employee_form.reset_link_24h_gueltig": "Link resetujący (ważny 24 h):",
      "employee_form.tab_access": "Portal klienta",
      "employee_form.tab_it": "IT i stanowisko pracy",
      "employee_form.tab_notes": "Notatki",
      "employee_form.tab_personal": "Dane osobowe",
      "employee_form.tab_work": "Praca i kontakt",
      "employee_form.weitere_it_informationen_wie_betriebssystem": "Dodatkowe informacje IT, takie jak system operacyjny czy zainstalowane oprogramowanie, można zapisać w notatkach.",
      "employee_form.z_b_koeln_buero_3_og": "np. Kolonia, biuro 3. piętro",
      "employees": "Pracownicy",
      "employees_ca": "Pracownicy (ok.)",
      "end_edit": "Zakończ edycję",
      "enter_title_error": "Proszę wpisać tytuł.",
      "escalate": "Eskaluj",
      "escalated": "Eskalowane",
      "escalated_badge": "Eskalowane",
      "expand_sidebar": "Rozwiń panel boczny",
      "expired": "Wygasł",
      "expires_at": "Wygasa dnia",
      "expiring_soon": "Wkrótce wygasa",
      "export_csv": "Plik CSV",
      "export_pdf": "Dokument PDF",
      "export_png": "Wykres PNG",
      "export_xlsx": "Excel (XLSX)",
      "filter_active": "Aktywny filtr",
      "filter_all_az": "Wszystkie A–Z",
      "filter_list_placeholder": "Filtruj listę...",
      "filter_open_first": "Otwarte najpierw",
      "filter_open_only": "Tylko z otwartymi",
      "filter_with_sla": "Z poziomem SLA",
      "first_post_attachments": "Załączniki do pierwszego posta",
      "first_response": "Pierwsza odpowiedź",
      "follow_ups": "Oczekiwanie na klienta",
      "generating": "Generowanie...",
      "greeting_day": "Dzień dobry, {{name}} 👋",
      "held_review": "Wymaga sprawdzenia",
      "high_priority": "Wysoki priorytet",
      "hours": "Godziny",
      "hours_ago": "{{count}} godz. temu",
      "inactive": "Nieaktywny",
      "included_hours": "Godz. w cenie",
      "industry": "Branża",
      "internal": "Wewnętrzne",
      "internal_chat": "Czat wewnętrzny",
      "internal_note": "Notatka wewnętrzna",
      "internal_notes": "Notatki wewnętrzne",
      "internal_notes_placeholder": "Wewnętrzne notatki o kliencie...",
      "invalid_datetime_error": "Nieprawidłowa data lub godzina.",
      "just_now": "Przed chwilą",
      "kb.all_articles": "Wszystkie artykuły",
      "kb.author": "Autor",
      "kb.back_to_overview": "Powrót do przeglądu",
      "kb.browse_more": "← Przeglądaj więcej artykułów",
      "kb.no_articles": "Brak dostępnych artykułów bazy wiedzy",
      "kb.no_articles_desc": "Wkrótce pojawią się tutaj pomocne artykuły",
      "kb.pinned": "Przypięte",
      "kb.read_time": "{{count}} min czytania",
      "kb.search_placeholder": "Czego Państwo szukają? np. VPN, hasło, e-mail...",
      "kb.subtitle": "Instrukcje, wskazówki i pomoc do Państwa pytań",
      "kb.try_different_search": "Prosimy spróbować innego hasła wyszukiwania",
      "kb.updated_at": "Zaktualizowano {{date}}",
      "kb.views_count": "{{count}} wyświetleń",
      "keyboard_shortcuts": "Skróty klawiszowe",
      "knowledge": "Baza wiedzy",
      "knowledge_base": "Baza wiedzy",
      "kpi_held": "Nadawca nieokreślony",
      "kpi_important": "ważne",
      "kpi_open": "otwarte",
      "kpi_sla_breached": "Naruszenie SLA",
      "kunde_loeschen.artikel": "Wissensartikel",
      "kunde_loeschen.bestaetigung_label": "Zur Bestätigung den Firmennamen eingeben",
      "kunde_loeschen.connectoren": "Connectoren",
      "kunde_loeschen.dokumente": "Dokumente",
      "kunde_loeschen.einleitung": "Dieser Kunde hat keine Tickets und keine Rechnungen. Er kann vollständig entfernt werden — mitsamt seinem Mandantenbereich in der Datenbank. Das lässt sich nicht rückgängig machen.",
      "kunde_loeschen.endgueltig_loeschen": "Endgültig löschen",
      "kunde_loeschen.fehlgeschlagen": "Das Löschen ist fehlgeschlagen.",
      "kunde_loeschen.geraete": "Geräte im Inventar",
      "kunde_loeschen.lizenzen": "Softwarelizenzen",
      "kunde_loeschen.mitarbeiter": "Mitarbeiter",
      "kunde_loeschen.netzgeraete": "Gefundene Netzwerkgeräte",
      "kunde_loeschen.nichts_dran": "An diesem Kunden hängen keine weiteren Daten.",
      "kunde_loeschen.portalbenutzer": "Portalzugänge",
      "kunde_loeschen.pruefung_fehlgeschlagen": "Die Prüfung ist fehlgeschlagen.",
      "kunde_loeschen.titel": "Kunde endgültig löschen",
      "kunde_loeschen.tokens": "API-Token",
      "kunde_loeschen.vertraege": "Verträge",
      "kunde_loeschen.wird_geprueft": "Wird geprüft …",
      "kunde_loeschen.wird_mitgeloescht": "Wird mitgelöscht",
      "kunde_loeschen.zeiten": "Zeiteinträge",
      "language": "Język",
      "license.cluster_audit": "Audyt",
      "license.cluster_balance": "Bilans",
      "license.cluster_calc": "Kalkulator",
      "license.cluster_contracts": "Umowy i licencje",
      "license.cluster_optimize": "Optymalizacja",
      "license.tab_ad_coupling": "Sprzężenie CAL-AD",
      "license.tab_cal_calc": "Kalkulator CAL",
      "license.tab_catalog": "Katalog oprogramowania",
      "license.tab_contracts": "Umowy",
      "license.tab_dashboard": "Bilans licencji i Trendy",
      "license.tab_licenses": "Zarządzanie licencjami",
      "license.tab_more_views": "Więcej widoków",
      "license.tab_reclaims": "Optymalizacja i Zwroty",
      "license.tab_remediation": "Naprawa",
      "license.tab_sealed": "Archiwum audytów",
      "license.tab_sql_calc": "Kalkulator licencji SQL",
      "license.tab_steering": "Sterowanie",
      "license.tab_suite_config": "Konfigurator pakietów",
      "license_compliance.actions": "Akcje",
      "license_compliance.assign_license_metric": "Przypisz metrykę licencji",
      "license_compliance.confirm_delete_assignment": "Czy na pewno usunąć przypisanie?",
      "license_compliance.confirm_delete_contract": "Czy na pewno usunąć umowę? Powiązane licencje zostaną zachowane, ale zostaną odłączone od umowy.",
      "license_compliance.contract_expiry_alert": "Wygaśnięcie umowy",
      "license_compliance.deficit_forecast_desc": "Na podstawie skanów na żywo w rocznicę umowy powstaną opłaty wyrównawcze za produkty z niedoborem licencji.",
      "license_compliance.edit_contract": "Edytuj umowę",
      "license_compliance.edit_license": "Edytuj licencję",
      "license_compliance.expired_contracts_title": "Wykryto wygasłe umowy na oprogramowanie!",
      "license_compliance.expired_contracts_warning_desc": "Licencje przypisane do tych umów są pomijane w obliczeniach zgodności.",
      "license_compliance.forecasted_payment": "Prognozowana dopłata",
      "license_compliance.license_deficit_alert": "Niedobór licencji",
      "license_compliance.mark_license_required_btn": "Oznacz jako wymagające licencji",
      "license_compliance.new_contract": "Utwórz nową umowę",
      "license_compliance.new_license": "Utwórz nową licencję",
      "license_compliance.no_deficit_desc": "Gratulacje! Państwa przypisania Microsoft Core/CAL pokrywają wszystkie wyniki skanowania.",
      "license_compliance.not_catalogued": "Nieskatalogowane",
      "license_compliance.reconciliation_desc": "Uruchamia ręczny przebieg uzgadniania dla tego najemcy. Na żywo przelicza VM-stacking, stany wykrywania WMI, okresy Software Assurance oraz ważność umów.",
      "license_compliance.reconciliation_running": "Trwa uzgadnianie...",
      "license_compliance.run_reconciliation": "Uruchom uzgadnianie",
      "license_compliance.sam_warnings_title": "Ostrzeżenia SAM i zgodność",
      "license_compliance.save_contract": "Zapisz umowę",
      "license_compliance.save_license": "Zapisz licencję",
      "license_compliance.seal_audit": "Zapieczętuj audyt",
      "license_compliance.seal_audit_btn": "Zapieczętuj z mocą prawną",
      "license_compliance.sealing": "Pieczętowanie...",
      "license_compliance.toast.add_suite_component_error": "Błąd podczas przypisywania komponentu pakietu",
      "license_compliance.toast.assignment_completed": "Przypisanie licencji zostało wykonane.",
      "license_compliance.toast.assignment_error": "Błąd podczas wykonywania przypisania",
      "license_compliance.toast.bulk_classify_error": "Błąd podczas klasyfikacji zbiorczej",
      "license_compliance.toast.bulk_classify_success": "Sklasyfikowano wpisy oprogramowania: {{count}}.",
      "license_compliance.toast.calc_audit_error": "Błąd podczas obliczania audytu licencji",
      "license_compliance.toast.contract_created": "Umowa została utworzona.",
      "license_compliance.toast.contract_deleted": "Umowa usunięta.",
      "license_compliance.toast.contract_updated": "Umowa została zaktualizowana.",
      "license_compliance.toast.create_purchase_req_error": "Błąd podczas tworzenia wniosku zakupowego",
      "license_compliance.toast.delete_contract_error": "Błąd podczas usuwania umowy",
      "license_compliance.toast.delete_license_error": "Błąd podczas usuwania licencji",
      "license_compliance.toast.delete_suite_component_error": "Błąd podczas usuwania przypisania",
      "license_compliance.toast.license_created": "Licencja została utworzona.",
      "license_compliance.toast.license_deleted": "Licencja usunięta.",
      "license_compliance.toast.license_updated": "Licencja została zaktualizowana.",
      "license_compliance.toast.load_customers_error": "Błąd podczas ładowania listy klientów",
      "license_compliance.toast.purchase_req_created": "Wniosek zakupowy na {{units}}x {{model}} (True-Up: {{cost}}) utworzono jako zgłoszenie {{ticket}}.",
      "license_compliance.toast.reconcile_completed": "Uzgadnianie zakończone pomyślnie. Wskaźniki zgodności zostały przeliczone na żywo.",
      "license_compliance.toast.reconcile_error": "Błąd podczas uzgadniania",
      "license_compliance.toast.sam_settings_saved": "Ustawienia SAM zostały zapisane.",
      "license_compliance.toast.save_contract_error": "Błąd podczas zapisywania umowy",
      "license_compliance.toast.save_license_error": "Błąd podczas zapisywania licencji",
      "license_compliance.toast.save_sam_settings_error": "Błąd podczas zapisywania ustawień SAM",
      "license_compliance.toast.seal_audit_error": "Błąd podczas pieczętowania audytu licencji",
      "license_compliance.toast.seal_audit_success": "Audyt licencji został zapieczętowany.",
      "license_compliance.toast.suite_component_added": "Komponent został przypisany do pakietu.",
      "license_compliance.toast.suite_component_deleted": "Przypisanie usunięte.",
      "license_compliance.toast.uninstall_error": "Błąd podczas uruchamiania deinstalacji",
      "license_compliance.toast.uninstall_triggered": "Polecenia deinstalacji dodano do kolejki.",
      "license_compliance.update_contract": "Aktualizuj umowę",
      "license_compliance.update_license": "Aktualizuj licencję",
      "licenses": "Licencje",
      "light_mode": "Jasny motyw",
      "link_asset_btn": "+ Połącz zasób",
      "live_activity": "Aktywność na żywo",
      "loading": "Wird geladen…",
      "loading_ellipsis": "Ładowanie...",
      "location_on_map": "Lokalizacja na mapie",
      "login.abbrechen": "Anuluj",
      "login.administratoradresse_konnte_nicht_geaendert_werden": "Die Administratoradresse konnte nicht geändert werden.",
      "login.adresse_aendern": "Adresse ändern",
      "login.adresse_wird_geaendert": "Adresse wird geändert…",
      "login.aendern": "Zmień",
      "login.aktivierung": "Aktywacja…",
      "login.aktivierung_fehlgeschlagen_code_pruefen": "Aktywacja nie powiodła się. Sprawdź kod.",
      "login.alle_rechte_vorbehalten": "· Wszelkie prawa zastrzeżone.",
      "login.anmelden": "Zaloguj się",
      "login.anmelden_laeuft": "Logowanie…",
      "login.anmeldung": "Logowanie…",
      "login.bestaetigen": "Potwierdź",
      "login.bitte_geben_sie_eine_gueltige_e_mail_adresse": "Podaj prawidłowy adres e-mail.",
      "login.bitte_geben_sie_ihr_passwort_ein": "Podaj hasło.",
      "login.bitte_geben_sie_zuerst_ihre_e_mail_adresse_e": "Najpierw podaj swój adres e-mail.",
      "login.claim": "Service desk, zasoby i licencje — jedna baza danych, jeden proces.",
      "login.datenschutz": "Prywatność",
      "login.e_mail_adresse_erfolgreich_geaendert": "E-Mail-Adresse erfolgreich geändert. Melden Sie sich jetzt mit der neuen Adresse an.",
      "login.ein_fehler_ist_aufgetreten": "Wystąpił błąd.",
      "login.einloggen_schliessen": "Zaloguj i zamknij",
      "login.erstanmeldung": "Pierwsze logowanie:",
      "login.falls_ein_konto_existiert_wurde_eine_e_mail": "Jeśli konto istnieje, wysłaliśmy wiadomość e-mail z linkiem do zresetowania hasła.",
      "login.fehler_beim_laden_des_mfa_setups": "Nie można załadować konfiguracji MFA",
      "login.fehler_beim_ueberpruefen_der_e_mail_adresse": "Nie można zweryfikować adresu e-mail.",
      "login.geben_sie_den_6_stelligen_code_aus_ihrer_aut": "Wprowadź 6-cyfrowy kod z aplikacji uwierzytelniającej lub kod odzyskiwania.",
      "login.geschaeftliche_e_mail": "Służbowy e-mail",
      "login.ihr_account_ist_deaktiviert": "Twoje konto jest dezaktywowane.",
      "login.ihr_administrator_erfordert_die_einrichtung": "Administrator wymaga skonfigurowania uwierzytelniania dwuskładnikowego.",
      "login.impressum": "Nota prawna",
      "login.kunden_account_erkannt": "Wykryto konto klienta",
      "login.manueller_schluessel": "Klucz ręczny",
      "login.melden_sie_sich_an_ihrem_service_desk_an": "Zaloguj się do swojego service desku.",
      "login.mfa_aktivieren_weiter": "Włącz MFA i kontynuuj",
      "login.mfa_einrichtung_erforderlich": "Wymagana konfiguracja MFA",
      "login.mfa_einrichtung_fehlgeschlagen": "Konfiguracja MFA nie powiodła się.",
      "login.mfa_erfolgreich_aktiviert": "MFA zostało włączone",
      "login.neue_geschaeftliche_e_mail": "Neue geschäftliche E-Mail",
      "login.oder": "LUB",
      "login.passwort": "Hasło",
      "login.qr_code_fuer_die_authenticator_app": "Kod QR dla aplikacji uwierzytelniającej",
      "login.sechsstelliger_verifizierungscode": "6-cyfrowy kod weryfikacyjny",
      "login.sende": "Wysyłanie…",
      "login.sicherheitszeile": "AES-256 · Dwuskładnikowe · Własna infrastruktura",
      "login.sicherheitszeile_kurz": "AES-256 · Zwei-Faktor",
      "login.sie_werden_automatisch_zum_kundenportal_weit": "Za chwilę nastąpi automatyczne przekierowanie do portalu klienta w celu zalogowania...",
      "login.single_sign_on_entra_id": "Single Sign-On (Entra ID)",
      "login.speichern_sie_diese_einmal_wiederherstellung": "Zapisz te jednorazowe kody odzyskiwania w bezpiecznym miejscu. Możesz ich użyć, jeśli utracisz dostęp do aplikacji.",
      "login.sso_anmeldung_fehlgeschlagen": "Logowanie SSO nie powiodło się",
      "login.startkonto_bestaetigt_adresse_festlegen": "Die Zugangsdaten des Startkontos wurden bestätigt. Legen Sie jetzt die geschäftliche Adresse für den Administrator fest.",
      "login.ueberpruefe": "Sprawdzanie...",
      "login.ungueltiger_oder_abgelaufener_mfa_code": "Nieprawidłowy lub wygasły kod MFA.",
      "login.verifiziere": "Weryfikacja…",
      "login.weiter": "Dalej",
      "login.willkommen_zurueck": "Witamy ponownie",
      "login.zurueck_zum_login": "Powrót do logowania",
      "login.zuruecksetzen": "Zresetuj",
      "login.zwei_faktor_code_totp": "Kod dwuskładnikowy (TOTP)",
      "logout": "Wyloguj się",
      "main_navigation_rail": "Główny pasek nawigacyjny",
      "managing_director": "Dyrektor zarządzający",
      "managing_director_abbrev": "Dyr",
      "managing_director_prefix": "Kierownictwo:",
      "mark_all_read": "Oznacz wszystkie jako przeczytane",
      "mark_as_resolved": "Oznacz jako rozwiązane",
      "mati.connection_error": "Błąd połączenia",
      "mati.delete": "Usuń",
      "mati.error_failed_connection": "Nie udało się połączyć z usługą AI.",
      "mati.error_generation": "Błąd podczas generowania odpowiedzi. Prosimy spróbować ponownie.",
      "mati.gdpr_warning": "Filtr RODO aktywny: dane osobowe są automatycznie anonimizowane przed przesłaniem.",
      "mati.greeting": "Cześć {{name}}! Jestem {{mascot}}. Jak mogę Ci dziś pomóc w pracy? 🔮\\n\\nMożesz mnie zapytać o:\\n- Status systemu lub obciążenie pracą agentów\\n- Wyszukiwanie zgłoszeń (\"Znajdź nierozwiązane zgłoszenia o wysokim priorytecie\")\\n- Tworzenie zgłoszeń (\"Utwórz zgłoszenie: pusty toner w drukarce na 2. piętrze\")",
      "mati.history": "Historia",
      "mati.input_placeholder": "Zapytaj mnie o zgłoszenia, obciążenie pracą lub utwórz zgłoszenie...",
      "mati.new_chat": "Nowy czat",
      "mati.online_intelligent": "Online i inteligentny",
      "mati.rename": "Zmień nazwę",
      "mati.restore_bead": "Pokaż pływającego asystenta",
      "mati.restore_bead_tooltip": "Ponownie pokaż pływającego asystenta (Bead) przy krawędzi ekranu",
      "mati.send_btn": "Wyślij",
      "mati.suggest.create_ticket.desc": "Zepsuta drukarka na 1. piętrze",
      "mati.suggest.create_ticket.prompt": "Utwórz zgłoszenie dotyczące zepsutej drukarki na 1. piętrze, priorytet średni.",
      "mati.suggest.create_ticket.title": "Utwórz zgłoszenie",
      "mati.suggest.search_tickets.desc": "Zapytanie \"baza danych\"",
      "mati.suggest.search_tickets.prompt": "Znajdź zgłoszenia zawierające słowo \"baza danych\".",
      "mati.suggest.search_tickets.title": "Szukaj zgłoszeń",
      "mati.suggest.support_help.desc": "Pomoc przy tworzeniu FAQ",
      "mati.suggest.support_help.prompt": "Jak sformułować uprzejmą odmowę w odpowiedzi na wniosek o zwrot pieniędzy?",
      "mati.suggest.support_help.title": "Pomoc wsparcia",
      "mati.suggest.system_status.desc": "Pokaż bieżące obciążenie",
      "mati.suggest.system_status.prompt": "Pokaż mi bieżący status systemu i przegląd obciążenia agentów.",
      "mati.suggest.system_status.title": "Status systemu",
      "mati.typing_text": "{{name}} pisze...",
      "mati.welcome_subtitle": "Jestem Twoim inteligentnym kopilotem AI. Mogę pomóc Ci zarządzać zgłoszeniami, wyszukiwać w systemie lub przeglądać statystyki systemowe.",
      "mati.welcome_title": "Cześć! Jestem {{name}}",
      "mati_gdpr_warning": "Filtr RODO aktywny: Dane osobowe są automatycznie anonimizowane przed wysłaniem.",
      "mati_placeholder": "Zapytaj mnie o zgłoszenia, obciążenie pracą lub utwórz zgłoszenie...",
      "mati_welcome": "Cześć! Jestem {{name}}",
      "meeting_error_title": "Nie można utworzyć spotkania Teams.",
      "meeting_success": "Spotkanie Teams utworzone.",
      "meeting_success_copy": "Spotkanie Teams utworzone, link skopiowany do schowka.",
      "megamenu.active_label": "Praca",
      "megamenu.calendar_desc": "Terminy i integracja z kalendarzem.",
      "megamenu.licenses_desc": "Zgodność licencyjna, pakiety i planowanie true-up.",
      "megamenu.modules": "Moduły",
      "megamenu.open_calendar": "Otwórz kalendarz",
      "megamenu.open_licenses": "Otwórz licencje",
      "megamenu.open_problems": "Otwórz problemy",
      "megamenu.problems_desc": "Zarządzanie problemami i RCA (analiza przyczyn źródłowych).",
      "megamenu.quick_search_commands": "Szybkie wyszukiwanie i polecenia",
      "merge": "Zusammenführen",
      "merge_tickets": "Die beiden markierten Tickets zusammenführen",
      "mfa_settings": "Ustawienia MFA",
      "minutes_ago": "{{count}} min temu",
      "mloffice.abgleich_fehler": "Abgleich konnte nicht gestartet werden.",
      "mloffice.abgleich_fehlgeschlagen": "Letzter Abgleich fehlgeschlagen: {{fehler}}",
      "mloffice.abgleich_gestartet": "Voll-Abgleich gestartet.",
      "mloffice.abgleich_laeuft": "Abgleich läuft",
      "mloffice.adresse": "MLOffice-Adresse",
      "mloffice.adresse_hinweis": "Basisadresse der MLOffice-Installation — ohne /api/v1.",
      "mloffice.agenten_titel": "Agenten ↔ MLOffice-Benutzer",
      "mloffice.aktion_anlegen": "Neu anlegen",
      "mloffice.aktion_entkoppeln": "Entkoppeln",
      "mloffice.aktion_entkoppeln_hinweis": "Aus dem Abgleich nehmen — der Kunde bleibt bestehen und wird wieder editierbar.",
      "mloffice.aktion_verknuepfen": "Verknüpfen",
      "mloffice.aktiv": "Aktiv",
      "mloffice.aktivieren": "Anbindung aktiv",
      "mloffice.auswahl_fehler": "Auswahl konnte nicht gespeichert werden.",
      "mloffice.bereits_uebertragen": "{{n}} Einträge im Zeitraum sind bereits übertragen und werden übersprungen.",
      "mloffice.email_eingeben": "Der Partner hat in MLOffice keine E-Mail-Adresse. E-Mail für den neuen Kunden:",
      "mloffice.entwurf_anlegen": "Entwurf anlegen",
      "mloffice.entwurf_fehler": "Entwurf konnte nicht angelegt werden.",
      "mloffice.entwurf_hinweis": "Erzeugt aus den bereits übertragenen Zeiten des Zeitraums einen ENTWURF in MLOffice. Belegnummer, Festschreibung und Versand bleiben MLOffice vorbehalten.",
      "mloffice.entwurf_ok": "Entwurf über {{h}} h in MLOffice angelegt — Festschreiben und Versand dort.",
      "mloffice.entwurf_titel": "Rechnungsentwurf in MLOffice",
      "mloffice.ereignis_closed": "Ticket geschlossen",
      "mloffice.ereignis_created": "Ticket eröffnet",
      "mloffice.ereignis_escalated": "Ticket eskaliert",
      "mloffice.ereignisse_titel": "Ticket-Ereignisse in die MLOffice-Kontakthistorie melden (nur Referenz, nie Inhalt):",
      "mloffice.erst_aktivieren": "Bitte zuerst die Anbindung aktivieren und die Verbindung testen — dann erscheint hier der MLOffice-Kundenbestand.",
      "mloffice.erst_aktivieren_abrechnung": "Bitte zuerst die Anbindung aktivieren — dann erscheinen hier offene Posten und der Kontingent-Abgleich.",
      "mloffice.erst_aktivieren_zeiten": "Bitte zuerst die Anbindung aktivieren — dann lassen sich Zeiten per Übertragungslauf nach MLOffice geben.",
      "mloffice.fallback_hinweis": "{{n}} Einträge ohne Agenten-Zuordnung werden über den technischen Benutzer gebucht (Agentenname in der Beschreibung).",
      "mloffice.feld_bis": "Bis",
      "mloffice.feld_kunde": "Kunde",
      "mloffice.feld_projekt": "MLOffice-Projekt",
      "mloffice.feld_satz": "Stundensatz (netto)",
      "mloffice.feld_von": "Von",
      "mloffice.gespeichert": "MLOffice-Einstellungen gespeichert.",
      "mloffice.gueltig_180": "180 Tage",
      "mloffice.gueltig_365": "365 Tage",
      "mloffice.gueltig_90": "90 Tage",
      "mloffice.gueltig_unbegrenzt": "Unbegrenzt",
      "mloffice.hoheit_frage": "MLOffice übernimmt die Hoheit über: {{felder}}.\\n\\nDiese Felder sind in AISupportDesk dann gesperrt und werden fortlaufend aus MLOffice übernommen. Fortfahren?",
      "mloffice.inaktiv": "Inaktiv",
      "mloffice.keine_partner": "Noch keine MLOffice-Kunden geladen. „Liste aus MLOffice laden“ holt den Bestand.",
      "mloffice.keine_zuordnung": "— keine Zuordnung —",
      "mloffice.konflikt_fehler": "Konnte nicht übernommen werden.",
      "mloffice.konflikt_geloest": "Übernommen.",
      "mloffice.konflikt_hinweis": "Übernahme braucht eine Entscheidung — siehe Konfliktzeile.",
      "mloffice.kopieren": "Kopieren",
      "mloffice.kunde_waehlen": "— Kunde wählen —",
      "mloffice.kunden_erklaerung": "Wähle aus, welche MLOffice-Kunden hier geführt werden. Ausgewählte Kunden werden fortlaufend abgeglichen; ihre Stammdaten sind hier gesperrt. Abwählen entkoppelt nur — der Kunde bleibt bestehen.",
      "mloffice.laden_fehler": "MLOffice-Einstellungen konnten nicht geladen werden.",
      "mloffice.laeufe_titel": "Bisherige Übertragungsläufe",
      "mloffice.lauf_detail": "Lauf #{{id}} — Einzelposten",
      "mloffice.lauf_fehler": "Lauf konnte nicht gestartet werden.",
      "mloffice.lauf_fertig": "Fertig",
      "mloffice.lauf_gestartet": "Übertragungslauf gestartet.",
      "mloffice.lauf_laeuft": "Läuft",
      "mloffice.lauf_starten": "Übertragung starten",
      "mloffice.lauf_teilfehler": "Mit Fehlern",
      "mloffice.linktoken_abgelaufen": "Das Verbindungstoken ist abgelaufen — MLOffice kann sich nicht mehr ausweisen. Neues Token erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_ablauf_teil": ", gültig bis {{datum}}",
      "mloffice.linktoken_einmal": "Jetzt kopieren — dieses Token wird nur EINMAL angezeigt:",
      "mloffice.linktoken_eintragen": "In MLOffice unter Einstellungen → AISupportDesk-Anbindung eintragen.",
      "mloffice.linktoken_erklaerung": "Dieses Token wird HIER erzeugt und in MLOffice unter „AISupportDesk-Anbindung“ eingetragen. MLOffice weist sich damit aus (Verbindungsstatus, Webhooks). Wird die Anbindung hier gelöst oder das Token widerrufen, zeigt MLOffice die Verbindung als gelöst.",
      "mloffice.linktoken_erzeugen": "Token erzeugen",
      "mloffice.linktoken_fehler": "Verbindungstoken konnte nicht erzeugt werden.",
      "mloffice.linktoken_gueltigkeit": "Gültigkeit",
      "mloffice.linktoken_kopiert": "Token kopiert.",
      "mloffice.linktoken_laeuft_ab": "Das Verbindungstoken läuft in {{tage}} Tagen ab. Rechtzeitig neu erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_neu": "Neues Token erzeugen",
      "mloffice.linktoken_rotieren_frage": "Es existiert bereits ein Verbindungstoken. Ein neues macht das alte sofort ungültig — MLOffice muss dann das neue Token eintragen. Fortfahren?",
      "mloffice.linktoken_status": "Hinterlegt ({{hint}}), erzeugt {{erzeugt}}{{ablauf}}.",
      "mloffice.linktoken_titel": "Verbindungstoken für MLOffice",
      "mloffice.linktoken_unbegrenzt_teil": ", unbegrenzt gültig",
      "mloffice.linktoken_widerruf_fehler": "Widerruf fehlgeschlagen.",
      "mloffice.linktoken_widerruf_frage": "Verbindungstoken widerrufen? MLOffice zeigt die Verbindung danach als gelöst; Webhooks und Statusabfragen von MLOffice werden abgewiesen.",
      "mloffice.linktoken_widerrufen": "Verbindungstoken widerrufen.",
      "mloffice.linktoken_widerrufen_btn": "Widerrufen",
      "mloffice.liste_aktualisieren": "Liste aus MLOffice laden",
      "mloffice.loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "mloffice.nur_verknuepfte": "Nur mit MLOffice verknüpfte Kunden.",
      "mloffice.ohne_email": "ohne E-Mail",
      "mloffice.op_aktualisiert": "Offene Posten aktualisiert.",
      "mloffice.op_belege": "Belege",
      "mloffice.op_fehler": "Offene Posten konnten nicht geladen werden.",
      "mloffice.op_laden": "Offene Posten aus MLOffice laden",
      "mloffice.op_stand": "Stand: {{zeit}}",
      "mloffice.op_titel": "Offene Posten (MLOffice)",
      "mloffice.partner_laden_fehler": "MLOffice-Kundenliste konnte nicht geladen werden.",
      "mloffice.posten_ok": "übertragen",
      "mloffice.posten_retry": "Erneut",
      "mloffice.posten_skip": "Überspringen",
      "mloffice.projekt_pflicht": "Bitte oben ein MLOffice-Projekt wählen.",
      "mloffice.projekt_waehlen": "— Projekt wählen —",
      "mloffice.rechte_fehlen": "Dem Token fehlen Rechte:",
      "mloffice.recon_asd": "Support-Sicht (NALVRA SERVICE)",
      "mloffice.recon_diff": "Abweichung Support- zu Abrechnungs-Sicht: {{min}} Min.",
      "mloffice.recon_gebucht": "{{min}} Min. im Projekt „{{projekt}}“ gebucht",
      "mloffice.recon_gesperrt_bis": "Erfassung gesperrt bis: {{d}}",
      "mloffice.recon_kein_projekt": "Kein MLOffice-Projekt zugeordnet (Tab „Zuordnung“).",
      "mloffice.recon_kein_vertrag": "Kein aktiver Vertrag mit Kontingent für diesen Kunden.",
      "mloffice.recon_mlo": "Abrechnungs-Sicht (MLOffice)",
      "mloffice.recon_offen": "{{min}} Min. der laufenden Periode sind noch nicht an MLOffice übertragen — Übertragungslauf im Tab „Zeiten-Übertragung“ starten.",
      "mloffice.recon_titel": "Kontingent-Abgleich",
      "mloffice.recon_verbrauch": "{{used}} von {{incl}} Min. verbraucht — {{rest}} Min. übrig",
      "mloffice.schon_drueben": "übertragen",
      "mloffice.sp_agent": "Agent",
      "mloffice.sp_beschreibung": "Beschreibung",
      "mloffice.sp_datum": "Datum",
      "mloffice.sp_fortschritt": "Gesendet / Fehler / Gesamt",
      "mloffice.sp_kunde": "Kunde",
      "mloffice.sp_minuten": "Min.",
      "mloffice.sp_status": "Status",
      "mloffice.sp_ticket": "Ticket",
      "mloffice.sp_zeitraum": "Zeitraum",
      "mloffice.spalte_kunde": "MLOffice-Kunde",
      "mloffice.spalte_status": "Status",
      "mloffice.spalte_sync": "Sync",
      "mloffice.spalte_zuordnung": "Zuordnung in NALVRA SERVICE",
      "mloffice.speichern": "Speichern",
      "mloffice.speichern_fehler": "Speichern fehlgeschlagen.",
      "mloffice.status_archiviert": "In MLOffice archiviert",
      "mloffice.status_delta": "Letzter Kundenabgleich: {{zeit}}",
      "mloffice.status_entkoppelt": "Entkoppelt",
      "mloffice.status_failed": "{{n}} Übertragungen fehlgeschlagen",
      "mloffice.status_kein_linktoken": "Kein Verbindungstoken für MLOffice erzeugt",
      "mloffice.status_konflikt": "Entscheidung nötig",
      "mloffice.status_linktoken_abgelaufen": "Verbindungstoken abgelaufen — neu erzeugen und in MLOffice eintragen",
      "mloffice.status_neu": "Neu",
      "mloffice.status_op": "Offene Posten: {{zeit}}",
      "mloffice.status_pending": "{{n}} Übertragungen offen",
      "mloffice.status_ratelimit": "MLOffice-Ratenbegrenzung — kurze Pause",
      "mloffice.status_sync_fehler": "Letzter Abgleich mit Fehler",
      "mloffice.status_uebernommen": "Übernommen",
      "mloffice.tab_abrechnung": "Abrechnung",
      "mloffice.tab_kunden": "Kundenabgleich",
      "mloffice.tab_verbindung": "Verbindung",
      "mloffice.tab_zeiten": "Zeiten-Übertragung",
      "mloffice.tab_zuordnung": "Zuordnung",
      "mloffice.techuser_hinweis": "Wird für Zeitbuchungen ohne Agenten-Zuordnung verwendet; der Agentenname wandert dann in die Buchungsbeschreibung.",
      "mloffice.techuser_titel": "Technischer Benutzer (Fallback)",
      "mloffice.test_fehler": "Verbindungstest fehlgeschlagen.",
      "mloffice.test_nicht_verbunden": "Keine Verbindung",
      "mloffice.test_ok": "Verbindung zu MLOffice steht.",
      "mloffice.test_verbunden": "Verbunden mit Mandant „{{tenant}}“",
      "mloffice.testen": "Verbindung testen",
      "mloffice.titel": "MLOffice-Anbindung",
      "mloffice.token": "API-Token",
      "mloffice.token_gesetzt": "hinterlegt ({{hint}})",
      "mloffice.token_hinweis": "In MLOffice unter Einstellungen → API-Tokens anlegen. Benötigte Rechte prüft der Verbindungstest.",
      "mloffice.token_name": "Token: {{name}}",
      "mloffice.token_unveraendert": "Leer lassen = unverändert",
      "mloffice.untertitel": "Kundenstammdaten, Abrechnung, Zeiterfassung und CRM mit MLOffice koppeln. MLOffice ist das führende System für Stammdaten und Rechnungen.",
      "mloffice.users_dropdown": "Zeitbuchungen werden in MLOffice unter dem zugeordneten Benutzer geführt. Ohne Zuordnung greift der technische Benutzer.",
      "mloffice.users_manuell": "MLOffice stellt (noch) keine Benutzerliste bereit — MLOffice-User-UUID bitte manuell eintragen (in MLOffice unter Benutzerverwaltung kopieren).",
      "mloffice.uuid_platzhalter": "MLOffice-User-UUID",
      "mloffice.verbindung": "Verbindung",
      "mloffice.vollabgleich": "Voll-Abgleich starten",
      "mloffice.vorschau": "Vorschau",
      "mloffice.vorschau_anlegen": "Wird neu angelegt",
      "mloffice.vorschau_email_fehlt": "E-Mail fehlt — wird bei Übernahme abgefragt",
      "mloffice.vorschau_fehler": "Vorschau fehlgeschlagen.",
      "mloffice.vorschau_titel": "Vorschau: {{n}} Einträge, {{h}} h werden übertragen",
      "mloffice.vorschau_verknuepfung": "Vorschlag: mit „{{name}}“ verknüpfen ({{grund}})",
      "mloffice.zeiten_erklaerung": "Zeiten werden NICHT automatisch übertragen. Du wählst Kunde und Zeitraum, prüfst die Vorschau und bestätigst — erst dann gehen die Buchungen nach MLOffice. Übertragene Buchungen sind dort unumkehrbar und hier gesperrt.",
      "mloffice.zeitraum_bis_heute": "Bis heute",
      "mloffice.zeitraum_dieser_monat": "Dieser Monat",
      "mloffice.zeitraum_letzter_monat": "Letzter Monat",
      "mloffice.zuordnung_fehler": "Zuordnung konnte nicht gespeichert werden.",
      "mloffice.zuordnung_fehlt": "{{n}} Einträge ohne Agenten-Zuordnung — bitte unter „Zuordnung“ pflegen oder einen technischen Benutzer hinterlegen.",
      "mloffice.zuordnung_gespeichert": "Zuordnung gespeichert.",
      "mobile": "Komórka",
      "move_ticket": "Verschieben",
      "my_tickets": "Moje zgłoszenia",
      "navbar_search_placeholder": "Szukaj zgłoszeń, klientów lub bazy wiedzy...",
      "new": "Nowy",
      "new_activity_aria": "Nowa aktywność",
      "new_activity_title": "Nowa aktywność od ostatniego wyświetlenia",
      "new_company": "Neue Firma",
      "new_label": "Nowy",
      "new_ticket": "Nowe zgłoszenie",
      "next": "Weiter",
      "no_activities_recorded": "Nie odnotowano jeszcze żadnej aktywności.",
      "no_canned_responses": "Brak gotowych odpowiedzi",
      "no_canned_responses_hint": "Można nimi zarządzać w panelu administracyjnym.",
      "no_critical_tickets": "Brak krytycznych zgłoszeń",
      "no_customer_assigned": "Nie przypisano klienta",
      "no_customer_data": "Brak danych klientów.",
      "no_customers_found": "Nie znaleziono klientów",
      "no_customers_matching": "Nie znaleziono klientów dla wybranych filtrów lub zapytania wyszukiwania.",
      "no_data_available": "Brak dostępnych danych",
      "no_employees_found": "Brak zarejestrowanych pracowników",
      "no_notes_placeholder": "Brak notatek. Kliknij \"Edytuj\", aby dodać notatki.",
      "no_notifications": "Brak powiadomień",
      "no_other_agents_online": "Obecnie brak innych członków zespołu online.",
      "no_results": "Brak wyników",
      "no_tickets_found": "Nie znaleziono zgłoszeń",
      "no_tickets_found_desc": "W tej kolejce filtrów nie ma obecnie żadnych elementów.",
      "no_tickets_risk": "Obecnie brak zgłoszeń w krytycznym oknie ostrzegawczym SLA.",
      "not_spam": "To nie spam",
      "notification_settings": "Ustawienia powiadomień",
      "notification_settings_desc": "Wybierz, które powiadomienia chcesz otrzymywać.",
      "notification_settings_saved": "Ustawienia powiadomień zapisane.",
      "notifications": "Powiadomienia",
      "notify_license_change": "Zmiany licencji",
      "notify_new_reply": "Nowe odpowiedzi",
      "notify_new_ticket": "Nowe zgłoszenia",
      "notify_status_changed": "Zmiany statusu",
      "observers_title": "Obserwatorzy",
      "only_visible_for": "Tylko {{name}}",
      "only_visible_to_agents": "Widoczne tylko dla pracowników",
      "open_administration": "Otwórz administrację",
      "open_btn": "Otwórz",
      "open_password_vault": "Otwórz sejf haseł w przeglądarce",
      "open_quick_search": "Otwórz szybkie wyszukiwanie",
      "open_tickets": "Otwarte zgłoszenia",
      "other_tickets_count": "Inne zgłoszenia ({{count}})",
      "other_tickets_requester_count": "Inne zgłoszenia zgłaszającego ({{count}})",
      "overdue": "Zaległe",
      "overview_option_1": "1. Standardowy panel KPI",
      "overview_option_10": "10. Wskaźnik naruszeń SLA według priorytetów",
      "overview_option_2": "2. Wskaźnik rozwiązań przy pierwszym kontakcie (FCR) i czas reakcji",
      "overview_option_3": "3. Rozwój wolumenu zgłoszeń i godziny szczytu",
      "overview_option_4": "4. Trendy wskaźnika rozwiązań (Utworzone vs Rozwiązane)",
      "overview_option_5": "5. Macierz CSAT vs czas rozwiązania",
      "overview_option_6": "6. Kanały zgłoszeń i podział źródeł",
      "overview_option_7": "7. Wskaźniki eskalacji i analiza ścieżki eskalacji",
      "overview_option_8": "8. Średni cykl życia zgłoszenia (starzenie się)",
      "overview_option_9": "9. Status backlogu i starzenie się",
      "performance_queues": "Wydajność i kolejki",
      "phone": "Telefon",
      "plan_teams_meeting": "Zaplanuj spotkanie Teams",
      "planning": "Planowanie",
      "please_enter_text": "Proszę wpisać tekst",
      "policy": "Polityka",
      "portal_company.load_failed": "Dokumente konnten nicht geladen werden.",
      "portal_company.primary_contact": "Hauptansprechpartner",
      "portal_session.continue": "Weiterarbeiten",
      "portal_session.login": "Erneut anmelden",
      "portal_session.warning": "Ihre Sitzung endet in {{seconds}} Sekunden. Gespeicherte Entwürfe bleiben erhalten.",
      "portal_speech.denied": "Mikrofonzugriff oder Spracherkennung wurde nicht erlaubt. Bitte die Browserberechtigung prüfen.",
      "portal_speech.failed": "Spracheingabe nicht verfügbar. Bitte Mikrofon und Verbindung prüfen oder weitertippen.",
      "portal_speech.listening": "Mikrofon aktiv – bitte sprechen …",
      "portal_speech.notice": "Diktierter Text wird unten an die Beschreibung angefügt. Der Browser kann Audio zur Erkennung an seinen Sprachdienst senden.",
      "portal_speech.silence": "Keine Sprache erkannt. Bitte erneut starten.",
      "portal_speech.start": "Diktat starten",
      "portal_speech.stop": "Stoppen",
      "portal_speech.title": "Spracheingabe",
      "portal_speech.unsupported": "Dieser Browser unterstützt hier keine Spracheingabe. Sie können die Diktierfunktion Ihrer Tastatur verwenden.",
      "preview": "Podgląd",
      "previous": "Zurück",
      "primary": "Główny",
      "priority": "Priorytet",
      "priority_": "",
      "priority_critical": "Krytyczny",
      "priority_high": "Wysoki",
      "priority_low": "Niski",
      "priority_medium": "Średni",
      "priority_urgent": "Pilne",
      "problem_cascade_close_checkbox": "Tak, zamknij wszystkie powiązane incydenty (zalecane)",
      "problem_cascade_close_desc": "Istnieją powiązane otwarte incydenty. Czy chcesz je automatycznie rozwiązać i skomentować przyczyną główną oraz rozwiązaniem?",
      "problem_cascade_close_title": "Zamknięcie Kaskadowe",
      "problem_confirm_resolve": "Potwierdź i Rozwiąż",
      "problem_create_btn": "Utwórz Problem",
      "problem_create_error": "Błąd podczas tworzenia problemu",
      "problem_create_success": "Utworzono zgłoszenie problemu.",
      "problem_create_title": "Utwórz Nowe Zgłoszenie Problemu",
      "problem_created_by_on": "Utworzone przez {{creator}} w dniu {{date}}",
      "problem_description_label": "Opis Problemu",
      "problem_detail_load_error": "Błąd podczas ładowania szczegółów problemu",
      "problem_incidents_linked": "Powiązane incydenty",
      "problem_kedb_empty": "Brak znanych błędów",
      "problem_kedb_empty_desc": "Problemy sklasyfikowane jako znany błąd pojawią się tutaj wraz z przyczyną i obejściem.",
      "problem_kedb_load_error": "Błąd podczas ładowania znanych błędów",
      "problem_kedb_search_placeholder": "Przeszukaj znane błędy...",
      "problem_kedb_title": "Znane błędy (Known Errors)",
      "problem_known_error_badge": "Znany błąd",
      "problem_known_error_checkbox": "Klasyfikuj jako Znany Błąd (Known Error)",
      "problem_known_error_only": "Tylko znane błędy",
      "problem_link_btn": "Powiąż",
      "problem_link_error": "Błąd podczas wiązania incydentów",
      "problem_link_incident_btn": "Powiąż Incydent",
      "problem_link_incidents_title": "Powiąż Incydenty",
      "problem_link_success": "Powiązano incydenty.",
      "problem_linked_incidents": "Powiązane Incydenty",
      "problem_load_error": "Błąd podczas ładowania problemów",
      "problem_loading": "Ładowanie zarządzania problemami ITIL...",
      "problem_mark_known_error": "Oznacz jako Znany Błąd",
      "problem_no_incidents_found": "Nie znaleziono powiązanych incydentów.",
      "problem_no_tickets": "Brak zgłoszeń problemów",
      "problem_no_tickets_desc": "Obecnie nie zarejestrowano żadnych zgłoszeń problemów ITIL.",
      "problem_no_unlinked_found": "Nie znaleziono otwartych, niepowiązanych incydentów.",
      "problem_none": "—",
      "problem_none_selected": "Nie wybrano żadnego problemu",
      "problem_none_selected_desc": "Wybierz zgłoszenie problemu ITIL po lewej stronie lub utwórz nowe, aby zarządzać danymi RCA.",
      "problem_open_change_confirm": "Otworzyć teraz nowe zgłoszenie zmiany {{num}}?",
      "problem_raise_change_btn": "Utwórz zmianę",
      "problem_raise_change_error": "Błąd podczas tworzenia zmiany",
      "problem_raise_change_success": "Utworzono zgłoszenie zmiany: {{num}}",
      "problem_raise_change_title": "Utwórz zmianę na podstawie tego problemu",
      "problem_rca_title": "Problemy ITIL (RCA)",
      "problem_resolution_note": "Notatka o Rozwiązaniu",
      "problem_resolution_note_placeholder": "Wpisz szczegóły ostatecznego rozwiązania...",
      "problem_resolve_btn": "Rozwiąż Problem",
      "problem_resolve_error": "Błąd podczas rozwiązywania problemu",
      "problem_resolve_success": "Problem rozwiązany.",
      "problem_root_cause_label": "Podejrzewana Przyczyna Główna",
      "problem_root_cause_short": "Przyczyna źródłowa",
      "problem_search_placeholder": "Przeszukaj problemy...",
      "problem_stage_closed": "Zamknięty",
      "problem_stage_known_error": "Znany błąd",
      "problem_stage_label": "Status cyklu życia (etap problemu)",
      "problem_stage_open": "Otwarty",
      "problem_stage_resolved": "Rozwiązany",
      "problem_stage_under_investigation": "W trakcie analizy",
      "problem_stage_updated": "Status cyklu życia zaktualizowany.",
      "problem_stage_workaround_found": "Znaleziono obejście",
      "problem_tab_kedb": "Baza znanych błędów (KEDB)",
      "problem_tab_problems": "Problemy (RCA)",
      "problem_title": "Problem ITIL: Powtarzający się incydent",
      "problem_title_label": "Tytuł Problemu",
      "problem_unlink_btn": "Usuń powiązanie",
      "problem_unlink_error": "Błąd podczas usuwania powiązania",
      "problem_unlink_success": "Powiązanie usunięte.",
      "problem_update_error": "Błąd podczas aktualizowania problemu",
      "problem_update_success": "Problem zaktualizowany pomyślnie.",
      "problem_workaround_label": "Znane Obejście",
      "problem_workaround_short": "Obejście",
      "problems": "Problemy",
      "queue.": "queue.",
      "queue_external_processing": "Externe Bearbeitung",
      "queues": "Kolejki",
      "quick_access_views": "Szybki dostęp i widoki",
      "quick_search": "Szybkie wyszukiwanie",
      "read_ticket_also": "również czyta to zgłoszenie",
      "reading_ticket": "Czyta zgłoszenie #{{id}}",
      "reassign_to": "Przepisz ({{name}})...",
      "recent_activities_description": "Ostatnie zgłoszenia i odpowiedzi dla tego klienta.",
      "recent_tickets": "Ostatnie zgłoszenia",
      "refresh": "Odśwież",
      "remove_assignment": "Usuń przypisanie",
      "remove_attachment_aria": "Usuń załącznik {{filename}}",
      "remove_filter": "Filter entfernen",
      "reopen": "Otwórz ponownie",
      "reply": "Odpowiedz",
      "reply_keyboard_shortcut_hint": "Skrót klawiszowy: Ctrl lub Cmd + Enter, aby wysłać, gdy kursor znajduje się w tekście.",
      "report_active_breaches": "Aktywne naruszenia",
      "report_ai_analysis": "Analiza SI",
      "report_ai_analyzing": "SI analizuje dane raportu...",
      "report_ai_highlights": "Wyróżnienia",
      "report_ai_recommendations": "Rekomendacje",
      "report_billable": "Rozliczalne",
      "report_compliance": "Zgodność",
      "report_export": "Eksportuj",
      "report_exporting": "Eksportowanie...",
      "report_no_data": "Brak dostępnych danych",
      "report_no_data_desc": "Nie można załadować danych raportu dla tego okresu.",
      "report_range": "Widok raportu:",
      "report_total_time": "Całkowity czas",
      "reports": "Raporty",
      "reports_desc": "Raporty i analizy zarządzania usługami",
      "request.additional_info": "Dodatkowe informacje",
      "request.back_to_dashboard": "Powrót do pulpitu",
      "request.back_to_dashboard_link": "← Pulpit",
      "request.back_to_list": "Do przeglądu",
      "request.back_to_requests": "← Wszystkie wnioski",
      "request.catalog_subtitle": "Prosimy wybrać rodzaj wniosku — otrzymają Państwo odpowiedni formularz.",
      "request.choose_files": "Wybierz pliki",
      "request.description_placeholder": "Prosimy opisać sprawę…",
      "request.description_required": "Prosimy wprowadzić opis.",
      "request.failed_load_catalog": "Nie udało się załadować katalogu",
      "request.file_too_large": "Plik jest za duży (maks. {{max}} MB): {{name}}",
      "request.file_type_not_allowed": "Dateityp nicht erlaubt: {{name}}",
      "request.no_requests": "W portalu nie udostępniono żadnych wniosków serwisowych.",
      "request.not_available": "Ten wniosek jest niedostępny lub nieopublikowany.",
      "request.optional_select": "— Opcjonalnie —",
      "request.please_select": "— Prosimy wybrać —",
      "request.remove_file": "Usuń",
      "request.required_field": "Pole obowiązkowe: {{label}}",
      "request.standard_fields_info": "Pola standardowe: priorytet, kategoria, opis i załączniki są zawarte w każdym wniosku serwisowym. Poniżej mogą znajdować się dodatkowe pola właściwe dla tego rodzaju wniosku.",
      "request.submit_btn": "Wyślij wniosek",
      "request.submit_failed": "Wysyłanie nie powiodło się",
      "request.submitting_btn": "Trwa wysyłanie…",
      "request_type": "Typ wniosku",
      "requester_title": "Zgłaszający",
      "reset": "Resetuj",
      "reset_all_filters": "Alle Filter zurücksetzen",
      "reset_filter": "Resetuj filtr",
      "reset_kpi_filter": "Kachel-Filter zurücksetzen",
      "reset_to_default": "Przywróć domyślne",
      "resolution": "Rozwiązanie",
      "resolve": "Rozwiąż",
      "resolved_label": "Rozwiązane",
      "retry": "Erneut versuchen",
      "risk": "Ryzyko",
      "risk_minutes": "{{count}} min",
      "save": "Zapisz",
      "save_changes": "Zapisz Zmiany",
      "save_note": "Zapisz notatkę",
      "saving": "Zapisywanie...",
      "scroll_to_reply": "Przewiń do odpowiedzi",
      "search": "Szukaj...",
      "search_canned_responses": "Przeszukaj gotowe odpowiedzi…",
      "search_customers": "Szukaj klientów...",
      "select_company": "Firma auswählen…",
      "select_customer_placeholder": "Wybierz klienta z listy",
      "self_healing": "Autonaprawa",
      "send": "Wyślij",
      "sending_ellipsis": "Wysyłanie...",
      "settings": "Ustawienia",
      "seven_days": "7 dni",
      "shortcut_back_close": "Wstecz / Zamknij",
      "shortcut_escalate": "Eskaluj",
      "shortcut_focus_mode": "Tryb skupienia",
      "shortcut_help": "Ta pomoc",
      "shortcut_internal_note": "Notatka wewnętrzna",
      "shortcut_next_prev": "Następne / Poprzednie zgłoszenie",
      "shortcut_quick_search": "Szybkie wyszukiwanie",
      "shortcut_write_reply": "Napisz odpowiedź",
      "show_all": "Pokaż wszystkie",
      "show_full_ticket_backlog": "Pokaż cały backlog zgłoszeń",
      "show_older_replies": "Pokaż {{count}} starszych odpowiedzi...",
      "sla_and_contract_title": "SLA i umowa",
      "sla_breached_both": "Przekroczono czas odpowiedzi i rozwiązania",
      "sla_breached_exclamation": "SLA przekroczone!",
      "sla_breached_resolution": "Przekroczono czas rozwiązania",
      "sla_breached_response": "Przekroczono czas odpowiedzi",
      "sla_breaches": "Naruszenia SLA:",
      "sla_compliance": "Zgodność z SLA",
      "sla_level": "Poziom SLA:",
      "sla_option_1": "1. Zgodność z SLA i trendy (Przegląd)",
      "sla_option_10": "10. Statystyki SLA w weekendy i święta",
      "sla_option_2": "2. Naruszenia SLA i zgłoszenia zagrożone",
      "sla_option_3": "3. SLA według priorytetu",
      "sla_option_4": "4. SLA według klienta / planu serwisowego",
      "sla_option_5": "5. Zgodność SLA czasu reakcji",
      "sla_option_6": "6. Zgodność SLA czasu rozwiązania",
      "sla_option_7": "7. Naruszenia SLA według agenta/grupy",
      "sla_option_8": "8. Przyczyny naruszeń SLA",
      "sla_option_9": "9. Podgląd kar i kredytów (Ryzyko finansowe)",
      "sla_performance_breaches": "Wydajność SLA i naruszenia",
      "sla_risk": "Ryzyko SLA",
      "sla_status_ok": "OK",
      "sort_by_label": "Sortuj według {{label}}",
      "spam": "Spam",
      "starred": "Oznaczone",
      "start": "Start",
      "status": "Status",
      "status_closed": "Zamknięte",
      "status_in_progress": "W toku",
      "status_new": "Nowy",
      "status_on_hold": "Wstrzymane",
      "status_open": "Otwarte",
      "status_resolved": "Rozwiązane",
      "status_waiting": "Oczekujące",
      "status_waiting_customer": "Oczekiwanie na klienta",
      "street": "Ulica",
      "subtasks": "Teilaufgaben",
      "supporting_agents": "Wspierający agenci",
      "switch_language": "Zmień język",
      "system_logs": "Logi systemowe",
      "tab_": "",
      "tab_activity": "Aktywność",
      "tab_agents": "Agenci",
      "tab_assets": "Zasoby",
      "tab_contracts": "Umowy",
      "tab_csat": "CSAT",
      "tab_custom": "Własne raporty",
      "tab_customers": "Klienci",
      "tab_documents": "Dokumenty",
      "tab_employees": "Pracownicy",
      "tab_incidents": "Incydenty",
      "tab_licenses": "Licencje",
      "tab_notes": "Notatki",
      "tab_overview": "Przegląd",
      "tab_sla": "SLA",
      "tab_tickets": "Zgłoszenia",
      "tab_time": "Ewidencja czasu",
      "tab_trends": "Trendy",
      "tag_add_placeholder": "Dodaj tag...",
      "tag_label": "Tag",
      "tax_number": "NIP",
      "teams_call_start": "Rozpocznij połączenie Teams",
      "teams_chat_open": "Otwórz czat Teams",
      "teams_meeting_subject": "Spotkanie {{number}}",
      "teams_meeting_title": "Spotkanie Teams",
      "thirty_days": "30 dni",
      "ticket_assets.action_col": "Akcja",
      "ticket_assets.agent_offline": "Agent offline",
      "ticket_assets.agent_ready": "Gotowy",
      "ticket_assets.assigned_assets": "Zasoby przypisane do pracownika",
      "ticket_assets.bios_label": "Wersja BIOS:",
      "ticket_assets.calculating_compliance": "Trwa obliczanie audytu licencji...",
      "ticket_assets.clean_temp": "Wyczyść pliki tymczasowe",
      "ticket_assets.cmd_status_completed": "Gotowe",
      "ticket_assets.cmd_status_failed": "Błąd",
      "ticket_assets.cmd_status_pending": "Oczekuje",
      "ticket_assets.cmd_status_running": "W trakcie...",
      "ticket_assets.cmdb_alert_desc": "Ten zasób zależy od / jest połączony z:",
      "ticket_assets.cmdb_alert_title": "Ostrzeżenie kaskadowe CMDB: awaria zależności!",
      "ticket_assets.command_execution_failed": "Wykonanie polecenia nie powiodło się.",
      "ticket_assets.command_placeholder": "np. ipconfig /all, systeminfo, dir",
      "ticket_assets.command_running": "Polecenie jest właśnie wykonywane na urządzeniu klienckim...",
      "ticket_assets.command_success_solved": "Wykonano pomyślnie! Zgłoszenie zostało automatycznie rozwiązane.",
      "ticket_assets.command_timeout": "Przekroczono limit czasu wykonania polecenia.",
      "ticket_assets.compliant": "Zgodne",
      "ticket_assets.confirm_kill_process": "Czy na pewno chcą Państwo zakończyć proces o PID {{pid}}?",
      "ticket_assets.cpu_cores_label": "Rdzenie:",
      "ticket_assets.cpu_label": "Procesor (CPU)",
      "ticket_assets.cpu_sockets_label": "Gniazda:",
      "ticket_assets.cpu_util_label": "Użycie CPU",
      "ticket_assets.created_label": "Utworzono:",
      "ticket_assets.device_scan_label": "Skanowanie urządzenia",
      "ticket_assets.disk_free_label": "wolne",
      "ticket_assets.disk_used_label": "Zajęte",
      "ticket_assets.disks_label": "Dyski / napędy",
      "ticket_assets.domain_label": "Grupa robocza/domena:",
      "ticket_assets.edition_id_label": "Identyfikator edycji:",
      "ticket_assets.employee_assets": "Zasoby pracownika",
      "ticket_assets.error_kill_process": "Błąd podczas kończenia procesu: {{error}}",
      "ticket_assets.error_loading_monitoring": "Błąd podczas ładowania monitoringu",
      "ticket_assets.error_sending_command": "Błąd podczas wysyłania polecenia.",
      "ticket_assets.error_submit_command": "Nie udało się przesłać polecenia: {{error}}",
      "ticket_assets.executed_label": "Wykonano:",
      "ticket_assets.fetch_logs_btn": "Pobierz dzienniki",
      "ticket_assets.filter_processes_placeholder": "Filtruj procesy (nazwa, PID)...",
      "ticket_assets.fix_dns": "Napraw DNS",
      "ticket_assets.fix_spooler": "Napraw bufor wydruku",
      "ticket_assets.hostname_label": "Nazwa sieciowa:",
      "ticket_assets.incomplete_summary": "Podsumowanie zgodności jest niekompletne.",
      "ticket_assets.invalid_json_response": "Nieprawidłowa odpowiedź serwera",
      "ticket_assets.kill_btn": "Zakończ",
      "ticket_assets.killing_proc": "Kończenie...",
      "ticket_assets.last_scan_label": "Ostatnie skanowanie:",
      "ticket_assets.license_compliance": "Zgodność licencyjna",
      "ticket_assets.link": "Powiąż",
      "ticket_assets.link_asset_title": "Powiąż zasób",
      "ticket_assets.linked": "Powiązane",
      "ticket_assets.linked_assets": "Zasoby powiązane ze zgłoszeniem",
      "ticket_assets.loading": "Trwa ładowanie zasobów...",
      "ticket_assets.loading_command_queue": "Ładowanie kolejki poleceń...",
      "ticket_assets.loading_logs": "Trwa ładowanie dzienników zdarzeń...",
      "ticket_assets.loading_monitoring": "Ładowanie monitoringu na żywo i kontroli CMDB...",
      "ticket_assets.log_name_label": "Nazwa dziennika",
      "ticket_assets.memory_col": "Pamięć",
      "ticket_assets.model_label": "Model:",
      "ticket_assets.monitored_ok": "Monitorowane (OK)",
      "ticket_assets.more_params_title": "Dodatkowe parametry",
      "ticket_assets.motherboard_label": "Płyta główna:",
      "ticket_assets.no_active_zabbix_alerts": "Brak aktywnych alarmów Zabbix.",
      "ticket_assets.no_assets_assigned": "Do tego pracownika nie przypisano żadnych zasobów IT.",
      "ticket_assets.no_assets_linked": "Brak powiązanych zasobów.",
      "ticket_assets.no_commands_executed": "Nie wykonano jeszcze żadnych poleceń. Prosimy wprowadzić polecenie poniżej.",
      "ticket_assets.no_compliance_available": "Brak dostępnych licencji lub raportu zgodności.",
      "ticket_assets.no_employee_assigned": "Do zgłoszenia nie przypisano żadnego pracownika.",
      "ticket_assets.no_hardware_details": "Nie zeskanowano szczegółów sprzętu.",
      "ticket_assets.no_matching_software": "Nie znaleziono pasujących wpisów oprogramowania.",
      "ticket_assets.no_monitoring_data": "Brak dostępnych danych monitoringu",
      "ticket_assets.os_arch_label": "Architektura:",
      "ticket_assets.os_label": "System operacyjny",
      "ticket_assets.os_ver_label": "Wersja:",
      "ticket_assets.overlicensed": "Nadmiar licencji",
      "ticket_assets.pagination_text": "Strona {{page}} z {{total}} (wpisów: {{count}})",
      "ticket_assets.process_name_col": "Nazwa procesu",
      "ticket_assets.publisher_col": "Wydawca",
      "ticket_assets.query_realtime_btn": "Odpytaj w czasie rzeczywistym",
      "ticket_assets.ram_label": "Pamięć operacyjna (RAM)",
      "ticket_assets.ram_util_label": "Użycie RAM",
      "ticket_assets.scan_details_btn": "Szczegóły skanowania",
      "ticket_assets.scan_never": "nigdy",
      "ticket_assets.search_logs_placeholder": "Przeszukaj wyniki (źródło, ID, komunikat)...",
      "ticket_assets.search_placeholder": "Szukaj nazwy, IP lub S/N...",
      "ticket_assets.search_software_placeholder": "Przeszukaj oprogramowanie...",
      "ticket_assets.self_healing_title": "Samonaprawa i automatyzacja",
      "ticket_assets.send_btn": "Wyślij",
      "ticket_assets.sending_command_failed": "Wysłanie polecenia nie powiodło się.",
      "ticket_assets.serial_number_label": "Numer seryjny:",
      "ticket_assets.severity_all": "Wszystkie",
      "ticket_assets.severity_error": "Błąd (Error)",
      "ticket_assets.severity_info": "Informacja",
      "ticket_assets.severity_label": "Poziom ważności",
      "ticket_assets.severity_warning": "Ostrzeżenie (Warning)",
      "ticket_assets.sn_label": "S/N:",
      "ticket_assets.software_name_col": "Nazwa oprogramowania",
      "ticket_assets.sql_instance_label": "Instancja:",
      "ticket_assets.sql_instances_title": "Wykryte instancje SQL Server",
      "ticket_assets.sql_patchlevel_label": "Poziom poprawek:",
      "ticket_assets.success_kill_process": "Proces został zakończony.",
      "ticket_assets.surplus_label": "Nadwyżka:",
      "ticket_assets.timeout_kill_process": "Przekroczono limit czasu kończenia procesu.",
      "ticket_assets.total_ram_desc": "Łączna pamięć fizyczna",
      "ticket_assets.underlicensed": "Niedobór licencji",
      "ticket_assets.unlink_asset_title": "Usuń powiązanie",
      "ticket_assets.unreachable": "Nieosiągalny",
      "ticket_assets.version_col": "Wersja",
      "ticket_assets.virtualization_label": "Wirtualizacja:",
      "ticket_assets.waiting_agent_response": "Oczekiwanie na odpowiedź agenta...",
      "ticket_assets.waiting_agent_timeout": "Przekroczono limit czasu: agent nie odpowiedział na czas.",
      "ticket_assets.zabbix_live_status": "Status Zabbix na żywo",
      "ticket_created": "Utworzono zgłoszenie",
      "ticket_detail.achtung_ueberschneidungskollisionen_ci_abhae": "Uwaga: wykryto nakładające się terminy (zależności CI)!",
      "ticket_detail.aktivitaeten": "Aktywności",
      "ticket_detail.aktivitaets_verlauf": "Historia aktywności",
      "ticket_detail.als_diesen_kunden_im_portal_anmelden": "Zaloguj się w portalu jako ten klient",
      "ticket_detail.anhaenge": "Załączniki",
      "ticket_detail.begruendung_kommentare": "Uzasadnienie / komentarze",
      "ticket_detail.bekannter_fehler_workaround_verfuegbar": "Znany błąd — dostępne obejście",
      "ticket_detail.cab_hat_die_aenderung_abgelehnt": "CAB odrzucił zmianę",
      "ticket_detail.change_advisory_board_cab_stimmen": "Głosy Change Advisory Board (CAB)",
      "ticket_detail.das_ticket_existiert_nicht_oder_wurde_geloes": "To zgłoszenie nie istnieje lub zostało usunięte.",
      "ticket_detail.der_status_kann_erst_auf_in_bearbeitung_oder": "Status można ustawić na „W trakcie” lub „Rozwiązane” dopiero po uzyskaniu zgody większości CAB.",
      "ticket_detail.detaillierte_schritte_zur_durchfuehrung": "Szczegółowe kroki realizacji...",
      "ticket_detail.es_wurde_noch_kein_change_plan_fuer_dieses_t": "Dla tego zgłoszenia nie utworzono jeszcze planu zmiany.",
      "ticket_detail.es_wurden_andere_aktive_tickets_auf_denselbe": "W tym samym okresie zaplanowano inne aktywne zgłoszenia dotyczące tych samych lub zależnych zasobów CMDB:",
      "ticket_detail.extrahierte_daten": "Wyodrębnione dane",
      "ticket_detail.geplanter_start_wartungsfenster": "Planowany start (okno serwisowe)",
      "ticket_detail.geplantes_ende": "Planowane zakończenie",
      "ticket_detail.geplantes_wartungsfenster": "Planowane okno serwisowe:",
      "ticket_detail.hinzufuegen": "Dodaj",
      "ticket_detail.keine_aktivitaeten_vorhanden": "Brak aktywności",
      "ticket_detail.keine_anhaenge_vorhanden": "Brak załączników",
      "ticket_detail.keine_kategorie": "Brak kategorii",
      "ticket_detail.kommentar_zur_entscheidung_optional": "Komentarz do decyzji (opcjonalnie)...",
      "ticket_detail.loeschen": "Usuń",
      "ticket_detail.niemand_zugewiesen": "Nikt nie przypisany",
      "ticket_detail.noch_keine_stimmen_abgegeben": "Nie oddano jeszcze żadnych głosów.",
      "ticket_detail.noch_keine_zeit_erfasst": "Nie zarejestrowano jeszcze czasu",
      "ticket_detail.nur_fuer_mitarbeiter_sichtbar": "Widoczne tylko dla pracowników",
      "ticket_detail.prioritaet": "Priorytet",
      "ticket_detail.sprachnotizen_in_administration_ki_einstellu": "Włącz notatki głosowe w Administracja → Ustawienia AI.",
      "ticket_detail.sprachnotizen_nicht_aktiv": "Notatki głosowe nieaktywne",
      "ticket_detail.stimme_uebermitteln": "Prześlij głos",
      "ticket_detail.tag_entfernen": "Usuń tag",
      "ticket_detail.tag_hinzufuegen": "Dodaj tag…",
      "ticket_detail.tag_hinzufuegen_2": "Dodaj tag",
      "ticket_detail.ticket_nicht_gefunden": "Nie znaleziono zgłoszenia",
      "ticket_detail.ticket_wird_geladen": "Wczytywanie zgłoszenia...",
      "ticket_detail.timer_laeuft_fuer_anderes_ticket": "Licznik działa dla innego zgłoszenia",
      "ticket_detail.timer_starten": "Uruchom licznik",
      "ticket_detail.timer_stoppen": "Zatrzymaj licznik",
      "ticket_detail.uebersicht": "Przegląd",
      "ticket_detail.veroeffentlicht": "Opublikowano",
      "ticket_detail.was_wurde_erledigt": "Co zostało zrobione?",
      "ticket_detail.welches_risiko_besteht_fuer_den_betrieb": "Jakie jest ryzyko dla działania operacyjnego?",
      "ticket_detail.wie_machen_wir_aenderungen_rueckgaengig": "Jak cofniemy zmiany?",
      "ticket_detail.wie_wird_die_funktion_verifiziert": "Jak zostanie zweryfikowane działanie?",
      "ticket_detail.zeiteintraege": "Wpisy czasu",
      "ticket_detail.zugewiesen_an": "Przypisane do",
      "ticket_detail.zugewiesen_an_2": "Przypisane do",
      "ticket_detail.zurueck_zur_uebersicht": "Powrót do przeglądu",
      "ticket_detail.zustimmung_des_change_advisory_boards_cab_zw": "Zgoda Change Advisory Board (CAB) bezwzględnie wymagana",
      "ticket_filter_active_label": "Filter aktiv",
      "ticket_inventory_kpis": "Kennzahlen & Arbeitslast",
      "ticket_properties_title": "Zgłoszenie",
      "ticket_relations": "Verknüpfte Tickets",
      "ticket_view_search_label": "Diese Ticketansicht durchsuchen",
      "tickets": "Zgłoszenia",
      "tickets_exist_hint": "Insgesamt sind {{count}} Tickets vorhanden.",
      "tickets_near_sla_breach": "Zgłoszenia bliskie naruszenia SLA",
      "tickets_plural": "{{count}} zgłoszeń",
      "tickets_ratio_label": "{{count}} z {{total}} zgłoszeń",
      "tickets_selected": "Wybrano {{count}} zgłoszeń",
      "tickets_without_assignee": "Zgłoszenia bez przypisanego agenta",
      "time_logged": "Zarejestrowany czas: {{time}}",
      "time_minutes": "Zeit in Minuten",
      "title": "Tytuł",
      "to_reply_composer": "Do odpowiedzi (Composer)",
      "today_due": "Na dzisiaj",
      "toggle_design_mode": "Przełącz motyw",
      "toggle_favorite": "Przełącz ulubione",
      "tracked_hours": "{{hours}} godz.",
      "tracked_hours_min": "{{hours}} godz. {{minutes}} min.",
      "tracked_min": "{{minutes}} min.",
      "tracked_time": "Zarejestrowany czas",
      "unassigned": "Nieprzypisane",
      "unlink_asset": "Odlinkuj",
      "unread": "Nieprzeczytane",
      "update": "Aktualizuj",
      "updated_at": "Zaktualizowano",
      "urgent": "Pilne",
      "user_profile_logout": "Profil użytkownika i wylogowanie",
      "vat_id": "REGON",
      "views": "Widoki",
      "voice_notes_admin_hint": "Notatki głosowe: Włącz 'Notatki głosowe' w Administracja → Ustawienia SI.",
      "voice_notes_enable_info": "Włącz notatki głosowe w Administracja → Ustawienia SI (przełącznik 'Notatki głosowe').",
      "voice_notes_not_active": "Notatki głosowe nieaktywne",
      "website": "Strona internetowa",
      "widget_critical_tickets": "Zgłoszenia krytyczne (Pilne)",
      "widget_group_analytics_team": "Analizy i zespół",
      "widget_group_overview_performance": "Przegląd i wydajność",
      "widget_group_volume_trends": "Wolumen i trendy",
      "widget_my_open_tickets": "Moje otwarte zgłoszenia",
      "widget_performance_times": "Czasy wydajności i wysiłek",
      "widget_priority_chart": "Rozkład priorytetów",
      "widget_sla_compliance": "Zgodność z SLA i ryzyko",
      "widget_status_chart": "Rozkład statusów zgłoszeń",
      "widget_team_presence": "Obecność zespołu i aktywność",
      "widget_ticket_trends": "Trendy zgłoszeń i wolumen",
      "widget_top_customers": "Najlepsi klienci według zgłoszeń",
      "zip_code": "Kod pocztowy"
    }
  },
  "nl": {
    "translation": {
      "access_denied": "Toegang geweigerd",
      "access_denied_desc": "U hebt agent- of administratorrechten nodig.",
      "actions": "Acties",
      "activate_dark_mode": "Donker thema activeren",
      "activate_light_mode": "Licht thema activeren",
      "active": "Actief",
      "active_filters": "Aktive Filter",
      "active_open_assignments": "Actieve, openstaande toewijzingen",
      "activity_optional": "Activiteit (optioneel)",
      "admin": "Admin",
      "admin_dashboard.administrative_berechtigungen": "Administratieve rechten",
      "admin_dashboard.aendern": "Wijzigen",
      "admin_dashboard.agent_deaktiviert": "Agent gedeactiveerd",
      "admin_dashboard.agent_erstellt": "Agent gemaakt",
      "admin_dashboard.agent_gespeichert": "Agent opgeslagen",
      "admin_dashboard.agent_ohne_zuordnung_hinweis": "Zonder toewijzing ziet deze agent {{umfang}} klanten. Zodra ten minste één klant is toegewezen, is de agent beperkt tot die klanten — tickets, rapporten en assets.",
      "admin_dashboard.agenten_in_der_kundenkonsole": "Agenten in de klantconsole",
      "admin_dashboard.aktuelles_passwort": "Huidig wachtwoord",
      "admin_dashboard.alle_eingehenden_befehle_wurden_bereits_vera": "Alle binnenkomende opdrachten zijn al verwerkt of vrijgegeven.",
      "admin_dashboard.alle_kunden": "Alle klanten",
      "admin_dashboard.als_hauptkategorie_erstellen": "Als hoofdcategorie maken",
      "admin_dashboard.api_token_hinweis": "Maak zo nodig vooraf een API-token aan op het tabblad {{reiter}} met de scope {{scope}}.",
      "admin_dashboard.aufloesungszeit": "Oplostijd *",
      "admin_dashboard.basic_auth_benutzername_passwort": "Basic Auth (gebruikersnaam/wachtwoord)",
      "admin_dashboard.bei_prefix_u00c4nderung_werden_alle_bestehen": "Bij wijziging van het prefix worden alle bestaande tickets automatisch hernoemd.",
      "admin_dashboard.benoetigte_berechtigung": "Vereist recht:",
      "admin_dashboard.bestaetigen": "Bevestigen",
      "admin_dashboard.bezeichnung_positionszeile": "Omschrijving factuurregel",
      "admin_dashboard.bitte_kunde_waehlen": "Selecteer een klant...",
      "admin_dashboard.bitte_kunde_waehlen_2": "Selecteer een klant...",
      "admin_dashboard.definieren_sie_hauptkategorien_und_bis_zu_zw": "Definieer hoofdcategorieën en maximaal twee niveaus subcategorieën. Deze worden bij het maken van een ticket als keuze aangeboden.",
      "admin_dashboard.definiert_die_standard_reihenfolge_der_queue": "Bepaalt de standaardvolgorde van de queues in de agent-zijbalk.",
      "admin_dashboard.details_anzeigen": "Details tonen",
      "admin_dashboard.details_anzeigen_2": "Details tonen",
      "admin_dashboard.die_smtp_einstellungen_fuer_den_e_mail_versa": "De SMTP-instellingen voor het verzenden van e-mail worden nu centraal onder",
      "admin_dashboard.e_mail_versand_smtp_wird_unter_e_mail_einste": "E-mailverzending (SMTP) wordt geconfigureerd onder E-mailinstellingen",
      "admin_dashboard.eine_sicherheitsgruppe_legt_fest_welche_kons": "Een beveiligingsgroep bepaalt welke consolemodules een agent ziet. “Volledige toegang” = alle modules. Adminrechten staan hier los van.",
      "admin_dashboard.einstellungen_speichern": "Instellingen opslaan",
      "admin_dashboard.eintraege": "Items",
      "admin_dashboard.endgeraet": "Apparaat",
      "admin_dashboard.endgueltig_loeschen": "Endgültig löschen",
      "admin_dashboard.entwurfsrechnung_aus_zeiteintraegen": "Conceptfactuur uit tijdregistraties",
      "admin_dashboard.erstellen_sie_ihre_erste_automatisierung": "Maak uw eerste automatisering",
      "admin_dashboard.erstellen_sie_oben_ihre_erste_hauptkategorie": "Maak hierboven uw eerste hoofdcategorie",
      "admin_dashboard.externer_mitarbeiter_dienstleister": "Externe medewerker / dienstverlener",
      "admin_dashboard.fehler_beim_deaktivieren": "Fout bij deactiveren",
      "admin_dashboard.fehler_beim_deaktivieren_2": "Fout bij deactiveren",
      "admin_dashboard.fehler_beim_deaktivieren_3": "Fout bij deactiveren",
      "admin_dashboard.fehler_beim_loeschen": "Fout bij verwijderen",
      "admin_dashboard.firma_adresse_kontakt_steuernummern_in_der_u": "Bedrijf, adres, contact en fiscale nummers zijn in het overzicht te bewerken. Klanten deactiveren blijft voorbehouden aan de administrator.",
      "admin_dashboard.fuer_entra_id_benoetigen_sie_eine_app_regist": "Voor Entra ID hebt u een app-registratie in Azure Portal met de machtiging Mail.Read nodig.",
      "admin_dashboard.geloescht": "Verwijderd",
      "admin_dashboard.geloescht_2": "Verwijderd",
      "admin_dashboard.installationspaket_herunterladen": "Installatiepakket downloaden",
      "admin_dashboard.kategorie_aktualisiert": "Categorie bijgewerkt",
      "admin_dashboard.kategorie_erstellt": "Categorie gemaakt",
      "admin_dashboard.kategorie_geloescht": "Categorie verwijderd",
      "admin_dashboard.keine_abteilung": "Geen afdeling",
      "admin_dashboard.keine_ausstehenden_befehls_freigaben_vorhand": "Er zijn geen openstaande opdrachtgoedkeuringen.",
      "admin_dashboard.keine_workflows_konfiguriert": "Geen workflows geconfigureerd",
      "admin_dashboard.keine_zuordnung_dieser_agent_sieht_alle_kund": "Geen toewijzing — deze agent ziet alle klanten.",
      "admin_dashboard.konfigurieren_sie_sprachmodelle_auto_respons": "Configureer taalmodellen, auto-response-prompts en systeemsjablonen",
      "admin_dashboard.kunde_auswaehlen": "Klant selecteren *",
      "admin_dashboard.kunde_deaktiviert": "Klant gedeactiveerd",
      "admin_dashboard.kunde_erstellt": "Klant gemaakt",
      "admin_dashboard.kunde_geloescht": "Kunde „{{firma}}\" wurde endgültig gelöscht",
      "admin_dashboard.kunde_gespeichert": "Klant opgeslagen",
      "admin_dashboard.kunde_waehlen": "Klant kiezen…",
      "admin_dashboard.kundenzuordnung_verwalten": "Klanttoewijzing beheren",
      "admin_dashboard.laden_sie_ein_fertiges_zip_archiv_fuer": "Download een kant-en-klaar ZIP-archief voor",
      "admin_dashboard.laedt": "Laden…",
      "admin_dashboard.laengengrad": "Lengtegraad",
      "admin_dashboard.legen_sie_fest_welche_daten_der_installierte": "Bepaal welke gegevens de geïnstalleerde agent verzamelt en configureer de optionele agentloze netwerkscanner (subnet-ping).",
      "admin_dashboard.letzte_exporte": "Laatste exports",
      "admin_dashboard.lexoffice_artikel_uuid_optional_dienstleistu": "Lexoffice artikel-UUID (optioneel, dienstverlening)",
      "admin_dashboard.lexoffice_deaktiviert_hinweis": "De LexOffice-integratie is momenteel uitgeschakeld. U kunt pas factuurconcepten maken zodra u de integratie onder {{bereich}} inschakelt en configureert.",
      "admin_dashboard.lexoffice_einstellungen_konnten_nicht_gelade": "Lexoffice-instellingen konden niet worden geladen (migratie uitvoeren / server opnieuw starten).",
      "admin_dashboard.loeschen": "Verwijderen",
      "admin_dashboard.loeschen_2": "Verwijderen",
      "admin_dashboard.mailbox_empfang_imap_oauth_wird_unter_postfa": "Mailboxontvangst (IMAP/OAuth) wordt geconfigureerd onder Mailboxen",
      "admin_dashboard.mailbox_speichern": "Mailbox opslaan",
      "admin_dashboard.microsoft_graph_api": "Microsoft Graph API",
      "admin_dashboard.mit_einem_frisch_generierten_api_schluessel": "met een nieuw gegenereerde API-sleutel en een",
      "admin_dashboard.mitarbeiter_deaktiviert": "Medewerker gedeactiveerd",
      "admin_dashboard.mitarbeiter_erstellt": "Medewerker gemaakt",
      "admin_dashboard.mitarbeiter_gespeichert": "Medewerker opgeslagen",
      "admin_dashboard.mloffice_gefuehrt": "Stammdaten werden von MLOffice geführt",
      "admin_dashboard.mloffice_geloest": "Mit MLOffice verknüpft — Abgleich derzeit gelöst",
      "admin_dashboard.module_assets": "Assets",
      "admin_dashboard.module_calendar": "Agenda",
      "admin_dashboard.module_customers": "Klanten",
      "admin_dashboard.module_knowledge": "Kennisbank",
      "admin_dashboard.module_licenses": "Licenties",
      "admin_dashboard.module_problems": "Problemen",
      "admin_dashboard.module_reports": "Rapporten",
      "admin_dashboard.module_tickets": "Tickets",
      "admin_dashboard.nach_kunde_filtern": "Filteren op klant",
      "admin_dashboard.neue_mailbox_konfiguration": "Nieuwe mailboxconfiguratie",
      "admin_dashboard.neuer_workflow": "Nieuwe workflow",
      "admin_dashboard.neues_passwort": "Nieuw wachtwoord",
      "admin_dashboard.nicht_abrechenbar": "Niet factureerbaar",
      "admin_dashboard.noch_keine_kategorien_definiert": "Nog geen categorieën gedefinieerd",
      "admin_dashboard.noch_keine_zeiteintraege_vorhanden": "Nog geen tijdregistraties aanwezig",
      "admin_dashboard.nur_abrechenbare_eintraege_ohne_vorherigen_l": "Alleen factureerbare registraties zonder eerdere Lexoffice-export; optioneel filteren op contract-ID.",
      "admin_dashboard.optionale_beschreibung_des_sla_umfangs": "Optionele beschrijving van de SLA-omvang",
      "admin_dashboard.passwort_aendern": "Wachtwoord wijzigen",
      "admin_dashboard.primaer": "Primair",
      "admin_dashboard.prioritaet_geaendert": "• Prioriteit gewijzigd",
      "admin_dashboard.pruefinterval_minuten": "Controle-interval (minuten)",
      "admin_dashboard.refresh_token": "Refresh Token",
      "admin_dashboard.sie_koennen_den_agenten_auch_manuell_registr": "U kunt de agent ook handmatig registreren. Gebruik daarvoor de volgende syntaxis op de client (vereist administratorrechten):",
      "admin_dashboard.standardmaessig_duerfen_agenten_kunden_stamm": "Standaard mogen agenten klantstamgegevens alleen lezen en klantdocumenten alleen inzien. Hier kunt u uitgebreide schrijfrechten per instelling activeren.",
      "admin_dashboard.status_geaendert": "• Status gewijzigd",
      "admin_dashboard.stundensatz_ueberschreiben_optional": "Uurtarief overschrijven (optioneel)",
      "admin_dashboard.tarif_erweitern": "Tarief uitbreiden",
      "admin_dashboard.ticket_id_format_und_admin_passwort_koennen": "Ticket-ID-formaat en Admin-wachtwoord kunnen hier worden geconfigureerd",
      "admin_dashboard.top_kunden_nach_ticketvolumen": "Topklanten op ticketvolume",
      "admin_dashboard.uebergeordnete_kategorie": "Bovenliggende categorie",
      "admin_dashboard.unterkategorie_hinzufuegen": "Subcategorie toevoegen",
      "admin_dashboard.upload_metadaten_bearbeiten_und_loeschen_von": "Uploaden, metadata bewerken en bestanden verwijderen op het klanttabblad “Documenten”.",
      "admin_dashboard.verfuegbare_trigger": "Beschikbare triggers",
      "admin_dashboard.verwalten_und_genehmigen_sie_ausstehende_adm": "Beheer openstaande administratieve opdrachten van andere administrators en keur ze goed voordat ze op de clientapparaten worden uitgevoerd.",
      "admin_dashboard.voller_zugriff_alle_module": "Volledige toegang (alle modules)",
      "admin_dashboard.vorkonfiguriertes_paket_zip": "Voorgeconfigureerd pakket (.zip)",
      "admin_dashboard.was_bedeuten_die_gruppen": "Wat betekenen de groepen?",
      "admin_dashboard.workflow_automatisierungen": "Workflow-automatiseringen",
      "admin_dashboard.z_b_hauptsitz_koeln": "bijv. hoofdkantoor Amsterdam",
      "admin_dashboard.zeit_standardmaessig_abrechenbar": "Tijd standaard factureerbaar",
      "admin_dashboard.zeitbuchung_bei_ticket_schliessung_erforderl": "Tijdregistratie verplicht bij het sluiten van een ticket",
      "admin_dashboard.zeitbuchungen_erscheinen_hier_sobald_agenten": "Tijdregistraties verschijnen hier zodra agenten tijd op tickets registreren.",
      "admin_dashboard.zeiteintraege": "Tijdregistraties",
      "admin_dashboard.zeiterfassung_aktivieren": "Tijdregistratie activeren",
      "admin_dashboard.zeiterfassung_einstellungen": "Instellingen tijdregistratie",
      "admin_dashboard.zugriff_verweigert": "Toegang geweigerd",
      "admin_dashboard.zugriff_verweigert_text": "U beschikt niet over de administratieve rechten die nodig zijn om het gedeelte {{bereich}} te bekijken of te beheren.",
      "admin_dashboard.zuordnung_entfernen": "Toewijzing verwijderen",
      "admin_dashboard.zusaetzliche_admin_rechte": "Aanvullende adminrechten",
      "admin_default": "Admin-standaard",
      "admin_only_change": "(alleen een beheerder kan de toewijzing wijzigen.)",
      "admin_overview.aktive_warnungen_risiken": "Actieve waarschuwingen & risico's",
      "admin_overview.alles_in_ordnung": "Alles in orde",
      "admin_overview.datenbank_engine": "Database-engine",
      "admin_overview.einstellungen_filtern": "Instellingen filteren...",
      "admin_overview.hinweis_fuer_administratoren": "Opmerking voor administrators:",
      "admin_overview.keine_ergebnisse_gefunden": "Geen resultaten gevonden",
      "admin_overview.keine_warnungen_oder_kritischen_meldungen": "Geen waarschuwingen of kritieke meldingen.",
      "admin_overview.lade_dashboard_daten": "Dashboardgegevens laden...",
      "admin_overview.system_status": "Systeemstatus",
      "admin_overview.upgrade_erforderlich": "Upgrade vereist",
      "admin_overview.upgrade_erforderlich_2": "Upgrade vereist",
      "admin_overview.versuchen_sie_es_mit_einem_anderen_suchbegri": "Probeer een andere zoekterm.",
      "admin_overview.zurueck_zum_agent_dashboard": "Terug naar het agent-dashboard",
      "admin_view": "Adminweergave",
      "administration": "Administratie",
      "administrator": "Beheerder",
      "agent": "Agent",
      "agent_available": "Beschikbaar",
      "agent_console": "Agentenconsole",
      "agent_console.alle_als_gelesen": "Alles als gelezen",
      "agent_console.anhaenge": "Bijlagen",
      "agent_console.anhaenge_zum_eroeffnungsbeitrag": "Bijlagen bij het openingsbericht",
      "agent_console.back_to_ticket_list": "Zurück zur Liste",
      "agent_console.beschreiben_sie_hier_details_die_dem_partner": "Beschrijf hier details die aan de partner moeten worden doorgegeven...",
      "agent_console.bitte_waehlen": "-- Maak een keuze --",
      "agent_console.detailansicht_schliessen": "Detailweergave sluiten",
      "agent_console.erneut_oeffnen": "Opnieuw openen",
      "agent_console.hinweis_der_partner_erhaelt_eine_benachricht": "Let op: de partner ontvangt een notificatie-e-mail met uw gegevens en een beveiligde link om het ticket te behandelen.",
      "agent_console.interner_chat": "Interne chat",
      "agent_console.interner_chat_2": "Interne chat",
      "agent_console.keine_benachrichtigungen": "Geen meldingen",
      "agent_console.language_selection": "Taalkeuze",
      "agent_console.loesen": "Oplossen",
      "agent_console.mir_zuweisen": "Aan mij toewijzen",
      "agent_console.nachricht_notiz_fuer_den_partner_optional": "Bericht / notitie voor de partner (optioneel)",
      "agent_console.neues_ticket": "Nieuw ticket",
      "agent_console.neues_ticket_2": "Nieuw ticket",
      "agent_console.partner_dienstleister_waehlen": "Partner-dienstverlener kiezen",
      "agent_console.schliessen": "Sluiten",
      "agent_console.schliessen_2": "Sluiten",
      "agent_console.schliessungsgrund": "Reden van sluiting:",
      "agent_console.schnellsuche_oeffnen": "Snelzoeken openen",
      "agent_console.sie_benoetigen_agent_oder_admin_rechte": "U hebt agent- of adminrechten nodig.",
      "agent_console.tastenkuerzel": "Sneltoetsen",
      "agent_console.ticket_erstellt": "Ticket gemaakt",
      "agent_console.ticket_schliessen": "Ticket sluiten",
      "agent_console.zugriff_verweigert": "Toegang geweigerd",
      "agent_console.zur_antwort_composer": "Naar het antwoord (composer)",
      "agent_console.zur_antwort_scrollen": "Naar het antwoord scrollen",
      "agent_console.zusammenfuehren": "Zusammenführen",
      "agent_console.zuweisung_entfernen": "Toewijzing verwijderen",
      "ai": "AI",
      "ai_analysis_running": "Analyse wordt uitgevoerd...",
      "ai_assistance": "AI-assistentie",
      "ai_confidence_label": "{{pct}}% betrouwbaarheid",
      "ai_context_title": "KI-Kontext & Prognosen",
      "ai_generate_summary": "Samenvatting generieren",
      "ai_key_points": "Belangrijkste punten",
      "ai_next_steps": "Volgende stappen",
      "ai_requested_action": "Gevraagde actie",
      "ai_risks": "Risico's",
      "ai_solution_assistant_title": "AI-oplossingsassistent",
      "ai_stale": "Verouderd",
      "ai_summary_title": "AI-samenvatting",
      "all": "Alle",
      "all_active_tickets": "Alle actieve tickets",
      "all_categories": "Alle categorieën",
      "all_customers": "Alle klanten",
      "all_deadlines_ok": "Alle deadlines vallen binnen het tijdsbestek.",
      "all_open": "Alle openstaande",
      "all_tickets": "Alle tickets",
      "allgemein.abbrechen": "Abbrechen",
      "allgemein.schliessen": "Schließen",
      "analyze_again": "Opnieuw analyseren",
      "article": "Artikel",
      "article_ai_generate": "Artikel maken met AI",
      "article_ai_generate_btn": "Artikel genereren",
      "article_ai_generate_desc": "Beschrijf het onderwerp en de AI genereert een concept",
      "article_ai_improve": "Tekst verbeteren",
      "article_ai_keywords": "Trefwoorden (optioneel)",
      "article_ai_keywords_placeholder": "bijv. Windows 11, OpenVPN, certificaat",
      "article_ai_language": "Taal",
      "article_ai_len_long": "Lang / uitgebreid",
      "article_ai_len_medium": "Gemiddeld",
      "article_ai_len_short": "Kort",
      "article_ai_length": "Lengte",
      "article_ai_style": "Taalstijl",
      "article_ai_style_balanced": "Evenwichtig",
      "article_ai_style_enduser": "Eindgebruiker (stap voor stap)",
      "article_ai_style_formal": "Formeel",
      "article_ai_style_simple": "Eenvoudig / goed te begrijpen",
      "article_ai_style_technical": "Technisch (IT-professionals)",
      "article_ai_summarize": "Samenvatting genereren",
      "article_ai_topic": "Onderwerp *",
      "article_ai_topic_placeholder": "bijv. VPN-verbinding instellen op Windows",
      "article_all_customers": "Alle klanten",
      "article_all_statuses": "Alle statussen",
      "article_all_visible": "Zichtbaar voor alle klanten",
      "article_archived": "Gearchiveerd",
      "article_category": "Categorie",
      "article_content_placeholder": "Begin hier met het schrijven van uw artikel...",
      "article_create_first": "Eerste artikel maken",
      "article_create_first_desc": "Maak uw eerste kennisartikel om informatie te delen met uw team.",
      "article_create_with_ai": "Maken met AI",
      "article_delete_confirm": "Weet u zeker dat u dit artikel wilt verwijderen?",
      "article_draft": "Ontwerp",
      "article_excerpt_placeholder": "Een korte samenvatting van het artikel...",
      "article_manage": "Artikelen beheren",
      "article_new": "Nieuw artikel",
      "article_no_articles": "Nog geen artikelen beschikbaar",
      "article_no_categories_desc": "Geen categorieën beschikbaar. Maak ze aan in het beheerdersgedeelte.",
      "article_no_category": "Geen categorie",
      "article_not_found": "Geen artikelen gevonden",
      "article_not_found_desc": "Er zijn geen artikelen gevonden voor uw zoekopdracht.",
      "article_only_visible": "Alleen zichtbaar voor {{name}}",
      "article_pinned": "Vastgepind",
      "article_pinned_desc": "Wordt bovenaan de lijst weergegeven",
      "article_plural": "Alle artikelen",
      "article_published": "Gepubliceerd",
      "article_search": "Artikelen zoeken...",
      "article_views": "weergaven",
      "article_visibility": "Klantzichtbaarheid",
      "article_write_content": "Artikelinhoud",
      "article_write_excerpt": "Samenvatting",
      "article_write_title": "Voer artikeltitel in...",
      "asset.discovery_agents": "Discovery-agents",
      "asset.event_logs": "Gebeurtenislogboeken",
      "asset.general": "Algemeen",
      "asset.hardware_wmi": "Hardware (WMI)",
      "asset.history_changes": "Geschiedenis & Wijzigingen",
      "asset.more": "Meer",
      "asset.network": "Netwerk",
      "asset.network_discovery": "Netwerkontdekking",
      "asset.printers": "Printers",
      "asset.processes": "Processen",
      "asset.relationships": "Relaties",
      "asset.remote_control": "Afstandsbediening",
      "asset.remote_terminal": "Remote Terminal",
      "asset.scan_history": "Scangeschiedenis",
      "asset.security": "Beveiliging",
      "asset.services": "Diensten",
      "asset.software_catalog": "Softwarecatalogus (SAM)",
      "asset.software_count": "Software",
      "asset.system_assets": "Systeemassets",
      "asset.updates": "Updates",
      "asset_": "asset_",
      "asset_active": "Actief",
      "asset_agent.offline": "Offline",
      "asset_agent.online_active": "Online (actief)",
      "asset_agent.recently_active": "Onlangs actief",
      "asset_inactive": "Inactief",
      "asset_maintenance": "Onderhoud",
      "asset_management": "Asset Management",
      "asset_panel.confirm_delete_asset": "\"{{name}}\" definitief verwijderen?",
      "asset_panel.confirm_delete_category": "Categorie \"{{name}}\" verwijderen? Assets worden ontkoppeld.",
      "asset_panel.edit_asset": "Asset bewerken",
      "asset_panel.edit_category": "Categorie bewerken",
      "asset_panel.import_as_managed_btn": "Als managed asset importeren",
      "asset_panel.import_device": "Apparaat importeren",
      "asset_panel.new_asset": "Nieuw asset",
      "asset_panel.new_category": "Nieuwe categorie",
      "asset_panel.print_asset_tag": "Assetlabel afdrukken",
      "asset_panel.print_now_btn": "Nu afdrukken",
      "asset_panel.toast.agent_no_response_hint": "De agent heeft niet op tijd gereageerd.",
      "asset_panel.toast.assets_imported": "{{count}} asset(s) geïmporteerd",
      "asset_panel.toast.command_queued": "Opdracht succesvol in de wachtrij geplaatst",
      "asset_panel.toast.create_problem_error": "Fout bij het maken van het probleemticket",
      "asset_panel.toast.csv_import_failed": "CSV-import mislukt",
      "asset_panel.toast.device_ignored": "Apparaat succesvol genegeerd",
      "asset_panel.toast.device_imported": "Apparaat succesvol geïmporteerd in beheerde assets",
      "asset_panel.toast.ignore_device_error": "Fout bij het negeren van het apparaat",
      "asset_panel.toast.import_device_error": "Fout bij het importeren van het apparaat",
      "asset_panel.toast.import_with_errors": "Import afgerond met fouten",
      "asset_panel.toast.itil_correlation_error": "Fout bij de ITIL-probleemcorrelatie",
      "asset_panel.toast.less_than_3_tickets": "Minder dan 3 tickets in de afgelopen 30 dagen.",
      "asset_panel.toast.manual_scan_error": "Fout bij de handmatige scan",
      "asset_panel.toast.problem_ticket_created": "Probleemticket gemaakt en incidenten gekoppeld!",
      "asset_panel.toast.queue_command_error": "Opdracht kon niet in de wachtrij worden geplaatst",
      "asset_panel.toast.request_scan_error": "Fout bij het aanvragen van de scan",
      "asset_panel.toast.scan_completed": "Scan succesvol afgerond",
      "asset_panel.toast.scan_failed": "Scan mislukt",
      "asset_panel.toast.scan_requested": "{{type}} aangevraagd",
      "asset_panel.toast.template_downloaded": "Sjabloon „asset-import-vorlage.csv“ gedownload",
      "asset_panel.toast.template_load_error": "Sjabloon kon niet worden geladen",
      "asset_remote_client_disconnected": "Client verbinding verbroken",
      "asset_remote_client_disconnected_desc": "De gebruiker op het clientapparaat heeft de sessie voor hulp op afstand beëindigd.",
      "asset_remote_closed_desc": "De sessie voor hulp op afstand is succesvol beëindigd.",
      "asset_remote_code_placeholder": "bijv. 123 456",
      "asset_remote_conn_disconnected": "Verbinding verbroken",
      "asset_remote_conn_failed": "Verbinding met de externe server mislukt",
      "asset_remote_conn_rejected": "Verbinding geweigerd",
      "asset_remote_consent_hint": "Er wordt een toestemmingsvenster weergegeven op het scherm van de klant. Vraag de klant om akkoord te gaan.",
      "asset_remote_disconnect": "Verbinding verbreken",
      "asset_remote_enter_code_hint": "Voer de 6-cijferige toegangscode in die op het scherm van de gebruiker wordt weergegeven:",
      "asset_remote_invalid_code": "Onjuiste toegangscode",
      "asset_remote_live_focus": "LIVE · Focus voor toetsenbordinvoer",
      "asset_remote_loading_screen": "Live scherm laden...",
      "asset_remote_preparing": "Verbinding voorbereiden...",
      "asset_remote_protocol2_code_label": "Zwölfstelliger Zugangscode",
      "asset_remote_protocol2_code_placeholder": "ABCD EFGH 2345",
      "asset_remote_protocol2_enter_code_hint": "Geben Sie den zwölfstelligen Zugangscode vom Bildschirm des Benutzers ein:",
      "asset_remote_protocol2_request_desc": "Sendet eine Verbindungsanfrage an den Client-Rechner. Der Benutzer muss zustimmen und den zwölfstelligen Zugangscode übermitteln.",
      "asset_remote_rejected_desc": "Het verbindingsverzoek is geweigerd door de gebruiker op het clientapparaat.",
      "asset_remote_req": "Sessie op afstand aanvragen",
      "asset_remote_request_again": "Opnieuw aanvragen",
      "asset_remote_request_desc": "Stuurt een verbindingsverzoek naar de clientcomputer. De gebruiker moet toestemming geven en een 6-cijferige toegangscode doorgeven.",
      "asset_remote_request_title": "Hulp op afstand aanvragen",
      "asset_remote_start_error": "Kan sessie voor hulp op afstand niet starten",
      "asset_remote_start_new": "Nieuwe sessie starten",
      "asset_remote_support": "Ingebouwde hulp op afstand",
      "asset_remote_support_desc": "Directe schermovername zonder externe software (TeamViewer/RustDesk).",
      "asset_remote_user_consented": "Gebruiker heeft toestemming gegeven",
      "asset_remote_verifying_code": "Toegangscode controleren...",
      "asset_remote_waiting_consent": "Wachten op toestemming van gebruiker...",
      "asset_retired": "Uitgefaseerd",
      "assets": "Assets",
      "assign_to": "Toewijzen...",
      "assign_to_me": "Aan mij toewijzen",
      "assigned_agents": "Toegewezen agenten",
      "assigned_to": "Toegewezen aan",
      "at_risk_title": "Risico (SLA-waarschuwing):",
      "attach_local_file": "Lokale bijlage toevoegen",
      "attachments": "Bijlagen",
      "attachments_tools": "Bijlagen & Tools",
      "attendees_emails": "Deelnemers (e-mails, door komma's gescheiden)",
      "automation": "Automatisering",
      "avg_first_response": "Eerste reactietijd",
      "avg_resolution": "Gemiddelde oplossingstijd",
      "billable": "Factureerbaar",
      "billable_time": "Factureerbaar: {{time}}",
      "book_on_send": "Boeken bij verzenden",
      "book_time_with_reply": "Tijd boeken met antwoord",
      "calendar": "Agenda",
      "calendar_enter_title_warning": "Voer een titel in.",
      "calendar_event_attendees": "E-mails van deelnemers (optioneel, door komma's gescheiden)",
      "calendar_event_created_error": "Evenement kon niet worden aangemaakt.",
      "calendar_event_created_success": "Evenement aangemaakt.",
      "calendar_event_description": "Beschrijving (optioneel)",
      "calendar_event_title": "Titel",
      "calendar_meeting_created_error": "Vergadering kon niet worden aangemaakt.",
      "calendar_meeting_link_copied": "Vergaderlink gekopieerd naar klembord.",
      "calendar_new_event": "Nieuw evenement",
      "calendar_no_integration_or": "of",
      "calendar_no_integration_prefix": "Geen agenda- of vergaderintegratie actief. Configureer",
      "calendar_no_integration_suffix": "met actieve vergaderplanning in de integraties.",
      "calendar_only_event": "Alleen agenda-afspraak",
      "calendar_talk_meeting": "Talk-vergadering",
      "calendar_talk_room_created": "Talk-ruimte aangemaakt.",
      "calendar_teams_meeting": "Teams-vergadering",
      "calendar_teams_meeting_created": "Teams-vergadering aangemaakt.",
      "cancel": "Annuleren",
      "canned_responses": "Tekstblokken invoegen",
      "canned_responses_short": "Tekstblok",
      "categories": "Categorieën",
      "category": "Categorie",
      "change_priority": "Prioriteit wijzigen...",
      "change_status_after_send": "Na verzenden wijzigen naar",
      "change_ticket_company": "Ticket anderer Firma zuordnen",
      "change_ticket_company_warning": "Portal-Ersteller, CC, Mitarbeiter, Bearbeiter, Kategorie, SLA, Assets und laufende Timer werden für die neue Firma zurückgesetzt.",
      "characters": "tekens",
      "city": "Stad",
      "clear_selection": "Selectie wissen",
      "click_to_logout": "Klik om af te melden",
      "close": "Sluiten",
      "close_detail_view": "Detailweergave sluiten",
      "close_ticket": "Ticket sluiten",
      "closed": "Gesloten",
      "collapse": "Inklappen",
      "collapse_composer": "Editor inklappen",
      "collapse_sidebar": "Zijbalk inklappen",
      "column_assignee_name": "Toegewezene",
      "column_category_name": "Categorie",
      "column_channel": "Kanaal",
      "column_created_at": "Gemaakt",
      "column_customer_name": "Klant",
      "column_priority": "Prioriteit",
      "column_reply_count": "Reacties",
      "column_requester_name": "Aanvrager",
      "column_sla": "SLA",
      "column_status": "Status",
      "column_subject": "Onderwerp",
      "column_tags": "Tags",
      "column_ticket_number": "Nr.",
      "column_updated_at": "Bijgewerkt",
      "columns_btn": "Kolommen",
      "common.abbrechen": "Abbrechen",
      "company_name": "Bedrijfsnaam",
      "company_title": "Bedrijf",
      "compliance_rate": "Nalevingspercentage",
      "composer_internal": "Intern",
      "composer_internal_placeholder": "Interne notitie...",
      "composer_public": "Openbaar",
      "composer_public_placeholder": "Antwoord schrijven...",
      "configure_columns": "Kolommen configureren",
      "connect": "Verbinden",
      "contact_and_master_data": "Contact & Stamgegevens",
      "contact_person": "Contactpersoon",
      "contact_person_abbrev": "CP",
      "contract": "Contract",
      "contract.auto_renew": "Automatische verlenging",
      "contract.auto_renews_suffix": " (wordt automatisch verlengd)",
      "contract.back_to_overview": "Terug naar het overzicht",
      "contract.billing": "Facturatie",
      "contract.billing_model": "Facturatiemodel",
      "contract.conditions": "Voorwaarden",
      "contract.days": "{{count}} dagen",
      "contract.end_date": "Einddatum",
      "contract.expires_in_days": "Verloopt over {{count}} dagen",
      "contract.first_response": "Eerste reactie",
      "contract.hourly_rate": "Uurtarief",
      "contract.hours_quota": "Urentegoed",
      "contract.included_hours": "Inbegrepen uren",
      "contract.no_contracts": "Geen contracten aanwezig",
      "contract.no_contracts_desc": "Neem contact met ons op voor een offerte op maat",
      "contract.notice_period": "Opzegtermijn: {{count}} dagen",
      "contract.period_per": "{{count}} u / periode",
      "contract.quota_summary": "{{remaining}} resterend ({{percent}}% gebruikt)",
      "contract.remaining": "Resterend",
      "contract.resolution": "Oplossing",
      "contract.runtime": "Looptijd",
      "contract.sla_tier": "SLA",
      "contract.start_date": "Startdatum",
      "contract.status.active": "Actief",
      "contract.status.expired": "Verlopen",
      "contract.status.expiring_soon": "Verloopt binnenkort",
      "contract.status.future": "Toekomstig",
      "contract.subtitle": "Overzicht van uw actieve contracten en service level agreements",
      "contract.unlimited": "Onbepaalde tijd",
      "contract.used": "Verbruikt",
      "contracts": "Contracten",
      "copied_to_clipboard": "Naar het klembord gekopieerd",
      "country": "Land",
      "create": "Maken",
      "create_ticket.aehnliche_tickets": "Vergelijkbare tickets",
      "create_ticket.angehaengte_cloud_dateien": "Bijgevoegde cloudbestanden:",
      "create_ticket.anhaenge": "Bijlagen",
      "create_ticket.asset_verknuepfen_optional": "Asset koppelen (optioneel):",
      "create_ticket.assets_filtern": "Assets filteren:",
      "create_ticket.assets_werden_geladen": "Assets worden geladen...",
      "create_ticket.beschreiben_sie_das_problem_so_detailliert_w": "Beschrijf het probleem zo gedetailleerd mogelijk...",
      "create_ticket.betroffene_systeme_benutzer_nennen": "Noem de betrokken systemen/gebruikers",
      "create_ticket.bitte_betreff_und_beschreibung_ausfuellen": "Vul onderwerp en beschrijving in",
      "create_ticket.bitte_eine_beschreibung_angeben": "Geef een beschrijving op.",
      "create_ticket.bitte_einen_kunden_auswaehlen": "Selecteer een klant.",
      "create_ticket.bitte_hauptkategorie_waehlen": "Selecteer een hoofdcategorie...",
      "create_ticket.bitte_klassifizierung_waehlen": "Selecteer een classificatie...",
      "create_ticket.bitte_kunde_waehlen": "Selecteer een klant...",
      "create_ticket.bitte_unterkategorie_waehlen": "Selecteer een subcategorie...",
      "create_ticket.bitte_zuerst_einen_kunden_waehlen": "Selecteer eerst een klant...",
      "create_ticket.datei_hochladen": "Bestand uploaden",
      "create_ticket.datei_hochladen_2": "Bestand uploaden",
      "create_ticket.datei_zu_gross_max_10_mb": "Bestand te groot (max. 10 MB)",
      "create_ticket.dateityp_nicht_erlaubt": "Bestandstype niet toegestaan",
      "create_ticket.erste_antwort": "Eerste reactie",
      "create_ticket.fehlermeldungen_und_screenshots_beifuegen": "Voeg foutmeldingen en screenshots toe",
      "create_ticket.keine_mitarbeiter_hinterlegt": "Geen medewerkers vastgelegd",
      "create_ticket.letzte_kunden_tickets": "Laatste tickets van de klant",
      "create_ticket.loesung": "Oplossing",
      "create_ticket.neues_ticket": "Nieuw ticket",
      "create_ticket.nur_geschaeftszeiten": "Alleen kantooruren",
      "create_ticket.praeziser_betreff_hilft_bei_der_zuordnung": "Een nauwkeurig onderwerp helpt bij de toewijzing",
      "create_ticket.priority_high": "Hoog",
      "create_ticket.priority_low": "Laag",
      "create_ticket.priority_medium": "Gemiddeld",
      "create_ticket.priority_urgent": "Urgent",
      "create_ticket.schritte_zur_reproduktion_angeben": "Geef de stappen aan om het probleem te reproduceren",
      "create_ticket.stoerung": "Storing",
      "create_ticket.text_mit_ki_verbessern": "Tekst verbeteren met AI",
      "create_ticket.ticket_erstellt": "Ticket gemaakt!",
      "create_ticket.uebernehmen": "Overnemen",
      "create_ticket.ueberschrift": "Kop",
      "create_ticket.vielleicht_loest_ein_artikel_das_problem_ber": "Misschien lost een artikel het probleem al op?",
      "create_ticket.vorlage_einfuegen": "Sjabloon invoegen",
      "create_ticket.waehlen_sie_einen_kunden_aus_um_dessen_asset": "Selecteer een klant om diens assets te kunnen koppelen.",
      "create_ticket.werden_bei_erstellung_ausgeloest": "Worden bij het maken geactiveerd",
      "create_ticket.zurueck": "Terug",
      "created_at": "Gemaakt op",
      "critical_priority_sla": "Prioriteit / SLA",
      "customer": "Klant",
      "customer_assets.no_assets": "Geen assets vastgelegd voor deze klant. Met een Zabbix-host-ID of uptimemonitor op een asset verschijnen hier statusmeldingen.",
      "customer_assets.no_assets_unconfigured": "Geen assets geregistreerd. Discovery of een monitoringintegratie kan de inventarisatie automatiseren.",
      "customer_assets.no_zabbix_id": "Geen Zabbix-host-ID op het asset",
      "customer_assets.start_rd": "RustDesk starten",
      "customer_assets.start_tv": "TeamViewer starten",
      "customer_form.adresse_eingeben_um_karte_anzuzeigen": "Voer een adres in om de kaart te tonen",
      "customer_form.client_secret": "Client Secret",
      "customer_form.domain_entfernen": "Domein verwijderen",
      "customer_form.domain_hinzufuegen": "+ Domein toevoegen",
      "customer_form.domains_mit_zugeordneten_mitarbeitern_koenne": "Domeinen met toegewezen medewerkers kunnen niet worden verwijderd.",
      "customer_form.geschaeftsfuehrer": "Directeur",
      "customer_form.in_openstreetmap_oeffnen": "In OpenStreetMap openen ↗",
      "customer_form.interne_notizen_zu_diesem_kunden": "Interne notities over deze klant...",
      "customer_form.kontakt_in_lexoffice_anlegen_uuid_hier_eintr": "Contact in Lexoffice maken, UUID hier invoeren",
      "customer_form.lexoffice_kontakt_id_uuid": "Lexoffice contact-ID (UUID)",
      "customer_form.logo_kann_nach_dem_erstellen_des_kunden_hoch": "Het logo kan worden geüpload nadat de klant is gemaakt.",
      "customer_form.mitarbeiter_koennen_sich_per_microsoft_konto": "Medewerkers kunnen zich aanmelden met een Microsoft-account",
      "customer_form.mloffice_badge": "Von MLOffice verwaltet",
      "customer_form.mloffice_banner": "Dieser Kunde wird mit MLOffice abgeglichen. Stammdaten (Name, E-Mail, Telefon, Anschrift, USt-ID) werden von MLOffice verwaltet und sind hier gesperrt.",
      "customer_form.mloffice_feld_hinweis": "Dieses Feld wird von MLOffice verwaltet — Änderungen bitte dort vornehmen; sie werden automatisch übernommen.",
      "customer_form.mloffice_geloest": "Verknüpfung gelöst — die Felder sind wieder bearbeitbar.",
      "customer_form.mloffice_loesen": "Verknüpfung lösen…",
      "customer_form.mloffice_loesen_fehler": "Verknüpfung konnte nicht gelöst werden.",
      "customer_form.mloffice_loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "customer_form.mloffice_loest": "Löse…",
      "customer_form.mloffice_verwaltung_hinweis": "Verwaltung der Verknüpfung unter Stammdaten & Organisation → MLOffice (erfordert Systemrechte).",
      "customer_form.registrieren_sie_eine_app_in_azure_portal_ap": "Registreer een app in Azure Portal → App-registraties. Redirect URI:",
      "customer_form.strasse": "Straat",
      "customer_form.tab_address": "Adres",
      "customer_form.tab_domains": "Domeinen",
      "customer_form.tab_general": "Algemeen",
      "customer_form.tab_notes": "Notities",
      "customer_form.tab_sso": "SSO",
      "customer_form.tab_tax": "Belasting & SLA",
      "customer_form.zuordnung_ticket_system_kunde_lexoffice_kont": "Toewijzing klant in ticketsysteem → Lexoffice-contact voor conceptfacturen (Admin → Tijdregistratie).",
      "customer_inactive": "Klant inactief",
      "customer_not_found": "Klant niet gevonden",
      "customer_notified_by_email": "Klant wordt per e-mail geïnformeerd",
      "customer_number_abbrev": "Klantnr",
      "customer_portal.action_required": "Actie vereist",
      "customer_portal.action_required_desc": "Het supportteam wacht op uw reactie op dit ticket.",
      "customer_portal.action_required_title": "Uw antwoord is nodig",
      "customer_portal.assignee": "Behandelaar",
      "customer_portal.attachments_count": "Bijlagen ({{count}})",
      "customer_portal.attachments_load_failed": "Weitere Anhänge konnten nicht geladen werden.",
      "customer_portal.back": "← Terug",
      "customer_portal.back_to_my_tickets": "← Terug naar Mijn tickets",
      "customer_portal.close": "Sluiten",
      "customer_portal.close_failed": "Het ticket kon niet worden gesloten.",
      "customer_portal.collapse_replies": "Ältere schließen",
      "customer_portal.compact_replies": "Ältere Antworten sind eingeklappt. Die letzte Antwort bleibt geöffnet.",
      "customer_portal.confirm_close": "Weet u zeker dat u dit ticket wilt sluiten?",
      "customer_portal.confirm_reopen": "Wilt u dit ticket weer openen?",
      "customer_portal.contracts.hours_minutes": "{{hours}} u {{minutes}} min",
      "customer_portal.contracts.hours_only": "{{hours}} u",
      "customer_portal.contracts.minutes_only": "{{minutes}} min",
      "customer_portal.create_first_ticket": "Nieuw ticket maken",
      "customer_portal.created": "Gemaakt op",
      "customer_portal.customer_colleague": "Kollegin/Kollege",
      "customer_portal.dashboard.active_count": "{{count}} actief",
      "customer_portal.dashboard.avg_resolution": "Gem. oplostijd",
      "customer_portal.dashboard.click_to_view_waiting": "Klik hier om de tickets te bekijken",
      "customer_portal.dashboard.create_first_link": "Eerste ticket maken →",
      "customer_portal.dashboard.create_new_ticket_link": "Nieuw ticket maken",
      "customer_portal.dashboard.history_trend": "Ticketverloop (laatste 12 maanden)",
      "customer_portal.dashboard.kb": "Help & kennisbank",
      "customer_portal.dashboard.kb_desc": "Handleidingen en veelgestelde vragen",
      "customer_portal.dashboard.my_tickets": "Mijn tickets",
      "customer_portal.dashboard.no_tickets": "Nog geen tickets aanwezig",
      "customer_portal.dashboard.no_tickets_status": "Geen tickets",
      "customer_portal.dashboard.open_active": "Open / actief",
      "customer_portal.dashboard.processing_time": "Behandeltijd",
      "customer_portal.dashboard.recent_tickets": "Laatste tickets",
      "customer_portal.dashboard.report_incident": "Storing melden",
      "customer_portal.dashboard.report_incident_desc": "Dringend probleem of storing melden",
      "customer_portal.dashboard.reports": "Overzicht & rapporten",
      "customer_portal.dashboard.reports_desc": "Alle tickets filteren en analyseren",
      "customer_portal.dashboard.search_kb_link": "Kennisbank doorzoeken",
      "customer_portal.dashboard.service_request": "Serviceaanvraag",
      "customer_portal.dashboard.service_request_desc": "Aanvragen via configureerbare formulieren",
      "customer_portal.dashboard.show_all_link": "Alles tonen →",
      "customer_portal.dashboard.status_overview": "Statusoverzicht",
      "customer_portal.dashboard.subtitle": "Uw supportoverzicht in één oogopslag",
      "customer_portal.dashboard.total_tickets": "Tickets totaal",
      "customer_portal.dashboard.waiting_tickets_warning": "1 ticket vereist uw antwoord",
      "customer_portal.dashboard.waiting_tickets_warning_plural": "{{count}} tickets vereisen uw antwoord",
      "customer_portal.dashboard.welcome": "Welkom",
      "customer_portal.dashboard.widget_unknown": "Widget: {{type}}",
      "customer_portal.dashboard.your_reply": "Uw antwoord",
      "customer_portal.details_title": "Details",
      "customer_portal.editor.bold": "Vet",
      "customer_portal.editor.code": "Code",
      "customer_portal.editor.italic": "Cursief",
      "customer_portal.editor.list": "Lijst",
      "customer_portal.expand_replies": "Alle öffnen",
      "customer_portal.files_draft_failed": "Anhänge konnten nicht dauerhaft im Entwurf gespeichert werden.",
      "customer_portal.files_need_reselect": "Anhänge können aus Sicherheitsgründen nicht wiederhergestellt werden. Bitte wählen Sie sie erneut aus.",
      "customer_portal.filters.active": "Actief",
      "customer_portal.filters.all": "Alle",
      "customer_portal.filters.closed": "Gesloten",
      "customer_portal.filters.external": "Extern",
      "customer_portal.filters.waiting_customer": "Uw antwoord",
      "customer_portal.history_title": "Historie",
      "customer_portal.impersonation_banner": "U bekijkt dit portaal momenteel in de impersonatiemodus (voorbeeld voor agents) als klant:",
      "customer_portal.incident_badge": "Storing",
      "customer_portal.kb.title": "Kennisbank",
      "customer_portal.load_more_attachments": "Weitere Anhänge laden",
      "customer_portal.login.betreut_von": "ONDERSTEUND DOOR NALVRA",
      "customer_portal.login.claim": "Uw directe lijn naar support — melden, status volgen, antwoorden vinden.",
      "customer_portal.login.copyright_text": "© {{year}} {{appName}}. Alle rechten voorbehouden.",
      "customer_portal.login.default_subtitle": "Meld u aan om uw aanvragen te beheren.",
      "customer_portal.login.default_welcome": "Welkom bij {{appName}}",
      "customer_portal.login.email": "E-mail",
      "customer_portal.login.email_placeholder": "naam@bedrijf.nl",
      "customer_portal.login.eyebrow": "KLANTENPORTAAL · 24/7 BEREIKBAAR",
      "customer_portal.login.forgot_password": "Wachtwoord vergeten?",
      "customer_portal.login.kein_zugang": "Nog geen toegang? Neem contact op met uw contactpersoon bij support.",
      "customer_portal.login.kundenanmeldung": "Klantaanmelding",
      "customer_portal.login.kundenportal": "KLANTENPORTAAL",
      "customer_portal.login.microsoft_signin": "Aanmelden met Microsoft",
      "customer_portal.login.mit_hinterlegter_adresse": "Meld u aan met het geregistreerde e-mailadres.",
      "customer_portal.login.or_password": "of met wachtwoord",
      "customer_portal.login.password": "Wachtwoord",
      "customer_portal.login.password_placeholder": "Uw wachtwoord",
      "customer_portal.login.reset_back": "Terug naar aanmelden",
      "customer_portal.login.reset_button": "Link versturen",
      "customer_portal.login.reset_instruction": "Voer uw e-mailadres in. Wij sturen u een link om het opnieuw in te stellen.",
      "customer_portal.login.reset_sent_message": "Als er een account met dit adres bestaat, hebben wij een link verstuurd.",
      "customer_portal.login.reset_sent_title": "E-mail verstuurd",
      "customer_portal.login.reset_title": "Wachtwoord opnieuw instellen",
      "customer_portal.login.sicherheitszeile": "Versleutelde verbinding · Toegang alleen voor geregistreerde contactpersonen",
      "customer_portal.login.signin_button": "Aanmelden",
      "customer_portal.login.signing_in": "Bezig met aanmelden …",
      "customer_portal.login.sso_available": "Eenmalige aanmelding beschikbaar",
      "customer_portal.login.sso_failed": "SSO-aanmelding mislukt",
      "customer_portal.login.sso_logging_in": "Bezig met aanmelden …",
      "customer_portal.menu.dashboard": "Dashboard",
      "customer_portal.menu.edit_profile": "Profiel bewerken",
      "customer_portal.menu.logout": "Afmelden",
      "customer_portal.menu.profile": "Mein Profil",
      "customer_portal.message_placeholder": "Uw bericht...",
      "customer_portal.nav.contracts": "Contracten",
      "customer_portal.nav.create_request": "Anfrage erstellen",
      "customer_portal.nav.dashboard": "Dashboard",
      "customer_portal.nav.documents": "Documenten",
      "customer_portal.nav.downloads": "Downloads",
      "customer_portal.nav.help": "Hilfe & Kurztour",
      "customer_portal.nav.kb": "Kennisbank",
      "customer_portal.nav.my_tickets": "Mijn tickets",
      "customer_portal.nav.profile": "Profiel",
      "customer_portal.nav.report_incident": "Storing melden",
      "customer_portal.nav.service_request": "Serviceaanvraag",
      "customer_portal.nav.support": "Support erhalten",
      "customer_portal.navigation": "Portal-Navigation",
      "customer_portal.new_ticket": "Nieuw ticket",
      "customer_portal.new_ticket.add_attachment": "Toevoegen",
      "customer_portal.new_ticket.ai_improve_btn": "Beschrijving verbeteren",
      "customer_portal.new_ticket.ai_improving": "Wordt verbeterd...",
      "customer_portal.new_ticket.ai_preanswer_title": "AI-suggestie voor uw probleem",
      "customer_portal.new_ticket.ai_suggestion_title": "AI-verbetervoorstel",
      "customer_portal.new_ticket.allowed_types_tip": "Alleen geconfigureerde bestandstypen (zie de aanwijzing van uw beheerder)",
      "customer_portal.new_ticket.apply": "Overnemen",
      "customer_portal.new_ticket.attach_file": "Bestand bijvoegen",
      "customer_portal.new_ticket.attachment_plural": "Bijlagen",
      "customer_portal.new_ticket.attachment_singular": "Bijlage",
      "customer_portal.new_ticket.back_step_1": "Zurück zu Schritt 1",
      "customer_portal.new_ticket.back_step_2": "Zurück zu Schritt 2",
      "customer_portal.new_ticket.categories_error": "Kategorien konnten nicht geladen werden.",
      "customer_portal.new_ticket.categories_loading": "Kategorien werden geladen …",
      "customer_portal.new_ticket.category_assignment": "Kategorie zuordnen",
      "customer_portal.new_ticket.category_by_support": "Zuordnung durch den Support",
      "customer_portal.new_ticket.category_hint": "Sie sind unsicher? Lassen Sie die Kategorie offen. Der Support übernimmt die Zuordnung.",
      "customer_portal.new_ticket.category_question": "Welche Kategorie passt zu Ihrem Anliegen?",
      "customer_portal.new_ticket.char_count": "{{count}} tekens",
      "customer_portal.new_ticket.continue_step_2": "Weiter zu Schritt 2",
      "customer_portal.new_ticket.continue_step_3": "Weiter zu Schritt 3",
      "customer_portal.new_ticket.create": "Maken",
      "customer_portal.new_ticket.create_anyway": "Toch een ticket maken",
      "customer_portal.new_ticket.create_ticket": "Ticket maken",
      "customer_portal.new_ticket.creating": "Wordt gemaakt...",
      "customer_portal.new_ticket.days_count": "{{count}} werkdagen",
      "customer_portal.new_ticket.description_label": "Beschrijving *",
      "customer_portal.new_ticket.description_placeholder": "Beschrijf uw probleem in detail...\\n\\n• Wat werkt er niet?\\n• Sinds wanneer treedt het probleem op?\\n• Is er een foutmelding?\\n• Welk systeem / apparaat is getroffen?\\n\\nTip: screenshots plakken met Ctrl+V",
      "customer_portal.new_ticket.description_required": "Bitte beschreiben Sie Ihr Problem.",
      "customer_portal.new_ticket.discard": "Verwerpen",
      "customer_portal.new_ticket.drag_more": "Sleep meer bestanden hierheen · Nog {{count}} mogelijk",
      "customer_portal.new_ticket.drag_or_click": "Sleep bestanden hierheen of klik",
      "customer_portal.new_ticket.drop_here": "Bestanden hier neerzetten...",
      "customer_portal.new_ticket.error_create_failed": "Fout bij het maken van het ticket.",
      "customer_portal.new_ticket.expected_first_response": "Eerste antwoord",
      "customer_portal.new_ticket.go_to_step": "Schritt {{step}}: {{label}}",
      "customer_portal.new_ticket.hide": "Verbergen",
      "customer_portal.new_ticket.hours_count": "{{count}} uur",
      "customer_portal.new_ticket.insert_template": "Sjabloon invoegen",
      "customer_portal.new_ticket.kb_article_error": "Dieser Artikel konnte nicht geladen werden. Sie können es erneut versuchen oder mit Ihrem Ticket fortfahren.",
      "customer_portal.new_ticket.kb_close_article": "Artikel schließen",
      "customer_portal.new_ticket.kb_did_help": "Hat dieser Artikel Ihr Problem gelöst?",
      "customer_portal.new_ticket.kb_draft_retained": "Ihr Ticketentwurf bleibt erhalten. Sie entscheiden, ob Sie ihn weiter bearbeiten.",
      "customer_portal.new_ticket.kb_feedback_error": "Ihre Rückmeldung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut. Ihr Entwurf bleibt erhalten.",
      "customer_portal.new_ticket.kb_helped": "Artikel hat mir geholfen",
      "customer_portal.new_ticket.kb_loading_article": "Artikel wird geladen",
      "customer_portal.new_ticket.kb_resolved_message": "Ihre Rückmeldung wurde gespeichert. Es wurde kein Ticket erstellt.",
      "customer_portal.new_ticket.kb_resolved_title": "Schön, dass die Anleitung geholfen hat",
      "customer_portal.new_ticket.kb_resume_draft": "Ticketentwurf weiter bearbeiten",
      "customer_portal.new_ticket.kb_retry": "Erneut laden",
      "customer_portal.new_ticket.kb_saved_draft": "Ihr Entwurf bleibt für Sie gespeichert, falls Sie später doch Unterstützung benötigen.",
      "customer_portal.new_ticket.kb_searching": "Lösungen werden gesucht",
      "customer_portal.new_ticket.kb_suggestions_hint": "Passende Anleitungen aus der Wissensbasis. Lesen Sie einen Artikel, bevor Sie Ihr Ticket erstellen.",
      "customer_portal.new_ticket.kb_suggestions_title": "Vielleicht ist die Lösung schon da",
      "customer_portal.new_ticket.kb_to_dashboard": "Zurück zum Dashboard",
      "customer_portal.new_ticket.max_files": "Max. {{count}} bestanden",
      "customer_portal.new_ticket.max_size": "Max. {{count}} MB / bestand",
      "customer_portal.new_ticket.minutes_count": "{{count}} minuten",
      "customer_portal.new_ticket.no_category": "Selecteer een categorie...",
      "customer_portal.new_ticket.optional": "Optional",
      "customer_portal.new_ticket.preanswer_might_resolve": "Heeft dit u geholpen? Dan hoeft u mogelijk geen ticket te maken.",
      "customer_portal.new_ticket.presubmit_kb_desc": "Geen passend artikel? Geen probleem — maak uw ticket.",
      "customer_portal.new_ticket.presubmit_kb_title": "Dit lost uw probleem mogelijk al op",
      "customer_portal.new_ticket.prio_desc_critical": "Direct",
      "customer_portal.new_ticket.prio_desc_high": "Urgent",
      "customer_portal.new_ticket.prio_desc_low": "Kan wachten",
      "customer_portal.new_ticket.prio_desc_medium": "Normaal",
      "customer_portal.new_ticket.progress": "Fortschritt der Ticketerstellung",
      "customer_portal.new_ticket.relevant_articles": "Passende artikelen:",
      "customer_portal.new_ticket.reply_by_email_tip": "U kunt ook per e-mail op dit ticket antwoorden",
      "customer_portal.new_ticket.resolution": "Oplossing",
      "customer_portal.new_ticket.response_time_typical": "Doorgaans antwoord binnen enkele uren",
      "customer_portal.new_ticket.retry_categories": "Erneut laden",
      "customer_portal.new_ticket.screenshot_tip": "Screenshots plakken met Ctrl+V",
      "customer_portal.new_ticket.similar_tickets": "Vergelijkbare tickets",
      "customer_portal.new_ticket.step_attachments": "Anhänge",
      "customer_portal.new_ticket.step_attachments_detail": "Kategorie, Anhänge und Absenden",
      "customer_portal.new_ticket.step_count": "Schritt {{step}} von 3",
      "customer_portal.new_ticket.step_details": "Details",
      "customer_portal.new_ticket.step_details_detail": "Beschreibung und Priorität",
      "customer_portal.new_ticket.step_subject": "Betreff",
      "customer_portal.new_ticket.step_subject_detail": "Person, Betreff und Wissensbasis",
      "customer_portal.new_ticket.subject_desc_required": "Onderwerp en beschrijving zijn verplicht.",
      "customer_portal.new_ticket.subject_label": "Onderwerp *",
      "customer_portal.new_ticket.subject_placeholder": "Korte beschrijving van het probleem of van uw aanvraag",
      "customer_portal.new_ticket.subject_required": "Bitte geben Sie einen Betreff ein.",
      "customer_portal.new_ticket.subtitle": "Technische storing of dringend probleem — wordt als ticket naar de support gestuurd.",
      "customer_portal.new_ticket.subtitle_2": "Beschrijf uw vraag en wij pakken het voor u op.",
      "customer_portal.new_ticket.success_desc": "Hartelijk dank. Wij nemen zo snel mogelijk contact met u op.",
      "customer_portal.new_ticket.success_title": "Ticket gemaakt!",
      "customer_portal.new_ticket.template_btn": "Voorbeeld",
      "customer_portal.new_ticket.view_ticket": "Ticket bekijken",
      "customer_portal.no_attachments": "Keine Anhänge vorhanden.",
      "customer_portal.no_tickets_create_desc": "Maak uw eerste ticket.",
      "customer_portal.no_tickets_filter_desc": "Probeer een ander filter.",
      "customer_portal.no_tickets_search_desc": "Probeer een andere zoekterm.",
      "customer_portal.no_tickets_title": "Geen tickets gevonden",
      "customer_portal.pagination_of": "von",
      "customer_portal.password.btn": "Wachtwoord wijzigen",
      "customer_portal.password.cancel": "Annuleren",
      "customer_portal.password.changing": "Wordt gewijzigd...",
      "customer_portal.password.confirm": "Nieuw wachtwoord bevestigen",
      "customer_portal.password.current": "Huidig wachtwoord",
      "customer_portal.password.error_change": "Fout bij het wijzigen.",
      "customer_portal.password.error_min_length": "Minimaal 8 tekens.",
      "customer_portal.password.error_mismatch": "Wachtwoorden komen niet overeen.",
      "customer_portal.password.error_same": "Het nieuwe wachtwoord moet afwijken.",
      "customer_portal.password.logout": "Afmelden",
      "customer_portal.password.mismatch_warning": "Wachtwoorden komen niet overeen",
      "customer_portal.password.must_change_desc": "Wijzig uw wachtwoord voordat u verdergaat.",
      "customer_portal.password.new": "Nieuw wachtwoord (min. 8 tekens)",
      "customer_portal.password.redirecting": "U wordt doorgestuurd...",
      "customer_portal.password.success": "Wachtwoord succesvol gewijzigd!",
      "customer_portal.password.title": "Wachtwoord wijzigen",
      "customer_portal.priority_help.high": "Mehrere Mitarbeitende oder eine wichtige Funktion sind stark beeinträchtigt. Es gibt keine praktikable Ausweichlösung, der übrige Betrieb läuft jedoch weiter.",
      "customer_portal.priority_help.low": "Kleine Einschränkung oder allgemeine Frage. Sie können normal weiterarbeiten, zum Beispiel bei einem Darstellungsfehler oder einem Änderungswunsch.",
      "customer_portal.priority_help.medium": "Die Arbeit ist eingeschränkt, aber eine Ausweichlösung ist möglich. Beispiel: Ein Drucker fällt aus, ein anderer kann genutzt werden.",
      "customer_portal.priority_help.urgent": "Der Betrieb oder ein geschäftskritischer Prozess steht still. Es gibt keine Ausweichlösung, zum Beispiel bei einem vollständigen Ausfall des zentralen Systems. Bitte nicht nur wegen eines persönlichen Wunschtermins wählen.",
      "customer_portal.processing_time": "Behandeltijd",
      "customer_portal.profile.cancel": "Annuleren",
      "customer_portal.profile.change_password_btn": "Wachtwoord wijzigen",
      "customer_portal.profile.change_photo": "Profilbild ändern",
      "customer_portal.profile.closed": "Gesloten",
      "customer_portal.profile.company": "Bedrijf",
      "customer_portal.profile.company_account": "Bedrijf & account",
      "customer_portal.profile.days_count": "{{count}} werkdag(en)",
      "customer_portal.profile.department": "Afdeling",
      "customer_portal.profile.edit": "Bewerken",
      "customer_portal.profile.email": "E-mail",
      "customer_portal.profile.error_save": "Fout bij het opslaan",
      "customer_portal.profile.error_upload": "Fout bij het uploaden",
      "customer_portal.profile.first_name": "Voornaam",
      "customer_portal.profile.first_response": "Eerste antwoord",
      "customer_portal.profile.hours_count": "{{count}} u",
      "customer_portal.profile.last_name": "Achternaam",
      "customer_portal.profile.loading": "Profiel wordt geladen...",
      "customer_portal.profile.location": "Locatie",
      "customer_portal.profile.member_since": "Lid sinds",
      "customer_portal.profile.minutes_count": "{{count}} min.",
      "customer_portal.profile.mobile": "Mobiel",
      "customer_portal.profile.mobile_placeholder": "bijv. +31 6 12345678",
      "customer_portal.profile.open": "Open",
      "customer_portal.profile.personal_data": "Persoonlijke gegevens",
      "customer_portal.profile.phone": "Telefoon",
      "customer_portal.profile.phone_placeholder": "bijv. +31 20 1234567",
      "customer_portal.profile.position": "Functie",
      "customer_portal.profile.resolution": "Oplossing",
      "customer_portal.profile.save": "Opslaan",
      "customer_portal.profile.security": "Beveiliging",
      "customer_portal.profile.security_desc": "Wijzig uw wachtwoord regelmatig voor extra veiligheid.",
      "customer_portal.profile.service_level": "Service level",
      "customer_portal.profile.show_dashboard": "Dashboard tonen",
      "customer_portal.profile.sla_tier": "SLA-niveau",
      "customer_portal.profile.sso_active": "SSO-authenticatie actief",
      "customer_portal.profile.success_photo": "Profielfoto bijgewerkt",
      "customer_portal.profile.success_update": "Profiel succesvol bijgewerkt",
      "customer_portal.profile.ticket_overview": "Ticketoverzicht",
      "customer_portal.profile.total": "Totaal",
      "customer_portal.reopen": "Weer openen",
      "customer_portal.reopen_failed": "Het ticket kon niet opnieuw worden geopend.",
      "customer_portal.reopen_ticket": "Ticket weer openen",
      "customer_portal.replies_load_failed": "Ältere Antworten konnten nicht geladen werden.",
      "customer_portal.reply_btn": "Antwoorden",
      "customer_portal.reply_failed": "Uw antwoord kon niet worden verzonden. Probeer het opnieuw.",
      "customer_portal.reply_plural": "Antwoorden",
      "customer_portal.reply_singular": "Antwoord",
      "customer_portal.request_badge": "Aanvraag",
      "customer_portal.requests.attachments": "Bijlagen",
      "customer_portal.requests.category": "Categorie",
      "customer_portal.requests.description": "Beschrijving",
      "customer_portal.requests.priority": "Prioriteit",
      "customer_portal.search_label": "Tickets suchen",
      "customer_portal.search_placeholder": "Ticketnr. of onderwerp zoeken...",
      "customer_portal.sending": "Wordt verzonden...",
      "customer_portal.service_level": "Service level",
      "customer_portal.show_older_replies": "{{count}} oudere antwoorden tonen...",
      "customer_portal.sla.met": "Behaald",
      "customer_portal.sla.on_track": "Op schema",
      "customer_portal.sla.overdue": "Overschreden",
      "customer_portal.sla.warning": "Bijna verlopen",
      "customer_portal.source": "Bron",
      "customer_portal.source_portal": "Portaal",
      "customer_portal.stop_impersonation": "Impersonatie beëindigen",
      "customer_portal.support_team": "Supportteam",
      "customer_portal.ticket_closed_desc": "Dit ticket is gesloten.",
      "customer_portal.ticket_load_failed": "Ticket konnte nicht geladen werden",
      "customer_portal.ticket_load_failed_desc": "Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "customer_portal.ticket_not_found": "Ticket niet gevonden",
      "customer_portal.ticket_owner": "Ihr zuständiger Support-Agent",
      "customer_portal.ticket_plural": "Tickets",
      "customer_portal.ticket_singular": "Ticket",
      "customer_portal.tickets_load_failed": "Tickets konnten nicht geladen werden",
      "customer_portal.tickets_load_failed_desc": "Ihre Daten wurden nicht verändert.",
      "customer_portal.times_title": "Tijden",
      "customer_portal.unassigned_owner": "Noch nicht zugewiesen",
      "customer_portal.unsaved_warning": "Ihr nicht gesendeter Entwurf geht beim Verlassen möglicherweise verloren.",
      "customer_portal.updated": "Bijgewerkt",
      "customer_portal.via_email": "per e-mail",
      "customer_portal.write_reply": "Antwoord schrijven",
      "customer_portal.you": "U",
      "customer_tickets_summary": "{{open}} open / {{total}} tot.",
      "customers": "Klanten",
      "customize": "Aanpassen",
      "dark_mode": "Donkere modus",
      "dashboard": "Dashboard",
      "dashboard_sub": "Hier zijn uw operationele KPI's, SLA-statussen en ticketstatistieken.",
      "days_ago": "{{count}} dagen geleden",
      "delete": "Verwijderen",
      "density": "Dichtheid:",
      "density_comfort_label": "Komfort",
      "density_comfortable": "Comfortabel",
      "density_compact": "Compact",
      "density_spacious": "Ruim",
      "density_standard_label": "Standard",
      "device_actions": "Geräte & Lizenzen",
      "device_actions_hint": "Fernwartung, Remote-Terminal, Behebung und Lizenzen der verknüpften Geräte",
      "document.all": "Alle",
      "document.category.certificate": "Certificaat",
      "document.category.contract": "Contract",
      "document.category.correspondence": "Correspondentie",
      "document.category.general": "Algemeen",
      "document.category.invoice": "Factuur",
      "document.category.manual": "Handleiding",
      "document.category.report": "Rapport",
      "document.none_found": "Geen documenten gevonden",
      "document.none_found_desc": "Probeer een andere zoekterm",
      "document.none_shared": "Nog geen documenten voor u vrijgegeven",
      "document.none_shared_desc": "Uw contactpersoon kan hier documenten voor u beschikbaar stellen",
      "document.plural": "Documenten",
      "document.search_placeholder": "Documenten doorzoeken...",
      "document.singular": "Document",
      "document.subtitle": "Uw vrijgegeven documenten, contracten en stukken",
      "document.total_suffix": "totaal",
      "domains": "Domeinen",
      "draft_present": "Concept",
      "draft_saved": "Concept opgeslagen",
      "drag_to_move": "{{label}} (sleep om te verplaatsen)",
      "drag_to_sort": "Sleep om te sorteren, klik om te tonen/verbergen",
      "duration": "Duur (min.)",
      "duration_minutes": "{{count}} minuten",
      "edit": "Bewerken",
      "edit_customer": "Klant bewerken",
      "edit_master_data_admin": "Stamgegevens bewerken in administratie",
      "edit_widgets_title": "Widgets tonen & sorteren",
      "email": "E-mail",
      "email_channel": "E-mailkanaal",
      "employee_form.account_erstellt": "Account gemaakt:",
      "employee_form.bitte_zuerst_kunde_auswaehlen": "Selecteer eerst een klant",
      "employee_form.dieser_mitarbeiter_hat_noch_keinen_zugang_zu": "Deze medewerker heeft nog geen toegang tot het klantportaal. Maak een account met wachtwoord.",
      "employee_form.domain_waehlen": "Domein kiezen",
      "employee_form.domains_werden_geladen": "Domeinen worden geladen...",
      "employee_form.e_mail_server_nicht_konfiguriert": "E-mailserver niet geconfigureerd",
      "employee_form.initialpasswort_vergeben": "Initieel wachtwoord instellen...",
      "employee_form.interne_notizen_zum_mitarbeiter": "Interne notities over de medewerker...",
      "employee_form.kein_portal_zugang_vorhanden": "Geen portaaltoegang aanwezig",
      "employee_form.keine_domains_fuer_diesen_kunden_hinterlegt": "Voor deze klant zijn geen domeinen vastgelegd.",
      "employee_form.kunde_auswaehlen": "Klant selecteren",
      "employee_form.lade_account_informationen": "Accountgegevens laden...",
      "employee_form.leer_lassen_wenn_kein_portal_zugang_benoetig": "Laat leeg wanneer geen portaaltoegang nodig is (bijv. bij SSO).",
      "employee_form.letzter_login": "Laatste aanmelding:",
      "employee_form.neues_passwort": "Nieuw wachtwoord...",
      "employee_form.neues_passwort_min_8_zeichen": "Nieuw wachtwoord (min. 8 tekens)",
      "employee_form.passwort_fuer_neuen_account_min_8_zeichen": "Wachtwoord voor nieuw account (min. 8 tekens)",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge": "Wachtwoordwijziging bij eerste aanmelding afdwingen",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge_2": "Wachtwoordwijziging bij eerste aanmelding afdwingen",
      "employee_form.passwortaenderung_beim_naechsten_login_erzwi": "Wachtwoordwijziging bij volgende aanmelding afdwingen",
      "employee_form.profilbild_kann_nach_dem_erstellen_hochgelad": "De profielfoto kan na het maken worden geüpload.",
      "employee_form.pw_aenderung_ausstehend": "Wachtwoordwijziging openstaand",
      "employee_form.reset_link_24h_gueltig": "Resetlink (24 uur geldig):",
      "employee_form.tab_access": "Klantenportaal",
      "employee_form.tab_it": "IT & werkplek",
      "employee_form.tab_notes": "Notities",
      "employee_form.tab_personal": "Persoonlijk",
      "employee_form.tab_work": "Werk & contact",
      "employee_form.weitere_it_informationen_wie_betriebssystem": "Aanvullende IT-informatie zoals besturingssysteem, geïnstalleerde software enz. kan in de notities worden vastgelegd.",
      "employee_form.z_b_koeln_buero_3_og": "bijv. Amsterdam, kantoor 3e etage",
      "employees": "Medewerkers",
      "employees_ca": "Medewerkers (ca.)",
      "end_edit": "Bewerken beëindigen",
      "enter_title_error": "Voer een titel in.",
      "escalate": "Escaleren",
      "escalated": "Geëscaleerd",
      "escalated_badge": "Geëscaleerd",
      "expand_sidebar": "Zijbalk uitklappen",
      "expired": "Verlopen",
      "expires_at": "Loopt tot",
      "expiring_soon": "Verloopt binnenkort",
      "export_csv": "CSV-bestand",
      "export_pdf": "PDF-document",
      "export_png": "PNG-diagram",
      "export_xlsx": "Excel (XLSX)",
      "filter_active": "Filter actief",
      "filter_all_az": "Alle A–Z",
      "filter_list_placeholder": "Lijst filteren...",
      "filter_open_first": "Eerst openstaande",
      "filter_open_only": "Alleen met openstaande",
      "filter_with_sla": "Met SLA-niveau",
      "first_post_attachments": "Bijlagen bij het eerste bericht",
      "first_response": "Eerste reactie",
      "follow_ups": "Wacht op klant",
      "generating": "Genereren...",
      "greeting_day": "Goedendag, {{name}} 👋",
      "held_review": "Controle vereist",
      "high_priority": "Hoge prioriteit",
      "hours": "Uren",
      "hours_ago": "{{count}} uur geleden",
      "inactive": "Inactief",
      "included_hours": "Incl. uren",
      "industry": "Branche",
      "internal": "Intern",
      "internal_chat": "Interne chat",
      "internal_note": "Interne notitie",
      "internal_notes": "Interne notities",
      "internal_notes_placeholder": "Interne notities over de klant...",
      "invalid_datetime_error": "Ongeldige datum of tijd.",
      "just_now": "Zojuist",
      "kb.all_articles": "Alle artikelen",
      "kb.author": "Auteur",
      "kb.back_to_overview": "Terug naar het overzicht",
      "kb.browse_more": "← Meer artikelen bekijken",
      "kb.no_articles": "Nog geen kennisartikelen beschikbaar",
      "kb.no_articles_desc": "Hier verschijnen binnenkort nuttige artikelen",
      "kb.pinned": "Vastgezet",
      "kb.read_time": "{{count}} min. leestijd",
      "kb.search_placeholder": "Waar zoekt u naar? Bijv. VPN, wachtwoord, e-mail...",
      "kb.subtitle": "Handleidingen, tips en hulp bij uw vragen",
      "kb.try_different_search": "Probeer een andere zoekterm",
      "kb.updated_at": "Bijgewerkt op {{date}}",
      "kb.views_count": "{{count}} weergaven",
      "keyboard_shortcuts": "Sneltoetsen",
      "knowledge": "Kennisbank",
      "knowledge_base": "Kennisbank",
      "kpi_held": "Afzender onduidelijk",
      "kpi_important": "belangrijk",
      "kpi_open": "open",
      "kpi_sla_breached": "SLA-schending",
      "kunde_loeschen.artikel": "Wissensartikel",
      "kunde_loeschen.bestaetigung_label": "Zur Bestätigung den Firmennamen eingeben",
      "kunde_loeschen.connectoren": "Connectoren",
      "kunde_loeschen.dokumente": "Dokumente",
      "kunde_loeschen.einleitung": "Dieser Kunde hat keine Tickets und keine Rechnungen. Er kann vollständig entfernt werden — mitsamt seinem Mandantenbereich in der Datenbank. Das lässt sich nicht rückgängig machen.",
      "kunde_loeschen.endgueltig_loeschen": "Endgültig löschen",
      "kunde_loeschen.fehlgeschlagen": "Das Löschen ist fehlgeschlagen.",
      "kunde_loeschen.geraete": "Geräte im Inventar",
      "kunde_loeschen.lizenzen": "Softwarelizenzen",
      "kunde_loeschen.mitarbeiter": "Mitarbeiter",
      "kunde_loeschen.netzgeraete": "Gefundene Netzwerkgeräte",
      "kunde_loeschen.nichts_dran": "An diesem Kunden hängen keine weiteren Daten.",
      "kunde_loeschen.portalbenutzer": "Portalzugänge",
      "kunde_loeschen.pruefung_fehlgeschlagen": "Die Prüfung ist fehlgeschlagen.",
      "kunde_loeschen.titel": "Kunde endgültig löschen",
      "kunde_loeschen.tokens": "API-Token",
      "kunde_loeschen.vertraege": "Verträge",
      "kunde_loeschen.wird_geprueft": "Wird geprüft …",
      "kunde_loeschen.wird_mitgeloescht": "Wird mitgelöscht",
      "kunde_loeschen.zeiten": "Zeiteinträge",
      "language": "Taal",
      "license.cluster_audit": "Audit",
      "license.cluster_balance": "Balans",
      "license.cluster_calc": "Calculator",
      "license.cluster_contracts": "Contracten & licenties",
      "license.cluster_optimize": "Optimalisatie",
      "license.tab_ad_coupling": "CAL-AD-koppeling",
      "license.tab_cal_calc": "CAL-calculator",
      "license.tab_catalog": "Softwarecatalogus",
      "license.tab_contracts": "Contracten",
      "license.tab_dashboard": "Licentiebalans & Trends",
      "license.tab_licenses": "Licentiebeheer",
      "license.tab_more_views": "Meer weergaven",
      "license.tab_reclaims": "Optimalisatie & Reclaims",
      "license.tab_remediation": "Remediation",
      "license.tab_sealed": "Auditarchief",
      "license.tab_sql_calc": "SQL-licentiecalculator",
      "license.tab_steering": "Sturing",
      "license.tab_suite_config": "Suite-configurator",
      "license_compliance.actions": "Acties",
      "license_compliance.assign_license_metric": "Licentiemetriek toewijzen",
      "license_compliance.confirm_delete_assignment": "Toewijzing definitief verwijderen?",
      "license_compliance.confirm_delete_contract": "Contract definitief verwijderen? Gekoppelde licenties blijven bestaan, maar worden losgemaakt van het contract.",
      "license_compliance.contract_expiry_alert": "Contractverloop",
      "license_compliance.deficit_forecast_desc": "Op basis van live scans ontstaan op de jaardatum nabetalingskosten voor ondergelicentieerde producten.",
      "license_compliance.edit_contract": "Contract bewerken",
      "license_compliance.edit_license": "Licentie bewerken",
      "license_compliance.expired_contracts_title": "Verlopen softwarecontracten vastgesteld!",
      "license_compliance.expired_contracts_warning_desc": "Licenties die aan deze contracten zijn toegewezen, worden in de complianceberekening genegeerd.",
      "license_compliance.forecasted_payment": "Verwachte nabetaling",
      "license_compliance.license_deficit_alert": "Licentietekort",
      "license_compliance.mark_license_required_btn": "Als licentieplichtig markeren",
      "license_compliance.new_contract": "Nieuw contract maken",
      "license_compliance.new_license": "Nieuwe licentie maken",
      "license_compliance.no_deficit_desc": "Gefeliciteerd! Uw Microsoft Core/CAL-toewijzingen dekken alle scanbevindingen af.",
      "license_compliance.not_catalogued": "Niet gecatalogiseerd",
      "license_compliance.reconciliation_desc": "Start een handmatige reconciliatieronde voor deze tenant. Berekent VM-stacking, WMI-discoverystanden, Software Assurance-periodes en contractgeldigheden live opnieuw.",
      "license_compliance.reconciliation_running": "Reconciliatie loopt...",
      "license_compliance.run_reconciliation": "Afstemming uitvoeren",
      "license_compliance.sam_warnings_title": "SAM-waarschuwingen & compliance",
      "license_compliance.save_contract": "Contract opslaan",
      "license_compliance.save_license": "Licentie opslaan",
      "license_compliance.seal_audit": "Audit verzegelen",
      "license_compliance.seal_audit_btn": "Rechtsgeldig verzegelen",
      "license_compliance.sealing": "Verzegelen...",
      "license_compliance.toast.add_suite_component_error": "Fout bij het toewijzen van de suitecomponent",
      "license_compliance.toast.assignment_completed": "Licentietoewijzing succesvol uitgevoerd.",
      "license_compliance.toast.assignment_error": "Fout bij het uitvoeren van de toewijzing",
      "license_compliance.toast.bulk_classify_error": "Fout bij de massaclassificatie",
      "license_compliance.toast.bulk_classify_success": "{{count}} software-items succesvol geclassificeerd.",
      "license_compliance.toast.calc_audit_error": "Fout bij het berekenen van de licentieaudit",
      "license_compliance.toast.contract_created": "Contract succesvol gemaakt.",
      "license_compliance.toast.contract_deleted": "Contract verwijderd.",
      "license_compliance.toast.contract_updated": "Contract succesvol bijgewerkt.",
      "license_compliance.toast.create_purchase_req_error": "Fout bij het maken van de aankoopaanvraag",
      "license_compliance.toast.delete_contract_error": "Fout bij het verwijderen van het contract",
      "license_compliance.toast.delete_license_error": "Fout bij het verwijderen van de licentie",
      "license_compliance.toast.delete_suite_component_error": "Fout bij het verwijderen van de toewijzing",
      "license_compliance.toast.license_created": "Licentie succesvol gemaakt.",
      "license_compliance.toast.license_deleted": "Licentie verwijderd.",
      "license_compliance.toast.license_updated": "Licentie succesvol bijgewerkt.",
      "license_compliance.toast.load_customers_error": "Fout bij het laden van de klantenlijst",
      "license_compliance.toast.purchase_req_created": "Aankoopaanvraag voor {{units}}x {{model}} (true-up: {{cost}}) als ticket {{ticket}} gemaakt.",
      "license_compliance.toast.reconcile_completed": "Reconciliatie succesvol afgerond. Compliancekengetallen zijn live opnieuw berekend.",
      "license_compliance.toast.reconcile_error": "Fout bij de reconciliatie",
      "license_compliance.toast.sam_settings_saved": "SAM-instellingen succesvol opgeslagen.",
      "license_compliance.toast.save_contract_error": "Fout bij het opslaan van het contract",
      "license_compliance.toast.save_license_error": "Fout bij het opslaan van de licentie",
      "license_compliance.toast.save_sam_settings_error": "Fout bij het opslaan van de SAM-instellingen",
      "license_compliance.toast.seal_audit_error": "Fout bij het verzegelen van de licentieaudit",
      "license_compliance.toast.seal_audit_success": "Licentieaudit succesvol verzegeld.",
      "license_compliance.toast.suite_component_added": "Component succesvol aan de suite toegewezen.",
      "license_compliance.toast.suite_component_deleted": "Toewijzing verwijderd.",
      "license_compliance.toast.uninstall_error": "Fout bij het starten van de deïnstallaties",
      "license_compliance.toast.uninstall_triggered": "Deïnstallatieopdrachten in de wachtrij geplaatst.",
      "license_compliance.update_contract": "Contract bijwerken",
      "license_compliance.update_license": "Licentie bijwerken",
      "licenses": "Licenties",
      "light_mode": "Lichte modus",
      "link_asset_btn": "+ Asset koppelen",
      "live_activity": "Live activiteit",
      "loading": "Wird geladen…",
      "loading_ellipsis": "Laden...",
      "location_on_map": "Locatie op kaart",
      "login.abbrechen": "Annuleren",
      "login.administratoradresse_konnte_nicht_geaendert_werden": "Die Administratoradresse konnte nicht geändert werden.",
      "login.adresse_aendern": "Adresse ändern",
      "login.adresse_wird_geaendert": "Adresse wird geändert…",
      "login.aendern": "Wijzigen",
      "login.aktivierung": "Activeren…",
      "login.aktivierung_fehlgeschlagen_code_pruefen": "Activering mislukt. Controleer de code.",
      "login.alle_rechte_vorbehalten": "· Alle rechten voorbehouden.",
      "login.anmelden": "Aanmelden",
      "login.anmelden_laeuft": "Aanmelden…",
      "login.anmeldung": "Aanmelden…",
      "login.bestaetigen": "Bevestigen",
      "login.bitte_geben_sie_eine_gueltige_e_mail_adresse": "Voer een geldig e-mailadres in.",
      "login.bitte_geben_sie_ihr_passwort_ein": "Voer uw wachtwoord in.",
      "login.bitte_geben_sie_zuerst_ihre_e_mail_adresse_e": "Voer eerst uw e-mailadres in.",
      "login.claim": "Servicedesk, assets en licenties — één databron, één proces.",
      "login.datenschutz": "Privacy",
      "login.e_mail_adresse_erfolgreich_geaendert": "E-Mail-Adresse erfolgreich geändert. Melden Sie sich jetzt mit der neuen Adresse an.",
      "login.ein_fehler_ist_aufgetreten": "Er is een fout opgetreden.",
      "login.einloggen_schliessen": "Aanmelden & sluiten",
      "login.erstanmeldung": "Eerste aanmelding:",
      "login.falls_ein_konto_existiert_wurde_eine_e_mail": "Als er een account bestaat, is er een e-mail voor het opnieuw instellen verzonden.",
      "login.fehler_beim_laden_des_mfa_setups": "Kan de MFA-instelling niet laden",
      "login.fehler_beim_ueberpruefen_der_e_mail_adresse": "Kan het e-mailadres niet controleren.",
      "login.geben_sie_den_6_stelligen_code_aus_ihrer_aut": "Voer de 6-cijferige code uit uw authenticator-app of een herstelcode in.",
      "login.geschaeftliche_e_mail": "Zakelijk e-mailadres",
      "login.ihr_account_ist_deaktiviert": "Uw account is gedeactiveerd.",
      "login.ihr_administrator_erfordert_die_einrichtung": "Uw administrator vereist het instellen van tweefactorauthenticatie.",
      "login.impressum": "Colofon",
      "login.kunden_account_erkannt": "Klantaccount herkend",
      "login.manueller_schluessel": "Handmatige sleutel",
      "login.melden_sie_sich_an_ihrem_service_desk_an": "Meld u aan bij uw servicedesk.",
      "login.mfa_aktivieren_weiter": "MFA inschakelen en doorgaan",
      "login.mfa_einrichtung_erforderlich": "MFA-instelling vereist",
      "login.mfa_einrichtung_fehlgeschlagen": "MFA-instelling mislukt.",
      "login.mfa_erfolgreich_aktiviert": "MFA is ingeschakeld",
      "login.neue_geschaeftliche_e_mail": "Neue geschäftliche E-Mail",
      "login.oder": "OF",
      "login.passwort": "Wachtwoord",
      "login.qr_code_fuer_die_authenticator_app": "QR-code voor de authenticator-app",
      "login.sechsstelliger_verifizierungscode": "6-cijferige verificatiecode",
      "login.sende": "Verzenden…",
      "login.sicherheitszeile": "AES-256 · Tweefactor · Eigen beheer",
      "login.sicherheitszeile_kurz": "AES-256 · Zwei-Faktor",
      "login.sie_werden_automatisch_zum_kundenportal_weit": "U wordt automatisch doorgestuurd naar het klantportaal om u daar aan te melden...",
      "login.single_sign_on_entra_id": "Single Sign-On (Entra ID)",
      "login.speichern_sie_diese_einmal_wiederherstellung": "Bewaar deze eenmalige herstelcodes goed! U kunt ze gebruiken als u de toegang tot uw app verliest.",
      "login.sso_anmeldung_fehlgeschlagen": "SSO-aanmelding mislukt",
      "login.startkonto_bestaetigt_adresse_festlegen": "Die Zugangsdaten des Startkontos wurden bestätigt. Legen Sie jetzt die geschäftliche Adresse für den Administrator fest.",
      "login.ueberpruefe": "Controleren...",
      "login.ungueltiger_oder_abgelaufener_mfa_code": "Ongeldige of verlopen MFA-code.",
      "login.verifiziere": "Verifiëren…",
      "login.weiter": "Doorgaan",
      "login.willkommen_zurueck": "Welkom terug",
      "login.zurueck_zum_login": "Terug naar aanmelden",
      "login.zuruecksetzen": "Herstellen",
      "login.zwei_faktor_code_totp": "Tweefactorcode (TOTP)",
      "logout": "Uitloggen",
      "main_navigation_rail": "Hoofdnavigatiebalk",
      "managing_director": "Directeur",
      "managing_director_abbrev": "Dir",
      "managing_director_prefix": "Directie:",
      "mark_all_read": "Alles als gelezen markeren",
      "mark_as_resolved": "Als opgelost markeren",
      "mati.connection_error": "Verbindingsfout",
      "mati.delete": "Verwijderen",
      "mati.error_failed_connection": "Verbinding met de AI-dienst mislukt.",
      "mati.error_generation": "Fout bij het genereren van het antwoord. Probeer het opnieuw.",
      "mati.gdpr_warning": "AVG-filter actief: persoonsgegevens worden vóór verzending automatisch geanonimiseerd.",
      "mati.greeting": "Hallo {{name}}! Ik ben {{mascot}}. Hoe kan ik je vandaag bij je werk ondersteunen? 🔮\\n\\nJe kunt mij vragen naar:\\n- De systeemstatus of de werkbelasting van de agents\\n- Ticketzoekopdrachten (\"Zoek onopgeloste tickets met hoge prioriteit\")\\n- Het maken van tickets (\"Maak ticket: printercartridge op de 2e verdieping leeg\")",
      "mati.history": "Historie",
      "mati.input_placeholder": "Vraag mij iets over tickets of werkbelasting, of maak een ticket...",
      "mati.new_chat": "Nieuwe chat",
      "mati.online_intelligent": "Online & intelligent",
      "mati.rename": "Hernoemen",
      "mati.restore_bead": "Zwevende helper tonen",
      "mati.restore_bead_tooltip": "Zwevende helper (bead) weer aan de schermrand tonen",
      "mati.send_btn": "Verzenden",
      "mati.suggest.create_ticket.desc": "Printer op de 1e verdieping defect",
      "mati.suggest.create_ticket.prompt": "Maak een ticket voor een defecte printer op de 1e verdieping, prioriteit gemiddeld.",
      "mati.suggest.create_ticket.title": "Ticket maken",
      "mati.suggest.search_tickets.desc": "Zoekopdracht \"database\"",
      "mati.suggest.search_tickets.prompt": "Zoek tickets die het woord \"database\" bevatten.",
      "mati.suggest.search_tickets.title": "Tickets zoeken",
      "mati.suggest.support_help.desc": "Hulp bij FAQ-concepten",
      "mati.suggest.support_help.prompt": "Hoe formuleer ik een vriendelijke afwijzing van een restitutieverzoek?",
      "mati.suggest.support_help.title": "Supporthulp",
      "mati.suggest.system_status.desc": "Actuele belasting tonen",
      "mati.suggest.system_status.prompt": "Toon mij de actuele systeemstatus en een overzicht van de belasting van de agents.",
      "mati.suggest.system_status.title": "Systeemstatus",
      "mati.typing_text": "{{name}} schrijft...",
      "mati.welcome_subtitle": "Ik ben je intelligente AI-copiloot. Ik kan je helpen tickets te beheren, in het systeem te zoeken of systeemstatistieken te bekijken.",
      "mati.welcome_title": "Hallo! Ik ben {{name}}",
      "mati_gdpr_warning": "AVG-filter actief: Persoonlijke gegevens worden automatisch geanonimiseerd voor verzending.",
      "mati_placeholder": "Vraag me alles over tickets, werklast, of maak een ticket...",
      "mati_welcome": "Hallo! Ik ben {{name}}",
      "meeting_error_title": "Teams-vergadering kon niet worden aangemaakt.",
      "meeting_success": "Teams-vergadering aangemaakt.",
      "meeting_success_copy": "Teams-vergadering aangemaakt, link gekopieerd naar klembord.",
      "megamenu.active_label": "Werken",
      "megamenu.calendar_desc": "Afspraken en agenda-integratie.",
      "megamenu.licenses_desc": "Licentiecompliance, suites & true-up-planning.",
      "megamenu.modules": "Modules",
      "megamenu.open_calendar": "Agenda openen",
      "megamenu.open_licenses": "Licenties openen",
      "megamenu.open_problems": "Problemen openen",
      "megamenu.problems_desc": "Problem management & RCA (root cause analysis).",
      "megamenu.quick_search_commands": "Snelzoeken & opdrachten",
      "merge": "Zusammenführen",
      "merge_tickets": "Die beiden markierten Tickets zusammenführen",
      "mfa_settings": "MFA-instellingen",
      "minutes_ago": "{{count}} min. geleden",
      "mloffice.abgleich_fehler": "Abgleich konnte nicht gestartet werden.",
      "mloffice.abgleich_fehlgeschlagen": "Letzter Abgleich fehlgeschlagen: {{fehler}}",
      "mloffice.abgleich_gestartet": "Voll-Abgleich gestartet.",
      "mloffice.abgleich_laeuft": "Abgleich läuft",
      "mloffice.adresse": "MLOffice-Adresse",
      "mloffice.adresse_hinweis": "Basisadresse der MLOffice-Installation — ohne /api/v1.",
      "mloffice.agenten_titel": "Agenten ↔ MLOffice-Benutzer",
      "mloffice.aktion_anlegen": "Neu anlegen",
      "mloffice.aktion_entkoppeln": "Entkoppeln",
      "mloffice.aktion_entkoppeln_hinweis": "Aus dem Abgleich nehmen — der Kunde bleibt bestehen und wird wieder editierbar.",
      "mloffice.aktion_verknuepfen": "Verknüpfen",
      "mloffice.aktiv": "Aktiv",
      "mloffice.aktivieren": "Anbindung aktiv",
      "mloffice.auswahl_fehler": "Auswahl konnte nicht gespeichert werden.",
      "mloffice.bereits_uebertragen": "{{n}} Einträge im Zeitraum sind bereits übertragen und werden übersprungen.",
      "mloffice.email_eingeben": "Der Partner hat in MLOffice keine E-Mail-Adresse. E-Mail für den neuen Kunden:",
      "mloffice.entwurf_anlegen": "Entwurf anlegen",
      "mloffice.entwurf_fehler": "Entwurf konnte nicht angelegt werden.",
      "mloffice.entwurf_hinweis": "Erzeugt aus den bereits übertragenen Zeiten des Zeitraums einen ENTWURF in MLOffice. Belegnummer, Festschreibung und Versand bleiben MLOffice vorbehalten.",
      "mloffice.entwurf_ok": "Entwurf über {{h}} h in MLOffice angelegt — Festschreiben und Versand dort.",
      "mloffice.entwurf_titel": "Rechnungsentwurf in MLOffice",
      "mloffice.ereignis_closed": "Ticket geschlossen",
      "mloffice.ereignis_created": "Ticket eröffnet",
      "mloffice.ereignis_escalated": "Ticket eskaliert",
      "mloffice.ereignisse_titel": "Ticket-Ereignisse in die MLOffice-Kontakthistorie melden (nur Referenz, nie Inhalt):",
      "mloffice.erst_aktivieren": "Bitte zuerst die Anbindung aktivieren und die Verbindung testen — dann erscheint hier der MLOffice-Kundenbestand.",
      "mloffice.erst_aktivieren_abrechnung": "Bitte zuerst die Anbindung aktivieren — dann erscheinen hier offene Posten und der Kontingent-Abgleich.",
      "mloffice.erst_aktivieren_zeiten": "Bitte zuerst die Anbindung aktivieren — dann lassen sich Zeiten per Übertragungslauf nach MLOffice geben.",
      "mloffice.fallback_hinweis": "{{n}} Einträge ohne Agenten-Zuordnung werden über den technischen Benutzer gebucht (Agentenname in der Beschreibung).",
      "mloffice.feld_bis": "Bis",
      "mloffice.feld_kunde": "Kunde",
      "mloffice.feld_projekt": "MLOffice-Projekt",
      "mloffice.feld_satz": "Stundensatz (netto)",
      "mloffice.feld_von": "Von",
      "mloffice.gespeichert": "MLOffice-Einstellungen gespeichert.",
      "mloffice.gueltig_180": "180 Tage",
      "mloffice.gueltig_365": "365 Tage",
      "mloffice.gueltig_90": "90 Tage",
      "mloffice.gueltig_unbegrenzt": "Unbegrenzt",
      "mloffice.hoheit_frage": "MLOffice übernimmt die Hoheit über: {{felder}}.\\n\\nDiese Felder sind in AISupportDesk dann gesperrt und werden fortlaufend aus MLOffice übernommen. Fortfahren?",
      "mloffice.inaktiv": "Inaktiv",
      "mloffice.keine_partner": "Noch keine MLOffice-Kunden geladen. „Liste aus MLOffice laden“ holt den Bestand.",
      "mloffice.keine_zuordnung": "— keine Zuordnung —",
      "mloffice.konflikt_fehler": "Konnte nicht übernommen werden.",
      "mloffice.konflikt_geloest": "Übernommen.",
      "mloffice.konflikt_hinweis": "Übernahme braucht eine Entscheidung — siehe Konfliktzeile.",
      "mloffice.kopieren": "Kopieren",
      "mloffice.kunde_waehlen": "— Kunde wählen —",
      "mloffice.kunden_erklaerung": "Wähle aus, welche MLOffice-Kunden hier geführt werden. Ausgewählte Kunden werden fortlaufend abgeglichen; ihre Stammdaten sind hier gesperrt. Abwählen entkoppelt nur — der Kunde bleibt bestehen.",
      "mloffice.laden_fehler": "MLOffice-Einstellungen konnten nicht geladen werden.",
      "mloffice.laeufe_titel": "Bisherige Übertragungsläufe",
      "mloffice.lauf_detail": "Lauf #{{id}} — Einzelposten",
      "mloffice.lauf_fehler": "Lauf konnte nicht gestartet werden.",
      "mloffice.lauf_fertig": "Fertig",
      "mloffice.lauf_gestartet": "Übertragungslauf gestartet.",
      "mloffice.lauf_laeuft": "Läuft",
      "mloffice.lauf_starten": "Übertragung starten",
      "mloffice.lauf_teilfehler": "Mit Fehlern",
      "mloffice.linktoken_abgelaufen": "Das Verbindungstoken ist abgelaufen — MLOffice kann sich nicht mehr ausweisen. Neues Token erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_ablauf_teil": ", gültig bis {{datum}}",
      "mloffice.linktoken_einmal": "Jetzt kopieren — dieses Token wird nur EINMAL angezeigt:",
      "mloffice.linktoken_eintragen": "In MLOffice unter Einstellungen → AISupportDesk-Anbindung eintragen.",
      "mloffice.linktoken_erklaerung": "Dieses Token wird HIER erzeugt und in MLOffice unter „AISupportDesk-Anbindung“ eingetragen. MLOffice weist sich damit aus (Verbindungsstatus, Webhooks). Wird die Anbindung hier gelöst oder das Token widerrufen, zeigt MLOffice die Verbindung als gelöst.",
      "mloffice.linktoken_erzeugen": "Token erzeugen",
      "mloffice.linktoken_fehler": "Verbindungstoken konnte nicht erzeugt werden.",
      "mloffice.linktoken_gueltigkeit": "Gültigkeit",
      "mloffice.linktoken_kopiert": "Token kopiert.",
      "mloffice.linktoken_laeuft_ab": "Das Verbindungstoken läuft in {{tage}} Tagen ab. Rechtzeitig neu erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_neu": "Neues Token erzeugen",
      "mloffice.linktoken_rotieren_frage": "Es existiert bereits ein Verbindungstoken. Ein neues macht das alte sofort ungültig — MLOffice muss dann das neue Token eintragen. Fortfahren?",
      "mloffice.linktoken_status": "Hinterlegt ({{hint}}), erzeugt {{erzeugt}}{{ablauf}}.",
      "mloffice.linktoken_titel": "Verbindungstoken für MLOffice",
      "mloffice.linktoken_unbegrenzt_teil": ", unbegrenzt gültig",
      "mloffice.linktoken_widerruf_fehler": "Widerruf fehlgeschlagen.",
      "mloffice.linktoken_widerruf_frage": "Verbindungstoken widerrufen? MLOffice zeigt die Verbindung danach als gelöst; Webhooks und Statusabfragen von MLOffice werden abgewiesen.",
      "mloffice.linktoken_widerrufen": "Verbindungstoken widerrufen.",
      "mloffice.linktoken_widerrufen_btn": "Widerrufen",
      "mloffice.liste_aktualisieren": "Liste aus MLOffice laden",
      "mloffice.loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "mloffice.nur_verknuepfte": "Nur mit MLOffice verknüpfte Kunden.",
      "mloffice.ohne_email": "ohne E-Mail",
      "mloffice.op_aktualisiert": "Offene Posten aktualisiert.",
      "mloffice.op_belege": "Belege",
      "mloffice.op_fehler": "Offene Posten konnten nicht geladen werden.",
      "mloffice.op_laden": "Offene Posten aus MLOffice laden",
      "mloffice.op_stand": "Stand: {{zeit}}",
      "mloffice.op_titel": "Offene Posten (MLOffice)",
      "mloffice.partner_laden_fehler": "MLOffice-Kundenliste konnte nicht geladen werden.",
      "mloffice.posten_ok": "übertragen",
      "mloffice.posten_retry": "Erneut",
      "mloffice.posten_skip": "Überspringen",
      "mloffice.projekt_pflicht": "Bitte oben ein MLOffice-Projekt wählen.",
      "mloffice.projekt_waehlen": "— Projekt wählen —",
      "mloffice.rechte_fehlen": "Dem Token fehlen Rechte:",
      "mloffice.recon_asd": "Support-Sicht (NALVRA SERVICE)",
      "mloffice.recon_diff": "Abweichung Support- zu Abrechnungs-Sicht: {{min}} Min.",
      "mloffice.recon_gebucht": "{{min}} Min. im Projekt „{{projekt}}“ gebucht",
      "mloffice.recon_gesperrt_bis": "Erfassung gesperrt bis: {{d}}",
      "mloffice.recon_kein_projekt": "Kein MLOffice-Projekt zugeordnet (Tab „Zuordnung“).",
      "mloffice.recon_kein_vertrag": "Kein aktiver Vertrag mit Kontingent für diesen Kunden.",
      "mloffice.recon_mlo": "Abrechnungs-Sicht (MLOffice)",
      "mloffice.recon_offen": "{{min}} Min. der laufenden Periode sind noch nicht an MLOffice übertragen — Übertragungslauf im Tab „Zeiten-Übertragung“ starten.",
      "mloffice.recon_titel": "Kontingent-Abgleich",
      "mloffice.recon_verbrauch": "{{used}} von {{incl}} Min. verbraucht — {{rest}} Min. übrig",
      "mloffice.schon_drueben": "übertragen",
      "mloffice.sp_agent": "Agent",
      "mloffice.sp_beschreibung": "Beschreibung",
      "mloffice.sp_datum": "Datum",
      "mloffice.sp_fortschritt": "Gesendet / Fehler / Gesamt",
      "mloffice.sp_kunde": "Kunde",
      "mloffice.sp_minuten": "Min.",
      "mloffice.sp_status": "Status",
      "mloffice.sp_ticket": "Ticket",
      "mloffice.sp_zeitraum": "Zeitraum",
      "mloffice.spalte_kunde": "MLOffice-Kunde",
      "mloffice.spalte_status": "Status",
      "mloffice.spalte_sync": "Sync",
      "mloffice.spalte_zuordnung": "Zuordnung in NALVRA SERVICE",
      "mloffice.speichern": "Speichern",
      "mloffice.speichern_fehler": "Speichern fehlgeschlagen.",
      "mloffice.status_archiviert": "In MLOffice archiviert",
      "mloffice.status_delta": "Letzter Kundenabgleich: {{zeit}}",
      "mloffice.status_entkoppelt": "Entkoppelt",
      "mloffice.status_failed": "{{n}} Übertragungen fehlgeschlagen",
      "mloffice.status_kein_linktoken": "Kein Verbindungstoken für MLOffice erzeugt",
      "mloffice.status_konflikt": "Entscheidung nötig",
      "mloffice.status_linktoken_abgelaufen": "Verbindungstoken abgelaufen — neu erzeugen und in MLOffice eintragen",
      "mloffice.status_neu": "Neu",
      "mloffice.status_op": "Offene Posten: {{zeit}}",
      "mloffice.status_pending": "{{n}} Übertragungen offen",
      "mloffice.status_ratelimit": "MLOffice-Ratenbegrenzung — kurze Pause",
      "mloffice.status_sync_fehler": "Letzter Abgleich mit Fehler",
      "mloffice.status_uebernommen": "Übernommen",
      "mloffice.tab_abrechnung": "Abrechnung",
      "mloffice.tab_kunden": "Kundenabgleich",
      "mloffice.tab_verbindung": "Verbindung",
      "mloffice.tab_zeiten": "Zeiten-Übertragung",
      "mloffice.tab_zuordnung": "Zuordnung",
      "mloffice.techuser_hinweis": "Wird für Zeitbuchungen ohne Agenten-Zuordnung verwendet; der Agentenname wandert dann in die Buchungsbeschreibung.",
      "mloffice.techuser_titel": "Technischer Benutzer (Fallback)",
      "mloffice.test_fehler": "Verbindungstest fehlgeschlagen.",
      "mloffice.test_nicht_verbunden": "Keine Verbindung",
      "mloffice.test_ok": "Verbindung zu MLOffice steht.",
      "mloffice.test_verbunden": "Verbunden mit Mandant „{{tenant}}“",
      "mloffice.testen": "Verbindung testen",
      "mloffice.titel": "MLOffice-Anbindung",
      "mloffice.token": "API-Token",
      "mloffice.token_gesetzt": "hinterlegt ({{hint}})",
      "mloffice.token_hinweis": "In MLOffice unter Einstellungen → API-Tokens anlegen. Benötigte Rechte prüft der Verbindungstest.",
      "mloffice.token_name": "Token: {{name}}",
      "mloffice.token_unveraendert": "Leer lassen = unverändert",
      "mloffice.untertitel": "Kundenstammdaten, Abrechnung, Zeiterfassung und CRM mit MLOffice koppeln. MLOffice ist das führende System für Stammdaten und Rechnungen.",
      "mloffice.users_dropdown": "Zeitbuchungen werden in MLOffice unter dem zugeordneten Benutzer geführt. Ohne Zuordnung greift der technische Benutzer.",
      "mloffice.users_manuell": "MLOffice stellt (noch) keine Benutzerliste bereit — MLOffice-User-UUID bitte manuell eintragen (in MLOffice unter Benutzerverwaltung kopieren).",
      "mloffice.uuid_platzhalter": "MLOffice-User-UUID",
      "mloffice.verbindung": "Verbindung",
      "mloffice.vollabgleich": "Voll-Abgleich starten",
      "mloffice.vorschau": "Vorschau",
      "mloffice.vorschau_anlegen": "Wird neu angelegt",
      "mloffice.vorschau_email_fehlt": "E-Mail fehlt — wird bei Übernahme abgefragt",
      "mloffice.vorschau_fehler": "Vorschau fehlgeschlagen.",
      "mloffice.vorschau_titel": "Vorschau: {{n}} Einträge, {{h}} h werden übertragen",
      "mloffice.vorschau_verknuepfung": "Vorschlag: mit „{{name}}“ verknüpfen ({{grund}})",
      "mloffice.zeiten_erklaerung": "Zeiten werden NICHT automatisch übertragen. Du wählst Kunde und Zeitraum, prüfst die Vorschau und bestätigst — erst dann gehen die Buchungen nach MLOffice. Übertragene Buchungen sind dort unumkehrbar und hier gesperrt.",
      "mloffice.zeitraum_bis_heute": "Bis heute",
      "mloffice.zeitraum_dieser_monat": "Dieser Monat",
      "mloffice.zeitraum_letzter_monat": "Letzter Monat",
      "mloffice.zuordnung_fehler": "Zuordnung konnte nicht gespeichert werden.",
      "mloffice.zuordnung_fehlt": "{{n}} Einträge ohne Agenten-Zuordnung — bitte unter „Zuordnung“ pflegen oder einen technischen Benutzer hinterlegen.",
      "mloffice.zuordnung_gespeichert": "Zuordnung gespeichert.",
      "mobile": "Mobiel",
      "move_ticket": "Verschieben",
      "my_tickets": "Mijn tickets",
      "navbar_search_placeholder": "Zoeken in tickets, klanten of KB...",
      "new": "Nieuw",
      "new_activity_aria": "Nieuwe activiteit",
      "new_activity_title": "Nieuwe activiteit sinds laatste weergave",
      "new_company": "Neue Firma",
      "new_label": "Nieuw",
      "new_ticket": "Nieuw ticket",
      "next": "Weiter",
      "no_activities_recorded": "Nog geen activiteit geregistreerd.",
      "no_canned_responses": "Geen tekstblokken",
      "no_canned_responses_hint": "Te beheren in de administratie.",
      "no_critical_tickets": "Geen kritieke tickets",
      "no_customer_assigned": "Geen klant toegewezen",
      "no_customer_data": "Geen klantgegevens geladen.",
      "no_customers_found": "Geen klanten gevonden",
      "no_customers_matching": "Er zijn geen klanten gevonden voor uw filterselectie of zoekopdracht.",
      "no_data_available": "Geen gegevens beschikbaar",
      "no_employees_found": "Geen medewerkers geregistreerd",
      "no_notes_placeholder": "Geen notities beschikbaar. Klik op \"Bewerken\" om notities toe te voegen.",
      "no_notifications": "Geen meldingen",
      "no_other_agents_online": "Momenteel geen andere teamleden online.",
      "no_results": "Geen resultaten",
      "no_tickets_found": "Geen tickets gevonden",
      "no_tickets_found_desc": "Er zijn momenteel geen items in deze filterwachtrij.",
      "no_tickets_risk": "Momenteel geen tickets in het kritieke SLA-waarschuwingsvenster.",
      "not_spam": "Geen spam",
      "notification_settings": "Notificatie-instellingen",
      "notification_settings_desc": "Kies welke meldingen u wilt ontvangen.",
      "notification_settings_saved": "Notificatie-instellingen opgeslagen.",
      "notifications": "Meldingen",
      "notify_license_change": "Licentiewijzigingen",
      "notify_new_reply": "Nieuwe reacties",
      "notify_new_ticket": "Nieuwe tickets",
      "notify_status_changed": "Statuswijzigingen",
      "observers_title": "Waarnemers",
      "only_visible_for": "Alleen {{name}}",
      "only_visible_to_agents": "Alleen zichtbaar voor medewerkers",
      "open_administration": "Open administratie",
      "open_btn": "Openen",
      "open_password_vault": "Wachtwoordkluis in browser openen",
      "open_quick_search": "Snel zoeken openen",
      "open_tickets": "Open tickets",
      "other_tickets_count": "Overige tickets ({{count}})",
      "other_tickets_requester_count": "Overige tickets van de aanvrager ({{count}})",
      "overdue": "Overtijd",
      "overview_option_1": "1. Standaard KPI-dashboard",
      "overview_option_10": "10. SLA-schendingspercentage op basis van prioriteit",
      "overview_option_2": "2. Eerste-lijns oplossingspercentage (FCR) & reactietijd",
      "overview_option_3": "3. Ticketvolume-ontwikkeling & piekuren",
      "overview_option_4": "4. Oplossingspercentage trends (Gemaakt vs. Opgelost)",
      "overview_option_5": "5. CSAT vs. Oplossingstijd matrix",
      "overview_option_6": "6. Ticketkanalen & bron-uitsplitsing",
      "overview_option_7": "7. Escalatieratio's & escalatiepad-analyse",
      "overview_option_8": "8. Gemiddelde levensduur ticket (veroudering)",
      "overview_option_9": "9. Backlog-status & veroudering",
      "performance_queues": "Prestaties & Wachtrijen",
      "phone": "Telefoon",
      "plan_teams_meeting": "Teams-vergadering plannen",
      "planning": "Planning",
      "please_enter_text": "Voer tekst in",
      "policy": "Beleid",
      "portal_company.load_failed": "Dokumente konnten nicht geladen werden.",
      "portal_company.primary_contact": "Hauptansprechpartner",
      "portal_session.continue": "Weiterarbeiten",
      "portal_session.login": "Erneut anmelden",
      "portal_session.warning": "Ihre Sitzung endet in {{seconds}} Sekunden. Gespeicherte Entwürfe bleiben erhalten.",
      "portal_speech.denied": "Mikrofonzugriff oder Spracherkennung wurde nicht erlaubt. Bitte die Browserberechtigung prüfen.",
      "portal_speech.failed": "Spracheingabe nicht verfügbar. Bitte Mikrofon und Verbindung prüfen oder weitertippen.",
      "portal_speech.listening": "Mikrofon aktiv – bitte sprechen …",
      "portal_speech.notice": "Diktierter Text wird unten an die Beschreibung angefügt. Der Browser kann Audio zur Erkennung an seinen Sprachdienst senden.",
      "portal_speech.silence": "Keine Sprache erkannt. Bitte erneut starten.",
      "portal_speech.start": "Diktat starten",
      "portal_speech.stop": "Stoppen",
      "portal_speech.title": "Spracheingabe",
      "portal_speech.unsupported": "Dieser Browser unterstützt hier keine Spracheingabe. Sie können die Diktierfunktion Ihrer Tastatur verwenden.",
      "preview": "Voorbeeld",
      "previous": "Zurück",
      "primary": "Primair",
      "priority": "Prioriteit",
      "priority_": "",
      "priority_critical": "Kritiek",
      "priority_high": "Hoog",
      "priority_low": "Laag",
      "priority_medium": "Gemiddeld",
      "priority_urgent": "Urgent",
      "problem_cascade_close_checkbox": "Ja, alle gekoppelde incidenten sluiten (aanbevolen)",
      "problem_cascade_close_desc": "Er zijn gekoppelde openstaande incidenten. Wilt u deze automatisch oplossen en voorzien van een opmerking met de bronoorzaak & oplossing?",
      "problem_cascade_close_title": "Kaskade sluiten",
      "problem_confirm_resolve": "Bevestigen & Oplossen",
      "problem_create_btn": "Probleem aanmaken",
      "problem_create_error": "Fout bij maken van probleem",
      "problem_create_success": "Probleemticket gemaakt.",
      "problem_create_title": "Nieuw probleemticket aanmaken",
      "problem_created_by_on": "Gemaakt door {{creator}} op {{date}}",
      "problem_description_label": "Probleembeschrijving",
      "problem_detail_load_error": "Fout bij laden van probleemdetails",
      "problem_incidents_linked": "Gekoppelde incidenten",
      "problem_kedb_empty": "Geen bekende fouten",
      "problem_kedb_empty_desc": "Problemen die als known error zijn geclassificeerd, verschijnen hier met oorzaak en workaround.",
      "problem_kedb_load_error": "Fout bij het laden van de bekende fouten",
      "problem_kedb_search_placeholder": "Bekende fouten doorzoeken...",
      "problem_kedb_title": "Bekende fouten (known errors)",
      "problem_known_error_badge": "Bekende fout",
      "problem_known_error_checkbox": "Klassificeren als Known Error (Bekende fout)",
      "problem_known_error_only": "Alleen bekende fouten",
      "problem_link_btn": "Koppelen",
      "problem_link_error": "Fout bij koppelen van incidenten",
      "problem_link_incident_btn": "Incident koppelen",
      "problem_link_incidents_title": "Incidenten koppelen",
      "problem_link_success": "Incidenten gekoppeld.",
      "problem_linked_incidents": "Gekoppelde incidenten",
      "problem_load_error": "Fout bij laden van problemen",
      "problem_loading": "ITIL Probleembeheer laden...",
      "problem_mark_known_error": "Als Known Error markeren",
      "problem_no_incidents_found": "Geen gekoppelde incidenten gevonden.",
      "problem_no_tickets": "Geen probleemtickets",
      "problem_no_tickets_desc": "Er zijn momenteel geen ITIL-probleemtickets geregistreerd.",
      "problem_no_unlinked_found": "Geen openstaande, ongekoppelde incidenten gevonden.",
      "problem_none": "—",
      "problem_none_selected": "Geen probleem geselecteerd",
      "problem_none_selected_desc": "Selecteer links een ITIL-probleemticket of maak een nieuwe aan om RCA-gegevens te beheren.",
      "problem_open_change_confirm": "Nieuw wijzigingsticket {{num}} nu openen?",
      "problem_raise_change_btn": "Wijziging afleiden",
      "problem_raise_change_error": "Fout bij het afleiden van de wijziging",
      "problem_raise_change_success": "Wijzigingsticket gemaakt: {{num}}",
      "problem_raise_change_title": "Wijziging uit dit probleem afleiden",
      "problem_rca_title": "ITIL-problemen (RCA)",
      "problem_resolution_note": "Oplossingsnotitie",
      "problem_resolution_note_placeholder": "Voer details over de definitieve oplossing in...",
      "problem_resolve_btn": "Probleem oplossen",
      "problem_resolve_error": "Fout bij oplossen van probleem",
      "problem_resolve_success": "Probleem opgelost.",
      "problem_root_cause_label": "Vermoedelijke bronoorzaak",
      "problem_root_cause_short": "Root cause",
      "problem_search_placeholder": "Problemen doorzoeken...",
      "problem_stage_closed": "Gesloten",
      "problem_stage_known_error": "Bekende fout",
      "problem_stage_label": "Lifecyclestatus (problem stage)",
      "problem_stage_open": "Open",
      "problem_stage_resolved": "Opgelost",
      "problem_stage_under_investigation": "In onderzoek",
      "problem_stage_updated": "Lifecyclestatus bijgewerkt.",
      "problem_stage_workaround_found": "Workaround gevonden",
      "problem_tab_kedb": "Known-error-DB (KEDB)",
      "problem_tab_problems": "Problemen (RCA)",
      "problem_title": "ITIL-probleem: Terugkerend incident",
      "problem_title_label": "Probleemtitel",
      "problem_unlink_btn": "Koppeling opheffen",
      "problem_unlink_error": "Fout bij het opheffen van de koppeling",
      "problem_unlink_success": "Koppeling opgeheven.",
      "problem_update_error": "Fout bij bijwerken van probleem",
      "problem_update_success": "Probleem succesvol bijgewerkt.",
      "problem_workaround_label": "Bekende workaround",
      "problem_workaround_short": "Workaround",
      "problems": "Problemen",
      "queue.": "queue.",
      "queue_external_processing": "Externe Bearbeitung",
      "queues": "Wachtrijen",
      "quick_access_views": "Snelle toegang & weergaven",
      "quick_search": "Snel zoeken",
      "read_ticket_also": "leest dit ticket ook",
      "reading_ticket": "Leest ticket #{{id}}",
      "reassign_to": "Opnieuw toewijzen ({{name}})...",
      "recent_activities_description": "Recente ticket- en antwoordactiviteiten voor deze klant.",
      "recent_tickets": "Recente tickets",
      "refresh": "Vernieuwen",
      "remove_assignment": "Toewijzing verwijderen",
      "remove_attachment_aria": "Bijlage {{filename}} verwijderen",
      "remove_filter": "Filter entfernen",
      "reopen": "Heropenen",
      "reply": "Beantwoorden",
      "reply_keyboard_shortcut_hint": "Sneltoets: Ctrl of Cmd + Enter om te verzenden wanneer de cursor in de tekst staat.",
      "report_active_breaches": "Actieve schendingen",
      "report_ai_analysis": "AI-analyse",
      "report_ai_analyzing": "AI analyseert rapportgegevens...",
      "report_ai_highlights": "Opvallende zaken",
      "report_ai_recommendations": "Aanbevelingen",
      "report_billable": "Factureerbaar",
      "report_compliance": "Compliance",
      "report_export": "Exporteren",
      "report_exporting": "Exporteren...",
      "report_no_data": "Geen gegevens beschikbaar",
      "report_no_data_desc": "Er konden geen rapportgegevens worden geladen voor deze periode.",
      "report_range": "Rapportweergave:",
      "report_total_time": "Totale tijd",
      "reports": "Rapporten",
      "reports_desc": "Service Management rapportages & analyse",
      "request.additional_info": "Aanvullende gegevens",
      "request.back_to_dashboard": "Terug naar het dashboard",
      "request.back_to_dashboard_link": "← Dashboard",
      "request.back_to_list": "Naar het overzicht",
      "request.back_to_requests": "← Alle aanvragen",
      "request.catalog_subtitle": "Kies een aanvraagtype — u ontvangt een passend formulier.",
      "request.choose_files": "Bestanden kiezen",
      "request.description_placeholder": "Beschrijf uw vraag…",
      "request.description_required": "Voer een beschrijving in.",
      "request.failed_load_catalog": "Catalogus kon niet worden geladen",
      "request.file_too_large": "Bestand te groot (max. {{max}} MB): {{name}}",
      "request.file_type_not_allowed": "Dateityp nicht erlaubt: {{name}}",
      "request.no_requests": "Er zijn geen serviceaanvragen vrijgegeven in het portaal.",
      "request.not_available": "Deze aanvraag is niet beschikbaar of niet gepubliceerd.",
      "request.optional_select": "— Optioneel —",
      "request.please_select": "— Maak een keuze —",
      "request.remove_file": "Verwijderen",
      "request.required_field": "Verplicht veld: {{label}}",
      "request.standard_fields_info": "Standaardvelden: prioriteit, categorie, beschrijving en bijlagen zijn bij elke serviceaanvraag inbegrepen. Daaronder volgen eventueel aanvullende velden voor dit aanvraagtype.",
      "request.submit_btn": "Aanvraag verzenden",
      "request.submit_failed": "Verzenden mislukt",
      "request.submitting_btn": "Wordt verzonden…",
      "request_type": "Type aanvraag",
      "requester_title": "Aanvrager",
      "reset": "Herstellen",
      "reset_all_filters": "Alle Filter zurücksetzen",
      "reset_filter": "Filter herstellen",
      "reset_kpi_filter": "Kachel-Filter zurücksetzen",
      "reset_to_default": "Standaard herstellen",
      "resolution": "Oplossing",
      "resolve": "Oplossen",
      "resolved_label": "Opgelost",
      "retry": "Erneut versuchen",
      "risk": "Risico",
      "risk_minutes": "{{count}} min",
      "save": "Opslaan",
      "save_changes": "Wijzigingen opslaan",
      "save_note": "Notitie opslaan",
      "saving": "Opslaan...",
      "scroll_to_reply": "Naar antwoord scrollen",
      "search": "Zoeken...",
      "search_canned_responses": "Tekstblokken doorzoeken…",
      "search_customers": "Klanten zoeken...",
      "select_company": "Firma auswählen…",
      "select_customer_placeholder": "Selecteer een klant uit de lijst",
      "self_healing": "Zelfherstel",
      "send": "Verzenden",
      "sending_ellipsis": "Verzenden...",
      "settings": "Instellingen",
      "seven_days": "7 Dagen",
      "shortcut_back_close": "Terug / Sluiten",
      "shortcut_escalate": "Escaleren",
      "shortcut_focus_mode": "Focusmodus",
      "shortcut_help": "Deze hulp",
      "shortcut_internal_note": "Interne notitie",
      "shortcut_next_prev": "Volgend / Vorig ticket",
      "shortcut_quick_search": "Snel zoeken",
      "shortcut_write_reply": "Antwoord schrijven",
      "show_all": "Toon alles",
      "show_full_ticket_backlog": "Volledige ticket-backlog weergeven",
      "show_older_replies": "{{count}} oudere antwoorden weergeven...",
      "sla_and_contract_title": "SLA & Contract",
      "sla_breached_both": "Reactie- en oplossingstermijn overschreden",
      "sla_breached_exclamation": "SLA geschonden!",
      "sla_breached_resolution": "Oplossingstermijn overschreden",
      "sla_breached_response": "Reactietermijn overschreden",
      "sla_breaches": "SLA-schendingen:",
      "sla_compliance": "SLA-naleving",
      "sla_level": "SLA-niveau:",
      "sla_option_1": "1. SLA-naleving & trends (Overzicht)",
      "sla_option_10": "10. SLA weekend- & feestdagenstatistieken",
      "sla_option_2": "2. SLA-schendingen & risicovolle tickets",
      "sla_option_3": "3. SLA op prioriteit",
      "sla_option_4": "4. SLA per klant / serviceplan",
      "sla_option_5": "5. SLA-naleving reactietijd",
      "sla_option_6": "6. SLA-naleving oplossingstijd",
      "sla_option_7": "7. SLA-schendingen per agent/groep",
      "sla_option_8": "8. Oorzaken SLA-schendingen",
      "sla_option_9": "9. Voorbeeld boetes & tegoeden (financieel risico)",
      "sla_performance_breaches": "SLA-prestaties & schendingen",
      "sla_risk": "SLA-risico",
      "sla_status_ok": "OK",
      "sort_by_label": "Sorteren op {{label}}",
      "spam": "Spam",
      "starred": "Met ster",
      "start": "Start",
      "status": "Status",
      "status_closed": "Gesloten",
      "status_in_progress": "In behandeling",
      "status_new": "Nieuw",
      "status_on_hold": "In de wacht",
      "status_open": "Open",
      "status_resolved": "Opgelost",
      "status_waiting": "Wachtend",
      "status_waiting_customer": "Wacht op klant",
      "street": "Straat",
      "subtasks": "Teilaufgaben",
      "supporting_agents": "Ondersteunende agenten",
      "switch_language": "Taal wijzigen",
      "system_logs": "Systeemlogs",
      "tab_": "",
      "tab_activity": "Activiteit",
      "tab_agents": "Agents",
      "tab_assets": "Assets",
      "tab_contracts": "Contracten",
      "tab_csat": "CSAT",
      "tab_custom": "Aangepaste rapporten",
      "tab_customers": "Klanten",
      "tab_documents": "Documenten",
      "tab_employees": "Medewerkers",
      "tab_incidents": "Incidenten",
      "tab_licenses": "Licenties",
      "tab_notes": "Notities",
      "tab_overview": "Overzicht",
      "tab_sla": "SLA",
      "tab_tickets": "Tickets",
      "tab_time": "Tijdregistratie",
      "tab_trends": "Trends",
      "tag_add_placeholder": "Tag toevoegen...",
      "tag_label": "Tag",
      "tax_number": "Belastingnummer",
      "teams_call_start": "Teams-oproep starten",
      "teams_chat_open": "Teams Chat openen",
      "teams_meeting_subject": "Vergadering {{number}}",
      "teams_meeting_title": "Teams-vergadering",
      "thirty_days": "30 Dagen",
      "ticket_assets.action_col": "Actie",
      "ticket_assets.agent_offline": "Agent offline",
      "ticket_assets.agent_ready": "Gereed",
      "ticket_assets.assigned_assets": "Aan de medewerker toegewezen assets",
      "ticket_assets.bios_label": "BIOS-versie:",
      "ticket_assets.calculating_compliance": "Licentieaudit wordt berekend...",
      "ticket_assets.clean_temp": "Temp verwijderen",
      "ticket_assets.cmd_status_completed": "Voltooid",
      "ticket_assets.cmd_status_failed": "Fout",
      "ticket_assets.cmd_status_pending": "Wachtend",
      "ticket_assets.cmd_status_running": "Loopt...",
      "ticket_assets.cmdb_alert_desc": "Dit asset is afhankelijk van/verbonden met:",
      "ticket_assets.cmdb_alert_title": "CMDB-cascadewaarschuwing: afhankelijkheidsstoring!",
      "ticket_assets.command_execution_failed": "Uitvoeren van de opdracht mislukt.",
      "ticket_assets.command_placeholder": "bijv. ipconfig /all, systeminfo, dir",
      "ticket_assets.command_running": "De opdracht wordt momenteel op het clientapparaat uitgevoerd...",
      "ticket_assets.command_success_solved": "Succesvol uitgevoerd! Het ticket is automatisch opgelost.",
      "ticket_assets.command_timeout": "Time-out bij het uitvoeren van de opdracht.",
      "ticket_assets.compliant": "Conform",
      "ticket_assets.confirm_kill_process": "Weet u zeker dat u het proces met PID {{pid}} wilt beëindigen?",
      "ticket_assets.cpu_cores_label": "Kernen:",
      "ticket_assets.cpu_label": "Processor (CPU)",
      "ticket_assets.cpu_sockets_label": "Sockets:",
      "ticket_assets.cpu_util_label": "CPU-gebruik",
      "ticket_assets.created_label": "Gemaakt op:",
      "ticket_assets.device_scan_label": "Apparaatscan",
      "ticket_assets.disk_free_label": "vrij",
      "ticket_assets.disk_used_label": "Bezet",
      "ticket_assets.disks_label": "Harde schijven / stations",
      "ticket_assets.domain_label": "Werkgroep/domein:",
      "ticket_assets.edition_id_label": "Editie-ID:",
      "ticket_assets.employee_assets": "Medewerker-assets",
      "ticket_assets.error_kill_process": "Fout bij het beëindigen van het proces: {{error}}",
      "ticket_assets.error_loading_monitoring": "Fout bij het laden van de monitoring",
      "ticket_assets.error_sending_command": "Fout bij het verzenden van de opdracht.",
      "ticket_assets.error_submit_command": "Opdracht kon niet worden verzonden: {{error}}",
      "ticket_assets.executed_label": "Uitgevoerd:",
      "ticket_assets.fetch_logs_btn": "Logboeken ophalen",
      "ticket_assets.filter_processes_placeholder": "Processen filteren (naam, PID)...",
      "ticket_assets.fix_dns": "DNS herstellen",
      "ticket_assets.fix_spooler": "Spooler herstellen",
      "ticket_assets.hostname_label": "Netwerknaam:",
      "ticket_assets.incomplete_summary": "Compliancesamenvatting onvolledig.",
      "ticket_assets.invalid_json_response": "Ongeldig antwoord van de server",
      "ticket_assets.kill_btn": "Kill",
      "ticket_assets.killing_proc": "Beëindigen...",
      "ticket_assets.last_scan_label": "Laatste scan:",
      "ticket_assets.license_compliance": "Licentiecompliance",
      "ticket_assets.link": "Koppelen",
      "ticket_assets.link_asset_title": "Asset koppelen",
      "ticket_assets.linked": "Gekoppeld",
      "ticket_assets.linked_assets": "Aan het ticket gekoppelde assets",
      "ticket_assets.loading": "Assets worden geladen...",
      "ticket_assets.loading_command_queue": "Opdrachtwachtrij laden...",
      "ticket_assets.loading_logs": "Gebeurtenislogboeken worden geladen...",
      "ticket_assets.loading_monitoring": "Live monitoring & CMDB-controle laden...",
      "ticket_assets.log_name_label": "Lognaam",
      "ticket_assets.memory_col": "Werkgeheugen",
      "ticket_assets.model_label": "Model:",
      "ticket_assets.monitored_ok": "Gemonitord (OK)",
      "ticket_assets.more_params_title": "Meer parameters",
      "ticket_assets.motherboard_label": "Moederbord:",
      "ticket_assets.no_active_zabbix_alerts": "Geen actieve Zabbix-alarmen.",
      "ticket_assets.no_assets_assigned": "Aan deze medewerker zijn geen IT-assets toegewezen.",
      "ticket_assets.no_assets_linked": "Geen assets gekoppeld.",
      "ticket_assets.no_commands_executed": "Nog geen opdrachten uitgevoerd. Voer hieronder een opdracht in.",
      "ticket_assets.no_compliance_available": "Geen licenties of compliancerapport beschikbaar.",
      "ticket_assets.no_employee_assigned": "Geen medewerker aan het ticket toegewezen.",
      "ticket_assets.no_hardware_details": "Geen hardwaredetails gescand.",
      "ticket_assets.no_matching_software": "Geen overeenkomende software-items gevonden.",
      "ticket_assets.no_monitoring_data": "Geen monitoringgegevens beschikbaar",
      "ticket_assets.os_arch_label": "Architectuur:",
      "ticket_assets.os_label": "Besturingssysteem",
      "ticket_assets.os_ver_label": "Versie:",
      "ticket_assets.overlicensed": "Overgelicentieerd",
      "ticket_assets.pagination_text": "Pagina {{page}} van {{total}} ({{count}} items)",
      "ticket_assets.process_name_col": "Procesnaam",
      "ticket_assets.publisher_col": "Uitgever",
      "ticket_assets.query_realtime_btn": "Realtime opvragen",
      "ticket_assets.ram_label": "Werkgeheugen (RAM)",
      "ticket_assets.ram_util_label": "RAM-gebruik",
      "ticket_assets.scan_details_btn": "Scandetails",
      "ticket_assets.scan_never": "nooit",
      "ticket_assets.search_logs_placeholder": "Resultaten doorzoeken (bron, ID, message)...",
      "ticket_assets.search_placeholder": "Naam, IP of S/N zoeken...",
      "ticket_assets.search_software_placeholder": "Software doorzoeken...",
      "ticket_assets.self_healing_title": "Zelfherstel & automatisering",
      "ticket_assets.send_btn": "Verzenden",
      "ticket_assets.sending_command_failed": "Verzenden van de opdracht mislukt.",
      "ticket_assets.serial_number_label": "Serienummer:",
      "ticket_assets.severity_all": "Alle",
      "ticket_assets.severity_error": "Fout (Error)",
      "ticket_assets.severity_info": "Informatie",
      "ticket_assets.severity_label": "Ernstgraad",
      "ticket_assets.severity_warning": "Waarschuwing (Warning)",
      "ticket_assets.sn_label": "S/N:",
      "ticket_assets.software_name_col": "Softwarenaam",
      "ticket_assets.sql_instance_label": "Instantie:",
      "ticket_assets.sql_instances_title": "Herkende SQL Server-instanties",
      "ticket_assets.sql_patchlevel_label": "Patchlevel:",
      "ticket_assets.success_kill_process": "Proces succesvol beëindigd.",
      "ticket_assets.surplus_label": "Overschot:",
      "ticket_assets.timeout_kill_process": "Time-out bij het beëindigen van het proces.",
      "ticket_assets.total_ram_desc": "Totaal fysiek geheugen",
      "ticket_assets.underlicensed": "Ondergelicentieerd",
      "ticket_assets.unlink_asset_title": "Koppeling opheffen",
      "ticket_assets.unreachable": "Niet bereikbaar",
      "ticket_assets.version_col": "Versie",
      "ticket_assets.virtualization_label": "Virtualisatie:",
      "ticket_assets.waiting_agent_response": "Wachten op antwoord van de agent...",
      "ticket_assets.waiting_agent_timeout": "Time-out: de agent heeft niet op tijd geantwoord.",
      "ticket_assets.zabbix_live_status": "Zabbix live-status",
      "ticket_created": "Ticket aangemaakt",
      "ticket_detail.achtung_ueberschneidungskollisionen_ci_abhae": "Let op: overlappingsconflicten (CI-afhankelijkheden) gedetecteerd!",
      "ticket_detail.aktivitaeten": "Activiteiten",
      "ticket_detail.aktivitaets_verlauf": "Activiteitenhistorie",
      "ticket_detail.als_diesen_kunden_im_portal_anmelden": "Als deze klant aanmelden in het portaal",
      "ticket_detail.anhaenge": "Bijlagen",
      "ticket_detail.begruendung_kommentare": "Motivering / opmerkingen",
      "ticket_detail.bekannter_fehler_workaround_verfuegbar": "Bekende fout — workaround beschikbaar",
      "ticket_detail.cab_hat_die_aenderung_abgelehnt": "CAB heeft de wijziging afgewezen",
      "ticket_detail.change_advisory_board_cab_stimmen": "Stemmen van het Change Advisory Board (CAB)",
      "ticket_detail.das_ticket_existiert_nicht_oder_wurde_geloes": "Het ticket bestaat niet of is verwijderd.",
      "ticket_detail.der_status_kann_erst_auf_in_bearbeitung_oder": "De status kan pas op “In behandeling” of “Opgelost” worden gezet zodra de CAB-meerderheid heeft ingestemd.",
      "ticket_detail.detaillierte_schritte_zur_durchfuehrung": "Gedetailleerde stappen voor de uitvoering...",
      "ticket_detail.es_wurde_noch_kein_change_plan_fuer_dieses_t": "Er is nog geen wijzigingsplan voor dit ticket gemaakt.",
      "ticket_detail.es_wurden_andere_aktive_tickets_auf_denselbe": "Er zijn andere actieve tickets gepland op dezelfde of afhankelijke CMDB-assets in dezelfde periode:",
      "ticket_detail.extrahierte_daten": "Geëxtraheerde gegevens",
      "ticket_detail.geplanter_start_wartungsfenster": "Geplande start (onderhoudsvenster)",
      "ticket_detail.geplantes_ende": "Gepland einde",
      "ticket_detail.geplantes_wartungsfenster": "Gepland onderhoudsvenster:",
      "ticket_detail.hinzufuegen": "Toevoegen",
      "ticket_detail.keine_aktivitaeten_vorhanden": "Geen activiteiten aanwezig",
      "ticket_detail.keine_anhaenge_vorhanden": "Geen bijlagen aanwezig",
      "ticket_detail.keine_kategorie": "Geen categorie",
      "ticket_detail.kommentar_zur_entscheidung_optional": "Opmerking bij het besluit (optioneel)...",
      "ticket_detail.loeschen": "Verwijderen",
      "ticket_detail.niemand_zugewiesen": "Niemand toegewezen",
      "ticket_detail.noch_keine_stimmen_abgegeben": "Er zijn nog geen stemmen uitgebracht.",
      "ticket_detail.noch_keine_zeit_erfasst": "Nog geen tijd geregistreerd",
      "ticket_detail.nur_fuer_mitarbeiter_sichtbar": "Alleen zichtbaar voor medewerkers",
      "ticket_detail.prioritaet": "Prioriteit",
      "ticket_detail.sprachnotizen_in_administration_ki_einstellu": "Spraaknotities activeren via Administratie → AI-instellingen.",
      "ticket_detail.sprachnotizen_nicht_aktiv": "Spraaknotities niet actief",
      "ticket_detail.stimme_uebermitteln": "Stem uitbrengen",
      "ticket_detail.tag_entfernen": "Tag verwijderen",
      "ticket_detail.tag_hinzufuegen": "Tag toevoegen…",
      "ticket_detail.tag_hinzufuegen_2": "Tag toevoegen",
      "ticket_detail.ticket_nicht_gefunden": "Ticket niet gevonden",
      "ticket_detail.ticket_wird_geladen": "Ticket wordt geladen...",
      "ticket_detail.timer_laeuft_fuer_anderes_ticket": "Timer loopt voor een ander ticket",
      "ticket_detail.timer_starten": "Timer starten",
      "ticket_detail.timer_stoppen": "Timer stoppen",
      "ticket_detail.uebersicht": "Overzicht",
      "ticket_detail.veroeffentlicht": "Gepubliceerd",
      "ticket_detail.was_wurde_erledigt": "Wat is er gedaan?",
      "ticket_detail.welches_risiko_besteht_fuer_den_betrieb": "Welk risico bestaat er voor de bedrijfsvoering?",
      "ticket_detail.wie_machen_wir_aenderungen_rueckgaengig": "Hoe maken we wijzigingen ongedaan?",
      "ticket_detail.wie_wird_die_funktion_verifiziert": "Hoe wordt de functie geverifieerd?",
      "ticket_detail.zeiteintraege": "Tijdregistraties",
      "ticket_detail.zugewiesen_an": "Toegewezen aan",
      "ticket_detail.zugewiesen_an_2": "Toegewezen aan",
      "ticket_detail.zurueck_zur_uebersicht": "Terug naar het overzicht",
      "ticket_detail.zustimmung_des_change_advisory_boards_cab_zw": "Goedkeuring van het Change Advisory Board (CAB) is verplicht",
      "ticket_filter_active_label": "Filter aktiv",
      "ticket_inventory_kpis": "Kennzahlen & Arbeitslast",
      "ticket_properties_title": "Ticket",
      "ticket_relations": "Verknüpfte Tickets",
      "ticket_view_search_label": "Diese Ticketansicht durchsuchen",
      "tickets": "Tickets",
      "tickets_exist_hint": "Insgesamt sind {{count}} Tickets vorhanden.",
      "tickets_near_sla_breach": "Tickets bijna in SLA-overschrijding",
      "tickets_plural": "{{count}} tickets",
      "tickets_ratio_label": "{{count}} van de {{total}} tickets",
      "tickets_selected": "{{count}} tickets geselecteerd",
      "tickets_without_assignee": "Tickets zonder behandelaar",
      "time_logged": "Tijd geregistreerd: {{time}}",
      "time_minutes": "Zeit in Minuten",
      "title": "Titel",
      "to_reply_composer": "Naar antwoord (Composer)",
      "today_due": "Vandaag vervallen",
      "toggle_design_mode": "Wissel ontwerpmodus",
      "toggle_favorite": "Favoriet in-/uitschakelen",
      "tracked_hours": "{{hours}} uur",
      "tracked_hours_min": "{{hours}} uur {{minutes}} min.",
      "tracked_min": "{{minutes}} min.",
      "tracked_time": "Geregistreerde tijd",
      "unassigned": "Niet toegewezen",
      "unlink_asset": "Ontkoppelen",
      "unread": "Ongelezen",
      "update": "Bijwerken",
      "updated_at": "Bijgewerkt",
      "urgent": "Urgent",
      "user_profile_logout": "Gebruikersprofiel & Afmelden",
      "vat_id": "Btw-identificatienummer",
      "views": "Weergaven",
      "voice_notes_admin_hint": "Spraaknotities: Schakel 'Spraaknotities' in onder Administratie → AI-instellingen.",
      "voice_notes_enable_info": "Schakel spraaknotities in onder Administratie → AI-instellingen (schakelaar 'Spraaknotities').",
      "voice_notes_not_active": "Spraaknotities niet actief",
      "website": "Website",
      "widget_critical_tickets": "Kritieke tickets (Brandweer)",
      "widget_group_analytics_team": "Analyses & Team",
      "widget_group_overview_performance": "Overzicht & Prestaties",
      "widget_group_volume_trends": "Volume & Trends",
      "widget_my_open_tickets": "Mijn open tickets",
      "widget_performance_times": "Prestatietijden & inspanning",
      "widget_priority_chart": "Prioriteitsverdeling",
      "widget_sla_compliance": "SLA-naleving & risico",
      "widget_status_chart": "Verdeling ticketstatus",
      "widget_team_presence": "Teampresentie & activiteit",
      "widget_ticket_trends": "Tickettrends & volume",
      "widget_top_customers": "Topklanten op basis van tickets",
      "zip_code": "Postcode"
    }
  },
  "be": {
    "translation": {
      "access_denied": "Toegang geweigerd",
      "access_denied_desc": "U hebt agent- of administratorrechten nodig.",
      "actions": "Acties",
      "activate_dark_mode": "Donker thema activeren",
      "activate_light_mode": "Licht thema activeren",
      "active": "Actief",
      "active_filters": "Aktive Filter",
      "active_open_assignments": "Actieve, openstaande toewijzingen",
      "activity_optional": "Activiteit (optioneel)",
      "admin": "Admin",
      "admin_dashboard.administrative_berechtigungen": "Administratieve machtigingen",
      "admin_dashboard.aendern": "Wijzigen",
      "admin_dashboard.agent_deaktiviert": "Agent gedeactiveerd",
      "admin_dashboard.agent_erstellt": "Agent aangemaakt",
      "admin_dashboard.agent_gespeichert": "Agent opgeslagen",
      "admin_dashboard.agent_ohne_zuordnung_hinweis": "Zonder toewijzing ziet deze agent {{umfang}} klanten. Zodra er minstens één klant is toegewezen, is de agent beperkt tot die klanten — tickets, rapporten en assets.",
      "admin_dashboard.agenten_in_der_kundenkonsole": "Agenten in de klantenconsole",
      "admin_dashboard.aktuelles_passwort": "Huidig wachtwoord",
      "admin_dashboard.alle_eingehenden_befehle_wurden_bereits_vera": "Alle binnenkomende opdrachten zijn al verwerkt of vrijgegeven.",
      "admin_dashboard.alle_kunden": "Alle klanten",
      "admin_dashboard.als_hauptkategorie_erstellen": "Als hoofdcategorie aanmaken",
      "admin_dashboard.api_token_hinweis": "Maak indien nodig vooraf een API-token aan op het tabblad {{reiter}} met de scope {{scope}}.",
      "admin_dashboard.aufloesungszeit": "Oplossingstijd *",
      "admin_dashboard.basic_auth_benutzername_passwort": "Basic Auth (gebruikersnaam/wachtwoord)",
      "admin_dashboard.bei_prefix_u00c4nderung_werden_alle_bestehen": "Bij een wijziging van de prefix worden alle bestaande tickets automatisch hernoemd.",
      "admin_dashboard.benoetigte_berechtigung": "Vereiste machtiging:",
      "admin_dashboard.bestaetigen": "Bevestigen",
      "admin_dashboard.bezeichnung_positionszeile": "Omschrijving factuurlijn",
      "admin_dashboard.bitte_kunde_waehlen": "Kies een klant...",
      "admin_dashboard.bitte_kunde_waehlen_2": "Kies een klant...",
      "admin_dashboard.definieren_sie_hauptkategorien_und_bis_zu_zw": "Definieer hoofdcategorieën en tot twee niveaus van subcategorieën. Deze worden bij het aanmaken van een ticket ter keuze aangeboden.",
      "admin_dashboard.definiert_die_standard_reihenfolge_der_queue": "Bepaalt de standaardvolgorde van de wachtrijen in de agentzijbalk.",
      "admin_dashboard.details_anzeigen": "Details weergeven",
      "admin_dashboard.details_anzeigen_2": "Details weergeven",
      "admin_dashboard.die_smtp_einstellungen_fuer_den_e_mail_versa": "De SMTP-instellingen voor het verzenden van e-mail worden nu centraal beheerd onder",
      "admin_dashboard.e_mail_versand_smtp_wird_unter_e_mail_einste": "E-mailverzending (SMTP) wordt geconfigureerd onder E-mailinstellingen",
      "admin_dashboard.eine_sicherheitsgruppe_legt_fest_welche_kons": "Een beveiligingsgroep bepaalt welke consolemodules een agent ziet. „Volledige toegang\" = alle modules. Adminrechten staan daar los van.",
      "admin_dashboard.einstellungen_speichern": "Instellingen opslaan",
      "admin_dashboard.eintraege": "Items",
      "admin_dashboard.endgeraet": "Eindtoestel",
      "admin_dashboard.endgueltig_loeschen": "Endgültig löschen",
      "admin_dashboard.entwurfsrechnung_aus_zeiteintraegen": "Ontwerpfactuur uit tijdsregistraties",
      "admin_dashboard.erstellen_sie_ihre_erste_automatisierung": "Maak uw eerste automatisering aan",
      "admin_dashboard.erstellen_sie_oben_ihre_erste_hauptkategorie": "Maak hierboven uw eerste hoofdcategorie aan",
      "admin_dashboard.externer_mitarbeiter_dienstleister": "Externe medewerker / dienstverlener",
      "admin_dashboard.fehler_beim_deaktivieren": "Fout bij het deactiveren",
      "admin_dashboard.fehler_beim_deaktivieren_2": "Fout bij het deactiveren",
      "admin_dashboard.fehler_beim_deaktivieren_3": "Fout bij het deactiveren",
      "admin_dashboard.fehler_beim_loeschen": "Fout bij het verwijderen",
      "admin_dashboard.firma_adresse_kontakt_steuernummern_in_der_u": "Firma, adres, contact en fiscale nummers zijn aanpasbaar in het overzicht. Klanten deactiveren blijft voorbehouden aan de administrator.",
      "admin_dashboard.fuer_entra_id_benoetigen_sie_eine_app_regist": "Voor Entra ID hebt u een app-registratie in de Azure Portal nodig met de machtiging Mail.Read.",
      "admin_dashboard.geloescht": "Verwijderd",
      "admin_dashboard.geloescht_2": "Verwijderd",
      "admin_dashboard.installationspaket_herunterladen": "Installatiepakket downloaden",
      "admin_dashboard.kategorie_aktualisiert": "Categorie bijgewerkt",
      "admin_dashboard.kategorie_erstellt": "Categorie aangemaakt",
      "admin_dashboard.kategorie_geloescht": "Categorie verwijderd",
      "admin_dashboard.keine_abteilung": "Geen afdeling",
      "admin_dashboard.keine_ausstehenden_befehls_freigaben_vorhand": "Er zijn geen openstaande goedkeuringen van opdrachten.",
      "admin_dashboard.keine_workflows_konfiguriert": "Geen workflows geconfigureerd",
      "admin_dashboard.keine_zuordnung_dieser_agent_sieht_alle_kund": "Geen toewijzing — deze agent ziet alle klanten.",
      "admin_dashboard.konfigurieren_sie_sprachmodelle_auto_respons": "Configureer taalmodellen, auto-responsprompts en systeemsjablonen",
      "admin_dashboard.kunde_auswaehlen": "Klant selecteren *",
      "admin_dashboard.kunde_deaktiviert": "Klant gedeactiveerd",
      "admin_dashboard.kunde_erstellt": "Klant aangemaakt",
      "admin_dashboard.kunde_geloescht": "Kunde „{{firma}}\" wurde endgültig gelöscht",
      "admin_dashboard.kunde_gespeichert": "Klant opgeslagen",
      "admin_dashboard.kunde_waehlen": "Klant kiezen…",
      "admin_dashboard.kundenzuordnung_verwalten": "Klanttoewijzing beheren",
      "admin_dashboard.laden_sie_ein_fertiges_zip_archiv_fuer": "Download een kant-en-klaar ZIP-archief voor",
      "admin_dashboard.laedt": "Laden…",
      "admin_dashboard.laengengrad": "Lengtegraad",
      "admin_dashboard.legen_sie_fest_welche_daten_der_installierte": "Bepaal welke gegevens de geïnstalleerde agent verzamelt en configureer de optionele agentloze netwerkscanner (subnetping).",
      "admin_dashboard.letzte_exporte": "Laatste exports",
      "admin_dashboard.lexoffice_artikel_uuid_optional_dienstleistu": "Lexoffice artikel-UUID (optioneel, dienstverlening)",
      "admin_dashboard.lexoffice_deaktiviert_hinweis": "De LexOffice-integratie is momenteel uitgeschakeld. U kunt pas factuurconcepten aanmaken zodra u de integratie onder {{bereich}} inschakelt en configureert.",
      "admin_dashboard.lexoffice_einstellungen_konnten_nicht_gelade": "De Lexoffice-instellingen konden niet worden geladen (migratie uitvoeren / server herstarten).",
      "admin_dashboard.loeschen": "Verwijderen",
      "admin_dashboard.loeschen_2": "Verwijderen",
      "admin_dashboard.mailbox_empfang_imap_oauth_wird_unter_postfa": "Mailboxontvangst (IMAP/OAuth) wordt geconfigureerd onder Mailboxen",
      "admin_dashboard.mailbox_speichern": "Mailbox opslaan",
      "admin_dashboard.microsoft_graph_api": "Microsoft Graph API",
      "admin_dashboard.mit_einem_frisch_generierten_api_schluessel": "met een vers gegenereerde API-sleutel en een",
      "admin_dashboard.mitarbeiter_deaktiviert": "Medewerker gedeactiveerd",
      "admin_dashboard.mitarbeiter_erstellt": "Medewerker aangemaakt",
      "admin_dashboard.mitarbeiter_gespeichert": "Medewerker opgeslagen",
      "admin_dashboard.mloffice_gefuehrt": "Stammdaten werden von MLOffice geführt",
      "admin_dashboard.mloffice_geloest": "Mit MLOffice verknüpft — Abgleich derzeit gelöst",
      "admin_dashboard.module_assets": "Assets",
      "admin_dashboard.module_calendar": "Kalender",
      "admin_dashboard.module_customers": "Klanten",
      "admin_dashboard.module_knowledge": "Kennisbank",
      "admin_dashboard.module_licenses": "Licenties",
      "admin_dashboard.module_problems": "Problemen",
      "admin_dashboard.module_reports": "Rapporten",
      "admin_dashboard.module_tickets": "Tickets",
      "admin_dashboard.nach_kunde_filtern": "Filteren op klant",
      "admin_dashboard.neue_mailbox_konfiguration": "Nieuwe mailboxconfiguratie",
      "admin_dashboard.neuer_workflow": "Nieuwe workflow",
      "admin_dashboard.neues_passwort": "Nieuw wachtwoord",
      "admin_dashboard.nicht_abrechenbar": "Niet factureerbaar",
      "admin_dashboard.noch_keine_kategorien_definiert": "Nog geen categorieën gedefinieerd",
      "admin_dashboard.noch_keine_zeiteintraege_vorhanden": "Nog geen tijdsregistraties aanwezig",
      "admin_dashboard.nur_abrechenbare_eintraege_ohne_vorherigen_l": "Enkel factureerbare items zonder eerdere Lexoffice-export; optioneel filteren op contract-ID.",
      "admin_dashboard.optionale_beschreibung_des_sla_umfangs": "Optionele beschrijving van de SLA-omvang",
      "admin_dashboard.passwort_aendern": "Wachtwoord wijzigen",
      "admin_dashboard.primaer": "Primair",
      "admin_dashboard.prioritaet_geaendert": "• Prioriteit gewijzigd",
      "admin_dashboard.pruefinterval_minuten": "Controle-interval (minuten)",
      "admin_dashboard.refresh_token": "Refresh token",
      "admin_dashboard.sie_koennen_den_agenten_auch_manuell_registr": "U kunt de agent ook manueel registreren. Gebruik daarvoor de volgende syntaxis op de client (vereist administratorrechten):",
      "admin_dashboard.standardmaessig_duerfen_agenten_kunden_stamm": "Standaard mogen agenten klantstamgegevens enkel lezen en klantdocumenten enkel inkijken. Hier kunt u uitgebreide schrijfrechten per instelling activeren.",
      "admin_dashboard.status_geaendert": "• Status gewijzigd",
      "admin_dashboard.stundensatz_ueberschreiben_optional": "Uurtarief overschrijven (optioneel)",
      "admin_dashboard.tarif_erweitern": "Tarief uitbreiden",
      "admin_dashboard.ticket_id_format_und_admin_passwort_koennen": "Ticket-ID-formaat en adminwachtwoord kunnen hier worden geconfigureerd",
      "admin_dashboard.top_kunden_nach_ticketvolumen": "Topklanten op ticketvolume",
      "admin_dashboard.uebergeordnete_kategorie": "Bovenliggende categorie",
      "admin_dashboard.unterkategorie_hinzufuegen": "Subcategorie toevoegen",
      "admin_dashboard.upload_metadaten_bearbeiten_und_loeschen_von": "Uploaden, metadata aanpassen en bestanden verwijderen in het klanttabblad „Documenten“.",
      "admin_dashboard.verfuegbare_trigger": "Beschikbare triggers",
      "admin_dashboard.verwalten_und_genehmigen_sie_ausstehende_adm": "Beheer openstaande administratieve opdrachten van andere administrators en keur ze goed vóór de uitvoering op de clienteindtoestellen.",
      "admin_dashboard.voller_zugriff_alle_module": "Volledige toegang (alle modules)",
      "admin_dashboard.vorkonfiguriertes_paket_zip": "Voorgeconfigureerd pakket (.zip)",
      "admin_dashboard.was_bedeuten_die_gruppen": "Wat betekenen de groepen?",
      "admin_dashboard.workflow_automatisierungen": "Workflowautomatiseringen",
      "admin_dashboard.z_b_hauptsitz_koeln": "bijv. hoofdzetel Keulen",
      "admin_dashboard.zeit_standardmaessig_abrechenbar": "Tijd standaard factureerbaar",
      "admin_dashboard.zeitbuchung_bei_ticket_schliessung_erforderl": "Tijdsregistratie vereist bij het sluiten van een ticket",
      "admin_dashboard.zeitbuchungen_erscheinen_hier_sobald_agenten": "Tijdsregistraties verschijnen hier zodra agenten tijd registreren op tickets.",
      "admin_dashboard.zeiteintraege": "Tijdsregistraties",
      "admin_dashboard.zeiterfassung_aktivieren": "Tijdsregistratie activeren",
      "admin_dashboard.zeiterfassung_einstellungen": "Instellingen tijdsregistratie",
      "admin_dashboard.zugriff_verweigert": "Toegang geweigerd",
      "admin_dashboard.zugriff_verweigert_text": "U beschikt niet over de administratieve rechten die nodig zijn om het gedeelte {{bereich}} te bekijken of te beheren.",
      "admin_dashboard.zuordnung_entfernen": "Toewijzing verwijderen",
      "admin_dashboard.zusaetzliche_admin_rechte": "Bijkomende adminrechten",
      "admin_default": "Admin-standaard",
      "admin_only_change": "(alleen een beheerder kan de toewijzing wijzigen.)",
      "admin_overview.aktive_warnungen_risiken": "Actieve waarschuwingen & risico's",
      "admin_overview.alles_in_ordnung": "Alles in orde",
      "admin_overview.datenbank_engine": "Database-engine",
      "admin_overview.einstellungen_filtern": "Instellingen filteren...",
      "admin_overview.hinweis_fuer_administratoren": "Opmerking voor administrators:",
      "admin_overview.keine_ergebnisse_gefunden": "Geen resultaten gevonden",
      "admin_overview.keine_warnungen_oder_kritischen_meldungen": "Geen waarschuwingen of kritieke meldingen.",
      "admin_overview.lade_dashboard_daten": "Dashboardgegevens laden...",
      "admin_overview.system_status": "Systeemstatus",
      "admin_overview.upgrade_erforderlich": "Upgrade vereist",
      "admin_overview.upgrade_erforderlich_2": "Upgrade vereist",
      "admin_overview.versuchen_sie_es_mit_einem_anderen_suchbegri": "Probeer een andere zoekterm.",
      "admin_overview.zurueck_zum_agent_dashboard": "Terug naar het agentdashboard",
      "admin_view": "Adminweergave",
      "administration": "Administratie",
      "administrator": "Beheerder",
      "agent": "Agent",
      "agent_available": "Beschikbaar",
      "agent_console": "Agentenconsole",
      "agent_console.alle_als_gelesen": "Alles als gelezen",
      "agent_console.anhaenge": "Bijlagen",
      "agent_console.anhaenge_zum_eroeffnungsbeitrag": "Bijlagen bij het openingsbericht",
      "agent_console.back_to_ticket_list": "Zurück zur Liste",
      "agent_console.beschreiben_sie_hier_details_die_dem_partner": "Beschrijf hier de details die aan de partner moeten worden meegedeeld...",
      "agent_console.bitte_waehlen": "-- Maak een keuze --",
      "agent_console.detailansicht_schliessen": "Detailweergave sluiten",
      "agent_console.erneut_oeffnen": "Heropenen",
      "agent_console.hinweis_der_partner_erhaelt_eine_benachricht": "Opmerking: de partner ontvangt een meldingsmail met uw gegevens en een beveiligde link om het ticket te behandelen.",
      "agent_console.interner_chat": "Interne chat",
      "agent_console.interner_chat_2": "Interne chat",
      "agent_console.keine_benachrichtigungen": "Geen meldingen",
      "agent_console.language_selection": "Taalkeuze",
      "agent_console.loesen": "Oplossen",
      "agent_console.mir_zuweisen": "Aan mij toewijzen",
      "agent_console.nachricht_notiz_fuer_den_partner_optional": "Bericht / notitie voor de partner (optioneel)",
      "agent_console.neues_ticket": "Nieuw ticket",
      "agent_console.neues_ticket_2": "Nieuw ticket",
      "agent_console.partner_dienstleister_waehlen": "Partnerdienstverlener kiezen",
      "agent_console.schliessen": "Sluiten",
      "agent_console.schliessen_2": "Sluiten",
      "agent_console.schliessungsgrund": "Reden van sluiting:",
      "agent_console.schnellsuche_oeffnen": "Snelzoeken openen",
      "agent_console.sie_benoetigen_agent_oder_admin_rechte": "U hebt agent- of adminrechten nodig.",
      "agent_console.tastenkuerzel": "Sneltoetsen",
      "agent_console.ticket_erstellt": "Ticket aangemaakt",
      "agent_console.ticket_schliessen": "Ticket sluiten",
      "agent_console.zugriff_verweigert": "Toegang geweigerd",
      "agent_console.zur_antwort_composer": "Naar het antwoord (composer)",
      "agent_console.zur_antwort_scrollen": "Naar het antwoord scrollen",
      "agent_console.zusammenfuehren": "Zusammenführen",
      "agent_console.zuweisung_entfernen": "Toewijzing verwijderen",
      "ai": "AI",
      "ai_analysis_running": "Analyse wordt uitgevoerd...",
      "ai_assistance": "AI-assistentie",
      "ai_confidence_label": "{{pct}}% betrouwbaarheid",
      "ai_context_title": "KI-Kontext & Prognosen",
      "ai_generate_summary": "Samenvatting generieren",
      "ai_key_points": "Belangrijkste punten",
      "ai_next_steps": "Volgende stappen",
      "ai_requested_action": "Gevraagde actie",
      "ai_risks": "Risico's",
      "ai_solution_assistant_title": "AI-oplossingsassistent",
      "ai_stale": "Verouderd",
      "ai_summary_title": "AI-samenvatting",
      "all": "Alle",
      "all_active_tickets": "Alle actieve tickets",
      "all_categories": "Alle categorieën",
      "all_customers": "Alle klanten",
      "all_deadlines_ok": "Alle deadlines vallen binnen het tijdsbestek.",
      "all_open": "Alle openstaande",
      "all_tickets": "Alle tickets",
      "allgemein.abbrechen": "Abbrechen",
      "allgemein.schliessen": "Schließen",
      "analyze_again": "Opnieuw analyseren",
      "article": "Artikel",
      "article_ai_generate": "Artikel maken met AI",
      "article_ai_generate_btn": "Artikel genereren",
      "article_ai_generate_desc": "Beschrijf het onderwerp en de AI genereert een concept",
      "article_ai_improve": "Tekst verbeteren",
      "article_ai_keywords": "Trefwoorden (optioneel)",
      "article_ai_keywords_placeholder": "bijv. Windows 11, OpenVPN, certificaat",
      "article_ai_language": "Taal",
      "article_ai_len_long": "Lang / uitgebreid",
      "article_ai_len_medium": "Gemiddeld",
      "article_ai_len_short": "Kort",
      "article_ai_length": "Lengte",
      "article_ai_style": "Taalstijl",
      "article_ai_style_balanced": "Evenwichtig",
      "article_ai_style_enduser": "Eindgebruiker (stap voor stap)",
      "article_ai_style_formal": "Formeel",
      "article_ai_style_simple": "Eenvoudig / makkelijk te begrijpen",
      "article_ai_style_technical": "Technisch (IT-professionals)",
      "article_ai_summarize": "Samenvatting genereren",
      "article_ai_topic": "Onderwerp *",
      "article_ai_topic_placeholder": "bijv. VPN-verbinding instellen op Windows",
      "article_all_customers": "Alle klanten",
      "article_all_statuses": "Alle statussen",
      "article_all_visible": "Zichtbaar voor alle klanten",
      "article_archived": "Gearchiveerd",
      "article_category": "Categorie",
      "article_content_placeholder": "Begin hier met het schrijven van uw artikel...",
      "article_create_first": "Eerste artikel maken",
      "article_create_first_desc": "Maak uw eerste kennisartikel om informatie te delen met uw team.",
      "article_create_with_ai": "Maken met AI",
      "article_delete_confirm": "Weet u zeker dat u dit artikel wilt verwijderen?",
      "article_draft": "Ontwerp",
      "article_excerpt_placeholder": "Een korte samenvatting van het artikel...",
      "article_manage": "Artikelen beheren",
      "article_new": "Nieuw artikel",
      "article_no_articles": "Nog geen artikelen beschikbaar",
      "article_no_categories_desc": "Geen categorieën beschikbaar. Maak ze aan in het beheerdersgedeelte.",
      "article_no_category": "Geen categorie",
      "article_not_found": "Geen artikelen gevonden",
      "article_not_found_desc": "Er zijn geen artikelen gevonden voor uw zoekopdracht.",
      "article_only_visible": "Alleen zichtbaar voor {{name}}",
      "article_pinned": "Vastgepind",
      "article_pinned_desc": "Wordt bovenaan de lijst weergegeven",
      "article_plural": "Alle artikelen",
      "article_published": "Gepubliceerd",
      "article_search": "Artikelen zoeken...",
      "article_views": "weergaven",
      "article_visibility": "Klantzichtbaarheid",
      "article_write_content": "Artikelinhoud",
      "article_write_excerpt": "Samenvatting",
      "article_write_title": "Voer artikeltitel in...",
      "asset.discovery_agents": "Discovery-agents",
      "asset.event_logs": "Gebeurtenislogboeken",
      "asset.general": "Algemeen",
      "asset.hardware_wmi": "Hardware (WMI)",
      "asset.history_changes": "Geschiedenis & Wijzigingen",
      "asset.more": "Meer",
      "asset.network": "Netwerk",
      "asset.network_discovery": "Netwerkontdekking",
      "asset.printers": "Printers",
      "asset.processes": "Processen",
      "asset.relationships": "Relaties",
      "asset.remote_control": "Afstandsbediening",
      "asset.remote_terminal": "Remote Terminal",
      "asset.scan_history": "Scangeschiedenis",
      "asset.security": "Beveiliging",
      "asset.services": "Diensten",
      "asset.software_catalog": "Softwarecatalogus (SAM)",
      "asset.software_count": "Software",
      "asset.system_assets": "Systeemassets",
      "asset.updates": "Updates",
      "asset_": "asset_",
      "asset_active": "Actief",
      "asset_agent.offline": "Offline",
      "asset_agent.online_active": "Online (actief)",
      "asset_agent.recently_active": "Recent actief",
      "asset_inactive": "Inactief",
      "asset_maintenance": "Onderhoud",
      "asset_management": "Asset Management",
      "asset_panel.confirm_delete_asset": "\"{{name}}\" echt verwijderen?",
      "asset_panel.confirm_delete_category": "Categorie \"{{name}}\" verwijderen? Assets worden ontkoppeld.",
      "asset_panel.edit_asset": "Asset aanpassen",
      "asset_panel.edit_category": "Categorie aanpassen",
      "asset_panel.import_as_managed_btn": "Als managed asset importeren",
      "asset_panel.import_device": "Apparaat importeren",
      "asset_panel.new_asset": "Nieuw asset",
      "asset_panel.new_category": "Nieuwe categorie",
      "asset_panel.print_asset_tag": "Assetlabel afdrukken",
      "asset_panel.print_now_btn": "Nu afdrukken",
      "asset_panel.toast.agent_no_response_hint": "De agent heeft niet tijdig gereageerd.",
      "asset_panel.toast.assets_imported": "{{count}} asset(s) geïmporteerd",
      "asset_panel.toast.command_queued": "Opdracht succesvol in de wachtrij geplaatst",
      "asset_panel.toast.create_problem_error": "Fout bij het aanmaken van het probleemticket",
      "asset_panel.toast.csv_import_failed": "CSV-import mislukt",
      "asset_panel.toast.device_ignored": "Apparaat succesvol genegeerd",
      "asset_panel.toast.device_imported": "Apparaat succesvol geïmporteerd in de beheerde assets",
      "asset_panel.toast.ignore_device_error": "Fout bij het negeren van het apparaat",
      "asset_panel.toast.import_device_error": "Fout bij het importeren van het apparaat",
      "asset_panel.toast.import_with_errors": "Import afgerond met fouten",
      "asset_panel.toast.itil_correlation_error": "Fout bij de ITIL-probleemcorrelatie",
      "asset_panel.toast.less_than_3_tickets": "Minder dan 3 tickets in de laatste 30 dagen.",
      "asset_panel.toast.manual_scan_error": "Fout bij de manuele scan",
      "asset_panel.toast.problem_ticket_created": "Probleemticket aangemaakt en incidenten gekoppeld!",
      "asset_panel.toast.queue_command_error": "De opdracht kon niet in de wachtrij worden geplaatst",
      "asset_panel.toast.request_scan_error": "Fout bij het aanvragen van de scan",
      "asset_panel.toast.scan_completed": "Scan succesvol afgerond",
      "asset_panel.toast.scan_failed": "Scan mislukt",
      "asset_panel.toast.scan_requested": "{{type}} aangevraagd",
      "asset_panel.toast.template_downloaded": "Sjabloon \"asset-import-vorlage.csv\" gedownload",
      "asset_panel.toast.template_load_error": "Het sjabloon kon niet worden geladen",
      "asset_remote_client_disconnected": "Client verbinding verbroken",
      "asset_remote_client_disconnected_desc": "De gebruiker op het clientapparaat heeft de sessie voor hulp op afstand beëindigd.",
      "asset_remote_closed_desc": "De sessie voor hulp op afstand is succesvol beëindigd.",
      "asset_remote_code_placeholder": "bijv. 123 456",
      "asset_remote_conn_disconnected": "Verbinding verbroken",
      "asset_remote_conn_failed": "Verbinding met de externe server mislukt",
      "asset_remote_conn_rejected": "Verbinding geweigerd",
      "asset_remote_consent_hint": "Er wordt een toestemmingsvenster weergegeven op het scherm van de klant. Vraag de klant om akkoord te gaan.",
      "asset_remote_disconnect": "Verbinding verbreken",
      "asset_remote_enter_code_hint": "Voer de 6-cijferige toegangscode in die op het scherm van de gebruiker wordt weergegeven:",
      "asset_remote_invalid_code": "Onjuiste toegangscode",
      "asset_remote_live_focus": "LIVE · Focus voor toetsenbordinvoer",
      "asset_remote_loading_screen": "Live scherm laden...",
      "asset_remote_preparing": "Verbinding voorbereiden...",
      "asset_remote_protocol2_code_label": "Zwölfstelliger Zugangscode",
      "asset_remote_protocol2_code_placeholder": "ABCD EFGH 2345",
      "asset_remote_protocol2_enter_code_hint": "Geben Sie den zwölfstelligen Zugangscode vom Bildschirm des Benutzers ein:",
      "asset_remote_protocol2_request_desc": "Sendet eine Verbindungsanfrage an den Client-Rechner. Der Benutzer muss zustimmen und den zwölfstelligen Zugangscode übermitteln.",
      "asset_remote_rejected_desc": "Het verbindingsverzoek is geweigerd door de gebruiker op het clientapparaat.",
      "asset_remote_req": "Sessie op afstand aanvragen",
      "asset_remote_request_again": "Opnieuw aanvragen",
      "asset_remote_request_desc": "Stuurt een verbindingsverzoek naar de clientcomputer. De gebruiker moet toestemming geven en een 6-cijferige toegangscode doorgeven.",
      "asset_remote_request_title": "Hulp op afstand aanvragen",
      "asset_remote_start_error": "Kan sessie voor hulp op afstand niet starten",
      "asset_remote_start_new": "Nieuwe sessie starten",
      "asset_remote_support": "Ingebouwde hulp op afstand",
      "asset_remote_support_desc": "Directe schermovername zonder externe software (TeamViewer/RustDesk).",
      "asset_remote_user_consented": "Gebruiker heeft toestemming gegeven",
      "asset_remote_verifying_code": "Toegangscode controleren...",
      "asset_remote_waiting_consent": "Wachten op toestemming van gebruiker...",
      "asset_retired": "Uitgefaseerd",
      "assets": "Assets",
      "assign_to": "Toewijzen...",
      "assign_to_me": "Aan mij toewijzen",
      "assigned_agents": "Toegewezen agenten",
      "assigned_to": "Toegewezen aan",
      "at_risk_title": "Risico (SLA-waarschuwing):",
      "attach_local_file": "Lokale bijlage toevoegen",
      "attachments": "Bijlagen",
      "attachments_tools": "Bijlagen & Tools",
      "attendees_emails": "Deelnemers (e-mails, door komma's gescheiden)",
      "automation": "Automatisering",
      "avg_first_response": "Eerste reactietijd",
      "avg_resolution": "Gemiddelde oplossingstijd",
      "billable": "Factureerbaar",
      "billable_time": "Factureerbaar: {{time}}",
      "book_on_send": "Boeken bij verzenden",
      "book_time_with_reply": "Tijd boeken met antwoord",
      "calendar": "Agenda",
      "calendar_enter_title_warning": "Voer een titel in.",
      "calendar_event_attendees": "E-mails van deelnemers (optioneel, door komma's gescheiden)",
      "calendar_event_created_error": "Evenement kon niet worden aangemaakt.",
      "calendar_event_created_success": "Evenement aangemaakt.",
      "calendar_event_description": "Beschrijving (optioneel)",
      "calendar_event_title": "Titel",
      "calendar_meeting_created_error": "Vergadering kon niet worden aangemaakt.",
      "calendar_meeting_link_copied": "Vergaderlink gekopieerd naar klembord.",
      "calendar_new_event": "Nieuw evenement",
      "calendar_no_integration_or": "of",
      "calendar_no_integration_prefix": "Geen agenda- of vergaderintegratie actief. Configureer",
      "calendar_no_integration_suffix": "met actieve vergaderplanning in de integraties.",
      "calendar_only_event": "Alleen agenda-afspraak",
      "calendar_talk_meeting": "Talk-vergadering",
      "calendar_talk_room_created": "Talk-ruimte aangemaakt.",
      "calendar_teams_meeting": "Teams-vergadering",
      "calendar_teams_meeting_created": "Teams-vergadering aangemaakt.",
      "cancel": "Annuleren",
      "canned_responses": "Standaardtekst invoegen",
      "canned_responses_short": "Standaardtekst",
      "categories": "Categorieën",
      "category": "Categorie",
      "change_priority": "Prioriteit wijzigen...",
      "change_status_after_send": "Na verzenden wijzigen naar",
      "change_ticket_company": "Ticket anderer Firma zuordnen",
      "change_ticket_company_warning": "Portal-Ersteller, CC, Mitarbeiter, Bearbeiter, Kategorie, SLA, Assets und laufende Timer werden für die neue Firma zurückgesetzt.",
      "characters": "tekens",
      "city": "Stad",
      "clear_selection": "Selectie wissen",
      "click_to_logout": "Klik om af te melden",
      "close": "Sluiten",
      "close_detail_view": "Detailweergave sluiten",
      "close_ticket": "Ticket sluiten",
      "closed": "Gesloten",
      "collapse": "Inklappen",
      "collapse_composer": "Editor inklappen",
      "collapse_sidebar": "Zijbalk inklappen",
      "column_assignee_name": "Toegewezene",
      "column_category_name": "Categorie",
      "column_channel": "Kanaal",
      "column_created_at": "Gemaakt",
      "column_customer_name": "Klant",
      "column_priority": "Prioriteit",
      "column_reply_count": "Reacties",
      "column_requester_name": "Aanvrager",
      "column_sla": "SLA",
      "column_status": "Status",
      "column_subject": "Onderwerp",
      "column_tags": "Tags",
      "column_ticket_number": "Nr.",
      "column_updated_at": "Bijgewerkt",
      "columns_btn": "Kolommen",
      "common.abbrechen": "Abbrechen",
      "company_name": "Bedrijfsnaam",
      "company_title": "Bedrijf",
      "compliance_rate": "Nalevingspercentage",
      "composer_internal": "Intern",
      "composer_internal_placeholder": "Interne notitie...",
      "composer_public": "Openbaar",
      "composer_public_placeholder": "Antwoord schrijven...",
      "configure_columns": "Kolommen configureren",
      "connect": "Verbinden",
      "contact_and_master_data": "Contact & Stamgegevens",
      "contact_person": "Contactpersoon",
      "contact_person_abbrev": "CP",
      "contract": "Contract",
      "contract.auto_renew": "Automatische verlenging",
      "contract.auto_renews_suffix": " (wordt automatisch verlengd)",
      "contract.back_to_overview": "Terug naar het overzicht",
      "contract.billing": "Facturatie",
      "contract.billing_model": "Facturatiemodel",
      "contract.conditions": "Voorwaarden",
      "contract.days": "{{count}} dagen",
      "contract.end_date": "Einddatum",
      "contract.expires_in_days": "Verloopt over {{count}} dagen",
      "contract.first_response": "Eerste reactie",
      "contract.hourly_rate": "Uurtarief",
      "contract.hours_quota": "Urencontingent",
      "contract.included_hours": "Inbegrepen uren",
      "contract.no_contracts": "Geen contracten aanwezig",
      "contract.no_contracts_desc": "Neem contact met ons op voor een offerte op maat",
      "contract.notice_period": "Opzegtermijn: {{count}} dagen",
      "contract.period_per": "{{count}}u / periode",
      "contract.quota_summary": "{{remaining}} resterend ({{percent}}% gebruikt)",
      "contract.remaining": "Resterend",
      "contract.resolution": "Oplossing",
      "contract.runtime": "Looptijd",
      "contract.sla_tier": "SLA",
      "contract.start_date": "Startdatum",
      "contract.status.active": "Actief",
      "contract.status.expired": "Verlopen",
      "contract.status.expiring_soon": "Verloopt binnenkort",
      "contract.status.future": "Toekomstig",
      "contract.subtitle": "Overzicht van uw actieve contracten en service level agreements",
      "contract.unlimited": "Onbepaalde duur",
      "contract.used": "Verbruikt",
      "contracts": "Contracten",
      "copied_to_clipboard": "Gekopieerd naar het klembord",
      "country": "Land",
      "create": "Aanmaken",
      "create_ticket.aehnliche_tickets": "Gelijkaardige tickets",
      "create_ticket.angehaengte_cloud_dateien": "Bijgevoegde cloudbestanden:",
      "create_ticket.anhaenge": "Bijlagen",
      "create_ticket.asset_verknuepfen_optional": "Asset koppelen (optioneel):",
      "create_ticket.assets_filtern": "Assets filteren:",
      "create_ticket.assets_werden_geladen": "Assets worden geladen...",
      "create_ticket.beschreiben_sie_das_problem_so_detailliert_w": "Beschrijf het probleem zo gedetailleerd mogelijk...",
      "create_ticket.betroffene_systeme_benutzer_nennen": "Vermeld de getroffen systemen/gebruikers",
      "create_ticket.bitte_betreff_und_beschreibung_ausfuellen": "Vul onderwerp en beschrijving in",
      "create_ticket.bitte_eine_beschreibung_angeben": "Geef een beschrijving op.",
      "create_ticket.bitte_einen_kunden_auswaehlen": "Selecteer een klant.",
      "create_ticket.bitte_hauptkategorie_waehlen": "Kies een hoofdcategorie...",
      "create_ticket.bitte_klassifizierung_waehlen": "Kies een classificatie...",
      "create_ticket.bitte_kunde_waehlen": "Kies een klant...",
      "create_ticket.bitte_unterkategorie_waehlen": "Kies een subcategorie...",
      "create_ticket.bitte_zuerst_einen_kunden_waehlen": "Kies eerst een klant...",
      "create_ticket.datei_hochladen": "Bestand uploaden",
      "create_ticket.datei_hochladen_2": "Bestand uploaden",
      "create_ticket.datei_zu_gross_max_10_mb": "Bestand te groot (max. 10 MB)",
      "create_ticket.dateityp_nicht_erlaubt": "Bestandstype niet toegelaten",
      "create_ticket.erste_antwort": "Eerste antwoord",
      "create_ticket.fehlermeldungen_und_screenshots_beifuegen": "Foutmeldingen en screenshots bijvoegen",
      "create_ticket.keine_mitarbeiter_hinterlegt": "Geen medewerkers geregistreerd",
      "create_ticket.letzte_kunden_tickets": "Laatste klanttickets",
      "create_ticket.loesung": "Oplossing",
      "create_ticket.neues_ticket": "Nieuw ticket",
      "create_ticket.nur_geschaeftszeiten": "Enkel kantooruren",
      "create_ticket.praeziser_betreff_hilft_bei_der_zuordnung": "Een precies onderwerp helpt bij de toewijzing",
      "create_ticket.priority_high": "Hoog",
      "create_ticket.priority_low": "Laag",
      "create_ticket.priority_medium": "Gemiddeld",
      "create_ticket.priority_urgent": "Dringend",
      "create_ticket.schritte_zur_reproduktion_angeben": "Vermeld de stappen om het probleem te reproduceren",
      "create_ticket.stoerung": "Storing",
      "create_ticket.text_mit_ki_verbessern": "Tekst verbeteren met AI",
      "create_ticket.ticket_erstellt": "Ticket aangemaakt!",
      "create_ticket.uebernehmen": "Overnemen",
      "create_ticket.ueberschrift": "Kop",
      "create_ticket.vielleicht_loest_ein_artikel_das_problem_ber": "Misschien lost een artikel het probleem al op?",
      "create_ticket.vorlage_einfuegen": "Sjabloon invoegen",
      "create_ticket.waehlen_sie_einen_kunden_aus_um_dessen_asset": "Selecteer een klant om diens assets te kunnen koppelen.",
      "create_ticket.werden_bei_erstellung_ausgeloest": "Worden geactiveerd bij het aanmaken",
      "create_ticket.zurueck": "Terug",
      "created_at": "Aangemaakt op",
      "critical_priority_sla": "Prioriteit / SLA",
      "customer": "Klant",
      "customer_assets.no_assets": "Geen assets geregistreerd voor deze klant. Met een Zabbix-host-ID of uptimemonitor op een asset verschijnen hier statusmeldingen.",
      "customer_assets.no_assets_unconfigured": "Geen assets geregistreerd. Discovery of een monitoringintegratie kan de inventarisatie automatiseren.",
      "customer_assets.no_zabbix_id": "Geen Zabbix-host-ID op het asset",
      "customer_assets.start_rd": "RustDesk starten",
      "customer_assets.start_tv": "TeamViewer starten",
      "customer_form.adresse_eingeben_um_karte_anzuzeigen": "Voer een adres in om de kaart weer te geven",
      "customer_form.client_secret": "Client Secret",
      "customer_form.domain_entfernen": "Domein verwijderen",
      "customer_form.domain_hinzufuegen": "+ Domein toevoegen",
      "customer_form.domains_mit_zugeordneten_mitarbeitern_koenne": "Domeinen met toegewezen medewerkers kunnen niet worden verwijderd.",
      "customer_form.geschaeftsfuehrer": "Zaakvoerder",
      "customer_form.in_openstreetmap_oeffnen": "Openen in OpenStreetMap ↗",
      "customer_form.interne_notizen_zu_diesem_kunden": "Interne notities over deze klant...",
      "customer_form.kontakt_in_lexoffice_anlegen_uuid_hier_eintr": "Contact aanmaken in Lexoffice, UUID hier invullen",
      "customer_form.lexoffice_kontakt_id_uuid": "Lexoffice contact-ID (UUID)",
      "customer_form.logo_kann_nach_dem_erstellen_des_kunden_hoch": "Het logo kan worden geüpload nadat de klant is aangemaakt.",
      "customer_form.mitarbeiter_koennen_sich_per_microsoft_konto": "Medewerkers kunnen zich aanmelden met een Microsoft-account",
      "customer_form.mloffice_badge": "Von MLOffice verwaltet",
      "customer_form.mloffice_banner": "Dieser Kunde wird mit MLOffice abgeglichen. Stammdaten (Name, E-Mail, Telefon, Anschrift, USt-ID) werden von MLOffice verwaltet und sind hier gesperrt.",
      "customer_form.mloffice_feld_hinweis": "Dieses Feld wird von MLOffice verwaltet — Änderungen bitte dort vornehmen; sie werden automatisch übernommen.",
      "customer_form.mloffice_geloest": "Verknüpfung gelöst — die Felder sind wieder bearbeitbar.",
      "customer_form.mloffice_loesen": "Verknüpfung lösen…",
      "customer_form.mloffice_loesen_fehler": "Verknüpfung konnte nicht gelöst werden.",
      "customer_form.mloffice_loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "customer_form.mloffice_loest": "Löse…",
      "customer_form.mloffice_verwaltung_hinweis": "Verwaltung der Verknüpfung unter Stammdaten & Organisation → MLOffice (erfordert Systemrechte).",
      "customer_form.registrieren_sie_eine_app_in_azure_portal_ap": "Registreer een app in de Azure Portal → App-registraties. Redirect URI:",
      "customer_form.strasse": "Straat",
      "customer_form.tab_address": "Adres",
      "customer_form.tab_domains": "Domeinen",
      "customer_form.tab_general": "Algemeen",
      "customer_form.tab_notes": "Notities",
      "customer_form.tab_sso": "SSO",
      "customer_form.tab_tax": "Fiscaal & SLA",
      "customer_form.zuordnung_ticket_system_kunde_lexoffice_kont": "Toewijzing klant ticketsysteem → Lexoffice-contact voor ontwerpfacturen (Admin → Tijdsregistratie).",
      "customer_inactive": "Klant inactief",
      "customer_not_found": "Klant niet gevonden",
      "customer_notified_by_email": "Klant wordt per e-mail geïnformeerd",
      "customer_number_abbrev": "Klantnr",
      "customer_portal.action_required": "Actie vereist",
      "customer_portal.action_required_desc": "Het supportteam wacht op uw feedback over dit ticket.",
      "customer_portal.action_required_title": "Uw antwoord is vereist",
      "customer_portal.assignee": "Behandelaar",
      "customer_portal.attachments_count": "Bijlagen ({{count}})",
      "customer_portal.attachments_load_failed": "Weitere Anhänge konnten nicht geladen werden.",
      "customer_portal.back": "← Terug",
      "customer_portal.back_to_my_tickets": "← Terug naar Mijn tickets",
      "customer_portal.close": "Sluiten",
      "customer_portal.close_failed": "Het ticket kon niet worden gesloten.",
      "customer_portal.collapse_replies": "Ältere schließen",
      "customer_portal.compact_replies": "Ältere Antworten sind eingeklappt. Die letzte Antwort bleibt geöffnet.",
      "customer_portal.confirm_close": "Wilt u dit ticket echt sluiten?",
      "customer_portal.confirm_reopen": "Wilt u dit ticket heropenen?",
      "customer_portal.contracts.hours_minutes": "{{hours}}u {{minutes}}min",
      "customer_portal.contracts.hours_only": "{{hours}}u",
      "customer_portal.contracts.minutes_only": "{{minutes}}min",
      "customer_portal.create_first_ticket": "Nieuw ticket aanmaken",
      "customer_portal.created": "Aangemaakt",
      "customer_portal.customer_colleague": "Kollegin/Kollege",
      "customer_portal.dashboard.active_count": "{{count}} actief",
      "customer_portal.dashboard.avg_resolution": "Ø Oplossingstijd",
      "customer_portal.dashboard.click_to_view_waiting": "Klik hier om de tickets weer te geven",
      "customer_portal.dashboard.create_first_link": "Eerste ticket aanmaken →",
      "customer_portal.dashboard.create_new_ticket_link": "Nieuw ticket aanmaken",
      "customer_portal.dashboard.history_trend": "Ticketgeschiedenis (laatste 12 maanden)",
      "customer_portal.dashboard.kb": "Hulp & kennisbank",
      "customer_portal.dashboard.kb_desc": "Handleidingen en FAQ's",
      "customer_portal.dashboard.my_tickets": "Mijn tickets",
      "customer_portal.dashboard.no_tickets": "Nog geen tickets aanwezig",
      "customer_portal.dashboard.no_tickets_status": "Geen tickets",
      "customer_portal.dashboard.open_active": "Open / actief",
      "customer_portal.dashboard.processing_time": "Behandeltijd",
      "customer_portal.dashboard.recent_tickets": "Laatste tickets",
      "customer_portal.dashboard.report_incident": "Storing melden",
      "customer_portal.dashboard.report_incident_desc": "Dringend probleem of uitval melden",
      "customer_portal.dashboard.reports": "Overzicht & rapporten",
      "customer_portal.dashboard.reports_desc": "Alle tickets filteren en analyseren",
      "customer_portal.dashboard.search_kb_link": "Kennisbank doorzoeken",
      "customer_portal.dashboard.service_request": "Serviceaanvraag",
      "customer_portal.dashboard.service_request_desc": "Aanvragen via configureerbare formulieren",
      "customer_portal.dashboard.show_all_link": "Alles weergeven →",
      "customer_portal.dashboard.status_overview": "Statusoverzicht",
      "customer_portal.dashboard.subtitle": "Uw supportoverzicht in één oogopslag",
      "customer_portal.dashboard.total_tickets": "Tickets totaal",
      "customer_portal.dashboard.waiting_tickets_warning": "1 ticket wacht op uw antwoord",
      "customer_portal.dashboard.waiting_tickets_warning_plural": "{{count}} tickets wachten op uw antwoord",
      "customer_portal.dashboard.welcome": "Welkom",
      "customer_portal.dashboard.widget_unknown": "Widget: {{type}}",
      "customer_portal.dashboard.your_reply": "Uw antwoord",
      "customer_portal.details_title": "Details",
      "customer_portal.editor.bold": "Vet",
      "customer_portal.editor.code": "Code",
      "customer_portal.editor.italic": "Cursief",
      "customer_portal.editor.list": "Lijst",
      "customer_portal.expand_replies": "Alle öffnen",
      "customer_portal.files_draft_failed": "Anhänge konnten nicht dauerhaft im Entwurf gespeichert werden.",
      "customer_portal.files_need_reselect": "Anhänge können aus Sicherheitsgründen nicht wiederhergestellt werden. Bitte wählen Sie sie erneut aus.",
      "customer_portal.filters.active": "Actief",
      "customer_portal.filters.all": "Alle",
      "customer_portal.filters.closed": "Gesloten",
      "customer_portal.filters.external": "Extern",
      "customer_portal.filters.waiting_customer": "Uw antwoord",
      "customer_portal.history_title": "Geschiedenis",
      "customer_portal.impersonation_banner": "U bekijkt dit portaal momenteel in impersonatiemodus (voorbeeld voor agenten) als klant:",
      "customer_portal.incident_badge": "Storing",
      "customer_portal.kb.title": "Kennisbank",
      "customer_portal.load_more_attachments": "Weitere Anhänge laden",
      "customer_portal.login.betreut_von": "ONDERSTEUND DOOR NALVRA",
      "customer_portal.login.claim": "Uw directe lijn naar support — melden, status volgen, antwoorden vinden.",
      "customer_portal.login.copyright_text": "© {{year}} {{appName}}. Alle rechten voorbehouden.",
      "customer_portal.login.default_subtitle": "Meld u aan om uw aanvragen te beheren.",
      "customer_portal.login.default_welcome": "Welkom bij {{appName}}",
      "customer_portal.login.email": "E-mail",
      "customer_portal.login.email_placeholder": "naam@bedrijf.be",
      "customer_portal.login.eyebrow": "KLANTENPORTAAL · 24/7 BEREIKBAAR",
      "customer_portal.login.forgot_password": "Wachtwoord vergeten?",
      "customer_portal.login.kein_zugang": "Nog geen toegang? Neem contact op met uw contactpersoon bij support.",
      "customer_portal.login.kundenanmeldung": "Klantaanmelding",
      "customer_portal.login.kundenportal": "KLANTENPORTAAL",
      "customer_portal.login.microsoft_signin": "Aanmelden met Microsoft",
      "customer_portal.login.mit_hinterlegter_adresse": "Meld u aan met het geregistreerde e-mailadres.",
      "customer_portal.login.or_password": "of met wachtwoord",
      "customer_portal.login.password": "Wachtwoord",
      "customer_portal.login.password_placeholder": "Uw wachtwoord",
      "customer_portal.login.reset_back": "Terug naar aanmelden",
      "customer_portal.login.reset_button": "Link versturen",
      "customer_portal.login.reset_instruction": "Geef uw e-mailadres in. Wij sturen u een link om het opnieuw in te stellen.",
      "customer_portal.login.reset_sent_message": "Als er een account met dit adres bestaat, hebben wij een link verstuurd.",
      "customer_portal.login.reset_sent_title": "E-mail verstuurd",
      "customer_portal.login.reset_title": "Wachtwoord opnieuw instellen",
      "customer_portal.login.sicherheitszeile": "Versleutelde verbinding · Toegang alleen voor geregistreerde contactpersonen",
      "customer_portal.login.signin_button": "Aanmelden",
      "customer_portal.login.signing_in": "Bezig met aanmelden …",
      "customer_portal.login.sso_available": "Eenmalige aanmelding beschikbaar",
      "customer_portal.login.sso_failed": "SSO-aanmelding mislukt",
      "customer_portal.login.sso_logging_in": "Bezig met aanmelden …",
      "customer_portal.menu.dashboard": "Dashboard",
      "customer_portal.menu.edit_profile": "Profiel aanpassen",
      "customer_portal.menu.logout": "Afmelden",
      "customer_portal.menu.profile": "Mein Profil",
      "customer_portal.message_placeholder": "Uw bericht...",
      "customer_portal.nav.contracts": "Contracten",
      "customer_portal.nav.create_request": "Anfrage erstellen",
      "customer_portal.nav.dashboard": "Dashboard",
      "customer_portal.nav.documents": "Documenten",
      "customer_portal.nav.downloads": "Downloads",
      "customer_portal.nav.help": "Hilfe & Kurztour",
      "customer_portal.nav.kb": "Kennisbank",
      "customer_portal.nav.my_tickets": "Mijn tickets",
      "customer_portal.nav.profile": "Profiel",
      "customer_portal.nav.report_incident": "Storing melden",
      "customer_portal.nav.service_request": "Serviceaanvraag",
      "customer_portal.nav.support": "Support erhalten",
      "customer_portal.navigation": "Portal-Navigation",
      "customer_portal.new_ticket": "Nieuw ticket",
      "customer_portal.new_ticket.add_attachment": "Toevoegen",
      "customer_portal.new_ticket.ai_improve_btn": "Beschrijving verbeteren",
      "customer_portal.new_ticket.ai_improving": "Wordt verbeterd...",
      "customer_portal.new_ticket.ai_preanswer_title": "AI-suggestie voor uw probleem",
      "customer_portal.new_ticket.ai_suggestion_title": "AI-verbetersuggestie",
      "customer_portal.new_ticket.allowed_types_tip": "Alleen geconfigureerde bestandstypen (zie de melding van uw beheerder)",
      "customer_portal.new_ticket.apply": "Overnemen",
      "customer_portal.new_ticket.attach_file": "Bestand bijvoegen",
      "customer_portal.new_ticket.attachment_plural": "Bijlagen",
      "customer_portal.new_ticket.attachment_singular": "Bijlage",
      "customer_portal.new_ticket.back_step_1": "Zurück zu Schritt 1",
      "customer_portal.new_ticket.back_step_2": "Zurück zu Schritt 2",
      "customer_portal.new_ticket.categories_error": "Kategorien konnten nicht geladen werden.",
      "customer_portal.new_ticket.categories_loading": "Kategorien werden geladen …",
      "customer_portal.new_ticket.category_assignment": "Kategorie zuordnen",
      "customer_portal.new_ticket.category_by_support": "Zuordnung durch den Support",
      "customer_portal.new_ticket.category_hint": "Sie sind unsicher? Lassen Sie die Kategorie offen. Der Support übernimmt die Zuordnung.",
      "customer_portal.new_ticket.category_question": "Welche Kategorie passt zu Ihrem Anliegen?",
      "customer_portal.new_ticket.char_count": "{{count}} tekens",
      "customer_portal.new_ticket.continue_step_2": "Weiter zu Schritt 2",
      "customer_portal.new_ticket.continue_step_3": "Weiter zu Schritt 3",
      "customer_portal.new_ticket.create": "Aanmaken",
      "customer_portal.new_ticket.create_anyway": "Toch een ticket aanmaken",
      "customer_portal.new_ticket.create_ticket": "Ticket aanmaken",
      "customer_portal.new_ticket.creating": "Wordt aangemaakt...",
      "customer_portal.new_ticket.days_count": "{{count}} werkdagen",
      "customer_portal.new_ticket.description_label": "Beschrijving *",
      "customer_portal.new_ticket.description_placeholder": "Beschrijf uw probleem in detail...\\n\\n• Wat werkt niet?\\n• Sinds wanneer doet het probleem zich voor?\\n• Is er een foutmelding?\\n• Welk systeem / apparaat is getroffen?\\n\\nTip: screenshots plakken met Ctrl+V",
      "customer_portal.new_ticket.description_required": "Bitte beschreiben Sie Ihr Problem.",
      "customer_portal.new_ticket.discard": "Verwerpen",
      "customer_portal.new_ticket.drag_more": "Meer bestanden hierheen slepen · Nog {{count}} mogelijk",
      "customer_portal.new_ticket.drag_or_click": "Bestanden hierheen slepen of klikken",
      "customer_portal.new_ticket.drop_here": "Bestanden hier neerzetten...",
      "customer_portal.new_ticket.error_create_failed": "Fout bij het aanmaken van het ticket.",
      "customer_portal.new_ticket.expected_first_response": "Eerste antwoord",
      "customer_portal.new_ticket.go_to_step": "Schritt {{step}}: {{label}}",
      "customer_portal.new_ticket.hide": "Verbergen",
      "customer_portal.new_ticket.hours_count": "{{count}} uur",
      "customer_portal.new_ticket.insert_template": "Sjabloon invoegen",
      "customer_portal.new_ticket.kb_article_error": "Dieser Artikel konnte nicht geladen werden. Sie können es erneut versuchen oder mit Ihrem Ticket fortfahren.",
      "customer_portal.new_ticket.kb_close_article": "Artikel schließen",
      "customer_portal.new_ticket.kb_did_help": "Hat dieser Artikel Ihr Problem gelöst?",
      "customer_portal.new_ticket.kb_draft_retained": "Ihr Ticketentwurf bleibt erhalten. Sie entscheiden, ob Sie ihn weiter bearbeiten.",
      "customer_portal.new_ticket.kb_feedback_error": "Ihre Rückmeldung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut. Ihr Entwurf bleibt erhalten.",
      "customer_portal.new_ticket.kb_helped": "Artikel hat mir geholfen",
      "customer_portal.new_ticket.kb_loading_article": "Artikel wird geladen",
      "customer_portal.new_ticket.kb_resolved_message": "Ihre Rückmeldung wurde gespeichert. Es wurde kein Ticket erstellt.",
      "customer_portal.new_ticket.kb_resolved_title": "Schön, dass die Anleitung geholfen hat",
      "customer_portal.new_ticket.kb_resume_draft": "Ticketentwurf weiter bearbeiten",
      "customer_portal.new_ticket.kb_retry": "Erneut laden",
      "customer_portal.new_ticket.kb_saved_draft": "Ihr Entwurf bleibt für Sie gespeichert, falls Sie später doch Unterstützung benötigen.",
      "customer_portal.new_ticket.kb_searching": "Lösungen werden gesucht",
      "customer_portal.new_ticket.kb_suggestions_hint": "Passende Anleitungen aus der Wissensbasis. Lesen Sie einen Artikel, bevor Sie Ihr Ticket erstellen.",
      "customer_portal.new_ticket.kb_suggestions_title": "Vielleicht ist die Lösung schon da",
      "customer_portal.new_ticket.kb_to_dashboard": "Zurück zum Dashboard",
      "customer_portal.new_ticket.max_files": "Max. {{count}} bestanden",
      "customer_portal.new_ticket.max_size": "Max. {{count}} MB / bestand",
      "customer_portal.new_ticket.minutes_count": "{{count}} minuten",
      "customer_portal.new_ticket.no_category": "Kies een categorie...",
      "customer_portal.new_ticket.optional": "Optional",
      "customer_portal.new_ticket.preanswer_might_resolve": "Heeft dit u geholpen? Dan hoeft u mogelijk geen ticket aan te maken.",
      "customer_portal.new_ticket.presubmit_kb_desc": "Geen passend artikel? Geen probleem — maak uw ticket aan.",
      "customer_portal.new_ticket.presubmit_kb_title": "Dit lost uw probleem misschien al op",
      "customer_portal.new_ticket.prio_desc_critical": "Onmiddellijk",
      "customer_portal.new_ticket.prio_desc_high": "Dringend",
      "customer_portal.new_ticket.prio_desc_low": "Kan wachten",
      "customer_portal.new_ticket.prio_desc_medium": "Normaal",
      "customer_portal.new_ticket.progress": "Fortschritt der Ticketerstellung",
      "customer_portal.new_ticket.relevant_articles": "Passende artikelen:",
      "customer_portal.new_ticket.reply_by_email_tip": "U kunt op dit ticket ook per e-mail antwoorden",
      "customer_portal.new_ticket.resolution": "Oplossing",
      "customer_portal.new_ticket.response_time_typical": "Antwoord doorgaans binnen enkele uren",
      "customer_portal.new_ticket.retry_categories": "Erneut laden",
      "customer_portal.new_ticket.screenshot_tip": "Screenshots plakken met Ctrl+V",
      "customer_portal.new_ticket.similar_tickets": "Gelijkaardige tickets",
      "customer_portal.new_ticket.step_attachments": "Anhänge",
      "customer_portal.new_ticket.step_attachments_detail": "Kategorie, Anhänge und Absenden",
      "customer_portal.new_ticket.step_count": "Schritt {{step}} von 3",
      "customer_portal.new_ticket.step_details": "Details",
      "customer_portal.new_ticket.step_details_detail": "Beschreibung und Priorität",
      "customer_portal.new_ticket.step_subject": "Betreff",
      "customer_portal.new_ticket.step_subject_detail": "Person, Betreff und Wissensbasis",
      "customer_portal.new_ticket.subject_desc_required": "Onderwerp en beschrijving zijn verplicht.",
      "customer_portal.new_ticket.subject_label": "Onderwerp *",
      "customer_portal.new_ticket.subject_placeholder": "Korte beschrijving van het probleem of van uw aanvraag",
      "customer_portal.new_ticket.subject_required": "Bitte geben Sie einen Betreff ein.",
      "customer_portal.new_ticket.subtitle": "Technische storing of dringend probleem — wordt als ticket bezorgd bij de support.",
      "customer_portal.new_ticket.subtitle_2": "Beschrijf uw vraag en wij zorgen ervoor.",
      "customer_portal.new_ticket.success_desc": "Hartelijk dank. Wij nemen zo snel mogelijk contact met u op.",
      "customer_portal.new_ticket.success_title": "Ticket aangemaakt!",
      "customer_portal.new_ticket.template_btn": "Voorbeeld",
      "customer_portal.new_ticket.view_ticket": "Ticket bekijken",
      "customer_portal.no_attachments": "Keine Anhänge vorhanden.",
      "customer_portal.no_tickets_create_desc": "Maak uw eerste ticket aan.",
      "customer_portal.no_tickets_filter_desc": "Probeer een andere filter.",
      "customer_portal.no_tickets_search_desc": "Probeer een andere zoekterm.",
      "customer_portal.no_tickets_title": "Geen tickets gevonden",
      "customer_portal.pagination_of": "von",
      "customer_portal.password.btn": "Wachtwoord wijzigen",
      "customer_portal.password.cancel": "Annuleren",
      "customer_portal.password.changing": "Wordt gewijzigd...",
      "customer_portal.password.confirm": "Nieuw wachtwoord bevestigen",
      "customer_portal.password.current": "Huidig wachtwoord",
      "customer_portal.password.error_change": "Fout bij het wijzigen.",
      "customer_portal.password.error_min_length": "Minstens 8 tekens.",
      "customer_portal.password.error_mismatch": "Wachtwoorden komen niet overeen.",
      "customer_portal.password.error_same": "Het nieuwe wachtwoord moet verschillen.",
      "customer_portal.password.logout": "Afmelden",
      "customer_portal.password.mismatch_warning": "Wachtwoorden komen niet overeen",
      "customer_portal.password.must_change_desc": "Wijzig uw wachtwoord voordat u verdergaat.",
      "customer_portal.password.new": "Nieuw wachtwoord (min. 8 tekens)",
      "customer_portal.password.redirecting": "U wordt doorgestuurd...",
      "customer_portal.password.success": "Wachtwoord succesvol gewijzigd!",
      "customer_portal.password.title": "Wachtwoord wijzigen",
      "customer_portal.priority_help.high": "Mehrere Mitarbeitende oder eine wichtige Funktion sind stark beeinträchtigt. Es gibt keine praktikable Ausweichlösung, der übrige Betrieb läuft jedoch weiter.",
      "customer_portal.priority_help.low": "Kleine Einschränkung oder allgemeine Frage. Sie können normal weiterarbeiten, zum Beispiel bei einem Darstellungsfehler oder einem Änderungswunsch.",
      "customer_portal.priority_help.medium": "Die Arbeit ist eingeschränkt, aber eine Ausweichlösung ist möglich. Beispiel: Ein Drucker fällt aus, ein anderer kann genutzt werden.",
      "customer_portal.priority_help.urgent": "Der Betrieb oder ein geschäftskritischer Prozess steht still. Es gibt keine Ausweichlösung, zum Beispiel bei einem vollständigen Ausfall des zentralen Systems. Bitte nicht nur wegen eines persönlichen Wunschtermins wählen.",
      "customer_portal.processing_time": "Behandeltijd",
      "customer_portal.profile.cancel": "Annuleren",
      "customer_portal.profile.change_password_btn": "Wachtwoord wijzigen",
      "customer_portal.profile.change_photo": "Profilbild ändern",
      "customer_portal.profile.closed": "Gesloten",
      "customer_portal.profile.company": "Bedrijf",
      "customer_portal.profile.company_account": "Bedrijf & account",
      "customer_portal.profile.days_count": "{{count}} werkdag(en)",
      "customer_portal.profile.department": "Afdeling",
      "customer_portal.profile.edit": "Aanpassen",
      "customer_portal.profile.email": "E-mail",
      "customer_portal.profile.error_save": "Fout bij het opslaan",
      "customer_portal.profile.error_upload": "Fout bij het uploaden",
      "customer_portal.profile.first_name": "Voornaam",
      "customer_portal.profile.first_response": "Eerste antwoord",
      "customer_portal.profile.hours_count": "{{count}} u.",
      "customer_portal.profile.last_name": "Achternaam",
      "customer_portal.profile.loading": "Profiel wordt geladen...",
      "customer_portal.profile.location": "Locatie",
      "customer_portal.profile.member_since": "Lid sinds",
      "customer_portal.profile.minutes_count": "{{count}} min.",
      "customer_portal.profile.mobile": "Gsm",
      "customer_portal.profile.mobile_placeholder": "bijv. +32 470 12 34 56",
      "customer_portal.profile.open": "Openstaand",
      "customer_portal.profile.personal_data": "Persoonlijke gegevens",
      "customer_portal.profile.phone": "Telefoon",
      "customer_portal.profile.phone_placeholder": "bijv. +32 2 123 45 67",
      "customer_portal.profile.position": "Functie",
      "customer_portal.profile.resolution": "Oplossing",
      "customer_portal.profile.save": "Opslaan",
      "customer_portal.profile.security": "Beveiliging",
      "customer_portal.profile.security_desc": "Wijzig uw wachtwoord regelmatig voor meer beveiliging.",
      "customer_portal.profile.service_level": "Service Level",
      "customer_portal.profile.show_dashboard": "Dashboard weergeven",
      "customer_portal.profile.sla_tier": "SLA-niveau",
      "customer_portal.profile.sso_active": "SSO-authenticatie actief",
      "customer_portal.profile.success_photo": "Profielfoto bijgewerkt",
      "customer_portal.profile.success_update": "Profiel succesvol bijgewerkt",
      "customer_portal.profile.ticket_overview": "Ticketoverzicht",
      "customer_portal.profile.total": "Totaal",
      "customer_portal.reopen": "Heropenen",
      "customer_portal.reopen_failed": "Het ticket kon niet worden heropend.",
      "customer_portal.reopen_ticket": "Ticket heropenen",
      "customer_portal.replies_load_failed": "Ältere Antworten konnten nicht geladen werden.",
      "customer_portal.reply_btn": "Antwoorden",
      "customer_portal.reply_failed": "Uw antwoord kon niet worden verzonden. Probeer het opnieuw.",
      "customer_portal.reply_plural": "Antwoorden",
      "customer_portal.reply_singular": "Antwoord",
      "customer_portal.request_badge": "Aanvraag",
      "customer_portal.requests.attachments": "Bijlagen",
      "customer_portal.requests.category": "Categorie",
      "customer_portal.requests.description": "Beschrijving",
      "customer_portal.requests.priority": "Prioriteit",
      "customer_portal.search_label": "Tickets suchen",
      "customer_portal.search_placeholder": "Ticketnr. of onderwerp zoeken...",
      "customer_portal.sending": "Wordt verzonden...",
      "customer_portal.service_level": "Service Level",
      "customer_portal.show_older_replies": "{{count}} oudere antwoorden weergeven...",
      "customer_portal.sla.met": "Voldaan",
      "customer_portal.sla.on_track": "Op schema",
      "customer_portal.sla.overdue": "Te laat",
      "customer_portal.sla.warning": "Binnenkort vervallen",
      "customer_portal.source": "Bron",
      "customer_portal.source_portal": "Portaal",
      "customer_portal.stop_impersonation": "Impersonatie beëindigen",
      "customer_portal.support_team": "Supportteam",
      "customer_portal.ticket_closed_desc": "Dit ticket is gesloten.",
      "customer_portal.ticket_load_failed": "Ticket konnte nicht geladen werden",
      "customer_portal.ticket_load_failed_desc": "Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "customer_portal.ticket_not_found": "Ticket niet gevonden",
      "customer_portal.ticket_owner": "Ihr zuständiger Support-Agent",
      "customer_portal.ticket_plural": "Tickets",
      "customer_portal.ticket_singular": "Ticket",
      "customer_portal.tickets_load_failed": "Tickets konnten nicht geladen werden",
      "customer_portal.tickets_load_failed_desc": "Ihre Daten wurden nicht verändert.",
      "customer_portal.times_title": "Tijden",
      "customer_portal.unassigned_owner": "Noch nicht zugewiesen",
      "customer_portal.unsaved_warning": "Ihr nicht gesendeter Entwurf geht beim Verlassen möglicherweise verloren.",
      "customer_portal.updated": "Bijgewerkt",
      "customer_portal.via_email": "per e-mail",
      "customer_portal.write_reply": "Antwoord schrijven",
      "customer_portal.you": "U",
      "customer_tickets_summary": "{{open}} open / {{total}} tot.",
      "customers": "Klanten",
      "customize": "Aanpassen",
      "dark_mode": "Donker thema",
      "dashboard": "Dashboard",
      "dashboard_sub": "Hier zijn uw operationele KPI's, SLA-statussen en ticketstatistieken.",
      "days_ago": "{{count}} dagen geleden",
      "delete": "Verwijderen",
      "density": "Dichtheid:",
      "density_comfort_label": "Komfort",
      "density_comfortable": "Comfortabel",
      "density_compact": "Compact",
      "density_spacious": "Ruim",
      "density_standard_label": "Standard",
      "device_actions": "Geräte & Lizenzen",
      "device_actions_hint": "Fernwartung, Remote-Terminal, Behebung und Lizenzen der verknüpften Geräte",
      "document.all": "Alle",
      "document.category.certificate": "Certificaat",
      "document.category.contract": "Contract",
      "document.category.correspondence": "Correspondentie",
      "document.category.general": "Algemeen",
      "document.category.invoice": "Factuur",
      "document.category.manual": "Handleiding",
      "document.category.report": "Rapport",
      "document.none_found": "Geen documenten gevonden",
      "document.none_found_desc": "Probeer een andere zoekterm",
      "document.none_shared": "Er zijn nog geen documenten voor u vrijgegeven",
      "document.none_shared_desc": "Uw contactpersoon kan hier documenten voor u klaarzetten",
      "document.plural": "Documenten",
      "document.search_placeholder": "Documenten doorzoeken...",
      "document.singular": "Document",
      "document.subtitle": "Uw vrijgegeven documenten, contracten en dossiers",
      "document.total_suffix": "totaal",
      "domains": "Domeinen",
      "draft_present": "Ontwerp",
      "draft_saved": "Concept opgeslagen",
      "drag_to_move": "{{label}} (sleep om te verplaatsen)",
      "drag_to_sort": "Sleep om te sorteren, klik om te tonen/verbergen",
      "duration": "Duur (min.)",
      "duration_minutes": "{{count}} minuten",
      "edit": "Aanpassen",
      "edit_customer": "Klant bewerken",
      "edit_master_data_admin": "Stamgegevens bewerken in administratie",
      "edit_widgets_title": "Widgets tonen & sorteren",
      "email": "E-mail",
      "email_channel": "E-mailkanaal",
      "employee_form.account_erstellt": "Account aangemaakt:",
      "employee_form.bitte_zuerst_kunde_auswaehlen": "Selecteer eerst een klant",
      "employee_form.dieser_mitarbeiter_hat_noch_keinen_zugang_zu": "Deze medewerker heeft nog geen toegang tot het klantenportaal. Maak een account met wachtwoord aan.",
      "employee_form.domain_waehlen": "Domein kiezen",
      "employee_form.domains_werden_geladen": "Domeinen worden geladen...",
      "employee_form.e_mail_server_nicht_konfiguriert": "E-mailserver niet geconfigureerd",
      "employee_form.initialpasswort_vergeben": "Initieel wachtwoord instellen...",
      "employee_form.interne_notizen_zum_mitarbeiter": "Interne notities over de medewerker...",
      "employee_form.kein_portal_zugang_vorhanden": "Geen portaaltoegang aanwezig",
      "employee_form.keine_domains_fuer_diesen_kunden_hinterlegt": "Er zijn geen domeinen geregistreerd voor deze klant.",
      "employee_form.kunde_auswaehlen": "Klant selecteren",
      "employee_form.lade_account_informationen": "Accountgegevens laden...",
      "employee_form.leer_lassen_wenn_kein_portal_zugang_benoetig": "Laat leeg als er geen portaaltoegang nodig is (bijv. bij SSO).",
      "employee_form.letzter_login": "Laatste aanmelding:",
      "employee_form.neues_passwort": "Nieuw wachtwoord...",
      "employee_form.neues_passwort_min_8_zeichen": "Nieuw wachtwoord (min. 8 tekens)",
      "employee_form.passwort_fuer_neuen_account_min_8_zeichen": "Wachtwoord voor het nieuwe account (min. 8 tekens)",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge": "Wachtwoordwijziging bij de eerste aanmelding afdwingen",
      "employee_form.passwortaenderung_beim_ersten_login_erzwinge_2": "Wachtwoordwijziging bij de eerste aanmelding afdwingen",
      "employee_form.passwortaenderung_beim_naechsten_login_erzwi": "Wachtwoordwijziging bij de volgende aanmelding afdwingen",
      "employee_form.profilbild_kann_nach_dem_erstellen_hochgelad": "De profielfoto kan na het aanmaken worden geüpload.",
      "employee_form.pw_aenderung_ausstehend": "WW-wijziging openstaand",
      "employee_form.reset_link_24h_gueltig": "Resetlink (24u geldig):",
      "employee_form.tab_access": "Klantenportaal",
      "employee_form.tab_it": "IT & werkplek",
      "employee_form.tab_notes": "Notities",
      "employee_form.tab_personal": "Persoonlijk",
      "employee_form.tab_work": "Werk & contact",
      "employee_form.weitere_it_informationen_wie_betriebssystem": "Bijkomende IT-informatie zoals besturingssysteem, geïnstalleerde software enz. kan in de notities worden vastgelegd.",
      "employee_form.z_b_koeln_buero_3_og": "bijv. Keulen, kantoor 3e verdieping",
      "employees": "Medewerkers",
      "employees_ca": "Medewerkers (ca.)",
      "end_edit": "Bewerken beëindigen",
      "enter_title_error": "Voer een titel in.",
      "escalate": "Escaleren",
      "escalated": "Geëscaleerd",
      "escalated_badge": "Geëscaleerd",
      "expand_sidebar": "Zijbalk uitklappen",
      "expired": "Verlopen",
      "expires_at": "Loopt tot",
      "expiring_soon": "Verloopt binnenkort",
      "export_csv": "CSV-bestand",
      "export_pdf": "PDF-document",
      "export_png": "PNG-diagram",
      "export_xlsx": "Excel (XLSX)",
      "filter_active": "Filter actief",
      "filter_all_az": "Alle A–Z",
      "filter_list_placeholder": "Lijst filteren...",
      "filter_open_first": "Openstaande eerst",
      "filter_open_only": "Alleen met openstaande",
      "filter_with_sla": "Met SLA-niveau",
      "first_post_attachments": "Bijlagen bij het eerste bericht",
      "first_response": "Eerste reactie",
      "follow_ups": "Wacht op klant",
      "generating": "Genereren...",
      "greeting_day": "Goedendag, {{name}} 👋",
      "held_review": "Controle vereist",
      "high_priority": "Hoge prioriteit",
      "hours": "Uren",
      "hours_ago": "{{count}} uur geleden",
      "inactive": "Inactief",
      "included_hours": "Incl. uren",
      "industry": "Sector",
      "internal": "Intern",
      "internal_chat": "Interne chat",
      "internal_note": "Interne notitie",
      "internal_notes": "Interne notities",
      "internal_notes_placeholder": "Interne notities over de klant...",
      "invalid_datetime_error": "Ongeldige datum of tijd.",
      "just_now": "Zojuist",
      "kb.all_articles": "Alle artikelen",
      "kb.author": "Auteur",
      "kb.back_to_overview": "Terug naar het overzicht",
      "kb.browse_more": "← Meer artikelen doorbladeren",
      "kb.no_articles": "Nog geen kennisartikelen beschikbaar",
      "kb.no_articles_desc": "Hier verschijnen binnenkort nuttige artikelen",
      "kb.pinned": "Vastgepind",
      "kb.read_time": "{{count}} min. leestijd",
      "kb.search_placeholder": "Waarnaar zoekt u? bijv. VPN, wachtwoord, e-mail...",
      "kb.subtitle": "Handleidingen, tips en ondersteuning voor uw vragen",
      "kb.try_different_search": "Probeer een andere zoekterm",
      "kb.updated_at": "Bijgewerkt op {{date}}",
      "kb.views_count": "{{count}} weergaven",
      "keyboard_shortcuts": "Sneltoetsen",
      "knowledge": "Kennisbank",
      "knowledge_base": "Kennisbank",
      "kpi_held": "Afzender onduidelijk",
      "kpi_important": "belangrijk",
      "kpi_open": "open",
      "kpi_sla_breached": "SLA-schending",
      "kunde_loeschen.artikel": "Wissensartikel",
      "kunde_loeschen.bestaetigung_label": "Zur Bestätigung den Firmennamen eingeben",
      "kunde_loeschen.connectoren": "Connectoren",
      "kunde_loeschen.dokumente": "Dokumente",
      "kunde_loeschen.einleitung": "Dieser Kunde hat keine Tickets und keine Rechnungen. Er kann vollständig entfernt werden — mitsamt seinem Mandantenbereich in der Datenbank. Das lässt sich nicht rückgängig machen.",
      "kunde_loeschen.endgueltig_loeschen": "Endgültig löschen",
      "kunde_loeschen.fehlgeschlagen": "Das Löschen ist fehlgeschlagen.",
      "kunde_loeschen.geraete": "Geräte im Inventar",
      "kunde_loeschen.lizenzen": "Softwarelizenzen",
      "kunde_loeschen.mitarbeiter": "Mitarbeiter",
      "kunde_loeschen.netzgeraete": "Gefundene Netzwerkgeräte",
      "kunde_loeschen.nichts_dran": "An diesem Kunden hängen keine weiteren Daten.",
      "kunde_loeschen.portalbenutzer": "Portalzugänge",
      "kunde_loeschen.pruefung_fehlgeschlagen": "Die Prüfung ist fehlgeschlagen.",
      "kunde_loeschen.titel": "Kunde endgültig löschen",
      "kunde_loeschen.tokens": "API-Token",
      "kunde_loeschen.vertraege": "Verträge",
      "kunde_loeschen.wird_geprueft": "Wird geprüft …",
      "kunde_loeschen.wird_mitgeloescht": "Wird mitgelöscht",
      "kunde_loeschen.zeiten": "Zeiteinträge",
      "language": "Taal",
      "license.cluster_audit": "Audit",
      "license.cluster_balance": "Balans",
      "license.cluster_calc": "Calculators",
      "license.cluster_contracts": "Contracten & licenties",
      "license.cluster_optimize": "Optimalisatie",
      "license.tab_ad_coupling": "CAL-AD-koppeling",
      "license.tab_cal_calc": "CAL-calculator",
      "license.tab_catalog": "Softwarecatalogus",
      "license.tab_contracts": "Contracten",
      "license.tab_dashboard": "Licentiebalans & Trends",
      "license.tab_licenses": "Licentiebeheer",
      "license.tab_more_views": "Meer weergaven",
      "license.tab_reclaims": "Optimalisatie & Reclaims",
      "license.tab_remediation": "Remediation",
      "license.tab_sealed": "Auditarchief",
      "license.tab_sql_calc": "SQL-licentiecalculator",
      "license.tab_steering": "Sturing",
      "license.tab_suite_config": "Suite-configurator",
      "license_compliance.actions": "Acties",
      "license_compliance.assign_license_metric": "Licentiemetriek toewijzen",
      "license_compliance.confirm_delete_assignment": "Toewijzing echt verwijderen?",
      "license_compliance.confirm_delete_contract": "Contract echt verwijderen? Gekoppelde licenties blijven bestaan, maar worden losgekoppeld van het contract.",
      "license_compliance.contract_expiry_alert": "Contractverloop",
      "license_compliance.deficit_forecast_desc": "Op basis van live scans worden op de jaardag nabetalingskosten aangerekend voor ondergelicentieerde producten.",
      "license_compliance.edit_contract": "Contract aanpassen",
      "license_compliance.edit_license": "Licentie aanpassen",
      "license_compliance.expired_contracts_title": "Verlopen softwarecontracten vastgesteld!",
      "license_compliance.expired_contracts_warning_desc": "Licenties die aan deze contracten zijn toegewezen, worden genegeerd in de compliance-berekening.",
      "license_compliance.forecasted_payment": "Verwachte nabetaling",
      "license_compliance.license_deficit_alert": "Licentietekort",
      "license_compliance.mark_license_required_btn": "Als licentieplichtig markeren",
      "license_compliance.new_contract": "Nieuw contract aanmaken",
      "license_compliance.new_license": "Nieuwe licentie aanmaken",
      "license_compliance.no_deficit_desc": "Proficiat! Uw Microsoft Core/CAL-toewijzingen dekken alle scanbevindingen.",
      "license_compliance.not_catalogued": "Niet gecatalogiseerd",
      "license_compliance.reconciliation_desc": "Start een manuele reconciliatieronde voor deze tenant. Berekent VM-stacking, WMI-discoverystanden, Software Assurance-periodes en contractgeldigheden live opnieuw.",
      "license_compliance.reconciliation_running": "Reconciliatie loopt...",
      "license_compliance.run_reconciliation": "Afstemming uitvoeren",
      "license_compliance.sam_warnings_title": "SAM-waarschuwingen & compliance",
      "license_compliance.save_contract": "Contract opslaan",
      "license_compliance.save_license": "Licentie opslaan",
      "license_compliance.seal_audit": "Audit verzegelen",
      "license_compliance.seal_audit_btn": "Juridisch bindend verzegelen",
      "license_compliance.sealing": "Wordt verzegeld...",
      "license_compliance.toast.add_suite_component_error": "Fout bij het toewijzen van de suitecomponent",
      "license_compliance.toast.assignment_completed": "Licentietoewijzing succesvol uitgevoerd.",
      "license_compliance.toast.assignment_error": "Fout bij het uitvoeren van de toewijzing",
      "license_compliance.toast.bulk_classify_error": "Fout bij de massaclassificatie",
      "license_compliance.toast.bulk_classify_success": "{{count}} software-items succesvol geclassificeerd.",
      "license_compliance.toast.calc_audit_error": "Fout bij het berekenen van de licentieaudit",
      "license_compliance.toast.contract_created": "Contract succesvol aangemaakt.",
      "license_compliance.toast.contract_deleted": "Contract verwijderd.",
      "license_compliance.toast.contract_updated": "Contract succesvol bijgewerkt.",
      "license_compliance.toast.create_purchase_req_error": "Fout bij het aanmaken van de aankoopaanvraag",
      "license_compliance.toast.delete_contract_error": "Fout bij het verwijderen van het contract",
      "license_compliance.toast.delete_license_error": "Fout bij het verwijderen van de licentie",
      "license_compliance.toast.delete_suite_component_error": "Fout bij het verwijderen van de toewijzing",
      "license_compliance.toast.license_created": "Licentie succesvol aangemaakt.",
      "license_compliance.toast.license_deleted": "Licentie verwijderd.",
      "license_compliance.toast.license_updated": "Licentie succesvol bijgewerkt.",
      "license_compliance.toast.load_customers_error": "Fout bij het laden van de klantenlijst",
      "license_compliance.toast.purchase_req_created": "Aankoopaanvraag voor {{units}}x {{model}} (true-up: {{cost}}) aangemaakt als ticket {{ticket}}.",
      "license_compliance.toast.reconcile_completed": "Reconciliatie succesvol afgerond. De compliance-kengetallen zijn live opnieuw berekend.",
      "license_compliance.toast.reconcile_error": "Fout bij de reconciliatie",
      "license_compliance.toast.sam_settings_saved": "SAM-instellingen succesvol opgeslagen.",
      "license_compliance.toast.save_contract_error": "Fout bij het opslaan van het contract",
      "license_compliance.toast.save_license_error": "Fout bij het opslaan van de licentie",
      "license_compliance.toast.save_sam_settings_error": "Fout bij het opslaan van de SAM-instellingen",
      "license_compliance.toast.seal_audit_error": "Fout bij het verzegelen van de licentieaudit",
      "license_compliance.toast.seal_audit_success": "Licentieaudit succesvol verzegeld.",
      "license_compliance.toast.suite_component_added": "Component succesvol aan de suite toegewezen.",
      "license_compliance.toast.suite_component_deleted": "Toewijzing verwijderd.",
      "license_compliance.toast.uninstall_error": "Fout bij het starten van de de-installaties",
      "license_compliance.toast.uninstall_triggered": "De-installatieopdrachten in de wachtrij geplaatst.",
      "license_compliance.update_contract": "Contract bijwerken",
      "license_compliance.update_license": "Licentie bijwerken",
      "licenses": "Licenties",
      "light_mode": "Licht thema",
      "link_asset_btn": "+ Asset koppelen",
      "live_activity": "Live activiteit",
      "loading": "Wird geladen…",
      "loading_ellipsis": "Laden...",
      "location_on_map": "Locatie op kaart",
      "login.abbrechen": "Annuleren",
      "login.administratoradresse_konnte_nicht_geaendert_werden": "Die Administratoradresse konnte nicht geändert werden.",
      "login.adresse_aendern": "Adresse ändern",
      "login.adresse_wird_geaendert": "Adresse wird geändert…",
      "login.aendern": "Wijzigen",
      "login.aktivierung": "Activeren…",
      "login.aktivierung_fehlgeschlagen_code_pruefen": "Activering mislukt. Controleer de code.",
      "login.alle_rechte_vorbehalten": "· Alle rechten voorbehouden.",
      "login.anmelden": "Aanmelden",
      "login.anmelden_laeuft": "Aanmelden…",
      "login.anmeldung": "Aanmelden…",
      "login.bestaetigen": "Bevestigen",
      "login.bitte_geben_sie_eine_gueltige_e_mail_adresse": "Voer een geldig e-mailadres in.",
      "login.bitte_geben_sie_ihr_passwort_ein": "Voer uw wachtwoord in.",
      "login.bitte_geben_sie_zuerst_ihre_e_mail_adresse_e": "Voer eerst uw e-mailadres in.",
      "login.claim": "Servicedesk, assets en licenties — één databron, één proces.",
      "login.datenschutz": "Privacy",
      "login.e_mail_adresse_erfolgreich_geaendert": "E-Mail-Adresse erfolgreich geändert. Melden Sie sich jetzt mit der neuen Adresse an.",
      "login.ein_fehler_ist_aufgetreten": "Er is een fout opgetreden.",
      "login.einloggen_schliessen": "Aanmelden & sluiten",
      "login.erstanmeldung": "Eerste aanmelding:",
      "login.falls_ein_konto_existiert_wurde_eine_e_mail": "Als er een account bestaat, is er een e-mail verstuurd om het wachtwoord opnieuw in te stellen.",
      "login.fehler_beim_laden_des_mfa_setups": "Kan de MFA-instelling niet laden",
      "login.fehler_beim_ueberpruefen_der_e_mail_adresse": "Kan het e-mailadres niet controleren.",
      "login.geben_sie_den_6_stelligen_code_aus_ihrer_aut": "Voer de 6-cijferige code uit uw authenticator-app of een herstelcode in.",
      "login.geschaeftliche_e_mail": "Zakelijk e-mailadres",
      "login.ihr_account_ist_deaktiviert": "Uw account is gedeactiveerd.",
      "login.ihr_administrator_erfordert_die_einrichtung": "Uw administrator vereist dat u tweefactorauthenticatie instelt.",
      "login.impressum": "Colofon",
      "login.kunden_account_erkannt": "Klantaccount herkend",
      "login.manueller_schluessel": "Manuele sleutel",
      "login.melden_sie_sich_an_ihrem_service_desk_an": "Meld u aan bij uw servicedesk.",
      "login.mfa_aktivieren_weiter": "MFA inschakelen en doorgaan",
      "login.mfa_einrichtung_erforderlich": "MFA-instelling vereist",
      "login.mfa_einrichtung_fehlgeschlagen": "MFA-instelling mislukt.",
      "login.mfa_erfolgreich_aktiviert": "MFA is ingeschakeld",
      "login.neue_geschaeftliche_e_mail": "Neue geschäftliche E-Mail",
      "login.oder": "OF",
      "login.passwort": "Wachtwoord",
      "login.qr_code_fuer_die_authenticator_app": "QR-code voor de authenticator-app",
      "login.sechsstelliger_verifizierungscode": "6-cijferige verificatiecode",
      "login.sende": "Verzenden…",
      "login.sicherheitszeile": "AES-256 · Tweefactor · Eigen beheer",
      "login.sicherheitszeile_kurz": "AES-256 · Zwei-Faktor",
      "login.sie_werden_automatisch_zum_kundenportal_weit": "U wordt automatisch doorgestuurd naar het klantenportaal om u daar aan te melden...",
      "login.single_sign_on_entra_id": "Single Sign-On (Entra ID)",
      "login.speichern_sie_diese_einmal_wiederherstellung": "Bewaar deze eenmalige herstelcodes goed! U kunt ze gebruiken als u de toegang tot uw app verliest.",
      "login.sso_anmeldung_fehlgeschlagen": "SSO-aanmelding mislukt",
      "login.startkonto_bestaetigt_adresse_festlegen": "Die Zugangsdaten des Startkontos wurden bestätigt. Legen Sie jetzt die geschäftliche Adresse für den Administrator fest.",
      "login.ueberpruefe": "Controleren...",
      "login.ungueltiger_oder_abgelaufener_mfa_code": "Ongeldige of verlopen MFA-code.",
      "login.verifiziere": "Verifiëren…",
      "login.weiter": "Doorgaan",
      "login.willkommen_zurueck": "Welkom terug",
      "login.zurueck_zum_login": "Terug naar aanmelden",
      "login.zuruecksetzen": "Herstellen",
      "login.zwei_faktor_code_totp": "Tweefactorcode (TOTP)",
      "logout": "Afmelden",
      "main_navigation_rail": "Hoofdnavigatiebalk",
      "managing_director": "Directeur",
      "managing_director_abbrev": "Dir",
      "managing_director_prefix": "Directie:",
      "mark_all_read": "Alles als gelezen markeren",
      "mark_as_resolved": "Als opgelost markeren",
      "mati.connection_error": "Verbindingsfout",
      "mati.delete": "Verwijderen",
      "mati.error_failed_connection": "Verbinding met de AI-dienst mislukt.",
      "mati.error_generation": "Fout bij het genereren van het antwoord. Probeer het opnieuw.",
      "mati.gdpr_warning": "GDPR-filter actief: persoonsgegevens worden vóór de overdracht automatisch geanonimiseerd.",
      "mati.greeting": "Hallo {{name}}! Ik ben {{mascot}}. Hoe kan ik je vandaag helpen bij je werk? 🔮\\n\\nJe kunt mij vragen naar:\\n- De systeemstatus of de werkbelasting van de agenten\\n- Ticketzoekopdrachten (\"Zoek onopgeloste tickets met hoge prioriteit\")\\n- Ticketaanmaak (\"Maak een ticket aan: printercartridge op de 2e verdieping leeg\")",
      "mati.history": "Geschiedenis",
      "mati.input_placeholder": "Vraag me iets over tickets of werkbelasting, of maak een ticket aan...",
      "mati.new_chat": "Nieuwe chat",
      "mati.online_intelligent": "Online & intelligent",
      "mati.rename": "Hernoemen",
      "mati.restore_bead": "Zwevende helper weergeven",
      "mati.restore_bead_tooltip": "De zwevende helper (bead) opnieuw aan de schermrand weergeven",
      "mati.send_btn": "Verzenden",
      "mati.suggest.create_ticket.desc": "Printer op de 1e verdieping defect",
      "mati.suggest.create_ticket.prompt": "Maak een ticket aan voor een defecte printer op de 1e verdieping, prioriteit gemiddeld.",
      "mati.suggest.create_ticket.title": "Ticket aanmaken",
      "mati.suggest.search_tickets.desc": "Zoekopdracht \"database\"",
      "mati.suggest.search_tickets.prompt": "Zoek tickets die het woord \"database\" bevatten.",
      "mati.suggest.search_tickets.title": "Tickets zoeken",
      "mati.suggest.support_help.desc": "Hulp bij FAQ-ontwerpen",
      "mati.suggest.support_help.prompt": "Hoe formuleer ik een vriendelijke weigering op een aanvraag tot terugbetaling?",
      "mati.suggest.support_help.title": "Supporthulp",
      "mati.suggest.system_status.desc": "Huidige werkbelasting weergeven",
      "mati.suggest.system_status.prompt": "Toon mij de huidige systeemstatus en een overzicht van de werkbelasting van de agenten.",
      "mati.suggest.system_status.title": "Systeemstatus",
      "mati.typing_text": "{{name}} schrijft...",
      "mati.welcome_subtitle": "Ik ben je intelligente AI-copiloot. Ik kan je helpen om tickets te beheren, in het systeem te zoeken of systeemstatistieken te bekijken.",
      "mati.welcome_title": "Hallo! Ik ben {{name}}",
      "mati_gdpr_warning": "AVG-filter actief: Persoonlijke gegevens worden automatisch geanonimiseerd voor verzending.",
      "mati_placeholder": "Vraag me alles over tickets, werklast, of maak een ticket...",
      "mati_welcome": "Hallo! Ik ben {{name}}",
      "meeting_error_title": "Teams-vergadering kon niet worden aangemaakt.",
      "meeting_success": "Teams-vergadering aangemaakt.",
      "meeting_success_copy": "Teams-vergadering aangemaakt, link gekopieerd naar klembord.",
      "megamenu.active_label": "Werken",
      "megamenu.calendar_desc": "Afspraken en agenda-integratie.",
      "megamenu.licenses_desc": "Licentiecompliance, suites & true-up-planning.",
      "megamenu.modules": "Modules",
      "megamenu.open_calendar": "Agenda openen",
      "megamenu.open_licenses": "Licenties openen",
      "megamenu.open_problems": "Problemen openen",
      "megamenu.problems_desc": "Probleembeheer & RCA (Root Cause Analysis).",
      "megamenu.quick_search_commands": "Snel zoeken & opdrachten",
      "merge": "Zusammenführen",
      "merge_tickets": "Die beiden markierten Tickets zusammenführen",
      "mfa_settings": "MFA-instellingen",
      "minutes_ago": "{{count}} min. geleden",
      "mloffice.abgleich_fehler": "Abgleich konnte nicht gestartet werden.",
      "mloffice.abgleich_fehlgeschlagen": "Letzter Abgleich fehlgeschlagen: {{fehler}}",
      "mloffice.abgleich_gestartet": "Voll-Abgleich gestartet.",
      "mloffice.abgleich_laeuft": "Abgleich läuft",
      "mloffice.adresse": "MLOffice-Adresse",
      "mloffice.adresse_hinweis": "Basisadresse der MLOffice-Installation — ohne /api/v1.",
      "mloffice.agenten_titel": "Agenten ↔ MLOffice-Benutzer",
      "mloffice.aktion_anlegen": "Neu anlegen",
      "mloffice.aktion_entkoppeln": "Entkoppeln",
      "mloffice.aktion_entkoppeln_hinweis": "Aus dem Abgleich nehmen — der Kunde bleibt bestehen und wird wieder editierbar.",
      "mloffice.aktion_verknuepfen": "Verknüpfen",
      "mloffice.aktiv": "Aktiv",
      "mloffice.aktivieren": "Anbindung aktiv",
      "mloffice.auswahl_fehler": "Auswahl konnte nicht gespeichert werden.",
      "mloffice.bereits_uebertragen": "{{n}} Einträge im Zeitraum sind bereits übertragen und werden übersprungen.",
      "mloffice.email_eingeben": "Der Partner hat in MLOffice keine E-Mail-Adresse. E-Mail für den neuen Kunden:",
      "mloffice.entwurf_anlegen": "Entwurf anlegen",
      "mloffice.entwurf_fehler": "Entwurf konnte nicht angelegt werden.",
      "mloffice.entwurf_hinweis": "Erzeugt aus den bereits übertragenen Zeiten des Zeitraums einen ENTWURF in MLOffice. Belegnummer, Festschreibung und Versand bleiben MLOffice vorbehalten.",
      "mloffice.entwurf_ok": "Entwurf über {{h}} h in MLOffice angelegt — Festschreiben und Versand dort.",
      "mloffice.entwurf_titel": "Rechnungsentwurf in MLOffice",
      "mloffice.ereignis_closed": "Ticket geschlossen",
      "mloffice.ereignis_created": "Ticket eröffnet",
      "mloffice.ereignis_escalated": "Ticket eskaliert",
      "mloffice.ereignisse_titel": "Ticket-Ereignisse in die MLOffice-Kontakthistorie melden (nur Referenz, nie Inhalt):",
      "mloffice.erst_aktivieren": "Bitte zuerst die Anbindung aktivieren und die Verbindung testen — dann erscheint hier der MLOffice-Kundenbestand.",
      "mloffice.erst_aktivieren_abrechnung": "Bitte zuerst die Anbindung aktivieren — dann erscheinen hier offene Posten und der Kontingent-Abgleich.",
      "mloffice.erst_aktivieren_zeiten": "Bitte zuerst die Anbindung aktivieren — dann lassen sich Zeiten per Übertragungslauf nach MLOffice geben.",
      "mloffice.fallback_hinweis": "{{n}} Einträge ohne Agenten-Zuordnung werden über den technischen Benutzer gebucht (Agentenname in der Beschreibung).",
      "mloffice.feld_bis": "Bis",
      "mloffice.feld_kunde": "Kunde",
      "mloffice.feld_projekt": "MLOffice-Projekt",
      "mloffice.feld_satz": "Stundensatz (netto)",
      "mloffice.feld_von": "Von",
      "mloffice.gespeichert": "MLOffice-Einstellungen gespeichert.",
      "mloffice.gueltig_180": "180 Tage",
      "mloffice.gueltig_365": "365 Tage",
      "mloffice.gueltig_90": "90 Tage",
      "mloffice.gueltig_unbegrenzt": "Unbegrenzt",
      "mloffice.hoheit_frage": "MLOffice übernimmt die Hoheit über: {{felder}}.\\n\\nDiese Felder sind in AISupportDesk dann gesperrt und werden fortlaufend aus MLOffice übernommen. Fortfahren?",
      "mloffice.inaktiv": "Inaktiv",
      "mloffice.keine_partner": "Noch keine MLOffice-Kunden geladen. „Liste aus MLOffice laden“ holt den Bestand.",
      "mloffice.keine_zuordnung": "— keine Zuordnung —",
      "mloffice.konflikt_fehler": "Konnte nicht übernommen werden.",
      "mloffice.konflikt_geloest": "Übernommen.",
      "mloffice.konflikt_hinweis": "Übernahme braucht eine Entscheidung — siehe Konfliktzeile.",
      "mloffice.kopieren": "Kopieren",
      "mloffice.kunde_waehlen": "— Kunde wählen —",
      "mloffice.kunden_erklaerung": "Wähle aus, welche MLOffice-Kunden hier geführt werden. Ausgewählte Kunden werden fortlaufend abgeglichen; ihre Stammdaten sind hier gesperrt. Abwählen entkoppelt nur — der Kunde bleibt bestehen.",
      "mloffice.laden_fehler": "MLOffice-Einstellungen konnten nicht geladen werden.",
      "mloffice.laeufe_titel": "Bisherige Übertragungsläufe",
      "mloffice.lauf_detail": "Lauf #{{id}} — Einzelposten",
      "mloffice.lauf_fehler": "Lauf konnte nicht gestartet werden.",
      "mloffice.lauf_fertig": "Fertig",
      "mloffice.lauf_gestartet": "Übertragungslauf gestartet.",
      "mloffice.lauf_laeuft": "Läuft",
      "mloffice.lauf_starten": "Übertragung starten",
      "mloffice.lauf_teilfehler": "Mit Fehlern",
      "mloffice.linktoken_abgelaufen": "Das Verbindungstoken ist abgelaufen — MLOffice kann sich nicht mehr ausweisen. Neues Token erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_ablauf_teil": ", gültig bis {{datum}}",
      "mloffice.linktoken_einmal": "Jetzt kopieren — dieses Token wird nur EINMAL angezeigt:",
      "mloffice.linktoken_eintragen": "In MLOffice unter Einstellungen → AISupportDesk-Anbindung eintragen.",
      "mloffice.linktoken_erklaerung": "Dieses Token wird HIER erzeugt und in MLOffice unter „AISupportDesk-Anbindung“ eingetragen. MLOffice weist sich damit aus (Verbindungsstatus, Webhooks). Wird die Anbindung hier gelöst oder das Token widerrufen, zeigt MLOffice die Verbindung als gelöst.",
      "mloffice.linktoken_erzeugen": "Token erzeugen",
      "mloffice.linktoken_fehler": "Verbindungstoken konnte nicht erzeugt werden.",
      "mloffice.linktoken_gueltigkeit": "Gültigkeit",
      "mloffice.linktoken_kopiert": "Token kopiert.",
      "mloffice.linktoken_laeuft_ab": "Das Verbindungstoken läuft in {{tage}} Tagen ab. Rechtzeitig neu erzeugen und in MLOffice eintragen.",
      "mloffice.linktoken_neu": "Neues Token erzeugen",
      "mloffice.linktoken_rotieren_frage": "Es existiert bereits ein Verbindungstoken. Ein neues macht das alte sofort ungültig — MLOffice muss dann das neue Token eintragen. Fortfahren?",
      "mloffice.linktoken_status": "Hinterlegt ({{hint}}), erzeugt {{erzeugt}}{{ablauf}}.",
      "mloffice.linktoken_titel": "Verbindungstoken für MLOffice",
      "mloffice.linktoken_unbegrenzt_teil": ", unbegrenzt gültig",
      "mloffice.linktoken_widerruf_fehler": "Widerruf fehlgeschlagen.",
      "mloffice.linktoken_widerruf_frage": "Verbindungstoken widerrufen? MLOffice zeigt die Verbindung danach als gelöst; Webhooks und Statusabfragen von MLOffice werden abgewiesen.",
      "mloffice.linktoken_widerrufen": "Verbindungstoken widerrufen.",
      "mloffice.linktoken_widerrufen_btn": "Widerrufen",
      "mloffice.liste_aktualisieren": "Liste aus MLOffice laden",
      "mloffice.loesen_frage": "Verknüpfung lösen? Der Kunde bleibt bestehen und wird wieder frei bearbeitbar; der Abgleich mit MLOffice endet.",
      "mloffice.nur_verknuepfte": "Nur mit MLOffice verknüpfte Kunden.",
      "mloffice.ohne_email": "ohne E-Mail",
      "mloffice.op_aktualisiert": "Offene Posten aktualisiert.",
      "mloffice.op_belege": "Belege",
      "mloffice.op_fehler": "Offene Posten konnten nicht geladen werden.",
      "mloffice.op_laden": "Offene Posten aus MLOffice laden",
      "mloffice.op_stand": "Stand: {{zeit}}",
      "mloffice.op_titel": "Offene Posten (MLOffice)",
      "mloffice.partner_laden_fehler": "MLOffice-Kundenliste konnte nicht geladen werden.",
      "mloffice.posten_ok": "übertragen",
      "mloffice.posten_retry": "Erneut",
      "mloffice.posten_skip": "Überspringen",
      "mloffice.projekt_pflicht": "Bitte oben ein MLOffice-Projekt wählen.",
      "mloffice.projekt_waehlen": "— Projekt wählen —",
      "mloffice.rechte_fehlen": "Dem Token fehlen Rechte:",
      "mloffice.recon_asd": "Support-Sicht (NALVRA SERVICE)",
      "mloffice.recon_diff": "Abweichung Support- zu Abrechnungs-Sicht: {{min}} Min.",
      "mloffice.recon_gebucht": "{{min}} Min. im Projekt „{{projekt}}“ gebucht",
      "mloffice.recon_gesperrt_bis": "Erfassung gesperrt bis: {{d}}",
      "mloffice.recon_kein_projekt": "Kein MLOffice-Projekt zugeordnet (Tab „Zuordnung“).",
      "mloffice.recon_kein_vertrag": "Kein aktiver Vertrag mit Kontingent für diesen Kunden.",
      "mloffice.recon_mlo": "Abrechnungs-Sicht (MLOffice)",
      "mloffice.recon_offen": "{{min}} Min. der laufenden Periode sind noch nicht an MLOffice übertragen — Übertragungslauf im Tab „Zeiten-Übertragung“ starten.",
      "mloffice.recon_titel": "Kontingent-Abgleich",
      "mloffice.recon_verbrauch": "{{used}} von {{incl}} Min. verbraucht — {{rest}} Min. übrig",
      "mloffice.schon_drueben": "übertragen",
      "mloffice.sp_agent": "Agent",
      "mloffice.sp_beschreibung": "Beschreibung",
      "mloffice.sp_datum": "Datum",
      "mloffice.sp_fortschritt": "Gesendet / Fehler / Gesamt",
      "mloffice.sp_kunde": "Kunde",
      "mloffice.sp_minuten": "Min.",
      "mloffice.sp_status": "Status",
      "mloffice.sp_ticket": "Ticket",
      "mloffice.sp_zeitraum": "Zeitraum",
      "mloffice.spalte_kunde": "MLOffice-Kunde",
      "mloffice.spalte_status": "Status",
      "mloffice.spalte_sync": "Sync",
      "mloffice.spalte_zuordnung": "Zuordnung in NALVRA SERVICE",
      "mloffice.speichern": "Speichern",
      "mloffice.speichern_fehler": "Speichern fehlgeschlagen.",
      "mloffice.status_archiviert": "In MLOffice archiviert",
      "mloffice.status_delta": "Letzter Kundenabgleich: {{zeit}}",
      "mloffice.status_entkoppelt": "Entkoppelt",
      "mloffice.status_failed": "{{n}} Übertragungen fehlgeschlagen",
      "mloffice.status_kein_linktoken": "Kein Verbindungstoken für MLOffice erzeugt",
      "mloffice.status_konflikt": "Entscheidung nötig",
      "mloffice.status_linktoken_abgelaufen": "Verbindungstoken abgelaufen — neu erzeugen und in MLOffice eintragen",
      "mloffice.status_neu": "Neu",
      "mloffice.status_op": "Offene Posten: {{zeit}}",
      "mloffice.status_pending": "{{n}} Übertragungen offen",
      "mloffice.status_ratelimit": "MLOffice-Ratenbegrenzung — kurze Pause",
      "mloffice.status_sync_fehler": "Letzter Abgleich mit Fehler",
      "mloffice.status_uebernommen": "Übernommen",
      "mloffice.tab_abrechnung": "Abrechnung",
      "mloffice.tab_kunden": "Kundenabgleich",
      "mloffice.tab_verbindung": "Verbindung",
      "mloffice.tab_zeiten": "Zeiten-Übertragung",
      "mloffice.tab_zuordnung": "Zuordnung",
      "mloffice.techuser_hinweis": "Wird für Zeitbuchungen ohne Agenten-Zuordnung verwendet; der Agentenname wandert dann in die Buchungsbeschreibung.",
      "mloffice.techuser_titel": "Technischer Benutzer (Fallback)",
      "mloffice.test_fehler": "Verbindungstest fehlgeschlagen.",
      "mloffice.test_nicht_verbunden": "Keine Verbindung",
      "mloffice.test_ok": "Verbindung zu MLOffice steht.",
      "mloffice.test_verbunden": "Verbunden mit Mandant „{{tenant}}“",
      "mloffice.testen": "Verbindung testen",
      "mloffice.titel": "MLOffice-Anbindung",
      "mloffice.token": "API-Token",
      "mloffice.token_gesetzt": "hinterlegt ({{hint}})",
      "mloffice.token_hinweis": "In MLOffice unter Einstellungen → API-Tokens anlegen. Benötigte Rechte prüft der Verbindungstest.",
      "mloffice.token_name": "Token: {{name}}",
      "mloffice.token_unveraendert": "Leer lassen = unverändert",
      "mloffice.untertitel": "Kundenstammdaten, Abrechnung, Zeiterfassung und CRM mit MLOffice koppeln. MLOffice ist das führende System für Stammdaten und Rechnungen.",
      "mloffice.users_dropdown": "Zeitbuchungen werden in MLOffice unter dem zugeordneten Benutzer geführt. Ohne Zuordnung greift der technische Benutzer.",
      "mloffice.users_manuell": "MLOffice stellt (noch) keine Benutzerliste bereit — MLOffice-User-UUID bitte manuell eintragen (in MLOffice unter Benutzerverwaltung kopieren).",
      "mloffice.uuid_platzhalter": "MLOffice-User-UUID",
      "mloffice.verbindung": "Verbindung",
      "mloffice.vollabgleich": "Voll-Abgleich starten",
      "mloffice.vorschau": "Vorschau",
      "mloffice.vorschau_anlegen": "Wird neu angelegt",
      "mloffice.vorschau_email_fehlt": "E-Mail fehlt — wird bei Übernahme abgefragt",
      "mloffice.vorschau_fehler": "Vorschau fehlgeschlagen.",
      "mloffice.vorschau_titel": "Vorschau: {{n}} Einträge, {{h}} h werden übertragen",
      "mloffice.vorschau_verknuepfung": "Vorschlag: mit „{{name}}“ verknüpfen ({{grund}})",
      "mloffice.zeiten_erklaerung": "Zeiten werden NICHT automatisch übertragen. Du wählst Kunde und Zeitraum, prüfst die Vorschau und bestätigst — erst dann gehen die Buchungen nach MLOffice. Übertragene Buchungen sind dort unumkehrbar und hier gesperrt.",
      "mloffice.zeitraum_bis_heute": "Bis heute",
      "mloffice.zeitraum_dieser_monat": "Dieser Monat",
      "mloffice.zeitraum_letzter_monat": "Letzter Monat",
      "mloffice.zuordnung_fehler": "Zuordnung konnte nicht gespeichert werden.",
      "mloffice.zuordnung_fehlt": "{{n}} Einträge ohne Agenten-Zuordnung — bitte unter „Zuordnung“ pflegen oder einen technischen Benutzer hinterlegen.",
      "mloffice.zuordnung_gespeichert": "Zuordnung gespeichert.",
      "mobile": "Mobiel",
      "move_ticket": "Verschieben",
      "my_tickets": "Mijn tickets",
      "navbar_search_placeholder": "Zoeken in tickets, klanten of KB...",
      "new": "Nieuw",
      "new_activity_aria": "Nieuwe activiteit",
      "new_activity_title": "Nieuwe activiteit sinds laatste weergave",
      "new_company": "Neue Firma",
      "new_label": "Nieuw",
      "new_ticket": "Nieuw ticket",
      "next": "Weiter",
      "no_activities_recorded": "Nog geen activiteit geregistreerd.",
      "no_canned_responses": "Geen standaardteksten",
      "no_canned_responses_hint": "Te beheren in de administratie.",
      "no_critical_tickets": "Geen kritieke tickets",
      "no_customer_assigned": "Geen klant toegewezen",
      "no_customer_data": "Geen klantgegevens geladen.",
      "no_customers_found": "Geen klanten gevonden",
      "no_customers_matching": "Er zijn geen klanten gevonden voor uw filterselectie of zoekopdracht.",
      "no_data_available": "Geen gegevens beschikbaar",
      "no_employees_found": "Geen medewerkers geregistreerd",
      "no_notes_placeholder": "Geen notities beschikbaar. Klik op \"Aanpassen\" om notities toe te voegen.",
      "no_notifications": "Geen meldingen",
      "no_other_agents_online": "Momenteel geen andere teamleden online.",
      "no_results": "Geen resultaten",
      "no_tickets_found": "Geen tickets gevonden",
      "no_tickets_found_desc": "Er zijn momenteel geen items in deze filterwachtrij.",
      "no_tickets_risk": "Momenteel geen tickets in het kritieke SLA-waarschuwingsvenster.",
      "not_spam": "Geen spam",
      "notification_settings": "Notificatie-instellingen",
      "notification_settings_desc": "Kies welke meldingen u wilt ontvangen.",
      "notification_settings_saved": "Notificatie-instellingen opgeslagen.",
      "notifications": "Meldingen",
      "notify_license_change": "Licentiewijzigingen",
      "notify_new_reply": "Nieuwe reacties",
      "notify_new_ticket": "Nieuwe tickets",
      "notify_status_changed": "Statuswijzigingen",
      "observers_title": "Waarnemers",
      "only_visible_for": "Alleen {{name}}",
      "only_visible_to_agents": "Alleen zichtbaar voor medewerkers",
      "open_administration": "Open administratie",
      "open_btn": "Openen",
      "open_password_vault": "Wachtwoordkluis in browser openen",
      "open_quick_search": "Snel zoeken openen",
      "open_tickets": "Openstaande tickets",
      "other_tickets_count": "Overige tickets ({{count}})",
      "other_tickets_requester_count": "Overige tickets van de aanvrager ({{count}})",
      "overdue": "Vervallen",
      "overview_option_1": "1. Standaard KPI-dashboard",
      "overview_option_10": "10. SLA-schendingspercentage op basis van prioriteit",
      "overview_option_2": "2. Eerste-lijns oplossingspercentage (FCR) & reactietijd",
      "overview_option_3": "3. Ticketvolume-ontwikkeling & piekuren",
      "overview_option_4": "4. Oplossingspercentage trends (Gemaakt vs. Opgelost)",
      "overview_option_5": "5. CSAT vs. Oplossingstijd matrix",
      "overview_option_6": "6. Ticketkanalen & bron-uitsplitsing",
      "overview_option_7": "7. Escalatieratio's & escalatiepad-analyse",
      "overview_option_8": "8. Gemiddelde levensduur ticket (veroudering)",
      "overview_option_9": "9. Backlog-status & veroudering",
      "performance_queues": "Prestaties & Wachtrijen",
      "phone": "Telefoon",
      "plan_teams_meeting": "Teams-vergadering plannen",
      "planning": "Planning",
      "please_enter_text": "Voer tekst in",
      "policy": "Beleid",
      "portal_company.load_failed": "Dokumente konnten nicht geladen werden.",
      "portal_company.primary_contact": "Hauptansprechpartner",
      "portal_session.continue": "Weiterarbeiten",
      "portal_session.login": "Erneut anmelden",
      "portal_session.warning": "Ihre Sitzung endet in {{seconds}} Sekunden. Gespeicherte Entwürfe bleiben erhalten.",
      "portal_speech.denied": "Mikrofonzugriff oder Spracherkennung wurde nicht erlaubt. Bitte die Browserberechtigung prüfen.",
      "portal_speech.failed": "Spracheingabe nicht verfügbar. Bitte Mikrofon und Verbindung prüfen oder weitertippen.",
      "portal_speech.listening": "Mikrofon aktiv – bitte sprechen …",
      "portal_speech.notice": "Diktierter Text wird unten an die Beschreibung angefügt. Der Browser kann Audio zur Erkennung an seinen Sprachdienst senden.",
      "portal_speech.silence": "Keine Sprache erkannt. Bitte erneut starten.",
      "portal_speech.start": "Diktat starten",
      "portal_speech.stop": "Stoppen",
      "portal_speech.title": "Spracheingabe",
      "portal_speech.unsupported": "Dieser Browser unterstützt hier keine Spracheingabe. Sie können die Diktierfunktion Ihrer Tastatur verwenden.",
      "preview": "Voorbeeld",
      "previous": "Zurück",
      "primary": "Primair",
      "priority": "Prioriteit",
      "priority_": "",
      "priority_critical": "Kritiek",
      "priority_high": "Hoog",
      "priority_low": "Laag",
      "priority_medium": "Gemiddeld",
      "priority_urgent": "Dringend",
      "problem_cascade_close_checkbox": "Ja, alle gekoppelde incidenten sluiten (aanbevolen)",
      "problem_cascade_close_desc": "Er zijn gekoppelde openstaande incidenten. Wilt u deze automatisch oplossen en voorzien van een opmerking met de bronoorzaak & oplossing?",
      "problem_cascade_close_title": "Kaskade sluiten",
      "problem_confirm_resolve": "Bevestigen & Oplossen",
      "problem_create_btn": "Probleem aanmaken",
      "problem_create_error": "Fout bij maken van probleem",
      "problem_create_success": "Probleemticket aangemaakt.",
      "problem_create_title": "Nieuw probleemticket aanmaken",
      "problem_created_by_on": "Aangemaakt door {{creator}} op {{date}}",
      "problem_description_label": "Probleembeschrijving",
      "problem_detail_load_error": "Fout bij laden van probleemdetails",
      "problem_incidents_linked": "Gekoppelde incidenten",
      "problem_kedb_empty": "Geen bekende fouten",
      "problem_kedb_empty_desc": "Problemen die als known error zijn geclassificeerd, verschijnen hier met oorzaak en workaround.",
      "problem_kedb_load_error": "Fout bij het laden van de bekende fouten",
      "problem_kedb_search_placeholder": "Bekende fouten doorzoeken...",
      "problem_kedb_title": "Bekende fouten (Known Errors)",
      "problem_known_error_badge": "Bekende fout",
      "problem_known_error_checkbox": "Klassificeren als Known Error (Bekende fout)",
      "problem_known_error_only": "Alleen bekende fouten",
      "problem_link_btn": "Koppelen",
      "problem_link_error": "Fout bij koppelen van incidenten",
      "problem_link_incident_btn": "Incident koppelen",
      "problem_link_incidents_title": "Incidenten koppelen",
      "problem_link_success": "Incidenten gekoppeld.",
      "problem_linked_incidents": "Gekoppelde incidenten",
      "problem_load_error": "Fout bij laden van problemen",
      "problem_loading": "ITIL Probleembeheer laden...",
      "problem_mark_known_error": "Als known error markeren",
      "problem_no_incidents_found": "Geen gekoppelde incidenten gevonden.",
      "problem_no_tickets": "Geen probleemtickets",
      "problem_no_tickets_desc": "Er zijn momenteel geen ITIL-probleemtickets geregistreerd.",
      "problem_no_unlinked_found": "Geen openstaande, ongekoppelde incidenten gevonden.",
      "problem_none": "—",
      "problem_none_selected": "Geen probleem geselecteerd",
      "problem_none_selected_desc": "Selecteer links een ITIL-probleemticket of maak een nieuwe aan om RCA-gegevens te beheren.",
      "problem_open_change_confirm": "Nieuw wijzigingsticket {{num}} nu openen?",
      "problem_raise_change_btn": "Wijziging afleiden",
      "problem_raise_change_error": "Fout bij het afleiden van de wijziging",
      "problem_raise_change_success": "Wijzigingsticket aangemaakt: {{num}}",
      "problem_raise_change_title": "Wijziging afleiden uit dit probleem",
      "problem_rca_title": "ITIL-problemen (RCA)",
      "problem_resolution_note": "Oplossingsnotitie",
      "problem_resolution_note_placeholder": "Voer details over de definitieve oplossing in...",
      "problem_resolve_btn": "Probleem oplossen",
      "problem_resolve_error": "Fout bij oplossen van probleem",
      "problem_resolve_success": "Probleem opgelost.",
      "problem_root_cause_label": "Vermoedelijke bronoorzaak",
      "problem_root_cause_short": "Bronoorzaak",
      "problem_search_placeholder": "Problemen doorzoeken...",
      "problem_stage_closed": "Gesloten",
      "problem_stage_known_error": "Bekende fout",
      "problem_stage_label": "Levenscyclusstatus (probleemfase)",
      "problem_stage_open": "Open",
      "problem_stage_resolved": "Opgelost",
      "problem_stage_under_investigation": "In onderzoek",
      "problem_stage_updated": "Levenscyclusstatus bijgewerkt.",
      "problem_stage_workaround_found": "Workaround gevonden",
      "problem_tab_kedb": "Known-error-DB (KEDB)",
      "problem_tab_problems": "Problemen (RCA)",
      "problem_title": "ITIL-probleem: Terugkerend incident",
      "problem_title_label": "Probleemtitel",
      "problem_unlink_btn": "Ontkoppelen",
      "problem_unlink_error": "Fout bij het ontkoppelen",
      "problem_unlink_success": "Koppeling opgeheven.",
      "problem_update_error": "Fout bij bijwerken van problem",
      "problem_update_success": "Probleem succesvol bijgewerkt.",
      "problem_workaround_label": "Bekende workaround",
      "problem_workaround_short": "Workaround",
      "problems": "Problemen",
      "queue.": "queue.",
      "queue_external_processing": "Externe Bearbeitung",
      "queues": "Wachtrijen",
      "quick_access_views": "Snelle toegang & weergaven",
      "quick_search": "Snel zoeken",
      "read_ticket_also": "leest dit ticket ook",
      "reading_ticket": "Leest ticket #{{id}}",
      "reassign_to": "Opnieuw toewijzen ({{name}})...",
      "recent_activities_description": "Recente ticket- en antwoordactiviteiten voor deze klant.",
      "recent_tickets": "Recente tickets",
      "refresh": "Vernieuwen",
      "remove_assignment": "Toewijzing verwijderen",
      "remove_attachment_aria": "Bijlage {{filename}} verwijderen",
      "remove_filter": "Filter entfernen",
      "reopen": "Heropenen",
      "reply": "Beantwoorden",
      "reply_keyboard_shortcut_hint": "Sneltoets: Ctrl of Cmd + Enter om te verzenden wanneer de cursor in de tekst staat.",
      "report_active_breaches": "Actieve schendingen",
      "report_ai_analysis": "AI-analyse",
      "report_ai_analyzing": "AI analyseert rapportgegevens...",
      "report_ai_highlights": "Opvallende zaken",
      "report_ai_recommendations": "Aanbevelingen",
      "report_billable": "Factureerbaar",
      "report_compliance": "Compliance",
      "report_export": "Exporteren",
      "report_exporting": "Exporteren...",
      "report_no_data": "Geen gegevens beschikbaar",
      "report_no_data_desc": "Er konden geen rapportgegevens worden geladen voor deze periode.",
      "report_range": "Rapportweergave:",
      "report_total_time": "Totale tijd",
      "reports": "Rapportering",
      "reports_desc": "Service Management rapporten & analyse",
      "request.additional_info": "Bijkomende gegevens",
      "request.back_to_dashboard": "Terug naar het dashboard",
      "request.back_to_dashboard_link": "← Dashboard",
      "request.back_to_list": "Naar het overzicht",
      "request.back_to_requests": "← Alle aanvragen",
      "request.catalog_subtitle": "Kies een aanvraagtype — u krijgt een passend formulier.",
      "request.choose_files": "Bestanden kiezen",
      "request.description_placeholder": "Beschrijf uw vraag…",
      "request.description_required": "Voer een beschrijving in.",
      "request.failed_load_catalog": "De catalogus kon niet worden geladen",
      "request.file_too_large": "Bestand te groot (max. {{max}} MB): {{name}}",
      "request.file_type_not_allowed": "Dateityp nicht erlaubt: {{name}}",
      "request.no_requests": "Er zijn geen serviceaanvragen vrijgegeven in het portaal.",
      "request.not_available": "Deze aanvraag is niet beschikbaar of niet gepubliceerd.",
      "request.optional_select": "— Optioneel —",
      "request.please_select": "— Maak een keuze —",
      "request.remove_file": "Verwijderen",
      "request.required_field": "Verplicht veld: {{label}}",
      "request.standard_fields_info": "Standaardvelden: prioriteit, categorie, beschrijving en bijlagen zijn bij elke serviceaanvraag inbegrepen. Daaronder volgen eventueel bijkomende velden voor dit aanvraagtype.",
      "request.submit_btn": "Aanvraag verzenden",
      "request.submit_failed": "Verzenden mislukt",
      "request.submitting_btn": "Wordt verzonden…",
      "request_type": "Type aanvraag",
      "requester_title": "Aanvrager",
      "reset": "Herstellen",
      "reset_all_filters": "Alle Filter zurücksetzen",
      "reset_filter": "Filter herstellen",
      "reset_kpi_filter": "Kachel-Filter zurücksetzen",
      "reset_to_default": "Standaard herstellen",
      "resolution": "Oplossing",
      "resolve": "Oplossen",
      "resolved_label": "Opgelost",
      "retry": "Erneut versuchen",
      "risk": "Risico",
      "risk_minutes": "{{count}} min",
      "save": "Opslaan",
      "save_changes": "Wijzigingen opslaan",
      "save_note": "Notitie opslaan",
      "saving": "Opslaan...",
      "scroll_to_reply": "Naar antwoord scrollen",
      "search": "Zoeken...",
      "search_canned_responses": "Standaardteksten doorzoeken…",
      "search_customers": "Klanten zoeken...",
      "select_company": "Firma auswählen…",
      "select_customer_placeholder": "Selecteer een klant uit de lijst",
      "self_healing": "Zelfherstel",
      "send": "Verzenden",
      "sending_ellipsis": "Verzenden...",
      "settings": "Instellingen",
      "seven_days": "7 Dagen",
      "shortcut_back_close": "Terug / Sluiten",
      "shortcut_escalate": "Escaleren",
      "shortcut_focus_mode": "Focusmodus",
      "shortcut_help": "Deze hulp",
      "shortcut_internal_note": "Interne notitie",
      "shortcut_next_prev": "Volgend / Vorig ticket",
      "shortcut_quick_search": "Snel zoeken",
      "shortcut_write_reply": "Antwoord schrijven",
      "show_all": "Toon alles",
      "show_full_ticket_backlog": "Volledige ticket-backlog weergeven",
      "show_older_replies": "{{count}} oudere antwoorden weergeven...",
      "sla_and_contract_title": "SLA & Contract",
      "sla_breached_both": "Reactie- en oplossingstermijn overschreden",
      "sla_breached_exclamation": "SLA geschonden!",
      "sla_breached_resolution": "Oplossingstermijn overschreden",
      "sla_breached_response": "Reactietermijn overschreden",
      "sla_breaches": "SLA-schendingen:",
      "sla_compliance": "SLA-naleving",
      "sla_level": "SLA-niveau:",
      "sla_option_1": "1. SLA-naleving & trends (Overzicht)",
      "sla_option_10": "10. SLA weekend- & feestdagenstatistieken",
      "sla_option_2": "2. SLA-schendingen & risicovolle tickets",
      "sla_option_3": "3. SLA op prioriteit",
      "sla_option_4": "4. SLA per klant / serviceplan",
      "sla_option_5": "5. SLA-naleving reactietijd",
      "sla_option_6": "6. SLA-naleving oplossingstijd",
      "sla_option_7": "7. SLA-schendingen per agent/groep",
      "sla_option_8": "8. Oorzaken SLA-schendingen",
      "sla_option_9": "9. Voorbeeld boetes & tegoeden (financieel risico)",
      "sla_performance_breaches": "SLA-prestaties & schendingen",
      "sla_risk": "SLA-risico",
      "sla_status_ok": "OK",
      "sort_by_label": "Sorteren op {{label}}",
      "spam": "Spam",
      "starred": "Met ster",
      "start": "Start",
      "status": "Status",
      "status_closed": "Sluiten",
      "status_in_progress": "In behandeling",
      "status_new": "Nieuw",
      "status_on_hold": "In de wacht",
      "status_open": "Open",
      "status_resolved": "Opgelost",
      "status_waiting": "Wachtend",
      "status_waiting_customer": "Wacht op klant",
      "street": "Straat",
      "subtasks": "Teilaufgaben",
      "supporting_agents": "Ondersteunende agenten",
      "switch_language": "Taal wijzigen",
      "system_logs": "Systeemlogs",
      "tab_": "",
      "tab_activity": "Activiteit",
      "tab_agents": "Agenten",
      "tab_assets": "Assets",
      "tab_contracts": "Contracten",
      "tab_csat": "CSAT",
      "tab_custom": "Aangepaste rapporten",
      "tab_customers": "Klanten",
      "tab_documents": "Documenten",
      "tab_employees": "Medewerkers",
      "tab_incidents": "Incidenten",
      "tab_licenses": "Licenties",
      "tab_notes": "Notities",
      "tab_overview": "Overzicht",
      "tab_sla": "SLA",
      "tab_tickets": "Tickets",
      "tab_time": "Tijdregistratie",
      "tab_trends": "Trends",
      "tag_add_placeholder": "Tag toevoegen...",
      "tag_label": "Tag",
      "tax_number": "Belastingnummer",
      "teams_call_start": "Teams-oproep starten",
      "teams_chat_open": "Teams Chat openen",
      "teams_meeting_subject": "Vergadering {{number}}",
      "teams_meeting_title": "Teams-vergadering",
      "thirty_days": "30 Dagen",
      "ticket_assets.action_col": "Actie",
      "ticket_assets.agent_offline": "Agent offline",
      "ticket_assets.agent_ready": "Klaar",
      "ticket_assets.assigned_assets": "Aan de medewerker toegewezen assets",
      "ticket_assets.bios_label": "BIOS-versie:",
      "ticket_assets.calculating_compliance": "Licentieaudit wordt berekend...",
      "ticket_assets.clean_temp": "Temp opruimen",
      "ticket_assets.cmd_status_completed": "Klaar",
      "ticket_assets.cmd_status_failed": "Fout",
      "ticket_assets.cmd_status_pending": "Wachtend",
      "ticket_assets.cmd_status_running": "Bezig...",
      "ticket_assets.cmdb_alert_desc": "Dit asset hangt af van/is verbonden met:",
      "ticket_assets.cmdb_alert_title": "CMDB-cascadewaarschuwing: afhankelijkheidsstoring!",
      "ticket_assets.command_execution_failed": "Uitvoering van de opdracht mislukt.",
      "ticket_assets.command_placeholder": "bijv. ipconfig /all, systeminfo, dir",
      "ticket_assets.command_running": "De opdracht wordt momenteel uitgevoerd op het clientapparaat...",
      "ticket_assets.command_success_solved": "Succesvol uitgevoerd! Het ticket is automatisch opgelost.",
      "ticket_assets.command_timeout": "Time-out bij het uitvoeren van de opdracht.",
      "ticket_assets.compliant": "Conform",
      "ticket_assets.confirm_kill_process": "Wilt u het proces met PID {{pid}} echt beëindigen?",
      "ticket_assets.cpu_cores_label": "Kernen:",
      "ticket_assets.cpu_label": "Processor (CPU)",
      "ticket_assets.cpu_sockets_label": "Sockets:",
      "ticket_assets.cpu_util_label": "CPU-gebruik",
      "ticket_assets.created_label": "Aangemaakt:",
      "ticket_assets.device_scan_label": "Apparaatscan",
      "ticket_assets.disk_free_label": "vrij",
      "ticket_assets.disk_used_label": "Gebruikt",
      "ticket_assets.disks_label": "Harde schijven / stations",
      "ticket_assets.domain_label": "Werkgroep/domein:",
      "ticket_assets.edition_id_label": "Edition-ID:",
      "ticket_assets.employee_assets": "Medewerkersassets",
      "ticket_assets.error_kill_process": "Fout bij het beëindigen van het proces: {{error}}",
      "ticket_assets.error_loading_monitoring": "Fout bij het laden van de monitoring",
      "ticket_assets.error_sending_command": "Fout bij het verzenden van de opdracht.",
      "ticket_assets.error_submit_command": "De opdracht kon niet worden doorgestuurd: {{error}}",
      "ticket_assets.executed_label": "Uitgevoerd:",
      "ticket_assets.fetch_logs_btn": "Logboeken ophalen",
      "ticket_assets.filter_processes_placeholder": "Processen filteren (naam, PID)...",
      "ticket_assets.fix_dns": "DNS herstellen",
      "ticket_assets.fix_spooler": "Spooler herstellen",
      "ticket_assets.hostname_label": "Netwerknaam:",
      "ticket_assets.incomplete_summary": "Compliance-samenvatting onvolledig.",
      "ticket_assets.invalid_json_response": "Ongeldig antwoord van de server",
      "ticket_assets.kill_btn": "Kill",
      "ticket_assets.killing_proc": "Wordt beëindigd...",
      "ticket_assets.last_scan_label": "Laatste scan:",
      "ticket_assets.license_compliance": "Licentiecompliance",
      "ticket_assets.link": "Koppelen",
      "ticket_assets.link_asset_title": "Asset koppelen",
      "ticket_assets.linked": "Gekoppeld",
      "ticket_assets.linked_assets": "Aan het ticket gekoppelde assets",
      "ticket_assets.loading": "Assets worden geladen...",
      "ticket_assets.loading_command_queue": "Opdrachtwachtrij laden...",
      "ticket_assets.loading_logs": "Gebeurtenislogboeken worden geladen...",
      "ticket_assets.loading_monitoring": "Live monitoring & CMDB-check laden...",
      "ticket_assets.log_name_label": "Logboeknaam",
      "ticket_assets.memory_col": "Werkgeheugen",
      "ticket_assets.model_label": "Model:",
      "ticket_assets.monitored_ok": "Monitored (OK)",
      "ticket_assets.more_params_title": "Overige parameters",
      "ticket_assets.motherboard_label": "Moederbord:",
      "ticket_assets.no_active_zabbix_alerts": "Geen actieve Zabbix-alarmen.",
      "ticket_assets.no_assets_assigned": "Aan deze medewerker zijn geen IT-assets toegewezen.",
      "ticket_assets.no_assets_linked": "Geen assets gekoppeld.",
      "ticket_assets.no_commands_executed": "Nog geen opdrachten uitgevoerd. Voer hieronder een opdracht in.",
      "ticket_assets.no_compliance_available": "Geen licenties of compliancerapport beschikbaar.",
      "ticket_assets.no_employee_assigned": "Geen medewerker toegewezen aan het ticket.",
      "ticket_assets.no_hardware_details": "Geen hardwaredetails gescand.",
      "ticket_assets.no_matching_software": "Geen overeenkomende software-items gevonden.",
      "ticket_assets.no_monitoring_data": "Geen monitoringgegevens beschikbaar",
      "ticket_assets.os_arch_label": "Architectuur:",
      "ticket_assets.os_label": "Besturingssysteem",
      "ticket_assets.os_ver_label": "Versie:",
      "ticket_assets.overlicensed": "Overgelicentieerd",
      "ticket_assets.pagination_text": "Pagina {{page}} van {{total}} ({{count}} items)",
      "ticket_assets.process_name_col": "Procesnaam",
      "ticket_assets.publisher_col": "Uitgever",
      "ticket_assets.query_realtime_btn": "Realtime opvragen",
      "ticket_assets.ram_label": "Werkgeheugen (RAM)",
      "ticket_assets.ram_util_label": "RAM-gebruik",
      "ticket_assets.scan_details_btn": "Scandetails",
      "ticket_assets.scan_never": "nooit",
      "ticket_assets.search_logs_placeholder": "Resultaten doorzoeken (bron, ID, message)...",
      "ticket_assets.search_placeholder": "Naam, IP of S/N zoeken...",
      "ticket_assets.search_software_placeholder": "Software doorzoeken...",
      "ticket_assets.self_healing_title": "Zelfherstel & automatisering",
      "ticket_assets.send_btn": "Verzenden",
      "ticket_assets.sending_command_failed": "Verzenden van de opdracht mislukt.",
      "ticket_assets.serial_number_label": "Serienummer:",
      "ticket_assets.severity_all": "Alle",
      "ticket_assets.severity_error": "Fout (Error)",
      "ticket_assets.severity_info": "Informatie",
      "ticket_assets.severity_label": "Ernstgraad",
      "ticket_assets.severity_warning": "Waarschuwing (Warning)",
      "ticket_assets.sn_label": "S/N:",
      "ticket_assets.software_name_col": "Softwarenaam",
      "ticket_assets.sql_instance_label": "Instantie:",
      "ticket_assets.sql_instances_title": "Gedetecteerde SQL Server-instanties",
      "ticket_assets.sql_patchlevel_label": "Patchlevel:",
      "ticket_assets.success_kill_process": "Proces succesvol beëindigd.",
      "ticket_assets.surplus_label": "Overschot:",
      "ticket_assets.timeout_kill_process": "Time-out bij het beëindigen van het proces.",
      "ticket_assets.total_ram_desc": "Totaal fysiek geheugen",
      "ticket_assets.underlicensed": "Ondergelicentieerd",
      "ticket_assets.unlink_asset_title": "Koppeling opheffen",
      "ticket_assets.unreachable": "Niet bereikbaar",
      "ticket_assets.version_col": "Versie",
      "ticket_assets.virtualization_label": "Virtualisatie:",
      "ticket_assets.waiting_agent_response": "Wachten op antwoord van de agent...",
      "ticket_assets.waiting_agent_timeout": "Time-out: de agent heeft niet tijdig geantwoord.",
      "ticket_assets.zabbix_live_status": "Zabbix live-status",
      "ticket_created": "Ticket aangemaakt",
      "ticket_detail.achtung_ueberschneidungskollisionen_ci_abhae": "Opgelet: overlappingsconflicten (CI-afhankelijkheden) vastgesteld!",
      "ticket_detail.aktivitaeten": "Activiteiten",
      "ticket_detail.aktivitaets_verlauf": "Activiteitengeschiedenis",
      "ticket_detail.als_diesen_kunden_im_portal_anmelden": "Als deze klant aanmelden in het portaal",
      "ticket_detail.anhaenge": "Bijlagen",
      "ticket_detail.begruendung_kommentare": "Motivering / opmerkingen",
      "ticket_detail.bekannter_fehler_workaround_verfuegbar": "Gekende fout — workaround beschikbaar",
      "ticket_detail.cab_hat_die_aenderung_abgelehnt": "Het CAB heeft de wijziging afgekeurd",
      "ticket_detail.change_advisory_board_cab_stimmen": "Stemmen van het Change Advisory Board (CAB)",
      "ticket_detail.das_ticket_existiert_nicht_oder_wurde_geloes": "Het ticket bestaat niet of werd verwijderd.",
      "ticket_detail.der_status_kann_erst_auf_in_bearbeitung_oder": "De status kan pas op „In behandeling\" of „Opgelost\" worden gezet zodra de CAB-meerderheid heeft ingestemd.",
      "ticket_detail.detaillierte_schritte_zur_durchfuehrung": "Gedetailleerde stappen voor de uitvoering...",
      "ticket_detail.es_wurde_noch_kein_change_plan_fuer_dieses_t": "Er werd nog geen wijzigingsplan aangemaakt voor dit ticket.",
      "ticket_detail.es_wurden_andere_aktive_tickets_auf_denselbe": "Er zijn andere actieve tickets ingepland op dezelfde of afhankelijke CMDB-assets in dezelfde periode:",
      "ticket_detail.extrahierte_daten": "Geëxtraheerde gegevens",
      "ticket_detail.geplanter_start_wartungsfenster": "Geplande start (onderhoudsvenster)",
      "ticket_detail.geplantes_ende": "Gepland einde",
      "ticket_detail.geplantes_wartungsfenster": "Gepland onderhoudsvenster:",
      "ticket_detail.hinzufuegen": "Toevoegen",
      "ticket_detail.keine_aktivitaeten_vorhanden": "Geen activiteiten aanwezig",
      "ticket_detail.keine_anhaenge_vorhanden": "Geen bijlagen aanwezig",
      "ticket_detail.keine_kategorie": "Geen categorie",
      "ticket_detail.kommentar_zur_entscheidung_optional": "Opmerking bij de beslissing (optioneel)...",
      "ticket_detail.loeschen": "Verwijderen",
      "ticket_detail.niemand_zugewiesen": "Niemand toegewezen",
      "ticket_detail.noch_keine_stimmen_abgegeben": "Er zijn nog geen stemmen uitgebracht.",
      "ticket_detail.noch_keine_zeit_erfasst": "Nog geen tijd geregistreerd",
      "ticket_detail.nur_fuer_mitarbeiter_sichtbar": "Enkel zichtbaar voor medewerkers",
      "ticket_detail.prioritaet": "Prioriteit",
      "ticket_detail.sprachnotizen_in_administration_ki_einstellu": "Activeer spraaknotities in Administratie → AI-instellingen.",
      "ticket_detail.sprachnotizen_nicht_aktiv": "Spraaknotities niet actief",
      "ticket_detail.stimme_uebermitteln": "Stem uitbrengen",
      "ticket_detail.tag_entfernen": "Tag verwijderen",
      "ticket_detail.tag_hinzufuegen": "Tag toevoegen…",
      "ticket_detail.tag_hinzufuegen_2": "Tag toevoegen",
      "ticket_detail.ticket_nicht_gefunden": "Ticket niet gevonden",
      "ticket_detail.ticket_wird_geladen": "Ticket wordt geladen...",
      "ticket_detail.timer_laeuft_fuer_anderes_ticket": "Timer loopt voor een ander ticket",
      "ticket_detail.timer_starten": "Timer starten",
      "ticket_detail.timer_stoppen": "Timer stoppen",
      "ticket_detail.uebersicht": "Overzicht",
      "ticket_detail.veroeffentlicht": "Gepubliceerd",
      "ticket_detail.was_wurde_erledigt": "Wat werd er uitgevoerd?",
      "ticket_detail.welches_risiko_besteht_fuer_den_betrieb": "Welk risico houdt dit in voor de werking?",
      "ticket_detail.wie_machen_wir_aenderungen_rueckgaengig": "Hoe maken we wijzigingen ongedaan?",
      "ticket_detail.wie_wird_die_funktion_verifiziert": "Hoe wordt de werking geverifieerd?",
      "ticket_detail.zeiteintraege": "Tijdsregistraties",
      "ticket_detail.zugewiesen_an": "Toegewezen aan",
      "ticket_detail.zugewiesen_an_2": "Toegewezen aan",
      "ticket_detail.zurueck_zur_uebersicht": "Terug naar het overzicht",
      "ticket_detail.zustimmung_des_change_advisory_boards_cab_zw": "Goedkeuring van het Change Advisory Board (CAB) is verplicht",
      "ticket_filter_active_label": "Filter aktiv",
      "ticket_inventory_kpis": "Kennzahlen & Arbeitslast",
      "ticket_properties_title": "Ticket",
      "ticket_relations": "Verknüpfte Tickets",
      "ticket_view_search_label": "Diese Ticketansicht durchsuchen",
      "tickets": "Tickets",
      "tickets_exist_hint": "Insgesamt sind {{count}} Tickets vorhanden.",
      "tickets_near_sla_breach": "Tickets bijna in SLA-overschrijding",
      "tickets_plural": "{{count}} tickets",
      "tickets_ratio_label": "{{count}} van de {{total}} tickets",
      "tickets_selected": "{{count}} tickets geselecteerd",
      "tickets_without_assignee": "Tickets zonder behandelaar",
      "time_logged": "Tijd geregistreerd: {{time}}",
      "time_minutes": "Zeit in Minuten",
      "title": "Titel",
      "to_reply_composer": "Naar antwoord (Composer)",
      "today_due": "Vandaag vervallen",
      "toggle_design_mode": "Wissel ontwerpmodus",
      "toggle_favorite": "Favoriet in-/uitschakelen",
      "tracked_hours": "{{hours}} uur",
      "tracked_hours_min": "{{hours}} uur {{minutes}} min.",
      "tracked_min": "{{minutes}} min.",
      "tracked_time": "Geregistreerde tijd",
      "unassigned": "Niet toegewezen",
      "unlink_asset": "Ontkoppelen",
      "unread": "Ongelezen",
      "update": "Bijwerken",
      "updated_at": "Bijgewerkt",
      "urgent": "Dringend",
      "user_profile_logout": "Gebruikersprofiel & Afmelden",
      "vat_id": "Btw-identificatienummer",
      "views": "Weergaven",
      "voice_notes_admin_hint": "Spraaknotities: Schakel 'Spraaknotities' in onder Administratie → AI-instellingen.",
      "voice_notes_enable_info": "Schakel spraaknotities in onder Administratie → AI-instellingen (schakelaar 'Spraaknotities').",
      "voice_notes_not_active": "Spraaknotities niet actief",
      "website": "Website",
      "widget_critical_tickets": "Kritieke tickets (Brandweer)",
      "widget_group_analytics_team": "Analyses & Team",
      "widget_group_overview_performance": "Overzicht & Prestaties",
      "widget_group_volume_trends": "Volume & Trends",
      "widget_my_open_tickets": "Mijn open tickets",
      "widget_performance_times": "Prestatietijden & inspanning",
      "widget_priority_chart": "Prioriteitsverdeling",
      "widget_sla_compliance": "SLA-naleving & risico",
      "widget_status_chart": "Verdeling ticketstatus",
      "widget_team_presence": "Teampresentie & activiteit",
      "widget_ticket_trends": "Tickettrends & volume",
      "widget_top_customers": "Topklanten op basis van tickets",
      "zip_code": "Postcode"
    }
  }
};

for (const [language, labels] of Object.entries(portalDashboardTranslations)) {
  Object.assign(resources[language as keyof typeof resources].translation, { portal_dashboard: labels });
}
for (const [language, labels] of Object.entries(portalDocumentTranslations)) {
  Object.assign(resources[language as keyof typeof resources].translation, { portal_documents: labels });
}
for (const [language, labels] of Object.entries(portalUsageTranslations)) {
  Object.assign(resources[language as keyof typeof resources].translation, { portal_usage: labels });
}
for (const [language, labels] of Object.entries(portalProfileTranslations)) {
  Object.assign(resources[language as keyof typeof resources].translation, { portal_profile: labels });
}
for (const [language, labels] of Object.entries(portalChartTranslations)) {
  Object.assign(resources[language as keyof typeof resources].translation, { portal_chart: labels });
}
for (const [language, labels] of Object.entries(portalEventTranslations)) {
  Object.assign(resources[language as keyof typeof resources].translation, { portal_ticket_labels: labels });
}
for (const [language, labels] of Object.entries(portalCompanyTranslations)) {
  Object.assign(resources[language as keyof typeof resources].translation, { portal_company: labels });
}
for (const [language, labels] of Object.entries(portalExternalTranslations)) {
  Object.assign(resources[language as keyof typeof resources].translation, { portal_external: labels });
}
for (const [language, labels] of Object.entries(portalTicketKindTranslations)) {
  Object.assign(resources[language as keyof typeof resources].translation, { portal_ticket_kind: labels });
}
for (const [language, labels] of Object.entries(portalTicketDetailTranslations)) {
  Object.assign(resources[language as keyof typeof resources].translation, { portal_ticket_detail: labels });
}
for (const [language, labels] of Object.entries(portalDownloadTranslations)) {
  Object.assign(resources[language as keyof typeof resources].translation, { portal_downloads: labels });
}

const getInitialLanguage = (): string => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('i18nextLng');
    if (saved) return saved;
  }
  return 'de';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

/**
 * `<html lang>` mitfuehren.
 *
 * In index.html steht fest `lang="de"`. Wer auf Franzoesisch umschaltet, bekam
 * bisher franzoesischen Text in einem als deutsch ausgezeichneten Dokument —
 * ein Vorleseprogramm spricht ihn dann mit deutscher Aussprache, und die
 * Silbentrennung des Browsers trennt nach den falschen Regeln.
 *
 * Die Zuweisung steht hier und nicht in einer Seite: Es gibt drei Umschalter
 * (Anmeldung, Agentenkonsole, Kundenportal), und der vierte wuerde es wieder
 * vergessen. i18next weiss als einziges, dass sich die Sprache geaendert hat.
 */
if (typeof document !== 'undefined') {
  const setzeDokumentSprache = (lng: string) => {
    if (lng) document.documentElement.setAttribute('lang', lng);
  };
  setzeDokumentSprache(i18n.language);
  i18n.on('languageChanged', setzeDokumentSprache);
}

export default i18n;
